/* eslint-disable */
import React, { useState, useMemo, useEffect } from "react";

const LOGO_SRC = "data:image/png;base64,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";

// ─────────────────────────────────────────────────────────────────────────────
// 🔐 INTERRUPTEUR PREMIUM
// false = fonctions premium CACHÉES aux utilisateurs (mode actuel)
// true  = fonctions premium VISIBLES (à activer le jour du lancement)
// ─────────────────────────────────────────────────────────────────────────────
const PREMIUM_URL = false; // Accès admin supprimé du client
const MERCI_URL = new URLSearchParams(window.location.search).get("merci") === "true";
// Codes permanents supprimés du client — vérification 100% serveur
const VERIFIER_CODE_URL = "https://eotl7w51dxswnq7.m.pipedream.net";
const PIPEDREAM_SECRET = "PDSFdlR1964*";

const C = {
  navy:"#1B3A6B", navyLight:"#2A5298", green:"#7CB342",
  greenPale:"#F1F8E9", orange:"#F4A035", orangePale:"#FFF8F0",
  cream:"#FAFAF7", white:"#FFFFFF", gray:"#6B7280",
  grayLight:"#F3F4F6", text:"#1a2a1a",
};

function AvocatLogo({ size = 48 }) {
  return <img src={LOGO_SRC} width={size} height={size} alt="Céto Club" style={{display:"block"}}/>;
}

// ═══════════════════════════════════════════════════════════════
// CALENDRIER DE SUIVI — vue mensuelle avec pastilles de données
// ═══════════════════════════════════════════════════════════════
function CalendrierSuivi({ onVoirJour }) {
  const [ouvert, setOuvert] = useState(false);
  const [moisAffiche, setMoisAffiche] = useState(() => {
    const d = new Date();
    return { annee: d.getFullYear(), mois: d.getMonth() };
  });

  // Lire toutes les données depuis localStorage
  const donneesParJour = useMemo(() => {
    const dico = {};
    const ajouter = (dateIso, type) => {
      if (!dateIso) return;
      if (!dico[dateIso]) dico[dateIso] = new Set();
      dico[dateIso].add(type);
    };

    try {
      const j = JSON.parse(localStorage.getItem("cetoclub_journal") || "{}");
      Object.keys(j).forEach(date => {
        const jour = j[date];
        if (jour && typeof jour === "object") {
          const repas = ["petit_dejeuner", "dejeuner", "diner", "collations"];
          if (repas.some(r => Array.isArray(jour[r]) && jour[r].length > 0)) {
            ajouter(date, "repas");
          }
        }
      });
    } catch {}

    try {
      const poids = JSON.parse(localStorage.getItem("cetoclub_poids") || "[]");
      poids.forEach(p => ajouter(p.date, "poids"));
    } catch {}

    try {
      const jeunes = JSON.parse(localStorage.getItem("cetoclub_jeune_histo") || "[]");
      jeunes.forEach(j => {
        const d = j.date || (j.debut ? j.debut.slice(0, 10) : null);
        ajouter(d, "jeune");
      });
    } catch {}

    try {
      const act = JSON.parse(localStorage.getItem("cetoclub_activite") || "[]");
      act.forEach(a => ajouter(a.date, "activite"));
    } catch {}

    try {
      const seances = JSON.parse(localStorage.getItem("cetoclub_activite_seances_v2") || "[]");
      seances.forEach(s => ajouter(s.date, "activite"));
    } catch {}

    try {
      const sommeil = JSON.parse(localStorage.getItem("cetoclub_sommeil") || "{}");
      Object.keys(sommeil).forEach(d => ajouter(d, "sommeil"));
    } catch {}

    return dico;
  }, [moisAffiche]);

  const MOIS_FR = ["Janvier","Février","Mars","Avril","Mai","Juin",
                   "Juillet","Août","Septembre","Octobre","Novembre","Décembre"];
  const JOURS_FR = ["L","M","M","J","V","S","D"];

  const { annee, mois } = moisAffiche;
  const premierJour = new Date(annee, mois, 1);
  const dernierJour = new Date(annee, mois + 1, 0);
  const nbJours = dernierJour.getDate();
  // getDay: 0=dim, 1=lun... On veut lundi=0
  const decalageDebut = (premierJour.getDay() + 6) % 7;
  const aujourdhui = new Date().toISOString().slice(0, 10);

  const changerMois = (delta) => {
    setMoisAffiche(m => {
      let nm = m.mois + delta;
      let na = m.annee;
      if (nm < 0) { nm = 11; na--; }
      if (nm > 11) { nm = 0; na++; }
      return { mois: nm, annee: na };
    });
  };

  const formatDate = (j) => {
    const mm = String(mois + 1).padStart(2, "0");
    const jj = String(j).padStart(2, "0");
    return `${annee}-${mm}-${jj}`;
  };

  // Fabriquer la grille (6 semaines max)
  const cases = [];
  for (let i = 0; i < decalageDebut; i++) cases.push(null);
  for (let j = 1; j <= nbJours; j++) cases.push(j);

  return (
    <div style={{background:"#fff",borderRadius:14,border:"2px solid #1B3A6B20",padding:18,marginBottom:14}}>
      {/* En-tête cliquable pour replier/déplier */}
      <div onClick={() => setOuvert(o => !o)}
        style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",userSelect:"none"}}>
        <div style={{width:32,height:32,borderRadius:8,background:"#F0F4FF",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>📅</div>
        <div style={{flex:1,fontSize:14,fontWeight:900,color:"#1B3A6B"}}>Mon calendrier de suivi</div>
        <div style={{fontSize:18,color:"#1B3A6B",transition:"transform 0.2s",transform:ouvert?"rotate(180deg)":"none"}}>⌄</div>
      </div>

      {ouvert && (
        <div style={{marginTop:14}}>
          {/* Navigation mois */}
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
            <button onClick={() => changerMois(-1)}
              style={{padding:"6px 12px",background:"#F0F4FF",color:"#1B3A6B",border:"none",borderRadius:8,fontSize:16,fontWeight:900,cursor:"pointer"}}>
              ‹
            </button>
            <div style={{fontSize:14,fontWeight:900,color:"#1B3A6B"}}>
              {MOIS_FR[mois]} {annee}
            </div>
            <button onClick={() => changerMois(1)}
              style={{padding:"6px 12px",background:"#F0F4FF",color:"#1B3A6B",border:"none",borderRadius:8,fontSize:16,fontWeight:900,cursor:"pointer"}}>
              ›
            </button>
          </div>

          {/* En-tête jours */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4,marginBottom:4}}>
            {JOURS_FR.map((j, i) => (
              <div key={i} style={{textAlign:"center",fontSize:11,fontWeight:800,color:"#6B7280",padding:"4px 0"}}>
                {j}
              </div>
            ))}
          </div>

          {/* Grille jours */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4}}>
            {cases.map((j, i) => {
              if (j === null) return <div key={i} style={{aspectRatio:"1",minHeight:44}}/>;
              const dateIso = formatDate(j);
              const types = donneesParJour[dateIso] || new Set();
              const hasData = types.size > 0;
              const estAujourdhui = dateIso === aujourdhui;
              const estFutur = dateIso > aujourdhui;

              return (
                <button
                  key={i}
                  onClick={() => { if (!estFutur && onVoirJour) onVoirJour(dateIso); }}
                  disabled={estFutur}
                  style={{
                    aspectRatio:"1",
                    minHeight:44,
                    padding:"4px 2px",
                    background: estAujourdhui ? "#1B3A6B" : (hasData ? "#F1F8E9" : "#fff"),
                    color: estAujourdhui ? "#fff" : (hasData ? "#1a2a1a" : (estFutur ? "#D1D5DB" : "#6B7280")),
                    border:`1.5px solid ${estAujourdhui ? "#1B3A6B" : (hasData ? "#7CB342" : "#E5E7EB")}`,
                    borderRadius:8,
                    fontSize:12,
                    fontWeight: hasData || estAujourdhui ? 900 : 600,
                    cursor: estFutur ? "default" : "pointer",
                    display:"flex",
                    flexDirection:"column",
                    alignItems:"center",
                    justifyContent:"center",
                    gap:2,
                    fontFamily:"inherit"
                  }}>
                  <div>{j}</div>
                  {hasData && (
                    <div style={{display:"flex",gap:1,flexWrap:"wrap",justifyContent:"center",fontSize:7,lineHeight:1}}>
                      {types.has("repas") && <span>🍽️</span>}
                      {types.has("poids") && <span>⚖️</span>}
                      {types.has("jeune") && <span>⏱️</span>}
                      {types.has("activite") && <span>🏃</span>}
                    </div>
                  )}
                </button>
              );
            })}
          </div>

          {/* Légende */}
          <div style={{marginTop:12,padding:"8px 10px",background:"#F9FAFB",borderRadius:8,fontSize:10,color:"#6B7280",lineHeight:1.6}}>
            🍽️ Repas · ⚖️ Poids · ⏱️ Jeûne · 🏃 Activité
          </div>

          {/* ── BOUTONS MODE VACANCES ── */}
          <BoutonsVacances/>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// BOUTONS DÉBUT / FIN DE VACANCES
// ═══════════════════════════════════════════════════════════════
function BoutonsVacances() {
  // État local : date de départ si on est en mode vacances (sinon null)
  const [dateDepartActive, setDateDepartActive] = React.useState(
    () => localStorage.getItem("cetoclub_vacances_depart") || null
  );
  // Re-synchronise après chaque action (début/fin) via un petit "tick"
  const refreshVacances = () => setDateDepartActive(localStorage.getItem("cetoclub_vacances_depart") || null);

  // Clés datées (tableaux d'entrées avec champ date)
  const KEYS_DATEES_TABLEAU = [
    "cetoclub_poids", "cetoclub_mensurations",
    "cetoclub_jeune_histo", "cetoclub_activite",
    "cetoclub_activite_seances_v2", "cetoclub_respiration_histo"
  ];
  // Clés datées (dictionnaires { date: valeur })
  const KEYS_DATEES_DICO = ["cetoclub_journal", "cetoclub_sommeil"];
  // Toutes les autres clés (profil, objectifs, recettes, produits, etc.)
  const KEYS_AUTRES = [
    "cetoclub_profil", "cetoclub_objectifs", "cetoclub_produits",
    "cetoclub_recettes", "cetoclub_recettes_histo", "cetoclub_suivi",
    "cetoclub_planning_jeune", "cetoclub_cycle_hormonal", "cetoclub_menopause",
    "cetoclub_menu_sauve", "cetoclub_onboarding", "cetoclub_premium_local",
    "cetoclub_activations"
  ];

  const snapshotComplet = () => {
    const backup = {};
    [...KEYS_DATEES_TABLEAU, ...KEYS_DATEES_DICO, ...KEYS_AUTRES].forEach(k => {
      const v = localStorage.getItem(k);
      if (v) backup[k] = v;
    });
    Object.keys(localStorage).forEach(k => {
      if (k.startsWith("cetoclub_journal_")) backup[k] = localStorage.getItem(k);
    });
    return backup;
  };

  const telechargerJson = (obj, nom) => {
    const blob = new Blob([JSON.stringify(obj, null, 2)], {type:"application/json"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = nom;
    a.click();
    URL.revokeObjectURL(url);
  };

  const chargerJson = () => new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".json";
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) { reject(new Error("Pas de fichier")); return; }
      const reader = new FileReader();
      reader.onload = (ev) => {
        try { resolve(JSON.parse(ev.target.result)); }
        catch (err) { reject(err); }
      };
      reader.readAsText(file);
    };
    input.click();
  });

  // ─── DÉBUT DE VACANCES ───
  // Exporte TOUT + marque la date de départ
  const debutVacances = () => {
    const ok = window.confirm(
      "🏖️ Début de vacances\n\n" +
      "Tu vas télécharger un fichier à importer sur ton smartphone pour continuer ton suivi pendant tes vacances.\n\n" +
      "Continuer ?"
    );
    if (!ok) return;
    const dateDepart = new Date().toISOString().slice(0, 10);
    const fichier = {
      type: "cetoclub_debut_vacances",
      date_depart: dateDepart,
      donnees: snapshotComplet()
    };
    telechargerJson(fichier, `cetoclub_debut_vacances_${dateDepart}.json`);

    // Mémoriser la date de départ sur CET appareil (smartphone qui recevra le fichier
    // mémorisera la sienne à l'import)
    localStorage.setItem("cetoclub_vacances_depart", dateDepart);
    refreshVacances();

    alert(
      "✅ Fichier téléchargé.\n\n" +
      "📲 Sur ton smartphone :\n" +
      "1. Envoie-toi le fichier (email, WhatsApp...)\n" +
      "2. Ouvre l'app Céto Club → Moi → Mon profil → 📤 Importer mes données\n" +
      "3. Sélectionne le fichier\n\n" +
      "Au retour, clique sur \"Fin de vacances\" depuis ton smartphone pour générer le fichier de retour."
    );
  };

  // ─── FIN DE VACANCES ───
  // 2 modes selon le fichier chargé :
  //  - Fichier "debut_vacances" → on est sur le smartphone qui part
  //    (on ne devrait pas atterrir ici, c'est plutôt "Importer mes données")
  //  - Fichier "fin_vacances" → on est sur l'ordi qui reçoit
  //  - Sans fichier → on EST le smartphone qui rentre → générer le fichier
  const finVacances = async () => {
    const dateDepart = localStorage.getItem("cetoclub_vacances_depart");

    // CAS A : cet appareil a une date de départ = on rentre de vacances, on génère le fichier
    if (dateDepart) {
      // Choix : annuler le mode vacances (erreur) OU générer le fichier de retour (vrai retour)
      const choix = window.prompt(
        "🧳 Fin de vacances\n\n" +
        "Tu es en mode vacances depuis le " + dateDepart.split("-").reverse().join("/") + " sur cet appareil.\n\n" +
        "Que veux-tu faire ?\n\n" +
        "• Tape 1 = Annuler le mode vacances (je l'ai activé par erreur)\n" +
        "• Tape 2 = Générer le fichier de retour (j'ai saisi mes données ici pendant les vacances)\n\n" +
        "Tape 1 ou 2 :"
      );
      if (choix === null) return;
      const c = choix.trim();

      if (c === "1") {
        localStorage.removeItem("cetoclub_vacances_depart");
        refreshVacances();
        alert("✅ Mode vacances annulé.\n\nTu peux saisir normalement tes données sur cet appareil.");
        return;
      }

      if (c !== "2") {
        alert("❌ Tape 1 pour annuler ou 2 pour générer le fichier de retour.");
        return;
      }

      const ok = window.confirm(
        "🧳 Génération du fichier de retour\n\n" +
        "Tu vas télécharger un fichier contenant UNIQUEMENT les données saisies depuis le " +
        dateDepart.split("-").reverse().join("/") + ".\n\n" +
        "Tu pourras l'ouvrir sur ton autre appareil pour fusionner ces nouvelles données avec ton historique.\n\n" +
        "Continuer ?"
      );
      if (!ok) return;

      const dateRetour = new Date().toISOString().slice(0, 10);
      const nouveautes = {};

      // Filtrer les tableaux datés
      KEYS_DATEES_TABLEAU.forEach(k => {
        const raw = localStorage.getItem(k);
        if (!raw) return;
        try {
          const arr = JSON.parse(raw);
          if (!Array.isArray(arr)) return;
          const filtre = arr.filter(entry => {
            const d = entry?.date || entry?.dateIso || entry?.jour;
            return d && d >= dateDepart;
          });
          if (filtre.length > 0) nouveautes[k] = filtre;
        } catch {}
      });

      // Filtrer les dictionnaires datés (journal, sommeil)
      KEYS_DATEES_DICO.forEach(k => {
        const raw = localStorage.getItem(k);
        if (!raw) return;
        try {
          const dico = JSON.parse(raw);
          if (!dico || typeof dico !== "object") return;
          const filtre = {};
          Object.keys(dico).forEach(date => {
            if (date >= dateDepart) filtre[date] = dico[date];
          });
          if (Object.keys(filtre).length > 0) nouveautes[k] = filtre;
        } catch {}
      });

      // Journaux quotidiens cetoclub_journal_YYYY-MM-DD
      Object.keys(localStorage).forEach(k => {
        if (k.startsWith("cetoclub_journal_")) {
          const d = k.replace("cetoclub_journal_", "");
          if (d >= dateDepart) {
            try { nouveautes[k] = JSON.parse(localStorage.getItem(k)); } catch {}
          }
        }
      });

      // Recettes et produits créés pendant les vacances (liste complète, fusion par ID)
      ["cetoclub_recettes", "cetoclub_produits"].forEach(k => {
        const raw = localStorage.getItem(k);
        if (raw) {
          try { nouveautes[k + "_complet"] = JSON.parse(raw); } catch {}
        }
      });

      const fichier = {
        type: "cetoclub_fin_vacances",
        date_depart: dateDepart,
        date_retour: dateRetour,
        nouveautes: nouveautes
      };
      telechargerJson(fichier, `cetoclub_fin_vacances_${dateRetour}.json`);

      alert(
        "✅ Fichier téléchargé.\n\n" +
        "💻 Sur ton ordinateur :\n" +
        "1. Envoie-toi le fichier\n" +
        "2. Ouvre l'app → Moi → Mon profil → 📅 Mon calendrier → Fin de vacances\n" +
        "3. Sélectionne le fichier → les données s'ajouteront à ton historique"
      );
      return;
    }

    // CAS B : pas de date de départ = on est sur l'ordi qui reçoit le fichier de retour
    try {
      const fichier = await chargerJson();
      if (fichier.type !== "cetoclub_fin_vacances") {
        alert("❌ Ce n'est pas un fichier de fin de vacances.\n\nPour importer une sauvegarde classique, utilise \"Importer mes données\".");
        return;
      }

      const dateDep = fichier.date_depart;
      let nbAjouts = 0;

      // Fusionner tableaux datés (retirer doublons par date)
      KEYS_DATEES_TABLEAU.forEach(k => {
        if (!fichier.nouveautes[k]) return;
        const existant = (() => {
          try { return JSON.parse(localStorage.getItem(k) || "[]"); }
          catch { return []; }
        })();
        if (!Array.isArray(existant)) return;
        const base = existant.filter(e => {
          const d = e?.date || e?.dateIso || e?.jour;
          return !d || d < dateDep;
        });
        const fusionne = [...base, ...fichier.nouveautes[k]];
        localStorage.setItem(k, JSON.stringify(fusionne));
        nbAjouts += fichier.nouveautes[k].length;
      });

      // Fusionner dictionnaires datés (journal, sommeil)
      KEYS_DATEES_DICO.forEach(k => {
        if (!fichier.nouveautes[k]) return;
        const existant = (() => {
          try { return JSON.parse(localStorage.getItem(k) || "{}"); }
          catch { return {}; }
        })();
        const fusionne = { ...existant, ...fichier.nouveautes[k] };
        localStorage.setItem(k, JSON.stringify(fusionne));
        nbAjouts += Object.keys(fichier.nouveautes[k]).length;
      });

      // Journaux quotidiens
      Object.keys(fichier.nouveautes).forEach(k => {
        if (k.startsWith("cetoclub_journal_")) {
          localStorage.setItem(k, JSON.stringify(fichier.nouveautes[k]));
          nbAjouts++;
        }
      });

      // Fusionner recettes et produits par ID
      ["cetoclub_recettes", "cetoclub_produits"].forEach(k => {
        const cleComplet = k + "_complet";
        if (!fichier.nouveautes[cleComplet]) return;
        const listeNouvelle = fichier.nouveautes[cleComplet];
        const listeOrdi = (() => {
          try { return JSON.parse(localStorage.getItem(k) || "[]"); }
          catch { return []; }
        })();
        const idsOrdi = new Set(listeOrdi.map(x => x.id).filter(Boolean));
        const ajouts = listeNouvelle.filter(x => x.id && !idsOrdi.has(x.id));
        if (ajouts.length > 0) {
          localStorage.setItem(k, JSON.stringify([...listeOrdi, ...ajouts]));
          nbAjouts += ajouts.length;
        }
      });

      // Nettoyer le marqueur de départ au cas où
      localStorage.removeItem("cetoclub_vacances_depart");
      refreshVacances();

      alert(
        "✅ Retour de vacances réussi !\n\n" +
        nbAjouts + " éléments ajoutés à ton suivi.\n\n" +
        "Période : " + fichier.date_depart.split("-").reverse().join("/") +
        " → " + fichier.date_retour.split("-").reverse().join("/") + "\n\n" +
        "L'app va se recharger."
      );
      window.location.reload();
    } catch (e) {
      alert("❌ Fichier invalide ou illisible.");
    }
  };

  const styleBouton = {
    flex: 1, minWidth: 130, padding: "12px 16px",
    border: "none", borderRadius: 10, fontSize: 13,
    fontWeight: 800, cursor: "pointer", fontFamily: "inherit"
  };

  const enVacances = !!dateDepartActive;
  const dateDepartFr = dateDepartActive ? dateDepartActive.split("-").reverse().join("/") : "";

  return (
    <div style={{marginTop:16,padding:14,background:"#FFF8F0",border:"2px solid #F4A03540",borderRadius:10}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
        <div style={{fontSize:18}}>🏖️</div>
        <div style={{fontSize:13,fontWeight:900,color:"#8B5A00"}}>Mode vacances</div>
      </div>

      {enVacances ? (
        <div style={{fontSize:12,color:"#fff",background:"#F4A035",borderRadius:8,padding:"10px 12px",marginBottom:12,lineHeight:1.5,fontWeight:700}}>
          ⚠️ Tu es en vacances depuis le <strong>{dateDepartFr}</strong>.<br/>
          Les données doivent être saisies sur ton téléphone, ou clique sur <strong>🧳 Fin de vacances</strong>.
        </div>
      ) : (
        <div style={{fontSize:11,color:"#6B4A00",marginBottom:12,lineHeight:1.5}}>
          Pars avec ton smartphone, saisis tes données là-bas, au retour elles s'ajoutent à ton suivi sans écraser ton historique.
        </div>
      )}

      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        {!enVacances && (
          <button onClick={debutVacances}
            style={{...styleBouton,background:"#F4A035",color:"#fff"}}>
            🏖️ Début de vacances
          </button>
        )}
        <button onClick={finVacances}
          style={{...styleBouton,background:enVacances?"#1B3A6B":"#F4A035",color:"#fff"}}>
          🧳 Fin de vacances
        </button>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// BANDEAU RAPPEL HEBDOMADAIRE SAUVEGARDE
// ═══════════════════════════════════════════════════════════════
function BandeauRappelSauvegarde({ onAller }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const ferme = localStorage.getItem("cetoclub_rappel_ferme");
      if (ferme) {
        const jours = (Date.now() - new Date(ferme).getTime()) / (1000*60*60*24);
        if (jours < 1) return; // fermé il y a moins d'un jour
      }
      const dernier = localStorage.getItem("cetoclub_dernier_export");
      if (!dernier) {
        // Jamais exporté : attendre 7 jours après l'installation
        const premiereOuverture = localStorage.getItem("cetoclub_premiere_ouverture");
        if (!premiereOuverture) {
          localStorage.setItem("cetoclub_premiere_ouverture", new Date().toISOString());
          return;
        }
        const jours = (Date.now() - new Date(premiereOuverture).getTime()) / (1000*60*60*24);
        if (jours >= 7) setVisible(true);
        return;
      }
      const jours = (Date.now() - new Date(dernier).getTime()) / (1000*60*60*24);
      if (jours >= 7) setVisible(true);
    } catch {}
  }, []);

  if (!visible) return null;

  const fermer = () => {
    try { localStorage.setItem("cetoclub_rappel_ferme", new Date().toISOString()); } catch {}
    setVisible(false);
  };

  return (
    <div style={{
      background:"#FFF8E1",
      border:"2px solid #F4A035",
      borderRadius:10,
      padding:"10px 12px",
      margin:"0 0 12px 0",
      display:"flex",
      alignItems:"center",
      gap:10,
      flexWrap:"wrap"
    }}>
      <div style={{fontSize:22}}>💾</div>
      <div style={{flex:1,minWidth:160,fontSize:12,color:"#8B5A00",lineHeight:1.4}}>
        <strong>N'oublie pas de sauvegarder ta semaine !</strong><br/>
        <span style={{fontSize:11}}>Moi → Mon profil → Mes données → Exporter</span>
      </div>
      {onAller && (
        <button onClick={() => { onAller(); fermer(); }} style={{
          padding:"8px 12px",background:"#F4A035",color:"#fff",border:"none",
          borderRadius:8,fontSize:11,fontWeight:800,cursor:"pointer",fontFamily:"inherit"
        }}>
          Y aller
        </button>
      )}
      <button onClick={fermer} style={{
        background:"transparent",border:"none",fontSize:18,
        cursor:"pointer",color:"#8B5A00",padding:"4px 8px",fontFamily:"inherit"
      }}>✕</button>
    </div>
  );
}

// ─── RECETTES ENCODÉES — ingrédients réels + macros calculées CIQUAL ──────────
// Chaque recette : portions = nb de parts, ingredients = [{nom, qte_g}]
// Les macros par portion sont pré-calculées pour fiabilité
const RECETTES_ENCODEES = [
  {
    id:"pain_ceto_autrichien",
    note:"2 tranches ce matin (il en reste {RESTANTES} sur 12) · À déguster avec : 2 œufs, jambon ou fromage au choix · 💡 À la sortie du four : laisser refroidir, couper en tranches et conserver au congélateur",
    titre:"Pain céto autrichien au fromage blanc et graines",
    url:"https://cetoclub.com/pain-ceto-autrichien-au-fromage-blanc-et-graines/",
    portions:12,
    parts_par_repas:2,
    categorie:"pain",
    regime:["omnivore","vegetarien"],
    repas:["petit_dejeuner"],
    ingredients:[
      {nom:"fromage blanc",  qte_g:250},
      {nom:"oeuf entier",    qte_g:150},
      {nom:"noix moulu",     qte_g:90},
      {nom:"graines sesame", qte_g:20},
      {nom:"graines lin",    qte_g:50},
      {nom:"graines chia",   qte_g:40},
      {nom:"graines tournesol", qte_g:20},
      {nom:"graines courge", qte_g:30},
    ],
    macros_portion:{pro:7.2, lip:12.8, glu:1.5},
  },
  {
    id:"petits_pains_lait_ceto",
    note:"1 pain (sur 2) · À déguster avec : 2 œufs, jambon ou fromage au choix",
    titre:"Petits pains au lait céto simplissimes",
    url:"https://cetoclub.com/petits-pains-au-lait-ceto-simplissime/",
    portions:2,
    categorie:"pain",
    regime:["omnivore","vegetarien"],
    repas:["petit_dejeuner"],
    ingredients:[
      {nom:"puree amande",   qte_g:170},
      {nom:"oeuf entier",    qte_g:150},
      {nom:"mascarpone",     qte_g:5},
      {nom:"graines sesame", qte_g:5},
    ],
    macros_portion:{pro:28.0, lip:57.5, glu:4.5},
  },
  {
    id:"petit_pain_3min",
    note:"1 pain · À déguster avec : 2 œufs, jambon ou fromage au choix + café ou thé",
    titre:"Petit pain keto prêt en 3 minutes",
    url:"https://cetoclub.com/petit-pain-keto-pret-en-3-minutes/",
    portions:1,
    categorie:"pain",
    regime:["omnivore","vegetarien"],
    repas:["petit_dejeuner"],
    ingredients:[
      {nom:"beurre",        qte_g:19},
      {nom:"farine coco",   qte_g:8},
      {nom:"poudre amande", qte_g:20},
      {nom:"oeuf entier",   qte_g:50},
    ],
    macros_portion:{pro:12.0, lip:32.0, glu:1.4},
  },
  {
    id:"crackers_graines",
    note:"1 portion (sur 4) · À déguster avec : jambon, saumon fumé, fromage au choix",
    titre:"Crackers aux graines cétogènes",
    url:"https://cetoclub.com/crackers-aux-graines-cetogenes/",
    portions:4,
    categorie:"pain",
    regime:["omnivore","vegetarien"],
    repas:["petit_dejeuner","dejeuner","diner"],
    ingredients:[
      {nom:"graines lin",       qte_g:130},
      {nom:"graines chia",      qte_g:80},
      {nom:"graines tournesol", qte_g:60},
      {nom:"graines courge",    qte_g:50},
      {nom:"graines sesame",    qte_g:40},
      {nom:"huile olive",       qte_g:40},
    ],
    macros_portion:{pro:18.0, lip:48.8, glu:3.0},
  },
  {
    id:"brioche_keto_fleur_oranger",
    note:"2 tranches ce matin (il en reste {RESTANTES} sur 10) · À compléter avec : 2 œufs, jambon ou fromage + café ou thé · 💡 À la sortie du four : laisser refroidir, couper en tranches et conserver au congélateur",
    titre:"Brioche keto à la fleur d'oranger",
    url:"https://cetoclub.com/brioche-keto-a-la-fleur-doranger/",
    portions:10,
    parts_par_repas:2,
    categorie:"pain",
    regime:["omnivore","vegetarien"],
    repas:["petit_dejeuner"],
    ingredients:[
      {nom:"mascarpone",     qte_g:340},
      {nom:"whey vanille",   qte_g:175},
      {nom:"creme fraiche",  qte_g:60},
      {nom:"beurre",         qte_g:50},
      {nom:"huile coco",     qte_g:50},
      {nom:"oeuf entier",    qte_g:200},
      {nom:"psyllium",       qte_g:10},
    ],
    macros_portion:{pro:18.2, lip:27.8, glu:2.6},
  },
  {
    id:"pizza_fathead_mozzarella",
    titre:"Pâte à pizza keto mozzarella (fathead dough)",
    url:"https://cetoclub.com/pate-a-pizza-keto-mozzarella/",
    portions:1,
    categorie:"pizza",
    regime:["omnivore","vegetarien"],
    repas:["dejeuner","diner"],
    note:"Garniture non comprise — ajouter selon goût",
    ingredients:[
      {nom:"mozzarella",     qte_g:100},
      {nom:"philadelphia",   qte_g:25},
      {nom:"poudre amande",  qte_g:50},
      {nom:"oeuf entier",    qte_g:50},
    ],
    macros_portion:{pro:37.0, lip:48.0, glu:4.0},
  },
  {
    id:"pizza_keto_cheddar",
    titre:"Pizza keto au cheddar",
    url:"https://cetoclub.com/pizza-keto-au-cheddar/",
    portions:2,
    categorie:"pizza",
    regime:["omnivore","vegetarien"],
    repas:["dejeuner","diner"],
    ingredients:[
      {nom:"cheddar",        qte_g:150},
      {nom:"oeuf entier",    qte_g:150},
      {nom:"psyllium",       qte_g:15},
      {nom:"poudre amande",  qte_g:15},
      {nom:"tomate",         qte_g:80},
      {nom:"mozzarella",     qte_g:100},
      {nom:"oignon",         qte_g:40},
      {nom:"poivron",        qte_g:40},
    ],
    macros_portion:{pro:40.0, lip:45.5, glu:3.5},
  },
  {
    id:"pates_proteinees_gelatine",
    titre:"Délicieuses pâtes protéinées (zéro glucide)",
    url:"https://cetoclub.com/delicieuses-pates-proteinees/",
    portions:1,
    categorie:"plat",
    regime:["carnivore","omnivore"],
    repas:["dejeuner","diner"],
    note:"Base neutre — ajouter une sauce selon goût",
    ingredients:[
      {nom:"gelatine",           qte_g:14},
      {nom:"blanc oeuf poudre",  qte_g:14},
      {nom:"oeuf entier",        qte_g:140},
      {nom:"beurre",             qte_g:10},
    ],
    macros_portion:{pro:49.0, lip:30.0, glu:1.0},
  },
  {
    id:"coulant_keto_chocolat",
    note:"Part : 1/4",
    titre:"Coulant keto au chocolat (sans sucre)",
    url:"https://cetoclub.com/coulant-keto-au-chocolat-sans-sucre/",
    portions:4,
    categorie:"dessert",
    regime:["omnivore","vegetarien"],
    repas:["dessert"],
    ingredients:[
      {nom:"chocolat 85",   qte_g:80},
      {nom:"oeuf entier",   qte_g:150},
      {nom:"beurre",        qte_g:65},
      {nom:"farine coco",   qte_g:15},
      {nom:"erythritol",    qte_g:50},
    ],
    macros_portion:{pro:7.5, lip:26.8, glu:1.8},
  },
  {
    id:"gateau_keto_choco_mascarpone",
    note:"Part : 1/6",
    titre:"Gâteau keto au chocolat et mascarpone",
    url:"https://cetoclub.com/gateau-keto-au-chocolat-et-mascarpone/",
    portions:8,
    categorie:"dessert",
    regime:["omnivore","vegetarien"],
    repas:["dessert"],
    ingredients:[
      {nom:"chocolat 90",   qte_g:200},
      {nom:"mascarpone",    qte_g:250},
      {nom:"erythritol",    qte_g:100},
      {nom:"oeuf entier",   qte_g:200},
      {nom:"beurre",        qte_g:40},
      {nom:"poudre amande", qte_g:50},
    ],
    macros_portion:{pro:9.5, lip:34.4, glu:2.5},
  },
  {
    id:"flan_caramel_sans_laitier",
    note:"Part : 1/12",
    titre:"Flan au caramel sans produit laitier",
    url:"https://cetoclub.com/flan-au-caramel-sans-produit-laitier/",
    portions:12,
    categorie:"dessert",
    regime:["omnivore","vegetarien"],
    repas:["dessert"],
    note:"Sans lactose",
    ingredients:[
      {nom:"creme coco",    qte_g:400},
      {nom:"oeuf entier",   qte_g:300},
      {nom:"erythritol",    qte_g:100},
      {nom:"allulose",      qte_g:60},
      {nom:"gingembre",     qte_g:10},
    ],
    macros_portion:{pro:3.9, lip:10.8, glu:1.4},
  },
  {
    id:"creme_chocolat_oeufs_durs",
    note:"1 portion entière",
    titre:"Crème chocolat aux œufs durs",
    url:"https://cetoclub.com/creme-chocolat-aux-oeufs-durs/",
    portions:1,
    categorie:"dessert",
    regime:["omnivore","vegetarien"],
    repas:["dessert"],
    ingredients:[
      {nom:"oeuf entier",   qte_g:100},
      {nom:"cacao poudre",  qte_g:12},
      {nom:"erythritol",    qte_g:20},
      {nom:"creme fraiche", qte_g:50},
    ],
    macros_portion:{pro:16.0, lip:28.0, glu:2.0},
  },
  {
    id:"gateau_citron_keto",
    note:"Part : 1/6",
    titre:"Gâteau au citron keto",
    url:"https://cetoclub.com/gateau-au-citron-keto/",
    portions:8,
    categorie:"dessert",
    regime:["omnivore","vegetarien"],
    repas:["dessert"],
    ingredients:[
      {nom:"farine amande",  qte_g:144},
      {nom:"farine coco",    qte_g:41},
      {nom:"erythritol",     qte_g:120},
      {nom:"oeuf entier",    qte_g:150},
      {nom:"beurre",         qte_g:55},
      {nom:"creme fraiche",  qte_g:81},
    ],
    macros_portion:{pro:7.2, lip:20.5, glu:1.4},
  },
  {
    id:"pancakes_proteines",
    note:"1 portion · À compléter avec : 2 œufs, jambon, saumon fumé ou fromage + café ou thé",
    titre:"Pancakes protéinés cétogènes",
    url:"https://cetoclub.com/pancakes-proteines/",
    portions:2,
    categorie:"petit_dejeuner",
    regime:["omnivore","vegetarien"],
    repas:["petit_dejeuner"],
    ingredients:[
      {nom:"isolate whey",  qte_g:50},
      {nom:"poudre amande", qte_g:20},
      {nom:"oeuf entier",   qte_g:50},
      {nom:"creme fraiche", qte_g:150},
    ],
    macros_portion:{pro:29.5, lip:30.5, glu:3.0},
  },
  {
    id:"gaufres_dinde",
    titre:"Gaufres zéro glucide hyper-protéinées (dinde)",
    url:"https://cetoclub.com/gaufres-zero-glucide-hyper-proteinees/",
    portions:4,
    categorie:"plat",
    regime:["carnivore","omnivore"],
    repas:["petit_dejeuner","dejeuner","diner"],
    note:"1 part sur 4 · À déguster avec : beurre (20g), 1 œuf au plat (50g), saumon fumé (60g) et crème fraîche (30g), jambon (60g), ou chantilly salée.",
    ingredients:[
      {nom:"dinde",          qte_g:800},
      {nom:"mozzarella",     qte_g:150},
      {nom:"parmesan",       qte_g:50},
      {nom:"oeuf entier",    qte_g:150},
      {nom:"huile coco",     qte_g:10},
    ],
    macros_portion:{pro:64.0, lip:22.5, glu:0.5},
  },
  {
    id:"kaiserschmarrn",
    note:"1 portion (sur 2) · À compléter avec : 2 œufs, jambon ou fromage + café ou thé",
    titre:"Kaiserschmarrn — Crêpe de l'Empereur cétogène",
    url:"https://cetoclub.com/kaiserschmarrn-crepe-de-lempereur-cetogene/",
    portions:2,
    categorie:"petit_dejeuner",
    regime:["omnivore","vegetarien"],
    repas:["petit_dejeuner"],
    ingredients:[
      {nom:"oeuf entier",        qte_g:150},
      {nom:"blanc oeuf poudre",  qte_g:20},
      {nom:"creme fraiche",      qte_g:70},
      {nom:"allulose",           qte_g:55},
    ],
    macros_portion:{pro:18.5, lip:19.0, glu:1.5},
  },
  {
    id:"porc_creme_cheddar_champignons",
    titre:"Porc à la crème fumée cheddar et champignons",
    url:"https://cetoclub.com/porc-a-la-creme-fumee-cheddar-et-champignons/",
    portions:4,
    categorie:"plat",
    regime:["omnivore"],
    repas:["dejeuner","diner"],
    ingredients:[
      {nom:"porc",          qte_g:1000},
      {nom:"creme fraiche", qte_g:300},
      {nom:"champignons",   qte_g:500},
      {nom:"cheddar",       qte_g:60},
      {nom:"comte",         qte_g:80},
      {nom:"oignon",        qte_g:100},
    ],
    macros_portion:{pro:67.2, lip:71.0, glu:5.0},
  },
  {
    id:"bulgogi_boeuf",
    titre:"Bulgogi version cétogène (Corée)",
    url:"https://cetoclub.com/le-bulgogi-version-cetogene-coree/",
    portions:2,
    categorie:"plat",
    regime:["omnivore"],
    repas:["dejeuner","diner"],
    ingredients:[
      {nom:"boeuf",        qte_g:600},
      {nom:"sauce soja",   qte_g:30},
      {nom:"huile sesame", qte_g:30},
      {nom:"oignon",       qte_g:50},
      {nom:"gingembre",    qte_g:15},
      {nom:"ail",          qte_g:10},
      {nom:"allulose",     qte_g:15},
    ],
    macros_portion:{pro:62.0, lip:45.0, glu:4.0},
  },
  {
    id:"tajine_canard_confit",
    titre:"Tajine de canard confit cétogène",
    url:"https://cetoclub.com/tajine-de-canard-confit-cetogene/",
    portions:4,
    categorie:"plat",
    regime:["carnivore","omnivore"],
    repas:["dejeuner","diner"],
    ingredients:[
      {nom:"canard",      qte_g:800},
      {nom:"oignon",      qte_g:200},
      {nom:"huile olive", qte_g:40},
      {nom:"ail",         qte_g:40},
    ],
    macros_portion:{pro:37.0, lip:66.0, glu:4.5},
  },
  {
    id:"veau_aux_olives",
    titre:"Veau aux olives cétogène",
    url:"https://cetoclub.com/veau-aux-olives/",
    portions:4,
    categorie:"plat",
    regime:["omnivore"],
    repas:["dejeuner","diner"],
    ingredients:[
      {nom:"veau",            qte_g:600},
      {nom:"ghee",            qte_g:20},
      {nom:"tomate concassee",qte_g:400},
      {nom:"olives vertes",   qte_g:100},
      {nom:"oignon",          qte_g:60},
    ],
    macros_portion:{pro:33.0, lip:20.8, glu:5.0},
  },
];

const ALIMENTS = [
  { id:1, nom:"Blanc d'oeuf, cru", cat:"Oeufs & Laitiers", lip:0.17, glu:0.73, pro:10.9, kcal:48.1, note:"Pour 100g" },
  { id:2, nom:"Jaune d'oeuf, cru", cat:"Oeufs & Laitiers", lip:26.7, glu:1.09, pro:15.5, kcal:307.0, note:"CIQUAL — pour 100g" },
  { id:3, nom:"Oeuf entier, cru (1 unité)", cat:"Oeufs & Laitiers", lip:5.9, glu:0.04, pro:7.68, kcal:84.0, unite:true, note:"CIQUAL — macros pour 1 oeuf ≈ 60g" },
  { id:4, nom:"Agneau, collier cru", cat:"Viandes", lip:13.7, glu:0.0, pro:18.0, kcal:195.0, note:null },
  { id:13, nom:"Autruche, viande crue", cat:"Viandes", lip:8.7, glu:0.0, pro:20.2, kcal:159.0, note:null },
  { id:14, nom:"Boeuf, basse-côte crue", cat:"Viandes", lip:13.2, glu:1.45, pro:19.0, kcal:201.0, note:null },
  { id:15, nom:"Boeuf, bavette d'aloyau crue", cat:"Viandes", lip:5.67, glu:0.0, pro:20.4, kcal:133.0, note:null },
  { id:16, nom:"Boeuf, boule de macreuse crue", cat:"Viandes", lip:3.36, glu:0.0, pro:21.8, kcal:118.0, note:null },
  { id:17, nom:"Boeuf, collier cru", cat:"Viandes", lip:12.7, glu:0.78, pro:20.1, kcal:198.0, note:null },
  { id:18, nom:"Boeuf, côte crue", cat:"Viandes", lip:19.6, glu:0.0, pro:18.7, kcal:251.0, note:null },
  { id:19, nom:"Boeuf, entrecôte crue", cat:"Viandes", lip:17.1, glu:0.0, pro:19.4, kcal:231.0, note:null },
  { id:20, nom:"Boeuf, faux-filet cru", cat:"Viandes", lip:6.74, glu:0.6, pro:22.3, kcal:152.0, note:null },
  { id:21, nom:"Boeuf, filet cru", cat:"Viandes", lip:4.95, glu:0.22, pro:21.6, kcal:132.0, note:null },
  { id:22, nom:"Boeuf, gîte à la noix cru", cat:"Viandes", lip:11.5, glu:0.0, pro:20.7, kcal:187.0, note:null },
  { id:23, nom:"Boeuf, hampe crue", cat:"Viandes", lip:8.63, glu:0.0, pro:19.0, kcal:154.0, note:null },
  { id:24, nom:"Boeuf, joue crue", cat:"Viandes", lip:5.02, glu:0.4, pro:22.3, kcal:136.0, note:null },
  { id:25, nom:"Boeuf, onglet cru", cat:"Viandes", lip:6.18, glu:0.62, pro:19.9, kcal:138.0, note:null },
  { id:26, nom:"Boeuf, paleron cru", cat:"Viandes", lip:6.54, glu:0.0, pro:21.2, kcal:144.0, note:null },
  { id:27, nom:"Boeuf, plat de côtes cru", cat:"Viandes", lip:23.7, glu:0.0, pro:18.4, kcal:287.0, note:null },
  { id:28, nom:"Boeuf, queue crue", cat:"Viandes", lip:12.9, glu:0.23, pro:21.5, kcal:203.0, note:null },
  { id:29, nom:"Boeuf, rond de gîte cru", cat:"Viandes", lip:2.02, glu:0.38, pro:22.9, kcal:111.0, note:null },
  { id:30, nom:"Boeuf, rumsteck cru", cat:"Viandes", lip:2.5, glu:0.4, pro:23.5, kcal:118.0, note:null },
  { id:31, nom:"Boeuf, steak ou bifteck cru", cat:"Viandes", lip:17.2, glu:0.06, pro:18.7, kcal:229.0, note:null },
  { id:32, nom:"Boeuf, tende de tranche crue", cat:"Viandes", lip:2.34, glu:0.57, pro:23.1, kcal:116.0, note:null },
  { id:33, nom:"Boeuf, à bourguignon ou pot-au-feu, cru", cat:"Viandes", lip:7.5, glu:0.0, pro:24.0, kcal:164.0, note:null },
  { id:34, nom:"Boeuf, épaule crue", cat:"Viandes", lip:4.97, glu:0.0, pro:21.4, kcal:130.0, note:null },
  { id:35, nom:"Caille, viande crue", cat:"Viandes", lip:4.53, glu:0.0, pro:21.8, kcal:128.0, note:null },
  { id:38, nom:"Canard, magret cru", cat:"Viandes", lip:29.4, glu:0.1, pro:17.9, kcal:337.0, note:null },
  { id:39, nom:"Canard, viande crue", cat:"Viandes", lip:5.95, glu:0.0, pro:18.3, kcal:127.0, note:null },
  { id:41, nom:"Cerf, viande crue", cat:"Viandes", lip:2.42, glu:0.0, pro:23.0, kcal:114.0, note:null },
  { id:42, nom:"Cervelle, agneau, crue", cat:"Viandes", lip:8.58, glu:0.49, pro:10.4, kcal:121.0, note:null },
  { id:43, nom:"Cervelle, porc, crue", cat:"Viandes", lip:9.21, glu:1.02, pro:10.3, kcal:128.0, note:null },
  { id:44, nom:"Cervelle, veau, crue", cat:"Viandes", lip:8.21, glu:0.33, pro:10.3, kcal:116.0, note:null },
  { id:45, nom:"Chapon, viande et peau crues", cat:"Viandes", lip:12.8, glu:0.0, pro:19.9, kcal:195.0, note:null },
  { id:50, nom:"Cheval, viande crue", cat:"Viandes", lip:5.5, glu:0.5, pro:20.2, kcal:132.0, note:null },
  { id:51, nom:"Chevreau, viande crue", cat:"Viandes", lip:2.31, glu:0.0, pro:20.6, kcal:103.0, note:null },
  { id:52, nom:"Chevreuil, viande crue", cat:"Viandes", lip:2.0, glu:0.0, pro:23.0, kcal:110.0, note:null },
  { id:53, nom:"Coeur, agneau, cru", cat:"Viandes", lip:5.68, glu:0.21, pro:16.5, kcal:118.0, note:null },
  { id:54, nom:"Coeur, boeuf, cru", cat:"Viandes", lip:2.95, glu:0.6, pro:18.5, kcal:103.0, note:null },
  { id:55, nom:"Coeur, dinde, cru", cat:"Viandes", lip:7.44, glu:0.4, pro:16.7, kcal:135.0, note:null },
  { id:56, nom:"Coeur, porc, cru", cat:"Viandes", lip:4.36, glu:1.32, pro:17.3, kcal:114.0, note:null },
  { id:57, nom:"Coeur, poulet, cru", cat:"Viandes", lip:9.33, glu:0.71, pro:15.6, kcal:149.0, note:null },
  { id:58, nom:"Coeur, veau, cru", cat:"Viandes", lip:3.98, glu:0.08, pro:17.2, kcal:105.0, note:null },
  { id:63, nom:"Dinde, viande crue", cat:"Viandes", lip:1.93, glu:0.0, pro:22.6, kcal:108.0, note:null },
  { id:65, nom:"Faisan, viande crue", cat:"Viandes", lip:3.73, glu:0.0, pro:23.2, kcal:126.0, note:null },
  { id:66, nom:"Faisan, viande et peau crues", cat:"Viandes", lip:7.95, glu:0.0, pro:23.2, kcal:164.0, note:null },
  { id:67, nom:"Foie, agneau, cru", cat:"Viandes", lip:5.45, glu:0.16, pro:21.8, kcal:137.0, note:null },
  { id:68, nom:"Foie, canard, cru", cat:"Viandes", lip:4.64, glu:3.52, pro:18.7, kcal:131.0, note:null },
  { id:69, nom:"Foie, dinde, cru", cat:"Viandes", lip:5.5, glu:0.0, pro:18.3, kcal:123.0, note:null },
  { id:70, nom:"Foie, génisse, cru", cat:"Viandes", lip:4.3, glu:3.33, pro:21.0, kcal:136.0, note:null },
  { id:71, nom:"Foie, lapin, cru", cat:"Viandes", lip:4.0, glu:5.39, pro:19.0, kcal:134.0, note:null },
  { id:72, nom:"Foie, oie, cru", cat:"Viandes", lip:4.28, glu:6.32, pro:16.4, kcal:129.0, note:null },
  { id:73, nom:"Foie, porc, cru", cat:"Viandes", lip:4.2, glu:1.06, pro:20.6, kcal:124.0, note:null },
  { id:75, nom:"Foie, veau, cru", cat:"Viandes", lip:3.4, glu:5.64, pro:15.5, kcal:120.0, note:null },
  { id:76, nom:"Foie, volaille, cru", cat:"Viandes", lip:4.75, glu:1.25, pro:21.5, kcal:134.0, note:null },
  { id:77, nom:"Gésier, poulet, cru", cat:"Viandes", lip:3.53, glu:0.0, pro:16.8, kcal:99.1, note:null },
  { id:78, nom:"Langue, agneau, crue", cat:"Viandes", lip:10.9, glu:1.75, pro:15.4, kcal:167.0, note:null },
  { id:79, nom:"Langue, boeuf, crue", cat:"Viandes", lip:13.8, glu:0.82, pro:16.8, kcal:195.0, note:null },
  { id:80, nom:"Langue, porc, crue", cat:"Viandes", lip:17.2, glu:0.5, pro:16.3, kcal:222.0, note:null },
  { id:81, nom:"Langue, veau, crue", cat:"Viandes", lip:12.2, glu:0.83, pro:16.9, kcal:181.0, note:null },
  { id:82, nom:"Lapin de garenne, viande crue", cat:"Viandes", lip:2.32, glu:0.0, pro:21.8, kcal:108.0, note:null },
  { id:83, nom:"Lapin, viande crue", cat:"Viandes", lip:11.6, glu:0.58, pro:20.4, kcal:188.0, note:null },
  { id:84, nom:"Lièvre, viande crue", cat:"Viandes", lip:2.67, glu:0.0, pro:21.6, kcal:111.0, note:null },
  { id:89, nom:"Mouton, épaule crue", cat:"Viandes", lip:17.6, glu:0.1, pro:17.3, kcal:228.0, note:null },
  { id:90, nom:"Oie, viande crue", cat:"Viandes", lip:7.13, glu:0.0, pro:22.8, kcal:155.0, note:null },
  { id:92, nom:"Pigeon, viande crue", cat:"Viandes", lip:15.7, glu:0.0, pro:18.0, kcal:213.0, note:null },
  { id:95, nom:"Pintade, viande crue", cat:"Viandes", lip:4.46, glu:0.0, pro:22.0, kcal:128.0, note:null },
  { id:96, nom:"Porc, bardière découennée crue", cat:"Viandes", lip:80.6, glu:0.1, pro:4.51, kcal:744.0, note:null },
  { id:97, nom:"Porc, carré cru", cat:"Viandes", lip:5.94, glu:0.4, pro:22.7, kcal:146.0, note:null },
  { id:98, nom:"Porc, côte crue", cat:"Viandes", lip:9.3, glu:0.38, pro:19.8, kcal:164.0, note:null },
  { id:99, nom:"Porc, escalope de jambon crue", cat:"Viandes", lip:4.76, glu:0.0, pro:21.5, kcal:129.0, note:null },
  { id:100, nom:"Porc, filet mignon cru", cat:"Viandes", lip:4.09, glu:0.4, pro:21.2, kcal:123.0, note:null },
  { id:101, nom:"Porc, gorge découennée crue", cat:"Viandes", lip:47.5, glu:0.14, pro:11.6, kcal:475.0, note:null },
  { id:102, nom:"Porc, jambon sans jarret, sans bateau, découenné, dégraissé, désossé, cru", cat:"Viandes", lip:6.3, glu:0.28, pro:20.9, kcal:141.0, note:null },
  { id:103, nom:"Porc, jambonneau arrière, découenné, dégraisssé, désossé, cru", cat:"Viandes", lip:7.31, glu:0.28, pro:20.2, kcal:148.0, note:null },
  { id:104, nom:"Porc, palette crue", cat:"Viandes", lip:12.1, glu:0.0, pro:24.8, kcal:208.0, note:null },
  { id:105, nom:"Porc, palette, découennée, dégraissée, désossée, crue", cat:"Viandes", lip:10.4, glu:0.25, pro:19.9, kcal:174.0, note:null },
  { id:106, nom:"Porc, poitrine crue", cat:"Viandes", lip:20.5, glu:0.0, pro:17.0, kcal:253.0, note:null },
  { id:107, nom:"Porc, poitrine cutter, sans mouille, crue", cat:"Viandes", lip:28.7, glu:0.22, pro:15.9, kcal:323.0, note:null },
  { id:108, nom:"Porc, rouelle de jambon crue", cat:"Viandes", lip:7.56, glu:0.0, pro:20.2, kcal:149.0, note:null },
  { id:109, nom:"Porc, rôti cru", cat:"Viandes", lip:6.86, glu:0.5, pro:22.3, kcal:153.0, note:null },
  { id:110, nom:"Porc, rôti filet avec chaînette, cru", cat:"Viandes", lip:6.2, glu:0.37, pro:22.3, kcal:146.0, note:null },
  { id:111, nom:"Porc, travers cru", cat:"Viandes", lip:18.0, glu:0.6, pro:18.0, kcal:237.0, note:null },
  { id:112, nom:"Porc, échine crue", cat:"Viandes", lip:18.8, glu:0.1, pro:17.1, kcal:238.0, note:null },
  { id:113, nom:"Porc, épaule crue", cat:"Viandes", lip:11.2, glu:0.38, pro:18.9, kcal:178.0, note:null },
  { id:115, nom:"Poule, viande crue", cat:"Viandes", lip:6.32, glu:0.0, pro:21.3, kcal:142.0, note:null },
  { id:125, nom:"Poulet, filet sans peau cru", cat:"Viandes", lip:1.5, glu:0.0, pro:23.4, kcal:110.0, note:null },
  { id:132, nom:"Poulet, viande et peau crues", cat:"Viandes", lip:9.54, glu:0.3, pro:21.5, kcal:173.0, note:null },
  { id:133, nom:"Ris, agneau, cru", cat:"Viandes", lip:9.82, glu:0.17, pro:14.8, kcal:148.0, note:null },
  { id:134, nom:"Ris, veau, cru", cat:"Viandes", lip:3.07, glu:0.0, pro:17.2, kcal:96.5, note:null },
  { id:135, nom:"Rognon, agneau, cru", cat:"Viandes", lip:3.43, glu:1.08, pro:14.7, kcal:93.9, note:null },
  { id:136, nom:"Rognon, boeuf, cru", cat:"Viandes", lip:2.65, glu:0.85, pro:17.1, kcal:95.7, note:null },
  { id:137, nom:"Rognon, porc, cru", cat:"Viandes", lip:3.25, glu:1.1, pro:16.5, kcal:99.5, note:null },
  { id:138, nom:"Rognon, veau, cru", cat:"Viandes", lip:3.12, glu:0.85, pro:15.8, kcal:94.5, note:null },
  { id:139, nom:"Sang, boeuf, cru", cat:"Viandes", lip:0.12, glu:0.8, pro:19.5, kcal:82.1, note:null },
  { id:140, nom:"Sanglier, viande crue", cat:"Viandes", lip:7.14, glu:0.0, pro:21.5, kcal:150.0, note:null },
  { id:141, nom:"Tripes, boeuf, crues", cat:"Viandes", lip:3.69, glu:0.0, pro:12.1, kcal:81.5, note:null },
  { id:142, nom:"Veau, carré cru", cat:"Viandes", lip:5.44, glu:0.4, pro:19.3, kcal:128.0, note:null },
  { id:143, nom:"Veau, collier cru", cat:"Viandes", lip:5.92, glu:0.0, pro:19.8, kcal:133.0, note:null },
  { id:144, nom:"Veau, côte crue", cat:"Viandes", lip:12.9, glu:0.0, pro:18.3, kcal:189.0, note:null },
  { id:145, nom:"Veau, escalope crue", cat:"Viandes", lip:3.28, glu:0.58, pro:20.5, kcal:114.0, note:null },
  { id:146, nom:"Veau, filet cru", cat:"Viandes", lip:1.4, glu:0.0, pro:20.6, kcal:95.0, note:null },
  { id:147, nom:"Veau, jarret cru", cat:"Viandes", lip:3.66, glu:0.0, pro:21.3, kcal:118.0, note:null },
  { id:148, nom:"Veau, noix,crue", cat:"Viandes", lip:2.58, glu:0.0, pro:21.8, kcal:111.0, note:null },
  { id:149, nom:"Veau, pied cru", cat:"Viandes", lip:12.0, glu:0.0, pro:19.1, kcal:184.0, note:null },
  { id:150, nom:"Veau, poitrine crue", cat:"Viandes", lip:14.8, glu:0.0, pro:17.5, kcal:203.0, note:null },
  { id:151, nom:"Veau, rôti cru", cat:"Viandes", lip:3.96, glu:0.0, pro:27.3, kcal:145.0, note:null },
  { id:152, nom:"Veau, épaule crue", cat:"Viandes", lip:4.63, glu:0.0, pro:20.7, kcal:124.0, note:null },
  { id:153, nom:"Andouille", cat:"Viandes", lip:15.1, glu:0.3, pro:18.4, kcal:211.0, note:null },
  { id:158, nom:"Andouillette, grillée/poêlée", cat:"Viandes", lip:22.3, glu:0.54, pro:24.5, kcal:301.0, note:null },
  { id:160, nom:"Boudin blanc, grillé/poêlé", cat:"Viandes", lip:17.1, glu:6.6, pro:9.89, kcal:220.0, note:null },
  { id:162, nom:"Boudin noir, grillé/poêlé", cat:"Viandes", lip:20.3, glu:3.78, pro:11.9, kcal:246.0, note:null },
  { id:165, nom:"Bresaola", cat:"Viandes", lip:4.3, glu:0.49, pro:32.8, kcal:172.0, note:null },
  { id:166, nom:"Canard, magret fumé", cat:"Viandes", lip:32.0, glu:0.5, pro:18.0, kcal:362.0, note:null },
  { id:167, nom:"Cervelas", cat:"Viandes", lip:24.8, glu:1.56, pro:11.9, kcal:278.0, note:null },
  { id:168, nom:"Cervelas obernois", cat:"Viandes", lip:27.5, glu:1.0, pro:13.0, kcal:305.0, note:null },
  { id:169, nom:"Cervelas à l'ail, pur porc", cat:"Viandes", lip:27.4, glu:0.2, pro:12.5, kcal:297.0, note:null },
  { id:170, nom:"Chair à saucisse crue", cat:"Viandes", lip:29.1, glu:0.6, pro:14.7, kcal:323.0, note:null },
  { id:171, nom:"Chair à saucisse, pur porc, crue", cat:"Viandes", lip:21.2, glu:0.0, pro:16.9, kcal:258.0, note:null },
  { id:172, nom:"Charcuterie (aliment moyen)", cat:"Viandes", lip:17.5, glu:1.94, pro:18.6, kcal:241.0, note:null },
  { id:173, nom:"Chipolata crue", cat:"Viandes", lip:20.6, glu:1.0, pro:15.8, kcal:253.0, note:null },
  { id:174, nom:"Chipolata cuite", cat:"Viandes", lip:22.4, glu:0.8, pro:18.8, kcal:283.0, note:null },
  { id:176, nom:"Chorizo supérieur, doux ou fort, type charcuterie en tranches", cat:"Viandes", lip:23.9, glu:1.47, pro:22.6, kcal:320.0, note:null },
  { id:177, nom:"Chorizo supérieur, doux ou fort, type saucisse sèche", cat:"Viandes", lip:41.9, glu:1.87, pro:20.9, kcal:474.0, note:null },
  { id:178, nom:"Confit de canard, appertisé", cat:"Viandes", lip:18.8, glu:0.15, pro:25.7, kcal:273.0, note:null },
  { id:182, nom:"Coppa", cat:"Viandes", lip:20.0, glu:1.0, pro:25.0, kcal:284.0, note:null },
  { id:183, nom:"Corned-beef, appertisé", cat:"Viandes", lip:10.9, glu:0, pro:23.2, kcal:191.0, note:null },
  { id:184, nom:"Diot cru", cat:"Viandes", lip:30.0, glu:0, pro:18.0, kcal:342.0, note:null },
  { id:185, nom:"Dés, allumettes, râpé ou haché de jambon", cat:"Viandes", lip:4.46, glu:2.08, pro:17.9, kcal:120.0, note:null },
  { id:186, nom:"Dés, allumettes, râpé ou haché de jambon de volaille", cat:"Viandes", lip:5.88, glu:1.58, pro:18.0, kcal:132.0, note:null },
  { id:187, nom:"Farce porc et boeuf crue", cat:"Viandes", lip:26.5, glu:4.4, pro:11.8, kcal:309.0, note:null },
  { id:188, nom:"Filet de bacon", cat:"Viandes", lip:2.6, glu:0.7, pro:23.1, kcal:118.0, note:null },
  { id:189, nom:"Fines tranches végétales, préemballées", cat:"Viandes", lip:11.1, glu:4.13, pro:29.7, kcal:242.0, note:null },
  { id:192, nom:"Foie gras, canard, cru", cat:"Viandes", lip:63.4, glu:1.41, pro:5.94, kcal:600.0, note:null },
  { id:193, nom:"Foie gras, canard, entier, cuit", cat:"Viandes", lip:54.6, glu:0.026, pro:8.41, kcal:526.0, note:null },
  { id:194, nom:"Fromage de tête", cat:"Viandes", lip:12.9, glu:3.15, pro:13.8, kcal:184.0, note:null },
  { id:195, nom:"Galantine", cat:"Viandes", lip:1.73, glu:1.28, pro:22.0, kcal:109.0, note:null },
  { id:196, nom:"Haché de volaille", cat:"Viandes", lip:5.68, glu:3.5, pro:17.7, kcal:137.0, note:null },
  { id:197, nom:"Jambon cru", cat:"Viandes", lip:13.2, glu:4.27, pro:25.9, kcal:239.0, note:null },
  { id:198, nom:"Jambon cru fumé", cat:"Viandes", lip:16.1, glu:0.98, pro:24.2, kcal:246.0, note:null },
  { id:201, nom:"Jambon cuit, choix, découenné dégraissé", cat:"Viandes", lip:3.24, glu:1.88, pro:19.6, kcal:115.0, note:null },
  { id:209, nom:"Jambon de Bayonne", cat:"Viandes", lip:12.6, glu:4.51, pro:28.0, kcal:243.0, note:null },
  { id:210, nom:"Jambon de dinde ou blanc de dinde en tranche", cat:"Viandes", lip:1.67, glu:0.023, pro:20.9, kcal:99.3, note:null },
  { id:211, nom:"Jambon de porc à cuire ou jambon à rôtir/cuire au four", cat:"Viandes", lip:9.0, glu:1.75, pro:18.8, kcal:163.0, note:null },
  { id:212, nom:"Jambon de poulet ou blanc de poulet en tranche", cat:"Viandes", lip:1.79, glu:1.39, pro:20.7, kcal:105.0, note:null },
  { id:213, nom:"Jambon de volaille ou blanc de volaille, à teneur réduite en sel, en tranche", cat:"Viandes", lip:1.65, glu:1.6, pro:21.3, kcal:108.0, note:null },
  { id:214, nom:"Jambon persillé en gelée", cat:"Viandes", lip:7.9, glu:0.48, pro:19.0, kcal:151.0, note:null },
  { id:215, nom:"Jambon sec", cat:"Viandes", lip:12.6, glu:0.48, pro:28.7, kcal:230.0, note:null },
  { id:216, nom:"Jambon sec de Parme", cat:"Viandes", lip:15.4, glu:0.3, pro:27.2, kcal:248.0, note:null },
  { id:217, nom:"Jambon sec Serrano", cat:"Viandes", lip:12.3, glu:0.76, pro:30.4, kcal:235.0, note:null },
  { id:218, nom:"Jambon à l'os braisé", cat:"Viandes", lip:12.3, glu:0.3, pro:21.6, kcal:198.0, note:null },
  { id:219, nom:"Jambonneau, cuit", cat:"Viandes", lip:6.0, glu:5.43, pro:20.0, kcal:157.0, note:null },
  { id:221, nom:"Lardon fumé, cuit", cat:"Viandes", lip:22.1, glu:4.8, pro:14.7, kcal:277.0, note:null },
  { id:223, nom:"Lardon nature, cuit", cat:"Viandes", lip:24.5, glu:2.0, pro:23.8, kcal:324.0, note:null },
  { id:227, nom:"Merguez, boeuf et mouton, crue", cat:"Viandes", lip:27.6, glu:2.8, pro:14.0, kcal:315.0, note:null },
  { id:235, nom:"Mortadelle, pur porc", cat:"Viandes", lip:25.8, glu:4.46, pro:14.8, kcal:310.0, note:null },
  { id:236, nom:"Mousse de foie de porc", cat:"Viandes", lip:24.9, glu:3.39, pro:12.0, kcal:286.0, note:null },
  { id:237, nom:"Museau de boeuf", cat:"Viandes", lip:5.17, glu:0.0, pro:26.2, kcal:151.0, note:null },
  { id:238, nom:"Oeuf au jambon en gelée", cat:"Viandes", lip:4.7, glu:0, pro:11.5, kcal:0, note:null },
  { id:239, nom:"Pancetta ou poitrine roulée sèche", cat:"Viandes", lip:28.8, glu:2.49, pro:20.2, kcal:349.0, note:null },
  { id:240, nom:"Pavé au poivre (charcuterie)", cat:"Viandes", lip:30.3, glu:1.51, pro:23.5, kcal:374.0, note:null },
  { id:241, nom:"Poitrine de porc en salaison, fumée, crue", cat:"Viandes", lip:26.1, glu:0.79, pro:15.6, kcal:303.0, note:null },
  { id:242, nom:"Poitrine de porc en salaison, nature, crue", cat:"Viandes", lip:24.7, glu:0.76, pro:15.7, kcal:288.0, note:null },
  { id:244, nom:"Rosette ou fuseau", cat:"Viandes", lip:30.7, glu:4.86, pro:24.2, kcal:392.0, note:null },
  { id:245, nom:"Roulade de porc pistachée", cat:"Viandes", lip:23.5, glu:3.0, pro:15.3, kcal:287.0, note:null },
  { id:246, nom:"Rôti de volaille en salaison, cuit", cat:"Viandes", lip:1.73, glu:1.28, pro:22.0, kcal:109.0, note:null },
  { id:247, nom:"Salami", cat:"Viandes", lip:41.8, glu:2.59, pro:17.7, kcal:457.0, note:null },
  { id:248, nom:"Salami pur porc", cat:"Viandes", lip:41.5, glu:0.75, pro:17.0, kcal:446.0, note:null },
  { id:249, nom:"Salami type danois", cat:"Viandes", lip:43.0, glu:2.42, pro:14.5, kcal:455.0, note:null },
  { id:250, nom:"Saucisse (aliment moyen)", cat:"Viandes", lip:23.4, glu:1.22, pro:17.4, kcal:286.0, note:null },
  { id:251, nom:"Saucisse alsacienne fumée ou gendarme", cat:"Viandes", lip:24.9, glu:0, pro:19.0, kcal:300.0, note:null },
  { id:252, nom:"Saucisse cocktail", cat:"Viandes", lip:25.9, glu:1.46, pro:12.7, kcal:290.0, note:null },
  { id:253, nom:"Saucisse de foie", cat:"Viandes", lip:35.9, glu:0.9, pro:11.7, kcal:374.0, note:null },
  { id:254, nom:"Saucisse de Francfort", cat:"Viandes", lip:23.4, glu:3.37, pro:13.7, kcal:279.0, note:null },
  { id:255, nom:"Saucisse de jambon pur porc", cat:"Viandes", lip:17.5, glu:3.96, pro:15.7, kcal:236.0, note:null },
  { id:256, nom:"Saucisse de langue à la pistache", cat:"Viandes", lip:25.8, glu:0, pro:15.3, kcal:294.0, note:null },
  { id:257, nom:"Saucisse de Montbéliard, à cuire", cat:"Viandes", lip:27.3, glu:1.72, pro:17.3, kcal:322.0, note:null },
  { id:258, nom:"Saucisse de Morteau", cat:"Viandes", lip:36.6, glu:1.17, pro:16.0, kcal:398.0, note:null },
  { id:259, nom:"Saucisse de Morteau bouillie/cuite à l'eau", cat:"Viandes", lip:29.1, glu:0.0, pro:15.2, kcal:323.0, note:null },
  { id:260, nom:"Saucisse de Strasbourg ou knack, à cuire", cat:"Viandes", lip:25.9, glu:1.39, pro:12.4, kcal:291.0, note:null },
  { id:262, nom:"Saucisse de Toulouse crue", cat:"Viandes", lip:29.5, glu:0.64, pro:13.3, kcal:321.0, note:null },
  { id:263, nom:"Saucisse de Toulouse cuite", cat:"Viandes", lip:22.1, glu:1.28, pro:18.8, kcal:279.0, note:null },
  { id:264, nom:"Saucisse de volaille façon charcutière", cat:"Viandes", lip:19.1, glu:1.14, pro:15.6, kcal:239.0, note:null },
  { id:265, nom:"Saucisse de volaille type knack", cat:"Viandes", lip:18.9, glu:1.82, pro:14.0, kcal:236.0, note:null },
  { id:266, nom:"Saucisse fumée à cuire", cat:"Viandes", lip:30.4, glu:0, pro:15.6, kcal:336.0, note:null },
  { id:267, nom:"Saucisse sèche", cat:"Viandes", lip:37.1, glu:4.04, pro:27.3, kcal:460.0, note:null },
  { id:268, nom:"Saucisse viennoise crue", cat:"Viandes", lip:21.3, glu:0, pro:10.3, kcal:233.0, note:null },
  { id:269, nom:"Saucisson de cheval type cervelas", cat:"Viandes", lip:20.0, glu:1.4, pro:14.2, kcal:244.0, note:null },
  { id:270, nom:"Saucisson pur porc cuit", cat:"Viandes", lip:29.0, glu:1.3, pro:13.8, kcal:322.0, note:null },
  { id:271, nom:"Saucisson sec", cat:"Viandes", lip:33.1, glu:5.48, pro:24.2, kcal:418.0, note:null },
  { id:272, nom:"Saucisson sec aux noix et/ou noisettes", cat:"Viandes", lip:39.7, glu:1.78, pro:27.7, kcal:477.0, note:null },
  { id:275, nom:"Saucisson sec pur porc, qualité supérieure", cat:"Viandes", lip:27.6, glu:2.1, pro:27.7, kcal:368.0, note:null },
  { id:276, nom:"Saucisson à l'ail", cat:"Viandes", lip:23.6, glu:0.56, pro:15.0, kcal:276.0, note:null },
  { id:277, nom:"Viande des Grisons", cat:"Viandes", lip:5.47, glu:0.56, pro:38.9, kcal:207.0, note:null },
  { id:278, nom:"Épaule de porc, cuite, choix, découennée dégraissée", cat:"Viandes", lip:4.5, glu:2.8, pro:18.0, kcal:124.0, note:null },
  { id:280, nom:"Anchois, cru", cat:"Poissons & Fruits de mer", lip:6.07, glu:0, pro:18.6, kcal:129.0, note:null },
  { id:281, nom:"Anguille, crue", cat:"Poissons & Fruits de mer", lip:18.6, glu:2.06, pro:16.1, kcal:240.0, note:null },
  { id:282, nom:"Bar commun ou loup (Méditerranée), sauvage, cru", cat:"Poissons & Fruits de mer", lip:1.94, glu:0.0, pro:20.1, kcal:97.9, note:null },
  { id:285, nom:"Bar rayé ou bar d'Amérique, cru", cat:"Poissons & Fruits de mer", lip:3.58, glu:0, pro:20.3, kcal:113.0, note:null },
  { id:286, nom:"Baudroie rousse ou Lotte, crue", cat:"Poissons & Fruits de mer", lip:0.37, glu:0, pro:16.7, kcal:70.2, note:null },
  { id:287, nom:"Bogue, crue", cat:"Poissons & Fruits de mer", lip:2.03, glu:0.53, pro:17.9, kcal:92.1, note:null },
  { id:288, nom:"Bonite ou bonite à dos rayé, crue", cat:"Poissons & Fruits de mer", lip:8.01, glu:0.0, pro:22.3, kcal:161.0, note:null },
  { id:289, nom:"Brochet, cru", cat:"Poissons & Fruits de mer", lip:0.94, glu:1.0, pro:18.8, kcal:87.7, note:null },
  { id:290, nom:"Brème, cru", cat:"Poissons & Fruits de mer", lip:4.0, glu:1.03, pro:16.9, kcal:108.0, note:null },
  { id:292, nom:"Cabillaud, cru", cat:"Poissons & Fruits de mer", lip:0.57, glu:0, pro:18.1, kcal:77.4, note:null },
  { id:293, nom:"Capelan, cru", cat:"Poissons & Fruits de mer", lip:1.71, glu:0.0, pro:18.7, kcal:90.0, note:null },
  { id:294, nom:"Carangue, cru", cat:"Poissons & Fruits de mer", lip:2.7, glu:0.0, pro:19.9, kcal:104.0, note:null },
  { id:295, nom:"Cardine franche, crue", cat:"Poissons & Fruits de mer", lip:1.53, glu:0.0, pro:19.9, kcal:93.4, note:null },
  { id:296, nom:"Carpe,  élevage, crue", cat:"Poissons & Fruits de mer", lip:4.76, glu:0.0, pro:17.7, kcal:114.0, note:null },
  { id:297, nom:"Carrelet ou plie ou plie commune, cru", cat:"Poissons & Fruits de mer", lip:0.94, glu:0, pro:20.0, kcal:88.6, note:null },
  { id:298, nom:"Chinchard gras, cru", cat:"Poissons & Fruits de mer", lip:7.66, glu:0.0, pro:19.6, kcal:147.0, note:null },
  { id:299, nom:"Chinchard, cru", cat:"Poissons & Fruits de mer", lip:4.42, glu:0.0, pro:19.0, kcal:116.0, note:null },
  { id:300, nom:"Congre ou congre commun, cru", cat:"Poissons & Fruits de mer", lip:4.6, glu:3.15, pro:18.3, kcal:127.0, note:null },
  { id:301, nom:"Corb, cru", cat:"Poissons & Fruits de mer", lip:0.8, glu:0.0, pro:20.0, kcal:87.2, note:null },
  { id:302, nom:"Corégone lavaret ou lavaret, cru", cat:"Poissons & Fruits de mer", lip:3.72, glu:0.0, pro:20.5, kcal:115.0, note:null },
  { id:303, nom:"Coulirou, cru", cat:"Poissons & Fruits de mer", lip:0.1, glu:0.0, pro:17.5, kcal:70.9, note:null },
  { id:304, nom:"Denté ou denté commun, cru", cat:"Poissons & Fruits de mer", lip:3.5, glu:0.65, pro:17.0, kcal:102.0, note:null },
  { id:305, nom:"Dorade grise ou daurade grise, ou griset, crue", cat:"Poissons & Fruits de mer", lip:5.27, glu:0.0, pro:20.5, kcal:129.0, note:null },
  { id:306, nom:"Dorade rose ou daurade rose ou pageot rose, crue", cat:"Poissons & Fruits de mer", lip:2.0, glu:0.0, pro:21.0, kcal:102.0, note:null },
  { id:307, nom:"Dorade royale ou daurade ou vraie daurade, sauvage, crue", cat:"Poissons & Fruits de mer", lip:2.31, glu:0.6, pro:18.1, kcal:95.6, note:null },
  { id:309, nom:"Empereur, filet, sans peau, cru", cat:"Poissons & Fruits de mer", lip:1.5, glu:0.0, pro:15.0, kcal:73.5, note:null },
  { id:310, nom:"Espadon, cru", cat:"Poissons & Fruits de mer", lip:5.97, glu:1.0, pro:18.9, kcal:134.0, note:null },
  { id:311, nom:"Esturgeon d'Europe occidentale, cru", cat:"Poissons & Fruits de mer", lip:0, glu:0, pro:0, kcal:0, note:null },
  { id:312, nom:"Flétan de l'Atlantique ou flétan, cru", cat:"Poissons & Fruits de mer", lip:1.31, glu:0.0, pro:21.2, kcal:96.5, note:null },
  { id:313, nom:"Flétan du Groënland ou flétan noir ou flétan commun, cru", cat:"Poissons & Fruits de mer", lip:12.7, glu:0, pro:13.5, kcal:168.0, note:null },
  { id:315, nom:"Grenadier (de roche), cru", cat:"Poissons & Fruits de mer", lip:0.81, glu:0, pro:15.4, kcal:68.9, note:null },
  { id:316, nom:"Grondin perlon, cru", cat:"Poissons & Fruits de mer", lip:1.79, glu:0, pro:20.3, kcal:97.4, note:null },
  { id:317, nom:"Grondin, cru", cat:"Poissons & Fruits de mer", lip:2.0, glu:3.4, pro:19.0, kcal:108.0, note:null },
  { id:318, nom:"Hareng gras, cru", cat:"Poissons & Fruits de mer", lip:10.8, glu:0.77, pro:18.7, kcal:175.0, note:null },
  { id:319, nom:"Hareng, cru", cat:"Poissons & Fruits de mer", lip:11.7, glu:0.0, pro:17.7, kcal:176.0, note:null },
  { id:320, nom:"Hoki de Nouvelle-Zélande, cru", cat:"Poissons & Fruits de mer", lip:1.46, glu:0, pro:15.6, kcal:75.5, note:null },
  { id:321, nom:"Hoki, tout lieu de pêche, cru", cat:"Poissons & Fruits de mer", lip:2.36, glu:0, pro:17.8, kcal:92.3, note:null },
  { id:323, nom:"Julienne ou lingue, crue", cat:"Poissons & Fruits de mer", lip:0.44, glu:0, pro:19.2, kcal:80.8, note:null },
  { id:324, nom:"Lieu jaune ou colin, cru", cat:"Poissons & Fruits de mer", lip:0.51, glu:0.0, pro:17.7, kcal:75.5, note:null },
  { id:325, nom:"Lieu noir, cru", cat:"Poissons & Fruits de mer", lip:0.8, glu:0.0, pro:18.8, kcal:82.5, note:null },
  { id:326, nom:"Lieu ou colin d'Alaska, cru", cat:"Poissons & Fruits de mer", lip:0.61, glu:0.51, pro:16.3, kcal:72.6, note:null },
  { id:327, nom:"Limande, crue", cat:"Poissons & Fruits de mer", lip:0.85, glu:0, pro:18.3, kcal:80.8, note:null },
  { id:328, nom:"Limande-sole, crue", cat:"Poissons & Fruits de mer", lip:1.4, glu:0, pro:17.0, kcal:80.6, note:null },
  { id:329, nom:"Lingue bleue, crue", cat:"Poissons & Fruits de mer", lip:0.44, glu:0.0, pro:18.9, kcal:79.6, note:null },
  { id:330, nom:"Lompe, crue", cat:"Poissons & Fruits de mer", lip:14.2, glu:0.0, pro:10.0, kcal:168.0, note:null },
  { id:331, nom:"Lotte de rivière, crue", cat:"Poissons & Fruits de mer", lip:0.66, glu:0.0, pro:17.8, kcal:77.0, note:null },
  { id:332, nom:"Lotte ou baudroie, crue", cat:"Poissons & Fruits de mer", lip:0.74, glu:0, pro:15.1, kcal:67.0, note:null },
  { id:333, nom:"Loup de l'Atlantique, cru", cat:"Poissons & Fruits de mer", lip:2.61, glu:0, pro:16.6, kcal:89.9, note:null },
  { id:334, nom:"Loup tacheté, cru", cat:"Poissons & Fruits de mer", lip:4.8, glu:0.0, pro:16.3, kcal:108.0, note:null },
  { id:335, nom:"Mahi-mahi, chair, cru", cat:"Poissons & Fruits de mer", lip:0.7, glu:1.15, pro:18.5, kcal:84.9, note:null },
  { id:336, nom:"Maquereau espagnol ou maquereau blanc ou billard, cru", cat:"Poissons & Fruits de mer", lip:5.15, glu:0.0, pro:22.1, kcal:135.0, note:null },
  { id:337, nom:"Maquereau, cru", cat:"Poissons & Fruits de mer", lip:13.5, glu:0.93, pro:18.1, kcal:198.0, note:null },
  { id:338, nom:"Merlan, cru", cat:"Poissons & Fruits de mer", lip:0.47, glu:0, pro:18.8, kcal:79.2, note:null },
  { id:339, nom:"Merlu, cru", cat:"Poissons & Fruits de mer", lip:1.35, glu:0.0, pro:17.6, kcal:82.6, note:null },
  { id:340, nom:"Mulet, cru", cat:"Poissons & Fruits de mer", lip:3.62, glu:1.35, pro:20.1, kcal:118.0, note:null },
  { id:341, nom:"Mérou, cru", cat:"Poissons & Fruits de mer", lip:0.86, glu:0.72, pro:18.6, kcal:85.2, note:null },
  { id:342, nom:"Omble chevalier, cru", cat:"Poissons & Fruits de mer", lip:2.7, glu:0.0, pro:19.8, kcal:103.0, note:null },
  { id:343, nom:"Orphie commune, crue", cat:"Poissons & Fruits de mer", lip:5.91, glu:3.06, pro:20.0, kcal:145.0, note:null },
  { id:344, nom:"Pangas, poisson-chat, machoiron, cru", cat:"Poissons & Fruits de mer", lip:1.27, glu:0, pro:13.5, kcal:65.2, note:null },
  { id:345, nom:"Perche du Nil, crue", cat:"Poissons & Fruits de mer", lip:0.68, glu:0, pro:19.1, kcal:82.4, note:null },
  { id:346, nom:"Perche ou perche européenne, crue", cat:"Poissons & Fruits de mer", lip:1.19, glu:0.6, pro:17.9, kcal:84.6, note:null },
  { id:347, nom:"Raie, crue", cat:"Poissons & Fruits de mer", lip:0.47, glu:0.5, pro:21.4, kcal:91.9, note:null },
  { id:348, nom:"Rascasse ou rascasse de profondeur, crue", cat:"Poissons & Fruits de mer", lip:1.33, glu:0, pro:18.9, kcal:87.6, note:null },
  { id:349, nom:"Requin, cru", cat:"Poissons & Fruits de mer", lip:2.91, glu:1.34, pro:20.8, kcal:115.0, note:null },
  { id:350, nom:"Rouget-barbet de roche, cru", cat:"Poissons & Fruits de mer", lip:9.37, glu:0, pro:18.4, kcal:158.0, note:null },
  { id:353, nom:"Sabre, cru", cat:"Poissons & Fruits de mer", lip:5.9, glu:0, pro:18.0, kcal:125.0, note:null },
  { id:354, nom:"Saint-Pierre, cru", cat:"Poissons & Fruits de mer", lip:0.8, glu:0, pro:19.9, kcal:86.7, note:null },
  { id:355, nom:"Sandre, cru", cat:"Poissons & Fruits de mer", lip:1.08, glu:1.06, pro:18.3, kcal:87.2, note:null },
  { id:356, nom:"Sardine, crue", cat:"Poissons & Fruits de mer", lip:9.17, glu:0.0, pro:19.5, kcal:160.0, note:null },
  { id:358, nom:"Saumon, sauvage, cru", cat:"Poissons & Fruits de mer", lip:9.17, glu:0.0, pro:21.0, kcal:166.0, note:null },
  { id:359, nom:"Saumon fumé", cat:"Poissons & Fruits de mer", lip:10.5, glu:0.1, pro:22.2, kcal:184.0, note:null },
  { id:360, nom:"Saupe, crue", cat:"Poissons & Fruits de mer", lip:2.5, glu:0.5, pro:18.0, kcal:96.5, note:null },
  { id:361, nom:"Sole tropicale ou sole-langue, crue", cat:"Poissons & Fruits de mer", lip:0.58, glu:0.53, pro:15.7, kcal:70.3, note:null },
  { id:362, nom:"Sole, crue", cat:"Poissons & Fruits de mer", lip:0.6, glu:0, pro:18.0, kcal:77.3, note:null },
  { id:363, nom:"Sprat, cru", cat:"Poissons & Fruits de mer", lip:11.9, glu:0.57, pro:19.8, kcal:189.0, note:null },
  { id:364, nom:"Sébaste du nord ou grand sébaste, ou dorade sébaste, ou daurade sébaste, crue", cat:"Poissons & Fruits de mer", lip:1.6, glu:0, pro:18.8, kcal:89.5, note:null },
  { id:365, nom:"Tacaud, cru", cat:"Poissons & Fruits de mer", lip:0.33, glu:0.0, pro:19.7, kcal:81.3, note:null },
  { id:366, nom:"Thon albacore, cru", cat:"Poissons & Fruits de mer", lip:0.94, glu:1.0, pro:25.0, kcal:112.0, note:null },
  { id:367, nom:"Thon germon ou thon blanc, cru", cat:"Poissons & Fruits de mer", lip:1.37, glu:0, pro:27.2, kcal:121.0, note:null },
  { id:368, nom:"Thon listao ou bonite à ventre rayé, cru", cat:"Poissons & Fruits de mer", lip:1.01, glu:0.0, pro:22.0, kcal:97.1, note:null },
  { id:369, nom:"Thon rouge, cru", cat:"Poissons & Fruits de mer", lip:6.81, glu:0.59, pro:23.3, kcal:157.0, note:null },
  { id:370, nom:"Thon, cru", cat:"Poissons & Fruits de mer", lip:5.84, glu:0, pro:23.3, kcal:146.0, note:null },
  { id:371, nom:"Tilapia, cru", cat:"Poissons & Fruits de mer", lip:2.13, glu:0, pro:18.1, kcal:91.6, note:null },
  { id:372, nom:"Truite arc en ciel, élevage, crue", cat:"Poissons & Fruits de mer", lip:6.24, glu:0.0, pro:19.0, kcal:132.0, note:null },
  { id:373, nom:"Truite de mer, crue", cat:"Poissons & Fruits de mer", lip:3.63, glu:0.81, pro:19.6, kcal:114.0, note:null },
  { id:374, nom:"Truite ou truite fario, élevage, crue", cat:"Poissons & Fruits de mer", lip:6.22, glu:0.0, pro:19.3, kcal:133.0, note:null },
  { id:375, nom:"Truite saumonée, crue", cat:"Poissons & Fruits de mer", lip:7.4, glu:0, pro:19.2, kcal:143.0, note:null },
  { id:377, nom:"Turbot, sauvage, cru", cat:"Poissons & Fruits de mer", lip:2.54, glu:0, pro:17.2, kcal:91.5, note:null },
  { id:379, nom:"Vivaneau, cru", cat:"Poissons & Fruits de mer", lip:1.34, glu:0.0, pro:20.5, kcal:94.1, note:null },
  { id:380, nom:"Églefin, cru", cat:"Poissons & Fruits de mer", lip:0.35, glu:1.02, pro:17.3, kcal:76.2, note:null },
  { id:381, nom:"Éperlan, cru", cat:"Poissons & Fruits de mer", lip:1.7, glu:0, pro:17.5, kcal:85.4, note:null },
  { id:382, nom:"Calmar ou calamar ou encornet, cru", cat:"Poissons & Fruits de mer", lip:1.19, glu:2.17, pro:14.4, kcal:77.0, note:null },
  { id:383, nom:"Clam, praire ou palourde, cru", cat:"Poissons & Fruits de mer", lip:2.65, glu:2.66, pro:11.5, kcal:80.5, note:null },
  { id:384, nom:"Coquille Saint-Jacques, noix et corail, crue", cat:"Poissons & Fruits de mer", lip:1.31, glu:0.78, pro:17.0, kcal:83.0, note:null },
  { id:385, nom:"Coquille Saint-Jacques, noix, crue", cat:"Poissons & Fruits de mer", lip:0.84, glu:1.15, pro:17.9, kcal:83.6, note:null },
  { id:386, nom:"Crabe, cru", cat:"Poissons & Fruits de mer", lip:2.86, glu:0.027, pro:19.5, kcal:104.0, note:null },
  { id:387, nom:"Crevette, crue", cat:"Poissons & Fruits de mer", lip:0.84, glu:3.21, pro:19.7, kcal:99.0, note:null },
  { id:388, nom:"Escargot, cru", cat:"Poissons & Fruits de mer", lip:0.92, glu:1.29, pro:16.1, kcal:77.9, note:null },
  { id:389, nom:"Grenouille, cuisse, crue", cat:"Poissons & Fruits de mer", lip:0.28, glu:0.66, pro:16.2, kcal:70.0, note:null },
  { id:390, nom:"Homard, cru", cat:"Poissons & Fruits de mer", lip:1.15, glu:0.94, pro:17.9, kcal:85.5, note:null },
  { id:391, nom:"Huître creuse, crue", cat:"Poissons & Fruits de mer", lip:1.91, glu:3.86, pro:8.64, kcal:67.2, note:null },
  { id:392, nom:"Huître plate, crue", cat:"Poissons & Fruits de mer", lip:0.9, glu:1.16, pro:10.2, kcal:53.5, note:null },
  { id:394, nom:"Langouste, crue", cat:"Poissons & Fruits de mer", lip:1.34, glu:1.07, pro:17.7, kcal:86.9, note:null },
  { id:395, nom:"Langoustine, crue", cat:"Poissons & Fruits de mer", lip:0.79, glu:1.53, pro:19.1, kcal:89.8, note:null },
  { id:396, nom:"Moule commune, crue", cat:"Poissons & Fruits de mer", lip:1.82, glu:2.69, pro:11.2, kcal:71.8, note:null },
  { id:397, nom:"Moule de Méditerranée, crue", cat:"Poissons & Fruits de mer", lip:1.67, glu:2.77, pro:10.7, kcal:68.7, note:null },
  { id:398, nom:"Pecten d'Amérique ou peigne du Canada, noix, crue", cat:"Poissons & Fruits de mer", lip:0.54, glu:1.78, pro:17.3, kcal:81.3, note:null },
  { id:399, nom:"Poulpe, cru", cat:"Poissons & Fruits de mer", lip:0.5, glu:0.97, pro:12.9, kcal:60.1, note:null },
  { id:400, nom:"Pétoncle ou peigne du Pérou, noix, crue", cat:"Poissons & Fruits de mer", lip:0.7, glu:3.1, pro:17.5, kcal:88.7, note:null },
  { id:401, nom:"Seiche, crue", cat:"Poissons & Fruits de mer", lip:1.05, glu:0.51, pro:16.2, kcal:76.3, note:null },
  { id:402, nom:"Écrevisse, crue", cat:"Poissons & Fruits de mer", lip:0.64, glu:0.81, pro:14.8, kcal:68.3, note:null },
  { id:403, nom:"Crème d'Isigny, >= 35% MG", cat:"Oeufs & Laitiers", lip:40.0, glu:3.0, pro:2.55, kcal:382.0, note:null },
  { id:404, nom:"Spécialité culinaire à base de crème et d'aromates 19% MG, à cuisiner", cat:"Oeufs & Laitiers", lip:19.0, glu:3.0, pro:3.06, kcal:195.0, note:null },
  { id:405, nom:"Crème fraîche épaisse 30% MG", cat:"Oeufs & Laitiers", lip:29.9, glu:1.38, pro:2.32, kcal:284.0, note:"CIQUAL — valeur standard 30% MG" },
  { id:406, nom:"Crème fraîche liquide 30% MG", cat:"Oeufs & Laitiers", lip:30.0, glu:3.69, pro:2.2, kcal:294.0, note:"CIQUAL — valeur standard 30% MG" },
  { id:407, nom:"Abondance", cat:"Oeufs & Laitiers", lip:31.6, glu:0, pro:27.1, kcal:393.0, note:null },
  { id:408, nom:"Asiago", cat:"Oeufs & Laitiers", lip:25.6, glu:0.0, pro:32.1, kcal:356.0, note:null },
  { id:409, nom:"Beaufort", cat:"Oeufs & Laitiers", lip:33.0, glu:0.72, pro:26.7, kcal:404.0, note:null },
  { id:410, nom:"Bleu de Gex ou fromage bleu du Haut-Jura ou bleu de Septmoncel", cat:"Oeufs & Laitiers", lip:30.7, glu:0, pro:22.5, kcal:364.0, note:null },
  { id:411, nom:"Bouchée apéritive de fromage au lait de vache non affiné, fourrée ou enrobée", cat:"Oeufs & Laitiers", lip:24.0, glu:2.92, pro:11.3, kcal:274.0, note:null },
  { id:412, nom:"Boulette d'Avesne", cat:"Oeufs & Laitiers", lip:30.0, glu:0, pro:20.9, kcal:355.0, note:null },
  { id:413, nom:"Brie de Meaux", cat:"Oeufs & Laitiers", lip:20.7, glu:1.17, pro:21.4, kcal:276.0, note:null },
  { id:414, nom:"Brie de Melun", cat:"Oeufs & Laitiers", lip:22.2, glu:0, pro:22.0, kcal:288.0, note:null },
  { id:416, nom:"Brocciu ou brucciu corse, fromage à base de lactosérum de brebis et/ou de chèvre non affiné", cat:"Oeufs & Laitiers", lip:13.0, glu:4.0, pro:10.2, kcal:0, note:null },
  { id:417, nom:"Brousse (fromage de brebis frais au lactosérum)", cat:"Oeufs & Laitiers", lip:9.36, glu:4.81, pro:9.38, kcal:142.0, note:null },
  { id:418, nom:"Burrata", cat:"Oeufs & Laitiers", lip:23.4, glu:0.93, pro:10.8, kcal:259.0, note:null },
  { id:419, nom:"Camembert au lait cru ou thermisé", cat:"Oeufs & Laitiers", lip:20.3, glu:0, pro:20.7, kcal:267.0, note:null },
  { id:420, nom:"Camembert au lait pasteurisé", cat:"Oeufs & Laitiers", lip:21.5, glu:1.29, pro:19.2, kcal:275.0, note:null },
  { id:421, nom:"Camembert, sans précision sur le type de lait (pasteurisé ou cru)", cat:"Oeufs & Laitiers", lip:22.5, glu:0, pro:19.5, kcal:280.0, note:null },
  { id:422, nom:"Cancoillotte (spécialité fromagère fondue)", cat:"Oeufs & Laitiers", lip:10.5, glu:0.48, pro:13.8, kcal:151.0, note:null },
  { id:423, nom:"Cantal", cat:"Oeufs & Laitiers", lip:32.0, glu:0.2, pro:23.0, kcal:380.0, note:null },
  { id:424, nom:"Cantal entre-deux", cat:"Oeufs & Laitiers", lip:30.5, glu:0, pro:26.6, kcal:383.0, note:null },
  { id:425, nom:"Cantal jeune", cat:"Oeufs & Laitiers", lip:29.1, glu:0, pro:24.7, kcal:363.0, note:null },
  { id:426, nom:"Carré de l'Est", cat:"Oeufs & Laitiers", lip:27.0, glu:0.83, pro:18.4, kcal:318.0, note:null },
  { id:427, nom:"Chabichou (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:24.8, glu:1.5, pro:19.4, kcal:305.0, note:null },
  { id:428, nom:"Chaource", cat:"Oeufs & Laitiers", lip:22.9, glu:0.58, pro:17.3, kcal:278.0, note:null },
  { id:429, nom:"Cheddar", cat:"Oeufs & Laitiers", lip:32.6, glu:1.2, pro:24.7, kcal:399.0, note:null },
  { id:430, nom:"Chevrot (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:21.1, glu:1.42, pro:17.2, kcal:263.0, note:null },
  { id:431, nom:"Comté", cat:"Oeufs & Laitiers", lip:33.8, glu:0, pro:27.8, kcal:413.0, note:null },
  { id:432, nom:"Coulommiers", cat:"Oeufs & Laitiers", lip:23.0, glu:0, pro:18.8, kcal:280.0, note:null },
  { id:434, nom:"Crottin de chèvre, au lait cru", cat:"Oeufs & Laitiers", lip:32.6, glu:0, pro:23.2, kcal:384.0, note:null },
  { id:436, nom:"Crème de camembert", cat:"Oeufs & Laitiers", lip:23.0, glu:4.0, pro:11.2, kcal:0, note:null },
  { id:437, nom:"Edam", cat:"Oeufs & Laitiers", lip:24.4, glu:0, pro:25.7, kcal:320.0, note:null },
  { id:439, nom:"Emmental ou emmenthal", cat:"Oeufs & Laitiers", lip:28.8, glu:0, pro:27.9, kcal:373.0, note:null },
  { id:441, nom:"Fontina", cat:"Oeufs & Laitiers", lip:31.1, glu:0.8, pro:25.6, kcal:384.0, note:null },
  { id:442, nom:"Fourme d'Ambert", cat:"Oeufs & Laitiers", lip:28.4, glu:0, pro:20.6, kcal:339.0, note:null },
  { id:443, nom:"Fourme de Montbrison", cat:"Oeufs & Laitiers", lip:30.8, glu:0.0, pro:22.5, kcal:365.0, note:null },
  { id:444, nom:"Fromage (aliment moyen)", cat:"Oeufs & Laitiers", lip:26.3, glu:0.71, pro:21.1, kcal:324.0, note:null },
  { id:445, nom:"Fromage blanc fondu en portion (carré ou bâtonnet), enrichi en vitamines", cat:"Oeufs & Laitiers", lip:28.7, glu:3.39, pro:8.38, kcal:305.0, note:null },
  { id:446, nom:"Fromage blanc fondu en portion (carré), non enrichi en vitamines", cat:"Oeufs & Laitiers", lip:28.6, glu:2.98, pro:8.77, kcal:305.0, note:null },
  { id:447, nom:"Fromage bleu d'Auvergne", cat:"Oeufs & Laitiers", lip:29.0, glu:0, pro:20.6, kcal:342.0, note:null },
  { id:448, nom:"Fromage bleu des Causses", cat:"Oeufs & Laitiers", lip:30.0, glu:0, pro:20.4, kcal:350.0, note:null },
  { id:449, nom:"Fromage de brebis corse à pâte molle", cat:"Oeufs & Laitiers", lip:38.4, glu:0.0, pro:20.4, kcal:426.0, note:null },
  { id:450, nom:"Fromage de brebis à pâte molle et croûte fleurie", cat:"Oeufs & Laitiers", lip:25.2, glu:0, pro:18.0, kcal:297.0, note:null },
  { id:451, nom:"Fromage de brebis à pâte pressée non cuite des Pyrénées, type tomme ou tome", cat:"Oeufs & Laitiers", lip:33.6, glu:0.72, pro:22.3, kcal:393.0, note:null },
  { id:452, nom:"Fromage de chèvre bûche", cat:"Oeufs & Laitiers", lip:23.3, glu:0, pro:18.8, kcal:285.0, note:null },
  { id:453, nom:"Fromage de chèvre demi-sec", cat:"Oeufs & Laitiers", lip:29.8, glu:0, pro:21.6, kcal:353.0, note:null },
  { id:454, nom:"Fromage de chèvre frais, type palet, crottin ou bûchette", cat:"Oeufs & Laitiers", lip:15.2, glu:2.5, pro:12.0, kcal:194.0, note:null },
  { id:455, nom:"Fromage de chèvre lactique affiné, type palet, crottin ou bûchette", cat:"Oeufs & Laitiers", lip:24.7, glu:1.24, pro:20.7, kcal:308.0, note:null },
  { id:456, nom:"Fromage de chèvre sec", cat:"Oeufs & Laitiers", lip:35.6, glu:0, pro:30.5, kcal:440.0, note:null },
  { id:457, nom:"Fromage de chèvre à pâte molle et croûte fleurie (type camembert, cabécou)", cat:"Oeufs & Laitiers", lip:23.8, glu:0, pro:19.0, kcal:288.0, note:null },
  { id:458, nom:"Fromage de chèvre à pâte molle non pressée non cuite et croûte naturelle", cat:"Oeufs & Laitiers", lip:23.0, glu:0.72, pro:19.5, kcal:286.0, note:null },
  { id:459, nom:"Fromage de chèvre à pâte pressée non cuite, type tomme ou tome ou gouda de chèvre", cat:"Oeufs & Laitiers", lip:28.2, glu:0.9, pro:22.1, kcal:344.0, note:null },
  { id:460, nom:"Fromage de chèvre à tartiner, nature", cat:"Oeufs & Laitiers", lip:12.2, glu:2.41, pro:10.8, kcal:161.0, note:null },
  { id:461, nom:"Fromage de lactosérum de brebis", cat:"Oeufs & Laitiers", lip:14.8, glu:4.3, pro:10.1, kcal:190.0, note:null },
  { id:462, nom:"Fromage fondu en tranchettes", cat:"Oeufs & Laitiers", lip:18.5, glu:5.34, pro:14.1, kcal:246.0, note:null },
  { id:463, nom:"Fromage pour tartiflette (pâte molle et croûte mixte)", cat:"Oeufs & Laitiers", lip:26.4, glu:0.72, pro:20.2, kcal:320.0, note:null },
  { id:464, nom:"Fromage à effilocher ou à dérouler", cat:"Oeufs & Laitiers", lip:22.4, glu:2.68, pro:23.8, kcal:307.0, note:null },
  { id:465, nom:"Fromage à pâte molle et croûte lavée (aliment moyen)", cat:"Oeufs & Laitiers", lip:25.9, glu:0.42, pro:20.0, kcal:313.0, note:null },
  { id:466, nom:"Fromage à pâte molle et croûte mixte (lavée et fleurie) colorée", cat:"Oeufs & Laitiers", lip:29.0, glu:1.0, pro:18.2, kcal:336.0, note:null },
  { id:467, nom:"Fromage à pâte molle, triple crème, environ 38% MG", cat:"Oeufs & Laitiers", lip:37.2, glu:1.05, pro:10.5, kcal:380.0, note:null },
  { id:468, nom:"Fromage à pâte pressée cuite (aliment moyen)", cat:"Oeufs & Laitiers", lip:31.6, glu:0.28, pro:27.8, kcal:396.0, note:null },
  { id:469, nom:"Fromage à pâte pressée demi-cuite", cat:"Oeufs & Laitiers", lip:28.8, glu:0, pro:25.6, kcal:359.0, note:null },
  { id:470, nom:"Gorgonzola", cat:"Oeufs & Laitiers", lip:26.9, glu:0, pro:19.5, kcal:318.0, note:null },
  { id:471, nom:"Gouda", cat:"Oeufs & Laitiers", lip:30.2, glu:0, pro:24.7, kcal:369.0, note:null },
  { id:472, nom:"Gouda au cumin", cat:"Oeufs & Laitiers", lip:31.0, glu:0.6, pro:24.1, kcal:378.0, note:null },
  { id:473, nom:"Grana Padano", cat:"Oeufs & Laitiers", lip:28.5, glu:1.17, pro:33.9, kcal:399.0, note:null },
  { id:474, nom:"Gruyère IGP France", cat:"Oeufs & Laitiers", lip:33.2, glu:0.7, pro:28.2, kcal:415.0, note:null },
  { id:475, nom:"Gruyère, sans précision (origine France ou Suisse)", cat:"Oeufs & Laitiers", lip:33.5, glu:0.78, pro:26.3, kcal:408.0, note:null },
  { id:476, nom:"Langres", cat:"Oeufs & Laitiers", lip:23.8, glu:1.13, pro:16.7, kcal:286.0, note:null },
  { id:477, nom:"Livarot", cat:"Oeufs & Laitiers", lip:22.6, glu:0, pro:24.6, kcal:301.0, note:null },
  { id:478, nom:"Maroilles, fermier", cat:"Oeufs & Laitiers", lip:29.5, glu:0.0, pro:21.2, kcal:349.0, note:null },
  { id:481, nom:"Mascarpone", cat:"Oeufs & Laitiers", lip:37.0, glu:3.1, pro:6.0, kcal:369.0, note:null },
  { id:482, nom:"Mimolette demi-vieille (6 mois d'affinage minimum)", cat:"Oeufs & Laitiers", lip:27.5, glu:0.75, pro:30.6, kcal:371.0, note:null },
  { id:483, nom:"Mimolette extra-vieille (18 mois d'affinage minimum)", cat:"Oeufs & Laitiers", lip:29.5, glu:1.0, pro:33.7, kcal:402.0, note:null },
  { id:484, nom:"Mimolette jeune (moins de 6 mois d'affinage)", cat:"Oeufs & Laitiers", lip:24.2, glu:0, pro:28.9, kcal:331.0, note:null },
  { id:485, nom:"Mimolette vieille (12 mois d'affinage minimum)", cat:"Oeufs & Laitiers", lip:28.8, glu:0, pro:34.0, kcal:397.0, note:null },
  { id:486, nom:"Mimolette, sans précision", cat:"Oeufs & Laitiers", lip:28.0, glu:0, pro:24.0, kcal:355.0, note:null },
  { id:487, nom:"Mont d'or ou vacherin du Haut-Doubs (produit en France) ou vacherin-Mont d'Or (produit en Suisse)", cat:"Oeufs & Laitiers", lip:24.6, glu:0.54, pro:17.9, kcal:293.0, note:null },
  { id:488, nom:"Morbier", cat:"Oeufs & Laitiers", lip:29.2, glu:0, pro:22.8, kcal:355.0, note:null },
  { id:489, nom:"Mozzarella au lait de bufflonne ou buflesse (\"di bufala\")", cat:"Oeufs & Laitiers", lip:22.3, glu:0.18, pro:14.5, kcal:260.0, note:null },
  { id:490, nom:"Mozzarella au lait de vache", cat:"Oeufs & Laitiers", lip:17.7, glu:0.7, pro:16.5, kcal:227.0, note:null },
  { id:491, nom:"Munster", cat:"Oeufs & Laitiers", lip:26.8, glu:0.7, pro:20.4, kcal:324.0, note:null },
  { id:492, nom:"Neufchâtel", cat:"Oeufs & Laitiers", lip:25.5, glu:0, pro:18.1, kcal:300.0, note:null },
  { id:493, nom:"Ossau-Iraty (fromage de brebis)", cat:"Oeufs & Laitiers", lip:36.0, glu:1.0, pro:24.2, kcal:423.0, note:null },
  { id:494, nom:"Parmesan", cat:"Oeufs & Laitiers", lip:31.0, glu:1.14, pro:31.1, kcal:411.0, note:null },
  { id:495, nom:"Pecorino (fromage de brebis)", cat:"Oeufs & Laitiers", lip:31.0, glu:1.0, pro:25.5, kcal:383.0, note:null },
  { id:496, nom:"Picodon (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:25.6, glu:1.0, pro:19.9, kcal:313.0, note:null },
  { id:497, nom:"Pont l'Évêque", cat:"Oeufs & Laitiers", lip:26.2, glu:0, pro:22.7, kcal:326.0, note:null },
  { id:498, nom:"Pouligny Saint-Pierre (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:23.5, glu:1.38, pro:17.6, kcal:286.0, note:null },
  { id:499, nom:"Provolone", cat:"Oeufs & Laitiers", lip:26.6, glu:0.0, pro:25.6, kcal:340.0, note:null },
  { id:500, nom:"Pélardon (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:27.8, glu:0.0, pro:23.8, kcal:343.0, note:null },
  { id:501, nom:"Raclette (fromage)", cat:"Oeufs & Laitiers", lip:27.5, glu:0, pro:23.4, kcal:342.0, note:null },
  { id:505, nom:"Reblochon", cat:"Oeufs & Laitiers", lip:26.9, glu:0, pro:20.3, kcal:322.0, note:null },
  { id:506, nom:"Ricotta", cat:"Oeufs & Laitiers", lip:10.7, glu:4.09, pro:8.13, kcal:0, note:null },
  { id:507, nom:"Rocamadour (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:22.2, glu:0.93, pro:18.1, kcal:274.0, note:null },
  { id:508, nom:"Roquefort (fromage de brebis)", cat:"Oeufs & Laitiers", lip:33.9, glu:0, pro:19.5, kcal:384.0, note:null },
  { id:509, nom:"Saint-Félicien", cat:"Oeufs & Laitiers", lip:25.2, glu:0, pro:13.4, kcal:281.0, note:null },
  { id:510, nom:"Saint-Marcellin", cat:"Oeufs & Laitiers", lip:24.3, glu:0, pro:15.1, kcal:280.0, note:null },
  { id:511, nom:"Saint-Nectaire, fermier", cat:"Oeufs & Laitiers", lip:29.8, glu:1.2, pro:22.3, kcal:360.0, note:null },
  { id:514, nom:"Saint-Paulin (fromage à pâte pressée non cuite demi-ferme)", cat:"Oeufs & Laitiers", lip:26.4, glu:0, pro:22.3, kcal:327.0, note:null },
  { id:515, nom:"Sainte-Maure (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:24.0, glu:0.91, pro:20.0, kcal:298.0, note:null },
  { id:516, nom:"Sainte-Maure de Touraine (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:23.3, glu:1.12, pro:18.5, kcal:286.0, note:null },
  { id:517, nom:"Salers", cat:"Oeufs & Laitiers", lip:31.4, glu:0.0, pro:25.9, kcal:388.0, note:null },
  { id:518, nom:"Selles-sur-Cher (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:23.5, glu:1.17, pro:18.8, kcal:289.0, note:null },
  { id:519, nom:"Spécialité fromagère fondante au fromage blanc et aux noix", cat:"Oeufs & Laitiers", lip:28.5, glu:2.5, pro:11.2, kcal:311.0, note:null },
  { id:520, nom:"Spécialité fromagère non affinée en coque, enrichie en vitamines", cat:"Oeufs & Laitiers", lip:22.9, glu:3.5, pro:5.51, kcal:242.0, note:null },
  { id:521, nom:"Spécialité végétale type fromage à tartiner, au soja, préemballée", cat:"Oeufs & Laitiers", lip:13.1, glu:1.05, pro:11.7, kcal:174.0, note:null },
  { id:522, nom:"Tome des Bauges", cat:"Oeufs & Laitiers", lip:30.8, glu:0.0, pro:26.6, kcal:381.0, note:null },
  { id:523, nom:"Tomme ou tome de Savoie", cat:"Oeufs & Laitiers", lip:29.2, glu:0.97, pro:23.5, kcal:361.0, note:null },
  { id:524, nom:"Tomme ou tome de vache", cat:"Oeufs & Laitiers", lip:29.4, glu:3.37, pro:21.6, kcal:364.0, note:null },
  { id:525, nom:"Tomme ou tome des Pyrénées", cat:"Oeufs & Laitiers", lip:27.9, glu:0.7, pro:22.1, kcal:340.0, note:null },
  { id:526, nom:"Tête de moine", cat:"Oeufs & Laitiers", lip:34.5, glu:0.5, pro:26.0, kcal:415.0, note:null },
  { id:527, nom:"Valençay (fromage de chèvre)", cat:"Oeufs & Laitiers", lip:24.3, glu:0.64, pro:18.9, kcal:295.0, note:null },
  { id:528, nom:"Époisses", cat:"Oeufs & Laitiers", lip:24.0, glu:0, pro:17.6, kcal:286.0, note:null },
  { id:529, nom:"Artichaut, appertisé, égoutté", cat:"Légumes", lip:0.2, glu:6.5, pro:1.5, kcal:39.8, note:null },
  { id:535, nom:"Asperge blanche, bouillie/cuite à l'eau", cat:"Légumes", lip:0.3, glu:1.63, pro:1.44, kcal:17.3, note:null },
  { id:536, nom:"Asperge verte, bouillie/cuite à l'eau", cat:"Légumes", lip:0.3, glu:1.73, pro:2.69, kcal:25.3, note:null },
  { id:540, nom:"Asperge, verte, crue", cat:"Légumes", lip:0.27, glu:2.03, pro:2.46, kcal:24.7, note:null },
  { id:543, nom:"Aubergine, cuite", cat:"Légumes", lip:0.23, glu:4.17, pro:0.83, kcal:27.1, note:null },
  { id:544, nom:"Avocat, chair sans peau, sans noyau, cru", cat:"Légumes", lip:20.6, glu:0, pro:1.56, kcal:203.0, note:null },
  { id:545, nom:"Bambou, pousse, crue", cat:"Légumes", lip:0.3, glu:2.57, pro:2.6, kcal:29.1, note:null },
  { id:547, nom:"Batavia, crue", cat:"Légumes", lip:0, glu:1.78, pro:1.25, kcal:14.9, note:null },
  { id:548, nom:"Bette ou blette, côte (sans feuille), crue", cat:"Légumes", lip:0, glu:1.63, pro:1.0, kcal:12.8, note:null },
  { id:551, nom:"Betterave rouge, crue", cat:"Légumes", lip:0.17, glu:6.34, pro:1.61, kcal:40.2, note:null },
  { id:558, nom:"Brocoli, purée", cat:"Légumes", lip:0.38, glu:2.75, pro:2.5, kcal:29.0, note:null },
  { id:559, nom:"Brèdes chou de Chine ou bok choy ou pak choï, tiges et feuilles, cuites à la vapeur, prélevées à La Réunion (Brassica rapa subsp. Chinensis)", cat:"Légumes", lip:0, glu:1.7, pro:1.69, kcal:16.4, note:null },
  { id:561, nom:"Cardon, cuit", cat:"Légumes", lip:0.11, glu:3.63, pro:0.76, kcal:22.0, note:null },
  { id:573, nom:"Champignon de Paris ou champignon de couche, sauté/poêlé, sans matière grasse", cat:"Légumes", lip:0.6, glu:4.53, pro:4.44, kcal:38.4, note:null },
  { id:574, nom:"Champignon noir, séché", cat:"Légumes", lip:0.075, glu:0, pro:7.5, kcal:0, note:null },
  { id:581, nom:"Champignon, tout type, appertisé, égoutté", cat:"Légumes", lip:0.29, glu:2.56, pro:1.87, kcal:24.9, note:null },
  { id:584, nom:"Chayote ou christophine ou chouchou à peau blanche, chair sans peau, sans noyau, cuite à la vapeur, prélevée à la Martinique", cat:"Légumes", lip:0.033, glu:5.93, pro:1.21, kcal:0, note:null },
  { id:586, nom:"Chayote ou christophine ou chouchou à peau verte, chair sans peau, sans noyau, cuite à la vapeur, prélevée à la Martinique", cat:"Légumes", lip:0.023, glu:4.6, pro:1.23, kcal:0, note:null },
  { id:588, nom:"Chayote ou christophine ou chouchou, chair sans peau, sans noyau, cuite à la vapeur, prélevée à La Réunion (Sechium edule)", cat:"Légumes", lip:0, glu:3.5, pro:0.63, kcal:20.9, note:null },
  { id:590, nom:"Chicorée rouge, crue", cat:"Légumes", lip:0.1, glu:1.6, pro:1.4, kcal:18.9, note:null },
  { id:591, nom:"Chicorée verte, crue", cat:"Légumes", lip:0.5, glu:0.5, pro:1.9, kcal:16.1, note:null },
  { id:593, nom:"Chou blanc, cru", cat:"Légumes", lip:0.6, glu:4.63, pro:1.38, kcal:35.2, note:null },
  { id:594, nom:"Chou chinois pak choï ou pak choy (feuilles vertes ressemblant à des blettes), cru", cat:"Légumes", lip:0.2, glu:1.2, pro:1.5, kcal:14.6, note:null },
  { id:597, nom:"Chou chinois pé-tsaï, sauté/poêlé", cat:"Légumes", lip:0, glu:2.77, pro:1.06, kcal:18.9, note:null },
  { id:599, nom:"Chou de Bruxelles, bouilli/cuit à l'eau", cat:"Légumes", lip:0, glu:5.4, pro:3.19, kcal:44.4, note:null },
  { id:601, nom:"Chou dur ou chou caraïbe ou macabo, pulpe, cuit à la vapeur, prélevé à la Martinique", cat:"Légumes", lip:0.0033, glu:0, pro:3.25, kcal:0, note:null },
  { id:602, nom:"Chou frisé, cru", cat:"Légumes", lip:0.93, glu:4.2, pro:4.28, kcal:49.5, note:null },
  { id:604, nom:"Chou kale, cru", cat:"Légumes", lip:1.49, glu:0.32, pro:2.92, kcal:34.6, note:null },
  { id:605, nom:"Chou romanesco ou brocoli à pomme, cru", cat:"Légumes", lip:0.3, glu:2.2, pro:2.95, kcal:29.7, note:null },
  { id:610, nom:"Chou rouge, cuit à l'étouffée", cat:"Légumes", lip:0, glu:5.7, pro:1.19, kcal:33.9, note:null },
  { id:613, nom:"Chou vert, cuit", cat:"Légumes", lip:0.45, glu:3.04, pro:1.03, kcal:24.1, note:null },
  { id:616, nom:"Chou-fleur, cuit à la vapeur", cat:"Légumes", lip:0.3, glu:3.41, pro:2.56, kcal:30.5, note:null },
  { id:617, nom:"Chou-rave, bouilli/cuit à l'eau", cat:"Légumes", lip:0.11, glu:4.4, pro:1.8, kcal:28.0, note:null },
  { id:619, nom:"Citrouille, chair sans peau, crue", cat:"Légumes", lip:0.1, glu:5.79, pro:1.0, kcal:29.7, note:null },
  { id:620, nom:"Coeur de palmier, appertisé, égoutté", cat:"Légumes", lip:0.56, glu:5.5, pro:2.51, kcal:41.5, note:null },
  { id:621, nom:"Concombre, chair et peau, cru", cat:"Légumes", lip:0.11, glu:2.87, pro:0.65, kcal:16.8, note:null },
  { id:628, nom:"Courge melonnette, chair sans peau, crue", cat:"Légumes", lip:0.13, glu:5.98, pro:0.75, kcal:30.8, note:null },
  { id:629, nom:"Courge musquée, chair sans peau, crue", cat:"Légumes", lip:0.1, glu:4.6, pro:0.55, kcal:23.5, note:null },
  { id:630, nom:"Courge spaghetti, chair sans peau, crue", cat:"Légumes", lip:0.57, glu:5.41, pro:0.64, kcal:32.3, note:null },
  { id:632, nom:"Courge, crue", cat:"Légumes", lip:0.13, glu:1.6, pro:0.95, kcal:14.4, note:null },
  { id:636, nom:"Courgette", cat:"Légumes", lip:0.32, glu:1.75, pro:1.21, kcal:16.7, note:"CIQUAL" },
  { id:637, nom:"Cresson de fontaine, cru", cat:"Légumes", lip:0.1, glu:1.11, pro:2.3, kcal:15.5, note:null },
  { id:639, nom:"Cresson, feuille, cru, prélevé à la Martinique", cat:"Légumes", lip:0.1, glu:0, pro:2.25, kcal:0, note:null },
  { id:643, nom:"Céleri branche, cuit à l'étouffée", cat:"Légumes", lip:0, glu:2.48, pro:0.75, kcal:14.7, note:null },
  { id:644, nom:"Céleri rave, bouilli/cuit à l'eau", cat:"Légumes", lip:0.3, glu:4.32, pro:0.94, kcal:26.2, note:null },
  { id:646, nom:"Céleri-rave, cuit", cat:"Légumes", lip:0.86, glu:4.6, pro:1.3, kcal:36.5, note:null },
  { id:650, nom:"Endive, rôtie/cuite au four", cat:"Légumes", lip:0, glu:4.38, pro:1.13, kcal:22.0, note:null },
  { id:651, nom:"Endive, crue", cat:"Légumes", lip:0, glu:2.83, pro:1.19, kcal:16.6, note:null },
  { id:652, nom:"Fenouil, cru", cat:"Légumes", lip:0, glu:2.63, pro:1.0, kcal:18.2, note:null },
  { id:655, nom:"Fondue de poireau, préemballée", cat:"Légumes", lip:5.2, glu:0, pro:1.1, kcal:58.4, note:null },
  { id:656, nom:"Giraumon (variété locale), chair sans peau, cuit à la vapeur, prélevé à la Martinique", cat:"Légumes", lip:0.097, glu:4.51, pro:1.1, kcal:0, note:null },
  { id:661, nom:"Gombo, entier, cuit à la vapeur, prélevé à la Martinique", cat:"Légumes", lip:0.3, glu:4.69, pro:1.8, kcal:0, note:null },
  { id:664, nom:"Graine germée de haricot mungo ou pousse de soja, crue", cat:"Légumes", lip:0, glu:3.4, pro:2.57, kcal:28.3, note:"CIQUAL" },
  { id:666, nom:"Graine germée de luzerne, crue", cat:"Légumes", lip:0.69, glu:0.81, pro:3.38, kcal:29.2, note:null },
  { id:667, nom:"Graine germée de radis, fraîche, crue", cat:"Légumes", lip:2.53, glu:0, pro:3.23, kcal:0, note:null },
  { id:670, nom:"Haricot beurre, cru", cat:"Légumes", lip:0.12, glu:5.6, pro:1.82, kcal:37.6, note:null },
  { id:671, nom:"Haricot plat, cru", cat:"Légumes", lip:0.12, glu:4.47, pro:1.93, kcal:32.4, note:null },
  { id:674, nom:"Haricot vert, cru", cat:"Légumes", lip:0.22, glu:4.14, pro:1.83, kcal:31.9, note:null },
  { id:676, nom:"Haricots verts, purée", cat:"Légumes", lip:2.9, glu:4.2, pro:1.7, kcal:56.3, note:null },
  { id:677, nom:"Laitue iceberg, crue", cat:"Légumes", lip:0.14, glu:2.5, pro:0.95, kcal:17.3, note:null },
  { id:678, nom:"Laitue romaine, crue", cat:"Légumes", lip:0.3, glu:1.35, pro:1.23, kcal:17.2, note:null },
  { id:679, nom:"Laitue, crue", cat:"Légumes", lip:0.2, glu:1.45, pro:1.35, kcal:13.9, note:null },
  { id:680, nom:"Légume cuit (aliment moyen)", cat:"Légumes", lip:0.3, glu:3.67, pro:1.68, kcal:28.7, note:null },
  { id:686, nom:"Moringa, feuille, cru", cat:"Légumes", lip:1.4, glu:6.28, pro:9.4, kcal:0, note:null },
  { id:688, nom:"Mâche, crue", cat:"Légumes", lip:0, glu:0.5, pro:2.0, kcal:15.0, note:null },
  { id:691, nom:"Navet, pelé, cru", cat:"Légumes", lip:0.1, glu:4.39, pro:0.9, kcal:25.6, note:null },
  { id:692, nom:"Oignon blanc ou jaune, sauté/poêlé sans matière grasse", cat:"Légumes", lip:0, glu:6.73, pro:1.56, kcal:39.2, note:null },
  { id:693, nom:"Oignon jaune, cru", cat:"Légumes", lip:0, glu:6.39, pro:1.19, kcal:35.9, note:null },
  { id:694, nom:"Oignon nouveau ou oignon frais ou cébette, sauté/poêlé sans matière grasse", cat:"Légumes", lip:0.3, glu:3.56, pro:1.13, kcal:28.0, note:null },
  { id:695, nom:"Oignon rouge, cru", cat:"Légumes", lip:0.4, glu:5.63, pro:1.31, kcal:35.0, note:null },
  { id:696, nom:"Oignon, cru", cat:"Légumes", lip:0.1, glu:7.12, pro:1.16, kcal:37.2, note:null },
  { id:698, nom:"Oseille, crue", cat:"Légumes", lip:0.65, glu:1.6, pro:1.89, kcal:23.4, note:null },
  { id:699, nom:"Papaye verte, chair sans peau, crue, prélevée à la Martinique", cat:"Légumes", lip:0.0033, glu:0, pro:0.67, kcal:0, note:null },
  { id:702, nom:"Piment, cru", cat:"Légumes", lip:0.44, glu:5.75, pro:1.87, kcal:37.4, note:null },
  { id:703, nom:"Pissenlit, cru", cat:"Légumes", lip:0.7, glu:6.1, pro:2.7, kcal:48.5, note:null },
  { id:705, nom:"Poireau, cru", cat:"Légumes", lip:0.3, glu:4.55, pro:1.5, kcal:30.4, note:null },
  { id:708, nom:"Pois mange-tout ou pois gourmand, cru", cat:"Légumes", lip:0.2, glu:6.2, pro:2.8, kcal:43.0, note:null },
  { id:709, nom:"Pois mange-tout ou pois gourmands, cuits", cat:"Légumes", lip:0.38, glu:5.92, pro:3.5, kcal:47.3, note:null },
  { id:718, nom:"Poivron vert, sauté/poêlé", cat:"Légumes", lip:0.3, glu:3.53, pro:1.25, kcal:27.3, note:null },
  { id:721, nom:"Potimarron, chair sans peau, bouilli/cuit à l'eau", cat:"Légumes", lip:0.3, glu:6.88, pro:1.06, kcal:38.6, note:null },
  { id:725, nom:"Potiron, cuit", cat:"Légumes", lip:0.07, glu:4.47, pro:0.81, kcal:26.1, note:null },
  { id:726, nom:"Pourpier, feuille, cru", cat:"Légumes", lip:0.36, glu:0, pro:2.03, kcal:0, note:null },
  { id:727, nom:"Radis noir, cru", cat:"Légumes", lip:0, glu:5.52, pro:0.94, kcal:28.2, note:null },
  { id:728, nom:"Radis rouge, cru", cat:"Légumes", lip:0, glu:1.53, pro:0.94, kcal:11.0, note:null },
  { id:729, nom:"Roquette, crue", cat:"Légumes", lip:0.66, glu:2.1, pro:2.58, kcal:27.9, note:null },
  { id:730, nom:"Rutabaga, cru", cat:"Légumes", lip:0.16, glu:5.7, pro:1.08, kcal:33.2, note:null },
  { id:731, nom:"Salade feuille de chêne, crue", cat:"Légumes", lip:0, glu:1.03, pro:1.13, kcal:10.7, note:null },
  { id:732, nom:"Salade ou chicorée frisée, crue", cat:"Légumes", lip:0.3, glu:2.13, pro:1.7, kcal:26.0, note:null },
  { id:733, nom:"Salade sucrine, crue", cat:"Légumes", lip:0, glu:2.58, pro:1.13, kcal:16.6, note:null },
  { id:734, nom:"Salicorne (Salicornia sp.), crue", cat:"Légumes", lip:0.17, glu:0.98, pro:1.02, kcal:13.1, note:null },
  { id:735, nom:"Salsifis, appertisé, égoutté", cat:"Légumes", lip:0.17, glu:4.33, pro:1.33, kcal:29.2, note:null },
  { id:736, nom:"Scarole, crue", cat:"Légumes", lip:0.23, glu:2.0, pro:1.44, kcal:20.5, note:null },
  { id:737, nom:"Ti nain, chair sans peau, cuit à la vapeur, prélevé à la Martinique", cat:"Légumes", lip:0.05, glu:0, pro:1.13, kcal:0, note:null },
  { id:738, nom:"Tomate allongée, crue", cat:"Légumes", lip:0, glu:3.29, pro:0, kcal:18.8, note:null },
  { id:739, nom:"Tomate cerise, crue", cat:"Légumes", lip:0, glu:5.62, pro:1.31, kcal:31.8, note:null },
  { id:740, nom:"Tomate côtelée ou coeur de boeuf, crue", cat:"Légumes", lip:0, glu:3.4, pro:0.5, kcal:17.4, note:null },
  { id:741, nom:"Tomate marmande, crue", cat:"Légumes", lip:0, glu:2.81, pro:0, kcal:0, note:null },
  { id:742, nom:"Tomate noire de Crimée, crue", cat:"Légumes", lip:0, glu:3.08, pro:0, kcal:0, note:null },
  { id:743, nom:"Tomate ronde, crue", cat:"Légumes", lip:0, glu:3.42, pro:0.5, kcal:17.5, note:null },
  { id:744, nom:"Tomate sans précision, crue (aliment moyen)", cat:"Légumes", lip:0, glu:3.69, pro:0.6, kcal:19.2, note:null },
  { id:745, nom:"Tomate verte, crue", cat:"Légumes", lip:0.2, glu:4.0, pro:1.2, kcal:24.8, note:null },
  { id:749, nom:"Tomate, chair, appertisée", cat:"Légumes", lip:0, glu:3.63, pro:1.2, kcal:22.6, note:null },
  { id:751, nom:"Topinambour, pulpe, cuit à la vapeur, prélevé à la Martinique", cat:"Légumes", lip:0.18, glu:0, pro:1.23, kcal:0, note:null },
  { id:752, nom:"Tétragone cornue, cuite", cat:"Légumes", lip:0.17, glu:1.0, pro:1.3, kcal:13.5, note:null },
  { id:755, nom:"Épinard, cru", cat:"Légumes", lip:0.39, glu:3.06, pro:2.68, kcal:33.3, note:null },
  { id:758, nom:"Citron vert ou lime, chair sans peau, sans pépins, cru", cat:"Fruits", lip:0, glu:3.14, pro:1.13, kcal:39.3, note:null },
  { id:759, nom:"Citron, chair sans peau, sans pépins, cru", cat:"Fruits", lip:0, glu:1.56, pro:0.25, kcal:24.3, note:null },
  { id:760, nom:"Citron, zeste, cru", cat:"Fruits", lip:0.3, glu:5.4, pro:1.5, kcal:0, note:null },
  { id:761, nom:"Fraise, crue", cat:"Fruits", lip:0, glu:6.03, pro:0.63, kcal:35.1, note:null },
  { id:762, nom:"Framboise, crue", cat:"Fruits", lip:0.8, glu:5.83, pro:1.19, kcal:47.9, note:null },
  { id:763, nom:"Fruits rouges, crus (framboises, fraises, groseilles, cassis)", cat:"Fruits", lip:0.5, glu:7.0, pro:1.0, kcal:0, note:null },
  { id:764, nom:"Groseille à maquereau, crue", cat:"Fruits", lip:0.58, glu:4.45, pro:0.88, kcal:39.4, note:null },
  { id:765, nom:"Mûre (de ronce), crue", cat:"Fruits", lip:0.7, glu:6.53, pro:1.13, kcal:46.0, note:null },
  { id:766, nom:"Prune de cythère, chair et peau, avec pépins, mûre, crue, prélevée à la Martinique", cat:"Fruits", lip:0.03, glu:0, pro:0.54, kcal:0, note:null },
  { id:767, nom:"Chanvre ou chènevis, graine décortiquée", cat:"Oléagineux & Graines", lip:48.8, glu:5.38, pro:30.8, kcal:617.0, note:null },
  { id:768, nom:"Courge, graine, séchée", cat:"Oléagineux & Graines", lip:49.1, glu:5.39, pro:29.5, kcal:618.0, note:null },
  { id:769, nom:"Graines de lin", cat:"Oléagineux & Graines", lip:42.2, glu:3.56, pro:18.0, kcal:533.0, note:"CIQUAL — Lin brun" },
  { id:771, nom:"Noix de coco, amande immature, fraîche", cat:"Oléagineux & Graines", lip:33.5, glu:6.22, pro:3.33, kcal:360.0, note:null },
  { id:772, nom:"Noix de coco, chair, fraîche", cat:"Oléagineux & Graines", lip:34.7, glu:4.69, pro:3.47, kcal:369.0, note:null },
  { id:773, nom:"Noix de macadamia, sans sel ajouté", cat:"Oléagineux & Graines", lip:75.8, glu:5.22, pro:7.91, kcal:757.0, note:null },
  { id:774, nom:"Noix de pécan, sans sel ajouté", cat:"Oléagineux & Graines", lip:72.0, glu:4.25, pro:9.17, kcal:727.0, note:null },
  { id:776, nom:"Noix du Brésil ou noix d'Amazonie, sans sel ajouté", cat:"Oléagineux & Graines", lip:67.1, glu:4.23, pro:14.3, kcal:701.0, note:null },
  { id:777, nom:"Noix de Grenoble (cerneau)", cat:"Oléagineux & Graines", lip:67.3, glu:6.88, pro:13.3, kcal:709.0, note:"CIQUAL — Noix cerneau séchée" },
  { id:778, nom:"Pignon de pin", cat:"Oléagineux & Graines", lip:68.4, glu:2.93, pro:13.7, kcal:712.0, note:null },
  { id:779, nom:"Beurre salé", cat:"Graisses & Condiments", lip:80.8, glu:0.68, pro:0.5, kcal:732.0, note:null },
  { id:780, nom:"Ghee (beurre clarifié)", cat:"Graisses & Condiments", lip:99.8, glu:0.0, pro:0.0, kcal:898.0, note:"Sans lactose" },
  { id:781, nom:"Huile d'avocat", cat:"Graisses & Condiments", lip:100.0, glu:0.0, pro:0.0, kcal:900.0, note:null },
  { id:782, nom:"Huile d'olive vierge extra", cat:"Graisses & Condiments", lip:99.9, glu:0, pro:0.25, kcal:899.0, note:null },
  { id:783, nom:"Huile de beurre ou beurre concentré", cat:"Graisses & Condiments", lip:99.9, glu:0.0, pro:0.28, kcal:900.0, note:null },
  { id:784, nom:"Huile ou graisse de coco (coprah), raffinée", cat:"Graisses & Condiments", lip:100.0, glu:0.0, pro:0.0, kcal:900.0, note:null },
  { id:785, nom:"Huile ou graisse de coco, sans précision", cat:"Graisses & Condiments", lip:99.5, glu:0.41, pro:0.0, kcal:897.0, note:null },
  { id:786, nom:"Huile ou graisse de coco, vierge", cat:"Graisses & Condiments", lip:99.9, glu:0, pro:0.16, kcal:899.0, note:null },
  { id:787, nom:"Champagne", cat:"Boissons", lip:0.0, glu:1.4, pro:0.3, kcal:76.1, note:null },
  { id:788, nom:"Eau", cat:"Boissons", lip:0.0, glu:0.0, pro:0.0, kcal:0.0, note:null },
  { id:789, nom:"Vin blanc mousseux", cat:"Boissons", lip:0.0, glu:1.78, pro:0.1, kcal:8.0, note:null },
  { id:790, nom:"Vin blanc sec", cat:"Boissons", lip:0.0, glu:0.17, pro:0.25, kcal:55.3, note:null },
  { id:791, nom:"Vin rosé", cat:"Boissons", lip:0.0, glu:1.4, pro:0.15, kcal:69.2, note:null },
  { id:792, nom:"Vin rouge", cat:"Boissons", lip:0, glu:0.0, pro:0.16, kcal:75.7, note:null },
  { id:793, nom:"Bouillon d'os", cat:"Boissons", lip:0.5, glu:0.0, pro:2.5, kcal:14.0, note:"Valeur moyenne" },
  { id:794, nom:"Café, expresso", cat:"Boissons", lip:0.2, glu:1.16, pro:0.25, kcal:6.54, note:"CIQUAL" },
  { id:795, nom:"Café, filtre", cat:"Boissons", lip:0.0, glu:0.0, pro:0.1, kcal:1.0, note:"CIQUAL — valeur standard" },
  { id:796, nom:"Thé infusé", cat:"Boissons", lip:0.0, glu:0.0, pro:0.1, kcal:0.4, note:"CIQUAL" },
  { id:797, nom:"Tisane / Infusion", cat:"Boissons", lip:0.0, glu:0.0, pro:0.0, kcal:0.0, note:null },
  { id:999, nom:"Joëls (petits poissons entiers) pour friture, crus", cat:"Poissons & Fruits de mer", lip:2.1, glu:0.0, pro:17.5, kcal:88.9, note:null },
  { id:1002, nom:"Amande, émondée, sans sel ajouté", cat:"Oléagineux & Graines", lip:52.5, glu:8.76, pro:21.4, kcal:631.0, note:null },
  { id:1003, nom:"Noisette, sans sel ajouté", cat:"Oléagineux & Graines", lip:56.9, glu:7.16, pro:14.4, kcal:632.0, note:null },
  { id:1008, nom:"Farine de coco", cat:"Oléagineux & Graines", lip:14.0, glu:6.0, pro:20.0, kcal:230.0, note:"Valeur de référence" },
  { id:1009, nom:"Poudre d'amande (non déshuilée)", cat:"Oléagineux & Graines", lip:51.5, glu:5.4, pro:21.0, kcal:569.0, note:"Valeur de référence" },
  { id:1012, nom:"Beurre de cacao", cat:"Graisses & Condiments", lip:100.0, glu:0.0, pro:0.0, kcal:900.0, note:null },
  { id:1013, nom:"Huile de palme rouge", cat:"Graisses & Condiments", lip:100.0, glu:0.0, pro:0.0, kcal:884.0, note:"CIQUAL — valeur standard" },
  { id:1014, nom:"Mayonnaise (70% MG)", cat:"Graisses & Condiments", lip:74.5, glu:3.41, pro:1.33, kcal:692.0, note:"CIQUAL" },
  { id:1016, nom:"Faisselle (vache, 3% MG)", cat:"Oeufs & Laitiers", lip:5.5, glu:3.36, pro:4.47, kcal:83.6, note:"CIQUAL — Faisselle 6% MG" },
  { id:1019, nom:"Fromage blanc nature (40% MG)", cat:"Oeufs & Laitiers", lip:16.0, glu:3.4, pro:6.5, kcal:183.0, note:"CIQUAL — valeur standard" },
  { id:1020, nom:"Yaourt grec nature (10% MG)", cat:"Oeufs & Laitiers", lip:8.16, glu:3.73, pro:3.02, kcal:103.0, note:"CIQUAL" },
  { id:1021, nom:"Yaourt nature au lait entier", cat:"Oeufs & Laitiers", lip:3.5, glu:4.7, pro:3.7, kcal:63.0, note:"CIQUAL — valeur standard" },
  { id:1022, nom:"Skyr nature", cat:"Oeufs & Laitiers", lip:0.2, glu:4.0, pro:11.0, kcal:63.0, note:"CIQUAL — valeur standard" },
  { id:1023, nom:"Foie de veau cuit", cat:"Viandes & Poissons", lip:3.02, glu:9.23, pro:19.0, kcal:140.0, note:"CIQUAL" },
  { id:1024, nom:"Kéfir de lait nature", cat:"Oeufs & Laitiers", lip:3.5, glu:4.5, pro:3.3, kcal:63.0, note:"CIQUAL — valeur standard" },
  { id:1025, nom:"Petit-suisse nature (40% MG)", cat:"Oeufs & Laitiers", lip:9.89, glu:2.61, pro:9.19, kcal:137.0, note:"CIQUAL" },
  { id:1029, nom:"Huile de coco", cat:"Graisses & Condiments", lip:99.5, glu:0.0, pro:0.0, kcal:895.0, note:"CIQUAL — valeur standard" },
  { id:1030, nom:"Chocolat noir 85% cacao", cat:"Sucreries & Snacks", lip:46.3, glu:26.9, pro:10.4, kcal:591.0, note:"CIQUAL — Choco noir 70%+ (proxy 85%)" },
  { id:1031, nom:"Chocolat noir 90% cacao", cat:"Sucreries & Snacks", lip:42.3, glu:34.1, pro:8.48, kcal:525.0, note:"CIQUAL — proxy >85%" },
  { id:1032, nom:"Beurre de cacahuète", cat:"Oléagineux & Graines", lip:51.4, glu:17.3, pro:22.2, kcal:643.0, note:"CIQUAL" },
  { id:1033, nom:"Courgette cuite", cat:"Légumes", lip:0.36, glu:1.4, pro:0.93, kcal:12.6, note:"CIQUAL" },
  { id:1034, nom:"Foie de morue, appertisé, égoutté", cat:"Poissons & Fruits de mer", lip:44.4, glu:1.0, pro:7.25, kcal:433.0, note:"CIQUAL" },
  { id:1035, nom:"Huile de foie de morue", cat:"Graisses & Condiments", lip:100.0, glu:0.0, pro:0.0, kcal:900.0, note:null },
  { id:1036, nom:"Ail cru", cat:"Légumes", lip:0, glu:18.6, pro:5.31, kcal:109.0, note:"CIQUAL" },
  { id:1037, nom:"Fromage frais ail et fines herbes", cat:"Oeufs & Laitiers", lip:30.8, glu:2.7, pro:8.03, kcal:320.0, note:"CIQUAL" },
  { id:1038, nom:"Sardines à l'huile d'olive, appertisées, égouttées", cat:"Poissons & Fruits de mer", lip:14.5, glu:0.11, pro:23.3, kcal:224.0, note:"CIQUAL" },
  { id:1039, nom:"Maquereaux marinés", cat:"Poissons & Fruits de mer", lip:13.3, glu:0, pro:16.3, kcal:185.0, note:"CIQUAL" },
  { id:1040, nom:"Konjac", cat:"Légumes", lip:0.0, glu:0.0, pro:0.0, kcal:3.0, note:"Glucomannane non assimilable" },
  { id:1041, nom:"Suif (graisse animale)", cat:"Graisses & Condiments", lip:100.0, glu:0.0, pro:0.0, kcal:900.0, note:"CIQUAL — graisse bovine/ovine pure" },
  { id:1042, nom:"Saindoux (graisse de porc)", cat:"Graisses & Condiments", lip:99.5, glu:0.0, pro:0.0, kcal:895.0, note:"CIQUAL" },
  { id:1043, nom:"Huile de sésame", cat:"Graisses & Condiments", lip:100.0, glu:0.0, pro:0.0, kcal:900.0, note:null },
  { id:1044, nom:"Grattons (viande frite)", cat:"Viandes", lip:30.0, glu:0.0, pro:25.0, kcal:370.0, note:"CIQUAL — valeur standard" },
  { id:1045, nom:"Graines de sésame", cat:"Oléagineux & Graines", lip:49.7, glu:12.8, pro:17.7, kcal:606.0, note:"CIQUAL" },
  { id:7782, nom:"Beurre doux", cat:"Graisses & Condiments", lip:83.0, glu:0.71, pro:0.64, kcal:753.0, note:null },
  { id:10242, nom:"Fromage blanc frais entier", cat:"Oeufs & Laitiers", lip:3.23, glu:3.86, pro:6.5, kcal:72.0, note:"CIQUAL — valeur standard" },
  { id:10262, nom:"Graines de chia", cat:"Oléagineux & Graines", lip:30.7, glu:7.72, pro:16.5, kcal:454.0, note:"CIQUAL" },
  { id:1046, nom:"Fromage mature (aliment moyen)", cat:"Oeufs & Laitiers", lip:27.0, glu:0.5, pro:24.0, kcal:340.0, note:"CIQUAL — valeur standard" },
  { id:10263, nom:"Pâté de foie de volaille", cat:"Viandes", lip:28.3, glu:1.21, pro:13.7, kcal:316.0, note:"CIQUAL 2025" },
  { id:10264, nom:"Mousse de canard", cat:"Viandes", lip:36.1, glu:7.07, pro:10.1, kcal:394.0, note:"CIQUAL 2025" },
  { id:10265, nom:"Pâté ou terrine de campagne", cat:"Viandes", lip:28.2, glu:1.5, pro:15.5, kcal:323.0, note:"CIQUAL 2025" },
  { id:10266, nom:"Terrine de canard", cat:"Viandes", lip:27.1, glu:5.64, pro:13.2, kcal:322.0, note:"CIQUAL 2025" },
  { id:10267, nom:"Pâté de lapin", cat:"Viandes", lip:24.5, glu:1.73, pro:14.7, kcal:286.0, note:"CIQUAL 2025" },
  { id:10268, nom:"Pâté de gibier", cat:"Viandes", lip:24.7, glu:3.28, pro:14.2, kcal:293.0, note:"CIQUAL 2025" },
  { id:10269, nom:"Rillettes pur porc", cat:"Viandes", lip:38.3, glu:0.13, pro:16.7, kcal:413.0, note:"CIQUAL 2025" },
  { id:10270, nom:"Rillettes de canard", cat:"Viandes", lip:34.6, glu:1.03, pro:15.3, kcal:377.0, note:"CIQUAL 2025" },
  { id:10271, nom:"Rillettes de poulet", cat:"Viandes", lip:30.3, glu:0.49, pro:16.4, kcal:340.0, note:"CIQUAL 2025" },
  { id:10272, nom:"Érythritol", cat:"Sucreries & Snacks", lip:0.0, glu:0.0, pro:0.0, kcal:0.0, note:"Polyol non assimilé (excrété intact dans l'urine) — étiquetage UE 0 kcal" },
  { id:10273, nom:"Sauce soja claire", cat:"Graisses & Condiments", lip:0.0, glu:3.2, pro:10.0, kcal:77.0, note:"Étiquette produit — pour 100 ml (sel : 16,9 g/100 ml)" },
  { id:10274, nom:"Huile de sésame grillé", cat:"Graisses & Condiments", lip:100.0, glu:0.0, pro:0.0, kcal:900.0, note:"Variante torréfiée de l'huile de sésame — usage condiment" },
  { id:10275, nom:"Cornichons au vinaigre", cat:"Graisses & Condiments", lip:0.2, glu:2.3, pro:0.33, kcal:11.0, note:"CIQUAL — pour 100 g égouttés" },
  { id:10276, nom:"Olives noires", cat:"Graisses & Condiments", lip:17.2, glu:0.1, pro:1.38, kcal:160.7, note:"Étiquette produit — pour 100 g égouttées" },
  { id:10277, nom:"Olives vertes", cat:"Graisses & Condiments", lip:16.6, glu:0.61, pro:1.13, kcal:156.4, note:"Étiquette produit — pour 100 g égouttées" },
  // Champignons sauvages
  { id:10278, nom:"Champignon morille, crue", cat:"Légumes", lip:0.57, glu:0.1, pro:3.12, kcal:18.0, note:"CIQUAL 2025" },
  { id:10279, nom:"Champignon pleurote, crue", cat:"Légumes", lip:0.41, glu:1.5, pro:3.31, kcal:23.0, note:"CIQUAL 2025" },
  { id:10280, nom:"Champignon cèpe, cru", cat:"Légumes", lip:0.49, glu:2.0, pro:3.23, kcal:25.0, note:"CIQUAL 2025" },
  { id:10281, nom:"Champignon chanterelle ou girolle, crue", cat:"Légumes", lip:0.53, glu:1.77, pro:1.49, kcal:18.0, note:"CIQUAL 2025" },
  // Légumes
  { id:10282, nom:"Mesclun (mélange de jeunes pousses)", cat:"Légumes", lip:0.0, glu:2.5, pro:2.0, kcal:18.0, note:"CIQUAL 2025" },
  { id:10283, nom:"Rhubarbe, tige, crue", cat:"Légumes", lip:0.16, glu:1.12, pro:0.73, kcal:9.0, note:"CIQUAL 2025" },
  // Condiments
  { id:10284, nom:"Câpres, au vinaigre", cat:"Graisses & Condiments", lip:0.86, glu:3.5, pro:2.18, kcal:30.0, note:"CIQUAL 2025" },
  { id:10285, nom:"Moutarde de Dijon", cat:"Graisses & Condiments", lip:11.2, glu:4.33, pro:6.92, kcal:146.0, note:"CIQUAL 2025" },
  { id:10286, nom:"Moutarde à l'ancienne", cat:"Graisses & Condiments", lip:9.9, glu:2.2, pro:6.6, kcal:124.0, note:"CIQUAL 2025" },
  { id:10287, nom:"Vinaigre de cidre", cat:"Graisses & Condiments", lip:0.0, glu:0.93, pro:0.0, kcal:4.0, note:"CIQUAL 2025" },
  // Fines herbes fraîches
  { id:10288, nom:"Basilic frais", cat:"Légumes", lip:0.64, glu:3.4, pro:3.15, kcal:32.0, note:"CIQUAL 2025" },
  { id:10289, nom:"Persil frais", cat:"Légumes", lip:0.63, glu:4.1, pro:2.97, kcal:34.0, note:"CIQUAL 2025" },
  { id:10290, nom:"Coriandre fraîche", cat:"Légumes", lip:0.52, glu:0.87, pro:2.13, kcal:17.0, note:"CIQUAL 2025" },
  { id:10291, nom:"Ciboulette fraîche", cat:"Légumes", lip:0.46, glu:2.85, pro:2.55, kcal:26.0, note:"CIQUAL 2025" },
  { id:10292, nom:"Sauge fraîche", cat:"Légumes", lip:0.5, glu:0.97, pro:4.0, kcal:24.0, note:"CIQUAL 2025" },
  { id:10293, nom:"Estragon frais", cat:"Légumes", lip:0.0, glu:4.1, pro:3.8, kcal:32.0, note:"CIQUAL 2025 — lipides non renseignés" },
  { id:10294, nom:"Aneth frais", cat:"Légumes", lip:1.1, glu:3.9, pro:3.93, kcal:41.0, note:"CIQUAL 2025" },
  { id:10295, nom:"Menthe fraîche", cat:"Légumes", lip:0.84, glu:5.3, pro:3.52, kcal:43.0, note:"CIQUAL 2025 — usage en pincée" },
  { id:10296, nom:"Thym frais", cat:"Légumes", lip:1.68, glu:10.5, pro:5.56, kcal:80.0, note:"CIQUAL 2025 — usage en pincée, impact glucidique négligeable" },
  { id:10297, nom:"Romarin frais", cat:"Légumes", lip:5.86, glu:6.6, pro:3.31, kcal:92.0, note:"CIQUAL 2025 — usage en pincée, impact glucidique négligeable" },
  { id:10298, nom:"Laurier, feuille", cat:"Légumes", lip:8.36, glu:48.6, pro:7.61, kcal:301.0, note:"CIQUAL 2025 — usage : 1-2 feuilles par plat, impact glucidique négligeable" },
  { id:10299, nom:"Origan séché", cat:"Légumes", lip:4.28, glu:26.4, pro:9.0, kcal:181.0, note:"CIQUAL 2025 — usage en pincée, impact glucidique négligeable" },
  // Produits laitiers
  { id:10300, nom:"Yaourt au lait de brebis, nature, 3% MG", cat:"Oeufs & Laitiers", lip:3.01, glu:3.48, pro:5.49, kcal:62.0, note:"CIQUAL 2025" },
  { id:10301, nom:"Petit-suisse nature, 4% MG", cat:"Oeufs & Laitiers", lip:3.9, glu:3.11, pro:9.52, kcal:88.0, note:"CIQUAL 2025" },
  { id:10302, nom:"Feta au lait de vache 100%", cat:"Oeufs & Laitiers", lip:22.6, glu:1.22, pro:15.1, kcal:271.0, note:"CIQUAL 2025" },
  { id:10303, nom:"Feta au lait de brebis 100%", cat:"Oeufs & Laitiers", lip:21.8, glu:0.83, pro:16.0, kcal:262.0, note:"CIQUAL 2025" },
  { id:10304, nom:"Côtelettes, agneau, crues", cat:"Viandes", lip:30.1, glu:0.0, pro:15.4, kcal:337.0, note:"CIQUAL 2025" },
  { id:10305, nom:"Psyllium blond, téguments", cat:"Épices & Condiments", lip:0.5, glu:8.8, pro:1.4, kcal:0, note:"nutri-naturel.com — fibres 81g/100g, impact glucidique net négligeable" },
];

const GOUTS_7J = {
  carnivore:  ["Bœuf","Agneau","Porc","Poulet","Canard","Poisson","Fruits de mer","Fromage","Lard","Bacon","Champignons","Crème fraîche","Beurre"],
  omnivore:   ["Bœuf","Agneau","Porc","Poulet","Canard","Saumon","Thon","Cabillaud","Sardines","Crevettes","Fromage","Champignons","Courgettes","Épinards","Brocolis","Noix","Crème fraîche","Beurre"],
  vegetarien: ["Œufs","Tofu","Tempeh","Séitan","Fromage","Champignons","Courgettes","Épinards","Brocolis","Noix","Crème fraîche","Beurre"],
};
const INTOLS_7J = {
  carnivore:  ["Lactose","Oeufs","Porc","Fruits de mer","Poisson"],
  omnivore:   ["Lactose","Fruits de mer","Noix/oléagineux","Oeufs","Porc","Poisson"],
  vegetarien: ["Lactose","Oeufs","Noix/oléagineux","Soja"],
};
const STYLES_7J = [
  {id:"varié",l:"🌈 Varié"},{id:"simple",l:"🍳 Simple & rapide"},
  {id:"gourmet",l:"👨‍🍳 Gourmet"},{id:"budget",l:"💶 Budget maîtrisé"},
];
const REPAS_CFG = [
  {key:"petit_dejeuner",icon:"☀️",label:"Petit-déjeuner",c:"#F4A035",bg:"#FFF8F0"},
  {key:"dejeuner",icon:"🌤️",label:"Déjeuner",c:"#2A5298",bg:"#F0F4FF"},
  {key:"diner",icon:"🌙",label:"Dîner",c:"#1B3A6B",bg:"#E8EEF8"},
  {key:"dessert",icon:"🍰",label:"Dessert du dimanche",c:"#7CB342",bg:"#F1F8E9"},
];

const REGIMES_7J = [
  {id:"omnivore",  l:"🥩🥗 Omnivore",   desc:"Viandes, poissons, œufs, légumes, fromages"},
  {id:"carnivore", l:"🥩 Carnivore",    desc:"Viandes, poissons, œufs, produits animaux uniquement"},
  {id:"vegetarien",l:"🥗 Végétarien",   desc:"Œufs, fromages, légumes — sans viande ni poisson"},
];
const NB_REPAS_7J = [
  {id:1,l:"1 repas / jour",desc:"Repas unique (OMAD)"},
  {id:2,l:"2 repas / jour",desc:"Matin + Midi ou Midi + Soir ?",choix:["matin-midi","midi-soir"]},
  {id:3,l:"3 repas / jour",desc:"Classique"},
];
function CarteRepas7J({repas,icon,label,c,bg}){
  const [ouvert, setOuvert] = React.useState(false);
  if(!repas)return null;
  const aRecetteBlog = !!repas.recette_url;
  return(
    <div style={{background:"#fff",borderRadius:14,border:`2px solid ${c}22`,marginBottom:8,overflow:"hidden"}}>
      <div onClick={()=>setOuvert(o=>!o)} style={{display:"flex",alignItems:"center",gap:8,padding:"12px 14px",cursor:"pointer",background:ouvert?`${c}08`:"#fff"}}>
        <div style={{width:32,height:32,borderRadius:8,background:bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{icon}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:9,fontWeight:800,color:c,textTransform:"uppercase",letterSpacing:1}}>{label}</div>
          <div style={{fontSize:14,fontWeight:900,color:"#1a2a1a",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{repas.nom}</div>
        </div>
        <span style={{fontSize:11,color:c,opacity:0.7,flexShrink:0,marginLeft:4}}>{ouvert?"▲":"▼"}</span>
      </div>
      {ouvert && <div style={{padding:"0 14px 14px",borderTop:`1px solid ${c}18`}}>
        {aRecetteBlog && <span style={{display:"inline-block",fontSize:9,background:"#F0F4FF",color:"#2A5298",padding:"3px 8px",borderRadius:6,fontWeight:800,marginBottom:8,marginTop:8}}>📖 Recette blog</span>}
      {aRecetteBlog ? (
        <div style={{paddingLeft:44,marginBottom:4}}>
          {/* Suggestion accompagnement pour recettes salées avec note */}
          {repas.description ? (() => {
            const desc = repas.description;
            // Extraire parties via marqueurs propres
            const partiesDesc = desc.split(" · ");
            const partieCompteur = partiesDesc.find(p => p.match(/tranch|il en reste|parts? sur|part sur|portion/i) && !p.startsWith("ACCOMP:")) || null;
            const partieAccompRaw = partiesDesc.find(p => p.startsWith("ACCOMP:"));
            const partieAccomp = partieAccompRaw ? partieAccompRaw.replace(/^ACCOMP:/, "") : null;
            const partiesAutres = partiesDesc.filter(p => p !== partieCompteur && !p.startsWith("ACCOMP:") && p.trim());
            if(!partieCompteur && !partieAccomp && partiesAutres.length === 0) {
              return <div style={{fontSize:11,color:"#6B7280",lineHeight:1.6,marginBottom:10,fontStyle:"italic"}}>{desc}</div>;
            }
            return <>
              {partieCompteur && (
                <div style={{fontSize:11,color:"#2A5298",fontWeight:800,marginBottom:6,background:"#F0F4FF",borderRadius:8,padding:"8px 12px"}}>
                  🍞 {partieCompteur}
                </div>
              )}
              {partieAccomp && (
                <div style={{fontSize:11,color:"#2A5298",fontWeight:800,marginBottom:10,background:"#F0F4FF",borderRadius:8,padding:"8px 12px"}}>
                  🍽️ À déguster avec : {partieAccomp}
                </div>
              )}
              {partiesAutres.length > 0 && (
                <div style={{fontSize:11,color:"#6B7280",lineHeight:1.6,marginBottom:10,fontStyle:"italic"}}>{partiesAutres.join(" · ")}</div>
              )}
            </>;
          })() : (
            <div style={{fontSize:11,color:"#6B7280",lineHeight:1.6,marginBottom:10,fontStyle:"italic"}}>
              Suis la recette sur le blog pour les ingrédients et les quantités exactes.
            </div>
          )}
          <a href={repas.recette_url} target="_blank" rel="noopener noreferrer"
            style={{fontSize:12,color:"#fff",fontWeight:800,textDecoration:"none",background:"linear-gradient(135deg,#2A5298,#1B3A6B)",borderRadius:8,padding:"8px 14px",display:"inline-block",boxShadow:"0 2px 8px rgba(42,82,152,.25)"}}>
            📖 Voir la recette complète →
          </a>
        </div>
      ) : (
        /* Repas simple : afficher les ingrédients calculés */
        <>
          {(repas.ingredients||[]).length>0&&<div style={{fontSize:11,color:"#6B7280",lineHeight:1.8,marginBottom:8,paddingLeft:44}}>{repas.ingredients.map(i=>{const n=i.nom?.toLowerCase()||"";const isOeuf=n==="oeuf entier"||n==="oeuf"||n==="oeufs";const isAvocat=n==="avocat";if(isOeuf&&i.qte_g){const nb=Math.round(i.qte_g/50);return nb>0?`${nb} œuf${nb>1?"s":""}`:null;}if(isAvocat&&i.qte_g){const nb=Math.round(i.qte_g/100);return nb>0?`${nb} avocat${nb>1?"s":""}`:null;}return `${i.qte_g}g ${i.nom}`;}).filter(Boolean).join(", ")}</div>}
          {repas.description&&<div style={{fontSize:11,color:"#9ca3af",lineHeight:1.6,marginBottom:8,paddingLeft:44,fontStyle:"italic"}}>{repas.description}</div>}
          {(()=>{
            const ings=(repas.ingredients||[]).map(i=>i.nom?.toLowerCase());
            const hasSeitan=ings.some(n=>n?.includes("seitan"));
            const hasVegPro=ings.some(n=>n?.includes("tofu")||n?.includes("tempeh"));
            const hasComplete=ings.some(n=>n?.includes("oeuf")||n?.includes("comte")||n?.includes("emmental")||n?.includes("parmesan")||n?.includes("fromage")||n?.includes("chevre")||n?.includes("feta")||n?.includes("mozzarella")||n?.includes("camembert"));
            return(<>
              {hasSeitan&&<div style={{paddingLeft:44,marginBottom:8}}><span style={{fontSize:10,color:"#C62828",fontWeight:800,background:"#FFEBEE",borderRadius:6,padding:"3px 8px"}}>⚠️ Seitan = gluten pur, déconseillé en cas d'intolérance</span></div>}
              {hasVegPro&&!hasComplete&&<div style={{paddingLeft:44,marginBottom:8}}><span style={{fontSize:10,color:"#E65100",fontWeight:800,background:"#FFF8F0",borderRadius:6,padding:"3px 8px"}}>ℹ️ Protéines incomplètes, à combiner avec œufs ou fromage</span></div>}
            </>);
          })()}
        </>
      )}
      </div>}
    </div>
  );
}
// Table CIQUAL intégrée (macros pour 100g)
const CIQUAL = {
  "oeuf entier":       {pro:13,  lip:11,  glu:0},
  "blanc de poulet":   {pro:30,  lip:2,   glu:0},
  "poulet cuit":       {pro:25,  lip:5,   glu:0},
  "poulet":            {pro:25,  lip:5,   glu:0},
  "saumon":            {pro:20,  lip:13,  glu:0},
  "thon boite":        {pro:27,  lip:4,   glu:0},
  "thon":              {pro:27,  lip:4,   glu:0},
  "sardine":           {pro:19,  lip:10,  glu:0},
  "crevettes":         {pro:18,  lip:1,   glu:0},
  "cabillaud":         {pro:18,  lip:1,   glu:0},
  "morue":             {pro:26,  lip:1,   glu:0},
  "saumon fume":       {pro:22,  lip:12,  glu:0},
  "boeuf":       {pro:18,  lip:15,  glu:0},
  "boeuf":             {pro:20,  lip:10,  glu:0},
  "agneau":            {pro:20,  lip:18,  glu:0},
  "porc":              {pro:21,  lip:15,  glu:0},
  "lard":              {pro:14,  lip:40,  glu:0},
  "bacon":             {pro:14,  lip:40,  glu:0},
  "jambon cru":        {pro:26,  lip:13,  glu:0},
  "jambon":            {pro:20,  lip:4,   glu:1},
  "chorizo":           {pro:19,  lip:38,  glu:1},
  "saucisse":          {pro:13,  lip:25,  glu:2},
  "canard":            {pro:18,  lip:28,  glu:0},
  "dinde":             {pro:29,  lip:4,   glu:0},
  "emmental":          {pro:28,  lip:29,  glu:0},
  "comte":             {pro:28,  lip:34,  glu:0},
  "beaufort":          {pro:27,  lip:33,  glu:1},
  "gruyere":           {pro:26,  lip:34,  glu:1},
  "pecorino":          {pro:26,  lip:31,  glu:1},
  "pintade":           {pro:22,  lip:4,   glu:0},
  "oie":               {pro:29,  lip:12,  glu:0},
  "lievre":            {pro:22,  lip:3,   glu:0},
  "fromage":           {pro:20,  lip:25,  glu:1},
  "chevre frais":      {pro:12,  lip:11,  glu:0},
  "chevre":            {pro:12,  lip:11,  glu:0},
  "parmesan":          {pro:31,  lip:31,  glu:0},
  "mozzarella":        {pro:18,  lip:17,  glu:1},
  "feta":              {pro:14,  lip:21,  glu:0},
  "camembert":         {pro:20,  lip:24,  glu:0},
  "creme fraiche":     {pro:2,   lip:30,  glu:3},
  "creme":             {pro:2,   lip:30,  glu:3},
  "beurre":            {pro:0,   lip:83,  glu:0},
  "ghee":              {pro:0,   lip:99,  glu:0},  // beurre clarifié, sans lactose
  "huile olive":       {pro:0,   lip:100, glu:0},
  "huile":             {pro:0,   lip:100, glu:0},
  "mayonnaise":        {pro:1.36,lip:75.2,glu:2.62},
  "mayo":              {pro:1,   lip:70,  glu:1},
  "avocat":            {pro:2,   lip:15,  glu:2},
  "noix":              {pro:15,  lip:65,  glu:3},
  "amandes":           {pro:21,  lip:50,  glu:4},
  "noisettes":         {pro:14,  lip:61,  glu:5},
  "epinards":          {pro:3,   lip:0,   glu:1},
  "courgette":         {pro:1,   lip:0,   glu:2},
  "brocolis":          {pro:3,   lip:0,   glu:4},
  "salade":            {pro:1,   lip:0,   glu:1},
  "champignons":       {pro:3,   lip:0,   glu:1},
  "poivron":           {pro:1,   lip:0,   glu:6},
  "aubergine":         {pro:1,   lip:0,   glu:3},
  "concombre":         {pro:1,   lip:0,   glu:2},
  "tomate":            {pro:1,   lip:0,   glu:3},
  "vinaigre":          {pro:0,   lip:0,   glu:0},
  "celeri":            {pro:1,   lip:0,   glu:1},
  "chou fleur":        {pro:2,   lip:0,   glu:3},
  "chou blanc":        {pro:1,   lip:0,   glu:4},
  "konjac nouilles":   {pro:0,   lip:0,   glu:0},
  "konjac riz":        {pro:0,   lip:0,   glu:0},
  "konjac":            {pro:0,   lip:0,   glu:0},
  "endive":            {pro:1,   lip:0,   glu:1},
  "fenouil":           {pro:1,   lip:0,   glu:3},
  "avocat":            {pro:2,   lip:15,  glu:2},
  "haricots verts":    {pro:2,   lip:0,   glu:3},
  "chou":              {pro:2,   lip:0,   glu:4},
  "tofu":              {pro:8,   lip:4,   glu:1},
  "tempeh":            {pro:19,  lip:11,  glu:4},
  "seitan":            {pro:25,  lip:2,   glu:4},
  // Ajouts pour recettes encodées
  "fromage blanc":     {pro:8,   lip:4,   glu:4},
  "philadelphia":      {pro:6,   lip:22,  glu:4},
  "mascarpone":        {pro:7,   lip:41,  glu:3},
  "cheddar":           {pro:25,  lip:33,  glu:0},
  "poudre amande":     {pro:21,  lip:50,  glu:4},
  "farine amande":     {pro:21,  lip:50,  glu:4},
  "farine coco":       {pro:17,  lip:14,  glu:8},
  "puree amande":      {pro:21,  lip:55,  glu:5},
  "whey vanille":      {pro:75,  lip:4,   glu:8},
  "whey nature":       {pro:80,  lip:4,   glu:5},
  "isolate whey":      {pro:90,  lip:1,   glu:2},
  "blanc oeuf poudre": {pro:80,  lip:0,   glu:5},
  "gelatine":          {pro:87,  lip:0,   glu:0},
  "blanc oeuf":        {pro:11,  lip:0,   glu:1},
  "jaune oeuf":        {pro:16,  lip:27,  glu:1},
  "morbier":           {pro:23,  lip:29,  glu:0},
  "noix grenoble":     {pro:13,  lip:67,  glu:3},
  "farine soja":       {pro:38,  lip:21,  glu:26},
  "farine lin":        {pro:19,  lip:40,  glu:7},
  "chocolat 85":       {pro:10,  lip:43,  glu:7},
  "chocolat 90":       {pro:11,  lip:46,  glu:5},
  "cacao poudre":      {pro:23,  lip:21,  glu:12},
  "creme coco":        {pro:2,   lip:24,  glu:4},
  "huile coco":        {pro:0,   lip:100, glu:0},
  "huile sesame":      {pro:0,   lip:100, glu:0},
  "noix cajou":        {pro:18,  lip:44,  glu:30},
  "graines lin":       {pro:18,  lip:42,  glu:2},
  "graines chia":      {pro:19.5,lip:30.7,glu:7.72},
  "graines sesame":    {pro:18,  lip:50,  glu:5},
  "graines tournesol": {pro:21,  lip:52,  glu:5},
  "graines courge":    {pro:30,  lip:49,  glu:5},
  "noix moulu":        {pro:15,  lip:65,  glu:3},
  "psyllium":          {pro:2,   lip:1,   glu:1},
  "erythritol":        {pro:0,   lip:0,   glu:0},
  "allulose":          {pro:0,   lip:0,   glu:0},
  "sauce soja":        {pro:10,  lip:0,   glu:3.2},
  "cornichon":         {pro:0.33,lip:0.2, glu:2.3},
  "olives vertes":     {pro:1.13,lip:16.6,glu:0.61},
  "olives noires":     {pro:1.38,lip:17.2,glu:0.1},
  "tomate concassee":  {pro:1,   lip:0,   glu:4},
  "oignon":            {pro:1,   lip:0,   glu:6},
  "ail":               {pro:6,   lip:1,   glu:16},
  "gingembre":         {pro:2,   lip:1,   glu:10},
  "poivron":           {pro:1,   lip:0,   glu:6},
  "veau":              {pro:21,  lip:8,   glu:0},
  "farine lupin":      {pro:40,  lip:9,   glu:0},
  "farine soja":       {pro:36,  lip:20,  glu:1},
  "farine bambou":     {pro:8,   lip:1,   glu:4},
  "farine chanvre":    {pro:32,  lip:49,  glu:4},
  "gomme guar":        {pro:6,   lip:1,   glu:0},
  "gomme xanthane":    {pro:0,   lip:0,   glu:0},
  "agar agar":         {pro:7,   lip:0,   glu:0},
  "bicarbonate soude": {pro:0,   lip:0,   glu:0},
  "creme tartre":      {pro:0,   lip:0,   glu:0},
  "gluten pur":        {pro:75,  lip:2,   glu:14},
  "huile avocat":      {pro:0,   lip:100, glu:0},
  "lait coco":         {pro:2,   lip:17,  glu:3},
  "beurre cacao":      {pro:0,   lip:100, glu:0},
  "pate arachide":     {pro:26,  lip:48,  glu:7},
  "macadamia":         {pro:8,   lip:76,  glu:5},
  "noix bresil":       {pro:14,  lip:67,  glu:4},
  "pignons":           {pro:14,  lip:69,  glu:4},
  "cacahuetes":        {pro:26,  lip:50,  glu:7},
  "noix coco rapee":   {pro:4,   lip:65,  glu:6},
  "stevia":            {pro:0,   lip:0,   glu:0},
  "fruit moine":       {pro:0,   lip:0,   glu:0},
  "ricotta":           {pro:9,   lip:10,  glu:4},
  "yaourt grec":       {pro:9,   lip:5,   glu:4},
  "skyr":              {pro:11,  lip:0,   glu:4},
  "yaourt skyr":       {pro:11,  lip:0,   glu:4},
  "foie de veau":      {pro:19,  lip:3,   glu:9},
  "foie de veau cuit": {pro:19,  lip:3,   glu:9},
  "fromage blanc frais entier": {pro:7,   lip:3,   glu:4},
  "fromage blanc nature":       {pro:7,   lip:3,   glu:4},

  "myrtilles":         {pro:1,   lip:0,   glu:10},
  "framboises":        {pro:1,   lip:0,   glu:5},
  "fraises":           {pro:1,   lip:0,   glu:7},
  "groseilles":        {pro:1,   lip:0,   glu:9},
  "cassis":            {pro:1,   lip:0,   glu:8},
  "mures":             {pro:1,   lip:0,   glu:7},
  "citron":            {pro:1,   lip:0,   glu:3},
  "vanille":           {pro:0,   lip:0,   glu:1},
  "feve tonka":        {pro:0,   lip:0,   glu:0},
  "vinaigre cidre":    {pro:0,   lip:0,   glu:1},
};

// Calcule les macros depuis une liste d'ingrédients [{nom, qte_g}]
function calcMacros(ingredients) {
  let pro=0, lip=0, glu=0;
  if (!Array.isArray(ingredients)) return {pro:0,lip:0,glu:0};
  const normalize = s => s.toLowerCase()
    .replace(/œ/g,"oe").replace(/æ/g,"ae")
    .normalize("NFD").replace(/[\u0300-\u036f]/g,"")
    .replace(/[^a-z0-9 ]/g," ").replace(/\s+/g," ").trim();
  const ciqualKeys = Object.keys(CIQUAL);
  ingredients.forEach(({nom, qte_g}) => {
    if (!nom || qte_g==null) return;
    const n = normalize(nom);
    const isOeuf = n.includes("oeuf");
    // Si l'IA envoie le nombre d'œufs (ex: qte_g=2 ou qte_g=3) au lieu des grammes
    let qte = parseFloat(qte_g) || 0;
    if (isOeuf && qte <= 12) qte = qte * 50; // convertir nombre → grammes (50g/oeuf)
    if (qte <= 0) return;
    // 1. Correspondance exacte
    let key = ciqualKeys.find(k => normalize(k) === n);
    // 2. Le nom contient la clé (clés longues en priorité)
    if (!key) {
      const matches = ciqualKeys.filter(k => n.includes(normalize(k)));
      if (matches.length) key = matches.reduce((a,b) => a.length > b.length ? a : b);
    }
    // 3. La clé contient le premier mot du nom
    if (!key) {
      const first = n.split(" ")[0];
      key = ciqualKeys.find(k => normalize(k).includes(first) && first.length > 3);
    }
    if (key) {
      pro += CIQUAL[key].pro * qte / 100;
      lip += CIQUAL[key].lip * qte / 100;
      glu += CIQUAL[key].glu * qte / 100;
    }
  });
  return {pro:Math.round(pro), lip:Math.round(lip), glu:Math.round(glu)};
}

// Recalcule tous les totaux journaliers depuis les repas
// Corrige le nom du plat si l'ingrédient principal est absent
function corrigerNomPlat(repas) {
  if (!repas?.nom || !repas?.ingredients) return repas;
  const nomNorm = s => s.toLowerCase().replace(/œ/g,"oe").replace(/æ/g,"ae").normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9 ]/g," ").replace(/\s+/g," ").trim();
  const nom = nomNorm(repas.nom);
  const ingsNoms = (repas.ingredients||[]).filter(i=>parseFloat(i.qte_g)>0).map(i=>nomNorm(i.nom||"")).join(" ");
  const viandes = ["boeuf","jambon cru","poulet","saumon","thon","agneau","boeuf","porc","lard","bacon","jambon","canard","sardine","crevettes","cabillaud","chorizo","saucisse","dinde","truite"];
  const motAbsent = viandes.find(v => nom.includes(nomNorm(v)) && !ingsNoms.includes(nomNorm(v)));
  if (motAbsent) {
    const nomCorrige = repas.nom
      .replace(new RegExp(`(au |aux |de |du |à la |à l')?${motAbsent}(\\s|$)`, 'gi'), '')
      .replace(/\s+/g,' ').trim()
      .replace(/^(au |aux |de |du |et |à la |à l')/i,'');
    return {...repas, nom: nomCorrige || repas.nom};
  }
  return repas;
}

function recalculerPlan(plan) {
  if (!plan?.jours) return plan;
  return {
    ...plan,
    jours: plan.jours.map(jour => {
      const repasCalc = {};
      let totalPro=0, totalLip=0, totalGlu=0;
      Object.entries(jour.repas||{}).forEach(([key, repas]) => {
        const macros = calcMacros(repas.ingredients);
        repasCalc[key] = corrigerNomPlat({...repas, macros});
        totalPro += macros.pro; totalLip += macros.lip; totalGlu += macros.glu;
      });
      return {...jour, repas:repasCalc, total_jour:{pro:totalPro, lip:totalLip, glu:totalGlu}};
    })
  };
}

// ─── BIBLIOTHÈQUE DE REPAS TYPES ─────────────────────────────────────────────
const REPAS_TYPES = [
  // OMNIVORE / CARNIVORE — MIDI & SOIR
  {id:"steak_champignons", nom:"Steak haché aux champignons", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"steak hache",ciqual:"boeuf"}, legumes:[{nom:"champignons",qte:150}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"boeuf_courgettes", nom:"Émincé de bœuf aux courgettes", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"boeuf",ciqual:"boeuf"}, legumes:[{nom:"courgette",qte:150}], graisses:[{nom:"creme fraiche",ciqual:"creme fraiche"}], crudites:{nom:"salade",qte:80}},
  {id:"boeuf_fromage", nom:"Steak haché au fromage fondu", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"boeuf",ciqual:"boeuf"}, legumes:[{nom:"champignons",qte:100}], graisses:[{nom:"beurre",ciqual:"beurre"}], extras:[{nom:"comte",ciqual:"comte",qte:40}], crudites:{nom:"salade",qte:80}},
  {id:"poulet_creme", nom:"Cuisse de poulet à la crème", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"poulet",ciqual:"poulet"}, legumes:[{nom:"champignons",qte:150}], graisses:[{nom:"creme fraiche",ciqual:"creme fraiche"}], crudites:{nom:"salade",qte:80}},
  {id:"poulet_beurre", nom:"Poulet rôti au beurre", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"poulet",ciqual:"poulet"}, legumes:[{nom:"courgette",qte:150}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"poulet_larde", nom:"Brochettes de poulet lardé", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"poulet",ciqual:"poulet"}, extras:[{nom:"lard",ciqual:"lard",qte:60}], legumes:[{nom:"champignons",qte:100}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"porc_champignons", nom:"Côte de porc aux champignons", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"porc",ciqual:"porc"}, legumes:[{nom:"champignons",qte:150}], graisses:[{nom:"creme fraiche",ciqual:"creme fraiche"}], crudites:{nom:"salade",qte:80}},
  {id:"porc_courgettes", nom:"Émincé de porc aux courgettes", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"porc",ciqual:"porc"}, legumes:[{nom:"courgette",qte:150}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"effiloche_porc", nom:"Effiloché de porc", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"porc",ciqual:"porc"}, legumes:[], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"agneau_champignons", nom:"Côtelettes d'agneau aux champignons", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"agneau",ciqual:"agneau"}, legumes:[{nom:"champignons",qte:150}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"agneau_courgettes", nom:"Agneau aux courgettes", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"agneau",ciqual:"agneau"}, legumes:[{nom:"courgette",qte:150}], graisses:[{nom:"huile olive",ciqual:"huile olive"}], crudites:{nom:"salade",qte:80}},
  {id:"canard_champignons", nom:"Confit de canard aux champignons", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"canard",ciqual:"canard"}, legumes:[{nom:"champignons",qte:150}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"lard_champignons", nom:"Lard poêlé aux champignons", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"lard",ciqual:"lard"}, legumes:[{nom:"champignons",qte:150}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"chorizo_courgettes", nom:"Chorizo aux courgettes", regime:["omnivore"], repas:["dejeuner","diner"], proteines:{nom:"chorizo",ciqual:"chorizo"}, legumes:[{nom:"courgette",qte:150}], graisses:[{nom:"creme fraiche",ciqual:"creme fraiche"}], crudites:{nom:"salade",qte:80}},
  {id:"saumon_beurre", nom:"Saumon grillé au beurre", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"saumon",ciqual:"saumon"}, legumes:[{nom:"epinards",qte:150}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"concombre",qte:80}},
  {id:"saumon_creme", nom:"Saumon à la crème", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"saumon",ciqual:"saumon"}, legumes:[{nom:"epinards",qte:150}], graisses:[{nom:"creme fraiche",ciqual:"creme fraiche"}], crudites:{nom:"salade",qte:80}},
  {id:"thon_courgettes", nom:"Thon aux courgettes sautées", regime:["omnivore"], repas:["dejeuner","diner"], proteines:{nom:"thon",ciqual:"thon"}, legumes:[{nom:"courgette",qte:150}], graisses:[{nom:"huile olive",ciqual:"huile olive"}], crudites:{nom:"salade",qte:80}},
  {id:"cabillaud_beurre", nom:"Cabillaud au beurre", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"cabillaud",ciqual:"cabillaud"}, legumes:[{nom:"courgette",qte:150}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"crevettes_beurre", nom:"Crevettes sautées au beurre", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"crevettes",ciqual:"crevettes"}, legumes:[{nom:"courgette",qte:150}], graisses:[{nom:"beurre",ciqual:"beurre"}], crudites:{nom:"salade",qte:80}},
  {id:"sardines_salade", nom:"Sardines à l'huile d'olive", regime:["omnivore"], repas:["dejeuner","diner"], proteines:{nom:"sardine",ciqual:"sardine"}, legumes:[], graisses:[{nom:"huile olive",ciqual:"huile olive"}], crudites:{nom:"salade",qte:100}},
  {id:"saint_jacques", nom:"Saint-Jacques poêlées au beurre", regime:["omnivore","carnivore"], repas:["dejeuner","diner"], proteines:{nom:"crevettes",ciqual:"crevettes"}, legumes:[], graisses:[{nom:"beurre",ciqual:"beurre"}]},
  // VÉGÉTARIEN — MIDI & SOIR
  {id:"tofu_champignons", nom:"Tofu sauté aux champignons", regime:["vegetarien"], repas:["dejeuner","diner"], proteines:{nom:"tofu",ciqual:"tofu"}, legumes:[{nom:"champignons",qte:150}], graisses:[{nom:"huile olive",ciqual:"huile olive"}], extras:[{nom:"comte",ciqual:"comte",qte:40}], crudites:{nom:"salade",qte:80}},
  {id:"tempeh_courgettes", nom:"Tempeh aux courgettes", regime:["vegetarien"], repas:["dejeuner","diner"], proteines:{nom:"tempeh",ciqual:"tempeh"}, legumes:[{nom:"courgette",qte:150}], graisses:[{nom:"huile olive",ciqual:"huile olive"}], crudites:{nom:"salade",qte:80}},
  {id:"gratin_fromage", nom:"Gratin de légumes au comté", regime:["vegetarien"], repas:["dejeuner","diner"], proteines:{nom:"comte",ciqual:"comte"}, legumes:[{nom:"courgette",qte:150},{nom:"champignons",qte:100}], graisses:[{nom:"creme fraiche",ciqual:"creme fraiche"}], crudites:{nom:"salade",qte:80}},
  // PETIT-DÉJEUNER
  {id:"cake_epinards", nom:"Cake céto épinards et fromage frais", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:true, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"chevre frais",ciqual:"chevre frais",qte:80},{nom:"epinards",ciqual:"epinards",qte:50},{nom:"jambon",ciqual:"jambon",qte:50}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"cake_chevre", nom:"Cake céto chèvre courgette", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:true, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"chevre frais",ciqual:"chevre frais",qte:80},{nom:"courgette",ciqual:"courgette",qte:100}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"cake_feta_poivron", nom:"Cake céto feta poivron", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:true, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"feta",ciqual:"feta",qte:80},{nom:"poivron",ciqual:"poivron",qte:80}], graisses:[{nom:"huile olive",ciqual:"huile olive"}], boisson:"café ou thé"},
  {id:"cake_sucre_amandes", nom:"Cake céto amandes et citron", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:false, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"amandes",ciqual:"amandes",qte:60},{nom:"chevre frais",ciqual:"chevre frais",qte:40}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"cake_sucre_noix", nom:"Cake céto noix et cannelle", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:false, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"noix",ciqual:"noix",qte:50},{nom:"chevre frais",ciqual:"chevre frais",qte:40}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"pancakes_ceto", nom:"Pancakes céto", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:false, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"chevre frais",ciqual:"chevre frais",qte:80},{nom:"amandes",ciqual:"amandes",qte:40}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"crepes_ceto", nom:"Crêpes céto", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:false, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"chevre frais",ciqual:"chevre frais",qte:60},{nom:"amandes",ciqual:"amandes",qte:30}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"pain_ceto_autrichien", nom:"Pain céto autrichien au fromage blanc", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:true, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"chevre frais",ciqual:"chevre frais",qte:80},{nom:"amandes",ciqual:"amandes",qte:50}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"bacon_oeufs", nom:"Bacon et œufs", regime:["omnivore","carnivore"], repas:["petit_dejeuner"], sale:true, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"bacon",ciqual:"bacon",qte:100}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"fromage_blanc_fruits", nom:"Fromage blanc aux fruits rouges", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:false, proteines:{nom:"chevre frais",ciqual:"chevre frais"}, extras:[{nom:"noix",ciqual:"noix",qte:30},{nom:"amandes",ciqual:"amandes",qte:20}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"plateau_fromages", nom:"Plateau comté et charcuterie", regime:["omnivore","carnivore"], repas:["petit_dejeuner"], sale:true, proteines:{nom:"comte",ciqual:"comte"}, extras:[{nom:"jambon cru",ciqual:"jambon cru",qte:60},{nom:"camembert",ciqual:"camembert",qte:50}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"brioche_keto", nom:"Brioche keto à la fleur d'oranger", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:false, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"amandes",ciqual:"amandes",qte:50},{nom:"chevre frais",ciqual:"chevre frais",qte:60}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé", confiture:true},
  {id:"omelette_jambon", nom:"Omelette au jambon et fromage", regime:["omnivore"], repas:["petit_dejeuner"], proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"jambon",ciqual:"jambon",qte:60},{nom:"comte",ciqual:"comte",qte:40}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"omelette_japonaise", nom:"Omelette japonaise", regime:["omnivore","carnivore"], repas:["petit_dejeuner"], proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"comte",ciqual:"comte",qte:50},{nom:"jambon cru",ciqual:"jambon cru",qte:40}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"oeufs_bacon", nom:"Œufs au bacon", regime:["omnivore","carnivore"], repas:["petit_dejeuner"], proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"bacon",ciqual:"bacon",qte:80}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"omelette_truite", nom:"Omelette à la truite fumée", regime:["omnivore","carnivore"], repas:["petit_dejeuner"], proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"saumon fume",ciqual:"saumon fume",qte:60}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"oeufs_beurre_carni", nom:"Œufs brouillés au beurre", regime:["carnivore"], repas:["petit_dejeuner"], proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"bacon",ciqual:"bacon",qte:80}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café au beurre ou thé"},
  {id:"viande_froide_carni", nom:"Viande froide et fromage", regime:["carnivore"], repas:["petit_dejeuner"], proteines:{nom:"jambon cru",ciqual:"jambon cru"}, extras:[{nom:"comte",ciqual:"comte",qte:60},{nom:"bacon",ciqual:"bacon",qte:60}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café au beurre ou thé"},
  {id:"saumon_fume_matin", nom:"Saumon fumé et fromage frais", regime:["omnivore","carnivore"], repas:["petit_dejeuner"], sale:true, proteines:{nom:"saumon fume",ciqual:"saumon fume"}, extras:[{nom:"chevre frais",ciqual:"chevre frais",qte:80}], graisses:[{nom:"beurre",ciqual:"beurre"}], boisson:"café ou thé"},
  {id:"fat_bombs_noix", nom:"Fat bombs aux noix", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:false, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"noix",ciqual:"noix",qte:40}], graisses:[{nom:"huile olive",ciqual:"huile olive"}], boisson:"café ou thé"},
  {id:"smoothie_fruits_rouges", nom:"Smoothie protéiné aux fruits rouges", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:false, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"noix",ciqual:"noix",qte:30}], graisses:[{nom:"huile olive",ciqual:"huile olive"}], boisson:"café ou thé"},
  {id:"petits_pains_keto", nom:"Petits pains keto", regime:["omnivore","vegetarien"], repas:["petit_dejeuner"], sale:false, proteines:{nom:"oeuf entier",ciqual:"oeuf entier"}, extras:[{nom:"amandes",ciqual:"amandes",qte:40}], graisses:[{nom:"huile olive",ciqual:"huile olive"}], boisson:"café ou thé"},
];

// ─── MOTEUR DE CALCUL DES QUANTITÉS ──────────────────────────────────────────
function calculerQuantites(repasType, proTarget, lipTarget) {
  const C = CIQUAL;
  const ingredients = [];
  const proNom = repasType.proteines.ciqual || repasType.proteines.nom;
  const proData = C[proNom];
  if (!proData) return [];

  // 1. Quantité protéine principale
  let qteProteine;
  if (proNom === "oeuf entier") {
    const nbOeufs = Math.max(2, Math.min(4, Math.round(proTarget / proData.pro * 100 / 50))); // MAX 4 oeufs
    qteProteine = nbOeufs * 50;
  } else {
    qteProteine = Math.round(proTarget / proData.pro * 100);
    qteProteine = Math.max(100, Math.min(400, qteProteine));
  }
  ingredients.push({nom: proNom, qte_g: qteProteine});

  // 2. Extras fixes
  let lipDepenses = proData.lip * qteProteine / 100;
  (repasType.extras || []).forEach(e => {
    const d = C[e.ciqual || e.nom];
    if (d) { ingredients.push({nom: e.ciqual || e.nom, qte_g: e.qte}); lipDepenses += d.lip * e.qte / 100; }
  });

  // 3. Légumes fixes
  (repasType.legumes || []).forEach(l => {
    const d = C[l.nom];
    if (d) ingredients.push({nom: l.nom, qte_g: l.qte});
  });

  // 4. Crudités fixes
  if (repasType.crudites) {
    const d = C[repasType.crudites.nom];
    if (d) ingredients.push({nom: repasType.crudites.nom, qte_g: repasType.crudites.qte});
  }

  // 5. Matière grasse pour compléter les lipides
  const lipRestants = Math.max(0, lipTarget - lipDepenses);
  if (lipRestants > 5 && repasType.graisses?.length > 0) {
    const graisse = repasType.graisses[0];
    const gData = C[graisse.ciqual || graisse.nom];
    if (gData?.lip > 0) {
      const qteGraisse = Math.max(10, Math.min(50, Math.round(lipRestants / gData.lip * 100))); // beurre/ghee MAX 50g
      ingredients.push({nom: graisse.ciqual || graisse.nom, qte_g: qteGraisse});
    }
  }
  return ingredients;
}

function ModulePlan7Jours(){
  // CN déclaré EN PREMIER — évite le TDZ (Temporal Dead Zone) en production minifiée
  const CN={navy:"#1B3A6B",navyLight:"#2A5298",green:"#7CB342",greenPale:"#F1F8E9",orange:"#F4A035",orangePale:"#FFF8F0",cream:"#FAFAF7",white:"#FFFFFF",gray:"#6B7280",grayLight:"#F3F4F6",red:"#C62828"};
  const [prefs,setPrefs]=useState({regime:"omnivore",aime:[],intol:[],style:"varié",nbRepas:3,repas2:"midi-soir",exclusionsLibres:""});
  const [plan,setPlan]=useState(null);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState(null);
  const [tab,setTab]=useState(0);
  // ── Menu sauvegardé (localStorage, 8 jours) ──
  const MENU_KEY = "cetoclub_menu_sauve";
  const MENU_DUREE_MS = 8 * 24 * 60 * 60 * 1000;
  const [menuSauve, setMenuSauve] = useState(() => {
    try {
      const raw = JSON.parse(localStorage.getItem(MENU_KEY)||"null");
      if (!raw || !raw._ts) return null;
      if (Date.now() - raw._ts > MENU_DUREE_MS) { localStorage.removeItem(MENU_KEY); return null; }
      return raw;
    } catch { return null; }
  });
  const sauvegarderMenu = () => {
    if (!plan) return;
    const data = {...plan, _ts: Date.now()};
    try { localStorage.setItem(MENU_KEY, JSON.stringify(data)); } catch {}
    setMenuSauve(data);
  };
  const supprimerMenu = () => {
    try { localStorage.removeItem(MENU_KEY); } catch {}
    setMenuSauve(null);
  };
  const joursRestants = menuSauve ? Math.ceil((MENU_DUREE_MS - (Date.now() - menuSauve._ts)) / 86400000) : 0;
  const macrosProfil = getObjectifsEffectifs();
  const toggle=(field,item)=>setPrefs(prev=>({...prev,[field]:prev[field].includes(item)?prev[field].filter(x=>x!==item):[...prev[field],item]}));
  const generer=async()=>{
    setLoading(true);setError(null);setPlan(null);
    try{
    const nbR = prefs.nbRepas || 3;
    const repas2 = prefs.repas2 || "midi-soir";
    const genCount = (() => { try { return parseInt(localStorage.getItem("cetoclub_gen_count")||"0"); } catch { return 0; } })();
    const histoRecettes = (() => { try { return JSON.parse(localStorage.getItem("cetoclub_recettes_histo")||"{}"); } catch { return {}; } })();
    const COOLDOWN_BLOG = 4;
    const recetteEnCooldown = (id) => {
      const derniere = histoRecettes[id];
      if(derniere === undefined) return false;
      return (genCount - derniere) < COOLDOWN_BLOG;
    };
    const repasKeys = nbR===1?["dejeuner"]:nbR===2?(repas2==="matin-midi"?["petit_dejeuner","dejeuner"]:["dejeuner","diner"]):["petit_dejeuner","dejeuner","diner"];
    const obj = getObjectifsEffectifs();
    // Minimum protéines absolu : 1.2g/kg (plancher garanti tous régimes)
    const poidsKg = (() => { try { const p = JSON.parse(localStorage.getItem("cetoclub_profil")||"null"); return parseFloat(p?.poids)||0; } catch { return 0; } })();
    const proMinJour = poidsKg > 0 ? Math.round(1.2 * poidsKg) : 0;
    const proJourGaranti = Math.max(obj.pro, proMinJour); // toujours au moins 1.2g/kg
    const PRO_MIN_ABSOLU = 80;
    const LIP_MIN_ABSOLU = 140;
    const proJourFinal = Math.max(proJourGaranti, PRO_MIN_ABSOLU);
    const lipJourFinal = Math.max(obj.lip, LIP_MIN_ABSOLU);
    const lipParRepas = Math.round(lipJourFinal/nbR);
    const proParRepas = Math.round(proJourFinal/nbR);
    const jours7 = ["Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi","Dimanche"];

    // ── Filtre accompagnement : retire viandes/poissons selon régime/exclusions ──
    const filtrerAccomp = (str) => {
      let s = str || "";
      // TOLÉRANCE ZÉRO — passe 1 : œufs + mode cuisson + grammes
      if(oeufsExclus) {
        s = s.replace(/\d*\s*[o\u0153]ufs?\s*(?:(?:au\s+plat|brouill\u00e9s?|durs?|en\s+omelette|entiers?)\s*)?(?:ou\s+(?:au\s+plat|brouill\u00e9s?|durs?|en\s+omelette)\s*)?(?:\(\d+g\))?[,\s\u00b7et]*/gi, "");
        // Passe 2 : résidus modes cuisson orphelins
        s = s.replace(/\b(?:au\s+plat|brouill\u00e9s?|durs?|en\s+omelette)\s*(?:\(\d+g\))?[,\s\u00b7]*/gi, "");
      }
      if(noixExclus || aSansOleagineux) {
        s = s.replace(/noix[^,\u00b7(]*(?:\(\d+g\))?[,\s\u00b7ou]*/gi, "");
        s = s.replace(/amandes?[^,\u00b7(]*(?:\(\d+g\))?[,\s\u00b7ou]*/gi, "");
      }
      if(prefs.regime === "vegetarien") {
        // Végétarien : zéro viande, zéro poisson, zéro charcuterie dans les notes
        s = s.replace(/jambon cru[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
        s = s.replace(/jambon[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
        s = s.replace(/saumon fumé?[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
        s = s.replace(/poulet[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
        s = s.replace(/thon[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
        s = s.replace(/dinde[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
        s = s.replace(/boeuf[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
        s = s.replace(/charcuterie[^,·(]*[,\s·ou]*/gi, "");
      } else {
        if(porcExclus) {
          s = s.replace(/jambon cru[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
          s = s.replace(/jambon[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
        }
        if(poissonExclus) {
          s = s.replace(/saumon fumé?[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
        }
      }
      if(oeufsExclus) s = s.replace(/\d+\s*[oœ]ufs?[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
      if(aLactose) s = s.replace(/fromage[^,·(]*(?:\(\d+g\))?[,\s·ou]*/gi, "");
      // Nettoyer résidus
      return s.replace(/\s*ou\s*$/, "").replace(/^ou\s*/, "").replace(/,\s*$/, "").replace(/^\s*,\s*/, "").trim();
    };

    // ── 1. Catégories d'ingrédients ────────────────────────────────────────────
    const CAT = {
      viandes:      ["boeuf","agneau","porc","canard","lard","dinde","chorizo","poulet"],
      poissons:     ["saumon","thon","cabillaud","sardine","crevettes","saumon fume"],
      oeufs:        ["oeuf entier"],
      prot_vege:    ["tofu","tempeh","seitan"],
      legumes:      ["courgette","brocolis","poivron","aubergine","champignons","epinards","tomate","chou fleur","chou blanc","celeri","endive","fenouil","avocat","concombre","salade"],
      fromages:     ["comte","chevre frais","camembert","feta"],
      graisses_ani: ["beurre","ghee","creme fraiche"],
      graisses_veg: ["huile olive"],
      oleagineux:   ["noix"],
    };

    // ── 2. Normalisation + exclusions — AVANT la construction de FORMULES ────────
    const normStr = s => (s||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").trim();
    const excl = [
      ...prefs.intol.filter(Boolean).map(normStr),
      ...(prefs.exclusionsLibres||"").split(",").map(e=>normStr(e.trim())).filter(Boolean)
    ];
    const estExclu = nom => excl.some(e => e && normStr(nom||"").includes(e));
    const oeufsExclus     = prefs.intol.includes("Oeufs")           || excl.some(e=>["oeuf","oeufs","oeuf entier","egg","eggs"].includes(e));
    const sojaExclus      = prefs.intol.includes("Soja")            || excl.some(e=>["soja","tofu","tempeh"].includes(e)); // seitan = blé, pas soja
    const lactoseExclus   = prefs.intol.includes("Lactose")         || excl.some(e=>["lactose"].includes(e));
    const noixExclus      = prefs.intol.includes("Noix/oléagineux") || excl.some(e=>["noix","oleagineux","amandes"].includes(e));
    const poissonExclus   = prefs.intol.includes("Poisson")         || excl.some(e=>["poisson","saumon","thon","cabillaud","sardine"].includes(e));
    const fruitsMerExclus = prefs.intol.includes("Fruits de mer")   || excl.some(e=>["crevettes","fruits de mer"].includes(e));
    const porcExclus      = prefs.intol.includes("Porc")            || excl.some(e=>["porc","lard","bacon","chorizo"].includes(e));
    const estAime = nom => prefs.aime.length===0 || prefs.aime.some(a => normStr(nom||"").includes(normStr(a||"")));
    const aSansOleagineux = noixExclus || prefs.regime==="carnivore";

    // Filtrer CAT selon exclusions AVANT que FORMULES les utilise
    if(poissonExclus)    { CAT.poissons  = []; }
    if(fruitsMerExclus)  { CAT.poissons  = CAT.poissons.filter(p => p!=="crevettes"); }
    if(porcExclus)       { CAT.viandes   = CAT.viandes.filter(v => !["porc","lard","bacon","chorizo"].includes(v)); }
    if(sojaExclus)       { CAT.prot_vege = CAT.prot_vege.filter(v => !["tofu","tempeh"].includes(v)); } // seitan = blé, pas soja

    // Formules par régime — construit APRÈS filtrage de CAT
    const toObj = arr => arr.map(n => ({nom:n, label:{
      "boeuf":"Bœuf","agneau":"Agneau","porc":"Porc","canard":"Canard","lard":"Lard",
      "bacon":"Bacon","dinde":"Dinde","chorizo":"Chorizo","poulet":"Poulet",
      "saumon":"Saumon","thon":"Thon","cabillaud":"Cabillaud","sardine":"Sardines",
      "crevettes":"Crevettes","saumon fume":"Saumon fumé",
      "oeuf entier":"Œufs","tofu":"Tofu","tempeh":"Tempeh","seitan":"Séitan",
    }[n]||n}));
    const FORMULES = {
      carnivore: {
        proteines: toObj([...CAT.viandes, ...CAT.poissons]),
        legumes:   [],
        graisses:  CAT.graisses_ani,
        fromages:  CAT.fromages,
        crudites:  false,
      },
      omnivore: {
        proteines: toObj([...CAT.viandes, ...CAT.poissons]),
        legumes:   CAT.legumes,
        graisses:  [...CAT.graisses_ani, ...CAT.graisses_veg],
        fromages:  CAT.fromages,
        crudites:  false,
      },
      vegetarien: {
        proteines: toObj([...CAT.oeufs, ...CAT.prot_vege]),
        legumes:   CAT.legumes,
        graisses:  [...CAT.graisses_veg, ...CAT.graisses_ani],
        fromages:  CAT.fromages,
        crudites:  false,
      },
    };

    const formule = FORMULES[prefs.regime] || FORMULES.omnivore;
    const aLactose = prefs.intol.includes("Lactose");

    const graissesDispo = aLactose
      ? formule.graisses.map(g => g==="beurre" ? "ghee" : g).filter(g => g!=="creme fraiche")
      : formule.graisses;
    const graissePrincipale = graissesDispo[0] || "huile olive";
    const fromagesDispo = aLactose ? [] : formule.fromages;
    const legumesDispo = formule.legumes;

    const GRAISSE_PAR_PRO = {
      "boeuf":"beurre","agneau":"beurre","porc":"creme fraiche","canard":"beurre",
      "lard":"beurre","bacon":"beurre","dinde":"creme fraiche","chorizo":"creme fraiche",
      "poulet":"creme fraiche","saumon":"beurre","thon":"huile olive","cabillaud":"beurre",
      "crevettes":"beurre","sardine":"huile olive","saumon fume":"beurre",
      "oeuf entier":"beurre","tofu":"huile olive","tempeh":"huile olive","seitan":"huile olive",
    };

    // ── 3. Filtrer chaque catégorie selon exclusions ──────────────────────────
    
    // Protéines : exclure + favoriser les aimées
    let proteinesExcluses = formule.proteines.filter(v => !estExclu(v.nom));
    // Carni/Omni : œufs interdits comme protéine principale à midi/soir (OK en recette élaborée)
    // Végétarien : œufs AUTORISÉS comme protéine principale (souvent la seule option)
    if(prefs.regime !== "vegetarien") {
      proteinesExcluses = proteinesExcluses.filter(v => v.nom !== "oeuf entier");
    }
    // Chorizo et bacon : jamais protéines principales (accompagnements uniquement)
    proteinesExcluses = proteinesExcluses.filter(v => v.nom !== "chorizo" && v.nom !== "bacon" && v.nom !== "lard");
    // Fallback : si liste vide après filtres, revenir au pool complet du régime (sans chorizo)
    if(proteinesExcluses.length === 0) {
      proteinesExcluses = formule.proteines.filter(v => v.nom !== "chorizo" && v.nom !== "bacon" && v.nom !== "lard");
    }
    // Fallback ultime : si toujours vide (ex: végé avec soja + œufs exclus), fromages
    if(proteinesExcluses.length === 0) {
      proteinesExcluses = toObj(CAT.fromages.length > 0 ? CAT.fromages : ["comte"]);
    }
    
    // Séparer aimées et autres pour pondérer la rotation (70% aimées si cochées)
    const proteinesAimees = proteinesExcluses.filter(v => estAime(v.nom));
    const proteinesAutres = proteinesExcluses.filter(v => !estAime(v.nom));
    // Si des aimées existent : 70% aimées, 30% autres pour varier quand même
    let proteinesDispos = proteinesAimees.length > 0
      ? [...proteinesAimees, ...proteinesAimees, ...proteinesAimees, ...proteinesAutres] // 3x aimées
      : proteinesExcluses;
    
    // Budget → retirer les produits chers
    if(prefs.style==="budget") proteinesDispos = proteinesDispos.filter(v=>!["saumon","crevettes","agneau","canard","saumon fume"].includes(v.nom));
    if(proteinesDispos.length===0) proteinesDispos = formule.proteines.slice(0,3);

    // Légumes : exclure les non voulus, favoriser les aimés
    let legumesDispos = legumesDispo.filter(l => !estExclu(l));
    if(legumesDispos.length===0) legumesDispos = legumesDispo;
    const legumesAimes = legumesDispos.filter(l => estAime(l));
    const legumesRotation = legumesAimes.length > 0
      ? [...legumesAimes, ...legumesAimes, ...legumesDispos]
      : legumesDispos;

    // Fromages : exclure si lactose ou exclusion explicite
    const fromagesDispos = fromagesDispo.filter(f => !estExclu(f));

    // Graisses : déjà filtrées par lactose, vérifier exclusions supplémentaires
    const graissesDispos = graissesDispo.filter(g => !estExclu(g));
    const graissePrincipaleFiltre = graissesDispos[0] || "huile olive";

    // ── 4. Index recettes encodées ──────────────────────────────────────────────
    const recetteIdx = {};
    let recetteBlogAujourdHui = false;
    // Suivi des parts restantes pour recettes multi-portions (ex: pain autrichien 12 parts)
    const partsRestantes = {}; // { recette_id: nb_parts_restantes }
    const recetteEnCoursId = { id: null }; // recette multi-portions actuellement en cours

    // ── 5. Rotation protéines sur 7 jours ────────────────────────────────────
    const slotsParJour = repasKeys.filter(k => k!=="petit_dejeuner");
    const nbSlots = jours7.length * slotsParJour.length;
    const rotation = [];
    while(rotation.length < nbSlots) {
      const shuffled = [...proteinesDispos].sort(()=>Math.random()-0.5);
      rotation.push(...shuffled);
    }

    // ── 3. Petits-déjeuners (via IA si inclus, sinon JS) ─────────────────────
    let dejsIA = {};
    const hasPtitDej = repasKeys.includes("petit_dejeuner");
    if(hasPtitDej) {
      // aSansOleagineux défini plus haut
      const rm = REPAS_TYPES.filter(r => {
        if(!r.repas.includes("petit_dejeuner")) return false;
        if(!r.regime.includes(prefs.regime)) return false;
        if(aLactose && r.id.startsWith("cake")) return false;
        if(aLactose && ["brioche_keto","pain_ceto_autrichien","fromage_blanc_fruits","plateau_fromages"].includes(r.id)) return false;
        if(aLactose && ["chevre frais","comte","emmental","camembert","feta","parmesan"].includes(r.proteines?.ciqual||r.proteines?.nom)) return false;
        // Exclure recettes avec noix/amandes si intolérance oléagineux
        // Si oléagineux exclus : zéro pâtisserie (amandes partout), garder seulement flans/crèmes
        if(aSansOleagineux && r.id.startsWith("cake")) return false;
        if(aSansOleagineux && ["pancakes_ceto","crepes_ceto","fat_bombs_noix","smoothie_fruits_rouges","petits_pains_keto","brioche_keto","fromage_blanc_fruits","pain_ceto_autrichien","cake_sucre_amandes","cake_sucre_noix"].includes(r.id)) return false;
        // Filtrer les extras selon exclusions
        if(r.extras && r.extras.some(e => estExclu(e.nom))) return false;
        return true;
      });
      const cakesSales  = rm.filter(r=>r.id.startsWith("cake")&&r.sale===true);
      const cakesSucres = rm.filter(r=>r.id.startsWith("cake")&&r.sale===false);
      const get = id => rm.find(r=>r.id===id);
      // Séquence variée sur 7 jours : salé / sucré / tradi alternés
      const painDispo = !recetteEnCooldown("pain_ceto_autrichien") ? get("pain_ceto_autrichien") : (!recetteEnCooldown("petits_pains_keto") ? get("petits_pains_keto") : null);
      const poolVaries = [
        cakesSales[0], get("pancakes_ceto"), cakesSucres[0], get("crepes_ceto"),
        !recetteEnCooldown("fat_bombs_noix") ? get("fat_bombs_noix") : cakesSales[1],
        !recetteEnCooldown("brioche_keto") ? get("brioche_keto") : cakesSales[0],
        !recetteEnCooldown("smoothie_fruits_rouges") ? get("smoothie_fruits_rouges") : cakesSucres[0],
        !recetteEnCooldown("fromage_blanc_fruits") ? get("fromage_blanc_fruits") : cakesSales[1],
        get("saumon_fume_matin"), cakesSales[1],
      ].filter(Boolean);
      let varieIdx = genCount * 3;
      jours7.forEach((jour, i) => {
        const estJourPain = ((i + genCount) % 2 === 0);
        if(estJourPain && painDispo) { dejsIA[jour] = painDispo; }
        else { dejsIA[jour] = poolVaries[varieIdx % poolVaries.length] || cakesSales[0] || rm[0]; varieIdx++; }
      });
    }

    // ── 5. Construire les repas de chaque jour ───────────────────────────────
    let slotIdx = 0;
    // Max 2x/semaine pour les aliments à oxalates ou à limiter
    const compteurs = {champignons:0, epinards:0, amandes:0, tomate:0, seitan:0};
    const MAX_SEMAINE = 2;
    const MAX_PIZZA = 1;
    const MAX_RECETTES_BLOG = 5;

    // Rotation finale : garantit que midi ≠ soir, et pas la même protéine 2 jours de suite
    const nbSlotsTotal = jours7.length * slotsParJour.length;
    const rotationFinale = [];
    const proteinesAimeesFiltre = proteinesExcluses.filter(v => estAime(v.nom) && (v.nom !== "oeuf entier" || prefs.regime==="vegetarien"));
    const proteinesAutresFiltre = proteinesExcluses.filter(v => !proteinesAimeesFiltre.includes(v));
    const poolAime = proteinesAimeesFiltre.length > 0 ? proteinesAimeesFiltre : proteinesExcluses;
    const poolAutre = proteinesAutresFiltre.length > 0 ? proteinesAutresFiltre : proteinesExcluses;

    // Construire jour par jour pour garantir la variété
    let derniereProteine = null;
    let idxAime = 0, idxAutre = 0;
    for(let j=0; j<7; j++) {
      const repasJourSlots = [];
      for(let s=0; s<slotsParJour.length; s++) {
        const globalSlot = j * slotsParJour.length + s;
        let candidat;
        if(proteinesAimeesFiltre.length > 0 && globalSlot % 2 === 0) {
          // Slot aimé — éviter répétition avec slot précédent
          candidat = poolAime[idxAime % poolAime.length];
          if(candidat.nom === derniereProteine && poolAime.length > 1) {
            idxAime++;
            candidat = poolAime[idxAime % poolAime.length];
          }
          idxAime++;
        } else {
          candidat = poolAutre[idxAutre % poolAutre.length];
          if(candidat.nom === derniereProteine && poolAutre.length > 1) {
            idxAutre++;
            candidat = poolAutre[idxAutre % poolAutre.length];
          }
          idxAutre++;
        }
        // Garantir que midi ≠ soir ET pas la même que le dernier slot
        const dejaNomJour = repasJourSlots.map(v => v.nom);
        // Lard et bacon comptent comme la même protéine (y compris si ptit-dej avait bacon)
        const ptitDejProt = dejsIA[jours7[j]]?.proteines?.nom || "";
        const similaire = (a, b) => a===b || (["lard","bacon"].includes(a) && ["lard","bacon"].includes(b));
        const dejaNomJourAvecPDej = [...dejaNomJour, ptitDejProt];
        if(dejaNomJourAvecPDej.some(n => similaire(n, candidat.nom))) {
          const pool2 = proteinesExcluses.filter(v => !dejaNomJourAvecPDej.some(n => similaire(n, v.nom)));
          if(pool2.length > 0) candidat = pool2[Math.floor(Math.random() * pool2.length)];
        }
        repasJourSlots.push(candidat);
        derniereProteine = candidat.nom;
      }
      rotationFinale.push(...repasJourSlots);
    }
    // Séitan : max 2x/semaine
    let seitanCount = 0;
    for(let i = 0; i < rotationFinale.length; i++) {
      if(rotationFinale[i].nom === "seitan") {
        seitanCount++;
        if(seitanCount > MAX_SEMAINE) {
          const autreVege = proteinesExcluses.find(v => v.nom !== "seitan" && v.nom !== rotationFinale[i === 0 ? 0 : i-1]?.nom);
          if(autreVege) rotationFinale[i] = autreVege;
        }
      }
    }
    // Viandes/poissons aimés : max 3x/semaine
    const MAX_AIME = 3;
    const compteurAimes = {};
    for(let i = 0; i < rotationFinale.length; i++) {
      const nom = rotationFinale[i].nom;
      if(proteinesAimeesFiltre.some(v => v.nom === nom)) {
        compteurAimes[nom] = (compteurAimes[nom] || 0) + 1;
        if(compteurAimes[nom] > MAX_AIME) {
          const avant = rotationFinale[i-1]?.nom || "";
          const apres = rotationFinale[i+1]?.nom || "";
          const remplacant = proteinesExcluses.find(v =>
            v.nom !== nom && v.nom !== avant && v.nom !== apres &&
            (!proteinesAimeesFiltre.some(a => a.nom === v.nom) || (compteurAimes[v.nom] || 0) < MAX_AIME)
          );
          if(remplacant) { rotationFinale[i] = remplacant; compteurAimes[nom]--; }
        }
      }
    }

    const nbSlotsParJour = slotsParJour.length;
    const champSlots = new Set([]); // plus utilisé — carnivore sans légumes
    // joursConstruit accumule les jours au fur et à mesure pour éviter l'auto-référence TDZ
    const joursConstruit = [];
    const jours = jours7.map(nomJour => {
      const repasJour = {};
      let totalPro=0, totalLip=0, totalGlu=0;
      recetteBlogAujourdHui = false; // reset chaque jour

      // Petit-déjeuner
      // Trouver la recette encodée disponible pour ce jour
      const LAITIERS = ["beurre","creme fraiche","comte","emmental","chevre frais","parmesan","mozzarella","feta","camembert","mascarpone","fromage blanc","cheddar","creme coco"];
      const encodeesPDejDispo = RECETTES_ENCODEES.filter(r =>
        r.repas.includes("petit_dejeuner") &&
        r.regime.includes(prefs.regime) &&
        !r.ingredients.some(i => estExclu(i.nom)) &&
        // Exclure pâtisseries/oléagineux si exclusion active
        !(aSansOleagineux && r.ingredients.some(i => ["poudre amande","farine amande","noix moulu","graines chia","graines lin","graines tournesol","graines courge","graines sesame","puree amande"].includes(i.nom))) &&
        // Filtre strict lactose : exclure toute recette avec produit laitier (sauf ghee)
        !(aLactose && r.ingredients.some(i => LAITIERS.includes(i.nom)))
      );
      if(hasPtitDej) {
        if(encodeesPDejDispo.length > 0) {
          const jourIdx = jours7.indexOf(nomJour);

          // Chercher si une recette multi-portions est en cours (parts restantes)
          let encodeePDej = null;
          let peutReutiliser = false;

          if(recetteEnCoursId.id) {
            const recEnCours = RECETTES_ENCODEES.find(r => r.id === recetteEnCoursId.id);
            const restantes = partsRestantes[recetteEnCoursId.id] || 0;
            const parParRepas = recEnCours?.parts_par_repas || 1;
            if(restantes >= parParRepas && recEnCours && encodeesPDejDispo.some(r => r.id === recetteEnCoursId.id)) {
              encodeePDej = recEnCours;
              peutReutiliser = true;
              partsRestantes[recetteEnCoursId.id] = restantes - parParRepas;
              if(partsRestantes[recetteEnCoursId.id] < parParRepas) recetteEnCoursId.id = null;
            } else {
              recetteEnCoursId.id = null; // épuisée ou non dispo
            }
          }

          // Sinon choisir une nouvelle recette
          if(!encodeePDej) {
            const idxPDejBase = jourIdx % encodeesPDejDispo.length;
            encodeePDej = encodeesPDejDispo[idxPDejBase];
            // Si multi-portions : initialiser le compteur (portions - parts_par_repas car on consomme dès maintenant)
            const parParRepas = encodeePDej.parts_par_repas || 1;
            if(encodeePDej.portions > parParRepas) {
              partsRestantes[encodeePDej.id] = encodeePDej.portions - parParRepas;
              recetteEnCoursId.id = encodeePDej.id;
            }
          }

          // Macros × parts_par_repas si applicable
          const parParRepasActuel = encodeePDej.parts_par_repas || 1;
          const restantesApres = partsRestantes[encodeePDej.id] ?? 0;
          const m = encodeePDej.macros_portion;
          const macros = {
            pro: Math.round(m.pro * parParRepasActuel),
            lip: Math.round(m.lip * parParRepasActuel),
            glu: Math.round(m.glu * parParRepasActuel),
          };
          totalPro+=macros.pro; totalLip+=macros.lip; totalGlu+=macros.glu;
          recetteBlogAujourdHui = true;

          // Construire la note avec X parts sur Y + accompagnement protéiné précis
          const totalPortions = encodeePDej.portions;
          let partiePDejParts = "";
          if(encodeePDej.note?.includes("{RESTANTES}")) {
            // Pain autrichien : note dynamique avec compteur — extraire SEULEMENT la partie compteur (avant le ·)
            const noteAvecRestantes = encodeePDej.note.replace("{RESTANTES}", String(restantesApres));
            partiePDejParts = noteAvecRestantes.split("·")[0].trim();
          } else if(totalPortions > 1) {
            partiePDejParts = parParRepasActuel > 1
              ? `${parParRepasActuel} parts sur ${totalPortions}`
              : peutReutiliser ? `1 part sur ${totalPortions} (reste de la fournée)` : `1 part sur ${totalPortions}`;
          } else {
            partiePDejParts = "1 portion entière";
          }

          // Accompagnement protéiné avec quantités précises
          // Pour le pain autrichien, la note contient "{RESTANTES}" + "· À déguster avec..."
          // On extrait seulement la partie après le premier "·" pour trouver l'accompagnement
          const noteRawPDej = encodeePDej.note || "";
          const noteSourcePDej = noteRawPDej.includes("{RESTANTES}")
            ? noteRawPDej.replace(/^[^·]*·\s*/, "") // enlever la partie "2 tranches ce matin..."
            : noteRawPDej;
          const matchAccompPDej = noteSourcePDej.match(/(?:déguster avec|compléter avec|accompagner de)\s*:?\s*(.+)/i);
          let partieAccompPDej = "";
          if(matchAccompPDej) {
            let accoStr = filtrerAccomp(matchAccompPDej[1]);
            accoStr = accoStr
              .replace(/\b2\s*[oœ]ufs?\b/gi, "2 œufs (100g)")
              .replace(/\bjambon cru\b/gi, "jambon cru (40g)")
              .replace(/\bjambon\b(?!\s*cru|\s*\()/gi, "jambon (60g)")
              .replace(/\bsaumon fumé\b/gi, "saumon fumé (60g)")
              .replace(/\bfromage au choix\b/gi, "fromage au choix (40g)")
              .replace(/\bfromage\b(?!\s*au\s*choix|\s*\()/gi, "fromage (40g)")
              .replace(/\bcafé ou thé\b/gi, "café ou thé")
              .replace(/\s*ou\s*$/, "").replace(/^ou\s*/, "").trim();
            if(accoStr) partieAccompPDej = accoStr;
          }

          const partiesPDej = [
            partiePDejParts,
            partieAccompPDej ? `ACCOMP:${partieAccompPDej}` : ""
          ].filter(Boolean);
          const notePDej = partiesPDej.join(" · ");

          repasJour.petit_dejeuner = {
            nom: encodeePDej.titre,
            ingredients: encodeePDej.ingredients,
            macros,
            description: notePDej,
            recette_url: encodeePDej.url,
            encodee: true,
          };
        } else {
          let ingsFb = [], nomFb = "", descFb = "";
          if(!oeufsExclus) {
            const nbOeufs = Math.min(4, Math.max(2, Math.round(proParRepas / 13)));
            ingsFb = [{nom:"oeuf entier", qte_g: nbOeufs*50}];
            if(!aLactose && !estExclu("beurre")) ingsFb.push({nom:"beurre", qte_g:15});
            nomFb = "Œufs au choix"; descFb = "Brouillés, au plat, durs ou en omelette · café ou thé";
          } else if(!aLactose && !estExclu("comte")) {
            ingsFb = [{nom:"comte", qte_g:80}];
            if(!porcExclus && !estExclu("jambon cru")) ingsFb.push({nom:"jambon cru", qte_g:60});
            else if(!poissonExclus && !estExclu("saumon fume")) ingsFb.push({nom:"saumon fume", qte_g:80});
            nomFb = "Plateau fromage & protéine"; descFb = "Fromage affiné + protéine · café ou thé";
          } else if(!poissonExclus && !estExclu("saumon fume")) {
            ingsFb = [{nom:"saumon fume", qte_g:120}];
            if(!aLactose && !estExclu("ghee")) ingsFb.push({nom:"ghee", qte_g:15});
            nomFb = "Saumon fumé nature"; descFb = "Avec concombre ou avocat · café ou thé";
          } else if(!porcExclus && !estExclu("jambon cru")) {
            ingsFb = [{nom:"jambon cru", qte_g:100}];
            nomFb = "Jambon cru & avocat"; descFb = "Avec avocat · café ou thé";
          } else {
            ingsFb = [{nom:"avocat", qte_g:150},{nom:"huile olive", qte_g:20}];
            nomFb = "Avocat & huile d'olive"; descFb = "Avec sel et citron · café ou thé";
          }
          const macrosFb = calcMacros(ingsFb);
          totalPro+=macrosFb.pro; totalLip+=macrosFb.lip; totalGlu+=macrosFb.glu;
          repasJour.petit_dejeuner = {nom:nomFb,ingredients:ingsFb,macros:macrosFb,description:descFb,recette_url:""};
        }
      }

      // Déjeuner et/ou dîner
      slotsParJour.forEach(slot => {
        const viande = rotationFinale[slotIdx % rotationFinale.length];
        slotIdx++;
        const ciqual = CIQUAL[viande.nom];
        if(!ciqual) return;

        // Quantité protéine selon cibles — en OMAD tout l'objectif journalier sur 1 repas
        const isOMAD = nbR === 1;
        // Minimum absolu OMAD : 80g pro, 140g lip — OBLIGATOIRE même sans profil
        const proMinOMAD = Math.max(proJourFinal, 80);
        const lipMinOMAD = Math.max(lipJourFinal, 140);
        // Plafond protéines = objectif réel de la personne (jamais dépasser l'objectif choisi)
        const proPlafond = isOMAD ? proJourFinal : proParRepas; // utilise proJourFinal (déjà max entre obj, 1.2g/kg, plancher absolu)
        const proTarget = isOMAD ? Math.min(proMinOMAD, proPlafond) : proParRepas;
        const lipTarget = isOMAD ? lipMinOMAD : lipParRepas;

        let qteViande;
        if(viande.nom==="oeuf entier") {
          const nb = Math.max(3, Math.min(4, Math.round(proTarget / ciqual.pro * 100 / 50))); // MAX 4 oeufs
          qteViande = nb * 50;
        } else {
          // Max 200g de viande par repas (150g hors OMAD), compléter avec 2ème protéine si besoin
          // Lard/bacon/jambon cru/chorizo : plafond strict AVANT le plancher OMAD
          const plafondSpecial = viande.nom==="lard" ? 100
            : viande.nom==="bacon" ? 60
            : viande.nom==="jambon cru" ? 50
            : viande.nom==="chorizo" ? 50
            : null;
          if(plafondSpecial !== null) {
            qteViande = Math.min(plafondSpecial, Math.round(proTarget / ciqual.pro * 100));
          } else {
            qteViande = Math.max(isOMAD?150:100, Math.min(200, Math.round(proTarget / ciqual.pro * 100)));
          }
        }

        // En OMAD : ajouter une 2ème protéine complémentaire (oeufs ou charcuterie)
        let viande2 = null, qteViande2 = 0;
        if(isOMAD) {
          const proRestante = Math.max(0, proTarget - (ciqual.pro * qteViande / 100));
          if(proRestante > 10) {
            // Choisir une protéine complémentaire différente
            // En OMAD : œufs autorisés pour tous les régimes comme complément
            const complements = (prefs.regime==="carnivore"
              ? [{nom:"oeuf entier",ciqual:"oeuf entier"},{nom:"jambon cru",ciqual:"jambon cru"},{nom:"comte",ciqual:"comte"},{nom:"saumon fume",ciqual:"saumon fume"}]
              : prefs.regime==="vegetarien"
              ? [{nom:"oeuf entier",ciqual:"oeuf entier"},{nom:"comte",ciqual:"comte"},{nom:"feta",ciqual:"feta"},{nom:"chevre frais",ciqual:"chevre frais"}]
              : [{nom:"oeuf entier",ciqual:"oeuf entier"},{nom:"jambon cru",ciqual:"jambon cru"},{nom:"saumon fume",ciqual:"saumon fume"},{nom:"comte",ciqual:"comte"},{nom:"thon boite",ciqual:"thon boite"}]
            ).filter(c => !(oeufsExclus && c.nom==="oeuf entier") && !(aLactose && ["comte","chevre frais","camembert","feta"].includes(c.nom)) && !(poissonExclus && ["saumon fume","thon boite"].includes(c.nom)) && !(porcExclus && c.nom==="jambon cru") && !estExclu(c.nom) && CIQUAL[c.ciqual]);
            const comp = complements.find(c => c.nom !== viande.nom && CIQUAL[c.ciqual] &&
              !((viande.nom==="lard" && c.nom==="bacon") || (viande.nom==="bacon" && c.nom==="lard")));
            if(comp) {
              const ciqual2 = CIQUAL[comp.ciqual];
              viande2 = comp;
              qteViande2 = comp.nom==="oeuf entier"
                ? Math.min(Math.round(proRestante / ciqual2.pro * 100 / 50) * 50, 200) // MAX 4 oeufs
                : Math.min(150, Math.round(proRestante / ciqual2.pro * 100));
            }
          }
        }

        // Légume : carnivore = champignons uniquement, max 2x/semaine
        // Crucifères (famille des choux) : jamais 2 dans le même repas ni le même jour
        const CRUCIFERES = ["brocolis","chou fleur","chou blanc","chou","celeri"];
        // Tous les légumes possibles à suivre (champignons inclus)
        const TOUS_LEGUMES = [...legumesRotation, "champignons"];
        let legume;
        if(prefs.regime === "carnivore") {
          legume = (compteurs["champignons"]||0) < MAX_SEMAINE ? "champignons" : null;
          if(legume) compteurs["champignons"] = (compteurs["champignons"]||0) + 1;
        } else {
          // Légumes déjà utilisés aujourd'hui (repas précédents + légumes en cours de sélection) — champignons inclus
          const legumesDejaAujourdHui = [
            ...Object.entries(repasJour)
              .flatMap(([,r]) => (r.ingredients||[]).map(i=>i.nom)),
            ...(repasJour['_tempLegumes'] || [])
          ].filter(n => TOUS_LEGUMES.includes(n));
          // Crucifères déjà dans le jour
          const crucifereDejaAujourdHui = legumesDejaAujourdHui.some(l => CRUCIFERES.includes(l));
          // Champignons déjà utilisés aujourd'hui
          const champignonDejaAujourdHui = legumesDejaAujourdHui.includes("champignons");

          // Légume principal : exclure crucifères si déjà un aujourd'hui, champignons si déjà aujourd'hui ou quota semaine atteint
          let legume1 = legumesRotation[slotIdx % legumesRotation.length];
          // Éviter répétition hebdo
          if(compteurs[legume1] >= MAX_SEMAINE) {
            const alts = legumesRotation.filter(l => (!compteurs[l] || compteurs[l] < MAX_SEMAINE) && !legumesDejaAujourdHui.includes(l));
            if(alts.length > 0) legume1 = alts[slotIdx % alts.length];
          }
          // Éviter même légume le même jour
          if(legumesDejaAujourdHui.includes(legume1)) {
            const alts2 = legumesRotation.filter(l => !legumesDejaAujourdHui.includes(l) && (!compteurs[l] || compteurs[l] < MAX_SEMAINE));
            if(alts2.length > 0) legume1 = alts2[Math.floor(Math.random() * alts2.length)];
          }
          // Éviter crucifère si déjà un aujourd'hui
          if(crucifereDejaAujourdHui && CRUCIFERES.includes(legume1)) {
            const alts3 = legumesRotation.filter(l => !CRUCIFERES.includes(l) && !legumesDejaAujourdHui.includes(l) && (!compteurs[l] || compteurs[l] < MAX_SEMAINE));
            if(alts3.length > 0) legume1 = alts3[Math.floor(Math.random() * alts3.length)];
          }
          // Éviter champignons si déjà aujourd'hui OU quota hebdo atteint
          if(legume1 === "champignons" && (champignonDejaAujourdHui || (compteurs["champignons"]||0) >= MAX_SEMAINE)) {
            const alts4 = legumesRotation.filter(l => l !== "champignons" && !legumesDejaAujourdHui.includes(l) && (!compteurs[l] || compteurs[l] < MAX_SEMAINE));
            if(alts4.length > 0) legume1 = alts4[Math.floor(Math.random() * alts4.length)];
          }
          if(legume1 && compteurs[legume1] !== undefined) compteurs[legume1]++;
          // Enregistrer immédiatement legume1 dans repasJour comme marqueur temporaire
          // pour que le slot suivant du même jour puisse le détecter dans legumesDejaAujourdHui
          if(!repasJour['_tempLegumes']) repasJour['_tempLegumes'] = [];
          if(legume1) repasJour['_tempLegumes'].push(legume1);

          // 2ème légume (50g) — toujours proposé pour omni/végé, différent du 1er
          const legume1EstCrucifere = CRUCIFERES.includes(legume1);
          const legumesDispos2 = legumesRotation.filter(l =>
            l !== legume1 &&
            !legumesDejaAujourdHui.includes(l) &&
            (!compteurs[l] || compteurs[l] < MAX_SEMAINE) &&
            // Pas 2 crucifères dans le même repas
            !(legume1EstCrucifere && CRUCIFERES.includes(l)) &&
            // Jamais champignons en legume2 si déjà utilisés aujourd'hui ou quota atteint
            !(l === "champignons" && (champignonDejaAujourdHui || legume1 === "champignons" || (compteurs["champignons"]||0) >= MAX_SEMAINE))
          );
          // Toujours un 2ème légume si disponible (omni/végé systématique)
          const legume2 = legumesDispos2.length > 0
            ? legumesDispos2[Math.floor(Math.random() * legumesDispos2.length)]
            : null;
          if(legume2 && compteurs[legume2] !== undefined) compteurs[legume2]++;
          if(legume2) repasJour['_tempLegumes'].push(legume2);

          legume = legume1;
          Object.defineProperty(repasJour, '_legume2_'+slotIdx, {value: legume2, enumerable: false, writable: true});
        }
        const legume2 = repasJour['_legume2_'+slotIdx] || null;

        // Pas de crudités — supprimées (irritantes)
        const crudite = null;

        // Graisse filtrée
        let graisseCle = GRAISSE_PAR_PRO[viande.nom] || graissePrincipaleFiltre;
        if(aLactose && graisseCle==="creme fraiche") graisseCle = "ghee";
        if(aLactose && graisseCle==="beurre") graisseCle = "ghee";
        if(estExclu(graisseCle)) graisseCle = graissesDispos[0] || "huile olive";
        const grasData = CIQUAL[graisseCle];
        const lipViande = ciqual.lip * qteViande/100;
        const lipRestant = Math.max(0, lipTarget - lipViande);
        const qteGraisse = grasData?.lip>0 ? Math.max(10, Math.min(50, Math.round(lipRestant/grasData.lip*100))) : 20; // beurre/ghee MAX 50g

        // Fromage : carnivore en rotation, végétarien systématiquement — jamais si lactose
        const fromageSlot = (!aLactose && !lactoseExclus && fromagesDispos.length > 0)
          ? (prefs.regime==="carnivore" || prefs.regime==="vegetarien"
              ? fromagesDispos[slotIdx % fromagesDispos.length]
              : null)
          : null;

        // Végétarien : œufs systématiquement ajoutés en complément si pas déjà protéine principale
        // + fromage systématique (géré ci-dessus)
        // + calcul protéines réelles pour vérifier le plancher 1.2g/kg
        const aDejaOeufs = viande.nom === "oeuf entier";
        const oeufVegeQte = (prefs.regime==="vegetarien" && !aDejaOeufs && !oeufsExclus)
          ? 100  // 2 œufs (50g chacun)
          : 0;

        // Calcul protéines après protéine principale + fromage + œufs végé
        const fromageData = fromageSlot ? CIQUAL[fromageSlot] : null;
        const proDuRepas = (ciqual.pro * qteViande / 100)
          + (fromageData ? fromageData.pro * (isOMAD?60:40) / 100 : 0)
          + (oeufVegeQte > 0 ? CIQUAL["oeuf entier"].pro * oeufVegeQte / 100 : 0)
          + (viande2 && qteViande2>0 ? (CIQUAL[viande2.ciqual]?.pro||0) * qteViande2 / 100 : 0);

        // Si protéines encore insuffisantes : ajouter protéines complémentaires jusqu'au plancher
        const proManquantes = proParRepas - proDuRepas;
        let proCompl = [];
        if(proManquantes > 5) {
          // Choisir la meilleure protéine complémentaire selon régime
          // Lard et bacon jamais ensemble dans le même repas
          const lardBaconPrincipal = ["lard","bacon"].includes(viande.nom);
          // Œufs autorisés comme complément au déjeuner/dîner UNIQUEMENT pour végétarien
          const estPetitDej = slot === "petit_dejeuner";
          const oeufAutorise = prefs.regime==="vegetarien" || estPetitDej;
          const LAITIERS_LACTOSE = ["comte","chevre frais","camembert","feta","parmesan","mozzarella"];
          const candidatsCompl = prefs.regime==="vegetarien"
            ? [
                {nom:"oeuf entier", pro:CIQUAL["oeuf entier"].pro},
                {nom:"comte",       pro:CIQUAL["comte"].pro},
                {nom:"feta",        pro:CIQUAL["feta"].pro},
                {nom:"chevre frais",pro:CIQUAL["chevre frais"].pro},
                {nom:"parmesan",    pro:CIQUAL["parmesan"].pro},
                {nom:"mozzarella",  pro:CIQUAL["mozzarella"].pro},
              ].filter(c => !estExclu(c.nom) && c.nom !== viande.nom
                && !(oeufsExclus && c.nom==="oeuf entier")
                && !(aLactose && LAITIERS_LACTOSE.includes(c.nom))
                && CIQUAL[c.nom])
            : prefs.regime==="carnivore"
            ? [
                {nom:"oeuf entier", pro:CIQUAL["oeuf entier"].pro},
                {nom:"jambon cru",  pro:CIQUAL["jambon cru"].pro},
                {nom:"comte",       pro:CIQUAL["comte"].pro},
                {nom:"saumon fume", pro:CIQUAL["saumon fume"].pro},
              ].filter(c => !estExclu(c.nom) && c.nom !== viande.nom &&
                !(lardBaconPrincipal && ["lard","bacon"].includes(c.nom)) &&
                !(!oeufAutorise && c.nom==="oeuf entier") &&
                !(oeufsExclus && c.nom==="oeuf entier") &&
                !(poissonExclus && ["saumon fume","thon","sardine"].includes(c.nom)) &&
                !(aLactose && LAITIERS_LACTOSE.includes(c.nom)) &&
                CIQUAL[c.nom])
            : [
                {nom:"oeuf entier", pro:CIQUAL["oeuf entier"].pro},
                {nom:"jambon cru",  pro:CIQUAL["jambon cru"].pro},
                {nom:"saumon fume", pro:CIQUAL["saumon fume"].pro},
                {nom:"thon boite",  pro:CIQUAL["thon boite"].pro},
                {nom:"comte",       pro:CIQUAL["comte"].pro},
                {nom:"chevre frais",pro:CIQUAL["chevre frais"].pro},
                {nom:"feta",        pro:CIQUAL["feta"].pro},
                {nom:"sardine",     pro:CIQUAL["sardine"].pro},
              ].filter(c => !estExclu(c.nom) && c.nom !== viande.nom &&
                !(lardBaconPrincipal && ["lard","bacon"].includes(c.nom)) &&
                !(!oeufAutorise && c.nom==="oeuf entier") &&
                !(oeufsExclus && c.nom==="oeuf entier") &&
                !(poissonExclus && ["saumon fume","thon boite","sardine"].includes(c.nom)) &&
                !(porcExclus && ["jambon cru","jambon"].includes(c.nom)) &&
                !(aLactose && LAITIERS_LACTOSE.includes(c.nom)) &&
                CIQUAL[c.nom]);

          let proRestante = proManquantes;
          for(const cand of candidatsCompl) {
            if(proRestante <= 3) break;
            const deja = proCompl.find(x=>x.nom===cand.nom);
            if(deja) continue;
            // Ne pas ajouter un ingrédient déjà présent via viande2
            if(viande2 && viande2.ciqual === cand.nom) continue;
            if(viande2 && viande2.nom === cand.nom) continue;
            const qteMax = cand.nom==="oeuf entier" ? 200 : cand.nom==="jambon cru" ? 50 : 200; // oeuf max 200g = 4 oeufs
            const qteCompl = cand.nom==="oeuf entier"
              ? Math.min(Math.ceil(proRestante / cand.pro * 100 / 50) * 50, qteMax)
              : Math.min(Math.round(proRestante / cand.pro * 100 / 5) * 5, qteMax);
            if(qteCompl > 0) {
              proCompl.push({nom: cand.nom, qte_g: qteCompl});
              proRestante -= cand.pro * qteCompl / 100;
            }
          }
        }

        const r5 = v => Math.round(v/5)*5; // arrondi au multiple de 5
        // Glucides de référence pour trier les légumes (source CIQUAL)
        const GLU_LEGUME = {courgette:2,brocolis:4,poivron:6,aubergine:3,champignons:1,epinards:1,tomate:3,"chou fleur":3,"chou blanc":4,celeri:1,endive:1,fenouil:3,avocat:2,concombre:2,salade:1};
        // Légume principal max 100g (le moins glucidique), légume 2 = 50g — avocat toujours 100g (1 pièce)
        // Si legume2 est moins glucidique que legume1, les inverser pour mettre le + léger en 100g
        let legumeA = legume, legumeB = legume2 || null;
        if(legumeA && legumeB && legumeA !== "avocat" && legumeB !== "avocat") {
          const gluA = GLU_LEGUME[legumeA] ?? 3;
          const gluB = GLU_LEGUME[legumeB] ?? 3;
          if(gluB < gluA) { [legumeA, legumeB] = [legumeB, legumeA]; } // legume le moins glucidique en 100g
        }
        const qteLegs = (l) => l === "avocat" ? 100 : 100; // légume principal 100g (le moins glucidique)
        const qteLeg2 = (l) => l === "avocat" ? 100 : 50;  // légume secondaire 50g
        // Si pas de legume2 disponible : augmenter legume1 à 150g pour atteindre le minimum
        const qteLegsAjuste = (l, hasLegume2) => l === "avocat" ? 100 : (hasLegume2 ? 100 : 150);
        const ings = [
          {nom:viande.nom, qte_g:r5(qteViande)},
          ...(viande2 && qteViande2>0 ? [{nom:viande2.ciqual, qte_g:r5(qteViande2)}] : []),
          ...(oeufVegeQte>0 ? [{nom:"oeuf entier", qte_g:r5(oeufVegeQte)}] : []),
          ...(legumeA?[{nom:legumeA, qte_g:qteLegsAjuste(legumeA, !!legumeB)}]:[]),
          ...(legumeB?[{nom:legumeB, qte_g:qteLeg2(legumeB)}]:[]),
          ...(fromageSlot?[{nom:fromageSlot, qte_g:isOMAD?60:40}]:[]),
          ...proCompl.map(p=>({...p, qte_g:r5(p.qte_g)})),
          {nom:graisseCle, qte_g:r5(qteGraisse)},
        ];

        // Chercher une recette encodée (priorité) ou blog (max 1 par jour)
        let nomPlat, recetteUrl = "", recetteEncodee = null;

        // 1. Recettes encodées avec vrais ingrédients et macros fiables
        if(!recetteBlogAujourdHui) {
          const proteineNom = viande.nom;
          const encodees = RECETTES_ENCODEES.filter(r =>
            r.repas.some(rp => rp===slot) &&
            r.regime.includes(prefs.regime) &&
            r.ingredients.some(i => i.nom === proteineNom || proteineNom === "poulet" && i.nom === "poulet" || proteineNom === "boeuf" && i.nom === "boeuf" || proteineNom === "porc" && i.nom === "porc" || proteineNom === "canard" && i.nom === "canard" || proteineNom === "dinde" && i.nom === "dinde" || proteineNom === "veau" && i.nom === "veau")
          ).filter(r => !r.ingredients.some(i => estExclu(i.nom)))
           .filter(r => !(r.categorie==="pizza" && (compteurs.pizza||0) >= MAX_PIZZA))
           .filter(r => (compteurs.recettesBlog||0) < MAX_RECETTES_BLOG)
           .filter(r => !recetteEnCooldown(r.id));
          if(encodees.length > 0) {
            // Exclure recettes avec champignons si déjà utilisés aujourd'hui ou quota atteint
            const encodeesSansChamp = encodees.filter(r => {
              const aChamp = r.ingredients.some(i => i.nom === "champignons");
              if(!aChamp) return true;
              const champDejaJour = Object.values(repasJour).some(rj =>
                (rj.ingredients||[]).some(i => i.nom === "champignons")
              );
              return !champDejaJour && (compteurs["champignons"]||0) < MAX_SEMAINE;
            });
            const poolEncodees = encodeesSansChamp.length > 0 ? encodeesSansChamp : encodees.filter(r => !r.ingredients.some(i => i.nom === "champignons"));
            if(poolEncodees.length > 0) {
              const idx = recetteIdx["enc_"+proteineNom] || 0;
              recetteEncodee = poolEncodees[idx % poolEncodees.length];
              recetteIdx["enc_"+proteineNom] = idx + 1;
              nomPlat = recetteEncodee.titre;
              recetteUrl = recetteEncodee.url;
              recetteBlogAujourdHui = true;
              if(recetteEncodee.categorie==="pizza") compteurs.pizza = (compteurs.pizza||0) + 1;
              compteurs.recettesBlog = (compteurs.recettesBlog||0) + 1;
              // Incrémenter compteur champignons si la recette en contient
              if(recetteEncodee.ingredients.some(i => i.nom === "champignons")) {
                compteurs["champignons"] = (compteurs["champignons"]||0) + 1;
              }
            }
          }
        }

        // 2. Repas simple généré
        if(!nomPlat) {
          const nomLegume = {champignons:"aux champignons",courgette:"aux courgettes",epinards:"aux épinards",brocolis:"aux brocolis",poivron:"aux poivrons",aubergine:"aux aubergines",tomate:"aux tomates","chou fleur":"au chou-fleur","chou blanc":"au chou blanc","celeri":"au céleri","endive":"aux endives","fenouil":"au fenouil","avocat":"à l'avocat","concombre":"au concombre","salade":"en salade verte"}[legume]||"";
          const graisseTxt = {beurre:"au beurre","creme fraiche":"à la crème","huile olive":"à l'huile d'olive"}[graisseCle]||"";
          nomPlat = `${viande.label} ${nomLegume} ${graisseTxt}`.trim();
        }

        // Macros : recette encodée → macros réelles × nb parts ; sinon calcul ingrédients
        let macros;
        let ingredientsFinaux = ings;
        let omadComplement = "";
        if(recetteEncodee) {
          ingredientsFinaux = recetteEncodee.ingredients;
          const m = recetteEncodee.macros_portion;
          macros = {pro:Math.round(m.pro), lip:Math.round(m.lip), glu:Math.round(m.glu)};
          // OMAD : liste structurée de protéines complémentaires variées
          if(isOMAD) {
            const proManqueOMAD = proMinOMAD - macros.pro;
            if(proManqueOMAD > 10) {
              const oeufsOKOMAD = !oeufsExclus && !estExclu("oeuf entier");
              const laitiersOKOMAD = !aLactose && !lactoseExclus;
              // Protéine principale de la recette encodée — à ne pas doubler en complément
              const proteineRecette = recetteEncodee?.ingredients?.map(i => i.nom) || [];
              const sourcesOMAD = prefs.regime==="vegetarien"
                ? [...(oeufsOKOMAD?[{nom:"oeuf entier",pro:13,lip:11}]:[]), ...(laitiersOKOMAD?[{nom:"comte",pro:28,lip:30}]:[])]
                : [...(oeufsOKOMAD?[{nom:"oeuf entier",pro:13,lip:11}]:[]), {nom:"poulet",pro:25,lip:5}, ...(laitiersOKOMAD?[{nom:"emmental",pro:28,lip:30}]:[]), (prefs.regime!=="carnivore"?{nom:"jambon",pro:20,lip:4}:{nom:"saumon",pro:20,lip:13})]
                  // Exclure toute source déjà présente comme ingrédient principal de la recette
                  .filter(src => !proteineRecette.includes(src.nom));
              const nbSrcOMAD = Math.min(sourcesOMAD.length, proManqueOMAD > 40 ? 3 : 2);
              const proParSrcOMAD = proManqueOMAD / Math.max(1, nbSrcOMAD);
              let proReste = proManqueOMAD, lipCompl = 0;
              const lignesCompl = [];
              for(const src of sourcesOMAD.slice(0, nbSrcOMAD)) {
                if(proReste <= 3) break;
                const proACov = Math.min(proParSrcOMAD, proReste);
                const qte = src.nom==="oeuf entier"
                  ? Math.min(Math.ceil(proACov/src.pro*100/50)*50, 200) // MAX 4 oeufs (200g)
                  : Math.min(Math.round(proACov/src.pro*100/5)*5, 200);
                if(qte > 0) {
                  lignesCompl.push(src.nom==="oeuf entier" ? `${Math.round(qte/50)} oeuf${qte/50>1?"s":""}` : `${qte}g ${src.nom}`);
                  lipCompl += src.lip * qte / 100;
                  proReste -= src.pro * qte / 100;
                }
              }
              macros = {pro:Math.round(macros.pro+proManqueOMAD), lip:Math.round(macros.lip+lipCompl), glu:Math.round(macros.glu)};
              omadComplement = lignesCompl.length > 0 ? "A completer : " + lignesCompl.join(" + ") : "";
            }
          }
        } else {
          macros = calcMacros(ings);
        }
        totalPro+=macros.pro; totalLip+=macros.lip; totalGlu+=macros.glu;

        // Construire la note affichée pour les recettes encodées
        let descSlot = "";
        if(recetteEncodee) {
          const parParRepas2 = recetteEncodee.parts_par_repas || 1;
          const totalParts = recetteEncodee.portions;

          // Partie "X part(s) sur Y" dynamique
          let partieParts = "";
          if(totalParts > 1) {
            partieParts = parParRepas2 > 1
              ? `${parParRepas2} parts sur ${totalParts}`
              : `1 part sur ${totalParts}`;
          } else {
            partieParts = "1 portion entière";
          }

          // Partie accompagnement protéiné : remplacer les vagues "2 œufs, jambon ou fromage" par des quantités précises
          const noteSource = recetteEncodee.note || "";
          // Extraire la partie accompagnement si présente
          const matchAccomp = noteSource.match(/(?:déguster avec|compléter avec|accompagner de)\s*:?\s*(.+)/i);
          let partieAccomp = "";
          if(matchAccomp) {
            let accoStr = filtrerAccomp(matchAccomp[1]);
            accoStr = accoStr
              .replace(/\b2\s*[oœ]ufs?\b/gi, "2 œufs (100g)")
              .replace(/\bjambon\b(?!\s*cru)/gi, "jambon (60g)")
              .replace(/\bjambon cru\b/gi, "jambon cru (40g)")
              .replace(/\bsaumon fumé\b/gi, "saumon fumé (60g)")
              .replace(/\bfromage au choix\b/gi, "fromage au choix (40g)")
              .replace(/\bfromage\b(?!\s*au\s*choix)/gi, "fromage (40g)")
              .replace(/\bcafé ou thé\b/gi, "café ou thé")
              .replace(/\s*ou\s*$/, "").replace(/^ou\s*/, "").trim();
            if(accoStr) partieAccomp = accoStr;
          }

          // Conserver les notes spéciales (glucides élevés, sans lactose, etc.) — filtrées
          const noteSpecialeRaw = noteSource.match(/^([^·]+)$/) && !matchAccomp ? noteSource.trim() : "";
          const noteSpeciale = filtrerAccomp(noteSpecialeRaw);

          // Assembler
          const parties = [partieParts, partieAccomp ? `ACCOMP:${partieAccomp}` : "", noteSpeciale, omadComplement].filter(Boolean);
          descSlot = parties.join(" · ");
        } else {
          descSlot = omadComplement;
        }
        repasJour[slot] = {nom:nomPlat, ingredients:ingredientsFinaux, macros, description:descSlot, recette_url:recetteUrl, encodee:!!recetteEncodee};
      });

      // Dessert le dimanche pour omni et végé
      if(nomJour==="Dimanche" && ["omnivore","vegetarien"].includes(prefs.regime)) {
        const desserts = RECETTES_ENCODEES.filter(r =>
          r.categorie==="dessert" &&
          r.regime.includes(prefs.regime) &&
          !r.ingredients.some(i => estExclu(i.nom)) &&
          !(aLactose && r.ingredients.some(i => ["mascarpone","creme fraiche","beurre","comte","emmental","chevre frais"].includes(i.nom)))
        );
        if(desserts.length > 0) {
          const dessert = desserts[Math.floor(Math.random() * desserts.length)];
          const m = dessert.macros_portion;
          const macrosDessert = {pro:Math.round(m.pro), lip:Math.round(m.lip), glu:Math.round(m.glu)};
          totalPro = Math.min(totalPro + macrosDessert.pro, Math.round(proJourFinal * 1.10));
          totalLip+=macrosDessert.lip; totalGlu+=macrosDessert.glu;
          const parsDessert = dessert.portions > 1 ? `1 part sur ${dessert.portions}` : "1 portion entière";
          const noteSpecDessert = dessert.note && !dessert.note.match(/part\s*:/i) ? dessert.note : "";
          const descDessert = [parsDessert, noteSpecDessert].filter(Boolean).join(" · ");
          repasJour.dessert = {
            nom: dessert.titre,
            ingredients: dessert.ingredients,
            macros: macrosDessert,
            description: descDessert,
            recette_url: dessert.url,
            encodee: true,
          };
        }
      }

      const jourData = {jour:nomJour, repas:repasJour, total_jour:{pro:totalPro,lip:totalLip,glu:totalGlu}};
      joursConstruit.push(jourData);
      return jourData;
    });

    // ── 5. Liste de courses ──────────────────────────────────────────────────
    const courses = {};
    jours.forEach(jour => Object.values(jour.repas||{}).forEach(repas => {
      (repas.ingredients||[]).forEach(ing => {
        // Carnivore : garder UNIQUEMENT produits animaux
        const PRODUITS_ANIMAUX = ["poulet","saumon","thon","sardine","crevettes","cabillaud","boeuf","agneau","porc","lard","bacon","jambon","jambon cru","canard","chorizo","saucisse","dinde","truite","saumon fume","veau","oeuf entier","comte","emmental","chevre frais","parmesan","mozzarella","feta","camembert","creme fraiche","beurre","ghee","cheddar","mascarpone","fromage blanc","champignons"];
        if(prefs.regime==="carnivore" && !PRODUITS_ANIMAUX.includes(ing.nom)) return;
        const cat = ["poulet","saumon","thon","sardine","crevettes","cabillaud","boeuf","agneau","porc","lard","bacon","jambon","jambon cru","canard","chorizo","saucisse","dinde","truite","saumon fume","veau"].includes(ing.nom)?"Viandes & Poissons"
          :["oeuf entier"].includes(ing.nom)?"Oeufs & Laitiers"
          :["comte","emmental","chevre frais","parmesan","mozzarella","feta","camembert","creme fraiche","beurre","ghee","cheddar","mascarpone","fromage blanc"].includes(ing.nom)?"Oeufs & Laitiers"
          :["huile olive","mayonnaise","noix","amandes","poudre amande","farine amande","graines lin","graines chia","graines sesame","graines tournesol","graines courge","puree amande","noix cajou","huile sesame","huile coco"].includes(ing.nom)?"Oléagineux & Graisses"
          :["epinards","courgette","brocolis","salade","champignons","poivron","aubergine","concombre","tomate","tomate concassee","oignon"].includes(ing.nom)?"Légumes"
          :["chocolat 85","chocolat 90","cacao poudre","erythritol","allulose","psyllium","gelatine","whey vanille","whey nature","isolate whey","blanc oeuf poudre","farine coco","creme coco"].includes(ing.nom)?"Pâtisserie & Douceurs"
          :"Divers";
        if(!courses[cat]) courses[cat]={};
        courses[cat][ing.nom]=(courses[cat][ing.nom]||0)+ing.qte_g;
      });
    }));
    const listeCourses={};
    Object.entries(courses).forEach(([cat,items])=>{
      listeCourses[cat]=Object.entries(items).map(([nom,qte])=>
        nom==="oeuf entier"?`${Math.round(qte/50)} œufs`:`${Math.round(qte/100)*100 || 100}g ${nom}`
      );
    });

    const newHisto = {...histoRecettes};
    jours.forEach(jour => { Object.values(jour.repas||{}).forEach(repas => { if(repas?.encodee && repas?.nom) { const r = RECETTES_ENCODEES.find(x => x.titre === repas.nom); if(r?.id) newHisto[r.id] = genCount; } }); });
    try { localStorage.setItem("cetoclub_recettes_histo", JSON.stringify(newHisto)); } catch {}
    try { localStorage.setItem("cetoclub_gen_count", String(genCount + 1)); } catch {}
    setPlan({jours, liste_courses:listeCourses, _ts:Date.now()});
    setTab(0);
    }catch(e){
      console.error("Erreur génération:",e);
      setError(`Erreur : ${e.message}`);
    }finally{
      setLoading(false);
    }
  };
  return(
    <div style={{minHeight:"100vh",background:CN.cream,fontFamily:"'Nunito',sans-serif",color:"#1a2a1a"}}>
      {/* Header */}
      <div style={{background:`linear-gradient(135deg,${CN.navy},${CN.navyLight})`,padding:"16px 16px 22px",color:"#fff"}}>
        <div style={{maxWidth:800,margin:"0 auto"}}>
          <div style={{display:"flex",gap:8,marginBottom:8}}>
            <span style={{background:"rgba(255,255,255,.15)",borderRadius:6,padding:"3px 9px",fontSize:9,fontWeight:800}}>✨ PREMIUM</span>
          </div>
          <h1 style={{fontSize:24,fontWeight:900,margin:"0 0 4px"}}>Tes 7 menus sur mesure</h1>
          <p style={{fontSize:12,opacity:.8,margin:0}}>Céto personnalisé · Macros CIQUAL · Liste de courses</p>
        </div>
      </div>
      <div style={{maxWidth:800,margin:"0 auto",padding:"18px 12px"}}>
        {/* Formulaire */}
        {!plan&&!loading&&(
          <div>
            {prefs.regime==="vegetarien"&&<div style={{background:"#F3E5F5",border:"2px solid #CE93D830",borderRadius:12,padding:14,marginBottom:12,lineHeight:1.7}}>
              <div style={{fontSize:12,fontWeight:900,color:"#6A1B9A",marginBottom:4}}>🌿 Protéines végétales</div>
              <div style={{fontSize:11,color:"#7B1FA2",fontWeight:700}}>Les protéines végétales s'assimilent moins facilement. Si tu sens fatigue, fringales ou fragilité (cheveux, ongles, peau), pense à augmenter les œufs ou les fromages dans tes repas.</div>
            </div>}
            <div style={{background:CN.greenPale,border:`2px solid ${CN.green}30`,borderRadius:12,padding:14,marginBottom:16,lineHeight:1.7}}>
              <div style={{fontSize:12,fontWeight:900,color:"#2E7D32",marginBottom:4}}>🌿 Les macros sont un cadre, pas une loi.</div>
              <div style={{fontSize:11,color:"#388E3C",fontWeight:700}}>Ce qui compte d'abord, c'est ce que ton corps te dit. Suis-le, c'est ton meilleur guide, en temps réel !</div>
              {macrosProfil.lip===150&&macrosProfil.pro===80&&<div style={{fontSize:10,color:"#E65100",marginTop:8,fontWeight:700}}>⚠️ Profil non renseigné, macros par défaut utilisées. Crée ton profil pour un plan personnalisé.</div>}
            </div>
            {/* Régime alimentaire */}
            <div style={{background:CN.white,borderRadius:14,border:`2px solid ${CN.navy}20`,padding:18,marginBottom:14}}>
              <div style={{fontSize:13,fontWeight:900,color:CN.navy,marginBottom:4}}>🥩 Régime alimentaire</div>
              <div style={{fontSize:10,color:CN.gray,marginBottom:12}}>Définit la philosophie de ton plan</div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {REGIMES_7J.map(r=>(
                  <button key={r.id} onClick={()=>setPrefs(p=>({...p,regime:r.id,aime:[],intol:[]}))} style={{padding:"12px 14px",borderRadius:10,fontSize:12,fontWeight:800,cursor:"pointer",textAlign:"left",background:prefs.regime===r.id?`linear-gradient(135deg,${CN.navy},${CN.navyLight})`:CN.grayLight,color:prefs.regime===r.id?"#fff":"#374151",border:`2px solid ${prefs.regime===r.id?CN.navy:"#E5E7EB"}`}}>
                    <div>{r.l}</div>
                    <div style={{fontSize:9,opacity:.75,marginTop:2,fontWeight:600}}>{r.desc}</div>
                  </button>
                ))}
              </div>
            </div>
            {/* Nombre de repas */}
            <div style={{background:CN.white,borderRadius:14,border:`2px solid ${CN.navyLight}20`,padding:18,marginBottom:14}}>
              <div style={{fontSize:13,fontWeight:900,color:CN.navyLight,marginBottom:4}}>🍽️ Nombre de repas par jour</div>
              <div style={{fontSize:10,color:CN.gray,marginBottom:12}}>Écoute ta faim, arrête quand tu n'as plus faim !</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
                {NB_REPAS_7J.map(opt=>(<button key={opt.id} onClick={()=>setPrefs(p=>({...p,nbRepas:opt.id}))} style={{padding:"12px 8px",borderRadius:10,fontSize:11,fontWeight:800,cursor:"pointer",textAlign:"center",background:prefs.nbRepas===opt.id?`linear-gradient(135deg,${CN.navy},${CN.navyLight})`:CN.grayLight,color:prefs.nbRepas===opt.id?"#fff":"#374151",border:`2px solid ${prefs.nbRepas===opt.id?CN.navy:"#E5E7EB"}`}}><div>{opt.l}</div><div style={{fontSize:9,opacity:.7,marginTop:2}}>{opt.desc}</div></button>))}
              </div>
              {prefs.nbRepas===2&&(
                <div style={{marginTop:10,display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8}}>
                  {[{id:"matin-midi",l:"☀️ Matin + Midi"},{id:"midi-soir",l:"🌙 Midi + Soir"}].map(opt=>(
                    <button key={opt.id} onClick={()=>setPrefs(p=>({...p,repas2:opt.id}))} style={{padding:"10px",borderRadius:10,fontSize:12,fontWeight:800,cursor:"pointer",textAlign:"center",background:prefs.repas2===opt.id?`linear-gradient(135deg,${CN.orange},#E65100)`:CN.grayLight,color:prefs.repas2===opt.id?"#fff":"#374151",border:`2px solid ${prefs.repas2===opt.id?CN.orange:"#E5E7EB"}`}}>{opt.l}</button>
                  ))}
                </div>
              )}
            </div>
            {/* Aliments appréciés */}
            <div style={{background:CN.white,borderRadius:14,border:`2px solid ${CN.navy}10`,padding:18,marginBottom:14}}>
              <div style={{fontSize:13,fontWeight:900,color:CN.navy,marginBottom:2}}>🥩 Aliments appréciés</div>
              <div style={{fontSize:10,color:CN.gray,marginBottom:12}}>L'IA les privilégiera dans ton plan</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {(GOUTS_7J[prefs.regime]||GOUTS_7J.omnivore).map(item=>{const sel=prefs.aime.includes(item);return(<button key={item} onClick={()=>toggle("aime",item)} style={{padding:"7px 14px",borderRadius:20,fontSize:11,fontWeight:800,cursor:"pointer",background:sel?CN.navy:CN.grayLight,color:sel?"#fff":"#374151",border:`2px solid ${sel?CN.navy:"#E5E7EB"}`}}>{sel?"✓ ":""}{item}</button>);})}
              </div>
            </div>
            {/* Intolérances */}
            <div style={{background:CN.white,borderRadius:14,border:`2px solid ${CN.red}20`,padding:18,marginBottom:14}}>
              <div style={{fontSize:13,fontWeight:900,color:CN.red,marginBottom:2}}>🚫 Intolérances / exclusions</div>
              <div style={{fontSize:10,color:CN.gray,marginBottom:12}}>Ces aliments seront évités</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:14}}>
                {(INTOLS_7J[prefs.regime]||INTOLS_7J.omnivore).map(item=>{const sel=prefs.intol.includes(item);return(<button key={item} onClick={()=>toggle("intol",item)} style={{padding:"7px 14px",borderRadius:20,fontSize:11,fontWeight:800,cursor:"pointer",background:sel?CN.red:CN.grayLight,color:sel?"#fff":"#374151",border:`2px solid ${sel?CN.red:"#E5E7EB"}`}}>{sel?"✗ ":""}{item}</button>);})}
              </div>
              <div style={{borderTop:`1px solid ${CN.grayLight}`,paddingTop:12}}>
                <div style={{fontSize:11,fontWeight:800,color:"#374151",marginBottom:6}}>✏️ Autres exclusions personnalisées</div>
                <div style={{fontSize:10,color:CN.gray,marginBottom:8}}>Ex : épinards, courgettes, champignons, avocat, noix…</div>
                <textarea
                  value={prefs.exclusionsLibres}
                  onChange={e=>setPrefs(p=>({...p,exclusionsLibres:e.target.value}))}
                  placeholder="Tape ici les aliments ou substances à éviter, séparés par des virgules…"
                  style={{width:"100%",minHeight:70,borderRadius:10,border:`2px solid ${CN.grayLight}`,padding:"10px 12px",fontSize:11,fontFamily:"'Nunito',sans-serif",color:"#374151",resize:"vertical",outline:"none",boxSizing:"border-box",lineHeight:1.6}}
                />
                {prefs.exclusionsLibres.trim()&&(
                  <div style={{marginTop:8,display:"flex",flexWrap:"wrap",gap:6}}>
                    {prefs.exclusionsLibres.split(",").map(e=>e.trim()).filter(Boolean).map((e,i)=>(
                      <span key={i} style={{background:"#FFEBEE",color:CN.red,borderRadius:20,padding:"4px 10px",fontSize:10,fontWeight:800}}>✗ {e}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {/* Style */}
            <div style={{background:CN.white,borderRadius:14,border:`2px solid ${CN.orange}20`,padding:18,marginBottom:24}}>
              <div style={{fontSize:13,fontWeight:900,color:"#E65100",marginBottom:12}}>🍽️ Style de cuisine</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8}}>
                {STYLES_7J.map(s=>(<button key={s.id} onClick={()=>setPrefs(p=>({...p,style:s.id}))} style={{padding:"12px",borderRadius:10,fontSize:12,fontWeight:800,cursor:"pointer",textAlign:"left",background:prefs.style===s.id?"linear-gradient(135deg,#F4A035,#E65100)":CN.grayLight,color:prefs.style===s.id?"#fff":"#374151",border:`2px solid ${prefs.style===s.id?CN.orange:"#E5E7EB"}`}}>{s.l}</button>))}
              </div>
            </div>
            <button onClick={generer} style={{width:"100%",padding:"18px",borderRadius:14,background:`linear-gradient(135deg,${CN.navy},${CN.navyLight})`,color:"#fff",border:"none",fontWeight:900,fontSize:16,cursor:"pointer",boxShadow:"0 6px 28px rgba(27,58,107,.32)"}}>
              🗓️ Génère le plan de 7 jours
            </button>
            <div style={{textAlign:"center",fontSize:10,color:"#9ca3af",marginTop:8}}>Génération en 15–30 secondes · Personnalisé selon ton profil</div>
          </div>
        )}
        {/* Chargement */}
        {loading&&(
          <div style={{textAlign:"center",padding:"40px 20px"}}>
            <div style={{marginBottom:18,display:"flex",justifyContent:"center"}}>
              <svg width="160" height="160" viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
                {/* Ombre */}
                <ellipse cx="80" cy="148" rx="52" ry="7" fill="#00000015"/>
                {/* Assiette fond */}
                <circle cx="80" cy="82" r="62" fill="#F5F0E8"/>
                {/* Bord assiette */}
                <circle cx="80" cy="82" r="62" fill="none" stroke="#E8DCC8" strokeWidth="6"/>
                {/* Zone intérieure */}
                <circle cx="80" cy="82" r="50" fill="#FDFAF4"/>
                <circle cx="80" cy="82" r="50" fill="none" stroke="#E8DCC8" strokeWidth="1.5"/>
                {/* Salade verte */}
                <ellipse cx="68" cy="90" rx="22" ry="14" fill="#7CB342" opacity=".9"/>
                <ellipse cx="72" cy="86" rx="18" ry="11" fill="#8BC34A" opacity=".85"/>
                <ellipse cx="64" cy="88" rx="12" ry="8" fill="#9CCC65" opacity=".8"/>
                {/* Viande / poulet */}
                <ellipse cx="94" cy="78" rx="19" ry="14" fill="#D4874A"/>
                <ellipse cx="94" cy="77" rx="16" ry="11" fill="#E8A060"/>
                <ellipse cx="94" cy="76" rx="10" ry="7" fill="#F0B070" opacity=".7"/>
                {/* Oeuf au plat */}
                <ellipse cx="72" cy="68" rx="12" ry="9" fill="#FFF9E6"/>
                <circle cx="72" cy="68" r="5" fill="#F4C430"/>
                <circle cx="73" cy="67" r="1.5" fill="#FFE57F" opacity=".7"/>
                {/* Avocat tranches */}
                <ellipse cx="58" cy="78" rx="9" ry="13" fill="#558B2F" transform="rotate(-15 58 78)"/>
                <ellipse cx="58" cy="78" rx="6" ry="9" fill="#7CB342" transform="rotate(-15 58 78)"/>
                <ellipse cx="58" cy="78" rx="3" ry="5" fill="#A5D6A7" transform="rotate(-15 58 78)"/>
                {/* Noix */}
                <ellipse cx="100" cy="92" rx="7" ry="5" fill="#A0785A" transform="rotate(20 100 92)"/>
                <ellipse cx="100" cy="92" rx="5" ry="3.5" fill="#C49A6C" transform="rotate(20 100 92)"/>
                {/* Fourchette */}
                <rect x="20" y="55" width="3" height="32" rx="1.5" fill="#C0B090"/>
                <rect x="19" y="48" width="1.5" height="12" rx=".75" fill="#C0B090"/>
                <rect x="22" y="48" width="1.5" height="12" rx=".75" fill="#C0B090"/>
                <rect x="25" y="48" width="1.5" height="12" rx=".75" fill="#C0B090"/>
                {/* Couteau */}
                <rect x="134" y="48" width="3" height="38" rx="1.5" fill="#C0B090"/>
                <path d="M134 48 Q130 56 134 64" fill="#D4C8A8" stroke="none"/>
              </svg>
            </div>
            <div style={{fontSize:20,fontWeight:900,color:CN.navy,marginBottom:10}}>Ton plan céto arrive…</div>
            <div style={{fontSize:12,color:CN.gray,lineHeight:1.8,maxWidth:340,margin:"0 auto"}}>Les macros sont un cadre, pas une loi. Ce qui compte d'abord, c'est ce que ton corps te dit. Suis-le, c'est ton meilleur guide, en temps réel !</div>
          </div>
        )}
        {/* Menu sauvegardé — affiché si pas de plan en cours */}
        {menuSauve && !plan && !loading && (
          <div style={{background:"#FFF8F0",border:"2px solid #F4A035",borderRadius:14,padding:16,marginBottom:14}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
              <span style={{fontSize:22}}>📋</span>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:900,color:"#E65100"}}>Ton menu de la semaine</div>
                <div style={{fontSize:10,color:"#6B7280"}}>Enregistré · expire dans {joursRestants} jour{joursRestants>1?"s":""}</div>
              </div>
              <button onClick={supprimerMenu} style={{background:"none",border:"1px solid #F4A03560",borderRadius:8,padding:"4px 10px",fontSize:10,color:"#E65100",cursor:"pointer",fontWeight:700}}>✕</button>
            </div>
            {/* Onglets jours du menu sauvé */}
            <div style={{display:"flex",gap:5,overflowX:"auto",paddingBottom:8,marginBottom:12}}>
              {menuSauve.jours?.map((j,i)=>(<button key={i} onClick={()=>setTab(i)} style={{flexShrink:0,padding:"7px 12px",borderRadius:10,fontSize:11,fontWeight:800,cursor:"pointer",background:tab===i?"#F4A035":"#fff",color:tab===i?"#fff":"#6B7280",border:`2px solid ${tab===i?"#F4A035":"#E5E7EB"}`}}>{j.jour}</button>))}
              <button onClick={()=>setTab(7)} style={{flexShrink:0,padding:"7px 12px",borderRadius:10,fontSize:11,fontWeight:800,cursor:"pointer",background:tab===7?"#E65100":"#fff",color:tab===7?"#fff":"#6B7280",border:`2px solid ${tab===7?"#E65100":"#E5E7EB"}`}}>🛒 Courses</button>
            </div>
            {tab<7&&menuSauve.jours?.[tab]&&(()=>{const jour=menuSauve.jours[tab];const RCFG=[{key:"petit_dejeuner",icon:"☀️",label:"Petit-déjeuner",c:"#F4A035",bg:"#FFF8F0"},{key:"dejeuner",icon:"🍽️",label:"Déjeuner",c:"#7CB342",bg:"#F1F8E9"},{key:"diner",icon:"🌙",label:"Dîner",c:"#1B3A6B",bg:"#F0F4FF"}];return(<div>{RCFG.map(cfg=><CarteRepas7J key={cfg.key} repas={jour.repas?.[cfg.key]} icon={cfg.icon} label={cfg.label} c={cfg.c} bg={cfg.bg}/>)}</div>);})()}
            {tab===7&&menuSauve.liste_courses&&(
              <div style={{fontSize:12,color:"#374151",lineHeight:1.8,whiteSpace:"pre-wrap"}}>{menuSauve.liste_courses}</div>
            )}
          </div>
        )}

        {/* Erreur */}
        {error&&!loading&&(
          <div style={{background:"#FFEBEE",border:`2px solid ${CN.red}`,borderRadius:14,padding:20,textAlign:"center",marginBottom:16}}>
            <div style={{fontSize:28,marginBottom:10}}>❌</div>
            <div style={{fontWeight:900,color:CN.red,marginBottom:12}}>{error}</div>
            <button onClick={()=>setError(null)} style={{padding:"10px 24px",borderRadius:10,background:CN.red,color:"#fff",border:"none",fontWeight:800,cursor:"pointer"}}>Réessayer</button>
          </div>
        )}
        {/* Résultat */}
        {plan&&!loading&&(
          <div>
            {/* Bandeau plan généré + actions */}
            <div style={{background:"linear-gradient(135deg,#7CB342,#558B2F)",borderRadius:14,padding:"14px 16px",marginBottom:14,color:"#fff"}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
                <div style={{fontSize:28}}>🎉</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:15,fontWeight:900}}>Plan généré avec succès !</div>
                  <div style={{fontSize:10,opacity:.85}}>7 jours · {prefs.nbRepas} repas/jour · Macros personnalisées</div>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                {!menuSauve ? (
                  <button onClick={sauvegarderMenu}
                    style={{padding:"10px 8px",borderRadius:10,background:"rgba(255,255,255,.95)",
                      color:"#558B2F",border:"none",fontWeight:900,fontSize:12,cursor:"pointer",
                      fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:5}}>
                    💾 Enregistrer ce plan
                  </button>
                ) : (
                  <div style={{padding:"10px 8px",borderRadius:10,background:"rgba(255,255,255,.2)",
                    display:"flex",alignItems:"center",justifyContent:"center",gap:5,fontSize:11,fontWeight:800}}>
                    ✅ Enregistré ({joursRestants}j)
                  </div>
                )}
                <button onClick={()=>{setPlan(null);setTab(0);}}
                  style={{padding:"10px 8px",borderRadius:10,background:"rgba(0,0,0,.2)",
                    color:"#fff",border:"none",fontWeight:800,fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>
                  ↺ En générer un autre
                </button>
              </div>
            </div>
            {/* Onglets jours — onglet Sauvegardé en premier si menuSauve */}
            <div style={{display:"flex",gap:5,overflowX:"auto",paddingBottom:8,marginBottom:16}}>
              {menuSauve && <button onClick={()=>setTab(8)} style={{flexShrink:0,padding:"8px 14px",borderRadius:10,fontSize:11,fontWeight:800,cursor:"pointer",background:tab===8?"#F4A035":CN.white,color:tab===8?"#fff":"#E65100",border:`2px solid ${tab===8?"#F4A035":"#F4A03560"}`}}>📋 Sauvegardé</button>}
              {plan.jours?.map((j,i)=>(<button key={i} onClick={()=>setTab(i)} style={{flexShrink:0,padding:"8px 14px",borderRadius:10,fontSize:11,fontWeight:800,cursor:"pointer",background:tab===i?CN.navy:CN.white,color:tab===i?"#fff":CN.gray,border:`2px solid ${tab===i?CN.navy:"#E5E7EB"}`}}>{j.jour}</button>))}
              <button onClick={()=>setTab(7)} style={{flexShrink:0,padding:"8px 14px",borderRadius:10,fontSize:11,fontWeight:800,cursor:"pointer",background:tab===7?CN.orange:CN.white,color:tab===7?"#fff":CN.gray,border:`2px solid ${tab===7?CN.orange:"#E5E7EB"}`}}>🛒 Courses</button>
            </div>
            {/* Onglet menu sauvegardé */}
            {tab===8&&menuSauve&&(
              <div>
                <div style={{background:"#FFF8F0",border:"2px solid #F4A035",borderRadius:12,padding:"10px 14px",marginBottom:12,display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:16}}>📋</span>
                  <div style={{flex:1,fontSize:11,color:"#E65100",fontWeight:800}}>Menu enregistré · encore {joursRestants} jour{joursRestants>1?"s":""}</div>
                  <button onClick={supprimerMenu} style={{background:"none",border:"1px solid #F4A03560",borderRadius:7,padding:"3px 9px",fontSize:10,color:"#E65100",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>✕ Supprimer</button>
                </div>
                <div style={{display:"flex",gap:5,overflowX:"auto",paddingBottom:8,marginBottom:12}}>
                  {menuSauve.jours?.map((j,i)=>(<button key={i} onClick={()=>setTab(80+i)} style={{flexShrink:0,padding:"7px 12px",borderRadius:10,fontSize:11,fontWeight:800,cursor:"pointer",background:tab===80+i?"#F4A035":CN.white,color:tab===80+i?"#fff":"#E65100",border:`2px solid ${tab===80+i?"#F4A035":"#F4A03560"}`}}>{j.jour}</button>))}
                  <button onClick={()=>setTab(87)} style={{flexShrink:0,padding:"7px 12px",borderRadius:10,fontSize:11,fontWeight:800,cursor:"pointer",background:tab===87?"#E65100":CN.white,color:tab===87?"#fff":"#E65100",border:`2px solid ${tab===87?"#E65100":"#F4A03560"}`}}>🛒 Courses</button>
                </div>
                {tab>=80&&tab<87&&menuSauve.jours?.[tab-80]&&(()=>{const j=menuSauve.jours[tab-80];return(<div>{["petit_dejeuner","dejeuner","diner"].map(k=>{const cfg={petit_dejeuner:{icon:"☀️",label:"Petit-déjeuner",c:"#F4A035",bg:"#FFF8F0"},dejeuner:{icon:"🍽️",label:"Déjeuner",c:"#7CB342",bg:"#F1F8E9"},diner:{icon:"🌙",label:"Dîner",c:"#1B3A6B",bg:"#F0F4FF"}}[k];return cfg?<CarteRepas7J key={k} repas={j.repas?.[k]} icon={cfg.icon} label={cfg.label} c={cfg.c} bg={cfg.bg}/>:null;})}</div>);})()}
                {tab===87&&menuSauve.liste_courses&&(
                  <div style={{fontSize:12,color:"#374151",lineHeight:1.8}}>
                    {Object.entries(menuSauve.liste_courses).map(([cat,items])=>(<div key={cat} style={{background:CN.white,borderRadius:12,border:`2px solid ${CN.navy}10`,padding:14,marginBottom:10}}><div style={{fontSize:12,fontWeight:900,color:CN.navy,marginBottom:8}}>{cat}</div><div style={{display:"flex",flexWrap:"wrap",gap:6}}>{(Array.isArray(items)?items:[]).map((item,i)=>(<div key={i} style={{background:CN.grayLight,borderRadius:20,padding:"4px 12px",fontSize:11,fontWeight:700,color:"#374151"}}>• {item}</div>))}</div></div>))}
                  </div>
                )}
              </div>
            )}
            {/* Jour */}
            {tab<7&&plan.jours?.[tab]&&(()=>{const jour=plan.jours[tab];return(
              <div>
                {REPAS_CFG.filter(cfg=>{const nb=prefs.nbRepas||3;const r2=prefs.repas2||"midi-soir";if(nb===1)return cfg.key==="dejeuner";if(nb===2)return r2==="matin-midi"?cfg.key!=="diner":cfg.key!=="petit_dejeuner";return true;}).map(cfg=><CarteRepas7J key={cfg.key} repas={jour.repas?.[cfg.key]} icon={cfg.icon} label={cfg.label} c={cfg.c} bg={cfg.bg}/>)}
                {jour.total_jour&&(
                  <div style={{background:`linear-gradient(135deg,${CN.navy},${CN.navyLight})`,borderRadius:14,padding:16,color:"#fff",marginBottom:8}}>
                    <div style={{fontSize:10,fontWeight:900,opacity:.8,letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>📊 Total {jour.jour}</div>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
                      {[{l:"Lipides",v:jour.total_jour.lip,u:"g",c:"#F4A035"},{l:"Glucides",v:jour.total_jour.glu,u:"g",c:"#f87171"},{l:"Protéines",v:jour.total_jour.pro,u:"g",c:"#86efac"}].map(m=>(
                        <div key={m.l} style={{textAlign:"center",background:"rgba(255,255,255,.1)",borderRadius:8,padding:"9px 4px"}}>
                          <div style={{fontSize:19,fontWeight:900,color:m.c}}>{m.v}<span style={{fontSize:9,opacity:.8}}>{m.u}</span></div>
                          <div style={{fontSize:9,opacity:.7,marginTop:2}}>{m.l}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );})()}
            {/* Liste de courses */}
            {tab===7&&plan.liste_courses&&(
              <div>
                <div style={{background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:14,padding:"14px 20px",marginBottom:16,color:"#fff"}}>
                  <div style={{fontSize:17,fontWeight:900}}>🛒 Liste de courses</div>
                  <div style={{fontSize:11,opacity:.9}}>Pour 7 jours de plan céto complet</div>
                </div>
                {Object.entries(plan.liste_courses).map(([cat,items])=>(
                  <div key={cat} style={{background:CN.white,borderRadius:12,border:`2px solid ${CN.navy}10`,padding:16,marginBottom:10}}>
                    <div style={{fontSize:12,fontWeight:900,color:CN.navy,marginBottom:10,paddingBottom:8,borderBottom:`1px solid ${CN.grayLight}`}}>{cat}</div>
                    <div style={{display:"flex",flexWrap:"wrap",gap:7}}>
                      {(Array.isArray(items)?items:[]).map((item,i)=>(<div key={i} style={{background:CN.grayLight,borderRadius:20,padding:"5px 13px",fontSize:11,fontWeight:700,color:"#374151"}}>• {item}</div>))}
                    </div>
                  </div>
                ))}
                <div style={{background:CN.greenPale,border:`2px solid #7CB34230`,borderRadius:12,padding:14,marginTop:4}}>
                  <div style={{fontSize:11,color:"#2E7D32",lineHeight:1.8}}>💡 <strong>Conseils céto :</strong> Privilégie les produits frais · Lis les étiquettes · Beurre AOP · Huile d'olive vierge extra</div>
                </div>
                {/* Bouton sauvegarder le menu */}
                <div style={{marginTop:14}}>
                  {!menuSauve ? (
                    <button onClick={sauvegarderMenu}
                      style={{width:"100%",padding:"14px 20px",borderRadius:12,
                        background:"linear-gradient(135deg,#F4A035,#E65100)",color:"#fff",border:"none",
                        fontWeight:900,fontSize:14,cursor:"pointer",fontFamily:"inherit",
                        display:"flex",alignItems:"center",justifyContent:"center",gap:8,
                        boxShadow:"0 4px 14px rgba(244,160,53,.35)"}}>
                      💾 Garder ce menu 8 jours
                    </button>
                  ) : (
                    <div style={{background:"#FFF8F0",border:"2px solid #F4A035",borderRadius:12,padding:"12px 16px",display:"flex",alignItems:"center",gap:10}}>
                      <span style={{fontSize:20}}>✅</span>
                      <div style={{flex:1}}>
                        <div style={{fontSize:12,fontWeight:900,color:"#E65100"}}>Menu enregistré</div>
                        <div style={{fontSize:10,color:"#6B7280"}}>Encore {joursRestants} jour{joursRestants>1?"s":""} · tu peux quitter l'app</div>
                      </div>
                      <button onClick={supprimerMenu} style={{background:"none",border:"1px solid #F4A03560",borderRadius:8,padding:"5px 10px",fontSize:11,color:"#E65100",cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>✕ Supprimer</button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}


// ─── MODULE SCANNER ──────────────────────────────────────────────────────────
// ─── MODULE SCANNER ──────────────────────────────────────────────────────────
function ModuleScanner({setPage}) {
  const [scanState, setScanState] = React.useState("idle");
  const [verdict, setVerdict] = React.useState(null);
  const [ajoutConfirm, setAjoutConfirm] = React.useState(false);
  const [retryCount, setRetryCount] = React.useState(0);
  const fileInputRef = React.useRef(null);
  const cameraInputRef = React.useRef(null);
  const zxingPromiseRef = React.useRef(null);

  // ── Chargement html5-qrcode (remplace ZXing, gère mieux la caméra mobile) ─
  const loadHtml5Qrcode = React.useCallback(async () => {
    if(window.Html5Qrcode) return window.Html5Qrcode;
    if(zxingPromiseRef.current) return zxingPromiseRef.current;
    zxingPromiseRef.current = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://unpkg.com/html5-qrcode@2.3.8/html5-qrcode.min.js";
      s.async = true;
      s.onload = () => resolve(window.Html5Qrcode);
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return zxingPromiseRef.current;
  }, []);

  // ── Analyser si céto ──────────────────────────────────────────────────────
  const analyserProduit = (p) => {
    const nom = (p.product_name_fr || p.product_name || "Produit inconnu").trim();
    const marque = (p.brands || "").trim();
    const nutriments = p.nutriments || {};
    const gluRaw = nutriments["carbohydrates_100g"];
    const glu = gluRaw != null ? parseFloat(gluRaw) : null;
    const lip = parseFloat(nutriments["fat_100g"]) || 0;
    const pro = parseFloat(nutriments["proteins_100g"]) || 0;
    const kcal = parseFloat(nutriments["energy-kcal_100g"]) || 0;
    const ingredients = (p.ingredients_text_fr || p.ingredients_text || "").toLowerCase();
    const image = p.image_front_small_url || p.image_front_url || null;
    const donnéesManquantes = glu == null;
    const gluVal = glu ?? 0;

    const sucresCaches = [
      {nom:"dextrose",label:"dextrose"},{nom:"maltodextrine",label:"maltodextrine"},
      {nom:"sirop de glucose",label:"sirop de glucose"},{nom:"amidon modifié",label:"amidon modifié"},
      {nom:"fructose",label:"fructose"},{nom:"saccharose",label:"saccharose"},
      {nom:"sirop d'agave",label:"sirop d'agave"},{nom:"sirop de maïs",label:"sirop de maïs"},
      {nom:"miel",label:"miel"},
    ];
    const edulcorantsRouge = [
      {nom:"aspartame",label:"aspartame (E951)",explication:"controverses neurologiques et métaboliques"},
      {nom:"e951",label:"aspartame (E951)",explication:"controverses neurologiques et métaboliques"},
      {nom:"sucralose",label:"sucralose (E955)",explication:"altération possible du microbiote"},
      {nom:"e955",label:"sucralose (E955)",explication:"altération possible du microbiote"},
      {nom:"acésulfame",label:"acésulfame K (E950)",explication:"perturbation possible du microbiote"},
      {nom:"acesulfame",label:"acésulfame K (E950)",explication:"perturbation possible du microbiote"},
      {nom:"e950",label:"acésulfame K (E950)",explication:"perturbation possible du microbiote"},
      {nom:"saccharine",label:"saccharine",explication:"édulcorant synthétique à éviter"},
      {nom:"e954",label:"saccharine (E954)",explication:"édulcorant synthétique à éviter"},
    ];
    const eRouge = {
      "e102":"tartrazine — hyperactivité, allergies","e110":"jaune orangé S — hyperactivité",
      "e122":"azorubine — hyperactivité","e124":"rouge cochenille A — hyperactivité",
      "e129":"rouge allura — hyperactivité",
      "e211":"benzoate de sodium — formation possible de benzène, cancérogène potentiel",
      "e433":"polysorbate 80 — perturbation du microbiote, inflammation intestinale",
      "e466":"carboxyméthylcellulose — inflammation intestinale, troubles métaboliques",
      "e171":"dioxyde de titane — suspect cancérogène",
      "e320":"BHA — suspect cancérogène","e321":"BHT — perturbateur endocrinien suspecté",
      "e250":"nitrite de sodium — cancérogène certain (CIRC Groupe 1), formation de nitrosamines",
      "e252":"nitrate de potassium — cancérogène certain (CIRC Groupe 1), formation de nitrosamines",
    };
    const eOrange = {
      "e150c":"caramel ammoniacal — composés potentiellement toxiques à haute dose",
      "e150d":"caramel sulfité — mêmes préoccupations, consommation élevée à éviter",
      "e338":"acide phosphorique — déminéralisation osseuse, impact sur les reins en excès",
      "e339":"phosphates de sodium — déséquilibre phosphocalcique",
      "e340":"phosphates de potassium — déséquilibre phosphocalcique",
      "e341":"phosphates de calcium — surcharge en phosphates",
      "e450":"diphosphates — troubles rénaux, calcifications",
      "e451":"triphosphates — troubles rénaux, calcifications",
      "e452":"polyphosphates — risque cardiovasculaire en excès",
      "e407":"carraghénanes — irritation intestinale possible",
      "e410":"gomme de caroube — troubles digestifs chez personnes sensibles",
      "e412":"gomme de guar — ballonnements","e415":"gomme xanthane — troubles digestifs possibles",
      "e420":"sorbitol — effet laxatif","e421":"mannitol — effet laxatif",
      "e953":"isomalt — troubles digestifs","e965":"maltitol — ballonnements, diarrhée",
      "e967":"xylitol — effet laxatif à forte dose",
      "e551":"dioxyde de silicium — accumulation possible (données encore débattues)",
      "e621":"glutamate monosodique — sensibilité chez certaines personnes",
      "e622":"glutamate de potassium — sensibilité chez certaines personnes",
      "e623":"diglutamate de calcium — sensibilité chez certaines personnes",
      "e624":"glutamate d'ammonium — sensibilité chez certaines personnes",
      "e625":"diglutamate de magnésium — sensibilité chez certaines personnes",
      "e200":"acide sorbique — irritations possibles",
      "e202":"sorbate de potassium — réactions cutanées rares",
    };
    const huilesRouge = [
      {nom:"huile de tournesol",label:"tournesol"},{nom:"huile de colza",label:"colza"},
      {nom:"huile de soja",label:"soja"},{nom:"huile de maïs",label:"maïs"},
      {nom:"huile de pépins de raisin",label:"pépins de raisin"},
      {nom:"huile d'arachide",label:"arachide"},
      {nom:"huile végétale",label:"végétale non précisée"},
      {nom:"matière grasse végétale",label:"matière grasse végétale"},
    ];
    const huilePalmeBlanche = ingredients.includes("huile de palme") && !ingredients.includes("huile de palme rouge");
    const aGhee = ingredients.includes("ghee") || ingredients.includes("beurre clarifié");
    const sucresTrouves = sucresCaches.filter(s => ingredients.includes(s.nom));
    const edulcTrouvesRouge = edulcorantsRouge.filter((e,i,arr) =>
      ingredients.includes(e.nom) && arr.findIndex(x=>x.label===e.label)===i
    );
    const eNumbers = (ingredients.match(/e\d{3,4}[a-z]?/g) || []).map(e=>e.toLowerCase());
    const eRougesTrouves = [...new Set(eNumbers.filter(e => eRouge[e]))];
    const eOrangeTrouves = [...new Set(eNumbers.filter(e => eOrange[e] && !eRouge[e]))];
    const huileMauvaise = huilesRouge.find(h => ingredients.includes(h.nom));
    const estChocolat = nom.toLowerCase().includes("chocolat") || ingredients.includes("cacao");
    const limiteGlu = estChocolat ? 20 : 6;
    const limiteOrange = estChocolat ? 25 : 10;
    const nbIngs = (p.ingredients || []).length || (ingredients.split(",").length);
    const listeLongue = nbIngs > 10;
    const ingredientsSimples = ["sel","eau","vinaigre","huile d'olive","huile de coco","beurre","ghee","citron","herbes","épices","poivre","moutarde"];
    const sembleSimple = nbIngs <= 2 && ingredientsSimples.some(s => ingredients.includes(s));

    let raisonsRouge = [], raisonsOrange = [], raisonsVert = [];
    if(gluVal > limiteOrange) raisonsRouge.push(`Trop de glucides (${gluVal.toFixed(1)}g/100g) — fait sortir de la cétose`);
    sucresTrouves.forEach(s => raisonsRouge.push(`Contient du ${s.label} — sucre qui fait sortir de la cétose`));
    edulcTrouvesRouge.forEach(e => raisonsRouge.push(`Contient du ${e.label} — édulcorant mauvais pour le microbiote (${e.explication})`));
    eRougesTrouves.forEach(e => raisonsRouge.push(`Contient ${e.toUpperCase()} — ${eRouge[e]}`));
    if(huileMauvaise) raisonsOrange.push(`Contient de l'huile de ${huileMauvaise.label} — graisse inflammatoire à éviter ou à consommer avec modération`);
    if(gluVal > limiteGlu && gluVal <= limiteOrange) raisonsOrange.push(`${gluVal.toFixed(1)}g de glucides pour 100g — à consommer occasionnellement`);
    eOrangeTrouves.forEach(e => raisonsOrange.push(`Contient ${e.toUpperCase()} — ${eOrange[e]}`));
    if(huilePalmeBlanche && !huileMauvaise) raisonsOrange.push("Contient de l'huile de palme — à limiter");
    if(listeLongue) raisonsOrange.push(`Produit ultra-transformé (${nbIngs} ingrédients)`);
    if(donnéesManquantes && !sembleSimple) raisonsOrange.push("Données nutritionnelles incomplètes — vérifie l'étiquette");
    if(aGhee) raisonsVert.push("Contient du ghee — excellente graisse céto ✓");

    let couleur, label, emoji, raisons;
    if(raisonsRouge.length > 0) {
      couleur = "#C62828"; label = "Sort de la cétose"; emoji = "🔴"; raisons = raisonsRouge;
    } else if(raisonsOrange.length > 0) {
      // Adapter le label selon la raison orange
      const seulementHuile = raisonsOrange.length > 0 && raisonsOrange.every(r => r.includes("huile") || r.includes("graisse inflammatoire"));
      couleur = "#F4A035";
      label = seulementHuile ? "Graisses inflammatoires" : "À consommer avec modération";
      emoji = "🟠";
      raisons = raisonsOrange;
    } else {
      couleur = "#2E7D32"; label = "Compatible céto ✓"; emoji = "🟢";
      raisons = raisonsVert.length > 0 ? raisonsVert : ["Ingrédients simples et connus, compatible avec ta cétose"];
    }
    return { nom, marque, glu:gluVal, lip, pro, kcal, image, couleur, label, emoji, raisons,
      produitPourAjout: { nom, marque, glu:gluVal, lip, pro, kcal } };
  };

  // ── Open Food Facts avec timeout et retry ────────────────────────────────
  const rechercherProduit = React.useCallback(async (code, attempt = 0) => {
    setScanState("loading");
    try {
      const res = await Promise.race([
        fetch(`https://world.openfoodfacts.org/api/v0/product/${code}.json`),
        new Promise((_, reject) => setTimeout(() => reject(new Error("Timeout")), 8000))
      ]);
      const data = await res.json();
      if(data.status === 1 && data.product) {
        setVerdict(analyserProduit(data.product));
        setScanState("result");
        setRetryCount(0);
      } else {
        setScanState("notfound");
      }
    } catch(e) {
      if(attempt < 3) {
        setRetryCount(attempt + 1);
        setTimeout(() => rechercherProduit(code, attempt + 1), 1000 * (attempt + 1));
      } else {
        setRetryCount(0);
        setScanState("error");
      }
    }
  }, []);

  // ── Ouvrir la caméra directe (capture=environment) ───────────────────────
  const demarrerScan = () => {
    setVerdict(null);
    setAjoutConfirm(false);
    if(cameraInputRef.current) {
      cameraInputRef.current.value = "";
      cameraInputRef.current.click();
    }
  };

  // ── Ouvrir la galerie (fallback) ──────────────────────────────────────────
  const ouvrirGalerie = () => {
    setVerdict(null);
    setAjoutConfirm(false);
    if(fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  // ── Décoder la photo avec ZXing ───────────────────────────────────────────
  const handlePhotoCapture = async (e) => {
    const file = e.target.files?.[0];
    if(!file) return;
    setScanState("loading");

    try {
      await loadHtml5Qrcode();
      // Créer un élément div temporaire requis par html5-qrcode
      const divId = "html5qr-tmp-" + Date.now();
      const div = document.createElement("div");
      div.id = divId;
      div.style.display = "none";
      document.body.appendChild(div);

      const scanner = new window.Html5Qrcode(divId);
      try {
        const result = await scanner.scanFile(file, false);
        document.body.removeChild(div);
        rechercherProduit(result);
      } catch(err) {
        document.body.removeChild(div);
        setScanState("notfound");
      }
    } catch(err) {
      setScanState("notfound");
    }
    if(cameraInputRef.current) cameraInputRef.current.value = "";
    if(fileInputRef.current) fileInputRef.current.value = "";
  };

  // ── Ajouter à Mes Produits ────────────────────────────────────────────────
  const ajouterAuxProduits = () => {
    if(!verdict) return;
    const p = verdict.produitPourAjout;
    const nouveau = { id:Date.now(), nom:p.nom, marque:p.marque,
      glu:parseFloat(p.glu.toFixed(1)), lip:parseFloat(p.lip.toFixed(1)),
      pro:parseFloat(p.pro.toFixed(1)), kcal:Math.round(p.kcal),
      unite:false, createdAt:new Date().toISOString().split("T")[0] };
    try {
      const existants = JSON.parse(localStorage.getItem("cetoclub_produits")||"[]");
      if(!existants.some(e => e.nom.toLowerCase()===p.nom.toLowerCase())) {
        const nouveauxProduits = [...existants, nouveau];
        // Correction : utilise saveProduits pour mettre à jour state ET localStorage ensemble
        localStorage.setItem("cetoclub_produits", JSON.stringify(nouveauxProduits));
        // Forcer le rafraîchissement du state React depuis le localStorage
        window.dispatchEvent(new Event("cetoclub_produits_updated"));
      }
    } catch(e) {}
    setAjoutConfirm(true);
  };

  const CN2 = {navy:"#1B3A6B",green:"#2E7D32",greenPale:"#E8F5E9",orange:"#F4A035",red:"#C62828",gray:"#6B7280",white:"#fff",cream:"#FAFAF7"};

  return (
    <main style={{maxWidth:600,margin:"0 auto",padding:"16px 12px",fontFamily:"'Nunito',sans-serif"}}>

      {/* Input caméra directe (capture=environment) */}
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        style={{display:"none"}}
        onChange={handlePhotoCapture}
      />
      {/* Input galerie (sans capture) — non utilisé mais gardé */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{display:"none"}}
        onChange={handlePhotoCapture}
      />

      {/* Header */}
      <div style={{background:`linear-gradient(135deg,${CN2.navy},#2A5298)`,borderRadius:16,padding:"20px 20px 16px",marginBottom:16,color:"#fff"}}>
        <div style={{fontSize:11,fontWeight:800,opacity:.7,letterSpacing:2,textTransform:"uppercase",marginBottom:4}}>✨ Premium</div>
        <div style={{fontSize:22,fontWeight:900,marginBottom:4}}>📷 Scanner un produit</div>
        <div style={{fontSize:12,opacity:.85}}>Photo du code-barres → résultat céto instantané</div>
      </div>

      {/* IDLE */}
      {scanState==="idle" && (
        <div style={{textAlign:"center",padding:"32px 20px",background:CN2.white,borderRadius:16,border:"2px solid #1B3A6B15",boxShadow:"0 4px 20px rgba(27,58,107,.06)"}}>
          <div style={{fontSize:72,marginBottom:16}}>📦</div>
          <div style={{fontSize:16,fontWeight:900,color:CN2.navy,marginBottom:8}}>Prêt à scanner</div>
          <div style={{fontSize:12,color:CN2.gray,marginBottom:8,lineHeight:1.7}}>
            1. Appuie sur le bouton ci-dessous<br/>
            2. Prends une photo nette du code-barres<br/>
            3. Le résultat arrive en quelques secondes
          </div>
          <div style={{fontSize:11,color:CN2.gray,marginBottom:20,padding:"8px 12px",background:"#F0F4FF",borderRadius:8,lineHeight:1.6}}>
            💡 Astuce : choisis "Prendre une photo" puis utilise la caméra arrière · Bonne lumière, à 15-20 cm du code-barres
          </div>
          <button onClick={demarrerScan} style={{background:`linear-gradient(135deg,${CN2.navy},#2A5298)`,color:"#fff",border:"none",borderRadius:14,padding:"16px 40px",fontSize:16,fontWeight:900,cursor:"pointer",boxShadow:"0 6px 24px rgba(27,58,107,.3)"}}>
            📷 Prendre une photo
          </button>
        </div>
      )}

      {/* LOADING */}
      {scanState==="loading" && (
        <div style={{textAlign:"center",padding:"48px 20px",background:CN2.white,borderRadius:16,border:"2px solid #1B3A6B15"}}>
          <div style={{fontSize:48,marginBottom:16}}>🔍</div>
          <div style={{fontSize:15,fontWeight:900,color:CN2.navy,marginBottom:6}}>
            Analyse en cours{retryCount > 0 ? ` (tentative ${retryCount}/3)` : "…"}
          </div>
          <div style={{fontSize:12,color:CN2.gray}}>Décodage du code-barres et recherche dans Open Food Facts</div>
        </div>
      )}

      {/* NOT FOUND */}
      {scanState==="notfound" && (
        <div style={{background:CN2.white,borderRadius:16,border:"2px solid #F4A03530",padding:24,textAlign:"center"}}>
          <div style={{fontSize:48,marginBottom:12}}>🔍</div>
          <div style={{fontSize:16,fontWeight:900,color:CN2.navy,marginBottom:8}}>Code-barres non lu ou produit introuvable</div>
          <div style={{fontSize:12,color:CN2.gray,marginBottom:6,lineHeight:1.7}}>
            La photo n'était peut-être pas assez nette.<br/>
            Essaie à nouveau en t'approchant et en éclairant bien le code-barres.
          </div>
          <div style={{fontSize:11,color:CN2.gray,marginBottom:20,padding:"8px 12px",background:"#F0F4FF",borderRadius:8}}>
            💡 Si le produit existe bien dans Open Food Facts, ressaie avec une meilleure photo.
          </div>
          <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
            <button onClick={demarrerScan} style={{background:`linear-gradient(135deg,${CN2.navy},#2A5298)`,color:"#fff",border:"none",borderRadius:10,padding:"12px 20px",fontSize:13,fontWeight:800,cursor:"pointer"}}>
              📷 Réessayer
            </button>
            <button onClick={()=>setPage("produits")} style={{background:CN2.cream,color:CN2.navy,border:`2px solid ${CN2.navy}20`,borderRadius:10,padding:"12px 20px",fontSize:13,fontWeight:800,cursor:"pointer"}}>
              ✏️ Saisir manuellement
            </button>
          </div>
        </div>
      )}

      {/* ERROR */}
      {scanState==="error" && (
        <div style={{background:"#FFEBEE",borderRadius:16,border:`2px solid ${CN2.red}30`,padding:24,textAlign:"center"}}>
          <div style={{fontSize:48,marginBottom:12}}>⚠️</div>
          <div style={{fontSize:16,fontWeight:900,color:CN2.red,marginBottom:8}}>Erreur de connexion</div>
          <div style={{fontSize:12,color:CN2.gray,marginBottom:16}}>Vérifie ta connexion internet et réessaie.</div>
          <button onClick={()=>setScanState("idle")} style={{background:CN2.red,color:"#fff",border:"none",borderRadius:10,padding:"12px 24px",fontSize:13,fontWeight:800,cursor:"pointer"}}>Réessayer</button>
        </div>
      )}

      {/* RESULT */}
      {scanState==="result" && verdict && (
        <div>
          <div style={{background:verdict.couleur,borderRadius:16,padding:"20px 20px 16px",marginBottom:12,color:"#fff",textAlign:"center"}}>
            <div style={{fontSize:52,marginBottom:8}}>{verdict.emoji}</div>
            <div style={{fontSize:20,fontWeight:900,marginBottom:4}}>{verdict.label}</div>
            <div style={{fontSize:13,opacity:.9}}>{verdict.nom}{verdict.marque?` · ${verdict.marque}`:""}</div>
          </div>
          {verdict.image && (
            <div style={{textAlign:"center",marginBottom:12}}>
              <img src={verdict.image} alt={verdict.nom} style={{maxHeight:100,maxWidth:"100%",borderRadius:12,objectFit:"contain",background:"#fff",padding:8,border:"2px solid #F3F4F6"}}/>
            </div>
          )}
          <div style={{background:CN2.white,borderRadius:14,border:"2px solid #1B3A6B15",padding:16,marginBottom:12}}>
            <div style={{fontSize:11,fontWeight:800,color:CN2.navy,marginBottom:10,textTransform:"uppercase",letterSpacing:1}}>📊 Pour 100g</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
              {[{l:"Glucides",v:verdict.glu.toFixed(1)+"g",c:"#C62828"},{l:"Lipides",v:verdict.lip.toFixed(1)+"g",c:"#E65100"},{l:"Protéines",v:verdict.pro.toFixed(1)+"g",c:"#2A5298"},{l:"Calories",v:Math.round(verdict.kcal)+"kcal",c:"#6B7280"}].map(m=>(
                <div key={m.l} style={{background:"#FAFAF7",borderRadius:10,padding:"10px 4px",textAlign:"center"}}>
                  <div style={{fontSize:14,fontWeight:900,color:m.c}}>{m.v}</div>
                  <div style={{fontSize:9,color:CN2.gray,marginTop:2,fontWeight:700}}>{m.l}</div>
                </div>
              ))}
            </div>
          </div>
          {verdict.raisons.length > 0 && (
            <div style={{background:"#FFF8F0",borderRadius:12,border:`2px solid ${CN2.orange}30`,padding:14,marginBottom:12}}>
              <div style={{fontSize:11,fontWeight:900,color:"#E65100",marginBottom:8}}>⚠️ Points d'attention</div>
              {verdict.raisons.map((r,i)=>(
                <div key={i} style={{fontSize:12,color:"#374151",padding:"4px 0",borderBottom:i<verdict.raisons.length-1?"1px solid #FEE2C020":"none"}}>• {r}</div>
              ))}
            </div>
          )}
          {!ajoutConfirm ? (
            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              {(verdict.couleur==="#2E7D32" || verdict.couleur==="#F4A035") && (
                <button onClick={ajouterAuxProduits} style={{flex:1,background:verdict.couleur==="#2E7D32"?"linear-gradient(135deg,#2E7D32,#388E3C)":`linear-gradient(135deg,${CN2.orange},#E65100)`,color:"#fff",border:"none",borderRadius:12,padding:"14px 16px",fontSize:13,fontWeight:900,cursor:"pointer"}}>
                  {verdict.couleur==="#2E7D32" ? "✅ Ajouter à Mes Produits" : "⚠️ Ajouter quand même ?"}
                </button>
              )}
              <button onClick={demarrerScan} style={{flex:1,background:CN2.cream,color:CN2.navy,border:`2px solid ${CN2.navy}20`,borderRadius:12,padding:"14px 16px",fontSize:13,fontWeight:900,cursor:"pointer"}}>
                📷 Nouveau scan
              </button>
            </div>
          ) : (
            <div style={{background:CN2.greenPale,borderRadius:12,border:"2px solid #2E7D3240",padding:16,textAlign:"center"}}>
              <div style={{fontSize:24,marginBottom:6}}>✅</div>
              <div style={{fontSize:14,fontWeight:900,color:CN2.green,marginBottom:4}}>Ajouté à Mes Produits !</div>
              <div style={{fontSize:11,color:CN2.gray,marginBottom:12}}>Tu peux maintenant l'utiliser dans ton journal.</div>
              <div style={{display:"flex",gap:8,justifyContent:"center",flexWrap:"wrap"}}>
                <button onClick={()=>setPage("produits")} style={{background:`linear-gradient(135deg,${CN2.navy},#2A5298)`,color:"#fff",border:"none",borderRadius:10,padding:"10px 18px",fontSize:12,fontWeight:800,cursor:"pointer"}}>Voir Mes Produits</button>
                <button onClick={demarrerScan} style={{background:CN2.cream,color:CN2.navy,border:`2px solid ${CN2.navy}20`,borderRadius:10,padding:"10px 18px",fontSize:12,fontWeight:800,cursor:"pointer"}}>📷 Nouveau scan</button>
              </div>
            </div>
          )}
        </div>
      )}
    </main>
  );
}



function BoutonPaypal({btnId, url}) {
  // Lien direct Stripe
  return React.createElement('a', {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    style: {display:"block",textAlign:"center",padding:"14px",borderRadius:10,background:"linear-gradient(135deg,#1B3A6B,#2A5298)",color:"#fff",fontWeight:900,fontSize:15,textDecoration:"none"}
  }, "💳 Payer via Stripe");
}

// ─── MODULE RESPIRATION PREMIUM ───────────────────────────────────────────────
const CC_RESP = {
  navy:   "#1B3A6B",
  blue:   "#2A5298",
  green:  "#7CB342",
  orange: "#F4A035",
  white:  "#FFFFFF",
};

const HISTO_KEY_RESP = "cetoclub_respiration_histo";

function lireHistoResp() {
  try { return JSON.parse(localStorage.getItem(HISTO_KEY_RESP) || "[]"); }
  catch { return []; }
}

function sauvegarderSeanceResp(techId, techNom, nbCycles, dureeTotaleSecondes) {
  const histo = lireHistoResp();
  histo.unshift({ date: new Date().toISOString(), techId, techNom, nbCycles, duree: dureeTotaleSecondes });
  localStorage.setItem(HISTO_KEY_RESP, JSON.stringify(histo.slice(0, 90)));
}

const TECHS_RESP = [
  {
    id: "longbreath", nom: "Long Breath Diet", rythme: "3s · 7s", couleur: CC_RESP.green, cyclesDefaut: 10,
    quand: "🔥 Perte de poids, gainage, énergie",
    desc: "Méthode de l'acteur japonais Miki Ryosuke, qui affirme avoir perdu 13 kg en pratiquant cet exercice 2 à 5 minutes par jour.",
    note: "🧍 Debout, pieds écartés, fessiers contractés. Inspiration courte et forte par le nez. Expiration longue et forcée par la bouche en rentrant progressivement le ventre.",
    pourquoi: "Elle active le gainage profond, améliore l'oxygénation et réduit le cortisol. En céto : moins de cortisol = moins de blocage de la lipolyse. Rapide, debout, faisable n'importe où.",
    phases: [
      { nom: "INSPIRE", action: "Court et fort par le nez",         duree: 3, type: "monter",    couleur: CC_RESP.green },
      { nom: "EXPIRE",  action: "Long et forcé — rentre le ventre", duree: 7, type: "descendre", couleur: CC_RESP.blue  },
    ],
  },
  {
    id: "coherence", nom: "Cohérence cardiaque", rythme: "5s · 5s", couleur: CC_RESP.blue, cyclesDefaut: 6,
    quand: "⚖️ Équilibre, quotidien, tension",
    desc: "Inspire 5 secondes, expire 5 secondes. 6 respirations par minute pendant 5 minutes. La technique la plus validée scientifiquement.",
    pourquoi: "La cohérence cardiaque régule le système nerveux autonome et stabilise la glycémie. En céto elle renforce les bénéfices métaboliques du régime et améliore la qualité du sommeil.",
    phases: [
      { nom: "INSPIRE", action: "Inspire doucement", duree: 5, type: "monter",    couleur: CC_RESP.green },
      { nom: "EXPIRE",  action: "Expire doucement",  duree: 5, type: "descendre", couleur: CC_RESP.blue  },
    ],
  },
  {
    id: "478", nom: "Respiration 4-7-8", rythme: "4s · 7s · 8s", couleur: CC_RESP.orange, cyclesDefaut: 4,
    quand: "😰 Stress, anxiété, insomnie",
    desc: "Inspire 4 secondes, bloque 7 secondes, expire lentement 8 secondes. Calme le système nerveux en quelques minutes.",
    pourquoi: "En céto, les premières semaines apportent souvent stress et nervosité. Cette respiration active le nerf vague et réduit le cortisol, l'hormone qui bloque la perte de graisses.",
    phases: [
      { nom: "INSPIRE",  action: "Inspire par le nez",    duree: 4, type: "monter",    couleur: CC_RESP.green  },
      { nom: "RETIENS",  action: "Bloque ta respiration", duree: 7, type: "droite",    couleur: CC_RESP.orange },
      { nom: "EXPIRE",   action: "Expire par la bouche",  duree: 8, type: "descendre", couleur: CC_RESP.blue   },
    ],
  },
  {
    id: "box", nom: "Box Breathing", rythme: "4s · 4s · 4s · 4s", couleur: CC_RESP.navy, cyclesDefaut: 4,
    quand: "🎯 Concentration, avant un effort",
    desc: "Inspire 4s, bloque 4s, expire 4s, bloque vide 4s. Utilisée par les Navy SEALs pour rester calme sous pression.",
    pourquoi: "Le Box Breathing équilibre les deux branches du système nerveux. Il améliore la concentration mentale et réduit les fringales impulsives.",
    phases: [
      { nom: "INSPIRE",       action: "Inspire par le nez",     duree: 4, type: "monter",    couleur: CC_RESP.green  },
      { nom: "RETIENS PLEIN", action: "Bloque, poumons pleins", duree: 4, type: "droite",    couleur: CC_RESP.orange },
      { nom: "EXPIRE",        action: "Expire par la bouche",   duree: 4, type: "descendre", couleur: CC_RESP.blue   },
      { nom: "RETIENS VIDE",  action: "Bloque, poumons vides",  duree: 4, type: "gauche",    couleur: CC_RESP.navy   },
    ],
  },
  {
    id: "abdominale", nom: "Respiration abdominale", rythme: "4s · 6s", couleur: CC_RESP.green, cyclesDefaut: 8,
    quand: "😴 Détente, endormissement, douleur",
    desc: "Inspire en gonflant le ventre 4 secondes, expire lentement 6 secondes en rentrant le nombril. La respiration naturelle du corps.",
    pourquoi: "La respiration abdominale profonde oxygène chaque cellule et active le drainage lymphatique. En céto elle favorise l'élimination des déchets métaboliques.",
    phases: [
      { nom: "INSPIRE", action: "Gonfle le ventre",  duree: 4, type: "monter",    couleur: CC_RESP.green },
      { nom: "EXPIRE",  action: "Rentre le nombril", duree: 6, type: "descendre", couleur: CC_RESP.blue  },
    ],
  },
];

const U_RESP = 14;
function calculerPointsResp(phases) {
  const pts = [{ x: 0, y: 0 }];
  let x = 0, y = 0;
  phases.forEach(p => {
    const d = p.duree * U_RESP;
    if      (p.type === "monter")    y -= d;
    else if (p.type === "descendre") y += d;
    else if (p.type === "droite")    x += d;
    else if (p.type === "gauche")    x -= d;
    pts.push({ x, y });
  });
  const xs = pts.map(p => p.x), ys = pts.map(p => p.y);
  const minX = Math.min(...xs), maxX = Math.max(...xs);
  const minY = Math.min(...ys), maxY = Math.max(...ys);
  const W = 300, H = 200;
  const offX = (W - (maxX - minX)) / 2 - minX;
  const offY = (H - (maxY - minY)) / 2 - minY;
  return pts.map(p => ({ x: p.x + offX, y: p.y + offY }));
}

function dessinerResp(canvas, phases, phaseActuelle, progressDansPhase) {
  if (!canvas || !phases) return;
  const ctx = canvas.getContext("2d");
  const W = canvas.width, H = canvas.height;
  ctx.clearRect(0, 0, W, H);
  const pts = calculerPointsResp(phases);
  const segLens = phases.map(p => p.duree * U_RESP);
  const totalLen = segLens.reduce((s, l) => s + l, 0);
  const durees = phases.map(p => p.duree);
  const totalDuree = durees.reduce((s, d) => s + d, 0);
  function posAt(ratio) {
    let target = Math.min(ratio, 0.9999) * totalLen, done = 0;
    for (let i = 0; i < segLens.length; i++) {
      if (done + segLens[i] >= target) {
        const t = segLens[i] > 0 ? (target - done) / segLens[i] : 0;
        return { x: pts[i].x+(pts[i+1].x-pts[i].x)*t, y: pts[i].y+(pts[i+1].y-pts[i].y)*t, couleur: phases[i].couleur };
      }
      done += segLens[i];
    }
    return { ...pts[pts.length-1], couleur: phases[phases.length-1].couleur };
  }
  ctx.beginPath(); ctx.moveTo(pts[0].x, pts[0].y);
  pts.slice(1).forEach(p => ctx.lineTo(p.x, p.y));
  ctx.strokeStyle = "rgba(255,255,255,0.15)"; ctx.lineWidth = 2.5;
  ctx.lineJoin = "miter"; ctx.lineCap = "square"; ctx.stroke();
  for (let i = 0; i < phaseActuelle; i++) {
    ctx.beginPath(); ctx.moveTo(pts[i].x, pts[i].y); ctx.lineTo(pts[i+1].x, pts[i+1].y);
    ctx.strokeStyle = phases[i].couleur; ctx.lineWidth = 3;
    ctx.lineJoin = "miter"; ctx.lineCap = "square"; ctx.stroke();
  }
  if (phaseActuelle < phases.length) {
    const t = progressDansPhase;
    const ex = pts[phaseActuelle].x + (pts[phaseActuelle+1].x - pts[phaseActuelle].x) * t;
    const ey = pts[phaseActuelle].y + (pts[phaseActuelle+1].y - pts[phaseActuelle].y) * t;
    ctx.beginPath(); ctx.moveTo(pts[phaseActuelle].x, pts[phaseActuelle].y); ctx.lineTo(ex, ey);
    ctx.strokeStyle = phases[phaseActuelle].couleur; ctx.lineWidth = 3;
    ctx.lineJoin = "miter"; ctx.lineCap = "square"; ctx.stroke();
  }
  const ratioG = (durees.slice(0, phaseActuelle).reduce((s,d)=>s+d,0) + (phaseActuelle < phases.length ? durees[phaseActuelle]*progressDansPhase : 0)) / totalDuree;
  const boule = posAt(ratioG);
  const halo = ctx.createRadialGradient(boule.x, boule.y, 2, boule.x, boule.y, 18);
  halo.addColorStop(0, boule.couleur+"88"); halo.addColorStop(1, "transparent");
  ctx.beginPath(); ctx.arc(boule.x, boule.y, 18, 0, Math.PI*2); ctx.fillStyle = halo; ctx.fill();
  ctx.beginPath(); ctx.arc(boule.x, boule.y, 9, 0, Math.PI*2);
  ctx.fillStyle = boule.couleur; ctx.shadowColor = boule.couleur; ctx.shadowBlur = 10; ctx.fill(); ctx.shadowBlur = 0;
  ctx.beginPath(); ctx.arc(boule.x, boule.y, 3, 0, Math.PI*2); ctx.fillStyle = "white"; ctx.fill();
  ctx.font = "10px Georgia,serif"; ctx.textAlign = "center";
  phases.forEach((phase, i) => {
    const mx = (pts[i].x+pts[i+1].x)/2, my = (pts[i].y+pts[i+1].y)/2;
    const dx = pts[i+1].x-pts[i].x, dy = pts[i+1].y-pts[i].y;
    let ox = 0, oy = 0;
    if (Math.abs(dy) > Math.abs(dx)) { ox = 22; oy = 0; ctx.textAlign = "left"; }
    else { ox = 0; oy = my < H/2 ? -16 : 18; ctx.textAlign = "center"; }
    ctx.fillStyle = i === phaseActuelle ? phase.couleur : "rgba(255,255,255,0.3)";
    ctx.fillText(phase.nom, mx+ox, my+oy);
    ctx.textAlign = "center";
  });
}

function useRespAudio() {
  const ctxRef = React.useRef(null);
  const get = React.useCallback(() => {
    if (!ctxRef.current) ctxRef.current = new (window.AudioContext || window.webkitAudioContext)();
    if (ctxRef.current.state === "suspended") ctxRef.current.resume();
    return ctxRef.current;
  }, []);
  const play = React.useCallback((type) => {
    try {
      const ctx = get(); const osc = ctx.createOscillator(); const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination); const t = ctx.currentTime;
      if (type === "monter") {
        osc.type="sine"; osc.frequency.setValueAtTime(220,t); osc.frequency.linearRampToValueAtTime(330,t+.3);
        gain.gain.setValueAtTime(.15,t); gain.gain.exponentialRampToValueAtTime(.001,t+.7); osc.start(t); osc.stop(t+.7);
      } else if (type === "descendre") {
        osc.type="sine"; osc.frequency.setValueAtTime(330,t); osc.frequency.linearRampToValueAtTime(200,t+.4);
        gain.gain.setValueAtTime(.12,t); gain.gain.exponentialRampToValueAtTime(.001,t+.7); osc.start(t); osc.stop(t+.7);
      } else if (type === "droite" || type === "gauche") {
        osc.type="sine"; osc.frequency.setValueAtTime(265,t);
        gain.gain.setValueAtTime(.08,t); gain.gain.exponentialRampToValueAtTime(.001,t+.4); osc.start(t); osc.stop(t+.4);
      } else if (type === "termine") {
        [0,.35,.7].forEach((delay,i) => {
          const o=ctx.createOscillator(),g=ctx.createGain(); o.connect(g); g.connect(ctx.destination);
          o.type="sine"; o.frequency.setValueAtTime(528+i*132,t+delay);
          g.gain.setValueAtTime(.15,t+delay); g.gain.exponentialRampToValueAtTime(.001,t+delay+1.2);
          o.start(t+delay); o.stop(t+delay+1.2);
        });
      }
    } catch(e) {}
  }, [get]);
  return { play };
}

function formatDureeResp(secondes) {
  const m = Math.floor(secondes / 60);
  const s = secondes % 60;
  return m > 0 ? `${m}min${s > 0 ? ` ${s}s` : ""}` : `${s}s`;
}

function RespEcranConfig({ tech, onDemarrer, onRetour }) {
  const dureeCycle = tech.phases.reduce((s, p) => s + p.duree, 0);
  const [nbCycles, setNbCycles] = React.useState(tech.cyclesDefaut);
  const dureeTotal = nbCycles * dureeCycle;
  return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh", background:"#0a1628", fontFamily:"Georgia,serif", color:"#fff" }}>
      <div style={{ padding:"16px 20px", display:"flex", alignItems:"center", gap:12 }}>
        <button onClick={onRetour} style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:8, color:"#fff", padding:"6px 14px", cursor:"pointer", fontSize:14, fontFamily:"Georgia,serif" }}>← Retour</button>
        <div>
          <div style={{ fontWeight:"bold", fontSize:16 }}>{tech.nom}</div>
          <div style={{ fontSize:12, opacity:0.6 }}>{tech.rythme}</div>
        </div>
      </div>
      <div style={{ flex:1, padding:"20px", display:"flex", flexDirection:"column", gap:16 }}>
        <div style={{ background:"rgba(255,255,255,0.06)", borderRadius:14, padding:16 }}>
          <div style={{ fontSize:11, color:CC_RESP.orange, letterSpacing:1, textTransform:"uppercase", marginBottom:10 }}>Phases</div>
          {tech.phases.map((p, i) => (
            <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
              <span style={{ fontSize:14, color:"rgba(255,255,255,0.8)" }}>{p.action}</span>
              <span style={{ fontSize:13, fontWeight:"bold", color:CC_RESP.orange, background:"rgba(244,160,53,0.15)", padding:"3px 10px", borderRadius:20, border:`1px solid ${CC_RESP.orange}55` }}>{p.duree}s</span>
            </div>
          ))}
        </div>
        <div style={{ background:"rgba(255,255,255,0.06)", borderRadius:14, padding:16 }}>
          <div style={{ fontSize:11, color:CC_RESP.orange, letterSpacing:1, textTransform:"uppercase", marginBottom:12 }}>Nombre de cycles</div>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:20 }}>
            <button onClick={() => setNbCycles(c => Math.max(1, c - 1))} style={{ width:44, height:44, borderRadius:"50%", background:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.2)", color:"#fff", fontSize:22, cursor:"pointer", fontFamily:"Georgia,serif" }}>−</button>
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:48, fontWeight:"bold", fontFamily:"monospace", color:CC_RESP.orange, lineHeight:1 }}>{nbCycles}</div>
              <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginTop:4 }}>cycles</div>
            </div>
            <button onClick={() => setNbCycles(c => Math.min(30, c + 1))} style={{ width:44, height:44, borderRadius:"50%", background:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.2)", color:"#fff", fontSize:22, cursor:"pointer", fontFamily:"Georgia,serif" }}>+</button>
          </div>
        </div>
        <div style={{ background:`rgba(42,82,152,0.2)`, border:`1px solid ${CC_RESP.blue}55`, borderRadius:14, padding:16, textAlign:"center" }}>
          <div style={{ fontSize:11, color:CC_RESP.orange, letterSpacing:1, textTransform:"uppercase", marginBottom:6 }}>⏱ Durée totale de la séance</div>
          <div style={{ fontSize:36, fontWeight:"bold", color:"#fff" }}>{formatDureeResp(dureeTotal)}</div>
          <div style={{ fontSize:12, color:"rgba(255,255,255,0.4)", marginTop:4 }}>{nbCycles} × {dureeCycle}s par cycle</div>
        </div>
        {tech.note && (
          <div style={{ background:"rgba(124,179,66,0.1)", border:`1px solid ${CC_RESP.green}44`, borderRadius:12, padding:14 }}>
            <div style={{ fontSize:11, color:CC_RESP.green, letterSpacing:1, textTransform:"uppercase", marginBottom:6 }}>📌 Position &amp; technique</div>
            <p style={{ fontSize:12, color:"rgba(255,255,255,0.8)", lineHeight:1.7, margin:0 }}>{tech.note}</p>
          </div>
        )}
      </div>
      <div style={{ padding:20 }}>
        <button onClick={() => onDemarrer(nbCycles)} style={{ width:"100%", padding:16, borderRadius:14, background:`linear-gradient(90deg,${CC_RESP.navy},${CC_RESP.blue})`, border:"none", color:"#fff", fontSize:16, fontWeight:"bold", cursor:"pointer", fontFamily:"Georgia,serif" }}>
          ▶ Démarrer la séance
        </button>
      </div>
    </div>
  );
}

function RespEcranExercice({ tech, nbCycles, onRetour }) {
  const canvasRef = React.useRef(null);
  const rafRef = React.useRef(null);
  const enCoursRef = React.useRef(false);
  const idxRef = React.useRef(0);
  const cyclesRef = React.useRef(0);
  const tDebutRef = React.useRef(null);
  const tDebutSeanceRef = React.useRef(null);
  const pauseRef = React.useRef(0);
  const [enCours, setEnCours] = React.useState(false);
  const [idx, setIdx] = React.useState(0);
  const [cycles, setCycles] = React.useState(0);
  const [label, setLabel] = React.useState("PRÊT");
  const [action, setAction] = React.useState("Appuie sur Commencer");
  const [compte, setCompte] = React.useState("—");
  const [couleur, setCouleur] = React.useState("rgba(255,255,255,0.5)");
  const [termine, setTermine] = React.useState(false);
  const [timerGlobal, setTimerGlobal] = React.useState(0);
  const dureeCycle = tech.phases.reduce((s, p) => s + p.duree, 0);
  const dureeTotal = nbCycles * dureeCycle;
  const { play } = useRespAudio();
  React.useEffect(() => { enCoursRef.current = enCours; }, [enCours]);
  React.useEffect(() => { idxRef.current = idx; }, [idx]);
  React.useEffect(() => { cyclesRef.current = cycles; }, [cycles]);
  React.useEffect(() => { dessinerResp(canvasRef.current, tech.phases, 0, 0); }, [tech]);
  React.useEffect(() => () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); }, []);
  const boucle = React.useCallback(() => {
    if (!enCoursRef.current) return;
    const i = idxRef.current;
    const phase = tech.phases[i];
    const el = (performance.now() - tDebutRef.current) / 1000;
    const prog = Math.min(el / phase.duree, 1);
    const reste = Math.max(Math.ceil(phase.duree - el), 0);
    const secsEcoulees = Math.floor((performance.now() - tDebutSeanceRef.current) / 1000);
    setTimerGlobal(secsEcoulees);
    setLabel(phase.nom); setCouleur(phase.couleur);
    setAction(phase.action); setCompte(reste === 0 ? "0" : String(reste));
    dessinerResp(canvasRef.current, tech.phases, i, prog);
    if (prog >= 1) {
      const next = i + 1;
      if (next >= tech.phases.length) {
        const nc = cyclesRef.current + 1;
        cyclesRef.current = nc; setCycles(nc);
        if (nc >= nbCycles) {
          enCoursRef.current = false;
          setEnCours(false); setTermine(true);
          play("termine");
          const dureeReelle = Math.floor((performance.now() - tDebutSeanceRef.current) / 1000);
          sauvegarderSeanceResp(tech.id, tech.nom, nc, dureeReelle);
          setLabel("TERMINÉ"); setCouleur(CC_RESP.green);
          setAction("🎉 Bravo, séance complète !"); setCompte("✓");
          dessinerResp(canvasRef.current, tech.phases, 0, 0);
          return;
        }
        idxRef.current = 0; setIdx(0);
      } else {
        idxRef.current = next; setIdx(next);
      }
      pauseRef.current = 0;
      tDebutRef.current = performance.now();
      play(tech.phases[idxRef.current].type);
    }
    rafRef.current = requestAnimationFrame(boucle);
  }, [tech, play, nbCycles]);
  const lancer = React.useCallback(() => {
    if (!tDebutSeanceRef.current) tDebutSeanceRef.current = performance.now() - timerGlobal * 1000;
    setEnCours(true); enCoursRef.current = true;
    tDebutRef.current = performance.now() - pauseRef.current * 1000;
    play(tech.phases[idxRef.current].type);
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(boucle);
  }, [boucle, play, tech, timerGlobal]);
  const stopper = React.useCallback(() => {
    setEnCours(false); enCoursRef.current = false;
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    if (tDebutRef.current !== null)
      pauseRef.current = Math.min((performance.now() - tDebutRef.current) / 1000, tech.phases[idxRef.current].duree);
  }, [tech]);
  const recommencer = React.useCallback(() => {
    setTermine(false); setIdx(0); idxRef.current = 0;
    setCycles(0); cyclesRef.current = 0;
    pauseRef.current = 0; tDebutRef.current = null; tDebutSeanceRef.current = null;
    setTimerGlobal(0);
    setLabel("PRÊT"); setAction("Appuie sur Commencer");
    setCompte("—"); setCouleur("rgba(255,255,255,0.5)");
    dessinerResp(canvasRef.current, tech.phases, 0, 0);
  }, [tech]);
  const handleRetour = () => { stopper(); onRetour(); };
  const toggle = () => { if (termine) recommencer(); else if (enCours) stopper(); else lancer(); };
  const timerRestant = Math.max(0, dureeTotal - timerGlobal);
  const progressGlobal = Math.min(timerGlobal / dureeTotal, 1);
  return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh", background:"#0a1628", fontFamily:"Georgia,serif", color:"#fff" }}>
      <div style={{ padding:"12px 20px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <button onClick={handleRetour} style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:8, color:"#fff", padding:"6px 14px", cursor:"pointer", fontSize:14, fontFamily:"Georgia,serif" }}>← Retour</button>
          <div>
            <div style={{ fontWeight:"bold", fontSize:15 }}>{tech.nom}</div>
            <div style={{ fontSize:11, opacity:0.5 }}>{tech.rythme}</div>
          </div>
        </div>
        <div style={{ textAlign:"right" }}>
          <div style={{ fontSize:20, fontWeight:"bold", fontFamily:"monospace", color: timerRestant < 30 && enCours ? CC_RESP.orange : "#fff" }}>
            {formatDureeResp(timerRestant)}
          </div>
          <div style={{ fontSize:10, color:"rgba(255,255,255,0.4)" }}>restant</div>
        </div>
      </div>
      <div style={{ height:3, background:"rgba(255,255,255,0.1)", margin:"0 20px" }}>
        <div style={{ height:"100%", background:`linear-gradient(90deg,${CC_RESP.green},${CC_RESP.blue})`, width:`${progressGlobal*100}%`, transition:"width 0.5s", borderRadius:2 }} />
      </div>
      <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:20 }}>
        <div style={{ fontSize:13, letterSpacing:3, textTransform:"uppercase", color:couleur, marginBottom:8, minHeight:20, transition:"color 0.3s" }}>{label}</div>
        <div style={{ fontSize:18, fontWeight:"bold", marginBottom:4, minHeight:28, textAlign:"center", maxWidth:280 }}>{action}</div>
        <div style={{ fontSize:56, fontWeight:"bold", marginBottom:20, minHeight:68, fontFamily:"monospace", textAlign:"center", color:couleur, transition:"color 0.3s" }}>{compte}</div>
        <canvas ref={canvasRef} width={300} height={200} style={{ borderRadius:12 }} />
        <div style={{ marginTop:16, textAlign:"center" }}>
          <div style={{ fontSize:18, fontWeight:"bold" }}>{cycles} / {nbCycles}</div>
          <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginTop:2 }}>cycles complétés</div>
        </div>
      </div>
      <div style={{ background:`rgba(42,82,152,0.15)`, border:`1px solid ${CC_RESP.blue}55`, borderRadius:12, padding:14, margin:"0 20px 12px" }}>
        <div style={{ fontSize:11, color:CC_RESP.orange, letterSpacing:1, textTransform:"uppercase", marginBottom:6 }}>🥑 Pourquoi en céto ?</div>
        <p style={{ fontSize:12, color:"rgba(255,255,255,0.75)", lineHeight:1.7, margin:0 }}>{tech.pourquoi}</p>
      </div>
      <div style={{ padding:"0 20px 20px" }}>
        <button onClick={toggle} style={{ width:"100%", padding:16, borderRadius:14, background: enCours ? "rgba(255,255,255,0.1)" : `linear-gradient(90deg,${CC_RESP.navy},${CC_RESP.blue})`, border: enCours ? `1px solid ${CC_RESP.blue}` : "none", color:"#fff", fontSize:16, fontWeight:"bold", cursor:"pointer", fontFamily:"Georgia,serif", transition:"background 0.3s" }}>
          {termine ? "▶ Recommencer" : enCours ? "⏸ Pause" : "▶ Commencer"}
        </button>
      </div>
    </div>
  );
}

function RespEcranHistorique({ onRetour }) {
  const histo = lireHistoResp();
  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { weekday:"short", day:"numeric", month:"short" }) + " à " + d.toLocaleTimeString("fr-FR", { hour:"2-digit", minute:"2-digit" });
  };
  const aujourd = new Date().toDateString();
  const seancesAujourd = histo.filter(s => new Date(s.date).toDateString() === aujourd).length;
  const seancesSemaine = histo.filter(s => (Date.now() - new Date(s.date)) / 86400000 <= 7).length;
  const dureeTotal = histo.reduce((s, e) => s + (e.duree || 0), 0);
  return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh", background:"#0a1628", fontFamily:"Georgia,serif", color:"#fff" }}>
      <div style={{ padding:"16px 20px", display:"flex", alignItems:"center", gap:12 }}>
        <button onClick={onRetour} style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:8, color:"#fff", padding:"6px 14px", cursor:"pointer", fontSize:14, fontFamily:"Georgia,serif" }}>← Retour</button>
        <div style={{ fontSize:18, fontWeight:"bold" }}>📊 Historique respiratoire</div>
      </div>
      <div style={{ padding:"0 20px 20px", flex:1 }}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:20 }}>
          {[
            { label:"Aujourd'hui", val:seancesAujourd, unit:"séance" + (seancesAujourd > 1 ? "s" : "") },
            { label:"Cette semaine", val:seancesSemaine, unit:"séance" + (seancesSemaine > 1 ? "s" : "") },
            { label:"Temps total", val:formatDureeResp(dureeTotal), unit:"" },
          ].map((s, i) => (
            <div key={i} style={{ background:"rgba(255,255,255,0.06)", borderRadius:12, padding:"12px 10px", textAlign:"center" }}>
              <div style={{ fontSize:20, fontWeight:"bold", color:CC_RESP.orange }}>{s.val}</div>
              <div style={{ fontSize:9, color:"rgba(255,255,255,0.4)", lineHeight:1.4 }}>{s.unit || ""}<br/>{s.label}</div>
            </div>
          ))}
        </div>
        {histo.length === 0 ? (
          <div style={{ textAlign:"center", padding:"40px 0", color:"rgba(255,255,255,0.3)", fontSize:14 }}>
            Aucune séance enregistrée pour l'instant.<br/>Lance ta première séance ! 🫁
          </div>
        ) : (
          histo.map((s, i) => (
            <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 14px", background:"rgba(255,255,255,0.05)", borderRadius:10, marginBottom:8, borderLeft:`3px solid ${TECHS_RESP.find(t=>t.id===s.techId)?.couleur||CC_RESP.blue}` }}>
              <div>
                <div style={{ fontSize:14, fontWeight:"bold", color:"#fff" }}>{s.techNom}</div>
                <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginTop:2 }}>{formatDate(s.date)}</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ fontSize:13, color:CC_RESP.orange, fontWeight:"bold" }}>{s.nbCycles} cycles</div>
                <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)" }}>{formatDureeResp(s.duree||0)}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

function RespEcranChoix({ onChoisir, onHistorique }) {
  const histo = lireHistoResp();
  const seancesAujourd = histo.filter(s => new Date(s.date).toDateString() === new Date().toDateString()).length;
  return (
    <div style={{ background:`linear-gradient(160deg,${CC_RESP.navy} 0%,#0a1628 100%)`, minHeight:"100vh", padding:"32px 20px", fontFamily:"Georgia,serif", color:"#fff" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:24 }}>
        <div>
          <div style={{ fontSize:11, letterSpacing:3, textTransform:"uppercase", color:"rgba(255,255,255,0.4)", marginBottom:6 }}>💎 Module Premium</div>
          <h1 style={{ fontSize:24, fontWeight:"normal", margin:"0 0 4px" }}>🫁 Respiration guidée</h1>
          <p style={{ fontSize:13, color:"rgba(255,255,255,0.6)", lineHeight:1.6, margin:0 }}>Choisis ta technique selon ton besoin.</p>
        </div>
        <button onClick={onHistorique} style={{ background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:10, color:"#fff", padding:"8px 12px", cursor:"pointer", fontSize:11, fontFamily:"Georgia,serif", textAlign:"center", flexShrink:0 }}>
          📊<br/><span style={{ fontSize:9, color:CC_RESP.orange }}>{seancesAujourd} auj.</span>
        </button>
      </div>
      {TECHS_RESP.map((t, i) => (
        <div key={t.id} onClick={() => onChoisir(t)}
          style={{ background: i === 0 ? "rgba(124,179,66,0.12)" : "rgba(255,255,255,0.05)", border: i === 0 ? `1px solid ${CC_RESP.green}55` : "1px solid rgba(255,255,255,0.1)", borderRadius:16, padding:18, marginBottom:12, cursor:"pointer" }}
          onMouseEnter={e => { e.currentTarget.style.background = i === 0 ? "rgba(124,179,66,0.2)" : "rgba(255,255,255,0.09)"; }}
          onMouseLeave={e => { e.currentTarget.style.background = i === 0 ? "rgba(124,179,66,0.12)" : "rgba(255,255,255,0.05)"; }}
        >
          {i === 0 && <div style={{ fontSize:10, color:CC_RESP.orange, letterSpacing:2, textTransform:"uppercase", marginBottom:8, fontWeight:"bold" }}>🔥 Recommandée pour la perte de poids</div>}
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
            <div>
              <div style={{ fontSize:16, fontWeight:"bold" }}>{t.nom}</div>
              <div style={{ fontSize:12, color:"rgba(255,255,255,0.5)" }}>{t.quand}</div>
            </div>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:6 }}>
              <span style={{ fontSize:12, padding:"3px 10px", borderRadius:20, fontWeight:"bold", background:`${CC_RESP.orange}22`, color:CC_RESP.orange, border:`1px solid ${CC_RESP.orange}88` }}>{t.rythme}</span>
              <span style={{ color:"rgba(255,255,255,0.3)", fontSize:18 }}>›</span>
            </div>
          </div>
          <div style={{ fontSize:13, color:"rgba(255,255,255,0.75)", lineHeight:1.6 }}>{t.desc}</div>
        </div>
      ))}
    </div>
  );
}

function ModuleRespiration({ onRetour }) {
  const [ecran, setEcran] = React.useState("choix");
  const [tech, setTech] = React.useState(null);
  const [nbCycles, setNbCycles] = React.useState(0);
  if (ecran === "histo")
    return <RespEcranHistorique onRetour={() => setEcran("choix")} />;
  if (ecran === "config" && tech)
    return <RespEcranConfig tech={tech} onDemarrer={(n) => { setNbCycles(n); setEcran("exercice"); }} onRetour={() => setEcran("choix")} />;
  if (ecran === "exercice" && tech)
    return <RespEcranExercice tech={tech} nbCycles={nbCycles} onRetour={() => setEcran("choix")} />;
  return <RespEcranChoix onChoisir={(t) => { setTech(t); setEcran("config"); }} onHistorique={() => setEcran("histo")} />;
}
// ─── FIN MODULE RESPIRATION ───────────────────────────────────────────────────

// ─── MODULE ÉVOLUTION PREMIUM ────────────────────────────────────────────────
const PHOTOS_KEY = "cetoclub_photos_evolution";

function CourbeSVG({ data, couleur, unite, labelY }) {
  if (!data || data.length < 2) return (
    <div style={{textAlign:"center",padding:"18px 0",fontSize:11,color:"#9CA3AF"}}>
      Ajoute au moins 2 entrées pour voir la courbe 📈
    </div>
  );
  const W = 300, H = 110, PL = 36, PR = 8, PT = 10, PB = 24;
  const vals = data.map(d => d.val);
  const min = Math.min(...vals), max = Math.max(...vals);
  const range = max - min || 1;
  const px = (i) => PL + (i / (data.length - 1)) * (W - PL - PR);
  const py = (v) => PT + (1 - (v - min) / range) * (H - PT - PB);
  const pts = data.map((d, i) => `${px(i)},${py(d.val)}`).join(" ");
  const aire = `${PL},${H - PB} ` + data.map((d, i) => `${px(i)},${py(d.val)}`).join(" ") + ` ${px(data.length-1)},${H - PB}`;
  // graduations Y
  const steps = 3;
  const grads = Array.from({length: steps+1}, (_,i) => min + (range / steps) * i);
  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{overflow:"visible"}}>
      {/* Aire sous la courbe */}
      <polygon points={aire} fill={couleur} fillOpacity="0.08"/>
      {/* Lignes de grille */}
      {grads.map((v,i) => (
        <g key={i}>
          <line x1={PL} y1={py(v)} x2={W-PR} y2={py(v)} stroke="#E5E7EB" strokeWidth="1" strokeDasharray="3,3"/>
          <text x={PL-4} y={py(v)+4} textAnchor="end" fontSize="8" fill="#9CA3AF">{v.toFixed(1)}</text>
        </g>
      ))}
      {/* Courbe */}
      <polyline points={pts} fill="none" stroke={couleur} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round"/>
      {/* Points */}
      {data.map((d, i) => (
        <g key={i}>
          <circle cx={px(i)} cy={py(d.val)} r="4" fill="#fff" stroke={couleur} strokeWidth="2"/>
          {i === data.length-1 && (
            <text x={px(i)} y={py(d.val)-9} textAnchor="middle" fontSize="9" fontWeight="bold" fill={couleur}>
              {d.val}{unite}
            </text>
          )}
        </g>
      ))}
      {/* Labels X — premier et dernier */}
      {[0, data.length-1].map(i => (
        <text key={i} x={px(i)} y={H} textAnchor="middle" fontSize="8" fill="#9CA3AF">
          {data[i].label}
        </text>
      ))}
    </svg>
  );
}

function ModuleEvolution({ todayStr, poidsHistorique, mensHistorique }) {
  const [onglet, setOnglet] = React.useState(null); // null = replié | poids | mensurations | photos
  const lirePhotos = () => { try { return JSON.parse(localStorage.getItem(PHOTOS_KEY)||"[]"); } catch { return []; } };
  const [photos, setPhotos] = React.useState(lirePhotos);
  const moisActuel = new Date().toISOString().slice(0,7);
  const dejaPhoto = photos.some(p => p.date.slice(0,7) === moisActuel);

  const formatMois = (iso) => {
    const [y,m] = iso.split("-");
    const noms = ["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"];
    return noms[parseInt(m,10)-1] + " " + y;
  };
  const formatDate = (iso) => {
    const [,m,d] = iso.split("-");
    const noms = ["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"];
    return d + " " + noms[parseInt(m,10)-1];
  };

  const ajouterPhoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const today = todayStr();
      const nouvelle = { date: today, src: ev.target.result };
      const updated = [...photos.filter(p => p.date.slice(0,7) !== moisActuel), nouvelle]
        .sort((a,b) => a.date.localeCompare(b.date));
      setPhotos(updated);
      try { localStorage.setItem(PHOTOS_KEY, JSON.stringify(updated)); } catch {}
    };
    reader.readAsDataURL(file);
  };
  const supprimerPhoto = (date) => {
    if (!window.confirm("Supprimer cette photo ?")) return;
    const updated = photos.filter(p => p.date !== date);
    setPhotos(updated);
    try { localStorage.setItem(PHOTOS_KEY, JSON.stringify(updated)); } catch {}
  };

  // Données pour les courbes
  const dataPoids = poidsHistorique.slice(-12).map(d => ({ val: d.poids, label: formatDate(d.date) }));
  const dataTaille = (mensHistorique||[]).filter(e=>e.taille).slice(-12).map(d => ({ val: parseFloat(d.taille), label: formatDate(d.date) }));
  const dataHanches = (mensHistorique||[]).filter(e=>e.hanches).slice(-12).map(d => ({ val: parseFloat(d.hanches), label: formatDate(d.date) }));
  const dataCuisseD = (mensHistorique||[]).filter(e=>e.cuisseD).slice(-12).map(d => ({ val: parseFloat(d.cuisseD), label: formatDate(d.date) }));

  // Delta poids
  const deltaPoids = dataPoids.length >= 2 ? (dataPoids[dataPoids.length-1].val - dataPoids[0].val).toFixed(1) : null;

  const onglets = [
    { id:"poids", l:"⚖️ Poids" },
    { id:"mensurations", l:"📏 Cm" },
    { id:"photos", l:"📸 Photos" },
  ];

  return (
    <div style={{borderRadius:14,marginBottom:14,boxShadow:"0 2px 12px rgba(27,58,107,0.10)"}}>
      {/* Header cliquable */}
      <div onClick={()=>setOnglet(onglet?null:"poids")}
        style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:onglet?"14px 14px 0 0":14,cursor:"pointer"}}>
        <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>📊 Mon évolution</div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{display:"flex",alignItems:"center",gap:5,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px"}}>
            <span style={{fontSize:11}}>💎</span>
            <span style={{fontSize:10,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
          </div>
          <span style={{fontSize:12,color:"rgba(255,255,255,0.7)"}}>{onglet?"▲":"▼"}</span>
        </div>
      </div>

      {onglet && (
      <div style={{background:"#fff",borderRadius:"0 0 14px 14px",padding:16}}>
      {/* Onglets internes */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:0,marginBottom:16,borderRadius:8,overflow:"hidden",border:"1.5px solid #E5E7EB"}}>
        {onglets.map((o,i) => (
          <button key={o.id} onClick={()=>setOnglet(o.id)}
            style={{padding:"8px 4px",border:"none",borderRight:i<2?"1px solid #E5E7EB":"none",
              background:onglet===o.id?"#1B3A6B":"#fff",
              color:onglet===o.id?"#fff":"#6B7280",
              fontWeight:onglet===o.id?900:600,fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>
            {o.l}
          </button>
        ))}
      </div>

      {/* ── Courbe poids ── */}
      {onglet === "poids" && (
        <div>
          {deltaPoids !== null && (
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:14}}>
              {[
                {l:"Départ", v:dataPoids[0].val+"kg", c:"#6B7280"},
                {l:"Actuel", v:dataPoids[dataPoids.length-1].val+"kg", c:"#1B3A6B"},
                {l:"Évolution", v:(parseFloat(deltaPoids)>0?"+":"")+deltaPoids+"kg", c:parseFloat(deltaPoids)<0?"#7CB342":"#C62828"},
              ].map(m=>(
                <div key={m.l} style={{background:"#F8FAFF",borderRadius:10,padding:"10px 8px",textAlign:"center"}}>
                  <div style={{fontSize:16,fontWeight:900,color:m.c}}>{m.v}</div>
                  <div style={{fontSize:9,color:"#9CA3AF",marginTop:2}}>{m.l}</div>
                </div>
              ))}
            </div>
          )}
          <CourbeSVG data={dataPoids} couleur="#1B3A6B" unite="kg" />
          {dataPoids.length < 2 && (
            <div style={{fontSize:10,color:"#9CA3AF",textAlign:"center",marginTop:4}}>
              Enregistre ton poids régulièrement pour voir la courbe
            </div>
          )}
        </div>
      )}

      {/* ── Courbes mensurations ── */}
      {onglet === "mensurations" && (
        <div>
          {[
            {data:dataTaille,  couleur:"#7CB342", label:"Tour de taille"},
            {data:dataHanches, couleur:"#F4A035", label:"Tour de hanches"},
            {data:dataCuisseD, couleur:"#2A5298", label:"Cuisse droite"},
          ].map(({data, couleur, label}) => (
            <div key={label} style={{marginBottom:16}}>
              <div style={{fontSize:11,fontWeight:800,color:"#6B7280",marginBottom:6,display:"flex",justifyContent:"space-between"}}>
                <span>{label}</span>
                {data.length >= 2 && (
                  <span style={{color: (data[data.length-1].val - data[0].val) < 0 ? "#7CB342" : "#C62828", fontWeight:900}}>
                    {(data[data.length-1].val - data[0].val) > 0 ? "+" : ""}{(data[data.length-1].val - data[0].val).toFixed(1)} cm
                  </span>
                )}
              </div>
              <CourbeSVG data={data} couleur={couleur} unite="cm" />
            </div>
          ))}
          {dataTaille.length < 2 && dataHanches.length < 2 && dataCuisseD.length < 2 && (
            <div style={{fontSize:10,color:"#9CA3AF",textAlign:"center",marginTop:4}}>
              Enregistre tes mensurations régulièrement pour voir les courbes
            </div>
          )}
        </div>
      )}

      {/* ── Photos ── */}
      {onglet === "photos" && (
        <div>
          {!dejaPhoto ? (
            <label style={{display:"block",marginBottom:14,cursor:"pointer"}}>
              <div style={{border:"2px dashed #1B3A6B30",borderRadius:12,padding:"20px 16px",textAlign:"center",background:"#F8FAFF"}}>
                <div style={{fontSize:28,marginBottom:6}}>📷</div>
                <div style={{fontSize:12,fontWeight:900,color:"#1B3A6B",marginBottom:2}}>Ajouter la photo du mois</div>
                <div style={{fontSize:10,color:"#9CA3AF"}}>{formatMois(moisActuel)} · Une photo par mois</div>
              </div>
              <input type="file" accept="image/*" onChange={ajouterPhoto} style={{display:"none"}}/>
            </label>
          ) : (
            <div style={{background:"#F1F8E9",borderRadius:10,padding:"10px 14px",marginBottom:14,fontSize:11,color:"#558B2F",fontWeight:700,textAlign:"center"}}>
              ✓ Photo de {formatMois(moisActuel)} enregistrée
            </div>
          )}
          {photos.length === 0 ? (
            <div style={{textAlign:"center",padding:"12px 0",fontSize:11,color:"#9CA3AF"}}>
              Aucune photo encore. Commence ce mois-ci ! 💪
            </div>
          ) : (
            <div>
              <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:8}}>
                {photos.length} photo{photos.length>1?"s":""} · du plus ancien au plus récent
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
                {photos.map((p) => (
                  <div key={p.date} style={{position:"relative",borderRadius:10,overflow:"hidden",aspectRatio:"1",background:"#F3F4F6"}}>
                    <img src={p.src} alt={formatMois(p.date)} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                    <div style={{position:"absolute",bottom:0,left:0,right:0,background:"rgba(0,0,0,0.55)",padding:"4px 6px",textAlign:"center"}}>
                      <div style={{fontSize:9,fontWeight:900,color:"#fff"}}>{formatMois(p.date)}</div>
                    </div>
                    <button onClick={()=>supprimerPhoto(p.date)}
                      style={{position:"absolute",top:4,right:4,background:"rgba(0,0,0,0.5)",border:"none",borderRadius:"50%",width:20,height:20,color:"#fff",fontSize:12,cursor:"pointer",lineHeight:"20px",textAlign:"center",padding:0}}>
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      </div>
      )}
    </div>
  );
}
// ─── MODULE ACTIVITÉ DOUCE PREMIUM ───────────────────────────────────────────
const IMG_ACT = {
  1:"/exercices/Exercice_1_Respiration_abdominale.png",2:"/exercices/Exercice_2_Bascule_du_bassin.png",
  3:"/exercices/Exercice_3_Chat-vache.png",4:"/exercices/Exercice_4_Etirement_lateral_assis.png",
  5:"/exercices/Exercice_5_Pont_fessier.png",6:"/exercices/Exercice_6_Rotation_du_tronc_allonge.png",
  7:"/exercices/Exercice_7_Cercles_de_chevilles.png",8:"/exercices/Exercice_8_Etirement_du_piriforme.png",
  9:"/exercices/Exercice_9_Roulement_vertebral_assis.png",10:"/exercices/Exercice_10_Serrage_des_epaules.png",
  11:"/exercices/Exercice_11_Enroulement_des_poignets.png",12:"/exercices/Exercice_12_Deplacement_du_poids.png",
  13:"/exercices/Exercice_13_Balancement_des_bras.png",14:"/exercices/Exercice_14_Repousser_le_mur.png",
  15:"/exercices/Exercice_15_Rotation_des_hanches.png",16:"/exercices/Exercice_16_Soulever_le_ciel.png",
  17:"/exercices/Exercice_17_Pas_de_lours.png",18:"/exercices/Exercice_18_Cercles_des_epaules.png",
  19:"/exercices/Exercice_19_Ancrage_au_sol.png",20:"/exercices/Exercice_20_Vague_des_bras.png",
  21:"/exercices/Exercice_21_Elevation_des_genoux.png",22:"/exercices/Exercice_22_Extension_de_jambe.png",
  23:"/exercices/Exercice_23_Lever_de_talons_assis.png",24:"/exercices/Exercice_24_Rotation_du_buste_assis.png",
  25:"/exercices/Exercice_25_Inclinaison_laterale_tete.png",26:"/exercices/Exercice_26_Serrage_des_fessiers.png",
  27:"/exercices/Exercice_27_Lever_dorteils_assis.png",28:"/exercices/Exercice_28_Ouverture_poitrine_assis.png",
  29:"/exercices/Exercice_29_Demi-squat_sur_chaise.png",30:"/exercices/Exercice_30_Etirement_du_mollet_assis.png",
};
const EXERCICES_ACT = [
  {id:1,famille:"Pilates",icon:"🧘",nom:"Respiration abdominale",niveau:1,duree:60,description:"Assis ou allongé, pose les mains sur ton ventre. Inspire par le nez en gonflant le ventre, expire lentement par la bouche en rentrant le nombril. Recommence 10 fois à ton rythme.",bienfaits:"Ancrage · Calme · Oxygénation",pourquoi:"En céto, ton corps est en pleine transformation métabolique. Cette respiration calme le système nerveux, réduit le cortisol qui bloque la perte de graisse, et améliore l'oxygénation de toutes tes cellules."},
  {id:2,famille:"Pilates",icon:"🧘",nom:"Bascule du bassin",niveau:1,duree:45,description:"Allongé sur le dos, genoux fléchis. Aplatis le bas du dos contre le sol en expirant, relâche en inspirant. Mouvement très doux, 10 répétitions.",bienfaits:"Lombaires · Mobilité du bassin",pourquoi:"La position assise prolongée fige le bassin. Cet exercice relâche les tensions lombaires accumulées et réactive les muscles profonds du plancher pelvien, souvent négligés."},
  {id:3,famille:"Pilates",icon:"🧘",nom:"Chat-vache à genoux",niveau:1,duree:60,description:"À quatre pattes. En inspirant, creuse le dos (tête en haut). En expirant, arrondis le dos (tête en bas). Alterne lentement 10 fois.",bienfaits:"Colonne vertébrale · Dos · Flexibilité",pourquoi:"La colonne vertébrale adore le mouvement. Cet enchaînement lubrifie les vertèbres, soulage les douleurs de dos fréquentes en début de céto, et active le drainage lymphatique."},
  {id:4,famille:"Pilates",icon:"🧘",nom:"Étirement latéral assis",niveau:1,duree:45,description:"Assis en tailleur ou sur une chaise. Lève le bras droit, penche-toi doucement à gauche. Tiens 15 secondes. Change de côté.",bienfaits:"Flancs · Intercostaux · Souplesse",pourquoi:"Les muscles intercostaux et les flancs sont rarement étirés. Cet exercice améliore la capacité respiratoire et facilite la digestion — deux points clés quand on mange plus de lipides."},
  {id:5,famille:"Pilates",icon:"🧘",nom:"Pont fessier",niveau:2,duree:45,description:"Allongé sur le dos, genoux fléchis. Soulève le bassin vers le plafond en contractant les fessiers. Tiens 5 secondes, redescends. 8 répétitions.",bienfaits:"Fessiers · Abdominaux · Lombaires",pourquoi:"Les fessiers sont les plus gros muscles du corps — les activer en douceur stimule le métabolisme sans épuiser les réserves. En céto, chaque muscle tonifié brûle plus de graisses au repos."},
  {id:6,famille:"Pilates",icon:"🧘",nom:"Rotation du tronc allongé",niveau:1,duree:60,description:"Allongé sur le dos, genoux fléchis collés. Laisse tomber les genoux doucement d'un côté, reviens, puis de l'autre. 10 fois de chaque côté.",bienfaits:"Colonne · Muscles profonds · Détente",pourquoi:"Ce mouvement de torsion douce masse les organes digestifs de l'intérieur, stimule le transit — souvent ralenti en début de régime céto — et détend la chaîne musculaire profonde."},
  {id:7,famille:"Pilates",icon:"🧘",nom:"Cercles de chevilles",niveau:1,duree:30,description:"Assis ou allongé. Lève légèrement un pied et fais des cercles avec la cheville, 10 fois dans chaque sens. Alterne les deux pieds.",bienfaits:"Circulation · Mobilité des chevilles",pourquoi:"En céto, la rétention d'eau diminue rapidement mais la circulation dans les membres inférieurs peut ralentir. Cet exercice active le retour veineux et prévient les jambes lourdes."},
  {id:8,famille:"Pilates",icon:"🧘",nom:"Étirement du piriforme",niveau:1,duree:60,description:"Allongé sur le dos. Croise la cheville droite sur le genou gauche. Attire doucement la jambe gauche vers toi. Tiens 20 sec. Change.",bienfaits:"Hanches · Fessiers · Sciatique",pourquoi:"Le muscle piriforme est souvent contracté chez les personnes sédentaires. Le libérer améliore la circulation dans tout le bas du corps et soulage les tensions sciatiques fréquentes."},
  {id:9,famille:"Pilates",icon:"🧘",nom:"Roulement vertébral assis",niveau:2,duree:60,description:"Assis au bord d'une chaise. Rentre le menton, arrondis progressivement le dos vertèbre par vertèbre en expirant. Redresse-toi en inspirant.",bienfaits:"Dos · Posture · Détente du rachis",pourquoi:"Ce mouvement vertèbre par vertèbre réveille la conscience corporelle et corrige la posture voûtée. Une bonne posture améliore la respiration et donc l'efficacité de la combustion des graisses."},
  {id:10,famille:"Pilates",icon:"🧘",nom:"Serrage des épaules",niveau:1,duree:30,description:"Assis droit. Monte les épaules vers les oreilles en inspirant, tiens 3 secondes, relâche d'un coup en expirant. Répète 10 fois.",bienfaits:"Tensions cervicales · Stress · Nuque",pourquoi:"Le stress chronique élève le cortisol et bloque la perte de poids. Cet exercice de relâchement des trapèzes est l'un des gestes les plus efficaces pour baisser rapidement le niveau de tension."},
  {id:11,famille:"Tai Chi",icon:"☯️",nom:"Enroulement des poignets",niveau:1,duree:60,description:"Debout ou assis. Tends les bras devant toi, fais tourner les poignets lentement en cercles, 10 fois dans chaque sens. Respire librement.",bienfaits:"Articulations · Circulation des mains",pourquoi:"Les articulations ont besoin de mouvement pour se lubrifier. En céto, l'inflammation articulaire diminue souvent — ces rotations douces entretiennent cette amélioration et stimulent la circulation périphérique."},
  {id:12,famille:"Tai Chi",icon:"☯️",nom:"Déplacement du poids",niveau:1,duree:60,description:"Debout, pieds écartés à la largeur des épaules. Déplace lentement le poids du corps sur le pied droit, puis sur le gauche. 10 allers-retours très lents.",bienfaits:"Équilibre · Proprioception · Chevilles",pourquoi:"L'équilibre s'améliore avec la pratique. Cet exercice fondamental du Tai Chi renforce les chevilles et entraîne le cerveau à mieux coordonner le corps — une compétence qui protège des chutes."},
  {id:13,famille:"Tai Chi",icon:"☯️",nom:"Balancement des bras",niveau:1,duree:60,description:"Debout, pieds à la largeur des épaules. Laisse les bras se balancer naturellement gauche-droite, comme des pendules. Corps détendu, genoux légèrement fléchis.",bienfaits:"Détente · Circulation · Dos",pourquoi:"Ce mouvement de balancement active la circulation dans les épaules et le haut du dos, zones de stockage des tensions. Il libère aussi les endorphines, un excellent complément à la clarté mentale du céto."},
  {id:14,famille:"Tai Chi",icon:"☯️",nom:"Repousser le mur",niveau:1,duree:60,description:"Debout. Pousse lentement les deux mains vers l'avant, paumes vers l'extérieur, en expirant. Ramène en inspirant. Mouvement lent et fluide. 10 répétitions.",bienfaits:"Épaules · Concentration · Souffle",pourquoi:"Ce geste iconique du Tai Chi synchronise le souffle et le mouvement, ancrant l'attention dans le présent. La pleine conscience ainsi cultivée réduit les envies de grignotage émotionnel."},
  {id:15,famille:"Tai Chi",icon:"☯️",nom:"Rotation des hanches",niveau:1,duree:60,description:"Debout, mains sur les hanches. Fais des cercles avec le bassin, 10 fois dans le sens des aiguilles, 10 fois dans l'autre. Comme un hula hoop, très lentement.",bienfaits:"Hanches · Lombaires · Souplesse",pourquoi:"Les hanches sont le carrefour du corps. Les faire tourner libère les fascias iliaques, améliore la mobilité générale et stimule la circulation dans les organes digestifs et reproducteurs."},
  {id:16,famille:"Tai Chi",icon:"☯️",nom:"Soulever le ciel",niveau:1,duree:60,description:"Debout. Joins les mains devant le ventre. Monte-les lentement au-dessus de la tête en inspirant, paumes vers le ciel, sur la pointe des pieds. Redescends en expirant. 8 fois.",bienfaits:"Étirement complet · Souffle · Ancrage",pourquoi:"Cet étirement global de toute la chaîne musculaire postérieure est l'un des rares exercices qui travaille le corps entier d'un coup. Il améliore la posture et l'équilibre en une seule action."},
  {id:17,famille:"Tai Chi",icon:"☯️",nom:"Pas de l'ours",niveau:2,duree:120,description:"Debout. Marche sur place très lentement, en levant à peine les pieds. Balance les bras opposés. Respire profondément. 2 minutes en pleine conscience.",bienfaits:"Équilibre · Coordination · Cardio doux",pourquoi:"La marche lente et consciente est l'une des activités les plus bénéfiques pour le système nerveux. En céto, elle favorise l'oxydation des graisses sans déclencher de réponse insulinique."},
  {id:18,famille:"Tai Chi",icon:"☯️",nom:"Cercles des épaules",niveau:1,duree:45,description:"Debout ou assis. Fais des cercles lents avec les épaules — vers l'avant 10 fois, vers l'arrière 10 fois. Ampleur progressive.",bienfaits:"Nuque · Épaules · Tensions du bureau",pourquoi:"Les épaules portent le poids du stress quotidien. Ces rotations débloquent les nœuds musculaires dans les trapèzes et favorisent la circulation vers le cerveau — clé de la clarté mentale céto."},
  {id:19,famille:"Tai Chi",icon:"☯️",nom:"Ancrage au sol",niveau:1,duree:60,description:"Debout, pieds parallèles. Fléchis légèrement les genoux. Imagine des racines qui partent de tes pieds. Respire 10 fois profondément. Immobilité totale.",bienfaits:"Stress · Ancrage mental · Équilibre",pourquoi:"Le système nerveux parasympathique — celui du repos et de la récupération — s'active dans cette posture immobile. Il contrebalance le stress de l'adaptation céto et favorise un meilleur sommeil."},
  {id:20,famille:"Tai Chi",icon:"☯️",nom:"Vague des bras",niveau:1,duree:60,description:"Debout. Lève un bras pendant que l'autre descend, comme une vague. Mouvement continu et fluide, 1 minute sans t'arrêter. Épaules relâchées.",bienfaits:"Fluidité · Coordination · Détente",pourquoi:"Ce mouvement continu et fluide entraîne la coordination entre les deux hémisphères cérébraux. Il améliore la plasticité neurologique et développe la conscience du corps dans l'espace."},
  {id:21,famille:"Gym sur chaise",icon:"🪑",nom:"Élévation des genoux",niveau:1,duree:45,description:"Assis au bord de la chaise, dos droit. Soulève un genou vers la poitrine, tiens 3 secondes, redescends. Alterne. 10 fois de chaque côté.",bienfaits:"Hanches · Abdominaux · Mobilité",pourquoi:"Les fléchisseurs de hanche se raccourcissent avec la position assise. Les réactiver améliore la posture debout, soulage les lombaires et active en douceur les abdominaux profonds."},
  {id:22,famille:"Gym sur chaise",icon:"🪑",nom:"Extension de jambe",niveau:1,duree:45,description:"Assis droit. Tends une jambe à l'horizontale, tiens 5 secondes en contractant la cuisse. Redescends doucement. 8 fois de chaque côté.",bienfaits:"Quadriceps · Genoux · Tonicité",pourquoi:"Les quadriceps sont les moteurs de la marche et des escaliers. Les renforcer sans impact protège les genoux et améliore l'autonomie quotidienne — sans jamais solliciter les articulations fragiles."},
  {id:23,famille:"Gym sur chaise",icon:"🪑",nom:"Lever de talons assis",niveau:1,duree:30,description:"Assis, pieds à plat. Soulève les deux talons ensemble en restant sur la pointe des pieds, tiens 3 secondes, redescends. 15 répétitions.",bienfaits:"Mollets · Circulation · Jambes lourdes",pourquoi:"Les mollets sont le 'deuxième cœur' du corps — leur contraction pompe le sang vers le haut. Cet exercice combat activement les jambes lourdes et prévient les varices souvent aggravées par la sédentarité."},
  {id:24,famille:"Gym sur chaise",icon:"🪑",nom:"Rotation du buste assis",niveau:1,duree:60,description:"Assis, bras croisés sur la poitrine. Tourne lentement le buste à droite en expirant, reviens au centre, puis à gauche. 10 fois de chaque côté.",bienfaits:"Colonne · Mobilité du dos · Digestion",pourquoi:"La torsion du tronc masse directement l'intestin et stimule le péristaltisme. En céto, où la digestion change de nature avec plus de graisses, cet exercice est un allié précieux contre les ballonnements."},
  {id:25,famille:"Gym sur chaise",icon:"🪑",nom:"Inclinaison latérale de la tête",niveau:1,duree:30,description:"Assis droit. Penche doucement la tête vers l'épaule droite, tiens 15 secondes. Reviens au centre, puis à gauche. Ne force jamais.",bienfaits:"Cervicales · Tensions de la nuque",pourquoi:"Les muscles sterno-cléido-mastoïdiens sont presque toujours contractés par l'usage des écrans. Les étirer libère des tensions qui peuvent provoquer des maux de tête — fréquents en début de céto."},
  {id:26,famille:"Gym sur chaise",icon:"🪑",nom:"Serrage des fessiers",niveau:1,duree:30,description:"Assis droit. Contracte les fessiers le plus fort possible, tiens 5 secondes, relâche. 10 répétitions. Discret, peut se faire n'importe où.",bienfaits:"Fessiers · Périnée · Tonus global",pourquoi:"Cet exercice invisible renforce simultanément les fessiers et le plancher pelvien. Tonifier ces muscles améliore la posture générale et active le métabolisme des graisses dans la zone pelvienne."},
  {id:27,famille:"Gym sur chaise",icon:"🪑",nom:"Lever d'orteils assis",niveau:1,duree:30,description:"Assis, talons au sol. Lève les orteils le plus haut possible, tiens 3 secondes, redescends. 15 répétitions. Active la circulation des jambes.",bienfaits:"Jambiers · Chevilles · Varices",pourquoi:"Les muscles jambiers antérieurs, rarement sollicités, jouent un rôle clé dans la stabilité de la marche. Les renforcer améliore l'équilibre et prévient les douleurs de cheville au quotidien."},
  {id:28,famille:"Gym sur chaise",icon:"🪑",nom:"Ouverture poitrine assis",niveau:1,duree:30,description:"Assis au bord de la chaise. Entrecroise les mains derrière le dos, ouvre la poitrine, tire les épaules en arrière. Inspire profondément. Tiens 20 secondes.",bienfaits:"Posture · Pectoraux · Respiration",pourquoi:"Des pectoraux raccourcis compriment les poumons et limitent la capacité respiratoire. Cet étirement libère le thorax, permet des inspirations plus profondes et améliore l'oxygénation — essentielle en céto."},
  {id:29,famille:"Gym sur chaise",icon:"🪑",nom:"Demi-squat sur chaise",niveau:2,duree:45,description:"Debout devant la chaise. Descends lentement comme pour t'asseoir, sans poser les fesses. Remonte. 8 répétitions. Garde le dos droit.",bienfaits:"Cuisses · Fessiers · Genoux en douceur",pourquoi:"Le demi-squat avec la chaise comme filet de sécurité est l'exercice de renforcement le plus sûr qui soit. Il renforce les cuisses et les fessiers de façon fonctionnelle, directement utile pour la vie quotidienne."},
  {id:30,famille:"Gym sur chaise",icon:"🪑",nom:"Étirement du mollet assis",niveau:1,duree:60,description:"Assis, jambe droite tendue. Tire les orteils vers toi avec une serviette ou les mains. Tiens 20 secondes, change. Excellent pour la circulation.",bienfaits:"Mollets · Ischio-jambiers · Circulation",pourquoi:"Les mollets et les ischio-jambiers sont les muscles les plus souvent contracturés. Les étirer améliore la circulation de retour vers le cœur, réduit les crampes nocturnes et favorise un meilleur sommeil."},
];
const FAM_COLORS_ACT = {
  "Pilates":        {bg:"#F0F4FF",border:"#2A5298",text:"#1B3A6B"},
  "Tai Chi":        {bg:"#F1F8E9",border:"#7CB342",text:"#4a7c1f"},
  "Gym sur chaise": {bg:"#FFF8F0",border:"#F4A035",text:"#b8730a"},
};

// ── Lecture objectifs avec fallback dynamique depuis le profil ──────────────
const getObjectifsEffectifs = () => {
  try {
    const saved = JSON.parse(localStorage.getItem("cetoclub_objectifs") || "null");
    if (saved && saved.lip && saved.pro) return saved;
    // Pas encore sauvegardé → calculer depuis le profil
    const p = JSON.parse(localStorage.getItem("cetoclub_profil") || "null");
    if (p && p.poids && p.age && p.taille) {
      const actif = parseFloat(p.activite || 1.2) >= 1.55;
      const age = parseFloat(p.age), poids = parseFloat(p.poids);
      let facteur;
      if (age < 50)       facteur = actif ? 1.8 : 1.25;
      else if (age <= 60) facteur = actif ? 1.8 : 1.5;
      else                facteur = actif ? 1.8 : 1.6;
      const pro = Math.round(facteur * poids);
      const lip = Math.round(1.5 * pro);
      return { lip, glu: 20, pro };
    }
  } catch {}
  return { lip: 150, glu: 20, pro: 80 }; // fallback ultime si profil incomplet
};
// ────────────────────────────────────────────────────────────────────────────
// ── MODULE SPORT PREMIUM ─────────────────────────────────────────────────────
// ────────────────────────────────────────────────────────────────────────────

const LS_SPORT = "cetoclub_sport_seances";
const loadSport = () => { try { return JSON.parse(localStorage.getItem(LS_SPORT)||"[]"); } catch { return []; } };
const saveSport = (d) => { try { localStorage.setItem(LS_SPORT, JSON.stringify(d.slice(0,300))); } catch {} };

const SPORTS_DEF = {
  marche:   { icon:"🚶", label:"Marche & Randonnée" },
  course:   { icon:"🏃", label:"Course / Jogging / HIIT" },
  natation: { icon:"🏊", label:"Natation" },
  velo:     { icon:"🚴", label:"Vélo" },
  muscu:    { icon:"💪", label:"Musculation" },
};

const INTENSITES_SPORT = [
  { val:"faible",  label:"Faible",  color:"#7CB342" },
  { val:"moderee", label:"Modérée", color:"#F4A035" },
  { val:"forte",   label:"Forte",   color:"#C62828" },
];

const EXERCICES_MUSCU = [
  {id:"bench",    groupe:"Pectoraux", label:"Bench press"},
  {id:"pompes",   groupe:"Pectoraux", label:"Pompes"},
  {id:"ecartes",  groupe:"Pectoraux", label:"Écartés haltères"},
  {id:"tractions",groupe:"Dos",       label:"Tractions"},
  {id:"rowing",   groupe:"Dos",       label:"Rowing haltères"},
  {id:"tirage",   groupe:"Dos",       label:"Tirage poulie"},
  {id:"devmil",   groupe:"Épaules",   label:"Développé militaire"},
  {id:"elevlat",  groupe:"Épaules",   label:"Élévations latérales"},
  {id:"curl",     groupe:"Bras",      label:"Curl biceps"},
  {id:"triceps",  groupe:"Bras",      label:"Triceps poulie"},
  {id:"dips",     groupe:"Bras",      label:"Dips"},
  {id:"squat",    groupe:"Jambes",    label:"Squat"},
  {id:"presse",   groupe:"Jambes",    label:"Presse"},
  {id:"fentes",   groupe:"Jambes",    label:"Fentes"},
  {id:"legcurl",  groupe:"Jambes",    label:"Leg curl"},
  {id:"crunchs",  groupe:"Abdos",     label:"Crunchs"},
  {id:"planche",  groupe:"Abdos",     label:"Planche"},
  {id:"relevjam", groupe:"Abdos",     label:"Relevés de jambes"},
];

// ── Formulaire saisie d'une séance ───────────────────────────────────────────
function SportSaisie({ sport, onSave, onCancel }) {
  const [form, setForm] = React.useState({intensite:"moderee",duree:"",distance:"",denivele:"",metres:"",hiit:false,seriesHiit:"8",travailHiit:"30",reposHiit:"30"});
  const [exercices, setExercices] = React.useState([]);
  const [exSel, setExSel] = React.useState(null);
  const [exForm, setExForm] = React.useState({poids:"",series:"3",reps:"10"});

  const inp = {width:"100%",padding:"9px 11px",borderRadius:8,border:"1.5px solid #E5E7EB",fontSize:13,fontFamily:"'Nunito',sans-serif",boxSizing:"border-box"};
  const lbl = {fontSize:10,fontWeight:800,color:"#1B3A6B",textTransform:"uppercase",letterSpacing:1,marginBottom:3,display:"block"};

  const ajouterEx = () => {
    if(!exSel) return;
    if(exercices.find(e=>e.id===exSel.id)) return;
    setExercices(p=>[...p,{...exSel,poids:exForm.poids,series:exForm.series,reps:exForm.reps}]);
    setExSel(null); setExForm({poids:"",series:"3",reps:"10"});
  };

  const sauvegarder = () => {
    const seance = {id:Date.now(),sport,date:new Date().toISOString().split("T")[0],heure:new Date().toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"}),...form,exercices:sport==="muscu"?exercices:undefined};
    saveSport([seance,...loadSport()]);
    onSave();
  };

  const groupes = [...new Set(EXERCICES_MUSCU.map(e=>e.groupe))];

  return (
    <div style={{background:"#F0F4FF",borderRadius:12,padding:14,marginBottom:10}}>
      {/* Durée */}
      <div style={{marginBottom:10}}>
        <label style={lbl}>Durée (min)</label>
        <input type="number" placeholder="Ex : 45" value={form.duree} onChange={e=>setForm(f=>({...f,duree:e.target.value}))} style={inp}/>
      </div>
      {/* Distance km */}
      {["marche","course","velo"].includes(sport) && (
        <div style={{marginBottom:10}}>
          <label style={lbl}>Distance (km)</label>
          <input type="number" placeholder="Ex : 5.2" step="0.1" value={form.distance} onChange={e=>setForm(f=>({...f,distance:e.target.value}))} style={inp}/>
        </div>
      )}
      {/* Dénivelé */}
      {["marche","velo"].includes(sport) && (
        <div style={{marginBottom:10}}>
          <label style={lbl}>Dénivelé (m)</label>
          <input type="number" placeholder="Ex : 250" value={form.denivele} onChange={e=>setForm(f=>({...f,denivele:e.target.value}))} style={inp}/>
        </div>
      )}
      {/* Mètres natation */}
      {sport==="natation" && (
        <div style={{marginBottom:10}}>
          <label style={lbl}>Distance (mètres)</label>
          <input type="number" placeholder="Ex : 1000" value={form.metres} onChange={e=>setForm(f=>({...f,metres:e.target.value}))} style={inp}/>
        </div>
      )}
      {/* HIIT */}
      {sport==="course" && (
        <div style={{marginBottom:10}}>
          <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",marginBottom:6}}>
            <input type="checkbox" checked={form.hiit} onChange={e=>setForm(f=>({...f,hiit:e.target.checked}))} style={{width:15,height:15}}/>
            <span style={{fontSize:13,fontWeight:800,color:"#1B3A6B"}}>Séance HIIT</span>
          </label>
          {form.hiit && (
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
              {[{k:"seriesHiit",l:"Séries"},{k:"travailHiit",l:"Travail (s)"},{k:"reposHiit",l:"Repos (s)"}].map(f=>(
                <div key={f.k}><label style={lbl}>{f.l}</label><input type="number" value={form[f.k]} onChange={e=>setForm(p=>({...p,[f.k]:e.target.value}))} style={inp}/></div>
              ))}
            </div>
          )}
        </div>
      )}
      {/* Intensité (pas musculation) */}
      {sport!=="muscu" && (
        <div style={{marginBottom:10}}>
          <label style={lbl}>Intensité</label>
          <div style={{display:"flex",gap:6}}>
            {INTENSITES_SPORT.map(i=>(
              <button key={i.val} onClick={()=>setForm(f=>({...f,intensite:i.val}))}
                style={{flex:1,padding:"8px 4px",borderRadius:8,border:`2px solid ${form.intensite===i.val?i.color:"#E5E7EB"}`,background:form.intensite===i.val?i.color:"#fff",color:form.intensite===i.val?"#fff":"#6B7280",fontWeight:900,fontSize:12,cursor:"pointer"}}>
                {i.label}
              </button>
            ))}
          </div>
        </div>
      )}
      {/* Exercices musculation */}
      {sport==="muscu" && (
        <div style={{marginBottom:10}}>
          <label style={lbl}>Exercices effectués</label>
          {exercices.length>0 && (
            <div style={{marginBottom:8}}>
              {exercices.map(ex=>(
                <div key={ex.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 10px",background:"#fff",borderRadius:8,border:"1.5px solid #1B3A6B20",marginBottom:5}}>
                  <span style={{fontSize:12,color:"#1B3A6B",fontWeight:800}}>{ex.label} <span style={{fontWeight:400,color:"#6B7280"}}>{ex.poids}kg × {ex.series}s × {ex.reps}r</span></span>
                  <button onClick={()=>setExercices(p=>p.filter(e=>e.id!==ex.id))} style={{background:"none",border:"none",color:"#C62828",fontSize:15,cursor:"pointer"}}>✕</button>
                </div>
              ))}
            </div>
          )}
          <div style={{background:"#fff",borderRadius:8,padding:10,border:"1.5px solid #E5E7EB"}}>
            <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:8,textTransform:"uppercase"}}>Choisir un exercice</div>
            {groupes.map(g=>(
              <div key={g} style={{marginBottom:8}}>
                <div style={{fontSize:10,color:"#6B7280",fontWeight:700,marginBottom:4}}>{g}</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
                  {EXERCICES_MUSCU.filter(e=>e.groupe===g).map(ex=>(
                    <button key={ex.id} onClick={()=>setExSel(ex)}
                      style={{padding:"4px 9px",borderRadius:16,border:`1.5px solid ${exSel?.id===ex.id?"#1B3A6B":"#E5E7EB"}`,background:exSel?.id===ex.id?"#1B3A6B":"#fff",color:exSel?.id===ex.id?"#fff":"#374151",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                      {ex.label}
                    </button>
                  ))}
                </div>
              </div>
            ))}
            {exSel && (
              <div style={{marginTop:8,borderTop:"1px solid #E5E7EB",paddingTop:8}}>
                <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:6}}>{exSel.label}</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6,marginBottom:8}}>
                  {[{k:"poids",l:"Poids (kg)"},{k:"series",l:"Séries"},{k:"reps",l:"Reps"}].map(f=>(
                    <div key={f.k}><label style={lbl}>{f.l}</label><input type="number" value={exForm[f.k]} onChange={e=>setExForm(p=>({...p,[f.k]:e.target.value}))} style={inp}/></div>
                  ))}
                </div>
                <button onClick={ajouterEx} style={{width:"100%",padding:"8px",borderRadius:8,background:"#1B3A6B",color:"#fff",border:"none",fontWeight:900,fontSize:12,cursor:"pointer"}}>➕ Ajouter</button>
              </div>
            )}
          </div>
        </div>
      )}
      <div style={{display:"flex",gap:8,marginTop:4}}>
        <button onClick={sauvegarder} style={{flex:2,padding:"11px",borderRadius:10,background:"linear-gradient(135deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer"}}>✅ Enregistrer</button>
        <button onClick={onCancel} style={{flex:1,padding:"11px",borderRadius:10,background:"#fff",color:"#6B7280",border:"1.5px solid #E5E7EB",fontWeight:800,fontSize:12,cursor:"pointer"}}>Annuler</button>
      </div>
    </div>
  );
}

// ── Bandeau d'un sport (saisie + historique, PAS de courbes) ─────────────────
function BandeauSport({ sport, PREMIUM_ACTIF, setPage }) {
  const [ouvert, setOuvert] = React.useState(false);
  const [saisie, setSaisie] = React.useState(false);
  const [seances, setSeances] = React.useState(()=>loadSport().filter(s=>s.sport===sport));
  const [vue, setVue] = React.useState("hebdo");
  const s = SPORTS_DEF[sport];

  const refreshSeances = () => setSeances(loadSport().filter(s2=>s2.sport===sport));

  const now = new Date();
  const debut = new Date(now);
  if(vue==="hebdo") debut.setDate(now.getDate()-6); else debut.setDate(1);
  debut.setHours(0,0,0,0);
  const seancesPeriode = seances.filter(s2=>new Date(s2.date)>=debut);

  if(!PREMIUM_ACTIF) {
    return (
      <BandeauPremium
        titre={`${s.icon} ${s.label}`}
        description={`Enregistre tes séances de ${s.label.toLowerCase()}, suis ta progression semaine après semaine.`}
        onClick={()=>setPage("premium")}
      />
    );
  }

  return (
    <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.08)"}}>
      <div onClick={()=>setOuvert(o=>!o)} style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"13px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:20}}>{s.icon}</span>
          <div>
            <div style={{color:"#fff",fontWeight:900,fontSize:14}}>{s.label}{sport==="marche"?" & Podomètre":""}</div>
            <div style={{fontSize:10,color:"rgba(255,255,255,0.6)",marginTop:1}}>{seancesPeriode.length} séance{seancesPeriode.length!==1?"s":""} · {vue==="hebdo"?"7 jours":"ce mois"}</div>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          {sport==="marche" && (
            <button onClick={e=>{e.stopPropagation();setPage("podometre");}} style={{background:"linear-gradient(135deg,#7CB342,#558B2F)",border:"none",borderRadius:16,padding:"4px 10px",color:"#fff",fontSize:10,fontWeight:800,cursor:"pointer"}}>👟 Pas</button>
          )}
          <div style={{background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"3px 10px",fontSize:10,fontWeight:800,color:"#fff"}}>✨ Premium</div>
          <span style={{color:"rgba(255,255,255,0.6)",fontSize:16}}>{ouvert?"▲":"▼"}</span>
        </div>
      </div>
      {ouvert && (
        <div style={{background:"#fff",padding:14}}>
          <div style={{display:"flex",gap:6,marginBottom:12,alignItems:"center"}}>
            {[{k:"hebdo",l:"7 jours"},{k:"mensuel",l:"Ce mois"}].map(v=>(
              <button key={v.k} onClick={()=>setVue(v.k)} style={{padding:"5px 12px",borderRadius:20,border:"none",background:vue===v.k?"#1B3A6B":"#F3F4F6",color:vue===v.k?"#fff":"#6B7280",fontWeight:800,fontSize:11,cursor:"pointer"}}>{v.l}</button>
            ))}
            <button onClick={()=>setSaisie(s2=>!s2)} style={{marginLeft:"auto",padding:"6px 14px",borderRadius:20,border:"none",background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",fontWeight:900,fontSize:12,cursor:"pointer"}}>➕ Séance</button>
          </div>
          {saisie && <SportSaisie sport={sport} onSave={()=>{refreshSeances();setSaisie(false);}} onCancel={()=>setSaisie(false)}/>}
          {seancesPeriode.length===0 ? (
            <div style={{textAlign:"center",padding:"18px 0",color:"#9CA3AF",fontSize:13}}>Aucune séance sur cette période.<br/>Appuie sur ➕ Séance pour commencer !</div>
          ) : (
            seancesPeriode.map(se=>(
              <div key={se.id} style={{padding:"9px 11px",background:"#FAFAF7",borderRadius:10,marginBottom:7,border:"1.5px solid #1B3A6B10"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <span style={{fontSize:12,fontWeight:900,color:"#1B3A6B"}}>{new Date(se.date).toLocaleDateString("fr-FR",{weekday:"short",day:"numeric",month:"short"})}{se.heure?` · ${se.heure}`:""}</span>
                  {se.intensite&&<span style={{fontSize:11,fontWeight:700,color:INTENSITES_SPORT.find(i=>i.val===se.intensite)?.color||"#6B7280"}}>{INTENSITES_SPORT.find(i=>i.val===se.intensite)?.label}</span>}
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                  {se.duree&&<span style={{fontSize:11,color:"#6B7280"}}>⏱ {se.duree} min</span>}
                  {se.distance&&<span style={{fontSize:11,color:"#6B7280"}}>📍 {se.distance} km</span>}
                  {se.metres&&<span style={{fontSize:11,color:"#6B7280"}}>📍 {se.metres} m</span>}
                  {se.denivele&&<span style={{fontSize:11,color:"#6B7280"}}>⛰ {se.denivele} m D+</span>}
                  {se.hiit&&<span style={{fontSize:11,color:"#F4A035",fontWeight:800}}>⚡ HIIT {se.seriesHiit}×{se.travailHiit}s/{se.reposHiit}s repos</span>}
                  {se.exercices?.length>0&&<span style={{fontSize:11,color:"#6B7280"}}>💪 {se.exercices.length} exercice{se.exercices.length>1?"s":""}</span>}
                </div>
                {se.exercices?.length>0&&(
                  <div style={{marginTop:5,display:"flex",flexWrap:"wrap",gap:4}}>
                    {se.exercices.map(ex=>(
                      <span key={ex.id} style={{fontSize:10,background:"#EEF2FF",borderRadius:6,padding:"2px 7px",color:"#1B3A6B",fontWeight:700}}>{ex.label} {ex.poids}kg×{ex.series}×{ex.reps}</span>
                    ))}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

// ── Courbes globales tout en bas ─────────────────────────────────────────────
function CourbesSport() {
  const [vue, setVue] = React.useState("hebdo");
  const [sportActif, setSportActif] = React.useState(null);
  const seancesToutes = loadSport();
  const sportsPratiques = [...new Set(seancesToutes.map(s=>s.sport))].filter(s=>SPORTS_DEF[s]);

  React.useEffect(()=>{ if(!sportActif && sportsPratiques.length>0) setSportActif(sportsPratiques[0]); },[]);

  if(seancesToutes.length===0) return null;
  if(!sportActif) return null;

  const now = new Date();
  const jours = vue==="hebdo"?7:30;
  const dates=[], labels=[];
  for(let i=jours-1;i>=0;i--) {
    const d=new Date(now); d.setDate(now.getDate()-i); d.setHours(0,0,0,0);
    dates.push(d.toISOString().split("T")[0]);
    labels.push(vue==="hebdo"?d.toLocaleDateString("fr-FR",{weekday:"short"}):d.getDate().toString());
  }

  const getVal = (se) => {
    if(sportActif==="natation") return parseFloat(se.metres)||0;
    if(sportActif==="muscu") return se.exercices?.length||0;
    if(se.distance) return parseFloat(se.distance)||0;
    return parseFloat(se.duree)||0;
  };
  const unitLabel = sportActif==="natation"?"m":sportActif==="muscu"?"ex":["marche","velo","course"].includes(sportActif)?"km":"min";

  const data = dates.map(d=>seancesToutes.filter(s=>s.sport===sportActif&&s.date===d).reduce((sum,s)=>sum+getVal(s),0));
  const max = Math.max(...data,1);
  const W=280,H=70;
  const pts = data.map((v,i)=>({x:i*(W/(jours-1)),y:H-Math.round((v/max)*H)}));
  const path = pts.map((p,i)=>i===0?`M${p.x},${p.y}`:`L${p.x},${p.y}`).join(" ");
  const area = `${path} L${pts[pts.length-1].x},${H} L0,${H} Z`;

  return (
    <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.08)"}}>
      <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"13px 16px"}}>
        <div style={{color:"#fff",fontWeight:900,fontSize:14}}>📈 Courbes de progression</div>
        <div style={{fontSize:10,color:"rgba(255,255,255,0.6)",marginTop:1}}>Tous tes sports, semaine par semaine</div>
      </div>
      <div style={{background:"#fff",padding:14}}>
        <div style={{display:"flex",gap:6,marginBottom:10,flexWrap:"wrap"}}>
          {[{k:"hebdo",l:"7 jours"},{k:"mensuel",l:"30 jours"}].map(v=>(
            <button key={v.k} onClick={()=>setVue(v.k)} style={{padding:"5px 12px",borderRadius:20,border:"none",background:vue===v.k?"#1B3A6B":"#F3F4F6",color:vue===v.k?"#fff":"#6B7280",fontWeight:800,fontSize:11,cursor:"pointer"}}>{v.l}</button>
          ))}
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:12}}>
          {sportsPratiques.map(sp=>(
            <button key={sp} onClick={()=>setSportActif(sp)} style={{padding:"4px 11px",borderRadius:16,border:`1.5px solid ${sportActif===sp?"#1B3A6B":"#E5E7EB"}`,background:sportActif===sp?"#1B3A6B":"#fff",color:sportActif===sp?"#fff":"#6B7280",fontWeight:800,fontSize:11,cursor:"pointer"}}>
              {SPORTS_DEF[sp]?.icon} {SPORTS_DEF[sp]?.label}
            </button>
          ))}
        </div>
        <svg viewBox={`0 0 ${W} ${H+20}`} style={{width:"100%",display:"block"}}>
          <defs>
            <linearGradient id="csg" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#1B3A6B" stopOpacity="0.15"/>
              <stop offset="100%" stopColor="#1B3A6B" stopOpacity="0"/>
            </linearGradient>
          </defs>
          <path d={area} fill="url(#csg)"/>
          <path d={path} fill="none" stroke="#1B3A6B" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round"/>
          {pts.map((p,i)=>data[i]>0&&(
            <g key={i}>
              <circle cx={p.x} cy={p.y} r="3" fill="#1B3A6B"/>
              <text x={p.x} y={p.y-6} textAnchor="middle" fontSize="8" fill="#1B3A6B" fontWeight="bold">{data[i]}</text>
            </g>
          ))}
          {labels.map((l,i)=>{
            if(vue==="mensuel"&&i%5!==0) return null;
            return <text key={i} x={pts[i].x} y={H+14} textAnchor="middle" fontSize="8" fill="#9CA3AF">{l}</text>;
          })}
        </svg>
        <div style={{textAlign:"center",fontSize:11,color:"#9CA3AF",marginTop:4}}>{unitLabel} · {vue==="hebdo"?"7 derniers jours":"30 derniers jours"}</div>
      </div>
    </div>
  );
}

// ────────────────────────────────────────────────────────────────────────────
const LS_SEANCES_ACT = "cetoclub_activite_seances_v2";
const LS_MARCHE_ACT  = "cetoclub_marche";
const todayKeyAct = () => {
  const d = new Date();
  return d.toLocaleDateString("fr-FR", {year:"numeric",month:"2-digit",day:"2-digit"}).split("/").reverse().join("-");
};
const loadSeancesAct = () => { try { return JSON.parse(localStorage.getItem(LS_SEANCES_ACT)||"[]"); } catch { return []; } };
const saveSeancesAct = (s) => { try { localStorage.setItem(LS_SEANCES_ACT, JSON.stringify(s.slice(0,60))); } catch {} };
const calcJoursDeSuite = (seances) => {
  if (!seances.length) return 0;
  const dates = [...new Set(seances.map(s=>s.date))].sort().reverse();
  let jours = 0;
  let cursor = new Date(); cursor.setHours(0,0,0,0);
  for (const d of dates) {
    const sd = new Date(d); sd.setHours(0,0,0,0);
    const diff = Math.round((cursor - sd) / 86400000);
    if (diff === 0 || diff === 1) { jours++; cursor = sd; } else break;
  }
  return jours;
};

function MinuteurAct({ duree, onFin }) {
  const [actif, setActif] = React.useState(false);
  const [reste, setReste] = React.useState(duree);
  const [termine, setTermine] = React.useState(false);
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (actif && reste > 0) { ref.current = setInterval(() => setReste(r => r-1), 1000); }
    else if (reste === 0 && actif) { clearInterval(ref.current); setActif(false); setTermine(true); onFin && onFin(); }
    return () => clearInterval(ref.current);
  }, [actif, reste]);
  const reset = () => { setReste(duree); setActif(false); setTermine(false); };
  const pct = ((duree - reste) / duree) * 100;
  return (
    <div style={{background:"#fff",borderRadius:12,padding:14,marginBottom:12,border:"1px solid #e5e7eb"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
        <div>
          <div style={{fontSize:24,fontWeight:"bold",color:termine?"#7CB342":"#1B3A6B",fontVariantNumeric:"tabular-nums"}}>
            {String(Math.floor(reste/60)).padStart(2,"0")}:{String(reste%60).padStart(2,"0")}
          </div>
          <div style={{fontSize:11,color:"#6B7280",marginTop:2}}>{termine?"Exercice terminé ! 🎉":actif?"En cours...":"Prêt à démarrer"}</div>
        </div>
        <div style={{display:"flex",gap:6}}>
          {!termine && (
            <button onClick={()=>setActif(a=>!a)} style={{background:actif?"#fff3cd":"#1B3A6B",color:actif?"#856404":"#fff",border:"none",borderRadius:8,padding:"7px 14px",fontSize:13,cursor:"pointer",fontFamily:"Georgia,serif"}}>
              {actif?"⏸ Pause":reste===duree?"▶ Démarrer":"▶ Reprendre"}
            </button>
          )}
          <button onClick={reset} style={{background:"#f8f9fa",color:"#6B7280",border:"1px solid #dee2e6",borderRadius:8,padding:"7px 10px",fontSize:13,cursor:"pointer"}}>↺</button>
        </div>
      </div>
      <div style={{height:6,background:"#f0f0f0",borderRadius:3,overflow:"hidden"}}>
        <div style={{height:"100%",width:`${pct}%`,background:termine?"#7CB342":"#2A5298",borderRadius:3,transition:"width 0.5s"}}/>
      </div>
    </div>
  );
}

function TrackerMarcheAct() {
  const [minutes, setMinutes] = React.useState(() => {
    try { const s=JSON.parse(localStorage.getItem(LS_MARCHE_ACT)||"{}"); return s[todayKeyAct()]||0; } catch { return 0; }
  });
  const ajouter = (n) => {
    try {
      const s=JSON.parse(localStorage.getItem(LS_MARCHE_ACT)||"{}");
      const nv=(s[todayKeyAct()]||0)+n; s[todayKeyAct()]=nv;
      localStorage.setItem(LS_MARCHE_ACT,JSON.stringify(s)); setMinutes(nv);
    } catch {}
  };
  const objectif=30; const pct=Math.min((minutes/objectif)*100,100);
  return (
    <div style={{background:"#fff",borderRadius:16,padding:16,marginBottom:16,boxShadow:"0 2px 12px rgba(27,58,107,0.08)"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div>
          <div style={{fontSize:11,color:"#6B7280",letterSpacing:1,textTransform:"uppercase"}}>🚶‍♀️ Marche du jour</div>
          <div style={{fontSize:20,fontWeight:"bold",color:"#1B3A6B"}}>{minutes} min <span style={{fontSize:13,color:"#6B7280",fontWeight:"normal"}}>/ objectif {objectif} min</span></div>
        </div>
        <div style={{fontSize:24}}>{minutes>=objectif?"🎉":"👟"}</div>
      </div>
      <div style={{height:8,background:"#f0f0f0",borderRadius:4,marginBottom:12,overflow:"hidden"}}>
        <div style={{height:"100%",width:`${pct}%`,background:pct>=100?"#7CB342":"#2A5298",borderRadius:4,transition:"width 0.4s"}}/>
      </div>
      <div style={{display:"flex",gap:8}}>
        {[5,10,15,20,30].map(n=>(
          <button key={n} onClick={()=>ajouter(n)} style={{flex:1,background:"#F0F4FF",border:"1px solid #2A5298",borderRadius:8,padding:"6px 2px",fontSize:12,color:"#1B3A6B",cursor:"pointer",fontFamily:"Georgia,serif"}}>+{n}m</button>
        ))}
      </div>
    </div>
  );
}

function JoursDeSuiteBadge({ jours }) {
  if (jours === 0) return null;
  const bg = jours>=7?"linear-gradient(135deg,#F4A035,#E65100)":jours>=3?"linear-gradient(135deg,#7CB342,#558B2F)":"linear-gradient(135deg,#2A5298,#1B3A6B)";
  const icon = jours>=7?"🏆":jours>=3?"🔥":"⚡";
  return (
    <div style={{display:"inline-flex",alignItems:"center",gap:6,background:bg,borderRadius:20,padding:"5px 14px",color:"#fff"}}>
      <span style={{fontSize:16}}>{icon}</span>
      <span style={{fontSize:12,fontWeight:"bold"}}>{jours} jour{jours>1?"s":""} de suite</span>
    </div>
  );
}


// ── PODOMÈTRE PREMIUM ──────────────────────────────────────────────
const LS_PODO = "cetoclub_podometre";
const loadPodo = () => { try { return JSON.parse(localStorage.getItem(LS_PODO)||"{}"); } catch { return {}; } };
const savePodo = (d) => { try { localStorage.setItem(LS_PODO, JSON.stringify(d)); } catch {} };

// Calcule l'objectif de pas personnalisé selon IMC, âge, sexe, activité
const calcObjectifPas = (profil) => {
  if (!profil) return 7000;
  const poids   = parseFloat(profil.poids)       || 0;
  const taille  = parseFloat(profil.taille)      || 0;
  const age     = parseInt(profil.age)           || 40;
  const sexe    = profil.sexe || "F";
  const activite= parseFloat(profil.activite)    || 1.2;
  if (!poids || !taille) return 7000;

  const imc = poids / ((taille / 100) ** 2);

  // Base selon IMC
  let base;
  if      (imc >= 45) base = 4000;
  else if (imc >= 40) base = 5000;
  else if (imc >= 35) base = 6000;
  else if (imc >= 30) base = 7500;
  else if (imc >= 25) base = 9000;
  else                base = 10000;

  // Coefficient sexe (les hommes ont généralement une foulée plus longue)
  const coeffSexe = sexe === "H" ? 1.05 : 1.0;

  // Coefficient âge
  let coeffAge = 1.0;
  if      (age >= 75) coeffAge = 0.80;
  else if (age >= 65) coeffAge = 0.88;
  else if (age >= 55) coeffAge = 0.94;

  // Coefficient activité habituelle
  let coeffAct = 1.0;
  if      (activite >= 1.725) coeffAct = 1.15;  // très actif
  else if (activite >= 1.55)  coeffAct = 1.08;  // actif
  else if (activite >= 1.375) coeffAct = 1.0;   // modéré
  else                        coeffAct = 0.88;  // sédentaire

  const resultat = Math.round((base * coeffSexe * coeffAge * coeffAct) / 500) * 500;
  return Math.max(3000, Math.min(12000, resultat));
};

// Libellé du palier IMC
const libellePalierIMC = (imc) => {
  if (!imc) return null;
  if      (imc >= 45) return { label: "Prochain palier à IMC < 45", cible: 45 };
  else if (imc >= 40) return { label: "Prochain palier à IMC < 40", cible: 40 };
  else if (imc >= 35) return { label: "Prochain palier à IMC < 35", cible: 35 };
  else if (imc >= 30) return { label: "Prochain palier à IMC < 30", cible: 30 };
  else if (imc >= 25) return { label: "Prochain palier à IMC < 25", cible: 25 };
  return null;
};

function PodometrePremium() {
  const today = todayKeyAct();

  // Lecture du profil en direct
  const profil = React.useMemo(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_profil")||"{}"); } catch { return {}; }
  }, []);

  const objectifCalcule = React.useMemo(() => calcObjectifPas(profil), [profil]);

  const [data, setData]       = React.useState(() => loadPodo());
  const [saisie, setSaisie]   = React.useState("");
  const [objectifManuel, setObjectifManuel] = React.useState(() => {
    try {
      const s = localStorage.getItem("cetoclub_podo_obj_manuel");
      return s ? parseInt(s) : null;
    } catch { return null; }
  });
  const [editObj, setEditObj]   = React.useState(false);
  const [objSaisie, setObjSaisie] = React.useState("");
  const [bandeauVisible, setBandeauVisible] = React.useState(true);

  const objectif = objectifManuel || objectifCalcule;
  const pasAujourdhui = data[today] || 0;
  const pct = Math.min(100, Math.round((pasAujourdhui / objectif) * 100));

  // Données profil pour affichage
  const poids   = parseFloat(profil.poids)  || null;
  const taille  = parseFloat(profil.taille) || null;
  const age     = parseInt(profil.age)      || null;
  const imc     = poids && taille ? poids / ((taille / 100) ** 2) : null;
  const palier  = libellePalierIMC(imc);

  // Poids à atteindre pour prochain palier (= poids cible à l'IMC suivant)
  const poidsProchainspalier = palier && taille
    ? Math.round(palier.cible * ((taille / 100) ** 2))
    : null;
  const kgRestants = poidsProchainspalier && poids
    ? Math.max(0, Math.round(poids - poidsProchainspalier))
    : null;

  // Objectif au prochain palier
  const objectifProchain = palier ? calcObjectifPas({
    ...profil,
    poids: poidsProchainspalier
  }) : null;

  const sauvegarderPas = () => {
    const val = parseInt(saisie);
    if (!val || val < 0 || val > 100000) return;
    const nv = { ...data, [today]: val };
    setData(nv); savePodo(nv); setSaisie("");
  };

  const sauvegarderObjectif = () => {
    const val = parseInt(objSaisie);
    if (!val || val < 1000) return;
    localStorage.setItem("cetoclub_podo_obj_manuel", String(val));
    setObjectifManuel(val); setEditObj(false); setObjSaisie("");
  };

  const reinitialiserObjectif = () => {
    localStorage.removeItem("cetoclub_podo_obj_manuel");
    setObjectifManuel(null); setEditObj(false);
  };

  // Historique 30 derniers jours avec données
  const historique = React.useMemo(() => {
    const jours = [];
    for (let i = 29; i >= 0; i--) {
      const d = new Date(); d.setDate(d.getDate() - i);
      const key = d.toLocaleDateString("fr-FR",{year:"numeric",month:"2-digit",day:"2-digit"}).split("/").reverse().join("-");
      const label = d.toLocaleDateString("fr-FR",{day:"numeric",month:"short"});
      if (data[key] !== undefined) jours.push({ key, label, val: data[key] });
    }
    return jours;
  }, [data]);

  // Courbe SVG avec ligne objectif en pointillés
  const CourbePas = () => {
    if (historique.length < 2) return (
      <div style={{textAlign:"center",padding:"18px 0",fontSize:11,color:"#9CA3AF"}}>
        Saisis tes pas au moins 2 jours pour voir la courbe 📈
      </div>
    );
    const W = 300, H = 120, PL = 42, PR = 18, PT = 14, PB = 24;
    const vals = historique.map(d => d.val);
    const maxV = Math.max(...vals, objectif) * 1.12;
    const px = (i) => PL + (i / (historique.length - 1)) * (W - PL - PR);
    const py = (v) => PT + (1 - v / maxV) * (H - PT - PB);
    const pts = historique.map((d, i) => `${px(i)},${py(d.val)}`).join(" ");
    const aire = `${PL},${H-PB} ` + historique.map((d,i)=>`${px(i)},${py(d.val)}`).join(" ") + ` ${px(historique.length-1)},${H-PB}`;
    const yObj = py(objectif);
    const fmt = (v) => v >= 1000 ? `${(v/1000).toFixed(1)}k` : String(v);
    const grads = [0, Math.round(maxV*0.33), Math.round(maxV*0.66), Math.round(maxV)];

    return (
      <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{overflow:"visible"}}>
        {grads.map((v,i) => (
          <g key={i}>
            <line x1={PL} y1={py(v)} x2={W-PR} y2={py(v)} stroke="#E5E7EB" strokeWidth="1" strokeDasharray="3,3"/>
            <text x={PL-4} y={py(v)+4} textAnchor="end" fontSize="8" fill="#9CA3AF">{fmt(v)}</text>
          </g>
        ))}
        {/* Ligne objectif orange pointillée */}
        <line x1={PL} y1={yObj} x2={W-PR} y2={yObj} stroke="#F4A035" strokeWidth="2" strokeDasharray="6,4"/>
        <text x={W-PR+2} y={yObj+4} fontSize="8" fill="#F4A035" fontWeight="bold">obj.</text>
        <polygon points={aire} fill="#2A5298" fillOpacity="0.08"/>
        <polyline points={pts} fill="none" stroke="#1B3A6B" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round"/>
        {historique.map((d, i) => (
          <g key={i}>
            <circle cx={px(i)} cy={py(d.val)} r="4"
              fill={d.val >= objectif ? "#7CB342" : "#fff"}
              stroke={d.val >= objectif ? "#7CB342" : "#1B3A6B"} strokeWidth="2"/>
            {i === historique.length-1 && (
              <text x={px(i)} y={py(d.val)-9} textAnchor="middle" fontSize="9" fontWeight="bold" fill="#1B3A6B">
                {fmt(d.val)}
              </text>
            )}
          </g>
        ))}
        {[0, historique.length-1].map(i => (
          <text key={i} x={px(i)} y={H} textAnchor="middle" fontSize="8" fill="#9CA3AF">
            {historique[i].label}
          </text>
        ))}
      </svg>
    );
  };

  const emoji = pct >= 100 ? "🏆" : pct >= 75 ? "💪" : pct >= 50 ? "🚶‍♀️" : "👟";

  return (
    <div style={{marginBottom:16}}>

      {/* ── BANDEAU PREMIUM ── */}
      <div style={{borderRadius:16,overflow:"hidden",boxShadow:"0 4px 16px rgba(27,58,107,0.15)",marginBottom:0}}>
        {/* Header bleu premium */}
        <div style={{background:"linear-gradient(135deg,#1B3A6B 0%,#2A5298 100%)",padding:"14px 16px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <span style={{fontSize:20}}>🚶‍♀️</span>
              <div>
                <div style={{fontSize:15,fontWeight:900,color:"#fff",letterSpacing:0.3}}>Marche quotidienne</div>
                <div style={{fontSize:10,color:"rgba(255,255,255,0.65)",marginTop:1}}>Objectif personnalisé · mis à jour à chaque pesée</div>
              </div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"3px 10px"}}>
              <span style={{fontSize:10}}>💎</span>
              <span style={{fontSize:10,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
            </div>
          </div>

          {/* Explication personnalisation — bandeau repliable */}
          {bandeauVisible && (
            <div style={{background:"rgba(255,255,255,0.10)",borderRadius:10,padding:"10px 12px",marginTop:8}}>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.92)",lineHeight:1.7}}>
                Ton objectif de pas est calculé <strong style={{color:"#fff"}}>sur mesure</strong> à partir de ton âge, ta taille, ton poids et ton niveau d'activité habituel.
                Il <strong style={{color:"#fff"}}>augmente automatiquement</strong> au fil de ta perte de poids — parce qu'un corps plus léger peut aller plus loin, et que chaque palier franchi mérite un nouveau défi. 🌿
              </div>
              {palier && kgRestants > 0 && objectifProchain && (
                <div style={{marginTop:8,background:"rgba(255,255,255,0.12)",borderRadius:8,padding:"7px 10px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{fontSize:10,color:"rgba(255,255,255,0.85)"}}>
                    Dans <strong style={{color:"#fff"}}>{kgRestants} kg</strong>, ton objectif passera à
                  </div>
                  <div style={{fontSize:14,fontWeight:900,color:"#7DD87D"}}>
                    {objectifProchain.toLocaleString("fr-FR")} pas
                  </div>
                </div>
              )}
              {imc && (
                <div style={{marginTop:6,display:"flex",gap:10,flexWrap:"wrap"}}>
                  {[
                    {l:"IMC actuel", v: imc.toFixed(1)},
                    age ? {l:"Âge", v: `${age} ans`} : null,
                  ].filter(Boolean).map((item,i)=>(
                    <div key={i} style={{fontSize:10,color:"rgba(255,255,255,0.7)"}}>
                      {item.l} : <span style={{color:"#fff",fontWeight:700}}>{item.v}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          <button onClick={()=>setBandeauVisible(v=>!v)}
            style={{background:"none",border:"none",color:"rgba(255,255,255,0.5)",fontSize:10,cursor:"pointer",marginTop:6,padding:0,width:"100%",textAlign:"center"}}>
            {bandeauVisible ? "▲ Réduire" : "▼ Voir le détail de ton objectif"}
          </button>
        </div>

        {/* Corps blanc */}
        <div style={{background:"#fff",padding:16}}>

          {/* Compteur du jour */}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
            <div>
              <div style={{fontSize:11,color:"#6B7280",letterSpacing:1,textTransform:"uppercase",marginBottom:2}}>Aujourd'hui</div>
              <div style={{fontSize:26,fontWeight:900,color:"#1B3A6B",lineHeight:1}}>
                {pasAujourdhui.toLocaleString("fr-FR")}
                <span style={{fontSize:13,color:"#9CA3AF",fontWeight:"normal"}}> pas</span>
              </div>
              <div style={{fontSize:11,color:"#6B7280",marginTop:2}}>
                objectif : <strong style={{color:"#1B3A6B"}}>{objectif.toLocaleString("fr-FR")}</strong> pas
                {objectifManuel && <span style={{color:"#F4A035",fontSize:10}}> · personnalisé</span>}
              </div>
            </div>
            <div style={{fontSize:32}}>{emoji}</div>
          </div>

          {/* Barre progression */}
          <div style={{height:10,background:"#f0f0f0",borderRadius:5,marginBottom:4,overflow:"hidden"}}>
            <div style={{
              height:"100%",width:`${pct}%`,borderRadius:5,transition:"width 0.6s",
              background:pct>=100?"#7CB342":"linear-gradient(90deg,#1B3A6B,#2A5298)"
            }}/>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"#9CA3AF",marginBottom:14}}>
            <span>{pct}% atteint</span>
            <span>{Math.max(0, objectif - pasAujourdhui).toLocaleString("fr-FR")} pas restants</span>
          </div>

          {/* Boutons app sante - toujours visibles */}
          <div style={{marginBottom:10}}>
            <div style={{fontSize:10,color:"#6B7280",marginBottom:6,textAlign:"center"}}>
              📱 Consulte ton app pour voir tes pas, puis saisis le total ci-dessous
            </div>
            <div style={{display:"flex",gap:8}}>
              <div onClick={()=>{ window.location.href="x-apple-health://"; setTimeout(()=>{ window.location.href="https://apps.apple.com/app/apple-health/id1242545199"; },1500); }}
                style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,background:"#F0F4FF",border:"1.5px solid #2A5298",borderRadius:10,padding:"10px 8px",cursor:"pointer"}}>
                <span style={{fontSize:16}}>❤️</span>
                <div>
                  <div style={{fontSize:11,fontWeight:900,color:"#1B3A6B"}}>Apple Santé</div>
                  <div style={{fontSize:9,color:"#6B7280"}}>iPhone</div>
                </div>
                <span style={{fontSize:11,color:"#9CA3AF"}}>↗</span>
              </div>
              <a href="https://fit.google.com" target="_blank" rel="noopener noreferrer"
                style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,background:"#F0FFF4",border:"1.5px solid #7CB342",borderRadius:10,padding:"10px 8px",textDecoration:"none"}}>
                <span style={{fontSize:16}}>🏃</span>
                <div>
                  <div style={{fontSize:11,fontWeight:900,color:"#2E7D32"}}>Google Fit</div>
                  <div style={{fontSize:9,color:"#6B7280"}}>Android</div>
                </div>
                <span style={{fontSize:11,color:"#9CA3AF"}}>↗</span>
              </a>
              <a href="samsunghealth://" target="_blank" rel="noopener noreferrer"
                style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,background:"#FFF8F0",border:"1.5px solid #F4A035",borderRadius:10,padding:"10px 8px",textDecoration:"none"}}>
                <span style={{fontSize:16}}>💙</span>
                <div>
                  <div style={{fontSize:11,fontWeight:900,color:"#E65100"}}>Samsung</div>
                  <div style={{fontSize:9,color:"#6B7280"}}>Android</div>
                </div>
                <span style={{fontSize:11,color:"#9CA3AF"}}>↗</span>
              </a>
            </div>
          </div>

          {/* Saisie */}
          <div style={{display:"flex",gap:8,marginBottom:8}}>
            <input
              type="number"
              value={saisie}
              onChange={e=>setSaisie(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&sauvegarderPas()}
              placeholder="Saisir le nombre de pas du jour"
              style={{flex:1,border:"1.5px solid #E5E7EB",borderRadius:8,padding:"9px 12px",fontSize:14,fontFamily:"Georgia,serif",color:"#1B3A6B",outline:"none"}}
            />
            <button onClick={sauvegarderPas}
              style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",borderRadius:8,padding:"9px 16px",fontSize:13,cursor:"pointer",fontFamily:"Georgia,serif",fontWeight:900,whiteSpace:"nowrap"}}>
              ✓ Sauver
            </button>
          </div>

          {/* Objectif manuel */}
          {editObj ? (
            <div style={{display:"flex",gap:6,marginBottom:10}}>
              <input type="number" value={objSaisie} onChange={e=>setObjSaisie(e.target.value)}
                onKeyDown={e=>e.key==="Enter"&&sauvegarderObjectif()}
                placeholder={`Objectif actuel : ${objectif}`}
                style={{flex:1,border:"1.5px solid #F4A035",borderRadius:8,padding:"7px 10px",fontSize:13,fontFamily:"Georgia,serif"}}/>
              <button onClick={sauvegarderObjectif} style={{background:"#F4A035",color:"#fff",border:"none",borderRadius:8,padding:"7px 12px",fontSize:12,cursor:"pointer",fontFamily:"Georgia,serif"}}>OK</button>
              {objectifManuel && <button onClick={reinitialiserObjectif} style={{background:"#f3f4f6",color:"#7CB342",border:"none",borderRadius:8,padding:"7px 10px",fontSize:11,cursor:"pointer"}}>↺ Auto</button>}
              <button onClick={()=>setEditObj(false)} style={{background:"#f3f4f6",color:"#6B7280",border:"none",borderRadius:8,padding:"7px 10px",fontSize:12,cursor:"pointer"}}>✕</button>
            </div>
          ) : (
            <button onClick={()=>{setEditObj(true);setObjSaisie(String(objectif));}}
              style={{background:"none",border:"none",fontSize:10,color:"#9CA3AF",cursor:"pointer",marginBottom:12,padding:0,textDecoration:"underline"}}>
              Ajuster l'objectif manuellement
            </button>
          )}

          {/* Courbe */}
          <div style={{borderTop:"1px solid #f3f4f6",paddingTop:12}}>
            <div style={{fontSize:10,color:"#6B7280",letterSpacing:1,textTransform:"uppercase",marginBottom:8}}>
              📈 Mes pas — courbe réelle <span style={{color:"#F4A035"}}>— — objectif</span>
            </div>
            <CourbePas/>
          </div>
        </div>
      </div>
    </div>
  );
}
// ── FIN PODOMÈTRE ───────────────────────────────────────────────────

function ModuleActivite({ onRetour }) {
  const [vue, setVue] = React.useState("intro");
  const [exerciceActif, setExerciceActif] = React.useState(null);
  const [familleFiltre, setFamilleFiltre] = React.useState("Tous");
  const [seances, setSeances] = React.useState(()=>loadSeancesAct());
  const [heureDebut, setHeureDebut] = React.useState(null);
  const seanceAujourdhui = seances.find(s=>s.date===todayKeyAct());
  const [exFaits, setExFaits] = React.useState(()=>seanceAujourdhui?.exFaits||[]);
  const jours = calcJoursDeSuite(seances);
  const exercicesDuJour = (()=>{
    const today = new Date();
    const seed = today.getFullYear()*10000+(today.getMonth()+1)*100+today.getDate();
    const familles = ["Pilates","Tai Chi","Gym sur chaise"];
    const sel = [];
    familles.forEach(f=>{
      const de_f = EXERCICES_ACT.filter(e=>e.famille===f).sort((a,b)=>((a.id*seed)%97)-((b.id*seed)%97));
      sel.push(...de_f.slice(0,2));
    });
    return sel;
  })();
  const dureeTotaleSecondes = exercicesDuJour.reduce((s,e)=>s+e.duree,0);
  const dureeTotaleMin = exercicesDuJour.length * 5;
  const now = new Date();
  const dateStr = now.toLocaleDateString("fr-FR",{weekday:"long",day:"numeric",month:"long"});
  const profil = (()=>{ try { return JSON.parse(localStorage.getItem("cetoclub_profil")||"{}"); } catch { return {}; } })();
  const age=parseInt(profil.age)||null; const poids=parseFloat(profil.poids)||null; const taille=parseFloat(profil.taille)||null;
  const imc=poids&&taille?poids/((taille/100)**2):null;
  const niveau=!imc?1:(age>65||imc>32)?1:(age>55||imc>28)?2:3;
  const niveauLabel=niveau===1?"🟢 Doux":niveau===2?"🟡 Modéré":"🔵 Actif";
  const messagePersonnalise=(()=>{
    if (!age&&!imc) return "Ce programme s'adaptera à ton profil dès que tu auras renseigné ton âge et ton poids dans l'application.";
    if (age>65) return `À ${age} ans, la douceur est la clé. Ton programme privilégie des mouvements lents et stables, sans aucun impact sur tes articulations.`;
    if (imc>32) return "Ton programme a été ajusté pour respecter tes articulations et ton souffle. Chaque exercice peut se faire à ton rythme, sans jamais forcer.";
    if (age>55) return `À ${age} ans, la régularité compte plus que l'intensité. Ton programme te propose des exercices modérés pour retrouver souplesse et énergie progressivement.`;
    if (imc>28) return "Ton programme est calibré pour te mettre en mouvement en douceur, sans épuiser le corps, et en soutenant activement ta perte de poids.";
    return "Ton profil te permet d'accéder à l'ensemble des exercices. Tu peux aller à ton rythme et progresser semaine après semaine.";
  })();
  const toggleFait = (id) => {
    setExFaits(prev=>{
      const nv=prev.includes(id)?prev.filter(x=>x!==id):[...prev,id];
      const maj=seances.filter(s=>s.date!==todayKeyAct());
      const entree={date:todayKeyAct(),exFaits:nv};
      const nvs=[entree,...maj]; setSeances(nvs); saveSeancesAct(nvs);
      return nv;
    });
  };
  const terminerSeance = () => {
    const fin=new Date();
    const dureeMin=heureDebut?Math.round((fin-heureDebut)/60000):dureeTotaleMin;
    const maj=seances.filter(s=>s.date!==todayKeyAct());
    const entree={date:todayKeyAct(),exFaits,nbExercices:exFaits.length,dureeMin,heure:fin.toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})};
    const nvs=[entree,...maj]; setSeances(nvs); saveSeancesAct(nvs); setVue("fin");
  };

  // ── PAGE INTRO ──
  if (vue==="intro") return (
    <div style={{fontFamily:"Georgia,serif",background:"#FAFAF7",minHeight:"100vh"}}>
      <div style={{background:"linear-gradient(135deg,#1B3A6B 0%,#2A5298 100%)",padding:"32px 24px 28px",textAlign:"center"}}>
        <div style={{fontSize:48,marginBottom:12}}>🚶‍♀️</div>
        <div style={{fontSize:11,color:"rgba(255,255,255,0.5)",letterSpacing:3,textTransform:"uppercase",marginBottom:8}}>💎 Module Premium</div>
        <h1 style={{color:"#fff",fontSize:28,fontWeight:"normal",margin:"0 0 8px"}}>Activité Douce</h1>
        <p style={{color:"rgba(255,255,255,0.75)",fontSize:13,lineHeight:1.7,margin:0}}>Le mouvement doux, c'est le premier pas vers un corps qu'on réhabite. Sans violence, sans comparaison, à son propre rythme. 30 exercices inspirés des recommandations kinésithérapeutiques.</p>
        {jours>0&&<div style={{marginTop:14}}><JoursDeSuiteBadge jours={jours}/></div>}
      </div>
      <div style={{padding:"24px 20px"}}>
        <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:14,padding:16,marginBottom:16,color:"#fff"}}>
          <div style={{fontSize:11,letterSpacing:2,textTransform:"uppercase",opacity:.7,marginBottom:8}}>Ton programme · {niveauLabel}</div>
          <p style={{fontSize:14,lineHeight:1.7,margin:0}}>{messagePersonnalise}</p>
        </div>
        <div style={{background:"#FFF8F0",border:"1.5px solid #F4A035",borderRadius:12,padding:16,marginBottom:20}}>
          <div style={{display:"flex",gap:10}}>
            <span style={{fontSize:22}}>👨‍⚕️</span>
            <p style={{fontSize:13,color:"#6B7280",lineHeight:1.7,margin:0}}>Ces exercices sont doux mais nous te recommandons d'en parler à ton médecin avant de commencer, surtout si tu as des douleurs articulaires ou des problèmes cardiaques. 💙</p>
          </div>
        </div>
        <div style={{background:"linear-gradient(135deg,#F0F4FF,#fff)",borderRadius:12,padding:16,marginBottom:20,border:"1px solid #2A5298"}}>
          <p style={{fontSize:13,color:"#374151",lineHeight:1.8,margin:0,fontStyle:"italic"}}>"Ce n'est pas l'intensité qui transforme le corps, c'est la régularité. Quelques minutes chaque jour — semaine après semaine — ton corps retrouve peu à peu sa souplesse, son équilibre, son énergie."</p>
        </div>
        <button onClick={()=>setVue("accueil")} style={{width:"100%",background:"linear-gradient(90deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",borderRadius:14,padding:16,fontSize:16,cursor:"pointer",fontFamily:"Georgia,serif"}}>C'est parti ! →</button>
        <button onClick={onRetour} style={{width:"100%",background:"none",border:"none",color:"#9CA3AF",fontSize:12,marginTop:12,cursor:"pointer",fontFamily:"Georgia,serif"}}>← Retour au journal</button>
      </div>
    </div>
  );

  // ── PAGE DÉTAIL EXERCICE ──
  if (exerciceActif) {
    const ex=exerciceActif; const col=FAM_COLORS_ACT[ex.famille];
    return (
      <div style={{fontFamily:"Georgia,serif",background:"#FAFAF7",minHeight:"100vh",paddingBottom:40}}>
        <div style={{background:col.border,padding:"16px 20px",display:"flex",alignItems:"center",gap:12}}>
          <button onClick={()=>setExerciceActif(null)} style={{background:"rgba(255,255,255,0.2)",border:"none",borderRadius:8,color:"#fff",padding:"6px 14px",cursor:"pointer",fontSize:14,fontFamily:"Georgia,serif"}}>← Retour</button>
          <span style={{color:"#fff",fontSize:13,opacity:.8}}>{ex.icon} {ex.famille}</span>
        </div>
        <div style={{padding:"20px 20px"}}>
          <div style={{textAlign:"center",marginBottom:16}}>
            <h2 style={{margin:"0 0 8px",color:col.text,fontSize:22}}>{ex.nom}</h2>
            <span style={{background:col.bg,border:`1px solid ${col.border}`,borderRadius:20,padding:"3px 14px",fontSize:12,color:col.text}}>{ex.niveau===1?"🟢 Niveau doux":"🟡 Niveau modéré"}</span>
          </div>
          <div style={{background:"#fff",borderRadius:16,padding:16,textAlign:"center",marginBottom:16,border:`2px solid ${col.border}`}}>
            <img src={IMG_ACT[ex.id]} alt={ex.nom} style={{maxHeight:200,maxWidth:"100%",objectFit:"contain"}}/>
          </div>
          <MinuteurAct duree={ex.duree} onFin={()=>toggleFait(ex.id)}/>
          <div style={{background:"#fff",borderRadius:12,padding:16,marginBottom:12,borderLeft:`3px solid ${col.border}`}}>
            <div style={{fontSize:11,color:"#6B7280",letterSpacing:1,textTransform:"uppercase",marginBottom:8}}>Comment faire</div>
            <p style={{margin:0,color:"#374151",lineHeight:1.7,fontSize:14}}>{ex.description}</p>
          </div>
          <div style={{background:col.bg,borderRadius:12,padding:14,marginBottom:12,display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:20}}>💚</span>
            <div>
              <div style={{fontSize:11,color:"#6B7280",marginBottom:2}}>BIENFAITS</div>
              <div style={{color:col.text,fontWeight:"bold",fontSize:14}}>{ex.bienfaits}</div>
            </div>
          </div>
          <div style={{background:"linear-gradient(135deg,#F1F8E9,#fff)",borderRadius:12,padding:16,marginBottom:16,border:"1px solid #7CB342"}}>
            <div style={{fontSize:11,color:"#4a7c1f",letterSpacing:1,textTransform:"uppercase",marginBottom:8}}>🥑 Pourquoi cet exercice ?</div>
            <p style={{margin:0,color:"#374151",lineHeight:1.7,fontSize:13}}>{ex.pourquoi}</p>
          </div>
          <button onClick={()=>{toggleFait(ex.id);setExerciceActif(null);}} style={{width:"100%",background:exFaits.includes(ex.id)?"#7CB342":"linear-gradient(90deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",borderRadius:14,padding:14,fontSize:15,cursor:"pointer",fontFamily:"Georgia,serif"}}>
            {exFaits.includes(ex.id)?"✓ Marqué comme fait !":"Marquer comme fait"}
          </button>
        </div>
      </div>
    );
  }

  // ── PAGE FIN DE SÉANCE ──
  if (vue==="fin") {
    const seanceTerminee=seances.find(s=>s.date===todayKeyAct());
    const nvJours=calcJoursDeSuite(seances);
    const messages=["Ton corps te remercie. Chaque mouvement compte. 💚","La régularité, c'est ton super-pouvoir. À demain ! 🌟","Tu viens d'investir dans ta santé. Bravo ! 🥑","Chaque séance te rapproche de ton objectif. Continue ! 🔥","Le mouvement doux, c'est la clé de la longévité. Tu l'as compris ! ✨"];
    const msg=messages[new Date().getDay()%messages.length];
    return (
      <div style={{fontFamily:"Georgia,serif",background:"linear-gradient(135deg,#1B3A6B 0%,#2A5298 100%)",minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"32px 24px",textAlign:"center"}}>
        <div style={{fontSize:64,marginBottom:16}}>🎉</div>
        <h1 style={{color:"#fff",fontSize:26,fontWeight:"normal",margin:"0 0 8px"}}>Séance terminée !</h1>
        <p style={{color:"rgba(255,255,255,0.75)",fontSize:14,lineHeight:1.7,marginBottom:28}}>{msg}</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,width:"100%",maxWidth:360,marginBottom:24}}>
          {[{icon:"🏋️",val:seanceTerminee?.nbExercices||exFaits.length,label:"exercices"},{icon:"⏱️",val:seanceTerminee?.dureeMin||dureeTotaleMin,label:"minutes"},{icon:"🔥",val:jours>0?jours:"0",label:"jours de suite"}].map(s=>(
            <div key={s.label} style={{background:"rgba(255,255,255,0.12)",borderRadius:14,padding:"16px 8px"}}>
              <div style={{fontSize:24,marginBottom:4}}>{s.icon}</div>
              <div style={{fontSize:22,fontWeight:"bold",color:"#fff"}}>{s.val}</div>
              <div style={{fontSize:11,color:"rgba(255,255,255,0.6)"}}>{s.label}</div>
            </div>
          ))}
        </div>
        {nvJours>0&&<div style={{marginBottom:24}}><JoursDeSuiteBadge jours={nvJours}/>{nvJours===7&&<div style={{color:"rgba(255,255,255,0.8)",fontSize:12,marginTop:8}}>🏆 Une semaine complète ! Exceptionnel !</div>}</div>}
        <button onClick={()=>setVue("accueil")} style={{background:"#fff",color:"#1B3A6B",border:"none",borderRadius:14,padding:"14px 32px",fontSize:16,cursor:"pointer",fontFamily:"Georgia,serif",fontWeight:"bold"}}>← Retour à l'accueil</button>
      </div>
    );
  }

  // ── PAGE SÉANCE DU JOUR ──
  if (vue==="seance") {
    const nbFaits=exFaits.filter(id=>exercicesDuJour.map(e=>e.id).includes(id)).length;
    const seanceComplete=nbFaits===exercicesDuJour.length;
    return (
      <div style={{fontFamily:"Georgia,serif",background:"#FAFAF7",minHeight:"100vh"}}>
        <div style={{background:"linear-gradient(135deg,#1B3A6B 0%,#2A5298 100%)",padding:"18px 20px",display:"flex",alignItems:"center",gap:12}}>
          <button onClick={()=>setVue("accueil")} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:8,color:"#fff",padding:"6px 14px",cursor:"pointer",fontSize:14,fontFamily:"Georgia,serif"}}>← Accueil</button>
          <div>
            <div style={{color:"#fff",fontWeight:"bold",fontSize:16}}>Séance du jour</div>
            <div style={{color:"rgba(255,255,255,0.6)",fontSize:12}}>{nbFaits}/{exercicesDuJour.length} exercices · ~{dureeTotaleMin} min</div>
          </div>
        </div>
        <div style={{height:4,background:"rgba(27,58,107,0.1)"}}>
          <div style={{height:"100%",width:`${(nbFaits/exercicesDuJour.length)*100}%`,background:"#7CB342",transition:"width 0.4s"}}/>
        </div>
        <div style={{padding:16}}>
          {exercicesDuJour.map(ex=>{
            const col=FAM_COLORS_ACT[ex.famille]; const fait=exFaits.includes(ex.id);
            return (
              <div key={ex.id} style={{background:fait?"#F1F8E9":"#fff",border:`2px solid ${fait?"#7CB342":col.border}`,borderRadius:16,padding:16,marginBottom:12,transition:"all 0.3s"}}>
                <div style={{display:"flex",gap:12,alignItems:"flex-start"}}>
                  <img src={IMG_ACT[ex.id]} alt={ex.nom} style={{width:75,height:75,objectFit:"contain",flexShrink:0,cursor:"pointer",background:"#f8f8f8",borderRadius:8}} onClick={()=>setExerciceActif(ex)}/>
                  <div style={{flex:1}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                      <div>
                        <div style={{fontSize:11,color:col.text,marginBottom:2}}>{ex.icon} {ex.famille}</div>
                        <div style={{color:"#1B3A6B",fontWeight:"bold",fontSize:15}}>{ex.nom}</div>
                      </div>
                      <span style={{fontSize:12,color:"#6B7280"}}>⏱ {Math.floor(ex.duree/60)}:{(ex.duree%60).toString().padStart(2,"0")}</span>
                    </div>
                    <div style={{fontSize:12,color:"#6B7280",marginTop:4}}>{ex.bienfaits}</div>
                    <div style={{display:"flex",gap:8,marginTop:10}}>
                      <button onClick={()=>setExerciceActif(ex)} style={{flex:1,background:col.bg,border:`1px solid ${col.border}`,borderRadius:8,padding:"7px 10px",fontSize:12,cursor:"pointer",color:col.text,fontFamily:"Georgia,serif"}}>Voir le détail</button>
                      <button onClick={()=>toggleFait(ex.id)} style={{flex:1,background:fait?"#7CB342":"#fff",border:`1px solid ${fait?"#7CB342":"#ddd"}`,borderRadius:8,padding:"7px 10px",fontSize:12,cursor:"pointer",color:fait?"#fff":"#6B7280",fontFamily:"Georgia,serif"}}>{fait?"✓ Fait !":"Marquer fait"}</button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {seanceComplete&&(
            <button onClick={terminerSeance} style={{width:"100%",background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",borderRadius:14,padding:16,fontSize:16,cursor:"pointer",fontFamily:"Georgia,serif",marginTop:8,boxShadow:"0 4px 16px rgba(124,179,66,0.4)"}}>
              🎉 Terminer et voir mes stats →
            </button>
          )}
        </div>
      </div>
    );
  }

  // ── PAGE BIBLIOTHÈQUE ──
  if (vue==="bibliotheque") {
    const exercicesFiltres=familleFiltre==="Tous"?EXERCICES_ACT:EXERCICES_ACT.filter(e=>e.famille===familleFiltre);
    return (
      <div style={{fontFamily:"Georgia,serif",background:"#FAFAF7",minHeight:"100vh"}}>
        <div style={{background:"linear-gradient(135deg,#1B3A6B 0%,#2A5298 100%)",padding:"18px 20px",display:"flex",alignItems:"center",gap:12}}>
          <button onClick={()=>setVue("accueil")} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:8,color:"#fff",padding:"6px 14px",cursor:"pointer",fontSize:14,fontFamily:"Georgia,serif"}}>← Accueil</button>
          <div style={{color:"#fff",fontWeight:"bold",fontSize:16}}>📚 Bibliothèque · 30 exercices</div>
        </div>
        <div style={{padding:"14px 16px",display:"flex",gap:8,overflowX:"auto"}}>
          {["Tous","Pilates","Tai Chi","Gym sur chaise"].map(f=>(
            <button key={f} onClick={()=>setFamilleFiltre(f)} style={{whiteSpace:"nowrap",padding:"7px 14px",borderRadius:20,border:"none",cursor:"pointer",fontSize:13,background:familleFiltre===f?"#1B3A6B":"#fff",color:familleFiltre===f?"#fff":"#1B3A6B",boxShadow:"0 1px 4px rgba(0,0,0,0.1)",fontFamily:"Georgia,serif"}}>
              {f==="Pilates"?"🧘 ":f==="Tai Chi"?"☯️ ":f==="Gym sur chaise"?"🪑 ":""}{f}
            </button>
          ))}
        </div>
        <div style={{padding:"0 16px 24px"}}>
          {exercicesFiltres.map(ex=>{
            const col=FAM_COLORS_ACT[ex.famille];
            return (
              <div key={ex.id} onClick={()=>setExerciceActif(ex)} style={{background:"#fff",borderRadius:14,padding:14,marginBottom:10,display:"flex",gap:12,alignItems:"center",cursor:"pointer",boxShadow:"0 2px 8px rgba(0,0,0,0.05)",border:`1px solid ${col.bg}`}}>
                <img src={IMG_ACT[ex.id]} alt={ex.nom} style={{width:65,height:65,objectFit:"contain",flexShrink:0,background:"#f8f8f8",borderRadius:8}}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:11,color:col.text,marginBottom:2}}>{ex.icon} {ex.famille}</div>
                  <div style={{color:"#1B3A6B",fontWeight:"bold",fontSize:14}}>{ex.nom}</div>
                  <div style={{display:"flex",gap:8,marginTop:4}}>
                    <span style={{fontSize:11,color:"#6B7280"}}>⏱ {Math.floor(ex.duree/60)}:{(ex.duree%60).toString().padStart(2,"0")}</span>
                    <span style={{fontSize:11,color:ex.niveau===1?"#4CAF50":"#FF9800"}}>{ex.niveau===1?"🟢 Doux":"🟡 Modéré"}</span>
                  </div>
                </div>
                <span style={{color:"#6B7280",fontSize:18}}>›</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // ── PAGE ACCUEIL ──
  return (
    <div style={{fontFamily:"Georgia,serif",background:"#FAFAF7",minHeight:"100vh"}}>
      <div style={{background:"linear-gradient(135deg,#1B3A6B 0%,#2A5298 100%)",padding:"24px 20px 20px",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:0,right:0,width:100,height:100,background:"rgba(255,255,255,0.05)",borderRadius:"0 0 0 100%"}}/>
        <button onClick={()=>setVue("intro")} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:8,color:"rgba(255,255,255,0.7)",padding:"4px 10px",fontSize:12,cursor:"pointer",marginBottom:10,fontFamily:"Georgia,serif"}}>ℹ️ À propos</button>
        <h1 style={{margin:"0 0 4px",color:"#fff",fontSize:24,fontWeight:"normal"}}>🚶‍♀️ Activité Douce</h1>
        <div style={{color:"rgba(255,255,255,0.7)",fontSize:12,marginBottom:jours>0?10:0}}>{dateStr}</div>
        {jours>0&&<JoursDeSuiteBadge jours={jours}/>}
      </div>
      <div style={{padding:16}}>
        <TrackerMarcheAct/>
        {seances.length>0&&(
          <div style={{background:"#fff",borderRadius:14,padding:16,marginBottom:16,boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
            <div style={{fontSize:11,color:"#6B7280",letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>📅 Dernières séances</div>
            {seances.slice(0,4).map((s,i)=>(
              <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:i<Math.min(seances.length,4)-1?"1px solid #f3f4f6":"none"}}>
                <div style={{fontSize:13,color:"#374151"}}>{new Date(s.date).toLocaleDateString("fr-FR",{weekday:"short",day:"numeric",month:"short"})}</div>
                <div style={{display:"flex",gap:10,fontSize:12,color:"#6B7280"}}>
                  <span>🏋️ {s.nbExercices||"?"} ex.</span>
                  <span>⏱ {s.dureeMin||"?"}min</span>
                  <span style={{color:"#7CB342",fontWeight:"bold"}}>✓</span>
                </div>
              </div>
            ))}
          </div>
        )}
        <div style={{background:"#fff",borderRadius:16,padding:18,marginBottom:16,boxShadow:"0 2px 12px rgba(27,58,107,0.08)"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <div>
              <div style={{fontSize:11,color:"#6B7280",letterSpacing:1,textTransform:"uppercase"}}>Séance du jour</div>
              <div style={{color:"#1B3A6B",fontWeight:"bold",fontSize:16}}>{exercicesDuJour.length} exercices · ~{dureeTotaleMin} min</div>
            </div>
            <span style={{fontSize:28}}>{seanceAujourdhui?.nbExercices===exercicesDuJour.length?"✅":"✨"}</span>
          </div>
          <div style={{height:4,background:"#f0f0f0",borderRadius:2,marginBottom:14,overflow:"hidden"}}>
            <div style={{height:"100%",width:`${(exFaits.filter(id=>exercicesDuJour.map(e=>e.id).includes(id)).length/exercicesDuJour.length)*100}%`,background:"#7CB342",transition:"width 0.4s"}}/>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:16}}>
            {["Pilates","Tai Chi","Gym sur chaise"].map(f=>{
              const col=FAM_COLORS_ACT[f];
              const icons={"Pilates":"🧘","Tai Chi":"☯️","Gym sur chaise":"🪑"};
              return <span key={f} style={{background:col.bg,border:`1px solid ${col.border}`,borderRadius:20,padding:"3px 10px",fontSize:12,color:col.text}}>{icons[f]} {f}</span>;
            })}
          </div>
          <button onClick={()=>{setHeureDebut(new Date());setVue("seance");}} style={{width:"100%",background:"linear-gradient(90deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",borderRadius:12,padding:14,fontSize:16,cursor:"pointer",fontFamily:"Georgia,serif"}}>
            {seanceAujourdhui?"▶ Reprendre la séance":"▶ Commencer la séance"}
          </button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:16}}>
          {[["🔥",jours,"jours de suite"],["📅",seances.length,"séances total"],["🏋️",seances.reduce((s,e)=>s+(e.nbExercices||0),0),"exercices faits"]].map(([icon,val,label])=>(
            <div key={label} style={{background:"#fff",borderRadius:12,padding:"14px 10px",textAlign:"center",boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              <div style={{fontSize:22,marginBottom:4}}>{icon}</div>
              <div style={{fontSize:18,fontWeight:"bold",color:"#1B3A6B"}}>{val}</div>
              <div style={{fontSize:10,color:"#6B7280",lineHeight:1.3}}>{label}</div>
            </div>
          ))}
        </div>
        <button onClick={()=>setVue("bibliotheque")} style={{width:"100%",background:"#F1F8E9",border:"2px solid #7CB342",color:"#1B3A6B",borderRadius:12,padding:14,fontSize:15,cursor:"pointer",fontFamily:"Georgia,serif"}}>
          📚 Voir les 30 exercices
        </button>
        <button onClick={onRetour} style={{width:"100%",background:"none",border:"none",color:"#9CA3AF",fontSize:12,marginTop:12,cursor:"pointer",fontFamily:"Georgia,serif"}}>← Retour au journal</button>
      </div>
    </div>
  );
}
// ─── FIN MODULE ACTIVITÉ ──────────────────────────────────────────────────────

// ─── CYCLE HORMONAL & JEÛNE ──────────────────────────────────────────────────
// ─── MODULE SPÉCIAL FEMME ────────────────────────────────────────────────────
const CYCLE_KEY = "cetoclub_cycle_hormonal";
const MENOPAUSE_KEY = "cetoclub_menopause";

const PHASES_CYCLE = [
  {
    id:"menstruelle", nom:"Phase menstruelle", jours:"Jours 1 à 5", emoji:"🌑",
    couleur:"#C62828", bg:"#FFEBEE", border:"#C6282840",
    jeune:"Jeûne court uniquement", dureeMax:"12h max",
    conseil:"Ton corps récupère et se régénère. Le jeûne prolongé stresse l'axe hormonal déjà sollicité. Privilégie un jeûne doux ou saute simplement le petit-déjeuner.",
    alimentation:"≤20g de glucides. Augmente légèrement les lipides pour soutenir l'énergie. Magnésium et fer bienvenus (viandes rouges, noix).",
    activite:"Activité douce uniquement : marche, étirements.",
  },
  {
    id:"folliculaire", nom:"Phase folliculaire", jours:"Jours 6 à 13", emoji:"🌒",
    couleur:"#F4A035", bg:"#FFF8F0", border:"#F4A03540",
    jeune:"Jeûne modéré à intense possible", dureeMax:"16h à 18h",
    conseil:"L'œstrogène monte, ton énergie avec. C'est la meilleure fenêtre pour un jeûne plus long. Ton corps tolère bien le déficit et l'effort physique.",
    alimentation:"≤20g glucides. Tu peux légèrement réduire les lipides si tu vises la perte de poids — ton énergie est naturellement haute.",
    activite:"Idéal pour les séances de Pilates ou Tai Chi plus intenses.",
  },
  {
    id:"ovulatoire", nom:"Phase ovulatoire", jours:"Jours 14 à 16", emoji:"🌕",
    couleur:"#7CB342", bg:"#F1F8E9", border:"#7CB34240",
    jeune:"Jeûne bien toléré", dureeMax:"16h à 20h",
    conseil:"Pic d'énergie et de clarté mentale. Ton corps est au maximum de ses capacités. Moment idéal pour des jeûnes plus longs si tu le souhaites.",
    alimentation:"≤20g glucides. Protéines légèrement augmentées pour soutenir la masse musculaire.",
    activite:"Profite de ce pic d'énergie pour les exercices les plus dynamiques.",
  },
  {
    id:"luteale", nom:"Phase lutéale", jours:"Jours 17 à 28", emoji:"🌘",
    couleur:"#2A5298", bg:"#F0F4FF", border:"#2A529840",
    jeune:"Jeûne court recommandé", dureeMax:"12h à 14h max",
    conseil:"La progestérone augmente ton appétit — c'est normal, pas une faiblesse. Un jeûne prolongé élève le cortisol et aggrave le SPM. Écoute ton corps.",
    alimentation:"≤20g glucides impérativement. Les envies de sucre sont hormonales : tiens bon avec des lipides rassasiants (avocat, noix, fromage). Le magnésium aide contre les crampes.",
    activite:"Reviens à l'activité douce. Évite les séances trop intenses.",
  },
];

function SpecialFemme() {
  const [menopause, setMenopause] = React.useState(() => {
    try { return localStorage.getItem(MENOPAUSE_KEY)||null; } catch { return null; }
  });
  const [dateRegles, setDateRegles] = React.useState(() => {
    try { return localStorage.getItem(CYCLE_KEY)||""; } catch { return ""; }
  });
  const [saisie, setSaisie] = React.useState(false);
  const [inputDate, setInputDate] = React.useState(dateRegles);

  const choisirMode = (val) => {
    try { localStorage.setItem(MENOPAUSE_KEY, val); } catch {}
    setMenopause(val);
  };

  const sauvegarderDate = () => {
    try { localStorage.setItem(CYCLE_KEY, inputDate); } catch {}
    setDateRegles(inputDate);
    setSaisie(false);
  };

  const phaseActuelle = React.useMemo(() => {
    if (!dateRegles) return null;
    const debut = new Date(dateRegles);
    const auj = new Date(); auj.setHours(0,0,0,0);
    const diff = Math.floor((auj - debut) / 86400000);
    const jourCycle = ((diff % 28) + 28) % 28 + 1;
    if (jourCycle <= 5)  return { phase: PHASES_CYCLE[0], jourCycle };
    if (jourCycle <= 13) return { phase: PHASES_CYCLE[1], jourCycle };
    if (jourCycle <= 16) return { phase: PHASES_CYCLE[2], jourCycle };
    return { phase: PHASES_CYCLE[3], jourCycle };
  }, [dateRegles]);

  return (
    <div style={{borderRadius:14,marginTop:14,boxShadow:"0 2px 12px rgba(27,58,107,0.10)"}}>
      {/* Header bandeau */}
      <div style={{background:"linear-gradient(90deg,#1B3A6B,#2A5298)",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:14}}>
        <div>
          <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>🌸 Spécial Femme</div>
          <div style={{fontSize:10,color:"rgba(255,255,255,0.65)",marginTop:1}}>Jeûne adapté à ton profil hormonal</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          {menopause && <button onClick={()=>{try{localStorage.removeItem(MENOPAUSE_KEY);}catch{}setMenopause(null);}} style={{background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",fontSize:10,cursor:"pointer",fontFamily:"inherit",borderRadius:6,padding:"3px 8px"}}>Changer</button>}
          <div style={{display:"flex",alignItems:"center",gap:5,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px"}}>
            <span style={{fontSize:13}}>💎</span>
            <span style={{fontSize:11,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
          </div>
        </div>
      </div>
      <div style={{background:"#fff",padding:16,borderRadius:"0 0 14px 14px"}}>

      {/* Choix du mode */}
      {!menopause ? (
        <div>
          <div style={{fontSize:12,fontWeight:800,color:"#1B3A6B",marginBottom:12,textAlign:"center"}}>Pour te proposer les recommandations adaptées :</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <button onClick={()=>choisirMode("non")}
              style={{background:"#FFF0F6",border:"2px solid #E91E8340",borderRadius:14,padding:"18px 12px",cursor:"pointer",textAlign:"center",fontFamily:"inherit"}}>
              <div style={{fontSize:28,marginBottom:8}}>🌸</div>
              <div style={{fontSize:13,fontWeight:900,color:"#AD1457",marginBottom:4}}>Cycle actif</div>
              <div style={{fontSize:11,color:"#6B7280",lineHeight:1.5}}>J'ai encore mes règles</div>
            </button>
            <button onClick={()=>choisirMode("oui")}
              style={{background:"#F3E5F5",border:"2px solid #9C27B040",borderRadius:14,padding:"18px 12px",cursor:"pointer",textAlign:"center",fontFamily:"inherit"}}>
              <div style={{fontSize:28,marginBottom:8}}>🦋</div>
              <div style={{fontSize:13,fontWeight:900,color:"#6A1B9A",marginBottom:4}}>Ménopause</div>
              <div style={{fontSize:11,color:"#6B7280",lineHeight:1.5}}>Je suis en ménopause ou péri-ménopause</div>
            </button>
          </div>
        </div>

      ) : menopause === "oui" ? (
        /* ── MODE MÉNOPAUSE ── */
        <div>
          <div style={{background:"linear-gradient(135deg,#F3E5F5,#EDE7F6)",border:"2px solid #9C27B030",borderRadius:12,padding:14,marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:900,color:"#4A148C",marginBottom:6}}>🦋 Ménopause & jeûne céto</div>
            <p style={{fontSize:12,color:"#374151",lineHeight:1.7,margin:0}}>Sans fluctuations cycliques, ton corps peut suivre un rythme de jeûne plus régulier. C'est même une période particulièrement favorable au céto : la résistance à l'insuline augmente à la ménopause, et le régime cétogène y répond directement.</p>
          </div>

          {[
            {
              icon:"⏱️", titre:"Jeûne recommandé", couleur:"#6A1B9A", bg:"#F3E5F5", border:"#9C27B030",
              contenu:"Le 16:8 est idéal et bien toléré. Tu peux aller jusqu'au 18:6 selon ton énergie. Évite les jeûnes très longs (>20h) qui peuvent élever le cortisol et favoriser la prise de graisse abdominale.",
            },
            {
              icon:"🥑", titre:"Alimentation céto adaptée", couleur:"#2E7D32", bg:"#F1F8E9", border:"#7CB34240",
              contenu:"≤20g de glucides — règle céto inchangée. Augmente les protéines (1,2 à 1,6g/kg) pour lutter contre la sarcopénie. Priorise : œufs, poissons gras, viandes, fromages. Les lipides de qualité restent la base.",
            },
            {
              icon:"💊", titre:"Micronutriments clés", couleur:"#1565C0", bg:"#E3F2FD", border:"#1976D240",
              contenu:"Magnésium (crampes, sommeil), Vitamine D3 + K2 (densité osseuse), Oméga-3 (inflammation, humeur), Calcium biodisponible. Le céto peut réduire certains apports — sois attentive.",
            },
            {
              icon:"🏃", titre:"Activité physique", couleur:"#E65100", bg:"#FFF8F0", border:"#F4A03540",
              contenu:"La musculation douce et le Pilates sont particulièrement précieux pour maintenir la masse musculaire et la densité osseuse. Vise 3-4 séances/semaine même légères.",
            },
            {
              icon:"🌙", titre:"Sommeil & cortisol", couleur:"#4A148C", bg:"#F3E5F5", border:"#9C27B030",
              contenu:"Les troubles du sommeil sont fréquents. Le céto aide via la stabilisation de la glycémie. Le magnésium glycinate le soir, la respiration guidée et un jeûne interrompu 2-3h avant le coucher améliorent la qualité du sommeil.",
            },
          ].map((s,i)=>(
            <div key={i} style={{background:s.bg,border:`1.5px solid ${s.border}`,borderRadius:10,padding:12,marginBottom:10}}>
              <div style={{fontSize:11,fontWeight:800,color:s.couleur,marginBottom:6}}>{s.icon} {s.titre}</div>
              <p style={{fontSize:11,color:"#374151",lineHeight:1.7,margin:0}}>{s.contenu}</p>
            </div>
          ))}

          <div style={{background:"#1B3A6B",borderRadius:10,padding:"10px 12px",display:"flex",alignItems:"center",gap:8,marginTop:4}}>
            <span style={{fontSize:16}}>⚖️</span>
            <div style={{fontSize:11,color:"#fff",fontWeight:700}}>≤ 20g de glucides/jour — règle céto inchangée</div>
          </div>

          <div style={{marginTop:12,background:"#FFF8F0",border:"1.5px solid #F4A03530",borderRadius:10,padding:"10px 12px",display:"flex",gap:10,alignItems:"flex-start"}}>
            <span style={{fontSize:18,flexShrink:0}}>👨‍⚕️</span>
            <p style={{fontSize:11,color:"#6B7280",lineHeight:1.6,margin:0}}>Ces recommandations sont indicatives. La ménopause est une période de changements importants — consulte ton médecin ou gynécologue pour un suivi personnalisé.</p>
          </div>
        </div>

      ) : (
        /* ── MODE CYCLE ACTIF ── */
        <div>
          {/* Saisie date règles */}
          {!dateRegles || saisie ? (
            <div style={{background:"#FFF0F6",border:"1.5px solid #E91E8330",borderRadius:12,padding:14,marginBottom:14}}>
              <div style={{fontSize:12,fontWeight:800,color:"#AD1457",marginBottom:8}}>📅 1er jour de tes dernières règles</div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <input type="date" value={inputDate} onChange={e=>setInputDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                  style={{flex:1,padding:"9px 12px",border:"2px solid #E91E8330",borderRadius:8,fontSize:14,outline:"none",fontFamily:"inherit"}}/>
                <button onClick={sauvegarderDate} disabled={!inputDate}
                  style={{padding:"9px 16px",borderRadius:8,background:inputDate?"#AD1457":"#E5E7EB",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:inputDate?"pointer":"not-allowed",fontFamily:"inherit"}}>
                  ✓
                </button>
              </div>
              {saisie && <button onClick={()=>setSaisie(false)} style={{marginTop:8,background:"none",border:"none",color:"#9CA3AF",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>Annuler</button>}
            </div>
          ) : (
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#FFF0F6",borderRadius:10,padding:"8px 12px",marginBottom:14}}>
              <div style={{fontSize:11,color:"#6B7280"}}>
                Dernières règles : <strong style={{color:"#AD1457"}}>{new Date(dateRegles).toLocaleDateString("fr-FR",{day:"numeric",month:"long"})}</strong>
                {phaseActuelle && <span style={{color:"#9CA3AF",marginLeft:6}}>(J{phaseActuelle.jourCycle}/28)</span>}
              </div>
              <button onClick={()=>{setInputDate(dateRegles);setSaisie(true);}} style={{background:"none",border:"none",color:"#AD1457",fontSize:11,cursor:"pointer",fontWeight:700,fontFamily:"inherit"}}>✏️ Modifier</button>
            </div>
          )}

          {/* Phase actuelle */}
          {phaseActuelle && (
            <div style={{marginBottom:14}}>
              <div style={{background:phaseActuelle.phase.bg,border:`2px solid ${phaseActuelle.phase.border}`,borderRadius:12,padding:14,marginBottom:12}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                  <div>
                    <div style={{fontSize:11,color:phaseActuelle.phase.couleur,fontWeight:800,letterSpacing:1,textTransform:"uppercase",marginBottom:2}}>
                      {phaseActuelle.phase.emoji} Phase actuelle · Jour {phaseActuelle.jourCycle}
                    </div>
                    <div style={{fontSize:16,fontWeight:900,color:"#1B3A6B"}}>{phaseActuelle.phase.nom}</div>
                    <div style={{fontSize:11,color:"#6B7280",marginTop:2}}>{phaseActuelle.phase.jours}</div>
                  </div>
                  <div style={{textAlign:"center",background:"#fff",borderRadius:10,padding:"8px 12px",border:`1.5px solid ${phaseActuelle.phase.border}`}}>
                    <div style={{fontSize:8,color:"#9CA3AF",fontWeight:700}}>JEÛNE</div>
                    <div style={{fontSize:12,fontWeight:900,color:phaseActuelle.phase.couleur}}>{phaseActuelle.phase.dureeMax}</div>
                  </div>
                </div>
                <p style={{fontSize:12,color:"#374151",lineHeight:1.7,margin:"0 0 10px"}}>{phaseActuelle.phase.conseil}</p>
                <div style={{background:"rgba(255,255,255,0.7)",borderRadius:8,padding:"8px 10px",marginBottom:8}}>
                  <div style={{fontSize:10,color:phaseActuelle.phase.couleur,fontWeight:800,marginBottom:3}}>🥑 Alimentation</div>
                  <div style={{fontSize:11,color:"#374151",lineHeight:1.6}}>{phaseActuelle.phase.alimentation}</div>
                </div>
                <div style={{background:"rgba(255,255,255,0.7)",borderRadius:8,padding:"8px 10px",marginBottom:8}}>
                  <div style={{fontSize:10,color:phaseActuelle.phase.couleur,fontWeight:800,marginBottom:3}}>🏃 Activité</div>
                  <div style={{fontSize:11,color:"#374151",lineHeight:1.6}}>{phaseActuelle.phase.activite}</div>
                </div>
                <div style={{background:"#1B3A6B",borderRadius:8,padding:"8px 10px",display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:16}}>⚖️</span>
                  <div style={{fontSize:11,color:"#fff",fontWeight:700}}>≤ 20g de glucides/jour — règle céto inchangée</div>
                </div>
              </div>
            </div>
          )}

          {/* Les 4 phases résumé */}
          <div style={{fontSize:11,fontWeight:800,color:"#6B7280",marginBottom:8,textTransform:"uppercase",letterSpacing:1}}>Les 4 phases du cycle</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6,marginBottom:12}}>
            {PHASES_CYCLE.map(p=>{
              const estActive = phaseActuelle?.phase.id === p.id;
              return (
                <div key={p.id} style={{background:estActive?p.bg:"#F8FAFF",border:`1.5px solid ${estActive?p.border:"#E5E7EB"}`,borderRadius:10,padding:"8px 6px",textAlign:"center"}}>
                  <div style={{fontSize:18,marginBottom:4}}>{p.emoji}</div>
                  <div style={{fontSize:9,fontWeight:800,color:estActive?p.couleur:"#6B7280",lineHeight:1.3,marginBottom:3}}>{p.nom.replace("Phase ","")}</div>
                  <div style={{fontSize:8,color:"#9CA3AF",lineHeight:1.3}}>{p.jours}</div>
                  <div style={{fontSize:8,fontWeight:700,color:estActive?p.couleur:"#9CA3AF",marginTop:4,background:estActive?`${p.couleur}15`:"transparent",borderRadius:4,padding:"2px 4px"}}>{p.dureeMax}</div>
                </div>
              );
            })}
          </div>

          <div style={{background:"#FFF0F6",border:"1.5px solid #E91E8330",borderRadius:10,padding:"10px 12px",display:"flex",gap:10,alignItems:"flex-start"}}>
            <span style={{fontSize:18,flexShrink:0}}>👨‍⚕️</span>
            <p style={{fontSize:11,color:"#6B7280",lineHeight:1.6,margin:0}}>Ces recommandations sont indicatives et basées sur les rythmes hormonaux généraux. Chaque femme est différente — écoute ton corps et consulte ton médecin en cas de doute.</p>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}
// ─── FIN MODULE SPÉCIAL FEMME ─────────────────────────────────────────────────



// ─── BANDEAU PREMIUM UNIFORME ─────────────────────────────────────────────────
function BandeauPremium({ titre, description, onClick }) {
  return (
    <div onClick={onClick} style={{cursor:onClick?"pointer":"default",borderRadius:14,marginBottom:14,boxShadow:"0 2px 12px rgba(27,58,107,0.10)"}}>
      <div style={{background:"linear-gradient(90deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:14,minHeight:56}}>
        <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>{titre}</div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",flexShrink:0}}>
            <span style={{fontSize:13}}>💎</span>
            <span style={{fontSize:11,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
          </div>
          <span style={{fontSize:12,color:"rgba(255,255,255,0.7)"}}>▼</span>
        </div>
      </div>
      <div style={{background:"#EEF2FF",padding:"10px 16px",borderRadius:14,minHeight:40,display:"flex",alignItems:"center",marginTop:4}}>
        <p style={{fontSize:11,color:"#374151",lineHeight:1.6,margin:0}}>{description || ""}</p>
      </div>
    </div>
  );
}
// ─── FIN BANDEAU PREMIUM ──────────────────────────────────────────────────────

// ─── PAGE PREMIUM ─────────────────────────────────────────────────────────────
function PagePremium({ setPage, codeInput, setCodeInput, codeError, codeSuccess, activerCodePremium }) {
  const [offreChoisie, setOffreChoisie] = React.useState(null);
  const [emailPay, setEmailPay] = React.useState("");
  const [prenomPay, setPrenomPay] = React.useState("");
  const [champErreur, setChampErreur] = React.useState("");
  const offres = [
    {id:"soutien",  emoji:"🔷", titre:"Soutien",     prix:"3,99€", periode:"/mois", couleur:"#1B3A6B", bg:"#F0F4FF", texte:"Pour soutenir l'asso et accéder à tous les outils premium.", btnId:"soutien",  url:"https://buy.stripe.com/00w7sLbSM8yYf0m89x8so00", badge:"/Soutien.png"},
    {id:"bienfait", emoji:"🔶", titre:"Bienfaiteur", prix:"7,99€", periode:"/mois", couleur:"#E65100", bg:"#FFF8F0", texte:"Ton soutien renforcé fait vivre une asso 100% indépendante.", btnId:"bienfait", url:"https://buy.stripe.com/fZudR9f4Y9D2aK6gG38so01", badge:"/Bienfaiteur.png"},
    {id:"membre",   emoji:"🟢", titre:"Membre",      prix:"35€",   periode:"/an",   couleur:"#2E7D32", bg:"#F1F8E9", texte:"Moins de 3€/mois — l'engagement sur la durée.", btnId:"membre",   url:"https://buy.stripe.com/bJe7sLg9216wdWi61p8so02", badge:"/Membre.png"},
    {id:"don",      emoji:"💙", titre:"Donateur",    prix:"libre",  periode:"",      couleur:"#1B3A6B", bg:"#F0F4FF", texte:"Tu choisis ton montant et soutiens le projet à ta façon.", btnId:"don",      url:"https://buy.stripe.com/5kQeVd2ic3eEcSe9dB8so03", badge:"/Donateur.png"},
  ];

  const validerEtPayer = (o) => {
    if (!prenomPay.trim() || !emailPay.trim() || !emailPay.includes("@")) {
      setChampErreur("Merci de renseigner ton prénom et un email valide pour recevoir ton code.");
      return false;
    }
    setChampErreur("");
    return true;
  };
  return (
    <main style={{maxWidth:440,margin:"0 auto",padding:"16px 12px",fontFamily:"'Nunito',sans-serif"}}>
      <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:20,padding:"28px 24px",marginBottom:20,color:"#fff",textAlign:"center"}}>
        <div style={{fontSize:38,marginBottom:8}}>💎</div>
        <div style={{fontSize:22,fontWeight:900,marginBottom:6}}>Devenir Membre Premium</div>
        <div style={{fontSize:12,opacity:.8,lineHeight:1.7}}>Sans pub · Sans data · Sans mauvaise surprise</div>
      </div>
      <div style={{background:"#F1F8E9",borderRadius:14,padding:"14px 16px",marginBottom:20,border:"1.5px solid #7CB34230"}}>
        <div style={{fontSize:12,fontWeight:900,color:"#2E7D32",marginBottom:10}}>✨ Ce que tu débloques :</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5}}>
          {["📊 Courbes macros 7 jours","🫁 Respiration guidée","🚶‍♀️ Activité douce guidée","📈 Évolution & courbes","🌸 Spécial Femme","📸 Photos évolution","📄 Bilan mensuel PDF","🔬 Scanner produits"].map(f=>(
            <div key={f} style={{fontSize:11,color:"#374151",display:"flex",alignItems:"center",gap:5}}>
              <span style={{color:"#7CB342",fontWeight:900}}>✓</span>{f}
            </div>
          ))}
        </div>
      </div>
      {offres.map(o=>(
        <div key={o.id} style={{marginBottom:12}}>
          <div onClick={()=>setOffreChoisie(offreChoisie===o.id?null:o.id)}
            style={{background:offreChoisie===o.id?o.bg:"#fff",borderRadius:offreChoisie===o.id?"14px 14px 0 0":"14px",border:`2px solid ${offreChoisie===o.id?o.couleur+"60":"#E5E7EB"}`,padding:"16px 20px",cursor:"pointer",transition:"all 0.2s"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontSize:15,fontWeight:900,color:o.couleur}}>{o.emoji} {o.titre}</div>
                <div style={{fontSize:11,color:"#6B7280",marginTop:3}}>{o.texte}</div>
              </div>
              <div style={{textAlign:"right",flexShrink:0,marginLeft:12}}>
                <div style={{fontSize:22,fontWeight:900,color:o.couleur}}>{o.prix}</div>
                <div style={{fontSize:10,color:"#9CA3AF"}}>{o.periode}</div>
              </div>
            </div>
            {offreChoisie!==o.id && (
              <div style={{marginTop:12,textAlign:"center",background:o.couleur,borderRadius:8,padding:"10px",color:"#fff",fontWeight:900,fontSize:13}}>
                Choisir cette offre →
              </div>
            )}
          </div>
          {offreChoisie===o.id && (
            <div style={{background:"#F8FAFF",borderRadius:"0 0 14px 14px",border:`2px solid ${o.couleur}60`,borderTop:"none",padding:"16px 20px"}}>
              {/* Champs prénom + email obligatoires */}
              <div style={{marginBottom:14}}>
                <div style={{fontSize:11,fontWeight:900,color:"#1B3A6B",marginBottom:8}}>📧 Pour recevoir ton code par email</div>
                <input
                  type="text" value={prenomPay} onChange={e=>{setPrenomPay(e.target.value);setChampErreur("");}}
                  placeholder="Ton prénom"
                  style={{width:"100%",padding:"10px 12px",border:"2px solid #1B3A6B20",borderRadius:8,fontSize:13,outline:"none",boxSizing:"border-box",marginBottom:8,fontFamily:"inherit"}}
                />
                <input
                  type="email" value={emailPay} onChange={e=>{setEmailPay(e.target.value);setChampErreur("");}}
                  placeholder="ton@email.com"
                  style={{width:"100%",padding:"10px 12px",border:`2px solid ${champErreur?"#C62828":"#1B3A6B20"}`,borderRadius:8,fontSize:13,outline:"none",boxSizing:"border-box",fontFamily:"inherit"}}
                />
                {champErreur && <div style={{fontSize:11,color:"#C62828",marginTop:6}}>{champErreur}</div>}
              </div>
              <div style={{fontSize:11,color:"#6B7280",marginBottom:12,textAlign:"center"}}>Paiement sécurisé via Stripe 🔒</div>
              <a href={o.url} target="_blank" rel="noopener noreferrer"
                onClick={()=>validerEtPayer(o)}
                style={{display:"block",textAlign:"center",textDecoration:"none"}}>
                <img src={o.badge} alt={o.titre} style={{width:180,height:"auto",display:"block",margin:"0 auto 8px"}}/>
                <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:10,padding:"12px",color:"#fff",fontWeight:900,fontSize:15}}>
                  💳 Payer via Stripe
                </div>
              </a>
              <button onClick={()=>setOffreChoisie(null)} style={{width:"100%",marginTop:10,background:"none",border:"none",color:"#9CA3AF",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>← Choisir une autre offre</button>
            </div>
          )}
        </div>
      ))}
      <div style={{display:"flex",alignItems:"center",gap:12,margin:"20px 0"}}>
        <div style={{flex:1,height:1,background:"#E5E7EB"}}/>
        <div style={{fontSize:11,color:"#9CA3AF",fontWeight:700}}>J'ai déjà un code</div>
        <div style={{flex:1,height:1,background:"#E5E7EB"}}/>
      </div>
      <div style={{background:"#fff",borderRadius:16,border:"2px solid #1B3A6B20",padding:"16px 20px",marginBottom:20}}>
        <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:4}}>🔑 Code d'activation</div>
        <div style={{fontSize:11,color:"#6B7280",marginBottom:12,lineHeight:1.6}}>
          Tu as reçu un code après ton paiement ? Saisis-le ici.<br/>
          <span style={{color:"#F4A035",fontWeight:700}}>⚠️ Utilisable sur 2 appareils maximum.</span>
        </div>
        {codeSuccess ? (
          <div style={{background:"#F1F8E9",borderRadius:10,padding:16,textAlign:"center"}}>
            <div style={{fontSize:28,marginBottom:6}}>🎉</div>
            <div style={{fontSize:14,fontWeight:900,color:"#2E7D32",marginBottom:4}}>Premium activé !</div>
            <div style={{fontSize:11,color:"#558B2F"}}>Bienvenue dans la communauté Céto Club premium.</div>
          </div>
        ) : (
          <div>
            <input type="text" value={codeInput} onChange={e=>setCodeInput(e.target.value.toUpperCase())}
              placeholder="CETO-XXXX-XXXX"
              style={{width:"100%",padding:"12px 14px",border:`2px solid ${codeError?"#C62828":"#1B3A6B30"}`,borderRadius:10,fontSize:14,fontWeight:800,outline:"none",boxSizing:"border-box",marginBottom:8,letterSpacing:2,textAlign:"center"}}/>
            {codeError && <div style={{fontSize:11,color:"#C62828",marginBottom:8,textAlign:"center"}}>{codeError}</div>}
            <div style={{background:"#FFF8F0",border:"1.5px solid #F4A03550",borderRadius:8,padding:"10px 12px",marginBottom:10,fontSize:11,color:"#6B7280",lineHeight:1.6}}>
              ⚠️ <strong style={{color:"#E65100"}}>À lire avant d'activer :</strong> En cliquant sur le bouton ci-dessous, tu confirmes que l'accès au contenu numérique commence immédiatement et que tu <strong style={{color:"#E65100"}}>renonces expressément à ton droit de rétractation de 14 jours</strong>, conformément à l'article L221-28 du Code de la consommation.
            </div>
            <button onClick={activerCodePremium}
              style={{width:"100%",padding:"12px",borderRadius:10,background:"linear-gradient(135deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",fontWeight:900,fontSize:14,cursor:"pointer"}}>
              ✓ Activer mon accès premium
            </button>
            <a href="https://billing.stripe.com/p/login/00w7sLbSM8yYf0m89x8so00" target="_blank" rel="noopener noreferrer"
              style={{display:"block",textAlign:"center",marginTop:10,padding:"10px",borderRadius:10,border:"1.5px solid #E5E7EB",background:"#F9FAFB",color:"#6B7280",fontSize:12,textDecoration:"none",fontWeight:700}}>
              🔧 Gérer ou résilier mon abonnement
            </a>
          </div>
        )}
      </div>
      <div style={{fontSize:9,color:"#9ca3af",textAlign:"center",lineHeight:1.8,marginBottom:20}}>
        Paiement sécurisé via Stripe · Résiliation à tout moment depuis votre espace Stripe<br/>
        Droit de rétractation 14 jours (sauf activation du code avant ce délai)<br/>
        <button onClick={()=>setPage("cgu")} style={{background:"none",border:"none",color:"#1B3A6B",cursor:"pointer",fontSize:9,fontWeight:700,textDecoration:"underline"}}>CGU & CGV</button>
        {" · "}
        <button onClick={()=>setPage("mentions")} style={{background:"none",border:"none",color:"#1B3A6B",cursor:"pointer",fontSize:9,fontWeight:700,textDecoration:"underline"}}>Mentions légales</button>
        <br/>Association Cuisiner pour la Paix — Céto Club · contact@cetoclub.com
      </div>
    </main>
  );
}
// ─── FIN PAGE PREMIUM ─────────────────────────────────────────────────────────

// ─── PLANNING JEÛNE HEBDOMADAIRE ─────────────────────────────────────────────
const PLANNING_JEUNE_KEY = "cetoclub_planning_jeune";
const JOURS_SEMAINE = ["Lun","Mar","Mer","Jeu","Ven","Sam","Dim"];

function PlanningJeune({ protocoles }) {
  const defaut = JOURS_SEMAINE.reduce((acc, j) => {
    acc[j] = { actif: ["Lun","Mar","Mer","Jeu","Ven"].includes(j), heure: "20:00", protocole: "16:8" };
    return acc;
  }, {});

  const [planning, setPlanning] = React.useState(() => {
    try { return JSON.parse(localStorage.getItem(PLANNING_JEUNE_KEY)) || defaut; } catch { return defaut; }
  });

  const sauvegarder = (p) => {
    setPlanning(p);
    try { localStorage.setItem(PLANNING_JEUNE_KEY, JSON.stringify(p)); } catch {}
  };

  const toggleJour = (j) => {
    const nv = { ...planning, [j]: { ...planning[j], actif: !planning[j].actif } };
    sauvegarder(nv);
  };

  const setHeure = (j, h) => {
    const nv = { ...planning, [j]: { ...planning[j], heure: h } };
    sauvegarder(nv);
  };

  const setProto = (j, p) => {
    const nv = { ...planning, [j]: { ...planning[j], protocole: p } };
    sauvegarder(nv);
  };

  // Quel jour sommes-nous ?
  const jourIdx = (new Date().getDay() + 6) % 7; // 0=Lun
  const jourAujourd = JOURS_SEMAINE[jourIdx];
  const planAujourd = planning[jourAujourd];

  // Calcul fin prévue aujourd'hui
  const finPrevue = planAujourd?.actif ? (() => {
    const [h, m] = planAujourd.heure.split(":").map(Number);
    const duree = protocoles.find(p => p.id === planAujourd.protocole)?.duree || 16;
    const fin = new Date(); fin.setHours(h + duree, m, 0, 0);
    if (fin < new Date()) fin.setDate(fin.getDate() + 1);
    return fin.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
  })() : null;

  const joursActifs = JOURS_SEMAINE.filter(j => planning[j].actif).length;

  return (
    <div style={{borderRadius:14,marginTop:14,boxShadow:"0 2px 12px rgba(27,58,107,0.10)"}}>
      {/* Header */}
      <div style={{background:"linear-gradient(90deg,#1B3A6B,#2A5298)",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:14}}>
        <div>
          <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>📅 Mon planning de jeûne</div>
          <div style={{fontSize:10,color:"rgba(255,255,255,0.65)",marginTop:1}}>{joursActifs} jour{joursActifs>1?"s":""} de jeûne programmé{joursActifs>1?"s":""} cette semaine</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:5,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px"}}>
          <span style={{fontSize:13}}>💎</span>
          <span style={{fontSize:11,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
        </div>
      </div>

      <div style={{background:"#fff",padding:16,borderRadius:"0 0 14px 14px"}}>

        {/* Rappel aujourd'hui */}
        {planAujourd && (
          <div style={{background:planAujourd.actif?"#F1F8E9":"#F8FAFF",border:`1.5px solid ${planAujourd.actif?"#7CB34240":"#E5E7EB"}`,borderRadius:10,padding:"10px 14px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <div style={{fontSize:11,fontWeight:800,color:planAujourd.actif?"#2E7D32":"#6B7280"}}>
                {planAujourd.actif ? "✅ Aujourd'hui tu jeûnes" : "⭕ Pas de jeûne aujourd'hui"}
              </div>
              {planAujourd.actif && (
                <div style={{fontSize:10,color:"#6B7280",marginTop:2}}>
                  Début {planAujourd.heure} · {planAujourd.protocole} · fin prévue {finPrevue}
                </div>
              )}
            </div>
            <div style={{fontSize:22}}>{planAujourd.actif?"🔥":"😌"}</div>
          </div>
        )}

        {/* Grille des 7 jours */}
        <div style={{display:"grid",gap:8}}>
          {JOURS_SEMAINE.map((j, i) => {
            const p = planning[j];
            const estAujourd = j === jourAujourd;
            return (
              <div key={j} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:10,background:estAujourd?"#EEF2FF":p.actif?"#F8FAFF":"#F3F4F6",border:estAujourd?"1.5px solid #1B3A6B":"1.5px solid transparent",transition:"all 0.2s"}}>

                {/* Toggle ON/OFF */}
                <button onClick={()=>toggleJour(j)}
                  style={{width:42,height:24,borderRadius:12,border:"none",cursor:"pointer",position:"relative",flexShrink:0,
                    background:p.actif?"#1B3A6B":"#D1D5DB",transition:"background 0.2s"}}>
                  <div style={{position:"absolute",top:3,left:p.actif?20:3,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}}/>
                </button>

                {/* Nom du jour */}
                <div style={{width:32,fontWeight:estAujourd?900:700,fontSize:12,color:estAujourd?"#1B3A6B":p.actif?"#374151":"#9CA3AF"}}>
                  {j}{estAujourd&&<span style={{fontSize:8,color:"#1B3A6B",display:"block",fontWeight:700}}>auj.</span>}
                </div>

                {/* Heure + protocole — visibles seulement si actif */}
                {p.actif ? (
                  <>
                    <div style={{flex:1,display:"flex",gap:6,alignItems:"center"}}>
                      <input type="time" value={p.heure} onChange={e=>setHeure(j,e.target.value)}
                        style={{padding:"4px 8px",border:"1.5px solid #1B3A6B20",borderRadius:7,fontSize:12,fontWeight:800,outline:"none",color:"#1B3A6B",background:"#fff",width:82}}/>
                      <select value={p.protocole} onChange={e=>setProto(j,e.target.value)}
                        style={{flex:1,padding:"4px 8px",border:"1.5px solid #1B3A6B20",borderRadius:7,fontSize:11,outline:"none",background:"#fff",color:"#374151"}}>
                        {protocoles.map(pr=>(
                          <option key={pr.id} value={pr.id}>{pr.l}</option>
                        ))}
                      </select>
                    </div>
                    <div style={{fontSize:10,color:"#9CA3AF",flexShrink:0,textAlign:"right"}}>
                      {(()=>{
                        const [h,m] = p.heure.split(":").map(Number);
                        const duree = protocoles.find(pr=>pr.id===p.protocole)?.duree||16;
                        const fin = new Date(); fin.setHours(h+duree,m,0,0);
                        return "→ "+fin.toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"});
                      })()}
                    </div>
                  </>
                ) : (
                  <div style={{flex:1,fontSize:11,color:"#9CA3AF",fontStyle:"italic"}}>Repos</div>
                )}
              </div>
            );
          })}
        </div>

        {/* Note bilan */}
        <div style={{marginTop:12,background:"#F0F4FF",borderRadius:8,padding:"8px 12px",fontSize:10,color:"#2A5298",lineHeight:1.5}}>
          📊 Ces données sont enregistrées et seront incluses dans ton bilan mensuel PDF.
        </div>
      </div>
    </div>
  );
}
// ─── FIN PLANNING JEÛNE ───────────────────────────────────────────────────────

// ─── BILAN PDF PREMIUM ────────────────────────────────────────────────────────

// ── MODULE CÉTONÉMIE & GLYCÉMIE PREMIUM ──────────────────────────────────────
const LS_CETO_BIO = "cetoclub_bio_mesures";
const loadBio = () => { try { return JSON.parse(localStorage.getItem(LS_CETO_BIO)||"[]"); } catch { return []; } };
const saveBio = (d) => { try { localStorage.setItem(LS_CETO_BIO, JSON.stringify(d.slice(0,500))); } catch {} };

function ModuleBiologie() {
  const today = new Date().toISOString().split("T")[0];
  const [ouvert, setOuvert] = React.useState(false);
  const [mesures, setMesures] = React.useState(() => loadBio());
  const [onglet, setOnglet] = React.useState("cetone");
  const [form, setForm] = React.useState({ date: today, heure: new Date().toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"}), valeur: "" });
  const [vue, setVue] = React.useState("courbe");

  const sauvegarder = () => {
    if (!form.valeur) return;
    const nouvelle = { id: Date.now(), type: onglet, date: form.date, heure: form.heure, valeur: parseFloat(form.valeur.replace(",",".")) };
    const nouvelles = [nouvelle, ...mesures];
    saveBio(nouvelles);
    setMesures(nouvelles);
    setForm(f => ({ ...f, valeur: "" }));
  };

  const supprimer = (id) => {
    const updated = mesures.filter(m => m.id !== id);
    saveBio(updated);
    setMesures(updated);
  };

  const mesuresFiltrees = mesures.filter(m => m.type === onglet).sort((a,b) => a.date.localeCompare(b.date) || a.heure.localeCompare(b.heure));
  const dernieres30 = mesuresFiltrees.filter(m => m.date >= new Date(Date.now()-30*86400000).toISOString().split("T")[0]);
  const unite = onglet === "cetone" ? "mmol/L" : "g/L";
  const step = onglet === "cetone" ? "0.1" : "0.01";
  const VERT = "#7CB342";
  const VERT_PALE = "#F1F8E9";

  const W = 280, H = 80;
  const vals = dernieres30.map(m => m.valeur);
  const maxV = Math.max(...vals, 0.1);
  const minV = Math.min(...vals, 0);
  const range = maxV - minV || 1;
  const pts = dernieres30.map((m, i) => ({
    x: dernieres30.length > 1 ? Math.round(i * W / (dernieres30.length - 1)) : W/2,
    y: Math.round(H - ((m.valeur - minV) / range) * H * 0.85 - H * 0.05),
    v: m.valeur, d: m.date
  }));
  const path = pts.map((p,i) => i===0 ? `M${p.x},${p.y}` : `L${p.x},${p.y}`).join(" ");
  const inp = {padding:"9px 12px",borderRadius:8,border:`1.5px solid ${VERT}40`,fontSize:13,fontFamily:"'Nunito',sans-serif",boxSizing:"border-box"};

  return (
    <div style={{background:"#fff",borderRadius:14,border:`2px solid ${VERT}30`,overflow:"hidden",marginBottom:12}}>
      {/* Header repliable */}
      <div onClick={()=>setOuvert(o=>!o)} style={{background:`linear-gradient(135deg,#1B3A6B,#2A5298)`,padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>
        <div>
          <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>🔬 Cétonémie & Glycémie</div>
          <div style={{fontSize:10,color:"rgba(255,255,255,0.7)",marginTop:1}}>Suivi de vos mesures biologiques</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{display:"flex",alignItems:"center",gap:5,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"3px 10px"}}>
            <span style={{fontSize:10,fontWeight:900,color:"#fff"}}>💎 PREMIUM</span>
          </div>
          <span style={{color:"#fff",fontSize:14,transform:ouvert?"rotate(180deg)":"rotate(0deg)",transition:"transform 0.2s"}}>▼</span>
        </div>
      </div>

      {ouvert && (
        <div style={{padding:14}}>
          {/* Onglets tout en vert */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:14}}>
            {[{k:"cetone",l:"🔵 Cétonémie",u:"mmol/L"},{k:"glycemie",l:"🟢 Glycémie",u:"g/L"}].map(o=>(
              <button key={o.k} onClick={()=>setOnglet(o.k)}
                style={{padding:"10px",borderRadius:10,border:`2px solid ${VERT}`,background:onglet===o.k?VERT:"#fff",color:onglet===o.k?"#fff":VERT,fontWeight:800,fontSize:12,cursor:"pointer",fontFamily:"inherit",transition:"all 0.15s"}}>
                {o.l}<div style={{fontSize:9,opacity:.8,marginTop:2}}>{o.u}</div>
              </button>
            ))}
          </div>

          {/* Saisie */}
          <div style={{background:VERT_PALE,borderRadius:10,padding:12,marginBottom:14,border:`1.5px solid ${VERT}20`}}>
            <div style={{fontSize:11,fontWeight:800,color:VERT,marginBottom:10}}>Nouvelle mesure</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:10}}>
              <div>
                <div style={{fontSize:9,fontWeight:800,color:"#6B7280",marginBottom:4,textTransform:"uppercase"}}>Date</div>
                <input type="date" value={form.date} onChange={e=>setForm(f=>({...f,date:e.target.value}))} style={{...inp,width:"100%"}}/>
              </div>
              <div>
                <div style={{fontSize:9,fontWeight:800,color:"#6B7280",marginBottom:4,textTransform:"uppercase"}}>Heure</div>
                <input type="time" value={form.heure} onChange={e=>setForm(f=>({...f,heure:e.target.value}))} style={{...inp,width:"100%"}}/>
              </div>
              <div>
                <div style={{fontSize:9,fontWeight:800,color:VERT,marginBottom:4,textTransform:"uppercase"}}>{unite}</div>
                <input type="number" min="0" step={step} placeholder={onglet==="cetone"?"ex: 1.8":"ex: 0.90"} value={form.valeur}
                  onChange={e=>setForm(f=>({...f,valeur:e.target.value}))}
                  style={{...inp,width:"100%",fontWeight:800,color:VERT}}/>
              </div>
            </div>
            <button onClick={sauvegarder} disabled={!form.valeur}
              style={{width:"100%",padding:"10px",borderRadius:8,background:form.valeur?VERT:"#E5E7EB",color:form.valeur?"#fff":"#9ca3af",border:"none",fontWeight:900,fontSize:12,cursor:form.valeur?"pointer":"default",fontFamily:"inherit"}}>
              ✓ Enregistrer cette mesure
            </button>
          </div>

          {/* Vue courbe / tableau */}
          {dernieres30.length > 0 && (
            <>
              <div style={{display:"flex",gap:6,marginBottom:12}}>
                {[{k:"courbe",l:"📈 Courbe"},{k:"tableau",l:"📋 Tableau"}].map(v=>(
                  <button key={v.k} onClick={()=>setVue(v.k)} style={{padding:"5px 12px",borderRadius:20,border:"none",background:vue===v.k?VERT:"#F3F4F6",color:vue===v.k?"#fff":"#6B7280",fontWeight:800,fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>{v.l}</button>
                ))}
              </div>

              {vue === "courbe" && (
                <div style={{background:VERT_PALE,borderRadius:10,padding:12,marginBottom:8,border:`1.5px solid ${VERT}20`}}>
                  <div style={{fontSize:10,color:"#6B7280",marginBottom:8}}>{onglet==="cetone"?"Cétonémie":"Glycémie"} — 30 derniers jours ({unite})</div>
                  {pts.length >= 2 ? (
                    <svg viewBox={`0 0 ${W} ${H+20}`} style={{width:"100%",display:"block"}}>
                      <path d={path} fill="none" stroke={VERT} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round"/>
                      {pts.map((p,i)=>(
                        <g key={i}>
                          <circle cx={p.x} cy={p.y} r="3.5" fill={VERT}/>
                          <text x={p.x} y={p.y-7} textAnchor="middle" fontSize="8" fill={VERT} fontWeight="bold">{p.v}</text>
                        </g>
                      ))}
                      {pts.filter((_,i)=>i===0||i===pts.length-1||(i%Math.ceil(pts.length/5)===0)).map((p,i)=>(
                        <text key={i} x={p.x} y={H+14} textAnchor="middle" fontSize="7" fill="#9CA3AF">{p.d.slice(8)}/{p.d.slice(5,7)}</text>
                      ))}
                    </svg>
                  ) : (
                    <div style={{textAlign:"center",fontSize:11,color:"#9ca3af",padding:"20px 0"}}>Saisissez au moins 2 mesures pour voir la courbe</div>
                  )}
                </div>
              )}

              {vue === "tableau" && (
                <div style={{borderRadius:10,overflow:"hidden",border:`1px solid ${VERT}30`,marginBottom:8}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
                    <thead>
                      <tr style={{background:"#1B3A6B"}}>
                        <th style={{padding:"7px 10px",textAlign:"left",color:VERT,fontWeight:800,fontSize:10}}>Date</th>
                        <th style={{padding:"7px 10px",textAlign:"center",color:VERT,fontWeight:800,fontSize:10}}>Heure</th>
                        <th style={{padding:"7px 10px",textAlign:"right",color:VERT,fontWeight:800,fontSize:10}}>{unite}</th>
                        <th style={{padding:"7px 4px",textAlign:"center",color:VERT,fontWeight:800,fontSize:10}}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {mesuresFiltrees.slice().reverse().map((m,i)=>(
                        <tr key={m.id} style={{background:i%2===0?"#fff":VERT_PALE,borderBottom:`0.5px solid ${VERT}15`}}>
                          <td style={{padding:"6px 10px",color:"#374151"}}>{m.date.slice(8)}/{m.date.slice(5,7)}/{m.date.slice(0,4)}</td>
                          <td style={{padding:"6px 10px",textAlign:"center",color:"#6B7280"}}>{m.heure}</td>
                          <td style={{padding:"6px 10px",textAlign:"right",fontWeight:800,color:VERT}}>{m.valeur}</td>
                          <td style={{padding:"6px 4px",textAlign:"center"}}>
                            <button onClick={()=>supprimer(m.id)} style={{background:"none",border:"none",color:"#D1D5DB",fontSize:12,cursor:"pointer",padding:"0 4px"}}>✕</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}

          {mesuresFiltrees.length === 0 && (
            <div style={{textAlign:"center",fontSize:11,color:"#9ca3af",padding:"12px 0"}}>
              Aucune mesure enregistrée — saisissez votre première valeur ci-dessus
            </div>
          )}
        </div>
      )}
    </div>
  );
}
// ── FIN MODULE CÉTONÉMIE & GLYCÉMIE ──────────────────────────────────────────

function BilanPDF({ onRetour }) {
  const [periode, setPeriode] = React.useState("30"); // "7" | "30" | "90"
  const [genere, setGenere] = React.useState(false);
  const [chargement, setChargement] = React.useState(false);

  // ── Lecture localStorage ──
  const lireData = () => {
    const profil    = (() => { try { return JSON.parse(localStorage.getItem("cetoclub_profil")||"{}"); } catch { return {}; } })();
    const poids     = (() => { try { return JSON.parse(localStorage.getItem("cetoclub_poids")||"[]"); } catch { return []; } })();
    const mensur    = (() => { try { return JSON.parse(localStorage.getItem("cetoclub_mensurations")||"[]"); } catch { return []; } })();
    const suivi     = (() => { try { return JSON.parse(localStorage.getItem("cetoclub_suivi")||"{}"); } catch { return {}; } })();
    const sommeil   = (() => { try { return JSON.parse(localStorage.getItem("cetoclub_sommeil")||"{}"); } catch { return {}; } })();
    const jeuneHisto= (() => { try { return JSON.parse(localStorage.getItem("cetoclub_jeune_histo")||"[]"); } catch { return []; } })();

    const nbJours = parseInt(periode);
    const maintenant = new Date();
    const debut = new Date(); debut.setDate(debut.getDate() - nbJours + 1);
    const debutStr = debut.toISOString().split("T")[0];

    // ── Macros journalières ──
    const macrosParJour = [];
    for (let i = 0; i < nbJours; i++) {
      const d = new Date(debut); d.setDate(debut.getDate() + i);
      const dateKey = d.toISOString().split("T")[0];
      const journalAllB = (() => { try { return JSON.parse(localStorage.getItem("cetoclub_journal")||"{}"); } catch { return {}; } })();
      const entrees = journalAllB[dateKey] || [];
      if (entrees.length > 0) {
        const tot = entrees.reduce((a,e) => ({lip:a.lip+(e.lip||0), glu:a.glu+(e.glu||0), pro:a.pro+(e.pro||0)}), {lip:0,glu:0,pro:0});
        macrosParJour.push({ date: dateKey, ...tot, nbRepas: entrees.length });
      }
    }

    // ── Statistiques macros ──
    const statsM = macrosParJour.length > 0 ? {
      jEnregistres: macrosParJour.length,
      gluMoy: Math.round(macrosParJour.reduce((a,j)=>a+j.glu,0)/macrosParJour.length),
      proMoy: Math.round(macrosParJour.reduce((a,j)=>a+j.pro,0)/macrosParJour.length),
      lipMoy: Math.round(macrosParJour.reduce((a,j)=>a+j.lip,0)/macrosParJour.length),
      joursOK: macrosParJour.filter(j=>j.glu<=20).length,
    } : null;

    // ── Poids sur la période ──
    const poidsPeriode = poids.filter(p => p.date >= debutStr).sort((a,b)=>a.date.localeCompare(b.date));
    const poidsDebut = poidsPeriode[0]?.poids ?? null;
    const poidsFin   = poidsPeriode[poidsPeriode.length-1]?.poids ?? null;
    const poidsEvol  = (poidsDebut && poidsFin) ? parseFloat((poidsFin - poidsDebut).toFixed(1)) : null;

    // ── Mensurations ──
    const mensurPeriode = mensur.filter(m => m.date >= debutStr).sort((a,b)=>a.date.localeCompare(b.date));
    const mensurDebut = mensurPeriode[0] ?? null;
    const mensurFin   = mensurPeriode[mensurPeriode.length-1] ?? null;

    // ── Suivi bien-être ──
    const suiviPeriode = Object.entries(suivi)
      .filter(([k]) => k >= debutStr)
      .map(([,v]) => v)
      .filter(Boolean);
    const statsS = suiviPeriode.length > 0 ? {
      jours: suiviPeriode.length,
      energieMoy: (suiviPeriode.reduce((a,v)=>a+Number(v.energie||3),0)/suiviPeriode.length).toFixed(1),
      humeurMoy:  (suiviPeriode.reduce((a,v)=>a+Number(v.humeur||3),0)/suiviPeriode.length).toFixed(1),
      faimMoy:    (suiviPeriode.reduce((a,v)=>a+Number(v.faim||3),0)/suiviPeriode.length).toFixed(1),
      notes:      suiviPeriode.filter(v=>v.note&&v.note.trim()).map(v=>({date:v.date,note:v.note.trim()})).slice(-30),
    } : null;

    // ── Sommeil ──
    const sommeilPeriode = Object.entries(sommeil)
      .filter(([k]) => k >= debutStr)
      .map(([,v]) => v)
      .filter(Boolean);
    const statsZ = sommeilPeriode.length > 0 ? {
      jours: sommeilPeriode.length,
      dureeMoy: (sommeilPeriode.reduce((a,v)=>a+(v.dureeH||0),0)/sommeilPeriode.length).toFixed(1),
      qualiteMoy:(sommeilPeriode.reduce((a,v)=>a+Number(v.qualite||3),0)/sommeilPeriode.length).toFixed(1),
    } : null;

    // ── Jeûnes ──
    const jeunesPeriode = jeuneHisto.filter(j => j.fin && j.fin >= debutStr);
    const statsJ = jeunesPeriode.length > 0 ? {
      nb: jeunesPeriode.length,
      dureeMoy: (jeunesPeriode.reduce((a,j)=>{
        const diff = (new Date(j.fin) - new Date(j.debut)) / 3600000;
        return a + diff;
      }, 0) / jeunesPeriode.length).toFixed(1),
      dureeMax: Math.max(...jeunesPeriode.map(j=>{
        return parseFloat(((new Date(j.fin) - new Date(j.debut)) / 3600000).toFixed(1));
      })),
    } : null;

    // ── Cétonémie & Glycémie ──
    const bioMesures = (() => { try { return JSON.parse(localStorage.getItem("cetoclub_bio_mesures")||"[]"); } catch { return []; } })();
    const biosPeriode = bioMesures.filter(m => m.date >= debutStr).sort((a,b)=>a.date.localeCompare(b.date)||a.heure.localeCompare(b.heure));
    const cetones = biosPeriode.filter(m=>m.type==="cetone");
    const glycemies = biosPeriode.filter(m=>m.type==="glycemie");

    return { profil, statsM, poidsDebut, poidsFin, poidsEvol, poidsPeriode, mensurDebut, mensurFin, statsS, statsZ, statsJ, cetones, glycemies, nbJours, debutStr };
  };

  const genererHTML = () => {
    const d = lireData();
    const prenom = d.profil.prenom || "Utilisateur";
    const dateFr = (str) => {
      if (!str) return "—";
      const [y,m,j] = str.split("-");
      return `${j}/${m}/${y}`;
    };
    const etoiles = (val) => {
      const n = Math.round(parseFloat(val)||0);
      return "★".repeat(n) + "☆".repeat(5-n);
    };
    const hoje = new Date().toLocaleDateString("fr-FR", {day:"2-digit",month:"long",year:"numeric"});

    const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8">
<title>Bilan Céto Club — ${prenom}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Inter', sans-serif; background: #FAFAF7; color: #1a2a1a; padding: 32px 24px; max-width: 720px; margin: 0 auto; }
  .entete { display: flex; align-items: center; gap: 16px; margin-bottom: 32px; padding-bottom: 20px; border-bottom: 3px solid #1B3A6B; }
  .logo-cercle { width: 56px; height: 56px; background: #1B3A6B; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 28px; flex-shrink: 0; }
  .entete-titre { flex: 1; }
  .entete-titre h1 { font-size: 22px; font-weight: 900; color: #1B3A6B; }
  .entete-titre p { font-size: 12px; color: #6B7280; margin-top: 3px; }
  .entete-periode { text-align: right; font-size: 11px; color: #6B7280; }
  .entete-periode strong { display: block; font-size: 18px; font-weight: 900; color: #1B3A6B; }
  .section { background: #fff; border-radius: 14px; border: 2px solid #1B3A6B15; padding: 20px; margin-bottom: 16px; break-inside: avoid; }
  .section-titre { font-size: 14px; font-weight: 900; color: #1B3A6B; margin-bottom: 14px; display: flex; align-items: center; gap: 8px; }
  .grille-3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 10px; }
  .grille-2 { display: grid; grid-template-columns: repeat(2,1fr); gap: 10px; }
  .carte { border-radius: 10px; padding: 12px; text-align: center; }
  .carte-label { font-size: 10px; font-weight: 800; margin-bottom: 4px; }
  .carte-valeur { font-size: 26px; font-weight: 900; }
  .carte-unit { font-size: 10px; color: #9ca3af; font-weight: 600; }
  .badge { display: inline-block; padding: 4px 10px; border-radius: 20px; font-size: 11px; font-weight: 800; }
  .badge-ok { background: #F1F8E9; color: #558B2F; }
  .badge-warn { background: #FFF3E0; color: #E65100; }
  .ligne-info { display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid #F3F4F6; font-size: 12px; }
  .ligne-info:last-child { border-bottom: none; }
  .ligne-info .lbl { color: #6B7280; font-weight: 600; }
  .ligne-info .val { font-weight: 900; color: #1B3A6B; }
  .note-item { background: #F8F9FA; border-radius: 8px; padding: 10px; margin-bottom: 8px; font-size: 11px; line-height: 1.5; }
  .note-date { font-size: 10px; font-weight: 800; color: #9ca3af; margin-bottom: 4px; }
  .vide { text-align: center; padding: 20px; color: #9ca3af; font-size: 12px; font-style: italic; }
  .pied { margin-top: 32px; padding-top: 16px; border-top: 2px solid #1B3A6B15; text-align: center; font-size: 9px; color: #9ca3af; line-height: 1.8; }
  .barre-prog { background: #F3F4F6; border-radius: 20px; height: 8px; overflow: hidden; margin-top: 4px; }
  .barre-prog-inner { height: 100%; border-radius: 20px; }
  @media print { body { padding: 16px; } }
</style>
</head>
<body>

<div class="entete">
  <div class="logo-cercle">🥑</div>
  <div class="entete-titre">
    <h1>Bilan de ${prenom}</h1>
    <p>Résumé personnel — Céto Club</p>
  </div>
  <div class="entete-periode">
    <strong>${d.nbJours} jours</strong>
    ${dateFr(d.debutStr)} → ${dateFr(new Date().toISOString().split("T")[0])}<br>
    <span>Généré le ${hoje}</span>
  </div>
</div>

${d.profil.debutCeto ? `
<div class="section">
  <div class="section-titre">👤 Mon profil</div>
  <div class="grille-2">
    ${d.profil.debutCeto ? `<div class="ligne-info"><span class="lbl">Début céto</span><span class="val">${dateFr(d.profil.debutCeto)}</span></div>` : ""}
    ${d.profil.objectifPoids ? `<div class="ligne-info"><span class="lbl">Objectif poids</span><span class="val">${d.profil.objectifPoids} kg</span></div>` : ""}
  </div>
</div>
` : ""}

<div class="section">
  <div class="section-titre">🥗 Nutrition</div>
  ${d.statsM ? `
  <div class="grille-3" style="margin-bottom:14px;">
    <div class="carte" style="background:#FFF8F0;">
      <div class="carte-label" style="color:#F4A035;">🧈 Lipides moy.</div>
      <div class="carte-valeur" style="color:#F4A035;">${d.statsM.lipMoy}<span class="carte-unit">g/j</span></div>
    </div>
    <div class="carte" style="background:#E8EEF8;">
      <div class="carte-label" style="color:#1B3A6B;">🌾 Glucides moy.</div>
      <div class="carte-valeur" style="color:#1B3A6B;">${d.statsM.gluMoy}<span class="carte-unit">g/j</span></div>
    </div>
    <div class="carte" style="background:#F1F8E9;">
      <div class="carte-label" style="color:#7CB342;">💪 Protéines moy.</div>
      <div class="carte-valeur" style="color:#7CB342;">${d.statsM.proMoy}<span class="carte-unit">g/j</span></div>
    </div>
  </div>
  <div class="ligne-info">
    <span class="lbl">Jours enregistrés</span>
    <span class="val">${d.statsM.jEnregistres} / ${d.nbJours}</span>
  </div>
  <div class="ligne-info">
    <span class="lbl">Jours céto ✓ (glucides ≤ 20g)</span>
    <span class="val">
      ${d.statsM.joursOK} jour${d.statsM.joursOK>1?"s":""}
      <span class="badge ${d.statsM.joursOK/d.statsM.jEnregistres>=0.8?"badge-ok":"badge-warn"}">
        ${Math.round(d.statsM.joursOK/d.statsM.jEnregistres*100)}%
      </span>
    </span>
  </div>
  ` : `<div class="vide">Aucune donnée nutritionnelle sur cette période.</div>`}
</div>

<div class="section">
  <div class="section-titre">⚖️ Évolution du poids</div>
  ${d.poidsEvol !== null ? `
  <div class="grille-3" style="margin-bottom:14px;">
    <div class="carte" style="background:#E8EEF8;">
      <div class="carte-label" style="color:#1B3A6B;">Début</div>
      <div class="carte-valeur" style="color:#1B3A6B;">${d.poidsDebut}<span class="carte-unit">kg</span></div>
    </div>
    <div class="carte" style="background:#F1F8E9;">
      <div class="carte-label" style="color:#7CB342;">Fin</div>
      <div class="carte-valeur" style="color:#7CB342;">${d.poidsFin}<span class="carte-unit">kg</span></div>
    </div>
    <div class="carte" style="background:${d.poidsEvol<=0?"#F1F8E9":"#FFF3E0"};">
      <div class="carte-label" style="color:${d.poidsEvol<=0?"#558B2F":"#E65100"};">Évolution</div>
      <div class="carte-valeur" style="color:${d.poidsEvol<=0?"#558B2F":"#E65100"};">${d.poidsEvol>0?"+":""}${d.poidsEvol}<span class="carte-unit">kg</span></div>
    </div>
  </div>
  <div class="ligne-info">
    <span class="lbl">Nombre de pesées</span>
    <span class="val">${d.poidsPeriode.length}</span>
  </div>
  ${d.profil.objectifPoids ? `
  <div class="ligne-info">
    <span class="lbl">Objectif</span>
    <span class="val">${d.profil.objectifPoids} kg — il reste ${Math.max(0,(d.poidsFin-d.profil.objectifPoids)).toFixed(1)} kg</span>
  </div>` : ""}
  ` : `<div class="vide">Aucune pesée enregistrée sur cette période.</div>`}
</div>

${d.mensurDebut || d.mensurFin ? `
<div class="section">
  <div class="section-titre">📏 Mensurations</div>
  ${["taille","hanches","cuisses"].map(m => {
    const vDeb = d.mensurDebut?.[m];
    const vFin = d.mensurFin?.[m];
    if (!vDeb && !vFin) return "";
    const diff = (vDeb && vFin) ? parseFloat((vFin - vDeb).toFixed(1)) : null;
    const labels = {taille:"Tour de taille",hanches:"Tour de hanches",cuisses:"Tour de cuisses"};
    return `<div class="ligne-info">
      <span class="lbl">${labels[m]}</span>
      <span class="val">
        ${vDeb ?? "—"} cm → ${vFin ?? "—"} cm
        ${diff !== null ? `<span class="badge ${diff<=0?"badge-ok":"badge-warn"}">${diff>0?"+":""}${diff} cm</span>` : ""}
      </span>
    </div>`;
  }).join("")}
</div>
` : ""}

${d.statsS ? `
<div class="section">
  <div class="section-titre">🌿 Bien-être (${d.statsS.jours} jour${d.statsS.jours>1?"s":""})</div>
  <div class="grille-3" style="margin-bottom:14px;">
    <div class="carte" style="background:#FFF8F0;">
      <div class="carte-label" style="color:#F4A035;">⚡ Énergie</div>
      <div class="carte-valeur" style="color:#F4A035;">${d.statsS.energieMoy}<span class="carte-unit">/5</span></div>
      <div style="font-size:11px;color:#F4A035;">${etoiles(d.statsS.energieMoy)}</div>
    </div>
    <div class="carte" style="background:#F0F4FF;">
      <div class="carte-label" style="color:#2A5298;">😊 Humeur</div>
      <div class="carte-valeur" style="color:#2A5298;">${d.statsS.humeurMoy}<span class="carte-unit">/5</span></div>
      <div style="font-size:11px;color:#2A5298;">${etoiles(d.statsS.humeurMoy)}</div>
    </div>
    <div class="carte" style="background:#F1F8E9;">
      <div class="carte-label" style="color:#7CB342;">🍽️ Faim</div>
      <div class="carte-valeur" style="color:#7CB342;">${d.statsS.faimMoy}<span class="carte-unit">/5</span></div>
      <div style="font-size:11px;color:#7CB342;">${etoiles(d.statsS.faimMoy)}</div>
    </div>
  </div>
  ${d.statsS.notes.length > 0 ? `
  <div style="font-size:11px;font-weight:800;color:#1B3A6B;margin-bottom:8px;">📝 Dernières notes</div>
  ${d.statsS.notes.map(n=>`<div class="note-item"><div class="note-date">${dateFr(n.date)}</div>${n.note}</div>`).join("")}
  ` : ""}
</div>
` : ""}

${d.statsZ ? `
<div class="section">
  <div class="section-titre">🌙 Sommeil (${d.statsZ.jours} jour${d.statsZ.jours>1?"s":""})</div>
  <div class="grille-2">
    <div class="carte" style="background:#F0F4FF;">
      <div class="carte-label" style="color:#2A5298;">Durée moyenne</div>
      <div class="carte-valeur" style="color:#2A5298;">${d.statsZ.dureeMoy}<span class="carte-unit">h/nuit</span></div>
      <div class="barre-prog"><div class="barre-prog-inner" style="width:${Math.min(100,parseFloat(d.statsZ.dureeMoy)/9*100)}%;background:#2A5298;"></div></div>
    </div>
    <div class="carte" style="background:#FFF8F0;">
      <div class="carte-label" style="color:#F4A035;">Qualité moyenne</div>
      <div class="carte-valeur" style="color:#F4A035;">${d.statsZ.qualiteMoy}<span class="carte-unit">/5</span></div>
      <div style="font-size:11px;color:#F4A035;">${etoiles(d.statsZ.qualiteMoy)}</div>
    </div>
  </div>
</div>
` : ""}

${d.statsJ ? `
<div class="section">
  <div class="section-titre">⏱️ Jeûnes</div>
  <div class="grille-3">
    <div class="carte" style="background:#E8EEF8;">
      <div class="carte-label" style="color:#1B3A6B;">Jeûnes effectués</div>
      <div class="carte-valeur" style="color:#1B3A6B;">${d.statsJ.nb}</div>
    </div>
    <div class="carte" style="background:#F1F8E9;">
      <div class="carte-label" style="color:#7CB342;">Durée moyenne</div>
      <div class="carte-valeur" style="color:#7CB342;">${d.statsJ.dureeMoy}<span class="carte-unit">h</span></div>
    </div>
    <div class="carte" style="background:#FFF8F0;">
      <div class="carte-label" style="color:#F4A035;">Record</div>
      <div class="carte-valeur" style="color:#F4A035;">${d.statsJ.dureeMax}<span class="carte-unit">h</span></div>
    </div>
  </div>
</div>
` : ""}

${(d.cetones.length > 0 || d.glycemies.length > 0) ? `
<div class="section">
  <div class="section-titre">🔬 Cétonémie & Glycémie</div>

  ${d.cetones.length > 0 ? `
  <div style="margin-bottom:20px;">
    <div style="font-size:12px;font-weight:700;color:#1B3A6B;margin-bottom:10px;">Cétonémie (mmol/L) — ${d.cetones.length} mesure${d.cetones.length>1?"s":""}</div>
    ${(() => {
      const vals = d.cetones.map(m=>m.valeur);
      const maxV = Math.max(...vals); const minV = Math.min(...vals);
      const range = maxV-minV||1;
      const W=600,H=100;
      const pts = d.cetones.map((m,i)=>({
        x:Math.round(i*W/(d.cetones.length-1||1)),
        y:Math.round(H-((m.valeur-minV)/range)*H*0.85-H*0.05),
        v:m.valeur, d:m.date
      }));
      const path = pts.map((p,i)=>i===0?`M${p.x},${p.y}`:`L${p.x},${p.y}`).join(" ");
      return d.cetones.length>=2 ? `<svg viewBox="0 0 ${W} ${H+20}" style="width:100%;display:block;margin-bottom:12px;">
        <path d="${path}" fill="none" stroke="#1B3A6B" stroke-width="2" stroke-linejoin="round"/>
        ${pts.map(p=>`<circle cx="${p.x}" cy="${p.y}" r="4" fill="#1B3A6B"/><text x="${p.x}" y="${p.y-8}" text-anchor="middle" font-size="9" fill="#1B3A6B" font-weight="bold">${p.v}</text>`).join("")}
        ${pts.filter((_,i)=>i===0||i===pts.length-1||(i%Math.ceil(pts.length/6)===0)).map(p=>`<text x="${p.x}" y="${H+14}" text-anchor="middle" font-size="8" fill="#9CA3AF">${p.d.slice(8)}/${p.d.slice(5,7)}</text>`).join("")}
      </svg>` : "";
    })()}
    <table style="width:100%;border-collapse:collapse;font-size:11px;">
      <thead><tr style="background:#1B3A6B;">
        <th style="padding:6px 10px;text-align:left;color:#7CB342;font-weight:700;">Date</th>
        <th style="padding:6px 10px;text-align:center;color:#7CB342;font-weight:700;">Heure</th>
        <th style="padding:6px 10px;text-align:right;color:#7CB342;font-weight:700;">mmol/L</th>
      </tr></thead>
      <tbody>${d.cetones.map((m,i)=>`<tr style="background:${i%2===0?"#fff":"#F8FAFF"};">
        <td style="padding:5px 10px;color:#374151;">${m.date.slice(8)}/${m.date.slice(5,7)}/${m.date.slice(0,4)}</td>
        <td style="padding:5px 10px;text-align:center;color:#6B7280;">${m.heure}</td>
        <td style="padding:5px 10px;text-align:right;font-weight:700;color:#1B3A6B;">${m.valeur}</td>
      </tr>`).join("")}</tbody>
    </table>
  </div>` : ""}

  ${d.glycemies.length > 0 ? `
  <div>
    <div style="font-size:12px;font-weight:700;color:#7CB342;margin-bottom:10px;">Glycémie (g/L) — ${d.glycemies.length} mesure${d.glycemies.length>1?"s":""}</div>
    ${(() => {
      const vals = d.glycemies.map(m=>m.valeur);
      const maxV = Math.max(...vals); const minV = Math.min(...vals);
      const range = maxV-minV||1;
      const W=600,H=100;
      const pts = d.glycemies.map((m,i)=>({
        x:Math.round(i*W/(d.glycemies.length-1||1)),
        y:Math.round(H-((m.valeur-minV)/range)*H*0.85-H*0.05),
        v:m.valeur, d:m.date
      }));
      const path = pts.map((p,i)=>i===0?`M${p.x},${p.y}`:`L${p.x},${p.y}`).join(" ");
      return d.glycemies.length>=2 ? `<svg viewBox="0 0 ${W} ${H+20}" style="width:100%;display:block;margin-bottom:12px;">
        <path d="${path}" fill="none" stroke="#7CB342" stroke-width="2" stroke-linejoin="round"/>
        ${pts.map(p=>`<circle cx="${p.x}" cy="${p.y}" r="4" fill="#7CB342"/><text x="${p.x}" y="${p.y-8}" text-anchor="middle" font-size="9" fill="#7CB342" font-weight="bold">${p.v}</text>`).join("")}
        ${pts.filter((_,i)=>i===0||i===pts.length-1||(i%Math.ceil(pts.length/6)===0)).map(p=>`<text x="${p.x}" y="${H+14}" text-anchor="middle" font-size="8" fill="#9CA3AF">${p.d.slice(8)}/${p.d.slice(5,7)}</text>`).join("")}
      </svg>` : "";
    })()}
    <table style="width:100%;border-collapse:collapse;font-size:11px;">
      <thead><tr style="background:#1B3A6B;">
        <th style="padding:6px 10px;text-align:left;color:#7CB342;font-weight:700;">Date</th>
        <th style="padding:6px 10px;text-align:center;color:#7CB342;font-weight:700;">Heure</th>
        <th style="padding:6px 10px;text-align:right;color:#7CB342;font-weight:700;">g/L</th>
      </tr></thead>
      <tbody>${d.glycemies.map((m,i)=>`<tr style="background:${i%2===0?"#fff":"#F8FAFF"};">
        <td style="padding:5px 10px;color:#374151;">${m.date.slice(8)}/${m.date.slice(5,7)}/${m.date.slice(0,4)}</td>
        <td style="padding:5px 10px;text-align:center;color:#6B7280;">${m.heure}</td>
        <td style="padding:5px 10px;text-align:right;font-weight:700;color:#7CB342;">${m.valeur}</td>
      </tr>`).join("")}</tbody>
    </table>
  </div>` : ""}
</div>
` : ""}

<div class="pied">
  📋 Ce document est un résumé personnel généré par Céto Club (app.cetoclub.com).<br>
  Il ne constitue pas un avis médical. Partagez-le avec votre professionnel de santé si vous le souhaitez.<br>
  © Céto Club — Association Loi 1901 — contact@cetoclub.com
</div>

</body>
</html>`;

    return html;
  };

  const handleGenerer = () => {
    setChargement(true);
    setTimeout(() => {
      setGenere(true);
      setChargement(false);
    }, 400);
  };

  const handleImprimer = () => {
    const html = genererHTML();
    const win = window.open("", "_blank");
    if (!win) { alert("Autorise les pop-ups pour générer le PDF."); return; }
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => win.print(), 500);
  };

  const data = genere ? lireData() : null;

  return (
    <div style={{maxWidth:700,margin:"0 auto",padding:"16px 12px"}}>
      {/* ── EN-TÊTE ── */}
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
        <button onClick={onRetour} style={{background:"none",border:"none",fontSize:20,cursor:"pointer",color:"#1B3A6B",padding:4}}>←</button>
        <div>
          <h1 style={{fontSize:22,fontWeight:900,color:"#1B3A6B",margin:0}}>📊 Mon bilan PDF</h1>
          <p style={{fontSize:11,color:"#6B7280",margin:0}}>Résumé de tes données à partager avec ton médecin</p>
        </div>
      </div>

      {/* ── CHOIX PÉRIODE ── */}
      <div style={{background:"#fff",borderRadius:14,border:"2px solid #1B3A6B15",padding:20,marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:800,color:"#1B3A6B",marginBottom:12}}>Période à résumer</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
          {[{v:"7",l:"7 jours"},{v:"30",l:"30 jours"},{v:"90",l:"3 mois"}].map(o=>(
            <button key={o.v} onClick={()=>{setPeriode(o.v);setGenere(false);}}
              style={{padding:"12px 8px",borderRadius:10,border:`2px solid ${periode===o.v?"#1B3A6B":"#E5E7EB"}`,
                background:periode===o.v?"#1B3A6B":"#fff",color:periode===o.v?"#fff":"#6B7280",
                fontWeight:800,fontSize:13,cursor:"pointer",fontFamily:"inherit"}}>
              {o.l}
            </button>
          ))}
        </div>
      </div>

      {/* ── APERÇU ── */}
      {!genere && (
        <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:14,padding:24,textAlign:"center",marginBottom:14}}>
          <div style={{fontSize:40,marginBottom:12}}>📋</div>
          <div style={{fontSize:15,fontWeight:900,color:"#fff",marginBottom:6}}>Génère ton bilan personnalisé</div>
          <div style={{fontSize:12,color:"rgba(255,255,255,0.75)",marginBottom:18,lineHeight:1.6}}>
            Nutrition · Poids · Mensurations · Bien-être · Sommeil · Jeûnes<br />
            Un document complet à imprimer ou enregistrer en PDF.
          </div>
          <button onClick={handleGenerer} disabled={chargement}
            style={{background:"#F4A035",color:"#fff",border:"none",borderRadius:10,padding:"14px 32px",
              fontSize:14,fontWeight:900,cursor:"pointer",fontFamily:"inherit",
              opacity:chargement?0.7:1}}>
            {chargement?"⏳ Préparation...":"✨ Générer mon bilan"}
          </button>
        </div>
      )}

      {/* ── RÉSUMÉ GÉNÉRÉ ── */}
      {genere && data && (
        <div>
          <div style={{background:"#F1F8E9",borderRadius:14,border:"2px solid #7CB34230",padding:16,marginBottom:14,display:"flex",alignItems:"center",gap:12}}>
            <div style={{fontSize:28}}>✅</div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:900,color:"#558B2F"}}>Bilan prêt !</div>
              <div style={{fontSize:11,color:"#6B7280"}}>
                {data.statsM ? `${data.statsM.jEnregistres} jours de nutrition · ` : ""}
                {data.poidsEvol !== null ? `Évolution poids : ${data.poidsEvol>0?"+":""}${data.poidsEvol} kg · ` : ""}
                {data.statsJ ? `${data.statsJ.nb} jeûne${data.statsJ.nb>1?"s":""} effectué${data.statsJ.nb>1?"s":""} · ` : ""}
                {data.statsS ? `Bien-être suivi ${data.statsS.jours}j` : ""}
              </div>
            </div>
          </div>

          {/* Bloc sections détail */}
          {[
            data.statsM && {icon:"🥗",titre:"Nutrition",detail:`Glucides moy. ${data.statsM.gluMoy}g/j · Protéines ${data.statsM.proMoy}g · Lipides ${data.statsM.lipMoy}g · ${data.statsM.joursOK}j céto ✓`},
            data.poidsEvol !== null && {icon:"⚖️",titre:"Poids",detail:`${data.poidsDebut} kg → ${data.poidsFin} kg (${data.poidsEvol>0?"+":""}${data.poidsEvol} kg sur ${data.nbJours}j)`},
            (data.mensurDebut||data.mensurFin) && {icon:"📏",titre:"Mensurations",detail:"Taille · Hanches · Cuisses"},
            data.statsS && {icon:"🌿",titre:"Bien-être",detail:`Énergie ${data.statsS.energieMoy}/5 · Humeur ${data.statsS.humeurMoy}/5 · Faim ${data.statsS.faimMoy}/5`},
            data.statsZ && {icon:"🌙",titre:"Sommeil",detail:`${data.statsZ.dureeMoy}h/nuit · Qualité ${data.statsZ.qualiteMoy}/5`},
            data.statsJ && {icon:"⏱️",titre:"Jeûnes",detail:`${data.statsJ.nb} jeûne${data.statsJ.nb>1?"s":""} · Moy. ${data.statsJ.dureeMoy}h · Record ${data.statsJ.dureeMax}h`},
          ].filter(Boolean).map((s,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:12,border:"2px solid #1B3A6B10",padding:"12px 16px",marginBottom:8,display:"flex",alignItems:"center",gap:12}}>
              <div style={{fontSize:22,width:32,textAlign:"center"}}>{s.icon}</div>
              <div>
                <div style={{fontSize:12,fontWeight:900,color:"#1B3A6B"}}>{s.titre}</div>
                <div style={{fontSize:11,color:"#6B7280"}}>{s.detail}</div>
              </div>
            </div>
          ))}

          <div style={{background:"#FFF8F0",borderRadius:12,border:"2px solid #F4A03530",padding:14,marginBottom:14,marginTop:4}}>
            <div style={{fontSize:11,color:"#E65100",lineHeight:1.6}}>
              ℹ️ Ce résumé personnel est destiné à faciliter tes échanges avec ton médecin. Il ne remplace pas un avis médical.
            </div>
          </div>

          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <button onClick={()=>{setGenere(false);}}
              style={{background:"#fff",color:"#1B3A6B",border:"2px solid #1B3A6B",borderRadius:10,
                padding:"12px 8px",fontSize:13,fontWeight:800,cursor:"pointer",fontFamily:"inherit"}}>
              ← Modifier la période
            </button>
            <button onClick={handleImprimer}
              style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",borderRadius:10,
                padding:"12px 8px",fontSize:13,fontWeight:900,cursor:"pointer",fontFamily:"inherit"}}>
              🖨️ Imprimer / PDF
            </button>
          </div>
        </div>
      )}

      <div style={{textAlign:"center",marginTop:20,fontSize:10,color:"#9ca3af"}}>
        📋 Toutes tes données restent sur ton appareil · Rien n'est envoyé sur internet
      </div>
    </div>
  );
}
// ─── FIN BILAN PDF ─────────────────────────────────────────────────────────────

// ─── PAGE MERCI (après paiement Stripe) ───────────────────────────────────────
function PageMerci() {
  const [prenom, setPrenom] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [statut, setStatut] = React.useState(null); // null | "loading" | "ok" | "error"

  React.useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {'send_to': 'AW-18004354220/Hx4oCOqXioscEKzJkolD'});
    }
  }, []);

  const envoyerCode = async () => {
    if (!prenom.trim() || !email.trim()) { setStatut("error"); return; }
    setStatut("loading");
    try {
      await fetch("https://eo3z652uirrx7fr.m.pipedream.net", {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-cetoclub-secret": PIPEDREAM_SECRET },
        body: JSON.stringify({ prenom: prenom.trim(), email: email.trim() }),
      });
      setStatut("ok");
    } catch {
      setStatut("error");
    }
  };

  if (statut === "ok") {
    return (
      <main style={{maxWidth:440,margin:"0 auto",padding:"40px 16px",textAlign:"center",fontFamily:"'Nunito',sans-serif"}}>
        <div style={{fontSize:56,marginBottom:16}}>🎉</div>
        <h1 style={{fontSize:22,fontWeight:900,color:"#1B3A6B",marginBottom:8}}>Ton code est en route !</h1>
        <p style={{fontSize:14,color:"#6B7280",lineHeight:1.7,marginBottom:24}}>
          Vérifie ta boîte mail (et tes spams).<br/>
          Tu recevras ton code d'activation dans quelques secondes.
        </p>
        <div style={{background:"#F1F8E9",borderRadius:14,padding:16,fontSize:12,color:"#2E7D32",fontWeight:700}}>
          ✅ Bienvenue dans la communauté Céto Club premium !
        </div>
      </main>
    );
  }

  return (
    <main style={{maxWidth:440,margin:"0 auto",padding:"24px 16px",fontFamily:"'Nunito',sans-serif"}}>
      <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:20,padding:"28px 24px",marginBottom:20,color:"#fff",textAlign:"center"}}>
        <div style={{fontSize:38,marginBottom:8}}>💎</div>
        <div style={{fontSize:20,fontWeight:900,marginBottom:6}}>Merci pour ton paiement !</div>
        <div style={{fontSize:12,opacity:.8,lineHeight:1.7}}>Saisis ton prénom et ton email pour recevoir ton code premium.</div>
      </div>

      <div style={{background:"#fff",borderRadius:16,padding:20,boxShadow:"0 2px 12px #0001",display:"flex",flexDirection:"column",gap:14}}>
        <div>
          <label style={{fontSize:12,fontWeight:700,color:"#1B3A6B",display:"block",marginBottom:4}}>Ton prénom</label>
          <input value={prenom} onChange={e=>setPrenom(e.target.value)} placeholder="Ex : Marie"
            style={{width:"100%",boxSizing:"border-box",padding:"12px 14px",borderRadius:10,border:"2px solid #E5E7EB",fontSize:14,outline:"none",fontFamily:"inherit"}} />
        </div>
        <div>
          <label style={{fontSize:12,fontWeight:700,color:"#1B3A6B",display:"block",marginBottom:4}}>Ton email</label>
          <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="ton@email.com" type="email"
            style={{width:"100%",boxSizing:"border-box",padding:"12px 14px",borderRadius:10,border:"2px solid #E5E7EB",fontSize:14,outline:"none",fontFamily:"inherit"}} />
        </div>

        {statut==="error" && (
          <div style={{background:"#FFF3E0",borderRadius:10,padding:10,textAlign:"center",color:"#E65100",fontWeight:700,fontSize:12}}>
            ⚠️ Vérifie que le prénom et l'email sont bien remplis.
          </div>
        )}

        <button onClick={envoyerCode} disabled={statut==="loading"}
          style={{padding:"14px",borderRadius:12,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",fontWeight:900,fontSize:15,border:"none",cursor:statut==="loading"?"not-allowed":"pointer",opacity:statut==="loading"?0.6:1,fontFamily:"inherit"}}>
          {statut==="loading" ? "⏳ Envoi en cours..." : "🚀 Recevoir mon code premium"}
        </button>

        <div style={{fontSize:10,color:"#9CA3AF",textAlign:"center",lineHeight:1.7}}>
          Ton code arrivera par email dans quelques secondes.<br/>
          Pense à vérifier tes spams.<br/><br/>
          🔒 Ton email est utilisé uniquement pour t'envoyer ton code.<br/>
          Nous ne le conservons pas, nous ne le partageons pas.
        </div>
      </div>
    </main>
  );
}
// ─── FIN PAGE MERCI ───────────────────────────────────────────────────────────

export default function CetoClub() {
  var RECETTES_DU_JOUR = [
    {titre:"Acras de morue céto",emoji:"🐟",url:"https://cetoclub.com/acras-de-morue-ceto/"},
    {titre:"Butter chicken ou poulet au beurre",emoji:"🍗",url:"https://cetoclub.com/butter-chicken-ou-poulet-au-beurre/"},
    {titre:"Soupe céto crémeuse poulet champignons",emoji:"🥣",url:"https://cetoclub.com/soupe-ceto-cremeuse-poulet-champignons/"},
    {titre:"Gougères de parmesan cétogènes",emoji:"🧀",url:"https://cetoclub.com/gougeres-de-parmesan-cetogenes/"},
    {titre:"Confit de canard",emoji:"🦆",url:"https://cetoclub.com/confit-de-canard/"},
    {titre:"Œufs cocotte aux champignons",emoji:"🍄",url:"https://cetoclub.com/oeufs-cocotte-aux-champignons/"},
    {titre:"Tartines céto croustillantes au saumon fumé",emoji:"🐟",url:"https://cetoclub.com/tartines-ceto-croustillantes-au-saumon-fume/"},
    {titre:"Osso buco alla milanese",emoji:"🍖",url:"https://cetoclub.com/osso-buco-alla-milanese/"},
    {titre:"Velouté de courgette aux 3 parfums",emoji:"🥣",url:"https://cetoclub.com/veloute-de-courgette-aux-3-parfums-keto/"},
    {titre:"Gratin de fruits de mer et saumon",emoji:"🦐",url:"https://cetoclub.com/gratin-de-fruits-de-mer-et-saumon-ceto/"},
    {titre:"Guacamole trinidadien",emoji:"🥑",url:"https://cetoclub.com/guacamole-trinidadien/"},
    {titre:"Cabillaud coco à la Samana",emoji:"🐠",url:"https://cetoclub.com/cabillaud-coco-a-la-samana/"},
    {titre:"Cake céto épinards et fromage frais",emoji:"🥬",url:"https://cetoclub.com/cake-ceto-epinards-et-fromage-frais/"},
    {titre:"Curry de poulet épicé au lait de coco",emoji:"🍛",url:"https://cetoclub.com/curry-de-poulet-epice-au-lait-de-coco/"},
    {titre:"Omelette japonaise",emoji:"🥚",url:"https://cetoclub.com/omelette-japonaise/"},
    {titre:"Avocat crevettes et poivre de Timut",emoji:"🥑",url:"https://cetoclub.com/avocat-crevettes-et-poivre-de-timut/"},
    {titre:"Salade de brocolis au thon",emoji:"🥗",url:"https://cetoclub.com/salade-de-brocolis-au-thon-keto/"},
    {titre:"Nachos céto",emoji:"🌽",url:"https://cetoclub.com/nachos-ceto/"},
    {titre:"Soupe de potimarron cétogène",emoji:"🎃",url:"https://cetoclub.com/soupe-de-potimarron-cetogene/"},
    {titre:"Saucisson à l'ail croustillant",emoji:"🥓",url:"https://cetoclub.com/saucisson-a-lail-croustillant/"},
    {titre:"Bouillon d'os",emoji:"🫕",url:"https://cetoclub.com/bouillon-dos/"},
    {titre:"Crackers aux graines cétogènes",emoji:"🌾",url:"https://cetoclub.com/crackers-aux-graines-cetogenes/"},
    {titre:"Cake céto feta poivron",emoji:"🫑",url:"https://cetoclub.com/cake-ceto-feta-poivron/"},
    {titre:"Œufs farcis à l'avocat",emoji:"🥚",url:"https://cetoclub.com/oeufs-farcis-a-lavocat/"},
    {titre:"Crevettes panées à la noix de coco",emoji:"🍤",url:"https://cetoclub.com/crevettes-panees-a-la-noix-de-coco-ceto-aruba/"},
    {titre:"Ailes de poulet marinées",emoji:"🍗",url:"https://cetoclub.com/ailes-de-poulet-marinees/"},
    {titre:"Tartine cétogène à l'avocat",emoji:"🥑",url:"https://cetoclub.com/tartine-cetogene-a-lavocat/"},
    {titre:"Cake céto chèvre courgette",emoji:"🫛",url:"https://cetoclub.com/cake-ceto-chevre-courgette/"},
    {titre:"Aubergines aux œufs brouillés",emoji:"🍆",url:"https://cetoclub.com/aubergines-aux-oeufs-brouilles/"},
    {titre:"Beignets de morue hyper-protéinés",emoji:"🐡",url:"https://cetoclub.com/beignets-de-morue-hyper-proteines-belize/"},
  ];
  var isZero = (a) => a.note && a.note.includes("non comptabilisé");
  var score = (glu, note) => {
    if (note && note.includes("non comptabilisé")) return {l:"0 glucide",c:"#1565C0",bg:"#E3F2FD"};
    if (glu<=1) return {l:"Excellent",c:"#2E7D32",bg:"#E8F5E9"};
    if (glu<=3) return {l:"Très bien",c:"#7CB342",bg:"#F1F8E9"};
    if (glu<=6) return {l:"Modéré",c:"#F4A035",bg:"#FFF8F0"};
    return {l:"Attention",c:"#C62828",bg:"#FFEBEE"};
  };
  var BP = [
    {e:"💧",t:"Hydratation",c:"#1B3A6B",i:["Boire de l'eau légèrement salée quand on a soif","Le corps sait parler selon ses besoins","Eaux riches en magnésium (>50mg/L indiqué sur l'étiquette)","Café, thé, tisanes non sucrés librement","Évite les sodas même light"]},
    {e:"🧂",t:"Électrolytes",c:"#F4A035",i:["Sale généreusement au sel de mer non raffiné","Magnésium : noix, graines, brocolis","Potassium : avocat, courgettes, champignons","Crampes = manque d'électrolytes, sale !"]},
    {e:"🥑",t:"Glucides & Cétose",c:"#7CB342",i:["Moins de 20g de glucides/jour pour être sûr d'être en cétose","Lipides élevés · Protéines suffisantes","Allulose & érythritol ne comptent pas","Pas de grignotage, 3 repas maximum par jour"]},
    {e:"🍳",t:"Cuisine maison",c:"#1B3A6B",i:["Cuisiner soi-même est essentiel","Évite les produits industriels même 'céto'","Contrôle chaque ingrédient","Sauces et marinades maison sans sucre"]},
    {e:"🚫",t:"À bannir",c:"#F4A035",i:["Céréales : blé, riz, avoine, maïs, orge…","Légumineuses : lentilles, pois chiches, haricots…","Légumes racines : pomme de terre, carotte, betterave, panais…","Fruits — sauf fruits rouges (fraises, framboises, myrtilles, mûres)","Sucre sous toutes ses formes"]},
    {e:"🥦",t:"Légumes autorisés",c:"#7CB342",i:["Légumes feuilles : salades, blette, chou, fenouil","Légumes tiges : asperge, céleri, courgette","Champignons, concombre, radis, poivron vert","Racines autorisées : céleri-rave, radis, daikon"]},
    {e:"🍬",t:"Édulcorants céto",c:"#1B3A6B",i:["Stévia : 0 cal, 0 glucide","Érythritol : non comptabilisé","Allulose : 0 impact glycémique","Monk fruit : 0 glucide comptabilisé"]},
  ];
  var BP_GRIPPE = [
    {e:"⚡",t:"C'est quoi la grippe céto ?",c:"#F4A035",i:["C'est une déshydratation avec tous les signes qui l'accompagnent : manque d'énergie, fatigue, maux de tête","Ton corps est en train de booster tes mitochondries et d'en fabriquer de nouvelles pour utiliser les cétones comme nouvelle source d'énergie","C'est un vaste chantier intérieur. Tu es fatigué ? C'est normal. Repose-toi pour aider ton corps à travailler","L'énergie va revenir petit à petit, au fur et à mesure que ton corps s'adapte"]},
    {e:"😴",t:"Fatigue",c:"#1B3A6B",i:["Ton corps reconstruit son système énergétique de fond en comble","Repose-toi le plus possible — c'est le meilleur coup de pouce que tu puisses lui donner","Ne force pas le sport pendant cette phase","L'adaptation se fait entre 3 semaines et 6 mois selon l'état de ton corps — sois patient"]},
    {e:"🤕",t:"Maux de tête",c:"#C62828",i:["Cause : déshydratation et perte de sodium","Remède option 1 : grand verre d'eau + sel de mer non raffiné","Remède option 2 : grand verre d'eau avec une pincée de bicarbonate de sodium","Bois un peu, très régulièrement — jamais beaucoup d'un coup, ne te laisse pas déshydrater"]},
    {e:"🦵",t:"Crampes",c:"#F4A035",i:["Place un gros savon de Marseille (le vrai, 72% d'huile d'olive) près de tes pieds la nuit — efficace et sans explication scientifique claire, mais ça marche !","Prends du magnésium bisglycinate le soir — la forme la mieux absorbée","En pharmacie : un complexe d'électrolytes (sur conseil du pharmacien) si tu n'arrives pas à trouver l'équilibre"]},
    {e:"🚽",t:"Constipation",c:"#7CB342",i:["Augmente ton apport en sel : des selles trop sèches signalent un manque de sodium","Bois davantage d'eau légèrement salée","Une cuillère à soupe de psyllium dans un grand verre d'eau — bois immédiatement, très efficace","La courgette a des fibres douces particulièrement efficaces — mange-en à chaque repas"]},
    {e:"🔥",t:"Accélérer l'adaptation",c:"#2A5298",i:["Douche froide — active le système nerveux et stimule la production de mitochondries","Repos maximum — ton corps travaille, laisse-le faire","Mange des lipides en abondance : c'est LE carburant de transition","C'est le moment de te régaler de fat bombs !","Lipides à chaque repas : beurre, huile d'olive, avocat, noix, fromage"]},
    {e:"🩺",t:"Si tu as peur",c:"#6A1B9A",i:["Ces symptômes sont normaux et temporaires — mais si tu as des doutes, consulte","Fais-toi accompagner par un médecin qui s'y connaît en céto","Il en existe de plus en plus — n'hésite pas à chercher un praticien formé à la nutrition cétogène"]},
  ];
  let todayStr = () => {
    const d = new Date();
    return d.toLocaleDateString("fr-FR", {year:"numeric",month:"2-digit",day:"2-digit"}).split("/").reverse().join("-");
  };
  const IS_LOCAL = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || new URLSearchParams(window.location.search).get("dev") === "cetoclub2026";
  let getNavGroup = (p) => {
    if (["profil"].includes(p)) return "moi";
    if (["journal"].includes(p)) return "journal";

    if (["aliments","produits","recettes","plan7j","scanner"].includes(p)) return "aliments";
    if (["pratiques","mentions","cgu"].includes(p)) return "guides";
    if (["plan7j"].includes(p)) return "premium";
    return "moi";
  };
  let recetteJour = RECETTES_DU_JOUR[new Date().getDate() % RECETTES_DU_JOUR.length];
  let CATS = ["Toutes","Oeufs & Laitiers","Viandes","Poissons & Fruits de mer","Légumes","Oleagineux & Graines","Graisses & Condiments","Boissons","Fruits","Douceurs & Édulcorants"];

  let [onboardingDone, setOnboardingDone] = useState(() => {
    try { return localStorage.getItem("cetoclub_onboarding")==="done"; } catch { return false; }
  });
  let [onboardingStep, setOnboardingStep] = useState(0);
  // ── Mode premium : URL ?sophie=true OU 5 clics sur le logo ──────────────
  let [logoClicks, setLogoClicks] = useState(0);
  // ── Code d'activation premium ──
  let [codeInput, setCodeInput] = useState("");
  let [codeError, setCodeError] = useState("");
  let [codeSuccess, setCodeSuccess] = useState(false);

  // Codes valides chargés depuis la constante globale

  const activerCodePremium = async () => {
    const code = codeInput.trim().toUpperCase();
    if (!code) { setCodeError("Saisis ton code."); return; }
    setCodeError("⏳ Vérification...");
    try {
      // Vérification 100% côté serveur Pipedream
      const res = await fetch(`${VERIFIER_CODE_URL}?code=${encodeURIComponent(code)}`, {
        headers: { "x-cetoclub-secret": PIPEDREAM_SECRET }
      });
      const data = await res.json();
      let valide = data.valide === true;
      if (!valide) {
        setCodeError("Code invalide. Vérifie ton email de confirmation.");
        return;
      }
      // Vérifier le nombre d'activations
      const activations = JSON.parse(localStorage.getItem("cetoclub_activations") || "{}");
      const count = activations[code] || 0;
      if (count >= 2) {
        setCodeError("Ce code a déjà été utilisé sur 2 appareils. Contacte contact@cetoclub.com");
        return;
      }
      activations[code] = count + 1;
      localStorage.setItem("cetoclub_activations", JSON.stringify(activations));
      setPremiumLocal(true);
      try { localStorage.setItem("cetoclub_premium_local", "true"); } catch {}
      setCodeSuccess(true);
      setCodeError("");
    } catch(e) {
      setCodeError("Erreur de connexion. Vérifie ta connexion internet et réessaie.");
    }
  };
  let [premiumLocal, setPremiumLocal] = useState(() => {
    try { return localStorage.getItem("cetoclub_premium_local") === "true"; } catch { return false; }
  });
  const PREMIUM_ACTIF = PREMIUM_URL || premiumLocal;
  const handleLogoClic = React.useCallback(() => {
    setLogoClicks(n => {
      const next = n + 1;
      if(next >= 5) {
        setPageRaw("premium");
        setTimeout(() => setLogoClicks(0), 500);
        return 0;
      }
      return next;
    });
  }, []);
  // Reset compteur après 2 secondes d'inactivité
  React.useEffect(() => {
    if(logoClicks === 0) return;
    const t = setTimeout(() => setLogoClicks(0), 2000);
    return () => clearTimeout(t);
  }, [logoClicks]);

  let [page, setPageRaw] = useState(() => {
    try {
      const onb = localStorage.getItem("cetoclub_onboarding")==="done";
      if(!onb) return "aliments";
      const saved = localStorage.getItem("cetoclub_last_page");
      const PAGES_RESTAURABLES = ["journal","profil","aliments","produits","recettes","plan7j","guides","mentions","cgu","pratiques"];
      return (saved && PAGES_RESTAURABLES.includes(saved)) ? saved : "journal";
    } catch { return "aliments"; }
  });
  const setPage = React.useCallback((p) => {
    setPageRaw(p);
    try { localStorage.setItem("cetoclub_last_page", p); } catch {}
  }, []);
  const [ongletMoi, setOngletMoi] = React.useState("profil");
  const [ongletGuide, setOngletGuide] = React.useState("generalites");

  let finishOnboarding = () => {
    try { localStorage.setItem("cetoclub_onboarding","done"); } catch {}
    setOnboardingDone(true);
    setPage("profil");
  };
  let [search, setSearch] = useState("");
  let [cat, setCat] = useState("Toutes");
  let [sel, setSel] = useState(null);
  let [g, setG] = useState(100);

  // ── Produits marque ──
  let [produits, setProduits] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_produits")||"[]"); } catch { return []; }
  });
  let [formOpen, setFormOpen] = useState(false);
  let [editId, setEditId] = useState(null);
  let [form, setForm] = useState({nom:"",marque:"",lip:"",glu:"",pro:"",portion:""});
  let [searchProd, setSearchProd] = useState("");
  let [selProd, setSelProd] = useState(null);
  let [gProd, setGProd] = useState(100);

  let saveProduits = (list) => {
    setProduits(list);
    try { localStorage.setItem("cetoclub_produits", JSON.stringify(list)); } catch {}
  };

  // Écoute les ajouts depuis le scanner (qui écrit directement dans localStorage)
  React.useEffect(() => {
    const syncDepuisScanner = () => {
      try {
        const liste = JSON.parse(localStorage.getItem("cetoclub_produits")||"[]");
        setProduits(liste);
      } catch {}
    };
    window.addEventListener("cetoclub_produits_updated", syncDepuisScanner);
    return () => window.removeEventListener("cetoclub_produits_updated", syncDepuisScanner);
  }, []);

  let toggleFavori = (id) => {
    saveProduits(produits.map(p => p.id===id ? {...p, favori:!p.favori} : p));
  };

  let deleteProduit = (id) => {
    if (selProd?.id===id) setSelProd(null);
    saveProduits(produits.filter(p => p.id!==id));
  };

  let submitForm = () => {
    if (!form.nom.trim()) return;
    const lip = parseFloat(form.lip)||0;
    const glu = parseFloat(form.glu)||0;
    const pro = parseFloat(form.pro)||0;
    if (editId) {
      saveProduits(produits.map(p => p.id===editId ? {...p,nom:form.nom.trim(),marque:form.marque.trim(),lip,glu,pro,portion:parseFloat(form.portion)||100} : p));
      setEditId(null);
    } else {
      saveProduits([...produits, {id:Date.now(),nom:form.nom.trim(),marque:form.marque.trim(),lip,glu,pro,portion:parseFloat(form.portion)||100,favori:false}]);
    }
    setForm({nom:"",marque:"",lip:"",glu:"",pro:"",portion:""});
    setFormOpen(false);
  };

  let openEdit = (p) => {
    setForm({nom:p.nom,marque:p.marque||"",lip:String(p.lip),glu:String(p.glu),pro:String(p.pro),portion:String(p.portion||100)});
    setEditId(p.id);
    setFormOpen(true);
  };

  let produitsFiltres = useMemo(() => {
    const list = produits.filter(p => p.nom.toLowerCase().includes(searchProd.toLowerCase()) || (p.marque||"").toLowerCase().includes(searchProd.toLowerCase()));
    return [...list.filter(p=>p.favori), ...list.filter(p=>!p.favori)];
  }, [produits, searchProd]);

  let normalizeSearch = (str) => str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/\u0153/g,"oe").replace(/\u0152/g,"oe").replace(/œ/g,"oe").replace(/Œ/g,"oe");
  let filtered = useMemo(() => {
    const s = normalizeSearch(search.trim());
    if (!s) return [];
    const byWord = ALIMENTS.filter(a => normalizeSearch(a.nom.trim()).split(/\s+/).some(w=>w.startsWith(s)));
    const byIncludes = ALIMENTS.filter(a => normalizeSearch(a.nom.trim()).includes(s) && !byWord.includes(a));
    return [...byWord, ...byIncludes];
  }, [search]);

  let calc = v => ((v*g)/100).toFixed(1);
  let calcP = v => ((v*(gProd||100))/100).toFixed(1);

  // ── Profil ──
  let [profil, setProfil] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_profil")||"null"); } catch { return null; }
  });
  let [profilForm, setProfilForm] = useState(() => {
    try {
      const p = JSON.parse(localStorage.getItem("cetoclub_profil")||"null");
      return p || {prenom:"",sexe:"F",age:"",poids:"",poidsDepart:"",poidsObjectif:"",taille:"",activite:"1.375",debutCeto:""};
    } catch { return {prenom:"",sexe:"F",age:"",poids:"",poidsDepart:"",poidsObjectif:"",taille:"",activite:"1.375",debutCeto:""}; }
  });

  let calcMacrosProfil = (p) => {
    if (!p) return null;
    const age = parseFloat(p.age), poids = parseFloat(p.poids), taille = parseFloat(p.taille);
    if (!age||!poids||!taille) return null;
    const sexe = p.sexe || 'F';
    // Masse maigre (formule Boer)
    const masseMaigre = sexe === 'H'
      ? 0.407*poids + 0.267*taille - 19.2
      : 0.252*poids + 0.473*taille - 48.3;
    const actif = parseFloat(p.activite||1.2) >= 1.55;
    // Plancher bloquant (perso premium) = fourchettes du tableau appliquées a la MASSE MAIGRE
    let facteurPlancher;
    if (actif)               facteurPlancher = 1.6;  // actif tous ages -> min 1.6g/kg MM
    else if (age < 50)       facteurPlancher = 1.25; // sedentaire <50 -> min 1.25g/kg MM
    else if (age <= 60)      facteurPlancher = 1.5;  // sedentaire 50-60 -> min 1.5g/kg MM
    else                     facteurPlancher = 1.8;  // sedentaire >60 -> min 1.8g/kg MM (prevention sarcopenie)
    const plancherPro = Math.round(facteurPlancher * masseMaigre);
    const plancherLip = plancherPro; // jamais lip < pro
    // Methode Ceto Club standard — basee sur le POIDS REEL
    let facteurPro;
    if (age < 50)       facteurPro = actif ? 1.8 : 1.25;
    else if (age <= 60) facteurPro = actif ? 1.8 : 1.5;
    else                facteurPro = actif ? 1.8 : 1.6;
    const pro = Math.round(facteurPro * poids);
    // Lipides Ceto Club : 1.5x les proteines sur poids reel
    const lip = Math.round(1.5 * pro);
    const glu = 20;
    return {lip, pro, glu, masseMaigre: Math.round(masseMaigre), plancherPro, plancherLip};
  };

  let calcMacrosPremium = (p) => {
    const age = parseFloat(p.age), poids = parseFloat(p.poids), taille = parseFloat(p.taille);
    const sexe = p.sexe || 'F';
    const activite = parseFloat(p.activite || 1.2);
    if (!age||!poids||!taille) return null;
    const actif = activite >= 1.55;
    // Masse maigre (formule Boer)
    const masseMaigre = sexe === 'H'
      ? 0.407*poids + 0.267*taille - 19.2
      : 0.252*poids + 0.473*taille - 48.3;
    // Plancher absolu protéines : 1.2g/kg de masse maigre
    const plancher = Math.round(1.2 * masseMaigre);
    // Méthode Confort (standard Céto Club sur poids total)
    let factStd;
    if (age < 50)       factStd = actif ? 1.8 : 1.25;
    else if (age <= 60) factStd = actif ? 1.8 : 1.5;
    else                factStd = actif ? 1.8 : 1.6;
    const pro_std = Math.round(factStd * poids);
    // Méthode Boer sur masse maigre (facteur céto 1.6)
    const pro_boer = Math.round(1.6 * masseMaigre);
    // Optimisé = moyenne 50/50 entre Confort et Boer, jamais sous plancher masse maigre
    const pro = Math.max(Math.round((pro_std + pro_boer) / 2), plancher);
    // Lipides : 1.5x les protéines, jamais sous 1g de lip pour 1g de pro
    const lip = Math.max(Math.round(1.5 * pro), pro);
    const glu = 20;
    // Infos pour affichage
    const tailleIn = taille / 2.54;
    const pi = sexe === 'H' ? 50 + 2.3*(tailleIn-60) : 45.5 + 2.3*(tailleIn-60);
    const ecartPoids = Math.round((poids - pi) / pi * 100);
    return { lip, pro, glu, ecartPoids, masseMaigre: Math.round(masseMaigre), plancher };
  };

  let saveProfil = (p) => {
    if (!p.createdAt) p.createdAt = new Date().toISOString().split("T")[0];
    setProfil(p);
    try { localStorage.setItem("cetoclub_profil",JSON.stringify(p)); } catch {}
    const macros = calcMacrosProfil(p);
    if (!macros) return;
    const choixExistant = (() => { try { return localStorage.getItem("cetoclub_choix_premium"); } catch { return null; } })();
    if (!choixExistant) {
      // Pas de perso premium -> recalcul standard
      saveObjectifs({lip:macros.lip, glu:macros.glu, pro:macros.pro});
    } else {
      // Objectifs perso existants -> verifier planchers avec nouveau profil
      const objActuels = (() => { try { return JSON.parse(localStorage.getItem("cetoclub_objectifs")||"null"); } catch { return null; } })();
      if (objActuels) {
        const plancherPro = macros.plancherPro; // fourchette tableau x masse maigre
        const plancherLip = macros.plancherLip || plancherPro;
        const proFinal = Math.max(objActuels.pro, plancherPro);
        const lipFinal = Math.max(objActuels.lip, plancherLip, proFinal);
        const gluFinal = Math.min(objActuels.glu || 20, 20);
        if (proFinal !== objActuels.pro || lipFinal !== objActuels.lip) {
          saveObjectifs({lip:lipFinal, glu:gluFinal, pro:proFinal});
        }
      }
    }
  };

  // ── Suivi poids ──
  let [premiumMacrosVisible, setPremiumMacrosVisible] = useState(false);
  let [choixPremium, setChoixPremium] = useState(() => { try { return localStorage.getItem("cetoclub_choix_premium") || null; } catch { return null; } }); // null | "confort" | "optimise"
  let [poidsSaisi, setPoidsSaisi] = useState("");
  let [poidsHistorique, setPoidsHistorique] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_poids")||"[]"); } catch { return []; }
  });

  let savePoidsHistorique = (list) => {
    setPoidsHistorique(list);
    try { localStorage.setItem("cetoclub_poids",JSON.stringify(list)); } catch {}
  };

  let joursDepuisDernierePesee = () => {
    if (poidsHistorique.length===0) return 999;
    const derniere = poidsHistorique[poidsHistorique.length-1].date;
    const diff = (new Date() - new Date(derniere+"T12:00:00")) / (1000*60*60*24);
    return Math.floor(diff);
  };

  let prochainePeseeDate = () => {
    if (poidsHistorique.length===0) return null;
    const derniere = new Date(poidsHistorique[poidsHistorique.length-1].date+"T12:00:00");
    derniere.setDate(derniere.getDate()+7);
    return derniere.toLocaleDateString("fr-FR",{weekday:"long",day:"numeric",month:"long"});
  };

  // ── Mensurations ──
  let [mensHistorique, setMensHistorique] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_mensurations")||"[]"); } catch { return []; }
  });
  let [mensForm, setMensForm] = useState({taille:"",hanches:"",cuisseD:"",cuisseG:""});

  let saveMensHistorique = (list) => {
    setMensHistorique(list);
    try { localStorage.setItem("cetoclub_mensurations",JSON.stringify(list)); } catch {}
  };

  let mensJoursDepuis = () => {
    if (mensHistorique.length===0) return 999;
    const derniere = mensHistorique[mensHistorique.length-1].date;
    return Math.floor((new Date() - new Date(derniere+"T12:00:00")) / (1000*60*60*24));
  };

  let ajouterMensurations = () => {
    if (!mensForm.taille && !mensForm.hanches && !mensForm.cuisseD && !mensForm.cuisseG) return;
    if (mensJoursDepuis() < 7) return;
    const today = new Date().toISOString().split("T")[0];
    const entry = {date:today, taille:mensForm.taille||"", hanches:mensForm.hanches||"", cuisseD:mensForm.cuisseD||"", cuisseG:mensForm.cuisseG||""};
    const updated = [...mensHistorique.filter(e=>e.date!==today), entry].sort((a,b)=>a.date.localeCompare(b.date));
    saveMensHistorique(updated);
    setMensForm({taille:"",hanches:"",cuisseD:"",cuisseG:""});
  };

  let ajouterPoids = () => {
    const p = parseFloat(poidsSaisi);
    if (!p||p<20||p>400) return;
    if (joursDepuisDernierePesee() < 7) return;
    const today = new Date().toISOString().split("T")[0];
    const updated = [...poidsHistorique, {date:today, poids:p}].sort((a,b)=>a.date.localeCompare(b.date));
    savePoidsHistorique(updated);
    if (profil) {
      const newProfil = {...profil, poids:String(p)};
      saveProfil(newProfil);
      setProfilForm(f=>({...f, poids:String(p)}));
    }
    setPoidsSaisi("");
  };

  // ── Recettes ──
  let [recettes, setRecettes] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_recettes")||"[]"); } catch { return []; }
  });
  let [recetteForm, setRecetteForm] = useState(false);
  let [recetteActive, setRecetteActive] = useState(null);
  let [recForm, setRecForm] = useState({nom:"",portions:"4",description:"",ingredients:[]});
  let [recSearch, setRecSearch] = useState("");
  let [toastRecette, setToastRecette] = useState(null);
  let [carteRecetteUrl, setCarteRecetteUrl] = useState(null);
  let [carteRecette, setCarteRecette] = useState(null);  let [recIngSearch, setRecIngSearch] = useState("");
  let [recIngResults, setRecIngResults] = useState([]);

  let saveRecettes = (list) => {
    setRecettes(list);
    try { localStorage.setItem("cetoclub_recettes",JSON.stringify(list)); } catch {}
  };

  let doRecIngSearch = (val) => {
    setRecIngSearch(val);
    if (!val.trim()) { setRecIngResults([]); return; }
    const v = normalizeSearch(val.trim());
    const tokens = v.split(/\s+/).filter(Boolean);
    const _all = ALIMENTS.filter(a => {
      const n = normalizeSearch(a.nom);
      return n.includes(v) || tokens.every(t => n.includes(t));
    });
    const _wordStarts = _all.filter(a => normalizeSearch(a.nom).split(/\s+/).some(w => w.startsWith(v)));
    const _starts = _all.filter(a => normalizeSearch(a.nom).startsWith(v) && !_wordStarts.includes(a));
    const _contains = _all.filter(a => !_wordStarts.includes(a) && !_starts.includes(a));
    const ciqual = [..._wordStarts, ..._starts, ..._contains].slice(0,15).map(a=>({...a,source:"ciqual"}));
    const perso = produits.filter(a => {
      const n = normalizeSearch(a.nom);
      return n.includes(v) || tokens.every(t => n.includes(t));
    }).slice(0,5).map(a=>({...a,source:"perso",glu:a.glu||0}));
    setRecIngResults([...ciqual,...perso]);
  };

  let addIngredientToRec = (aliment) => {
    const ing = {id:aliment.id,nom:aliment.nom,source:aliment.source,
      gram:aliment.unite ? 1 : 100,
      unite:aliment.unite||false,
      lip:aliment.lip,glu:aliment.glu,pro:aliment.pro};
    setRecForm(f=>({...f,ingredients:[...f.ingredients,ing]}));
    setRecIngSearch(""); setRecIngResults([]);
  };

  let updateIngGram = (idx, gram) => {
    setRecForm(f=>({...f,ingredients:f.ingredients.map((ing,i)=>i===idx?{...ing,gram:+gram||0}:ing)}));
  };

  let removeIng = (idx) => {
    setRecForm(f=>({...f,ingredients:f.ingredients.filter((_,i)=>i!==idx)}));
  };

  let calcRecMacros = (ingredients, portions) => {
    const p = parseFloat(portions)||1;
    const total = ingredients.reduce((acc,ing)=>({
      lip: acc.lip + (ing.unite ? ing.lip*ing.gram : ing.lip*ing.gram/100),
      glu: acc.glu + (ing.unite ? ing.glu*ing.gram : ing.glu*ing.gram/100),
      pro: acc.pro + (ing.unite ? ing.pro*ing.gram : ing.pro*ing.gram/100),
    }),{lip:0,glu:0,pro:0});
    return {
      total,
      portion:{lip:total.lip/p, glu:total.glu/p, pro:total.pro/p}
    };
  };

  let saveRecette = () => {
    if (!recForm.nom||recForm.ingredients.length===0) return;
    const macros = calcRecMacros(recForm.ingredients, recForm.portions);
    if (editRecId) {
      saveRecettes(recettes.map(r=>r.id===editRecId ? {...r, nom:recForm.nom, portions:parseFloat(recForm.portions)||1, description:recForm.description, ingredients:recForm.ingredients, macros} : r));
      setEditRecId(null);
    } else {
      const rec = {id:Date.now(), nom:recForm.nom, portions:parseFloat(recForm.portions)||1, description:recForm.description, ingredients:recForm.ingredients, macros, createdAt:new Date().toISOString().split("T")[0]};
      saveRecettes([...recettes, rec]);
    }
    setRecetteForm(false);
    setRecForm({nom:"",portions:"4",description:"",ingredients:[]});
  };

  let getTexteRecette = (rec) => {
    const sc = score(rec.macros.portion.glu);
    const prenomStr = profil?.prenom ? `de ${profil.prenom}` : "céto";
    const lines = [
      `🥑 Recette ${prenomStr} : ${rec.nom}`,
      ``,
      `📊 Pour 1 portion (sur ${rec.portions}) :`,
      `🧈 Lipides : ${rec.macros.portion.lip.toFixed(1)}g`,
      `🌾 Glucides : ${rec.macros.portion.glu.toFixed(1)}g`,
      `💪 Protéines : ${rec.macros.portion.pro.toFixed(1)}g`,
      `✅ Score céto : ${sc.l}`,
      ``,
      `🥦 Ingrédients :`,
      ...rec.ingredients.map(ing => `• ${ing.nom} (${ing.gram}g)`),
    ];
    if (rec.description) {
      lines.push(``);
      lines.push(`📝 Préparation :`);
      lines.push(rec.description);
    }
    lines.push(``);
    lines.push(`✨ Recette créée sur l'app gratuite Céto Club → https://app.cetoclub.com`);
    return lines.join("\n");
  };

  let partagerRecette = (rec) => {
    const sc = score(rec.macros.portion.glu);
    const W = 900, PAD = 56, LINE = 28, MAXW = W - PAD*2;

    const wrapText = (ctx, text, maxW) => {
      const words = text.split(" ");
      const lines = [];
      let cur = "";
      words.forEach(w => {
        const test = cur ? cur+" "+w : w;
        if (ctx.measureText(test).width > maxW && cur) { lines.push(cur); cur = w; }
        else cur = test;
      });
      if (cur) lines.push(cur);
      return lines;
    };

    const tmpCanvas = document.createElement("canvas");
    const tmpCtx = tmpCanvas.getContext("2d");
    tmpCtx.font = "20px Arial";
    let descLines = [];
    if (rec.description) {
      rec.description.split("\n").forEach(para => {
        wrapText(tmpCtx, para, MAXW).forEach(l => descLines.push(l));
      });
    }

    const H = 240 + 200 + 50 + rec.ingredients.length * 46
            + (descLines.length > 0 ? 50 + descLines.length * LINE + 20 : 0) + 70;

    const canvas = document.createElement("canvas");
    canvas.width = W; canvas.height = H;
    const ctx = canvas.getContext("2d");

    const rr = (x,y,w,h,r) => { ctx.beginPath(); ctx.moveTo(x+r,y); ctx.lineTo(x+w-r,y); ctx.arcTo(x+w,y,x+w,y+r,r); ctx.lineTo(x+w,y+h-r); ctx.arcTo(x+w,y+h,x+w-r,y+h,r); ctx.lineTo(x+r,y+h); ctx.arcTo(x,y+h,x,y+h-r,r); ctx.lineTo(x,y+r); ctx.arcTo(x,y,x+r,y,r); ctx.closePath(); };

    let y = 0;
    ctx.fillStyle = "#FAFAF7"; ctx.fillRect(0,0,W,H);

    const grad = ctx.createLinearGradient(0,0,W,200);
    grad.addColorStop(0,"#1B3A6B"); grad.addColorStop(1,"#2A5298");
    ctx.fillStyle = grad; ctx.fillRect(0,0,W,230);
    y = 48;

    ctx.font = "bold 28px Arial";
    const label = profil?.prenom ? "Recette de " : "Recette céto";
    ctx.fillStyle = "#fff"; ctx.fillText(label, PAD, y);
    if (profil?.prenom) { const lw = ctx.measureText(label).width; ctx.fillStyle = "#F4A035"; ctx.fillText(profil.prenom, PAD+lw, y); }
    y += 52;

    ctx.fillStyle = "#fff"; ctx.font = "bold 44px Georgia"; ctx.fillText(rec.nom, PAD, y); y += 42;

    ctx.fillStyle = "rgba(255,255,255,0.18)"; rr(PAD,y,180,30,15); ctx.fill();
    ctx.fillStyle = "#fff"; ctx.font = "bold 18px Arial"; ctx.fillText(`${rec.portions} portion${rec.portions>1?"s":""}`, PAD+16, y+20);
    ctx.fillStyle = "rgba(255,255,255,0.18)"; rr(PAD+192,y,220,30,15); ctx.fill();
    ctx.fillStyle = "#fff"; ctx.fillText(`${rec.ingredients.length} ingrédient${rec.ingredients.length>1?"s":""}`, PAD+208, y+20);
    y += 58;

    ctx.fillStyle = "#FAFAF7"; ctx.fillRect(0,y-12,W,200);
    ctx.fillStyle = "#9CA3AF"; ctx.font = "bold 18px Arial"; ctx.fillText("POUR UNE PORTION", PAD, y+18); y += 42;

    const bw = (W-PAD*2-32)/3;
    [{label:"Lipides",val:`${rec.macros.portion.lip.toFixed(1)}g`,bg:"#FFF8F0",col:"#E65100"},
     {label:"Glucides",val:`${rec.macros.portion.glu.toFixed(1)}g`,bg:"#FFF0F0",col:"#C62828"},
     {label:"Protéines",val:`${rec.macros.portion.pro.toFixed(1)}g`,bg:"#F0F4FF",col:"#2A5298"}
    ].forEach((m,i) => {
      const bx = PAD+i*(bw+16);
      ctx.fillStyle = m.bg; rr(bx,y,bw,86,12); ctx.fill();
      ctx.fillStyle = m.col; ctx.font = "bold 36px Arial"; ctx.textAlign = "center"; ctx.fillText(m.val, bx+bw/2, y+52);
      ctx.fillStyle = "#9CA3AF"; ctx.font = "bold 16px Arial"; ctx.fillText(m.label, bx+bw/2, y+74);
    });
    ctx.textAlign = "left"; y += 104;

    ctx.fillStyle = sc.bg; rr(PAD,y,W-PAD*2,44,8); ctx.fill();
    ctx.fillStyle = sc.c; ctx.font = "bold 22px Arial"; ctx.textAlign = "center";
    ctx.fillText(`Score céto par portion : ${sc.l}`, W/2, y+28);
    ctx.textAlign = "left"; y += 62;

    ctx.fillStyle = "#9CA3AF"; ctx.font = "bold 20px Arial"; ctx.fillText("🥦  INGRÉDIENTS", PAD, y); y += 36;
    rec.ingredients.forEach((ing,i) => {
      ctx.fillStyle = i%2===0 ? "#fff" : "#F3F4F6";
      ctx.fillRect(PAD-10, y-8, W-PAD*2+20, 44);
      ctx.fillStyle = "#374151"; ctx.font = "bold 22px Arial"; ctx.fillText(`• ${ing.nom.trim()}`, PAD, y+24);
      ctx.fillStyle = "#7CB342"; ctx.textAlign = "right"; ctx.fillText(ing.unite ? `x${ing.gram}` : `${ing.gram}g`, W-PAD, y+24);
      ctx.textAlign = "left"; y += 46;
    });

    if (descLines.length > 0) {
      y += 18;
      ctx.fillStyle = "#9CA3AF"; ctx.font = "bold 20px Arial"; ctx.fillText("📝  PRÉPARATION", PAD, y); y += 34;
      ctx.fillStyle = "#374151"; ctx.font = "20px Arial";
      descLines.forEach(line => { ctx.fillText(line, PAD, y); y += LINE; });
    }

    y = H - 62;
    ctx.fillStyle = "#1B3A6B"; ctx.fillRect(0,y,W,62);
    ctx.fillStyle = "#fff"; ctx.font = "bold 20px Arial"; ctx.fillText("via Céto Club · app gratuite", PAD, y+38);
    ctx.fillStyle = "#F4A035"; ctx.font = "bold 22px Arial"; ctx.textAlign = "right"; ctx.fillText("app.cetoclub.com", W-PAD, y+38);

    canvas.toBlob(async blob => {
      const isMobile = /iPhone|iPad|Android/i.test(navigator.userAgent);

      if (isMobile && navigator.share && navigator.canShare) {
        // Mobile : partage natif (menu partage du téléphone)
        const file = new File([blob], "recette-ceto.png", {type:"image/png"});
        if (navigator.canShare({files:[file]})) {
          try {
            await navigator.share({files:[file], title: rec.nom, text: "Ma recette céto 🥑 via app.cetoclub.com"});
            return;
          } catch(e) {}
        }
      }

      if (!isMobile) {
        // PC : copier dans le presse-papier
        try {
          await navigator.clipboard.write([new ClipboardItem({"image/png": blob})]);
          setToastRecette("clipboard");
          setTimeout(()=>setToastRecette(null), 5000);
          return;
        } catch(e) {}
      }

      // Fallback : afficher l'image pour appui long
      const url = URL.createObjectURL(blob);
      setCarteRecetteUrl(url);
    });
  };

  let [recettePortionModal, setRecettePortionModal] = useState(null); // {rec, nbParts}

  let addRecetteAuJournal = (rec) => {
    // Ouvrir le modal de sélection du nombre de parts
    // Pré-sélectionner le repas ouvert si on est dans le journal, sinon Repas 1
    setRecettePortionModal({rec, nbParts: 1, repasNum: repasOuvert || 1});
  };

  let confirmerRecetteAuJournal = () => {
    if(!recettePortionModal) return;
    const {rec, nbParts, repasNum} = recettePortionModal;
    const macros = rec.macros.portion;
    const nb = parseFloat(nbParts) || 1;
    const numRepas = repasNum || repasOuvert || 1;
    const entree = {
      id: Date.now(),
      nom: `${rec.nom} (${nb} part${nb>1?"s":""} / ${rec.portions})`,
      source: "recette",
      recetteId: rec.id,
      nbParts: nb,
      totalParts: rec.portions,
      gram: nb, // nb de parts (pas des grammes)
      repas: numRepas,
      lip: parseFloat((macros.lip * nb).toFixed(2)),
      glu: parseFloat((macros.glu * nb).toFixed(2)),
      pro: parseFloat((macros.pro * nb).toFixed(2)),
    };
    const dateCible = journalDate || todayStr();
    const entreesDate = journal[dateCible] || [];
    const updated = {...journal, [dateCible]: [...entreesDate, entree]};
    saveJournal(updated);
    setRecettePortionModal(null);
    setPage("journal");
    setJournalDate(dateCible);
    setRepasOuvert(numRepas);
  };

  let recettesFiltrees = recettes.filter(r => {
    if (!recSearch.trim()) return true;
    return r.nom.toLowerCase().includes(recSearch.toLowerCase());
  });

  // ── Suivi bien-être ──
  let [suiviData, setSuiviData] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_suivi")||"{}"); } catch { return {}; }
  });
  let [suiviForm, setSuiviForm] = useState({energie:"3",humeur:"3",sommeil:"3",faim:"3",note:""});

  let saveSuiviData = (d) => {
    setSuiviData(d);
    try { localStorage.setItem("cetoclub_suivi",JSON.stringify(d)); } catch {}
  };

  let saveSuiviJour = () => {
    const today = todayStr();
    const updated = {...suiviData, [today]: {...suiviForm, date:today}};
    saveSuiviData(updated);
  };

  let suiviAujourdhui = suiviData[todayStr()];

  // Résumé hebdomadaire
  let resumeHebdo = () => {
    const days = [];
    for (let i=6; i>=0; i--) {
      const d = new Date(); d.setDate(d.getDate()-i);
      const str = d.toISOString().split("T")[0];
      days.push({date:str, journal:journal[str]||[], suivi:suiviData[str]||null});
    }
    const joursAvecJournal = days.filter(d=>d.journal.length>0);
    const moyGlu = joursAvecJournal.length>0
      ? joursAvecJournal.reduce((s,d)=>s+d.journal.reduce((a,e)=>a+e.glu,0),0)/joursAvecJournal.length
      : 0;
    const moyEnergie = days.filter(d=>d.suivi).length>0
      ? days.filter(d=>d.suivi).reduce((s,d)=>s+parseFloat(d.suivi.energie),0)/days.filter(d=>d.suivi).length
      : 0;
    const joursOk = joursAvecJournal.filter(d=>d.journal.reduce((a,e)=>a+e.glu,0)<=20).length;
    return {days, joursAvecJournal:joursAvecJournal.length, moyGlu, moyEnergie, joursOk};
  };

  // Conseils plateau / doute
  let conseilsPlateau = [
    {e:"💧", t:"Vérifie ton hydratation", c:"Bois de l'eau légèrement salée. Un manque d'électrolytes peut bloquer ta perte de poids."},
    {e:"😴", t:"Le sommeil est clé", c:"Un mauvais sommeil élève le cortisol et bloque la lipolyse. Priorité au repos."},
    {e:"⏰", t:"Respecte les 3 repas", c:"Pas de grignotage. L'insuline doit rester basse entre tes repas pour que le gras se débloque."},
    {e:"🔬", t:"Vérifie les glucides cachés", c:"Relisez les étiquettes. Sauces, charcuterie industrielle, fromages aromatisés peuvent contenir des sucres cachés."},
    {e:"🥑", t:"Fais confiance au processus", c:"Un plateau n'est pas un échec, c'est ton corps qui se réajuste. Continue, il reprendra son chemin."},
    {e:"📏", t:"Mesure plutôt que pèse", c:"Le poids peut stagner alors que le corps se remodèle. Prends tes mensurations : taille, hanches, cuisses."},
  ];

  // ── Jeûne intermittent ──
  let [openMacros, setOpenMacros] = useState(false);
  let [openRecettes, setOpenRecettes] = useState(false);
  let [openRepas, setOpenRepas] = useState(false);
  let [openPoids, setOpenPoids] = useState(false);
  let [openRespiration, setOpenRespiration] = useState(false);
  let [openSommeil, setOpenSommeil] = useState(false);
  let [openRessenti, setOpenRessenti] = useState(false);
  let [openJeune, setOpenJeune] = useState(false);
  let [openMensurations, setOpenMensurations] = useState(false);
  let [openBienetre, setOpenBienetre] = useState(false);
  let [openPlanning, setOpenPlanning] = useState(false);
  let [openFemme, setOpenFemme] = useState(false);
  let [openCourbes, setOpenCourbes] = useState(false);
  // ── Futurs repas (premium) ──
  let [openFutursRepas, setOpenFutursRepas] = useState(false);
  // ── Notes perso (premium) ──
  let [openNotesPerso, setOpenNotesPerso] = useState(false);
  let [openConseils, setOpenConseils] = useState(false);
  let [openConseilsPoids, setOpenConseilsPoids] = useState(false);
  let [openConseilsJeune, setOpenConseilsJeune] = useState(false);
  let [openProfilMoi, setOpenProfilMoi] = useState(false);
  let [openProfilPoids, setOpenProfilPoids] = useState(false);
  let [openProfilActivite, setOpenProfilActivite] = useState(false);
  let [openProfilObjectifs, setOpenProfilObjectifs] = useState(false);
  let [openProfilVacances, setOpenProfilVacances] = useState(false);
  let [openProfilDonnees, setOpenProfilDonnees] = useState(false);
  let [catOpen, setCatOpen] = useState({});
  let [notesPerso, setNotesPerso] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_notes_perso")||"[]"); } catch { return []; }
  });
  let [notePersoTexte, setNotePersoTexte] = useState("");
  let saveNotesPerso = (list) => {
    setNotesPerso(list);
    try { localStorage.setItem("cetoclub_notes_perso", JSON.stringify(list)); } catch {}
  };
  let ajouterNotePerso = () => {
    const txt = notePersoTexte.trim();
    if (!txt) return;
    const nouvelle = { id: Date.now(), date: todayStr(), texte: txt };
    saveNotesPerso([nouvelle, ...notesPerso]);
    setNotePersoTexte("");
  };
  let supprimerNotePerso = (id) => {
    saveNotesPerso(notesPerso.filter(n => n.id !== id));
  };

  // Migration unique : bascule les notes de l'ancien "journal du jour" vers "notes perso"
  useEffect(() => {
    try {
      const dejaMigre = localStorage.getItem("cetoclub_notes_migration_done");
      if (dejaMigre) return;
      const suivi = JSON.parse(localStorage.getItem("cetoclub_suivi")||"{}");
      const notesExistantes = JSON.parse(localStorage.getItem("cetoclub_notes_perso")||"[]");
      const idsExistants = new Set(notesExistantes.map(n=>n.id));
      const notesAMigrer = [];
      Object.entries(suivi).forEach(([date, val]) => {
        if (val && val.note && val.note.trim()) {
          // Utiliser la date comme id de migration (stable)
          const idMigre = "migre_"+date;
          if (!idsExistants.has(idMigre)) {
            notesAMigrer.push({ id: idMigre, date, texte: val.note.trim() });
          }
        }
      });
      if (notesAMigrer.length > 0) {
        // Trier par date décroissante et fusionner
        const toutes = [...notesExistantes, ...notesAMigrer].sort((a,b)=>b.date.localeCompare(a.date));
        saveNotesPerso(toutes);
      }
      localStorage.setItem("cetoclub_notes_migration_done","1");
    } catch {}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let [journalFutur, setJournalFutur] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_journal_futur")||"{}"); } catch { return {}; }
  });
  let [futurDate, setFuturDate] = useState(null); // null = calendrier, "YYYY-MM-DD" = saisie
  let [futurRepasOuvert, setFuturRepasOuvert] = useState(null);
  let [futurJSearch, setFuturJSearch] = useState("");
  let [futurJSearchRes, setFuturJSearchRes] = useState([]);
  let [futurJSel, setFuturJSel] = useState(null);
  let [futurJGram, setFuturJGram] = useState(100);
  let [futurEditEntreeId, setFuturEditEntreeId] = useState(null);
  let [futurEditEntreeGram, setFuturEditEntreeGram] = useState("");
  let [jeuneActif, setJeuneActif] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_jeune_actif")||"null"); } catch { return null; }
  });
  let [jeuneHistorique, setJeuneHistorique] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_jeune_histo")||"[]"); } catch { return []; }
  });
  let [jeuneProtocole, setJeuneProtocole] = useState("16:8");
  let [jeuneNow, setJeuneNow] = useState(new Date());
  let [jeuneHeureDebut, setJeuneHeureDebut] = useState(new Date().toTimeString().slice(0,5));
  let [jeuneEditMode, setJeuneEditMode] = useState("");
  let [jeuneCorrection, setJeuneCorrection] = useState(false);
  let [jeuneEditHeure, setJeuneEditHeure] = useState("");

  // Timer tick
  let tickJeune = () => setJeuneNow(new Date());

  let saveJeuneActif = (j) => {
    setJeuneActif(j);
    try { localStorage.setItem("cetoclub_jeune_actif", JSON.stringify(j)); } catch {}
  };
  let saveJeuneHisto = (h) => {
    setJeuneHistorique(h);
    try { localStorage.setItem("cetoclub_jeune_histo", JSON.stringify(h)); } catch {}
  };

  let demarrerJeune = () => {
    const now = new Date();
    const [h,m] = jeuneHeureDebut.split(":").map(Number);
    const debut = new Date(now); debut.setHours(h,m,0,0);
    // Si l'heure choisie est dans le futur, on prend hier
    if (debut > now) debut.setDate(debut.getDate()-1);
    const j = {debut: debut.toISOString(), protocole: jeuneProtocole};
    saveJeuneActif(j);
  };

  let terminerJeune = () => {
    if (!jeuneActif) return;
    const fin = new Date().toISOString();
    const dureeMs = new Date(fin) - new Date(jeuneActif.debut);
    const dureeH = dureeMs / (1000*60*60);
    const entree = {...jeuneActif, fin, dureeH: parseFloat(dureeH.toFixed(1))};
    saveJeuneHisto([entree, ...jeuneHistorique].slice(0,30));
    saveJeuneActif(null);
  };

  let semaineCeto = () => {
    const dateRef = profil?.debutCeto || profil?.createdAt;
    if (!dateRef) return 0;
    const debut = new Date(dateRef+"T12:00:00");
    const diff = (new Date() - debut) / (1000*60*60*24*7);
    return Math.floor(diff);
  };

  let formatDuree = (ms) => {
    const h = Math.floor(ms/3600000);
    const m = Math.floor((ms%3600000)/60000);
    const s = Math.floor((ms%60000)/1000);
    return `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
  };

  let protocoles = [
    {id:"16:8", l:"16:8", d:"16h de jeûne, 8h d'alimentation", duree:16, bienfait:"Idéal pour débuter · Facile au quotidien · Sommeil compte dans le jeûne"},
    {id:"18:6", l:"18:6", d:"18h de jeûne, 6h d'alimentation", duree:18, bienfait:"Autophagie renforcée · Perte de poids accélérée · Clarté mentale"},
    {id:"20:4", l:"20:4 (Jeûne intensif)", d:"20h de jeûne, 4h d'alimentation", duree:20, bienfait:"Nettoyage cellulaire profond · Réservé aux pratiquants confirmés"},
    {id:"24h",  l:"24h (OMAD)", d:"Un repas par jour", duree:24, bienfait:"Résistance à l'insuline maximale · À pratiquer occasionnellement"},
  ];

  let conseilsJeune = [
    {e:"💧", t:"Hydratation renforcée", c:"Pendant le jeûne, bois de l'eau légèrement salée. Le sel aide à conserver les électrolytes."},
    {e:"☕", t:"Café & thé autorisés", c:"Café noir, thé, tisanes ne rompent pas le jeûne. Ils peuvent même aider à tenir."},
    {e:"🧂", t:"Électrolytes essentiels", c:"Ajoute une pincée de sel à ton eau. Un bouillon de légumes non sucré est aussi autorisé."},
    {e:"🎧", t:"Écoute ton corps", c:"Si tu ressens des vertiges, maux de tête intenses ou malaise, romps le jeûne. Pas d'héroïsme."},
    {e:"🥑", t:"Rompre le jeûne en douceur", c:"Privilégie un repas léger pour rompre : oeufs, avocat, bouillon. Évite de te jeter sur la nourriture."},
    {e:"😴", t:"Le sommeil compte", c:"La nuit fait partie du jeûne ! Dîner tôt et déjeuner tard est la façon la plus naturelle de pratiquer le 16:8."},
  ];

  // ── Sommeil ──
  let [sommeilData, setSommeilData] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_sommeil")||"{}"); } catch { return {}; }
  });
  let [sommeilForm, setSommeilForm] = useState({heureCoucher:"22:30",heureReveil:"06:30",qualite:"3",note:""});

  let saveSommeilData = (d) => {
    setSommeilData(d);
    try { localStorage.setItem("cetoclub_sommeil",JSON.stringify(d)); } catch {}
  };

  let saveSommeilJour = () => {
    const today = todayStr();
    const [hC,mC] = sommeilForm.heureCoucher.split(":").map(Number);
    const [hR,mR] = sommeilForm.heureReveil.split(":").map(Number);
    let duree = (hR*60+mR) - (hC*60+mC);
    if (duree < 0) duree += 24*60;
    const dureeH = parseFloat((duree/60).toFixed(1));
    const updated = {...sommeilData, [today]: {...sommeilForm, dureeH, date:today}};
    saveSommeilData(updated);
  };

  let sommeilAujourdhui = sommeilData[todayStr()];

  let sommeilHebdo = () => {
    const days = [];
    for (let i=6; i>=0; i--) {
      const d = new Date(); d.setDate(d.getDate()-i);
      const str = d.toISOString().split("T")[0];
      days.push({date:str, data:sommeilData[str]||null});
    }
    const avecData = days.filter(d=>d.data);
    const moyDuree = avecData.length>0 ? avecData.reduce((s,d)=>s+d.data.dureeH,0)/avecData.length : 0;
    const moyQualite = avecData.length>0 ? avecData.reduce((s,d)=>s+parseFloat(d.data.qualite),0)/avecData.length : 0;
    return {days, moyDuree, moyQualite, avecData:avecData.length};
  };

  // ── Activité ──
  let [activiteData, setActiviteData] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_activite")||"[]"); } catch { return []; }
  });
  let [activiteForm, setActiviteForm] = useState({type:"marche",duree:"30",intensite:"2",note:""});

  let saveActiviteData = (d) => {
    setActiviteData(d);
    try { localStorage.setItem("cetoclub_activite",JSON.stringify(d)); } catch {}
  };

  let saveSeance = () => {
    const seance = {...activiteForm, date:todayStr(), id:Date.now()};
    saveActiviteData([seance, ...activiteData].slice(0,60));
    setActiviteForm({type:"marche",duree:"30",intensite:"2",note:""});
  };

  let activiteTypesLabels = {
    marche:"🚶 Marche", velo:"🚴 Vélo", course:"🏃 Course",
    natation:"🏊 Natation", musculation:"💪 Musculation",
    pilates:"🤸 Pilates", randonnee:"🥾 Randonnée", autre:"⭐ Autre"
  };

  let poidsActuel = parseFloat(profil?.poids||0);

  // Recommandation selon poids
  let recoActivite = () => {
    if (poidsActuel >= 120) return {
      niveau:"doux", couleur:"#7CB342",
      titre:"Marche & natation recommandées",
      message:"À partir de 120kg, les articulations (genoux, hanches, chevilles) subissent une pression importante. La marche douce et la natation permettent de bouger sans impact articulaire. Pas de running, pas de sauts.",
      activites:["🚶 Marche douce 20-30 min","🏊 Natation / aquagym","🚴 Vélo en salle (assis)","🧘 Étirements doux"],
      eviter:["Sauts, corde à sauter","Running, jogging","Sports de contact","Squats lestés"]
    };
    if (poidsActuel >= 90) return {
      niveau:"modéré", couleur:"#F4A035",
      titre:"Activité douce à modérée",
      message:"Entre 90 et 120kg, privilégie les activités à faible impact. La marche rapide, le vélo et la natation sont idéaux. Introduis progressivement la musculation légère après 4 semaines de céto.",
      activites:["🚶 Marche rapide 30-45 min","🏊 Natation","🚴 Vélo","💪 Musculation légère"],
      eviter:["Running intense","Sports collectifs intenses","Exercices avec sauts"]
    };
    return {
      niveau:"libre", couleur:"#1B3A6B",
      titre:"Activité selon ton énergie",
      message:"Au début du céto, ton corps a besoin de toute son énergie pour s'adapter. Commence par des activités calmes (marche, étirements). Une fois adapté, tu éclateras d'énergie ! 💪",
      activites:["🚶 Marche, randonnée","🏊 Natation","🚴 Vélo","💪 Musculation"],
      eviter:["Effort maximal les 2 premières semaines","Entraînements à jeun au début"]
    };
  };

  let activiteHebdo = () => {
    const days = [];
    for (let i=6; i>=0; i--) {
      const d = new Date(); d.setDate(d.getDate()-i);
      const str = d.toISOString().split("T")[0];
      const seances = activiteData.filter(a=>a.date===str);
      days.push({date:str, seances, dureeTotal:seances.reduce((s,a)=>s+parseInt(a.duree||0),0)});
    }
    const totalMin = days.reduce((s,d)=>s+d.dureeTotal,0);
    const nbSeances = days.reduce((s,d)=>s+d.seances.length,0);
    return {days, totalMin, nbSeances};
  };

  // ── Respiration ──
  let [respActif, setRespActif] = useState(false);
  let [respProtocole, setRespProtocole] = useState("478");
  let [respPhase, setRespPhase] = useState(0); // 0=inspire 1=retient 2=expire 3=retient
  let [respCompte, setRespCompte] = useState(0);
  let [respCycle, setRespCycle] = useState(0);
  let [respObjectif, setRespObjectif] = useState(5);
  let [respTimer, setRespTimer] = useState(null);

  let respProtocoles = {
    "478":    {l:"4-7-8",         phases:[4,7,8,0],   desc:"Relaxation profonde · Réduit le cortisol", couleur:"#0277BD"},
    "coherence":{l:"Cohérence cardiaque",phases:[5,0,5,0], desc:"5 min · Régule le système nerveux autonome", couleur:"#2E7D32"},
    "box":    {l:"Box Breathing",  phases:[4,4,4,4],   desc:"4×4 · Utilisé par les Navy SEALs · Anti-stress", couleur:"#6A1B9A"},
    "222":    {l:"2-2-2 Doux",    phases:[2,2,2,0],   desc:"Débutant · Idéal avant de dormir", couleur:"#F57F17"},
  };

  let phaseLabels = ["Inspire","Retiens","Expire","Retiens"];
  let phaseColors = ["#0277BD","#6A1B9A","#2E7D32","#F57F17"];
  let phaseEmojis = ["🌬️","🫁","💨","⏸️"];

  let demarrerResp = () => {
    const proto = respProtocoles[respProtocole];
    setRespPhase(0);
    setRespCompte(proto.phases[0]);
    setRespCycle(0);
    setRespActif(true);
    if (respTimer) clearInterval(respTimer);
    let phase = 0, compte = proto.phases[0], cycle = 0;
    const interval = setInterval(() => {
      const next = tickResp(phase, compte, cycle, proto);
      phase = next.phase; compte = next.compte; cycle = next.cycle;
      setRespPhase(next.phase);
      setRespCompte(next.compte);
      setRespCycle(next.cycle);
      if (next.cycle >= respObjectif) {
        clearInterval(interval);
        setRespTimer(null);
      }
    }, 1000);
    setRespTimer(interval);
  };

  let arreterResp = () => {
    setRespActif(false);
    if (respTimer) { clearInterval(respTimer); setRespTimer(null); }
  };

  let tickResp = (phase, compte, cycle, proto) => {
    if (compte > 1) {
      return {phase, compte: compte-1, cycle};
    }
    // Passer à la phase suivante
    let nextPhase = phase;
    let nextCycle = cycle;
    do {
      nextPhase = (nextPhase + 1) % 4;
      if (nextPhase === 0) nextCycle = cycle + 1;
    } while (proto.phases[nextPhase] === 0);
    return {phase: nextPhase, compte: proto.phases[nextPhase], cycle: nextCycle};
  };

  // ── Audio Web API ──
  let [audioCtx, setAudioCtx] = useState(null);
  let [audioNodes, setAudioNodes] = useState([]);

  // ── INSTALLATION PWA UNIVERSELLE ──
  let [pwaInstallPrompt, setPwaInstallPrompt] = useState(null);
  let [pwaInstallable, setPwaInstallable] = useState(false);
  let [modalInstall, setModalInstall] = useState(false);
  let [dejaInstallee, setDejaInstallee] = useState(false);

  useEffect(()=>{
    // Détecte si l'app tourne déjà en mode standalone (déjà installée)
    const estStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (estStandalone) setDejaInstallee(true);

    // Écoute l'événement d'installation native (Chrome/Edge/Samsung/Brave)
    const handler = (e) => { e.preventDefault(); setPwaInstallPrompt(e); setPwaInstallable(true); };
    window.addEventListener("beforeinstallprompt", handler);

    // Écoute la confirmation d'installation
    const handlerInstalled = () => {
      setPwaInstallable(false);
      setDejaInstallee(true);
      setModalInstall(false);
      if (window.va) window.va("event", { name: "app_installed" });
    };
    window.addEventListener("appinstalled", handlerInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", handlerInstalled);
    };
  },[]);

  // Timer jeûne — tick chaque seconde si jeûne actif
  useEffect(()=>{
    if (!jeuneActif) return;
    const interval = setInterval(()=>setJeuneNow(new Date()), 1000);
    return ()=>clearInterval(interval);
  },[jeuneActif]);

  // Détection du navigateur de l'utilisateur
  let detecterNavigateur = () => {
    const ua = navigator.userAgent.toLowerCase();
    const estIOS = /iphone|ipad|ipod/.test(ua);
    const estAndroid = /android/.test(ua);
    const estSafari = /safari/.test(ua) && !/chrome|crios|fxios|edg/.test(ua);
    const estChromeIOS = /crios/.test(ua);
    const estFirefoxIOS = /fxios/.test(ua);
    const estFirefox = /firefox/.test(ua) && !estFirefoxIOS;
    const estEdge = /edg/.test(ua);
    const estChrome = /chrome/.test(ua) && !estEdge && !estChromeIOS;
    const estSamsung = /samsungbrowser/.test(ua);
    const estOpera = /opr\//.test(ua) || /opera/.test(ua);

    if (estIOS) return "ios";
    if (estAndroid && estFirefox) return "firefox-android";
    if (estAndroid && (estChrome || estSamsung || estOpera)) return "android-chrome";
    if (estFirefox) return "firefox-desktop";
    if (estChrome || estEdge || estOpera) return "desktop-chrome";
    if (estSafari) return "safari-desktop";
    return "autre";
  };

  // Clic sur le bouton Installer
  let clicBoutonInstaller = async () => {
    // Cas 1 : installation native disponible
    if (pwaInstallPrompt) {
      pwaInstallPrompt.prompt();
      const result = await pwaInstallPrompt.userChoice;
      if (result.outcome === "accepted") {
        setPwaInstallable(false);
        setPwaInstallPrompt(null);
        if (window.va) window.va("event", { name: "app_installed" });
      }
      return;
    }
    // Cas 2 : pas d'install auto → ouvrir popup d'instructions
    setModalInstall(true);
  };

  // Ancien alias conservé pour compatibilité
  let installPwa = clicBoutonInstaller;

  // ── Journal journalier ──
  let [journalDate, setJournalDate] = useState(todayStr());
  let [tabJournal, setTabJournal] = useState("nutrition"); // nutrition | corps | activite | jeune | bienetre
  let [journal, setJournal] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cetoclub_journal")||"{}"); } catch { return {}; }
  });
  let [objectifs, setObjectifs] = useState(() => {
    return getObjectifsEffectifs();
  });
  let [objEdit, setObjEdit] = useState(false);
  let [objForm, setObjForm] = useState({lip:"150",glu:"20",pro:"80"});
  let [jSearch, setJSearch] = useState("");
  let [jSearchRes, setJSearchRes] = useState([]);
  let [jSel, setJSel] = useState(null);
  let [jGram, setJGram] = useState(100);
  let [jSource, setJSource] = useState("ciqual");
  let [repasOuvert, setRepasOuvert] = useState(null);
  let [editEntreeId, setEditEntreeId] = useState(null);
  let [editEntreeGram, setEditEntreeGram] = useState("");
  let [editPoidsDate, setEditPoidsDate] = useState(null);
  let [editPoidsVal, setEditPoidsVal] = useState("");
  let [editMensDate, setEditMensDate] = useState(null);
  let [editMensForm, setEditMensForm] = useState({taille:"",hanches:"",cuisseD:"",cuisseG:""});
  let [editRecId, setEditRecId] = useState(null);
  let [tuileOuverte, setTuileOuverte] = useState(null);
  let [sommeilTuileForm, setSommeilTuileForm] = useState({heureCoucher:"22:30",heureLever:"06:30"});
  let [activiteTuileForm, setActiviteTuileForm] = useState({sport:"marche",nbSeances:"1",duree:"30",intensite:"moderee"});
  let [jeuneTuileForm, setJeuneTuileForm] = useState({heureDebut:"",heureFin:""});

  let PHRASES_JOUR = [
    "Chaque repas céto est un pas vers ta liberté alimentaire 🥑",
    "Ton corps est en train de s'adapter, fais-lui confiance 💪",
    "La cétose ne se voit pas tout de suite, elle se ressent ✨",
    "Une journée sans sucre, c'est une victoire silencieuse 🌟",
    "Le changement commence là où la routine s'arrête 🔥",
    "Ton corps brûle des graisses pendant que tu lis ceci 😴",
    "La patience est le premier ingrédient du succès céto ⏳",
    "Chaque verre d'eau bu est un électrolyte de plus pour toi 💧",
    "Le céto n'est pas un régime, c'est un retour à l'essentiel 🌿",
    "Aujourd'hui encore, tu choisis ta santé, c'est énorme 💚",
    "Ton foie fabrique des cétones pendant ton sommeil 🌙",
    "La graisse que tu manges devient l'énergie que tu ressens ⚡",
    "Douter c'est humain. Continuer c'est céto. 🥑",
    "Chaque semaine de céto recalibre ton métabolisme 📈",
    "Tu n'es pas au régime, tu es en train de te réparer 🛠️",
    "Le sucre crée la faim. Le gras crée la satiété. Simple. 🧈",
    "Résiste aujourd'hui, ressens demain la différence 💥",
    "L'adaptation céto est un investissement sur toi-même 🏆",
    "Ce que tu ne manges pas compte autant que ce que tu manges 🎯",
    "Ton énergie céto est propre, stable et durable 🔋",
    "Confiance dans le processus, ton corps sait ce qu'il fait 🧠",
    "Une bonne nuit de sommeil double les bénéfices du céto 🌛",
    "Le stress est l'ennemi de la cétose, respire 🧘",
    "Chaque jour céto est un jour de moins d'inflammation 🌸",
    "Tu construis une nouvelle version de toi, brique par brique 🏗️",
    "Les résultats se voient sur la balance, se sentent dans l'énergie 💫",
    "Manger gras pour brûler gras — la logique céto est parfaite 🔄",
    "Ce soir, pendant ton sommeil, ton corps va faire le travail 🌃",
    "Tu es plus proche de tes objectifs qu'hier 📍",
    "Le céto est simple : moins de 20g de glucides, et tout le reste suit 🥦",
  ];
  let phraseJour = PHRASES_JOUR[new Date().getDate() % PHRASES_JOUR.length];

  let saveSommeilTuile = () => {
    const [hC,mC] = sommeilTuileForm.heureCoucher.split(":").map(Number);
    const [hL,mL] = sommeilTuileForm.heureLever.split(":").map(Number);
    let duree = (hL*60+mL)-(hC*60+mC);
    if (duree<0) duree+=1440;
    const dureeH = parseFloat((duree/60).toFixed(1));
    const today = todayStr();
    const updated = {...sommeilData, [today]:{heureCoucher:sommeilTuileForm.heureCoucher,heureReveil:sommeilTuileForm.heureLever,dureeH,date:today}};
    setSommeilData(updated);
    try { localStorage.setItem("cetoclub_sommeil",JSON.stringify(updated)); } catch {}
    setTuileOuverte(null);
  };

  let saveActiviteTuile = () => {
    const seance = {...activiteTuileForm, date:todayStr(), id:Date.now()};
    saveActiviteData([seance,...activiteData].slice(0,60));
    setActiviteTuileForm({sport:"marche",nbSeances:"1",duree:"30",intensite:"moderee"});
    setTuileOuverte(null);
  };

  let saveJeuneTuile = () => {
    if (!jeuneTuileForm.heureDebut||!jeuneTuileForm.heureFin) return;
    const today = todayStr();
    const debut = new Date(today+"T"+jeuneTuileForm.heureDebut+":00");
    const fin = new Date(today+"T"+jeuneTuileForm.heureFin+":00");
    let dureeMs = fin-debut; if(dureeMs<0) dureeMs+=86400000;
    const dureeH = parseFloat((dureeMs/3600000).toFixed(1));
    const entree = {debut:debut.toISOString(),fin:fin.toISOString(),protocole:dureeH+"h",dureeH,date:today};
    saveJeuneHisto([entree,...jeuneHistorique].slice(0,30));
    const jEntry = {id:Date.now(),nom:"⏱️ Jeûne de "+dureeH+"h accompli",gram:0,lip:0,glu:0,pro:0,repas:0,source:"jeune"};
    const updJ = {...journal,[today]:[...(journal[today]||[]),jEntry]};
    setJournal(updJ);
    try { localStorage.setItem("cetoclub_journal",JSON.stringify(updJ)); } catch {}
    setJeuneTuileForm({heureDebut:"",heureFin:""});
    setTuileOuverte(null);
  };

  let saveJournal = (j) => {
    setJournal(j);
    try { localStorage.setItem("cetoclub_journal",JSON.stringify(j)); } catch {}
  };

  let saveJournalFutur = (jf) => {
    setJournalFutur(jf);
    try { localStorage.setItem("cetoclub_journal_futur",JSON.stringify(jf)); } catch {}
  };

  // Migration quotidienne : bascule les repas du jour J depuis le journal futur vers le journal normal
  useEffect(() => {
    const today = todayStr();
    try {
      const jf = JSON.parse(localStorage.getItem("cetoclub_journal_futur")||"{}");
      if (!jf[today] || jf[today].length === 0) return;
      const jn = JSON.parse(localStorage.getItem("cetoclub_journal")||"{}");
      const existing = jn[today] || [];
      const toMerge = jf[today];
      // Ne pas dupliquer si déjà migré (vérif par id)
      const existingIds = new Set(existing.map(e=>e.id));
      const newEntries = toMerge.filter(e=>!existingIds.has(e.id));
      if (newEntries.length > 0) {
        const mergedJournal = {...jn, [today]: [...existing, ...newEntries]};
        setJournal(mergedJournal);
        try { localStorage.setItem("cetoclub_journal",JSON.stringify(mergedJournal)); } catch {}
      }
      // Supprimer du journal futur
      const {[today]: _, ...jfSansAujourdhui} = jf;
      setJournalFutur(jfSansAujourdhui);
      try { localStorage.setItem("cetoclub_journal_futur",JSON.stringify(jfSansAujourdhui)); } catch {}
    } catch {}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let futurJourneeEntrees = futurDate ? (journalFutur[futurDate] || []) : [];

  let doFuturJSearch = (val) => {
    setFuturJSearch(val);
    setFuturJSel(null);
    if (!val.trim()) { setFuturJSearchRes([]); return; }
    const v = normalizeSearch(val.trim());
    const tokens = v.split(/\s+/).filter(Boolean);
    const _allCiqual = ALIMENTS.filter(a => {
      const n = normalizeSearch(a.nom.trim());
      return n.includes(v) || tokens.every(t => n.includes(t));
    });
    const _wordStarts = _allCiqual.filter(a => normalizeSearch(a.nom.trim()).split(/\s+/).some(w => w.startsWith(v)));
    const _starts = _allCiqual.filter(a => normalizeSearch(a.nom.trim()).startsWith(v) && !_wordStarts.includes(a));
    const _contains = _allCiqual.filter(a => !_wordStarts.includes(a) && !_starts.includes(a));
    const ciqual = [..._wordStarts, ..._starts, ..._contains].slice(0,15).map(a => ({...a, nom:a.nom.trim(), source:"ciqual"}));
    const perso = produits.filter(a => {
      const n = normalizeSearch(a.nom);
      const m = a.marque ? normalizeSearch(a.marque) : "";
      return n.includes(v) || m.includes(v) || tokens.every(t => n.includes(t) || m.includes(t));
    }).slice(0,5).map(a => ({...a,source:"perso",glu:a.glu||0}));
    const mesRecettes = recettes.filter(r => normalizeSearch(r.nom).includes(v)).slice(0,3).map(r => ({
      id: r.id,
      nom: r.nom,
      source: "recette",
      portions: r.portions,
      macros: r.macros,
      glu: parseFloat(r.macros.portion.glu.toFixed(1)),
      lip: parseFloat(r.macros.portion.lip.toFixed(1)),
      pro: parseFloat(r.macros.portion.pro.toFixed(1)),
    }));
    setFuturJSearchRes([...mesRecettes,...ciqual,...perso]);
  };

  let addFuturEntree = () => {
    if (!futurJSel || !futurDate) return;
    const g = +futurJGram || (futurJSel.unite ? 1 : 100);
    const entree = {
      id: Date.now(),
      nom: futurJSel.nom,
      marque: futurJSel.marque||null,
      source: futurJSel.source||"ciqual",
      unite: futurJSel.unite||false,
      gram: g,
      repas: futurRepasOuvert||1,
      lip: parseFloat((futurJSel.unite ? futurJSel.lip*g : (futurJSel.lip*g)/100).toFixed(2)),
      glu: parseFloat((futurJSel.unite ? futurJSel.glu*g : (futurJSel.glu*g)/100).toFixed(2)),
      pro: parseFloat((futurJSel.unite ? futurJSel.pro*g : (futurJSel.pro*g)/100).toFixed(2)),
    };
    const entreesDate = journalFutur[futurDate] || [];
    saveJournalFutur({...journalFutur, [futurDate]: [...entreesDate, entree]});
    setFuturJSel(null); setFuturJSearch(""); setFuturJSearchRes([]); setFuturJGram(100);
  };

  let removeFuturEntree = (id) => {
    const entreesDate = (journalFutur[futurDate]||[]).filter(e=>e.id!==id);
    saveJournalFutur({...journalFutur, [futurDate]: entreesDate});
  };

  let saveFuturEditEntree = (id) => {
    const g = parseFloat(futurEditEntreeGram);
    if (!g||g<1) return;
    const entreesDate = (journalFutur[futurDate]||[]).map(e => e.id!==id ? e : {
      ...e, gram:g,
      lip: parseFloat((e.lip/e.gram)*g).toFixed(2)*1,
      glu: parseFloat((e.glu/e.gram)*g).toFixed(2)*1,
      pro: parseFloat((e.pro/e.gram)*g).toFixed(2)*1,
    });
    saveJournalFutur({...journalFutur, [futurDate]: entreesDate});
    setFuturEditEntreeId(null); setFuturEditEntreeGram("");
  };

  let addFuturRecetteAuJournal = (rec) => {
    if (!futurDate) return;
    const macros = rec.macros.portion;
    const nb = 1;
    const entree = {
      id: Date.now(),
      nom: `${rec.nom} (${nb} part / ${rec.portions})`,
      source: "recette",
      recetteId: rec.id,
      nbParts: nb,
      totalParts: rec.portions,
      gram: nb,
      repas: futurRepasOuvert||1,
      lip: parseFloat((macros.lip * nb).toFixed(2)),
      glu: parseFloat((macros.glu * nb).toFixed(2)),
      pro: parseFloat((macros.pro * nb).toFixed(2)),
    };
    const entreesDate = journalFutur[futurDate] || [];
    saveJournalFutur({...journalFutur, [futurDate]: [...entreesDate, entree]});
    setFuturJSearch(""); setFuturJSearchRes([]);
  };
  let saveObjectifs = (o) => {
    setObjectifs(o);
    try { localStorage.setItem("cetoclub_objectifs",JSON.stringify(o)); } catch {}
  };

  let journeeEntrees = journal[journalDate] || [];

  let totauxRepas = (num) => {
    return (journeeEntrees||[]).filter(e=>e.repas===num).reduce((acc,e)=>({lip:acc.lip+e.lip,glu:acc.glu+e.glu,pro:acc.pro+e.pro}),{lip:0,glu:0,pro:0});
  };

  let addEntree = () => {
    if (!jSel) return;
    const g = +jGram || (jSel.unite ? 1 : 100);
    const entree = {
      id: Date.now(),
      nom: jSel.nom,
      marque: jSel.marque||null,
      source: jSource,
      unite: jSel.unite||false,
      gram: g,
      repas: repasOuvert||1,
      lip: parseFloat((jSel.unite ? jSel.lip*g : (jSel.lip*g)/100).toFixed(2)),
      glu: parseFloat((jSel.unite ? jSel.glu*g : (jSel.glu*g)/100).toFixed(2)),
      pro: parseFloat((jSel.unite ? jSel.pro*g : (jSel.pro*g)/100).toFixed(2)),
    };
    const updated = {...journal, [journalDate]: [...journeeEntrees, entree]};
    saveJournal(updated);
    setJSel(null); setJSearch(""); setJSearchRes([]); setJGram(100);
  };

  let removeEntree = (id) => {
    const updated = {...journal, [journalDate]: journeeEntrees.filter(e=>e.id!==id)};
    saveJournal(updated);
  };

  let saveEditEntree = (id) => {
    const g = parseFloat(editEntreeGram);
    if (!g||g<1) return;
    const updated = {...journal, [journalDate]: journeeEntrees.map(e=> e.id!==id ? e : {
      ...e, gram:g,
      lip: parseFloat((e.unite ? (e.lip/e.gram)*g : (e.lip/e.gram)*g).toFixed(2)),
      glu: parseFloat((e.unite ? (e.glu/e.gram)*g : (e.glu/e.gram)*g).toFixed(2)),
      pro: parseFloat((e.unite ? (e.pro/e.gram)*g : (e.pro/e.gram)*g).toFixed(2))
    })};
    saveJournal(updated);
    setEditEntreeId(null); setEditEntreeGram("");
  };

  let totalJ = journeeEntrees.reduce((acc,e)=>({lip:acc.lip+e.lip,glu:acc.glu+e.glu,pro:acc.pro+e.pro}),{lip:0,glu:0,pro:0});

  let changeDate = (delta) => {
    const d = new Date(journalDate);
    d.setDate(d.getDate()+delta);
    setJournalDate(d.toISOString().split("T")[0]);
  };

  let formatDate = (str) => {
    const d = new Date(str+"T12:00:00");
    const today = todayStr();
    const yesterday = new Date(); yesterday.setDate(yesterday.getDate()-1);
    const yStr = yesterday.toISOString().split("T")[0];
    if (str===today) return "Aujourd'hui";
    if (str===yStr) return "Hier";
    return d.toLocaleDateString("fr-FR",{weekday:"long",day:"numeric",month:"long"});
  };

  let doJSearch = (val) => {
    setJSearch(val);
    setJSel(null);
    if (!val.trim()) { setJSearchRes([]); return; }
    const v = normalizeSearch(val.trim());
    const tokens = v.split(/\s+/).filter(Boolean);
    // Un aliment matche si la chaîne complète est incluse OU si tous les tokens sont présents
    const _allCiqual = ALIMENTS.filter(a => {
      const n = normalizeSearch(a.nom.trim());
      return n.includes(v) || tokens.every(t => n.includes(t));
    });
    // Tri en 3 niveaux : 1) un mot du nom commence par v  2) le nom commence par v  3) le reste
    const _wordStarts = _allCiqual.filter(a => normalizeSearch(a.nom.trim()).split(/\s+/).some(w => w.startsWith(v)));
    const _starts = _allCiqual.filter(a => normalizeSearch(a.nom.trim()).startsWith(v) && !_wordStarts.includes(a));
    const _contains = _allCiqual.filter(a => !_wordStarts.includes(a) && !_starts.includes(a));
    const ciqual = [..._wordStarts, ..._starts, ..._contains].slice(0,15).map(a => ({...a, nom:a.nom.trim(), source:"ciqual"}));
    const perso = produits.filter(a => {
      const n = normalizeSearch(a.nom);
      const m = a.marque ? normalizeSearch(a.marque) : "";
      return n.includes(v) || m.includes(v) || tokens.every(t => n.includes(t) || m.includes(t));
    }).slice(0,5).map(a => ({...a,source:"perso",glu:a.glu||0}));
    // Recettes personnelles enregistrees
    const mesRecettes = recettes.filter(r => normalizeSearch(r.nom).includes(v)).slice(0,3).map(r => ({
      id: r.id,
      nom: r.nom,
      source: "recette",
      portions: r.portions,
      macros: r.macros,
      glu: parseFloat(r.macros.portion.glu.toFixed(1)),
      lip: parseFloat(r.macros.portion.lip.toFixed(1)),
      pro: parseFloat(r.macros.portion.pro.toFixed(1)),
    }));
    setJSearchRes([...mesRecettes,...ciqual,...perso]);
  };

  // ── Onboarding ──
  if (!onboardingDone) {
    const isLast = onboardingStep === 3;
    const profilComplet = profilForm.prenom && profilForm.poids && profilForm.age && profilForm.taille;
    const macrosPreview = profilComplet ? calcMacrosProfil({
      sexe:profilForm.sexe, age:profilForm.age, poids:profilForm.poids,
      taille:profilForm.taille, activite:profilForm.activite
    }) : null;

    const handleFinish = () => {
      if (profilComplet) {
        saveProfil({
          prenom:profilForm.prenom, sexe:profilForm.sexe, age:profilForm.age,
          poids:profilForm.poids, taille:profilForm.taille, activite:profilForm.activite,
          poidsDepart:profilForm.poids, poidsObjectif:profilForm.poidsObjectif||"", debutCeto:new Date().toISOString().split("T")[0]
        });
      }
      try { localStorage.setItem("cetoclub_onboarding","done"); } catch {}
      setOnboardingDone(true);
      setPage("journal");
    };

    return (
      <div style={{minHeight:"100vh",background:"#FAFAF7",fontFamily:"'Nunito',sans-serif",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"20px 16px",overflowX:"hidden"}}>
        <style>{"@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600;700;800;900&display=swap');*{box-sizing:border-box}html,body{overflow-x:hidden}"}</style>

        {/* Logo */}
        <div style={{textAlign:"center",marginBottom:20}}>
          <AvocatLogo size={56}/>
          <div style={{fontSize:26,fontWeight:900,color:"#1B3A6B",marginTop:6}}>Céto Club</div>
          <div style={{fontSize:11,color:"#7CB342",fontWeight:700}}>🤝 Association à but non lucratif · Sans pub · Sans tracking</div>
        </div>

        {/* Barre progression */}
        <div style={{display:"flex",gap:6,marginBottom:20}}>
          {[0,1,2,3].map(i=>(
            <div key={i} style={{height:5,borderRadius:3,background:i<=onboardingStep?"#7CB342":"#E5E7EB",transition:"all .3s",width:i===onboardingStep?40:20}}/>
          ))}
        </div>

        <div style={{background:"#fff",borderRadius:20,border:"2px solid #7CB34220",padding:"24px 20px",maxWidth:480,width:"100%",boxShadow:"0 8px 32px rgba(27,58,107,.1)"}}>

          {/* ── ÉCRAN 1 : Bienvenue ── */}
          {onboardingStep===0 && (
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:52,marginBottom:12}}>🥑</div>
              <h2 style={{fontSize:22,fontWeight:900,color:"#1B3A6B",margin:"0 0 10px"}}>Bienvenue dans Céto Club !</h2>
              <p style={{fontSize:13,color:"#6B7280",lineHeight:1.7,margin:"0 0 20px"}}>
                Je suis là pour t'aider à <strong style={{color:"#1B3A6B"}}>réussir le céto</strong>.<br/>
                Simple, bienveillant, sans prise de tête.
              </p>
              <div style={{background:"linear-gradient(135deg,#1B3A6B10,#7CB34210)",borderRadius:14,padding:16,marginBottom:20,textAlign:"left"}}>
                {[
                  {e:"🥑",t:`${ALIMENTS.length} aliments certifiés ANSES — accès complet`},
                  {e:"📊",t:"Journal quotidien — suivi de tes macros"},
                  {e:"🎯",t:"Calcul de tes macros personnalisées"},
                  {e:"🍳",t:"Recettes du blog Céto Club"},
                  {e:"📖",t:"Guides pratiques pour débuter le céto"},
                  {e:"⏱️",t:"Chronomètre de jeûne intermittent"},
                  {e:"⚖️",t:"Suivi du poids"},
                  {e:"🌿",t:"Suivi humeur, énergie, sommeil"},
                  {e:"🚫",t:"Sans publicité"},
                  {e:"🔒",t:"Tes données restent sur ton téléphone — aucun compte requis"},
                  {e:"💙",t:"Créée par une association, pour toi"},
                ].map((item,i)=>(
                  <div key={i} style={{display:"flex",gap:10,alignItems:"center",marginBottom:i<3?8:0}}>
                    <span style={{fontSize:16}}>{item.e}</span>
                    <span style={{fontSize:12,fontWeight:700,color:"#1B3A6B"}}>{item.t}</span>
                  </div>
                ))}
              </div>
              <div style={{background:"#FFF8F0",border:"2px solid #F4A03530",borderRadius:10,padding:12,fontSize:11,color:"#E65100",lineHeight:1.6}}>
                ⚕️ <strong>Information médicale :</strong> Cette app ne remplace pas un médecin. Consulte ton médecin avant de démarrer le céto, surtout si tu as une pathologie ou prends des médicaments.
              </div>
            </div>
          )}

          {/* ── ÉCRAN 2 : Ce que l'app fait pour toi ── */}
          {onboardingStep===1 && (
            <div>
              <div style={{textAlign:"center",marginBottom:20}}>
                <div style={{fontSize:36,marginBottom:8}}>💪</div>
                <h2 style={{fontSize:20,fontWeight:900,color:"#1B3A6B",margin:"0 0 6px"}}>Ce que je fais pour toi</h2>
                <p style={{fontSize:12,color:"#6B7280",margin:0}}>Tout ce dont tu as besoin, au même endroit</p>
              </div>
              {[
                {e:"📔",t:"Suivre tes glucides",d:`Journal quotidien avec ${ALIMENTS.length} aliments certifiés ANSES`,c:"#1B3A6B", premium:false},
                {e:"🎯",t:"Calculer tes macros",d:"Objectifs personnalisés selon ton corps réel",c:"#7CB342", premium:false},
                {e:"✨",t:"Mes menus sur mesure",d:"Plan 7 jours personnalisé selon ton régime et tes goûts",c:"#E65100", premium:true},
                {e:"🥦",t:"Trouver les bons aliments",d:`${ALIMENTS.length} aliments triés du moins au plus glucidique`,c:"#F4A035", premium:false},
                {e:"📷",t:"Scanner un produit",d:"Scanne le code-barres pour savoir si c'est céto",c:"#2A5298", premium:true},
                {e:"📖",t:"T'accompagner",d:"Guides pratiques pour réussir dès le premier jour",c:"#6A1B9A", premium:false},
              ].filter(f => !f.premium || PREMIUM_ACTIF).map((f,i)=>(
                <div key={i} style={{display:"flex",gap:12,alignItems:"center",padding:"10px 12px",background:i%2===0?"#FAFAF7":"#fff",borderRadius:10,marginBottom:6,border:`1.5px solid ${f.c}15`}}>
                  <span style={{fontSize:22,flexShrink:0}}>{f.e}</span>
                  <div>
                    <div style={{fontSize:12,fontWeight:900,color:f.c}}>{f.t}</div>
                    <div style={{fontSize:10,color:"#6B7280"}}>{f.d}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* ── ÉCRAN 3 : Créer son profil ── */}
          {onboardingStep===2 && (
            <div>
              <div style={{textAlign:"center",marginBottom:16}}>
                <div style={{fontSize:36,marginBottom:8}}>👤</div>
                <h2 style={{fontSize:20,fontWeight:900,color:"#1B3A6B",margin:"0 0 6px"}}>Crée ton profil</h2>
                <p style={{fontSize:11,color:"#6B7280",margin:0}}>Pour des objectifs calculés sur mesure pour toi</p>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
                <div style={{gridColumn:"1/-1"}}>
                  <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B",marginBottom:4}}>Prénom</div>
                  <input value={profilForm.prenom} onChange={e=>setProfilForm(f=>({...f,prenom:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="Ton prénom" style={{width:"100%",padding:"10px 12px",border:"2px solid #1B3A6B20",borderRadius:8,fontSize:13,outline:"none",fontFamily:"inherit"}}/>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B",marginBottom:4}}>Sexe</div>
                  <select value={profilForm.sexe} onChange={e=>setProfilForm(f=>({...f,sexe:e.target.value}))} style={{width:"100%",padding:"10px 12px",border:"2px solid #1B3A6B20",borderRadius:8,fontSize:13,outline:"none",background:"#fff",fontFamily:"inherit"}}>
                    <option value="F">Femme</option>
                    <option value="M">Homme</option>
                  </select>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B",marginBottom:4}}>Âge</div>
                  <input type="number" min="15" max="100" value={profilForm.age} onChange={e=>setProfilForm(f=>({...f,age:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="ex: 35" style={{width:"100%",padding:"10px 12px",border:"2px solid #1B3A6B20",borderRadius:8,fontSize:13,outline:"none",fontFamily:"inherit"}}/>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B",marginBottom:4}}>Poids (kg)</div>
                  <input type="number" min="30" max="300" value={profilForm.poids} onChange={e=>setProfilForm(f=>({...f,poids:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="ex: 75" style={{width:"100%",padding:"10px 12px",border:"2px solid #1B3A6B20",borderRadius:8,fontSize:13,outline:"none",fontFamily:"inherit"}}/>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B",marginBottom:4}}>Taille (cm)</div>
                  <input type="number" min="100" max="250" value={profilForm.taille} onChange={e=>setProfilForm(f=>({...f,taille:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="ex: 168" style={{width:"100%",padding:"10px 12px",border:"2px solid #1B3A6B20",borderRadius:8,fontSize:13,outline:"none",fontFamily:"inherit"}}/>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B",marginBottom:4}}>Niveau d'activité</div>
                  <select value={profilForm.activite} onChange={e=>setProfilForm(f=>({...f,activite:e.target.value}))} style={{width:"100%",padding:"10px 12px",border:"2px solid #1B3A6B20",borderRadius:8,fontSize:13,outline:"none",background:"#fff",fontFamily:"inherit"}}>
                    <option value="1.2">Sédentaire (bureau, peu de sport)</option>
                    <option value="1.375">Légèrement actif (marche, sport léger)</option>
                    <option value="1.55">Soutenu à intense (sport régulier)</option>
                    <option value="1.725">Très intense (sport quotidien)</option>
                    <option value="1.9">Athlète (2x/jour)</option>
                  </select>
                </div>
              </div>
              {macrosPreview && (
                <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:12,padding:14,color:"#fff",textAlign:"center"}}>
                  <div style={{fontSize:11,fontWeight:800,marginBottom:8,opacity:.9}}>✨ Tes objectifs personnalisés</div>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
                    {[{l:"Lipides",v:macrosPreview.lip,u:"g",c:"#FFB74D"},{l:"Glucides",v:macrosPreview.glu,u:"g",c:"#EF9A9A"},{l:"Protéines",v:macrosPreview.pro,u:"g",c:"#90CAF9"}].map(m=>(
                      <div key={m.l} style={{background:"rgba(255,255,255,.15)",borderRadius:8,padding:"8px 4px"}}>
                        <div style={{fontSize:18,fontWeight:900,color:m.c}}>{m.v}<span style={{fontSize:11}}>{m.u}</span></div>
                        <div style={{fontSize:9,opacity:.8}}>{m.l}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!profilComplet && (
                <div style={{textAlign:"center",fontSize:10,color:"#9ca3af",marginTop:8}}>
                  Remplis tous les champs pour voir tes objectifs 👆
                </div>
              )}
            </div>
          )}

          {/* ── ÉCRAN 4 : Ouvrir le journal ── */}
          {onboardingStep===3 && (
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:52,marginBottom:12}}>🚀</div>
              <h2 style={{fontSize:22,fontWeight:900,color:"#1B3A6B",margin:"0 0 10px"}}>
                {profilForm.prenom ? `Prête ${profilForm.prenom} ? 🥑` : "C'est parti ! 🥑"}
              </h2>
              <p style={{fontSize:13,color:"#6B7280",lineHeight:1.7,margin:"0 0 20px"}}>
                Ton journal t'attend. Note ton premier repas aujourd'hui et commence à voir tes glucides en temps réel.
              </p>
              <div style={{background:"#F1F8E9",border:"2px solid #7CB34230",borderRadius:14,padding:16,marginBottom:20}}>
                {[
                  "📔 Note tes repas chaque jour",
                  "🎯 Reste sous 20g de glucides",
                  "💚 Écoute ton corps",
                  "🤝 La communauté est là si tu as besoin",
                ].map((t,i)=>(
                  <div key={i} style={{fontSize:12,fontWeight:700,color:"#2E7D32",marginBottom:i<3?8:0,textAlign:"left"}}>{t}</div>
                ))}
              </div>
              <div style={{background:"#FFF8F0",border:"2px solid #F4A03530",borderRadius:10,padding:10,fontSize:10,color:"#E65100",lineHeight:1.6,marginBottom:16}}>
                ℹ️ Pour améliorer l'app, nous comptons anonymement le nombre d'ouvertures. Aucune donnée personnelle n'est collectée.
              </div>
              <button onClick={handleFinish} style={{width:"100%",padding:"14px",borderRadius:12,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:15,cursor:"pointer",boxShadow:"0 4px 16px rgba(124,179,66,.4)"}}>
                📔 Ouvrir mon journal →
              </button>
            </div>
          )}

          {/* Boutons nav */}
          <div style={{display:"flex",gap:10,justifyContent:"space-between",alignItems:"center",marginTop:20}}>
            {onboardingStep>0
              ? <button onClick={()=>setOnboardingStep(s=>s-1)} style={{padding:"10px 18px",borderRadius:10,border:"2px solid #E5E7EB",background:"#fff",color:"#6B7280",fontWeight:700,fontSize:13,cursor:"pointer"}}>← Retour</button>
              : <div/>
            }
            {!isLast && (
              <button onClick={()=>setOnboardingStep(s=>s+1)}
                style={{padding:"12px 28px",borderRadius:10,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:14,cursor:"pointer",boxShadow:"0 4px 12px rgba(124,179,66,.3)"}}>
                Suivant →
              </button>
            )}
          </div>

          {!isLast && (
            <div style={{textAlign:"center",marginTop:12}}>
              <button onClick={handleFinish} style={{background:"none",border:"none",color:"#9ca3af",fontSize:11,cursor:"pointer",textDecoration:"underline"}}>
                Passer l'introduction
              </button>
            </div>
          )}
        </div>

        <div style={{marginTop:14,fontSize:10,color:"#9ca3af",textAlign:"center"}}>
          🤝 Association loi 1901 · Aucune pub · Données sur ton appareil · © 2026 Céto Club
        </div>
      </div>
    );
  }

  return (
    <div style={{minHeight:"100vh",background:"#FAFAF7",fontFamily:"'Nunito',sans-serif",color:"#1a2a1a",overflowX:"hidden",maxWidth:"100vw"}}>
      <style>{"@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600;700;800;900&display=swap');*{box-sizing:border-box}html,body{overflow-x:hidden;max-width:100vw}input,select{font-family:inherit}.row:hover{background:#F1F8E9!important;transform:translateY(-1px)}.row{transition:all .15s}#root{overflow-x:hidden;max-width:100vw}@media(max-width:480px){.grid-2col{grid-template-columns:1fr!important}.grid-resp{grid-template-columns:1fr!important}}"}</style>

      {/* Modal sélection du nombre de parts */}
      {recettePortionModal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:10000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{background:"#fff",borderRadius:16,padding:24,maxWidth:340,width:"100%",boxShadow:"0 8px 32px rgba(0,0,0,0.2)"}}>
            <div style={{fontSize:16,fontWeight:900,color:"#1B3A6B",marginBottom:4}}>📔 Ajouter au journal</div>
            <div style={{fontSize:13,fontWeight:700,color:"#374151",marginBottom:16}}>{recettePortionModal.rec.nom}</div>
            <div style={{fontSize:11,color:"#6B7280",marginBottom:8}}>Cette recette fait <strong>{recettePortionModal.rec.portions} parts</strong>. Combien de parts as-tu mangé ?</div>
            <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
              {[0.5,1,1.5,2,3].map(n => (
                <button key={n} onClick={()=>setRecettePortionModal(m=>({...m,nbParts:n}))}
                  style={{padding:"8px 14px",borderRadius:10,fontSize:13,fontWeight:800,cursor:"pointer",
                    background:recettePortionModal.nbParts===n?"#1B3A6B":"#F3F4F6",
                    color:recettePortionModal.nbParts===n?"#fff":"#374151",
                    border:`2px solid ${recettePortionModal.nbParts===n?"#1B3A6B":"#E5E7EB"}`}}>
                  {n === 0.5 ? "½" : n}
                </button>
              ))}
            </div>
            <div style={{fontSize:11,color:"#6B7280",marginBottom:8}}>À quel repas l'ajouter ?</div>
            <div style={{display:"flex",gap:8,marginBottom:16}}>
              {[1,2,3].map(num => (
                <button key={num} onClick={()=>setRecettePortionModal(m=>({...m,repasNum:num}))}
                  style={{flex:1,padding:"8px 10px",borderRadius:10,fontSize:12,fontWeight:800,cursor:"pointer",
                    background:(recettePortionModal.repasNum||1)===num?"#1B3A6B":"#F3F4F6",
                    color:(recettePortionModal.repasNum||1)===num?"#fff":"#374151",
                    border:`2px solid ${(recettePortionModal.repasNum||1)===num?"#1B3A6B":"#E5E7EB"}`}}>
                  {num===1?"🌅":num===2?"☀️":"🌙"} Repas {num}
                </button>
              ))}
            </div>
            <div style={{fontSize:11,color:"#6B7280",marginBottom:16,background:"#F3F4F6",borderRadius:8,padding:"8px 12px"}}>
              {(()=>{
                const m = recettePortionModal.rec.macros.portion;
                const n = recettePortionModal.nbParts;
                return `Lip: ${(m.lip*n).toFixed(1)}g · Glu: ${(m.glu*n).toFixed(1)}g · Pro: ${(m.pro*n).toFixed(1)}g`;
              })()}
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setRecettePortionModal(null)}
                style={{flex:1,padding:10,borderRadius:10,background:"#F3F4F6",border:"none",fontWeight:800,fontSize:12,cursor:"pointer",color:"#374151"}}>
                Annuler
              </button>
              <button onClick={confirmerRecetteAuJournal}
                style={{flex:2,padding:10,borderRadius:10,background:"linear-gradient(135deg,#1B3A6B,#2A5298)",border:"none",fontWeight:800,fontSize:12,cursor:"pointer",color:"#fff"}}>
                ✅ Ajouter {recettePortionModal.nbParts === 0.5 ? "½ part" : `${recettePortionModal.nbParts} part${recettePortionModal.nbParts>1?"s":""}`}
              </button>
            </div>
          </div>
        </div>
      )}

      {carteRecette && (()=>{
        const rec = carteRecette;
        const sc = score(rec.macros.portion.glu);
        return (
          <div style={{position:"fixed",inset:0,background:"#fff",zIndex:9999,overflowY:"auto"}}>
            {/* CARTE SEULE — faire la capture d'écran ici */}
            <div style={{padding:"20px 16px",maxWidth:480,margin:"0 auto"}}>
              {/* Header bleu */}
              <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:"16px 16px 0 0",padding:"20px 22px 16px"}}>
                <div style={{fontSize:13,fontWeight:800,marginBottom:4}}>
                  <span style={{color:"#fff"}}>Recette de </span>
                  <span style={{color:"#F4A035"}}>{profil?.prenom || "céto"}</span>
                </div>
                <div style={{fontFamily:"Georgia,serif",fontSize:24,fontWeight:700,color:"#fff",lineHeight:1.2,marginBottom:10}}>{rec.nom}</div>
                <div style={{display:"flex",gap:8}}>
                  <span style={{background:"#ffffff20",color:"#fff",padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{rec.portions} portion{rec.portions>1?"s":""}</span>
                  <span style={{background:"#ffffff20",color:"#fff",padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700}}>{rec.ingredients.length} ingrédient{rec.ingredients.length>1?"s":""}</span>
                </div>
              </div>
              {/* Macros */}
              <div style={{background:"#FAFAF7",padding:"16px 22px 12px",borderLeft:"1px solid #eee",borderRight:"1px solid #eee"}}>
                <div style={{fontSize:10,color:"#9CA3AF",fontWeight:800,letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>Pour une portion</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:10}}>
                  {[{l:"Lipides",v:rec.macros.portion.lip,c:"#E65100",bg:"#FFF8F0"},{l:"Glucides",v:rec.macros.portion.glu,c:"#C62828",bg:"#FFF0F0"},{l:"Protéines",v:rec.macros.portion.pro,c:"#2A5298",bg:"#F0F4FF"}].map(m=>(
                    <div key={m.l} style={{background:m.bg,borderRadius:10,padding:10,textAlign:"center"}}>
                      <div style={{fontSize:22,fontWeight:900,color:m.c}}>{m.v.toFixed(1)}g</div>
                      <div style={{fontSize:10,color:"#9CA3AF",fontWeight:700}}>{m.l}</div>
                    </div>
                  ))}
                </div>
                <div style={{background:sc.bg,borderRadius:8,padding:"8px 14px",textAlign:"center",fontSize:13,fontWeight:900,color:sc.c}}>Score céto par portion : {sc.l}</div>
              </div>
              {/* Ingrédients */}
              <div style={{background:"#FAFAF7",padding:"12px 22px",borderLeft:"1px solid #eee",borderRight:"1px solid #eee"}}>
                <div style={{fontSize:10,color:"#9CA3AF",fontWeight:800,letterSpacing:1,textTransform:"uppercase",marginBottom:8}}>🥦 Ingrédients</div>
                {rec.ingredients.map((ing,i)=>(
                  <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"1px solid #F3F4F6"}}>
                    <span style={{fontSize:13,color:"#374151",fontWeight:700}}>• {ing.nom.trim()}</span>
                    <span style={{fontSize:13,fontWeight:900,color:"#7CB342"}}>{ing.gram}g</span>
                  </div>
                ))}
                {rec.description && (
                  <div style={{marginTop:12}}>
                    <div style={{fontSize:10,color:"#9CA3AF",fontWeight:800,letterSpacing:1,textTransform:"uppercase",marginBottom:6}}>📝 Préparation</div>
                    <div style={{fontSize:13,color:"#374151",lineHeight:1.6}}>{rec.description}</div>
                  </div>
                )}
              </div>
              {/* Footer */}
              <div style={{background:"#1B3A6B",borderRadius:"0 0 16px 16px",padding:"12px 22px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span style={{color:"#fff",fontSize:12,fontWeight:700}}>via <strong>Céto Club</strong> · app gratuite</span>
                <span style={{color:"#F4A035",fontSize:12,fontWeight:800}}>app.cetoclub.com</span>
              </div>
            </div>
            {/* Bouton fermer — EN BAS, hors de la carte */}
            <div style={{textAlign:"center",padding:"24px 16px 40px"}}>
              <div style={{background:"#1B3A6B",color:"#fff",borderRadius:10,padding:"10px 20px",fontSize:12,fontWeight:800,marginBottom:16,display:"inline-block"}}>
                📸 Fais la capture maintenant, puis clique Fermer
              </div>
              <br/>
              <button onClick={()=>setCarteRecette(null)} style={{background:"#F3F4F6",color:"#374151",border:"none",borderRadius:10,padding:"12px 32px",fontWeight:800,fontSize:14,cursor:"pointer"}}>
                ✕ Fermer
              </button>
            </div>
          </div>
        );
      })()}

      {toastRecette === "clipboard" && (
        <div style={{position:"fixed",bottom:80,left:"50%",transform:"translateX(-50%)",background:"#1B3A6B",color:"#fff",padding:"12px 24px",borderRadius:12,fontWeight:800,fontSize:13,zIndex:9999,boxShadow:"0 4px 20px rgba(0,0,0,.3)",whiteSpace:"nowrap"}}>
          🖼️ Image copiée ! Colle-la sur Facebook avec Ctrl+V 🥑
        </div>
      )}

      {carteRecetteUrl && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:9999,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{color:"#fff",fontWeight:900,fontSize:15,marginBottom:14,textAlign:"center"}}>
            📱 Appuie longtemps sur l'image → "Enregistrer"<br/>
            <span style={{fontWeight:400,fontSize:12,opacity:.8}}>puis partage-la sur Facebook depuis ta galerie</span>
          </div>
          <img
            src={carteRecetteUrl}
            alt="Carte recette"
            style={{maxWidth:"100%",maxHeight:"70vh",borderRadius:12,boxShadow:"0 8px 40px rgba(0,0,0,.5)"}}
          />
          <button
            onClick={()=>{ URL.revokeObjectURL(carteRecetteUrl); setCarteRecetteUrl(null); }}
            style={{marginTop:20,background:"#fff",color:"#1B3A6B",border:"none",borderRadius:10,padding:"12px 32px",fontWeight:900,fontSize:14,cursor:"pointer"}}
          >
            ✕ Fermer
          </button>
        </div>
      )}

      <header style={{background:"#fff",borderBottom:"2px solid #1B3A6B15",position:"sticky",top:0,zIndex:100,boxShadow:"0 2px 10px rgba(27,58,107,.08)"}}>
        {/* Logo + titre */}
        <div style={{padding:"6px 12px",display:"flex",alignItems:"center",gap:8,borderBottom:"1px solid #F3F4F6"}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div onClick={handleLogoClic} style={{cursor:"pointer",position:"relative",userSelect:"none"}}>
              <AvocatLogo size={36}/>
              {logoClicks > 0 && !PREMIUM_ACTIF && (
                <div style={{position:"absolute",top:-6,right:-6,background:"#1B3A6B",color:"#fff",borderRadius:"50%",width:16,height:16,fontSize:9,fontWeight:900,display:"flex",alignItems:"center",justifyContent:"center"}}>{logoClicks}</div>
              )}
              {PREMIUM_ACTIF && premiumLocal && (
                <div style={{position:"absolute",top:-4,right:-4,fontSize:12}}>✨</div>
              )}
            </div>
            <div onClick={()=>setPage("journal")} style={{cursor:"pointer",fontSize:16,fontWeight:900,color:"#1B3A6B"}}>Céto Club</div>
          </div>          {!dejaInstallee && <button onClick={clicBoutonInstaller} style={{marginLeft:"auto",padding:"6px 12px",borderRadius:8,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:800,fontSize:11,cursor:"pointer",boxShadow:"0 2px 6px rgba(124,179,66,0.35)"}}>📲 Installer l'app</button>}
        </div>
        {/* Navigation principale — 2 lignes sur mobile */}
        <div style={{padding:"6px 8px",display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:4}}>
          {[
            {g:"moi",      l:"👤",  t:"Moi",       def:"profil"},
            {g:"journal",  l:"📔",  t:"Journal",    def:"journal"},
            {g:"aliments", l:"🍽️",  t:"Mes repas",  def:"aliments"},
            {g:"guides",   l:"📖",  t:"Guides",     def:"pratiques"},
          ].map(t=>{
            const active = getNavGroup(page)===t.g;
            return (
              <button key={t.g} onClick={()=>setPage(t.def)}
                style={{padding:"6px 4px",borderRadius:10,fontWeight:800,fontSize:10,border:"none",background:active?(t.g==="premium"?"linear-gradient(135deg,#F4A035,#E65100)":"#1B3A6B"):"#F3F4F6",color:active?"#fff":"#6B7280",cursor:"pointer",transition:"all .15s",display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
                <span style={{fontSize:18}}>{t.l}</span>
                <span>{t.t}</span>
              </button>
            );
          })}
        </div>
        {/* Sous-navigation contextuelle */}

        {getNavGroup(page)==="aliments" && (
          <div style={{padding:"8px 12px",display:"flex",justifyContent:"center",gap:6,background:"#F8FAFF",borderTop:"1px solid #F3F4F6"}}>
            {[
              {id:"aliments", l:"🥦 Aliments",  premium:false},
              {id:"produits", l:"🏷️ Produits",  premium:false},
              {id:"recettes", l:"🍳 Recettes",  premium:false},
              {id:"plan7j",   l:"✨ Mes menus", premium:true},
            ].filter(t => !t.premium || PREMIUM_ACTIF).concat(!PREMIUM_ACTIF?[{id:"premium",l:"✨ Menus",premium:true,redirect:true}]:[]).map(t=>(
              <button key={t.id} onClick={()=>setPage(t.redirect?"premium":t.id)}
                style={{padding:"8px 20px",borderRadius:10,fontWeight:700,fontSize:12,
                  border:`1.5px solid ${page===t.id?(t.premium?"#F4A035":"#1B3A6B"):t.premium?"#F4A03560":"#E5E7EB"}`,
                  background:page===t.id?(t.premium?"linear-gradient(135deg,#F4A035,#E65100)":"#1B3A6B"):t.premium?"#FFF3E0":"#fff",
                  color:page===t.id?"#fff":t.premium?"#E65100":"#6B7280",
                  cursor:"pointer",textAlign:"center",position:"relative"}}>
                {t.l}
              </button>
            ))}
          </div>
        )}
      </header>

      {page==="aliments" && (
        <main style={{maxWidth:1100,margin:"0 auto",padding:"16px 12px",overflowX:"hidden",boxSizing:"border-box",width:"100%"}}>
          <div style={{textAlign:"center",marginBottom:4}}><span style={{fontSize:10,color:"#7CB342",fontWeight:700,letterSpacing:2,textTransform:"uppercase"}}>🔬 Base Ciqual ANSES · {ALIMENTS.length} aliments officiels</span></div>
          <div style={{textAlign:"center",marginBottom:20}}>
            <h1 style={{fontSize:28,fontWeight:900,color:"#1B3A6B",margin:"0 0 4px"}}>Aliments & Boissons Cétogènes</h1>
            <p style={{color:"#6B7280",fontSize:13,margin:0}}>{ALIMENTS.length} aliments · ANSES Ciqual · Pour 100g</p>
          </div>
          <div style={{display:"flex",gap:7,marginBottom:16,flexWrap:"wrap"}}>
            {[
              {l:"0 glucide",c:"#1565C0",bg:"#E3F2FD",n:ALIMENTS.filter(a=>isZero(a)).length},
              {l:"Excellent ≤1g",c:"#2E7D32",bg:"#E8F5E9",n:ALIMENTS.filter(a=>!isZero(a)&&a.glu<=1).length},
              {l:"Très bien ≤3g",c:"#7CB342",bg:"#F1F8E9",n:ALIMENTS.filter(a=>!isZero(a)&&a.glu>1&&a.glu<=3).length},
              {l:"Modéré ≤6g",c:"#F4A035",bg:"#FFF8F0",n:ALIMENTS.filter(a=>!isZero(a)&&a.glu>3&&a.glu<=6).length},
              {l:"Attention >6g",c:"#C62828",bg:"#FFEBEE",n:ALIMENTS.filter(a=>!isZero(a)&&a.glu>6).length},
            ].map(s=>(
              <div key={s.l} style={{flex:1,minWidth:85,background:s.bg,borderRadius:8,border:`1.5px solid ${s.c}20`,padding:"7px 10px",display:"flex",alignItems:"center",gap:6}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:s.c}}/>
                <div><div style={{fontSize:16,fontWeight:900,color:s.c}}>{s.n}</div><div style={{fontSize:9,color:"#6B7280",fontWeight:600}}>{s.l}</div></div>
              </div>
            ))}
          </div>
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            <div style={{flex:1,position:"relative"}}>
              <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:14}}>🔍</span>
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Rechercher un aliment…" style={{width:"100%",padding:"10px 10px 10px 32px",border:"2px solid #1B3A6B15",borderRadius:8,fontSize:13,outline:"none",background:"#fff"}} onFocus={e=>e.target.style.borderColor="#7CB342"} onBlur={e=>e.target.style.borderColor="#7CB34215"}/>
              {search && <button onClick={()=>setSearch("")} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",fontSize:16,color:"#9ca3af"}}>✕</button>}
            </div>
          </div>
          <div style={{display:"flex",gap:14,alignItems:"flex-start"}}>
            <div style={{flex:1}}>
              <div style={{display:"grid",gridTemplateColumns:"4px 1fr 38px 44px 38px 58px",gap:4,padding:"4px 10px",marginBottom:2,color:"#6B7280",fontSize:9,fontWeight:800,textTransform:"uppercase",letterSpacing:.6,minWidth:0}}>
                <div/><div>Aliment</div><div style={{textAlign:"center"}}>Lip.</div><div style={{textAlign:"center"}}>Glu.</div><div style={{textAlign:"center"}}>Pro.</div><div style={{textAlign:"center"}}>Score</div>
              </div>
              {search.trim() ? (
                // Mode recherche — liste plate
                <div style={{display:"flex",flexDirection:"column",gap:3}}>
                  {filtered.map(a=>{
                    const z=isZero(a), s=score(a.glu,a.note), isSel=sel?.id===a.id;
                    return (
                      <div key={a.id} onClick={()=>{setSel(a);setG(100)}} style={{display:"grid",gridTemplateColumns:"4px 1fr 38px 44px 38px 58px",gap:4,alignItems:"center",padding:"8px 10px",background:isSel?"#1B3A6B":"#fff",border:`1.5px solid ${isSel?"#1B3A6B":"#1B3A6B10"}`,borderRadius:8,cursor:"pointer"}}>
                        <div style={{width:7,height:7,borderRadius:"50%",background:s.c}}/>
                        <div>
                          <div style={{fontSize:12,fontWeight:800,color:isSel?"#fff":"#1B3A6B"}}>{a.nom}</div>
                          {a.note&&<div style={{fontSize:9,color:isSel?"#aaccee":"#F4A035",fontStyle:"italic"}}>{a.note}</div>}
                        </div>
                        <div style={{textAlign:"center",fontSize:12,fontWeight:800,color:isSel?"#fff":"#E65100"}}>{a.lip}<span style={{fontSize:9,color:isSel?"#aac":"#9ca3af"}}>g</span></div>
                        <div style={{textAlign:"center"}}>{z?<span style={{fontSize:9,fontWeight:800,color:isSel?"#fff":"#1565C0",background:isSel?"rgba(255,255,255,.15)":"#E3F2FD",padding:"1px 4px",borderRadius:3}}>non compté</span>:<span style={{fontSize:12,fontWeight:800,color:isSel?"#fff":"#C62828"}}>{a.glu}<span style={{fontSize:9,color:isSel?"#aac":"#9ca3af"}}>g</span></span>}</div>
                        <div style={{textAlign:"center",fontSize:12,fontWeight:800,color:isSel?"#fff":"#2A5298"}}>{a.pro}<span style={{fontSize:9,color:isSel?"#aac":"#9ca3af"}}>g</span></div>
                        <div style={{textAlign:"center",padding:"2px 4px",background:isSel?"rgba(255,255,255,.12)":s.bg,border:`1px solid ${s.c}25`,borderRadius:4,fontSize:9,fontWeight:800,color:isSel?"#fff":s.c}}>{s.l}</div>
                      </div>
                    );
                  })}
                  {filtered.length===0&&<div style={{textAlign:"center",padding:40,color:"#6B7280"}}><div style={{fontSize:32}}>🥦</div><div style={{fontWeight:800,marginTop:8}}>Aucun résultat</div></div>}
                </div>
              ) : (
                // Mode catégories — groupé
                <div style={{display:"flex",flexDirection:"column",gap:0}}>
                  {CATS.filter(c=>c!=="Toutes").map(categorie => {
                    const items = ALIMENTS.filter(a => a.cat.trim() === categorie.trim());
                    if(items.length===0) return null;
                    const ouvert = !!catOpen[categorie];
                    return (
                      <div key={categorie} style={{marginBottom:8,borderRadius:10,overflow:"hidden",boxShadow:"0 1px 6px rgba(27,58,107,0.07)"}}>
                        <button onClick={()=>setCatOpen(o=>({...o,[categorie]:!o[categorie]}))}
                          style={{width:"100%",padding:"11px 14px",background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:12,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:ouvert?"10px 10px 0 0":10,letterSpacing:.3,textTransform:"uppercase"}}>
                          <span>{categorie} <span style={{opacity:.75,fontWeight:600}}>({items.length})</span></span>
                          <span style={{fontSize:12,opacity:0.8}}>{ouvert?"▲":"▼"}</span>
                        </button>
                        {ouvert && (
                          <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 10px 10px",padding:"6px 8px",display:"flex",flexDirection:"column",gap:3}}>
                            {items.map(a=>{
                              const z=isZero(a), s=score(a.glu,a.note), isSel=sel?.id===a.id;
                              return (
                                <div key={a.id} onClick={()=>{setSel(a);setG(100)}} style={{display:"grid",gridTemplateColumns:"4px 1fr 38px 44px 38px 58px",gap:4,alignItems:"center",padding:"8px 10px",background:isSel?"#1B3A6B":"#fff",border:`1.5px solid ${isSel?"#1B3A6B":"#1B3A6B10"}`,borderRadius:8,cursor:"pointer"}}>
                                  <div style={{width:7,height:7,borderRadius:"50%",background:s.c}}/>
                                  <div>
                                    <div style={{fontSize:12,fontWeight:800,color:isSel?"#fff":"#1B3A6B"}}>{a.nom}</div>
                                    {a.note&&<div style={{fontSize:9,color:isSel?"#aaccee":"#F4A035",fontStyle:"italic"}}>{a.note}</div>}
                                  </div>
                                  <div style={{textAlign:"center",fontSize:12,fontWeight:800,color:isSel?"#fff":"#E65100"}}>{a.lip}<span style={{fontSize:9,color:isSel?"#aac":"#9ca3af"}}>g</span></div>
                                  <div style={{textAlign:"center"}}>{z?<span style={{fontSize:9,fontWeight:800,color:isSel?"#fff":"#1565C0",background:isSel?"rgba(255,255,255,.15)":"#E3F2FD",padding:"1px 4px",borderRadius:3}}>non compté</span>:<span style={{fontSize:12,fontWeight:800,color:isSel?"#fff":"#C62828"}}>{a.glu}<span style={{fontSize:9,color:isSel?"#aac":"#9ca3af"}}>g</span></span>}</div>
                                  <div style={{textAlign:"center",fontSize:12,fontWeight:800,color:isSel?"#fff":"#2A5298"}}>{a.pro}<span style={{fontSize:9,color:isSel?"#aac":"#9ca3af"}}>g</span></div>
                                  <div style={{textAlign:"center",padding:"2px 4px",background:isSel?"rgba(255,255,255,.12)":s.bg,border:`1px solid ${s.c}25`,borderRadius:4,fontSize:9,fontWeight:800,color:isSel?"#fff":s.c}}>{s.l}</div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

            </div>

            {sel&&(()=>{
              const z=isZero(sel), s=score(sel.glu,sel.note);
              return (
                <>
                  {/* Fond sombre */}
                  <div onClick={()=>setSel(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",zIndex:200}}/>
                  {/* Bottom sheet */}
                  <div style={{position:"fixed",bottom:0,left:0,right:0,background:"#fff",borderRadius:"16px 16px 0 0",padding:"16px 16px 32px",zIndex:201,boxShadow:"0 -4px 32px rgba(27,58,107,.18)",maxHeight:"80vh",overflowY:"auto"}}>
                    {/* Barre de drag */}
                    <div style={{width:40,height:4,borderRadius:2,background:"#E5E7EB",margin:"0 auto 14px"}}/>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
                      <div style={{flex:1}}>
                        <div style={{fontSize:16,fontWeight:900,color:"#1B3A6B"}}>{sel.nom}</div>
                        <div style={{fontSize:10,color:"#6B7280",marginTop:2}}>{sel.cat}</div>
                        {sel.note&&<div style={{fontSize:10,color:"#F4A035",marginTop:2,fontStyle:"italic"}}>{sel.note}</div>}
                      </div>
                      <button onClick={()=>setSel(null)} style={{background:"none",border:"none",fontSize:20,color:"#6B7280",cursor:"pointer",padding:0}}>✕</button>
                    </div>
                    <div style={{background:s.bg,border:`1.5px solid ${s.c}30`,borderRadius:8,padding:"7px 10px",marginBottom:14,display:"flex",alignItems:"center",gap:6}}>
                      <div style={{width:8,height:8,borderRadius:"50%",background:s.c}}/>
                      <span style={{color:s.c,fontWeight:800,fontSize:12}}>Score : {s.l}</span>
                    </div>
                    {!z&&<div style={{marginBottom:14}}>
                      <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                        <span style={{fontSize:11,color:"#6B7280",fontWeight:700}}>Quantité</span>
                        <span style={{fontSize:15,fontWeight:900,color:"#1B3A6B"}}>{g}g</span>
                      </div>
                      <input type="range" min={5} max={500} step={5} value={g} onChange={e=>setG(+e.target.value)} style={{width:"100%",accentColor:"#1B3A6B"}}/>
                    </div>}
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:10}}>
                      {[{l:"Lipides",v:z?"0":calc(sel.lip),c:"#E65100",e:"🧈"},{l:"Glucides",v:z?"non compté":calc(sel.glu),c:z?"#1565C0":"#C62828",e:"🌾"},{l:"Protéines",v:z?"0":calc(sel.pro),c:"#2A5298",e:"💪"}].map(m=>(
                        <div key={m.l} style={{background:"#F3F4F6",borderRadius:10,padding:"10px 6px",textAlign:"center"}}>
                          <div style={{fontSize:9,color:"#6B7280",fontWeight:700,marginBottom:3}}>{m.e} {m.l}</div>
                          <div style={{fontSize:18,fontWeight:900,color:m.c}}>{m.v}<span style={{fontSize:9,color:"#6B7280"}}>{m.v!=="non compté"?" g":""}</span></div>
                        </div>
                      ))}
                    </div>
                    {!z&&sel.glu>0&&<div style={{padding:"10px 12px",background:"#F1F8E9",borderRadius:8,border:"1.5px solid #7CB34230",marginBottom:10}}>
                      <div style={{fontSize:9,color:"#6B7280",fontWeight:700}}>Ratio lip/glu</div>
                      <div style={{fontSize:20,fontWeight:900,color:"#1B3A6B"}}>{(sel.lip/sel.glu).toFixed(1)}<span style={{fontSize:10,color:"#6B7280",marginLeft:4}}>idéal &gt; 4</span></div>
                    </div>}
                    <div style={{fontSize:9,color:"#ccc",textAlign:"center",marginTop:4}}>Source : ANSES Ciqual 2020</div>
                  </div>
                </>
              );
            })()}
          </div>
        </main>
      )}

      {page==="profil" && (()=>{
        const profilLocal = (()=>{ try { return JSON.parse(localStorage.getItem("cetoclub_profil")||"{}"); } catch { return {}; } })();
        const nbJoursCeto = (()=>{
          const d = profilLocal.debutCeto;
          if (!d) return 0;
          return Math.floor((new Date() - new Date(d)) / 86400000);
        })();
        const bilanDisponible = nbJoursCeto >= 7;
        return (
        <main style={{maxWidth:700,margin:"0 auto",padding:"16px 12px",overflowX:"hidden",boxSizing:"border-box",width:"100%"}}>
          {/* ── ONGLETS MON PROFIL / MON RAPPORT / MON ABONNEMENT ── */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6,marginBottom:20}}>
            <button onClick={()=>setOngletMoi("profil")}
              style={{padding:"10px 8px",borderRadius:10,fontWeight:800,fontSize:12,
                border:`2px solid ${ongletMoi==="profil"?"#1B3A6B":"#E5E7EB"}`,
                background:ongletMoi==="profil"?"#1B3A6B":"#fff",
                color:ongletMoi==="profil"?"#fff":"#6B7280",
                cursor:"pointer",fontFamily:"inherit"}}>
              👤 Mon profil
            </button>
            <button onClick={()=>{ if(PREMIUM_ACTIF) setOngletMoi("bilan"); else setPage("premium"); }}
              style={{padding:"10px 8px",borderRadius:10,fontWeight:800,fontSize:12,
                border:`1.5px solid ${ongletMoi==="bilan"?"#F4A035":"#F4A03560"}`,
                background:ongletMoi==="bilan"?"linear-gradient(135deg,#F4A035,#E65100)":"#FFF3E0",
                color:ongletMoi==="bilan"?"#fff":"#E65100",
                cursor:"pointer",fontFamily:"inherit",textAlign:"center",position:"relative"}}>
              📊 Mon rapport{!PREMIUM_ACTIF?" 💎":""}
            </button>
            <button onClick={()=>setOngletMoi("abonnement")}
              style={{padding:"10px 8px",borderRadius:10,fontWeight:800,fontSize:12,
                border:`2px solid ${ongletMoi==="abonnement"?"#2E7D32":"#E5E7EB"}`,
                background:ongletMoi==="abonnement"?"#2E7D32":"#fff",
                color:ongletMoi==="abonnement"?"#fff":"#6B7280",
                cursor:"pointer",fontFamily:"inherit"}}>
              💙 Soutien & Dons
            </button>
          </div>

          {ongletMoi==="profil" && (<div>

          {/* ── SECTION 1 : Moi ── */}
          <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
            <button onClick={()=>setOpenProfilMoi(!openProfilMoi)} style={{width:"100%",padding:"14px 16px",borderRadius:openProfilMoi?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:16}}>👤</span><span>Moi</span></div>
              <span style={{fontSize:12,opacity:0.8}}>{openProfilMoi?"▲":"▼"}</span>
            </button>
            {openProfilMoi && (
              <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                <div className="grid-2col" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
                  <div>
                    <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:6}}>Prénom</div>
                    <input value={profilForm.prenom} onChange={e=>setProfilForm(f=>({...f,prenom:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="Ton prénom" style={{width:"100%",padding:"11px 14px",border:"2px solid #1B3A6B20",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box"}} onFocus={e=>e.target.style.borderColor="#1B3A6B"} onBlur={e=>e.target.style.borderColor="#1B3A6B20"}/>
                  </div>
                  <div>
                    <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:6}}>Sexe</div>
                    <select value={profilForm.sexe} onChange={e=>setProfilForm(f=>({...f,sexe:e.target.value}))} style={{width:"100%",padding:"11px 14px",border:"2px solid #1B3A6B20",borderRadius:10,fontSize:13,outline:"none",background:"#fff",boxSizing:"border-box"}}>
                      <option value="F">Femme</option>
                      <option value="H">Homme</option>
                    </select>
                  </div>
                  <div>
                    <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:6}}>Âge</div>
                    <input type="number" min="15" max="100" value={profilForm.age} onChange={e=>setProfilForm(f=>({...f,age:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="ex : 35 ans" style={{width:"100%",padding:"11px 14px",border:"2px solid #1B3A6B20",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box"}} onFocus={e=>e.target.style.borderColor="#1B3A6B"} onBlur={e=>e.target.style.borderColor="#1B3A6B20"}/>
                  </div>
                  <div>
                    <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:6}}>Taille (cm)</div>
                    <input type="number" min="100" max="250" value={profilForm.taille} onChange={e=>setProfilForm(f=>({...f,taille:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="ex : 168 cm" style={{width:"100%",padding:"11px 14px",border:"2px solid #1B3A6B20",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box"}} onFocus={e=>e.target.style.borderColor="#1B3A6B"} onBlur={e=>e.target.style.borderColor="#1B3A6B20"}/>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ── SECTION 2 : Mon poids ── */}
          <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
            <button onClick={()=>setOpenProfilPoids(!openProfilPoids)} style={{width:"100%",padding:"14px 16px",borderRadius:openProfilPoids?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:16}}>⚖️</span><span>Mon poids</span></div>
              <span style={{fontSize:12,opacity:0.8}}>{openProfilPoids?"▲":"▼"}</span>
            </button>
            {openProfilPoids && (
              <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                <div className="grid-2col" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
                  <div>
                    <div style={{fontSize:11,fontWeight:800,color:"#7CB342",marginBottom:6}}>Poids actuel (kg)</div>
                    <input type="number" min="30" max="300" value={profilForm.poids} onChange={e=>setProfilForm(f=>({...f,poids:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="ex : 75 kg" style={{width:"100%",padding:"11px 14px",border:"2px solid #7CB34230",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box"}} onFocus={e=>e.target.style.borderColor="#7CB342"} onBlur={e=>e.target.style.borderColor="#7CB34230"}/>
                  </div>
                  <div>
                    <div style={{fontSize:11,fontWeight:800,color:"#7CB342",marginBottom:6}}>🏁 Poids de départ (kg)</div>
                    <input type="number" min="30" max="300" value={profilForm.poidsDepart} onChange={e=>setProfilForm(f=>({...f,poidsDepart:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="ex : 82 kg" style={{width:"100%",padding:"11px 14px",border:"2px solid #7CB34230",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box"}} onFocus={e=>e.target.style.borderColor="#7CB342"} onBlur={e=>e.target.style.borderColor="#7CB34230"}/>
                    <div style={{fontSize:9,color:"#9ca3af",marginTop:3}}>Le jour où tu as commencé</div>
                  </div>
                  <div style={{gridColumn:"1 / -1"}}>
                    <div style={{fontSize:11,fontWeight:800,color:"#F4A035",marginBottom:6}}>🎯 Poids objectif (kg)</div>
                    <input type="number" min="30" max="300" value={profilForm.poidsObjectif} onChange={e=>setProfilForm(f=>({...f,poidsObjectif:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&e.preventDefault()} placeholder="ex : 65 kg" style={{width:"100%",padding:"11px 14px",border:"2px solid #F4A03530",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box"}} onFocus={e=>e.target.style.borderColor="#F4A035"} onBlur={e=>e.target.style.borderColor="#F4A03530"}/>
                    <div style={{fontSize:9,color:"#9ca3af",marginTop:3}}>Ton corps décide du rythme 🥑</div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ── SECTION 3 : Mon activité ── */}
          <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
            <button onClick={()=>setOpenProfilActivite(!openProfilActivite)} style={{width:"100%",padding:"14px 16px",borderRadius:openProfilActivite?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:16}}>🏃</span><span>Mon activité</span></div>
              <span style={{fontSize:12,opacity:0.8}}>{openProfilActivite?"▲":"▼"}</span>
            </button>
            {openProfilActivite && (
              <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
                  <div style={{gridColumn:"1 / -1"}}>
                    <div style={{fontSize:11,fontWeight:800,color:"#F4A035",marginBottom:6}}>Niveau d'activité physique</div>
                    <select value={profilForm.activite} onChange={e=>setProfilForm(f=>({...f,activite:e.target.value}))} style={{width:"100%",padding:"11px 14px",border:"2px solid #F4A03530",borderRadius:10,fontSize:13,outline:"none",background:"#fff",boxSizing:"border-box"}}>
                      <option value="1.2">🪑 Sédentaire (bureau, peu de sport)</option>
                      <option value="1.375">🚶 Légèrement actif (1-3 séances/sem)</option>
                      <option value="1.55">🏃 Soutenu à intense (3-5 séances/sem)</option>
                      <option value="1.725">💪 Très intense (sport quotidien)</option>
                      <option value="1.9">🏆 Athlète (entraînement intense 2x/jour)</option>
                    </select>
                  </div>
                  <div style={{gridColumn:"1 / -1"}}>
                    <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:6}}>📅 Je suis le céto depuis le...</div>
                    <input type="date" value={profilForm.debutCeto} onChange={e=>setProfilForm(f=>({...f,debutCeto:e.target.value}))} max={new Date().toISOString().split("T")[0]} style={{width:"100%",padding:"11px 14px",border:"2px solid #1B3A6B20",borderRadius:10,fontSize:13,outline:"none",boxSizing:"border-box"}}/>
                    <div style={{fontSize:9,color:"#9ca3af",marginTop:3}}>Si tu suis déjà le céto depuis plus de 4 semaines, le jeûne intermittent sera disponible immédiatement</div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ── MES OBJECTIFS — bandeau vert dépliable ── */}
          <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
            <button onClick={()=>setOpenProfilObjectifs(!openProfilObjectifs)} style={{width:"100%",padding:"14px 16px",borderRadius:openProfilObjectifs?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:16}}>🎯</span><span>Mes objectifs</span></div>
              <span style={{fontSize:12,opacity:0.8}}>{openProfilObjectifs?"▲":"▼"}</span>
            </button>
            {openProfilObjectifs && (()=>{ try { return (
              <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>

                <button type="button" onClick={()=>{
                  const p = {...profilForm};
                  if (!p.age||!p.poids||!p.taille) { alert("Merci de remplir âge, poids et taille."); return; }
                  saveProfil(p);
                }} style={{width:"100%",padding:"14px",borderRadius:12,background:"linear-gradient(135deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",fontWeight:900,fontSize:14,cursor:"pointer",marginBottom:16}}>
                  ✓ Calculer & sauvegarder mes objectifs
                </button>

                {profil && (()=>{
                  const macros = calcMacrosProfil(profil);
                  if (!macros) return null;
                  const affichage = choixPremium ? objectifs : macros;
                  const estPersonnalise = choixPremium === "perso";
                  return (
                    <div>
                      <div style={{background:"#F0F4FF",border:"2px solid #1B3A6B20",borderRadius:14,padding:16,marginBottom:14}}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                          <div style={{fontSize:12,fontWeight:900,color:"#1B3A6B",textTransform:"uppercase",letterSpacing:1}}>
                            {profil?.prenom ? `🎯 Objectifs de ${profil.prenom}` : "🎯 Tes objectifs céto personnalisés"}
                          </div>
                          {estPersonnalise && (
                            <div style={{fontSize:9,fontWeight:800,color:"#7CB342",background:"#F1F8E9",borderRadius:10,padding:"3px 8px"}}>✏️ Perso</div>
                          )}
                        </div>
                        <div className="grid-resp" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:14}}>
                          {[
                            {l:"🧈 Lipides",v:affichage.lip,u:"g/j",c:"#F4A035",bg:"#FFF8F0",sub:"lipides céto"},
                            {l:"🌾 Glucides",v:affichage.glu,u:"g/j",c:"#1B3A6B",bg:"#fff",sub:"max cétose"},
                            {l:"💪 Protéines",v:affichage.pro,u:"g/j",c:"#7CB342",bg:"#F1F8E9",sub:"protéines céto"},
                          ].map(m=>(
                            <div key={m.l} style={{background:m.bg,border:`1.5px solid ${m.c}25`,borderRadius:10,padding:12,textAlign:"center"}}>
                              <div style={{fontSize:10,fontWeight:800,color:m.c,marginBottom:4}}>{m.l}</div>
                              <div style={{fontSize:28,fontWeight:900,color:m.c}}>{m.v}<span style={{fontSize:11,color:"#9ca3af"}}>{m.u}</span></div>
                              <div style={{fontSize:9,color:"#9ca3af",marginTop:2}}>{m.sub}</div>
                            </div>
                          ))}
                        </div>
                        <div style={{borderTop:"1px solid #1B3A6B10",paddingTop:10,fontSize:10,color:"#6B7280",lineHeight:1.6,textAlign:"center"}}>
                          💡 Ceci est une indication sécure pour ta santé, mais rien ne remplacera l'écoute de ton corps : faim ou pas faim.
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* ── Bandeau premium : personnaliser ses macros ── */}
                {(()=>{
                  const ms = calcMacrosProfil(profil);
                  if (!ms) return null;
                  const poids = parseFloat(profil.poids||0);
                  // Fourchette perso : min = plancher masse maigre, max = 1.8 x poids reel
                  const minPro = ms.plancherPro;
                  const maxPro = Math.round(1.8 * poids);
                  const minLip = minPro; // jamais lip < pro
                  const maxLip = Math.round(1.5 * maxPro);
                  // Si min >= max (cas très musclé) on fixe max = min
                  const realMaxPro = Math.max(maxPro, minPro);
                  const realMaxLip = Math.max(maxLip, minLip);

                  const bandeauClick = () => {
                    if (!PREMIUM_ACTIF) { setPage("premium"); return; }
                    // Initialiser les sliders sur les objectifs actuels, clampés dans la fourchette
                    const curPro = Math.min(Math.max(objectifs.pro, minPro), realMaxPro);
                    const curLip = Math.min(Math.max(objectifs.lip, minLip), realMaxLip);
                    const curGlu = Math.min(objectifs.glu||20, 20);
                    setObjForm({lip:String(curLip), glu:String(curGlu), pro:String(curPro)});
                    setPremiumMacrosVisible(true);
                  };

                  return (
                    <>
                      {/* Bandeau */}
                      <div onClick={bandeauClick} style={{borderRadius:14,marginTop:12,background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",boxShadow:"0 2px 12px rgba(27,58,107,0.15)"}}>
                        <div>
                          <div style={{fontSize:13,fontWeight:900,color:"#fff"}}>✏️ Personnalise tes macros</div>
                          <div style={{fontSize:10,color:"rgba(255,255,255,0.7)",marginTop:2}}>Ajuste dans ta fourchette personnalisée</div>
                        </div>
                        <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",flexShrink:0}}>
                          <span style={{fontSize:11}}>💎</span>
                          <span style={{fontSize:10,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
                        </div>
                      </div>

                      {/* Modal */}
                      {PREMIUM_ACTIF && premiumMacrosVisible && (
                        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:9999,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={()=>setPremiumMacrosVisible(false)}>
                          <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:"20px 20px 0 0",width:"100%",maxWidth:480,maxHeight:"90vh",overflowY:"auto",paddingBottom:32}}>

                            {/* Header */}
                            <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:"20px 20px 0 0",padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                              <div>
                                <div style={{fontSize:15,fontWeight:900,color:"#fff"}}>✏️ Mes macros personnalisées</div>
                                <div style={{fontSize:10,color:"rgba(255,255,255,0.7)",marginTop:2}}>Ajuste dans ta fourchette sécurisée</div>
                              </div>
                              <button onClick={()=>setPremiumMacrosVisible(false)} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:"50%",width:28,height:28,cursor:"pointer",color:"#fff",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>✕</button>
                            </div>

                            <div style={{padding:"20px 20px 0"}}>

                              {/* Explication fourchette */}
                              <div style={{background:"#F1F8E9",border:"1.5px solid #7CB34230",borderRadius:10,padding:"10px 14px",marginBottom:20,display:"flex",gap:12,alignItems:"center"}}>
                                <div style={{fontSize:20,flexShrink:0}}>🎯</div>
                                <div style={{fontSize:11,color:"#374151",lineHeight:1.6}}>
                                  Ta fourchette est calculée <strong style={{color:"#1B3A6B"}}>pour toi</strong> selon ton profil. Tu ne peux pas descendre en dessous du minimum — mais tu peux aller au-dessus si tu le souhaites.
                                </div>
                              </div>

                              {/* Slider Protéines */}
                              {(()=>{
                                const valPro = parseInt(objForm.pro)||minPro;
                                const valLip = parseInt(objForm.lip)||minLip;
                                return (
                                  <>
                                    {/* Protéines */}
                                    <div style={{marginBottom:24}}>
                                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:6}}>
                                        <div style={{fontSize:13,fontWeight:900,color:"#7CB342"}}>💪 Protéines</div>
                                        <div style={{fontSize:22,fontWeight:900,color:"#7CB342"}}>{valPro}<span style={{fontSize:11,color:"#9ca3af",fontWeight:400}}>g/j</span></div>
                                      </div>
                                      <input type="range" min={minPro} max={realMaxPro} step={1} value={valPro}
                                        onChange={e=>{
                                          const v = parseInt(e.target.value);
                                          setObjForm(ff=>({...ff, pro:String(v), lip:String(Math.max(parseInt(ff.lip)||minLip, v))}));
                                        }}
                                        style={{width:"100%",accentColor:"#7CB342"}}
                                      />
                                      <div style={{display:"flex",justifyContent:"space-between",fontSize:9,color:"#9ca3af",marginTop:3}}>
                                        <span>min {minPro}g</span>
                                        <span>max {realMaxPro}g</span>
                                      </div>
                                    </div>

                                    {/* Lipides */}
                                    <div style={{marginBottom:24}}>
                                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:6}}>
                                        <div style={{fontSize:13,fontWeight:900,color:"#F4A035"}}>🧈 Lipides</div>
                                        <div style={{fontSize:22,fontWeight:900,color:"#F4A035"}}>{valLip}<span style={{fontSize:11,color:"#9ca3af",fontWeight:400}}>g/j</span></div>
                                      </div>
                                      <input type="range" min={Math.max(minLip,valPro)} max={realMaxLip} step={1} value={Math.max(valLip,valPro)}
                                        onChange={e=>{
                                          const v = parseInt(e.target.value);
                                          setObjForm(ff=>({...ff, lip:String(v)}));
                                        }}
                                        style={{width:"100%",accentColor:"#F4A035"}}
                                      />
                                      <div style={{display:"flex",justifyContent:"space-between",fontSize:9,color:"#9ca3af",marginTop:3}}>
                                        <span>min {Math.max(minLip,valPro)}g <span style={{color:"#F4A035"}}>(≥ protéines)</span></span>
                                        <span>max {realMaxLip}g</span>
                                      </div>
                                    </div>

                                    {/* Glucides — fixe 20g max */}
                                    <div style={{marginBottom:24}}>
                                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:6}}>
                                        <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B"}}>🌾 Glucides</div>
                                        <div style={{fontSize:22,fontWeight:900,color:"#1B3A6B"}}>{parseInt(objForm.glu)||20}<span style={{fontSize:11,color:"#9ca3af",fontWeight:400}}>g/j</span></div>
                                      </div>
                                      <input type="range" min={0} max={20} step={1} value={parseInt(objForm.glu)||20}
                                        onChange={e=>setObjForm(ff=>({...ff,glu:e.target.value}))}
                                        style={{width:"100%",accentColor:"#1B3A6B"}}
                                      />
                                      <div style={{display:"flex",justifyContent:"space-between",fontSize:9,color:"#9ca3af",marginTop:3}}>
                                        <span>0g</span>
                                        <span>max 20g</span>
                                      </div>
                                    </div>
                                  </>
                                );
                              })()}

                              <button
                                onClick={()=>{
                                  const pro = Math.min(Math.max(parseInt(objForm.pro)||minPro, minPro), realMaxPro);
                                  const lip = Math.min(Math.max(parseInt(objForm.lip)||minLip, pro), realMaxLip);
                                  const glu = Math.min(parseInt(objForm.glu)||20, 20);
                                  saveObjectifs({lip, glu, pro});
                                  try { localStorage.setItem("cetoclub_choix_premium","perso"); } catch {}
                                  setChoixPremium("perso");
                                  setPremiumMacrosVisible(false);
                                }}
                                style={{width:"100%",padding:"13px",borderRadius:12,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:14,cursor:"pointer"}}
                              >
                                ✓ Enregistrer mes macros
                              </button>

                              <div style={{fontSize:9,color:"#9ca3af",textAlign:"center",marginTop:10,lineHeight:1.6}}>
                                Ces valeurs remplaceront les objectifs Céto Club dans ton journal
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })()}

              </div>
            ); } catch(e) { return <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16,color:"#C62828",fontSize:13,fontWeight:700}}>⚠️ Complète ton profil (âge, poids, taille) pour voir tes objectifs.</div>; } })()}
          </div>

          {/* ── JE PARS EN VACANCES ── */}
          {ongletMoi==="profil" && (
            <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
              <button onClick={()=>setOpenProfilVacances(!openProfilVacances)} style={{width:"100%",padding:"14px 16px",borderRadius:openProfilVacances?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:16}}>🏖️</span><span>Je pars en vacances</span></div>
                <span style={{fontSize:12,opacity:0.8}}>{openProfilVacances?"▲":"▼"}</span>
              </button>
              {openProfilVacances && (
                <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:14}}>
                  <CalendrierSuivi onVoirJour={(dateIso) => {
                    try { setJournalDate(dateIso); } catch {}
                    setPage("journal");
                  }}/>
                </div>
              )}
            </div>
          )}

          {/* ── MES DONNÉES ── */}
          {ongletMoi==="profil" && (
            <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
              <button onClick={()=>setOpenProfilDonnees(!openProfilDonnees)} style={{width:"100%",padding:"14px 16px",borderRadius:openProfilDonnees?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:16}}>💾</span><span>Mes données</span></div>
                <span style={{fontSize:12,opacity:0.8}}>{openProfilDonnees?"▲":"▼"}</span>
              </button>
              {openProfilDonnees && (
                <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                  <div style={{fontSize:12,color:"#6B7280",marginBottom:14,lineHeight:1.5}}>
                    Sauvegarde tes recettes, produits, historique et profil dans un fichier. Tu pourras les recharger sur n'importe quel appareil.
                  </div>
              <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                <button onClick={()=>{
                  try {
                    const KEYS = ["cetoclub_profil","cetoclub_objectifs","cetoclub_journal","cetoclub_poids","cetoclub_mensurations","cetoclub_produits","cetoclub_recettes","cetoclub_recettes_histo","cetoclub_suivi","cetoclub_sommeil","cetoclub_jeune_histo","cetoclub_planning_jeune","cetoclub_cycle_hormonal","cetoclub_menopause","cetoclub_activite","cetoclub_activite_seances_v2","cetoclub_respiration_histo","cetoclub_menu_sauve","cetoclub_onboarding","cetoclub_premium_local","cetoclub_activations"];
                    const backup = {};
                    KEYS.forEach(k => { try { const v = localStorage.getItem(k); if(v) backup[k] = v; } catch {} });
                    // Ajouter les clés journal_date
                    Object.keys(localStorage).forEach(k => { if(k.startsWith("cetoclub_journal_")) backup[k] = localStorage.getItem(k); });
                    const blob = new Blob([JSON.stringify(backup, null, 2)], {type:"application/json"});
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "cetoclub_sauvegarde_" + new Date().toISOString().slice(0,10) + ".json";
                    a.click();
                    URL.revokeObjectURL(url);
                    try { localStorage.setItem("cetoclub_dernier_export", new Date().toISOString()); } catch {}
                  } catch(e) { alert("Erreur lors de l'export. Réessaie."); }
                }} style={{flex:1,minWidth:130,padding:"12px 16px",background:"#1B3A6B",color:"#fff",border:"none",borderRadius:10,fontSize:13,fontWeight:800,cursor:"pointer"}}>
                  📥 Exporter mes données
                </button>
                <button onClick={()=>{
                  const input = document.createElement("input");
                  input.type = "file";
                  input.accept = ".json";
                  input.onchange = (e) => {
                    const file = e.target.files[0];
                    if(!file) return;
                    const reader = new FileReader();
                    reader.onload = (ev) => {
                      try {
                        const data = JSON.parse(ev.target.result);
                        if(typeof data !== "object") throw new Error("Format invalide");

                        // Détecter le format "début de vacances"
                        let donneesAImporter = data;
                        let messageSupplementaire = "";
                        if (data.type === "cetoclub_debut_vacances" && data.donnees) {
                          donneesAImporter = data.donnees;
                          // Mémoriser la date de départ sur cet appareil (smartphone)
                          localStorage.setItem("cetoclub_vacances_depart", data.date_depart);
                          messageSupplementaire = "\n\n🏖️ Mode vacances activé depuis le " +
                            data.date_depart.split("-").reverse().join("/") +
                            ".\nAu retour, clique sur \"Fin de vacances\" depuis ton calendrier.";
                        } else if (data.type === "cetoclub_fin_vacances") {
                          alert("❌ Ce fichier est un retour de vacances. Utilise le bouton \"Fin de vacances\" dans ton calendrier pour l'importer correctement.");
                          return;
                        }

                        let count = 0;
                        Object.entries(donneesAImporter).forEach(([k,v]) => {
                          if(k.startsWith("cetoclub_")) {
                            const val = typeof v === "string" ? v : JSON.stringify(v);
                            localStorage.setItem(k, val);
                            count++;
                          }
                        });
                        alert("✅ " + count + " données restaurées !" + messageSupplementaire + "\n\nL'app va se recharger.");
                        window.location.reload();
                      } catch(err) { alert("❌ Fichier invalide. Vérifie qu'il s'agit bien d'une sauvegarde Céto Club."); }
                    };
                    reader.readAsText(file);
                  };
                  input.click();
                }} style={{flex:1,minWidth:130,padding:"12px 16px",background:"#fff",color:"#1B3A6B",border:"2px solid #1B3A6B",borderRadius:10,fontSize:13,fontWeight:800,cursor:"pointer"}}>
                  📤 Importer mes données
                </button>
              </div>
                </div>
              )}
            </div>
          )}

        </div>)}

          {ongletMoi==="abonnement" && (
            <div style={{marginTop:8}}>
              <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:16,padding:"20px 18px",marginBottom:16,color:"#fff",textAlign:"center"}}>
                <div style={{fontSize:32,marginBottom:6}}>💳</div>
                <div style={{fontSize:17,fontWeight:900,marginBottom:4}}>Soutien & Dons</div>
                <div style={{fontSize:11,opacity:.8}}>Gérer, upgrader ou résilier</div>
              </div>
              {[
                {id:"soutien",  badge:"/Soutien.png",     titre:"Soutien",     prix:"3,99€/mois", url:"https://buy.stripe.com/00w7sLbSM8yYf0m89x8so00", montantMin:0,    montantMax:4.5},
                {id:"bienfait", badge:"/Bienfaiteur.png", titre:"Bienfaiteur", prix:"7,99€/mois", url:"https://buy.stripe.com/fZudR9f4Y9D2aK6gG38so01", montantMin:4.5,  montantMax:20},
                {id:"membre",   badge:"/Membre.png",      titre:"Membre",      prix:"35€/an",     url:"https://buy.stripe.com/bJe7sLg9216wdWi61p8so02", montantMin:20,   montantMax:36},
                {id:"don",      badge:"/Donateur.png",    titre:"Donateur",    prix:"Libre",      url:"https://buy.stripe.com/5kQeVd2ic3eEcSe9dB8so03", montantMin:36,   montantMax:99999},
              ].map(o => {
                const montantActuel = (() => { try { const d = JSON.parse(localStorage.getItem("cetoclub_premium_data")||"null"); return parseFloat(d?.montant)||0; } catch { return 0; } })();
                const estActuel = PREMIUM_ACTIF && montantActuel >= o.montantMin && montantActuel < o.montantMax;
                return (
                  <div key={o.id} style={{background:"#fff",borderRadius:14,border:`2px solid ${estActuel?"#2E7D32":"#E5E7EB"}`,padding:"14px 16px",marginBottom:10,display:"flex",alignItems:"center",gap:12}}>
                    <img src={o.badge} alt={o.titre} style={{width:56,height:56,objectFit:"contain",flexShrink:0}}/>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B"}}>{estActuel?"⭐ ":""}{o.titre}</div>
                      <div style={{fontSize:11,color:"#6B7280"}}>{o.prix}</div>
                      {estActuel && <div style={{fontSize:10,color:"#2E7D32",fontWeight:700,marginTop:2}}>Abonnement actuel</div>}
                    </div>
                    {!estActuel && (
                      <a href={o.url} target="_blank" rel="noopener noreferrer"
                        style={{flexShrink:0,padding:"8px 12px",borderRadius:8,background:"#1B3A6B",color:"#fff",fontSize:11,fontWeight:900,textDecoration:"none"}}>
                        Choisir
                      </a>
                    )}
                  </div>
                );
              })}
              <a href="https://billing.stripe.com/p/login/00w7sLbSM8yYf0m89x8so00" target="_blank" rel="noopener noreferrer"
                style={{display:"block",textAlign:"center",marginTop:14,padding:"12px",borderRadius:10,border:"1.5px solid #E5E7EB",background:"#F9FAFB",color:"#6B7280",fontSize:12,textDecoration:"none",fontWeight:700}}>
                🔧 Gérer ou résilier mon abonnement
              </a>
            </div>
          )}

          {ongletMoi==="bilan" && (
            <div>
              {PREMIUM_ACTIF ? (
                bilanDisponible ? (
                  <BilanPDF onRetour={()=>setOngletMoi("profil")} />
                ) : (
                  <div style={{background:"#FFF8F0",borderRadius:14,border:"2px solid #F4A03540",padding:28,textAlign:"center",marginTop:8}}>
                    <div style={{fontSize:40,marginBottom:12}}>⏳</div>
                    <div style={{fontSize:15,fontWeight:900,color:"#E65100",marginBottom:8}}>Encore un peu de patience !</div>
                    <div style={{fontSize:12,color:"#6B7280",lineHeight:1.7}}>
                      Ton rapport mensuel sera disponible après <strong>7 jours</strong> de suivi.<br/>
                      {nbJoursCeto > 0
                        ? `Tu es à J+${nbJoursCeto} — encore ${7 - nbJoursCeto} jour${7 - nbJoursCeto > 1 ? "s" : ""} !`
                        : "Renseigne ta date de début céto dans ton profil pour commencer le suivi."}
                    </div>
                  </div>
                )
              ) : (
                <BandeauPremium
                  titre="📊 Mon rapport mensuel"
                  description="Génère un résumé complet de tes données (nutrition, poids, bien-être, jeûnes) à partager avec ton professionnel de santé."
                  onClick={()=>setPage("premium")}
                />
              )}
            </div>
          )}

        </main>
        );
      })()}

      {page==="recettes" && (
        <main style={{maxWidth:1000,margin:"0 auto",padding:"16px 12px",overflowX:"hidden",boxSizing:"border-box",width:"100%"}}>

          {/* BLOC 1 — Recette du jour cliquable */}
          <a href={recetteJour.url} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none",display:"block",marginBottom:14}}>
            <div style={{background:"#fff",borderRadius:14,border:"2px solid #1B3A6B",padding:16,display:"flex",alignItems:"center",gap:14,flexWrap:"wrap",cursor:"pointer"}}>
              <div style={{fontSize:40,flexShrink:0}}>{recetteJour.emoji}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B",textTransform:"uppercase",letterSpacing:1,marginBottom:3}}>🍳 Recette du jour</div>
                <div style={{fontSize:16,fontWeight:900,color:"#1B3A6B",marginBottom:6}}>{recetteJour.titre}</div>
                <div style={{fontSize:11,color:"#7CB342",fontWeight:700}}>Voir la recette complète sur le blog →</div>
              </div>
              <div style={{fontSize:11,fontWeight:900,color:"#1B3A6B",flexShrink:0,display:"flex",alignItems:"center",gap:4}}>Voir la recette →</div>
            </div>
          </a>

          {/* BLOC 2 — Lien blog 1000 recettes */}
          <div style={{background:"#fff",borderRadius:14,border:"2px solid #1B3A6B",padding:16,marginBottom:18,display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
            <div style={{fontSize:36,flexShrink:0}}>📖</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:900,fontSize:14,color:"#1B3A6B",marginBottom:4}}>+1000 recettes céto sur le blog</div>
              <div style={{fontSize:11,color:"#6B7280",lineHeight:1.5}}>Toutes les recettes de référence Céto Club. Cuisine-les, puis enregistre tes versions ici !</div>
            </div>
            <a href="https://cetoclub.com/de-1000-recettes-cetogenes/" target="_blank" rel="noopener noreferrer"
              style={{padding:"10px 18px",borderRadius:10,background:"#7CB342",color:"#fff",fontWeight:900,fontSize:12,textDecoration:"none",whiteSpace:"nowrap",flexShrink:0}}>
              Voir les recettes →
            </a>
          </div>

          {/* TITRE section recettes perso — repliable */}
          <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
            <button onClick={()=>setOpenRecettes(!openRecettes)} style={{width:"100%",padding:"14px 16px",borderRadius:openRecettes?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span>🍳 Mes recettes céto</span>
              <span style={{fontSize:12,opacity:0.8}}>{openRecettes?"▲":"▼"}</span>
            </button>
            {openRecettes && <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:14}}>
            <p style={{color:"#6B7280",fontSize:11,margin:"0 0 12px"}}>Tes recettes maison avec calcul automatique des glucides</p>

          {/* Barre actions */}
          <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
            <div style={{flex:1,minWidth:180,position:"relative"}}>
              <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:13}}>🔍</span>
              <input value={recSearch} onChange={e=>setRecSearch(e.target.value)} placeholder="Rechercher une recette…" style={{width:"100%",padding:"10px 10px 10px 30px",border:"2px solid #1B3A6B15",borderRadius:8,fontSize:12,outline:"none"}}/>
            </div>

            <button onClick={()=>{setRecetteForm(true);setRecetteActive(null);setEditRecId(null);setRecForm({nom:"",portions:"4",description:"",ingredients:[]});}} style={{padding:"10px 18px",borderRadius:8,background:"#7CB342",color:"#fff",border:"none",fontWeight:800,fontSize:12,cursor:"pointer"}}>
              ＋ Enregistre ta nouvelle recette
            </button>
          </div>

          {/* Formulaire nouvelle recette */}
          {recetteForm && (
            <div style={{background:"#fff",border:"2px solid #7CB34230",borderRadius:14,padding:20,marginBottom:18,boxShadow:"0 4px 20px rgba(27,58,107,.08)"}}>
              <div style={{fontSize:14,fontWeight:900,color:"#1B3A6B",marginBottom:14}}>{editRecId ? "✏️ Modifier la recette" : "🍳 Enregistre ta nouvelle recette"}</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10,marginBottom:10}}>
                <div>
                  <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:4}}>NOM DE LA RECETTE *</div>
                  <input value={recForm.nom} onChange={e=>setRecForm(f=>({...f,nom:e.target.value}))} placeholder="Ex: Omelette avocat-saumon" style={{width:"100%",padding:"9px 12px",border:"2px solid #1B3A6B20",borderRadius:7,fontSize:13,outline:"none"}}/>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:4}}>NOMBRE DE PORTIONS</div>
                  <input type="number" min="1" max="20" value={recForm.portions} onChange={e=>setRecForm(f=>({...f,portions:e.target.value}))} style={{width:"100%",padding:"9px 12px",border:"2px solid #1B3A6B20",borderRadius:7,fontSize:13,outline:"none",textAlign:"center",fontWeight:800}}/>
                </div>
              </div>
              <div style={{marginBottom:12}}>
                <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:4}}>DESCRIPTION / INSTRUCTIONS (optionnel)</div>
                <textarea value={recForm.description} onChange={e=>setRecForm(f=>({...f,description:e.target.value}))} placeholder="Décrivez la préparation…" rows={3} style={{width:"100%",padding:"9px 12px",border:"2px solid #1B3A6B20",borderRadius:7,fontSize:12,outline:"none",resize:"vertical",fontFamily:"inherit"}}/>
              </div>

              {/* Ajout ingrédients */}
              <div style={{marginBottom:12}}>
                <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:8}}>🥦 Ingrédients</div>
                <div style={{position:"relative",marginBottom:8}}>
                  <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:12}}>🔍</span>
                  <input value={recIngSearch} onChange={e=>doRecIngSearch(e.target.value)} placeholder="Rechercher un ingrédient (Ciqual + Mes Produits)…" style={{width:"100%",padding:"8px 8px 8px 28px",border:"2px solid #1B3A6B15",borderRadius:7,fontSize:12,outline:"none"}}/>
                  {recIngResults.length>0 && (
                    <div style={{position:"absolute",top:"100%",left:0,right:0,background:"#fff",border:"2px solid #1B3A6B20",borderRadius:8,boxShadow:"0 4px 16px rgba(27,58,107,.12)",zIndex:50,maxHeight:180,overflow:"auto",marginTop:2}}>
                      {recIngResults.map(a=>(
                        <div key={a.id+a.source} onClick={()=>addIngredientToRec(a)} style={{padding:"7px 12px",cursor:"pointer",borderBottom:"1px solid #F3F4F6",display:"flex",justifyContent:"space-between",alignItems:"center"}} onMouseEnter={e=>e.currentTarget.style.background="#F1F8E9"} onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
                          <span style={{fontSize:12,fontWeight:700,color:"#1B3A6B"}}>{a.nom}</span>
                          <div style={{display:"flex",gap:6}}>
                            <span style={{fontSize:9,background:a.source==="perso"?"#FFF8F0":"#F1F8E9",color:a.source==="perso"?"#F4A035":"#7CB342",padding:"1px 5px",borderRadius:3,fontWeight:700}}>{a.source==="perso"?"Perso":"Ciqual"}</span>
                            <span style={{fontSize:10,color:"#C62828",fontWeight:700}}>{a.glu}g glu</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Liste ingrédients ajoutés */}
                {recForm.ingredients.length>0 && (
                  <div style={{border:"1px solid #F3F4F6",borderRadius:8,overflow:"hidden",marginBottom:8}}>
                    {recForm.ingredients.map((ing,i)=>(
                      <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 80px 30px",gap:8,alignItems:"center",padding:"7px 10px",borderBottom:"1px solid #F3F4F6",background:i%2===0?"#fff":"#FAFAF7"}}>
                        <div style={{fontSize:12,fontWeight:700,color:"#1B3A6B"}}>{ing.nom}</div>
                        <div style={{display:"flex",alignItems:"center",gap:4}}>
                          <input type="number" min="1" max="2000" value={ing.gram} onChange={e=>updateIngGram(i,e.target.value)} style={{width:55,padding:"4px 6px",border:"2px solid #1B3A6B20",borderRadius:5,fontSize:12,fontWeight:800,textAlign:"center",outline:"none"}}/>
                          <span style={{fontSize:10,color:"#9ca3af"}}>{ing.unite ? "unité(s)" : "g"}</span>
                        </div>
                        <button onClick={()=>removeIng(i)} style={{background:"none",border:"none",cursor:"pointer",color:"#C62828",fontSize:14,padding:0}}>🗑️</button>
                      </div>
                    ))}
                  </div>
                )}

                {/* Aperçu nutritionnel en temps réel */}
                {recForm.ingredients.length>0 && (()=>{
                  const m = calcRecMacros(recForm.ingredients, recForm.portions);
                  const sc = score(m.portion.glu);
                  return (
                    <div style={{background:"#F1F8E9",borderRadius:8,padding:"10px 14px",fontSize:11}}>
                      <div style={{fontWeight:900,color:"#1B3A6B",marginBottom:6}}>Aperçu · Par portion ({recForm.portions} portion{recForm.portions>1?"s":""})</div>
                      <div style={{display:"flex",gap:16,flexWrap:"wrap",alignItems:"center"}}>
                        <span style={{color:"#E65100",fontWeight:800}}>🧈 {m.portion.lip.toFixed(1)}g lip</span>
                        <span style={{color:"#C62828",fontWeight:800}}>🌾 {m.portion.glu.toFixed(1)}g glu</span>
                        <span style={{color:"#2A5298",fontWeight:800}}>💪 {m.portion.pro.toFixed(1)}g pro</span>
                        <span style={{background:sc.bg,color:sc.c,padding:"2px 8px",borderRadius:5,fontWeight:800,fontSize:10}}>{sc.l}</span>
                      </div>
                    </div>
                  );
                })()}
              </div>

              <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:12}}>
                <button onClick={()=>{setRecetteForm(false);setEditRecId(null);setRecForm({nom:"",portions:"4",description:"",ingredients:[]});}} style={{padding:"9px 18px",borderRadius:7,border:"2px solid #F3F4F6",background:"#F3F4F6",color:"#6B7280",fontWeight:700,fontSize:12,cursor:"pointer"}}>Annuler</button>
                <button onClick={saveRecette} style={{padding:"9px 22px",borderRadius:7,border:"none",background:"#7CB342",color:"#fff",fontWeight:900,fontSize:12,cursor:"pointer"}}>{editRecId ? "✓ Sauvegarder les modifications" : "✓ Enregistrer la recette"}</button>
              </div>
            </div>
          )}

          {/* Liste recettes */}
          {recettesFiltrees.length===0 && !recetteForm ? (
            <div style={{textAlign:"center",padding:48,background:"#fff",borderRadius:14,border:"2px dashed #7CB34230",color:"#6B7280"}}>
              <div style={{fontSize:40,marginBottom:10}}>🍳</div>
              <div style={{fontWeight:900,fontSize:14,color:"#1B3A6B",marginBottom:6}}>Aucune recette encore</div>
              <div style={{fontSize:12,marginBottom:14}}>Inspire-toi du blog Céto Club puis crée tes propres recettes ici !</div>
              <a href="https://cetoclub.com/de-1000-recettes-cetogenes/" target="_blank" rel="noopener noreferrer" style={{padding:"10px 20px",borderRadius:8,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",fontWeight:800,fontSize:12,textDecoration:"none"}}>Voir les recettes du blog →</a>
            </div>
          ) : (
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(min(280px,100%),1fr))",gap:14}}>
              {recettesFiltrees.map(rec=>{
                const sc = score(rec.macros.portion.glu);
                return (
                  <div key={rec.id} style={{background:"#fff",borderRadius:12,border:"2px solid #1B3A6B10",overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,.06)"}}>
                    {/* En-tête cliquable → détail */}
                    <div style={{cursor:"pointer"}} onClick={()=>setRecetteActive(recetteActive?.id===rec.id?null:rec)}>
                      <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"12px 14px",color:"#fff"}}>
                        <div style={{fontWeight:900,fontSize:13,marginBottom:2}}>{rec.nom}</div>
                        <div style={{fontSize:10,opacity:.75}}>{rec.portions} portion{rec.portions>1?"s":""} · {rec.ingredients.length} ingrédient{rec.ingredients.length>1?"s":""} · {rec.createdAt}</div>
                      </div>
                      <div style={{padding:"10px 12px 0"}}>
                        <div style={{display:"flex",gap:10,justifyContent:"space-between",alignItems:"center"}}>
                          <div style={{display:"flex",gap:10}}>
                            <span style={{fontSize:11,fontWeight:800,color:"#E65100"}}>🧈 {rec.macros.portion.lip.toFixed(1)}g</span>
                            <span style={{fontSize:11,fontWeight:800,color:"#C62828"}}>🌾 {rec.macros.portion.glu.toFixed(1)}g</span>
                            <span style={{fontSize:11,fontWeight:800,color:"#2A5298"}}>💪 {rec.macros.portion.pro.toFixed(1)}g</span>
                          </div>
                          <span style={{fontSize:9,background:sc.bg,color:sc.c,padding:"2px 6px",borderRadius:4,fontWeight:800}}>{sc.l}</span>
                        </div>
                        {rec.description && <div style={{fontSize:10,color:"#6B7280",lineHeight:1.5,marginTop:6,overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>{rec.description}</div>}
                      </div>
                    </div>

                    {/* Bouton partage */}
                    <div style={{padding:"10px 12px"}} onClick={e=>e.stopPropagation()}>
                      <button
                        onClick={()=>partagerRecette(rec)}
                        style={{width:"100%",padding:"9px",borderRadius:8,background:"#F4A035",color:"#fff",border:"none",fontWeight:900,fontSize:12,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:6}}
                      >
                        📤 Partage ta recette
                      </button>
                    </div>

                    {/* Panel détail (accordéon) */}
                    {recetteActive?.id===rec.id && (
                      <div style={{borderTop:"1px solid #F3F4F6",padding:"10px 12px 12px"}} onClick={e=>e.stopPropagation()}>
                        <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:6}}>Ingrédients :</div>
                        {rec.ingredients.map((ing,i)=>(
                          <div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:10,padding:"3px 0",borderBottom:"1px solid #F9F9F9",color:"#374151"}}>
                            <span>{ing.nom}</span>
                            <span style={{fontWeight:700,color:"#6B7280"}}>{ing.unite ? `x${ing.gram}` : `${ing.gram}g`}</span>
                          </div>
                        ))}
                        {rec.description && (
                          <div style={{marginTop:8,fontSize:10,color:"#6B7280",background:"#F9F9F9",borderRadius:6,padding:"8px 10px",lineHeight:1.6}}>{rec.description}</div>
                        )}
                        <div style={{display:"flex",gap:8,marginTop:10}}>
                          <button onClick={()=>addRecetteAuJournal(rec)} style={{flex:1,padding:"8px",borderRadius:7,background:"#1B3A6B",color:"#fff",border:"none",fontWeight:800,fontSize:11,cursor:"pointer"}}>📔 Ajouter au journal</button>
                          <button onClick={()=>{setEditRecId(rec.id);setRecForm({nom:rec.nom,portions:String(rec.portions),description:rec.description||"",ingredients:rec.ingredients.map(ing=>({...ing}))});setRecetteForm(true);setRecetteActive(null);window.scrollTo(0,0);}} style={{padding:"8px 12px",borderRadius:7,background:"none",border:"1px solid #F4A035",color:"#F4A035",fontWeight:700,fontSize:11,cursor:"pointer"}}>✏️ Modifier</button>
                          <button onClick={()=>saveRecettes(recettes.filter(r=>r.id!==rec.id))} style={{padding:"8px 12px",borderRadius:7,background:"none",border:"1px solid #C62828",color:"#C62828",fontWeight:700,fontSize:11,cursor:"pointer"}}>🗑️</button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
            </div>}
          </div>
        </main>
      )}

      {page==="produits" && (
        <main style={{maxWidth:1100,margin:"0 auto",padding:"16px 12px",overflowX:"hidden",boxSizing:"border-box",width:"100%"}}>
          <div style={{textAlign:"center",marginBottom:20}}>
            <h1 style={{fontSize:28,fontWeight:900,color:"#1B3A6B",margin:"0 0 4px"}}>Mes Produits de Marque</h1>
            <p style={{color:"#6B7280",fontSize:13,margin:0}}>Saisis les valeurs nutritionnelles depuis l'étiquette de tes produits emballés</p>
          </div>
          {/* Scanner premium — toujours visible */}
          <div style={{borderRadius:14,marginBottom:16,boxShadow:"0 2px 12px rgba(27,58,107,0.10)",cursor:"pointer"}}
            onClick={()=>setPage(PREMIUM_ACTIF?"scanner":"premium")}>
            <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:14}}>
              <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>📷 Scanner un code-barres</div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",flexShrink:0}}>
                  <span style={{fontSize:11}}>💎</span>
                  <span style={{fontSize:10,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
                </div>
                <span style={{fontSize:12,color:"rgba(255,255,255,0.7)"}}>▼</span>
              </div>
            </div>
            <div style={{background:"#EEF2FF",padding:"10px 16px",borderRadius:14,marginTop:4}}>
              <p style={{fontSize:11,color:"#374151",lineHeight:1.6,margin:0}}>Scanne le code-barres d'un produit — macros et ingrédients importés automatiquement.</p>
            </div>
          </div>
          <div style={{display:"none"}}>
          </div>

          {/* Barre actions */}
          <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
            <div style={{flex:1,minWidth:180,position:"relative"}}>
              <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:14}}>🔍</span>
              <input value={searchProd} onChange={e=>setSearchProd(e.target.value)} placeholder="Chercher un de mes produits enregistrés…" style={{width:"100%",padding:"10px 10px 10px 32px",border:"2px solid #1B3A6B15",borderRadius:8,fontSize:13,outline:"none",background:"#fff"}} onFocus={e=>e.target.style.borderColor="#1B3A6B"} onBlur={e=>e.target.style.borderColor="#1B3A6B15"}/>
            </div>
            <button onClick={()=>{setFormOpen(true);setEditId(null);setForm({nom:"",marque:"",lip:"",glu:"",pro:"",portion:"100"});}} style={{padding:"10px 18px",borderRadius:8,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:800,fontSize:12,cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
              ＋ Ajouter un produit
            </button>

          </div>

          {/* Formulaire ajout/edit */}
          {formOpen && (
            <div style={{background:"#fff",border:"2px solid #1B3A6B",borderRadius:12,padding:20,marginBottom:18,boxShadow:"0 4px 20px rgba(27,58,107,.1)"}}>
              <div style={{fontSize:14,fontWeight:900,color:"#1B3A6B",marginBottom:14}}>{editId?"✏️ Modifier le produit":"➕ Nouveau produit"}</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                <div>
                  <div style={{fontSize:10,fontWeight:700,color:"#6B7280",marginBottom:4}}>NOM DU PRODUIT *</div>
                  <input value={form.nom} onChange={e=>setForm(f=>({...f,nom:e.target.value}))} placeholder="Ex: Beurre de cacahuète" style={{width:"100%",padding:"9px 12px",border:"2px solid #1B3A6B20",borderRadius:7,fontSize:13,outline:"none"}} onFocus={e=>e.target.style.borderColor="#1B3A6B"} onBlur={e=>e.target.style.borderColor="#1B3A6B20"}/>
                </div>
                <div>
                  <div style={{fontSize:10,fontWeight:700,color:"#6B7280",marginBottom:4}}>MARQUE</div>
                  <input value={form.marque} onChange={e=>setForm(f=>({...f,marque:e.target.value}))} placeholder="Ex: Bjorg, Lindt…" style={{width:"100%",padding:"9px 12px",border:"2px solid #1B3A6B20",borderRadius:7,fontSize:13,outline:"none"}} onFocus={e=>e.target.style.borderColor="#1B3A6B"} onBlur={e=>e.target.style.borderColor="#1B3A6B20"}/>
                </div>
              </div>
              <div style={{fontSize:11,color:"#6B7280",marginBottom:6,fontStyle:"italic"}}>Valeurs pour 100g (telles qu'indiquées sur l'étiquette)</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:10,marginBottom:14}}>
                {[{k:"lip",l:"Lipides (g)",c:"#E65100"},{k:"glu",l:"Glucides (g)",c:"#C62828"},{k:"pro",l:"Protéines (g)",c:"#2A5298"},{k:"portion",l:"Portion (g)",c:"#6B7280"}].map(f=>(
                  <div key={f.k}>
                    <div style={{fontSize:10,fontWeight:700,color:f.c,marginBottom:4}}>{f.l}</div>
                    <input type="number" min="0" step="0.1" value={form[f.k]} onChange={e=>setForm(ff=>({...ff,[f.k]:e.target.value}))} placeholder="0" style={{width:"100%",padding:"9px 12px",border:`2px solid ${f.c}20`,borderRadius:7,fontSize:13,outline:"none",fontFamily:"inherit"}} onFocus={e=>e.target.style.borderColor=f.c} onBlur={e=>e.target.style.borderColor=`${f.c}20`}/>
                  </div>
                ))}
              </div>
              {/* Alerte glucides cachés */}
              {parseFloat(form.glu)>5 && (
                <div style={{background:"#FFEBEE",border:"2px solid #C6282830",borderRadius:8,padding:"10px 14px",marginBottom:12,fontSize:11,color:"#C62828",display:"flex",gap:8,alignItems:"flex-start"}}>
                  <span style={{fontSize:16}}>⚠️</span>
                  <div>
                    <strong>Glucides élevés — vérifie les sucres cachés !</strong><br/>
                    Ce produit contient <strong>{form.glu}g de glucides/100g</strong>. Vérifiez s'il y a des maltodextrines, sirop de glucose, amidon ou sucre sous d'autres noms dans la liste des ingrédients.
                  </div>
                </div>
              )}
              {parseFloat(form.glu)>0 && parseFloat(form.glu)<=5 && (
                <div style={{background:"#FFF8F0",border:"2px solid #F4A03530",borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:11,color:"#E65100",display:"flex",gap:8,alignItems:"center"}}>
                  <span>💡</span>
                  <span>Vérifiez la liste des ingrédients pour détecter les sucres ajoutés cachés.</span>
                </div>
              )}
              <div style={{display:"flex",gap:8,justifyContent:"space-between",alignItems:"center"}}>

                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>{setFormOpen(false);setEditId(null);}} style={{padding:"9px 18px",borderRadius:7,border:"2px solid #F3F4F6",background:"#F3F4F6",color:"#6B7280",fontWeight:700,fontSize:12,cursor:"pointer"}}>Annuler</button>
                  <button onClick={submitForm} style={{padding:"9px 22px",borderRadius:7,border:"none",background:"#1B3A6B",color:"#fff",fontWeight:800,fontSize:12,cursor:"pointer"}}>✓ Enregistrer</button>
                </div>
              </div>
            </div>
          )}

          {/* Liste produits */}
          <div>
            {produitsFiltres.length===0 && !formOpen && (
              <div style={{textAlign:"center",padding:56,color:"#6B7280",background:"#fff",borderRadius:12,border:"2px dashed #1B3A6B20"}}>
                <div style={{fontSize:40,marginBottom:10}}>🏷️</div>
                <div style={{fontWeight:900,fontSize:15,color:"#1B3A6B",marginBottom:6}}>Aucun produit encore</div>
                <div style={{fontSize:12}}>Cliquez sur "Ajouter un produit" pour commencer</div>
              </div>
            )}
            {produitsFiltres.length>0 && (
              <>
                <div style={{display:"grid",gridTemplateColumns:"18px 1fr 42px 44px 42px 58px 48px",gap:4,padding:"4px 10px",marginBottom:2,color:"#6B7280",fontSize:9,fontWeight:800,textTransform:"uppercase",letterSpacing:.6}}>
                  <div/><div>Produit</div><div style={{textAlign:"center"}}>Lip.</div><div style={{textAlign:"center"}}>Glu.</div><div style={{textAlign:"center"}}>Pro.</div><div style={{textAlign:"center"}}>Score</div><div/>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:3}}>
                  {produitsFiltres.map(p=>{
                    const s=score(p.glu, null);
                    const isSel=selProd?.id===p.id;
                    return (
                      <div key={p.id} style={{background:isSel?"#1B3A6B":"#fff",border:`1.5px solid ${isSel?"#1B3A6B":"#1B3A6B10"}`,borderRadius:8,cursor:"pointer",transition:"all .15s",overflow:"hidden"}}>
                        {/* Ligne principale — tap pour sélectionner */}
                        <div onClick={()=>{setSelProd(p);setGProd(p.portion||100);}} style={{display:"grid",gridTemplateColumns:"28px 1fr 42px 44px 42px 58px",gap:4,alignItems:"center",padding:"10px 10px 6px 10px"}}>
                          <button onClick={e=>{e.stopPropagation();toggleFavori(p.id);}} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",padding:"4px",opacity:p.favori?1:0.3,minWidth:28,minHeight:28}}>{p.favori?"⭐":"☆"}</button>
                          <div>
                            <div style={{fontSize:12,fontWeight:800,color:isSel?"#fff":"#1B3A6B"}}>{p.nom}</div>
                            {p.marque&&<div style={{fontSize:9,color:isSel?"#aaccee":"#7CB342",fontWeight:600}}>{p.marque}</div>}
                          </div>
                          <div style={{textAlign:"center",fontSize:12,fontWeight:800,color:isSel?"#fff":"#E65100"}}>{p.lip}<span style={{fontSize:9,color:isSel?"#aac":"#9ca3af"}}>g</span></div>
                          <div style={{textAlign:"center",fontSize:12,fontWeight:800,color:isSel?"#fff":"#C62828"}}>{p.glu}<span style={{fontSize:9,color:isSel?"#aac":"#9ca3af"}}>g</span></div>
                          <div style={{textAlign:"center",fontSize:12,fontWeight:800,color:isSel?"#fff":"#2A5298"}}>{p.pro}<span style={{fontSize:9,color:isSel?"#aac":"#9ca3af"}}>g</span></div>
                          <div style={{textAlign:"center",padding:"2px 4px",background:isSel?"rgba(255,255,255,.12)":s.bg,border:`1px solid ${s.c}25`,borderRadius:4,fontSize:9,fontWeight:800,color:isSel?"#fff":s.c}}>{s.l}</div>
                        </div>
                        {/* Boutons d'action — grande zone tactile séparée */}
                        <div style={{display:"flex",gap:0,borderTop:`1px solid ${isSel?"rgba(255,255,255,.15)":"#1B3A6B10"}`}}>
                          <button
                            onClick={e=>{e.stopPropagation();openEdit(p);}}
                            style={{flex:1,background:isSel?"rgba(255,255,255,.1)":"#f0f4ff",border:"none",borderRight:`1px solid ${isSel?"rgba(255,255,255,.15)":"#1B3A6B10"}`,padding:"10px 0",fontSize:16,cursor:"pointer",color:isSel?"#fff":"#1B3A6B",minHeight:44,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}
                          >✏️ <span style={{fontSize:11,fontWeight:700}}>Modifier</span></button>
                          <button
                            onClick={e=>{e.stopPropagation();deleteProduit(p.id);}}
                            style={{flex:1,background:isSel?"rgba(255,100,100,.15)":"#fff5f5",border:"none",padding:"10px 0",fontSize:16,cursor:"pointer",color:isSel?"#ffaaaa":"#C62828",minHeight:44,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}
                          >🗑️ <span style={{fontSize:11,fontWeight:700}}>Supprimer</span></button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>

          {/* Panel détail produit — bottom sheet */}
          {selProd && (()=>{
            const s=score(selProd.glu, null);
            return (
              <>
                <div onClick={()=>setSelProd(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.4)",zIndex:200}}/>
                <div style={{position:"fixed",bottom:0,left:0,right:0,background:"#fff",borderRadius:"16px 16px 0 0",padding:"16px 16px 32px",zIndex:201,boxShadow:"0 -4px 32px rgba(27,58,107,.18)",maxHeight:"80vh",overflowY:"auto"}}>
                  <div style={{width:36,height:4,background:"#E5E7EB",borderRadius:2,margin:"0 auto 14px"}}/>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:14,fontWeight:900,color:"#1B3A6B"}}>{selProd.nom}</div>
                      {selProd.marque&&<div style={{fontSize:11,color:"#7CB342",fontWeight:700,marginTop:2}}>{selProd.marque}</div>}
                      <div style={{fontSize:10,color:"#6B7280",marginTop:2}}>Portion habituelle : {selProd.portion||100}g</div>
                    </div>
                    <button onClick={()=>setSelProd(null)} style={{background:"none",border:"none",fontSize:15,color:"#6B7280",cursor:"pointer",padding:0}}>✕</button>
                  </div>
                  <div style={{background:s.bg,border:`1.5px solid ${s.c}30`,borderRadius:6,padding:"5px 8px",marginBottom:12,display:"flex",alignItems:"center",gap:6}}>
                    <div style={{width:6,height:6,borderRadius:"50%",background:s.c}}/>
                    <span style={{color:s.c,fontWeight:800,fontSize:11}}>Score céto : {s.l}</span>
                  </div>
                  <div style={{marginBottom:12}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                      <span style={{fontSize:10,color:"#6B7280",fontWeight:700}}>Quantité</span>
                      <span style={{fontSize:13,fontWeight:900,color:"#1B3A6B"}}>{gProd}g</span>
                    </div>
                    <input type="range" min={5} max={500} step={5} value={gProd} onChange={e=>setGProd(+e.target.value)} style={{width:"100%",accentColor:"#1B3A6B"}}/>
                  </div>
                  {[{l:"Lipides",v:calcP(selProd.lip),c:"#E65100",e:"🧈"},{l:"Glucides",v:calcP(selProd.glu),c:"#C62828",e:"🌾"},{l:"Protéines",v:calcP(selProd.pro),c:"#2A5298",e:"💪"}].map(m=>(
                    <div key={m.l} style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:"#F3F4F6",borderRadius:5,padding:"6px 8px",marginBottom:4}}>
                      <span style={{fontSize:11,color:"#6B7280",fontWeight:600}}>{m.e} {m.l}</span>
                      <span style={{fontSize:14,fontWeight:900,color:m.c}}>{m.v}<span style={{fontSize:9,color:"#6B7280"}}> g</span></span>
                    </div>
                  ))}
                  {selProd.glu>0&&<div style={{marginTop:10,padding:"7px 8px",background:"#F1F8E9",borderRadius:6,border:"1.5px solid #7CB34230"}}>
                    <div style={{fontSize:9,color:"#6B7280",fontWeight:700}}>Ratio lip/glu</div>
                    <div style={{fontSize:17,fontWeight:900,color:"#1B3A6B"}}>{(selProd.lip/selProd.glu).toFixed(1)}<span style={{fontSize:9,color:"#6B7280",marginLeft:4}}>idéal &gt; 4</span></div>
                  </div>}
                  <div style={{marginTop:12,display:"flex",gap:6}}>
                    <button onClick={()=>{toggleFavori(selProd.id);setSelProd(p=>({...p,favori:!p.favori}));}} style={{flex:1,padding:"7px",borderRadius:7,border:"2px solid #F4A03530",background:selProd.favori?"#FFF8F0":"#fff",color:"#F4A035",fontWeight:800,fontSize:11,cursor:"pointer"}}>
                      {selProd.favori?"⭐ Favori":"☆ Ajouter aux favoris"}
                    </button>
                  </div>
                  {selProd.glu>5 && (
                    <div style={{marginTop:10,background:"#FFEBEE",border:"1px solid #C6282830",borderRadius:7,padding:"8px 10px",fontSize:10,color:"#C62828"}}>
                      <strong>⚠️ Glucides élevés ({selProd.glu}g/100g)</strong><br/>
                      Vérifie les sucres cachés dans les ingrédients : maltodextrine, sirop de glucose, amidon, dextrose…
                    </div>
                  )}
                  <div style={{marginTop:8,fontSize:9,color:"#ccc",textAlign:"center"}}>Saisie manuelle · Pour 100g</div>
                </div>
              </>
            );
          })()}
        </main>
      )}

      {page==="journal" && (
        <main style={{maxWidth:900,margin:"0 auto",padding:"16px 12px",overflowX:"hidden",boxSizing:"border-box",width:"100%"}}>

          <BandeauRappelSauvegarde onAller={() => { setPage("profil"); setOngletMoi("profil"); }} />

          {/* ── BARRE D'ONGLETS ── */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:0,marginBottom:16,borderBottom:"1px solid #F3F4F6"}}>
            {[
              {id:"nutrition", e:"🥗", l:"Nutrition"},
              {id:"corps",     e:"⚖️", l:"Corps"},
              {id:"activite",  e:"🏃", l:"Activité"},
              {id:"jeune",     e:"⏱️", l:"Jeûne"},
              {id:"bienetre",  e:"🌿", l:"Bien-être"},
            ].map(t=>(
              <button key={t.id} onClick={()=>setTabJournal(t.id)}
                style={{padding:"6px 4px",borderRadius:8,fontWeight:700,fontSize:11,
                  border:`1.5px solid ${tabJournal===t.id?"#1B3A6B":"#E5E7EB"}`,
                  background:tabJournal===t.id?"#1B3A6B":"#fff",
                  color:tabJournal===t.id?"#fff":"#6B7280",
                  cursor:"pointer",textAlign:"center",
                  display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
                <span style={{fontSize:16}}>{t.e}</span>
                <span>{t.l}</span>
              </button>
            ))}
          </div>

          {/* ══════════════════════════════════════════════════════ */}
          {/* ── ONGLET NUTRITION ── */}
          {/* ══════════════════════════════════════════════════════ */}
          {tabJournal==="nutrition" && (<div>

          {/* Message d'invitation repliable */}
          <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
            <button onClick={()=>setOpenRepas(!openRepas)} style={{width:"100%",padding:"14px 16px",borderRadius:openRepas?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span>🥗 Enregistrer mes repas</span>
              <span style={{fontSize:12,opacity:0.8}}>{openRepas?"▲":"▼"}</span>
            </button>
            {openRepas && <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:14}}>
          {/* ── 3 CASES REPAS ── */}
          <div style={{display:"grid",gridTemplateColumns:"1fr",gap:10,marginBottom:18}}>
            {[1,2,3].map(num => {
              const repasEntrees = journeeEntrees.filter(e=>(e.repas||1)===num);
              const totaux = repasEntrees.reduce((acc,e)=>({lip:acc.lip+e.lip,glu:acc.glu+e.glu,pro:acc.pro+e.pro}),{lip:0,glu:0,pro:0});
              const ouvert = repasOuvert===num;
              return (
                <div key={num} style={{background:"#fff",borderRadius:12,border:`2px solid ${ouvert?"#1B3A6B":"#1B3A6B15"}`,transition:"border .2s"}}>
                  {/* En-tête repas */}
                  <div onClick={()=>setRepasOuvert(ouvert?null:num)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 16px",cursor:"pointer",background:ouvert?"#F0F4FF":"#fff"}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <div style={{width:32,height:32,borderRadius:8,background:ouvert?"#1B3A6B":"#F3F4F6",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>
                        {num===1?"🌅":num===2?"☀️":"🌙"}
                      </div>
                      <div>
                        <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B"}}>Repas {num}</div>
                        {repasEntrees.length>0
                          ? <div style={{fontSize:10,color:"#6B7280"}}>{repasEntrees.length} aliment{repasEntrees.length>1?"s":""} · <span style={{color:"#C62828",fontWeight:800}}>{totaux.glu.toFixed(1)}g glu</span></div>
                          : <div style={{fontSize:10,color:"#9CA3AF",fontStyle:"italic"}}>Aucun aliment</div>
                        }
                      </div>
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      {repasEntrees.length>0 && (
                        <div style={{display:"flex",gap:8,fontSize:10,color:"#6B7280"}}>
                          <span style={{color:"#E65100",fontWeight:700}}>{totaux.lip.toFixed(1)}g lip</span>
                          <span style={{color:"#2A5298",fontWeight:700}}>{totaux.pro.toFixed(1)}g pro</span>
                        </div>
                      )}
                      <div style={{fontSize:18,color:"#1B3A6B",transition:"transform .2s",transform:ouvert?"rotate(180deg)":"rotate(0deg)"}}>⌄</div>
                    </div>
                  </div>

                  {/* Contenu ouvert */}
                  {ouvert && (
                    <div style={{padding:"0 16px 16px",borderTop:"1px solid #F3F4F6"}}>
                      {/* Liste aliments du repas */}
                      {repasEntrees.length>0 && (
                        <div style={{marginTop:10,marginBottom:10,border:"1px solid #F3F4F6",borderRadius:8,overflow:"hidden"}}>
                          {repasEntrees.map((e,i)=>(
                            <div key={e.id} style={{borderBottom:"1px solid #F3F4F6",background:i%2===0?"#fff":"#FAFAF7"}}>
                              <div style={{display:"grid",gridTemplateColumns:"1fr 38px 34px 34px 34px 24px 24px",gap:2,alignItems:"center",padding:"6px 6px",minWidth:0}}>
                                <div style={{minWidth:0,overflow:"hidden"}}>
                                  <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{e.nom}</div>
                                  {e.marque&&<div style={{fontSize:9,color:"#7CB342",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{e.marque}</div>}
                                </div>
                                <div style={{textAlign:"center",fontSize:11,fontWeight:700,color:"#6B7280"}}>{e.source==="recette" ? `${e.gram} part${e.gram>1?"s":""}` : e.unite ? `x${e.gram}` : `${e.gram}g`}</div>
                                <div style={{textAlign:"center",fontSize:11,fontWeight:800,color:"#E65100"}}>{e.lip.toFixed(1)}</div>
                                <div style={{textAlign:"center",fontSize:11,fontWeight:800,color:"#C62828"}}>{e.glu.toFixed(1)}</div>
                                <div style={{textAlign:"center",fontSize:11,fontWeight:800,color:"#2A5298"}}>{e.pro.toFixed(1)}</div>
                                <button onClick={()=>{setEditEntreeId(e.id===editEntreeId?null:e.id);setEditEntreeGram(String(e.gram));}} style={{background:"none",border:"none",cursor:"pointer",fontSize:13,padding:0}}>✏️</button>
                                <button onClick={()=>removeEntree(e.id)} style={{background:"none",border:"none",cursor:"pointer",color:"#C62828",fontSize:13,padding:0}}>🗑️</button>
                              </div>
                              {editEntreeId===e.id && (
                                <div style={{display:"flex",gap:8,alignItems:"center",padding:"6px 10px 10px",background:"#F1F8E9"}}>
                                  <span style={{fontSize:11,color:"#6B7280",flex:1}}>Modifier la quantité :</span>
                                  <input type="number" min="1" max="2000" value={editEntreeGram} onChange={ev=>setEditEntreeGram(ev.target.value)} style={{width:70,padding:"6px 8px",border:"2px solid #7CB34250",borderRadius:6,fontSize:14,fontWeight:900,textAlign:"center",outline:"none"}}/>
                                  <span style={{fontSize:11,color:"#6B7280"}}>g</span>
                                  <button onClick={()=>saveEditEntree(e.id)} style={{padding:"6px 14px",borderRadius:6,background:"#1B3A6B",color:"#fff",border:"none",fontWeight:800,fontSize:12,cursor:"pointer"}}>✓</button>
                                  <button onClick={()=>setEditEntreeId(null)} style={{padding:"6px 10px",borderRadius:6,background:"none",border:"1px solid #ccc",color:"#6B7280",fontWeight:700,fontSize:11,cursor:"pointer"}}>✕</button>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Recherche + ajout */}
                      <div style={{marginTop:10}}>
                        {!jSel ? (
                          <>
                            <input
                              value={jSearch}
                              onChange={e=>doJSearch(e.target.value)}
                              placeholder="🔍 Tape un aliment (ex: poulet, oeuf…)"
                              autoComplete="off"
                              style={{width:"100%",padding:"11px 12px",border:"2px solid #1B3A6B40",borderRadius:8,fontSize:14,outline:"none",boxSizing:"border-box",background:"#fff"}}
                            />
                            {jSearchRes.length>0 && (
                              <div style={{marginTop:4,border:"2px solid #1B3A6B20",borderRadius:8,background:"#fff",maxHeight:220,overflowY:"scroll",scrollbarWidth:"auto",scrollbarColor:"#1B3A6B #E3F2FD",paddingRight:4}}>
                                {jSearchRes.map(a=>(
                                  <div key={a.id+a.source}
                                    onClick={()=>{
                                      if(a.source==="recette"){
                                        // Ouvrir modal portions pour les recettes perso
                                        const recObj = recettes.find(r=>r.id===a.id);
                                        if(recObj){ addRecetteAuJournal(recObj); setJSearchRes([]); setJSearch(""); }
                                      } else {
                                        setJSel(a);setJSource(a.source||"ciqual");setJGram(a.unite ? 1 : 100);setJSearchRes([]);setJSearch("");
                                      }
                                    }}
                                    style={{padding:"11px 14px",cursor:"pointer",borderBottom:"1px solid #F3F4F6",display:"flex",justifyContent:"space-between",alignItems:"center",background:"#fff"}}
                                    onMouseEnter={e=>e.currentTarget.style.background="#F1F8E9"}
                                    onMouseLeave={e=>e.currentTarget.style.background="#fff"}
                                  >
                                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                                      <span style={{fontSize:14,fontWeight:700,color:"#1B3A6B"}}>{a.nom}</span>
                                      {a.source==="recette" && <span style={{fontSize:9,background:"#F0F4FF",color:"#2A5298",padding:"2px 6px",borderRadius:4,fontWeight:800}}>Ma recette</span>}
                                      {a.source==="perso" && <span style={{fontSize:9,background:"#FFF8F0",color:"#F4A035",padding:"2px 6px",borderRadius:4,fontWeight:800}}>Perso</span>}
                                    </div>
                                    {a.source==="recette"
                                      ? <span style={{fontSize:12,color:"#2A5298",fontWeight:800}}>{a.glu}g glu/part</span>
                                      : <span style={{fontSize:12,color:"#C62828",fontWeight:800}}>{a.glu}g glu/100g</span>
                                    }
                                  </div>
                                ))}
                              </div>
                            )}
                            {jSearch.length>1 && jSearchRes.length===0 && (
                              <div style={{marginTop:4,padding:"10px 14px",background:"#F3F4F6",borderRadius:8,fontSize:12,color:"#6B7280"}}>
                                Aucun résultat pour «&nbsp;{jSearch}&nbsp;» — essaie un autre mot
                              </div>
                            )}
                          </>
                        ) : (
                          <div style={{background:"#F1F8E9",border:"2px solid #7CB34250",borderRadius:10,padding:14}}>
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                              <div style={{fontSize:14,fontWeight:900,color:"#1B3A6B"}}>{jSel.nom}</div>
                              <button onClick={()=>{setJSel(null);setJSearch("");setJSearchRes([]);}} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:"#9CA3AF",padding:0}}>✕</button>
                            </div>
                            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                              <input
                                type="number" min="1" max="2000"
                                value={jGram}
                                onChange={e=>setJGram(e.target.value===""?"":Math.max(1,+e.target.value))}
                                style={{width:80,padding:"10px",border:"2px solid #1B3A6B40",borderRadius:8,fontSize:16,fontWeight:900,textAlign:"center",outline:"none"}}
                              />
                              <span style={{fontSize:13,color:"#6B7280"}}>{jSel.unite ? "unité(s)" : "g"}</span>
                              <div style={{fontSize:12,color:"#6B7280"}}>
                                🧈 {(jSel.unite ? jSel.lip*(+jGram||1) : (jSel.lip*(+jGram||100))/100).toFixed(1)}g &nbsp;🌾 {(jSel.unite ? jSel.glu*(+jGram||1) : (jSel.glu*(+jGram||100))/100).toFixed(1)}g &nbsp;💪 {(jSel.unite ? jSel.pro*(+jGram||1) : (jSel.pro*(+jGram||100))/100).toFixed(1)}g
                              </div>
                            </div>
                            <button onClick={addEntree} style={{width:"100%",padding:"12px",borderRadius:8,background:"#1B3A6B",color:"#fff",border:"none",fontWeight:900,fontSize:14,cursor:"pointer"}}>
                              ✓ Ajouter au repas {num}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* ── NAVIGATION DATE ── */}
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14,background:"#F1F8E9",borderRadius:12,padding:"10px 16px",border:"2px solid #7CB342"}}>
            <button onClick={()=>changeDate(-1)} style={{background:"#7CB342",border:"none",fontSize:18,cursor:"pointer",color:"#fff",padding:"4px 12px",fontWeight:900,borderRadius:8}}>‹</button>
            <div style={{textAlign:"center"}}>
              <div style={{fontSize:14,fontWeight:900,color:"#2E7D32"}}>{formatDate(journalDate)}</div>
              {journalDate!==todayStr() && <button onClick={()=>setJournalDate(todayStr())} style={{background:"none",border:"none",fontSize:10,color:"#7CB342",cursor:"pointer",fontWeight:700,padding:0}}>→ Aujourd'hui</button>}
            </div>
            <button onClick={()=>changeDate(1)} disabled={journalDate>=todayStr()} style={{background:journalDate>=todayStr()?"#D1D5DB":"#7CB342",border:"none",fontSize:18,cursor:"pointer",color:"#fff",padding:"4px 12px",fontWeight:900,borderRadius:8}}>›</button>
          </div>

          {/* ── BILAN DU JOUR ── */}
          {journeeEntrees.length>0 && (
            <div style={{background:"#fff",borderRadius:12,border:"2px solid #1B3A6B10",padding:16,marginBottom:14}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
                <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B"}}>Bilan du jour</div>
                <button onClick={()=>{setObjForm({lip:String(objectifs.lip),glu:String(objectifs.glu),pro:String(objectifs.pro)});setObjEdit(true);}} style={{fontSize:10,fontWeight:700,color:"#6B7280",background:"#F3F4F6",border:"none",borderRadius:5,padding:"4px 8px",cursor:"pointer"}}>⚙️ Objectifs</button>
              </div>
              {objEdit && (
                <div style={{background:"#F3F4F6",borderRadius:8,padding:12,marginBottom:12}}>
                  <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:8}}>Mes objectifs quotidiens</div>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(90px,1fr))",gap:8,marginBottom:8}}>
                    {[{k:"lip",l:"Lipides g",c:"#E65100"},{k:"glu",l:"Glucides g",c:"#C62828"},{k:"pro",l:"Protéines g",c:"#2A5298"}].map(f=>(
                      <div key={f.k}>
                        <div style={{fontSize:9,fontWeight:700,color:f.c,marginBottom:3}}>{f.l}</div>
                        <input type="number" min="0" value={objForm[f.k]} onChange={e=>setObjForm(ff=>({...ff,[f.k]:e.target.value}))} style={{width:"100%",padding:"7px 8px",border:`2px solid ${f.c}30`,borderRadius:6,fontSize:13,fontWeight:800,outline:"none",textAlign:"center"}}/>
                      </div>
                    ))}
                  </div>
                  <div style={{display:"flex",gap:6,justifyContent:"flex-end"}}>
                    <button onClick={()=>setObjEdit(false)} style={{padding:"6px 12px",borderRadius:6,border:"none",background:"#E5E5E5",color:"#6B7280",fontWeight:700,fontSize:11,cursor:"pointer"}}>Annuler</button>
                    <button onClick={()=>{saveObjectifs({lip:parseFloat(objForm.lip)||150,glu:parseFloat(objForm.glu)||20,pro:parseFloat(objForm.pro)||80});setObjEdit(false);}} style={{padding:"6px 14px",borderRadius:6,border:"none",background:"#1B3A6B",color:"#fff",fontWeight:800,fontSize:11,cursor:"pointer"}}>✓ Sauvegarder</button>
                  </div>
                </div>
              )}
              {[
                {k:"lip",l:"Lipides",c:"#E65100",bg:"#FFF3E0"},
                {k:"glu",l:"Glucides",c:"#C62828",bg:"#FFEBEE"},
                {k:"pro",l:"Protéines",c:"#2A5298",bg:"#E3F2FD"},
              ].map(m=>{
                const val=totalJ[m.k], obj=objectifs[m.k], pct=Math.min(100,Math.round((val/obj)*100)), reste=Math.max(0,obj-val);
                const over=val>obj;
                return (
                  <div key={m.k} style={{marginBottom:10}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                      <span style={{fontSize:11,fontWeight:800,color:m.c}}>{m.l}</span>
                      <span style={{fontSize:11,fontWeight:700,color:"#6B7280"}}>
                        <span style={{fontWeight:900,color:over?"#C62828":m.c}}>{val.toFixed(1)}g</span> / {obj}g
                        {over
                          ? <span style={{color:"#C62828",fontWeight:800,marginLeft:6}}>+{(val-obj).toFixed(1)}g dépassé ⚠️</span>
                          : <span style={{color:"#7CB342",marginLeft:6}}>reste {reste.toFixed(1)}g</span>
                        }
                      </span>
                    </div>
                    <div style={{height:10,background:"#F3F4F6",borderRadius:5,overflow:"hidden"}}>
                      <div style={{height:"100%",width:`${pct}%`,background:over?"#C62828":m.c,borderRadius:5,transition:"width .3s"}}/>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* ── SCORE CÉTO ── */}
          {(()=>{
            const gluToday = (journal[todayStr()]||[]).reduce((s,e)=>s+e.glu,0);
            const sToday = gluToday===0 && (journal[todayStr()]||[]).length===0
              ? null
              : gluToday<=20 ? {l:"Excellent 🎉",c:"#2E7D32",bg:"#E8F5E9",msg:"Tu es en cétose !"}
              : gluToday<=30 ? {l:"Très bien 👍",c:"#7CB342",bg:"#F1F8E9",msg:"Presque parfait"}
              : gluToday<=50 ? {l:"Modéré ⚠️",c:"#F4A035",bg:"#FFF8F0",msg:"Réduis un peu"}
              : {l:"Attention ❌",c:"#C62828",bg:"#FFEBEE",msg:"Dépasse 50g"};
            if (!sToday) return null;
            return (
              <div style={{background:sToday.bg,border:`2px solid ${sToday.c}30`,borderRadius:14,padding:"14px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10,marginBottom:14}}>
                <div>
                  <div style={{fontSize:11,fontWeight:800,color:sToday.c,textTransform:"uppercase",letterSpacing:1,marginBottom:2}}>Score céto aujourd'hui</div>
                  <div style={{fontSize:22,fontWeight:900,color:sToday.c}}>{gluToday.toFixed(1)}g glucides — {sToday.l}</div>
                  <div style={{fontSize:11,color:sToday.c,opacity:.8}}>{sToday.msg}</div>
                </div>
                <button onClick={()=>{
                  const txt = `🥑 Mon score céto aujourd'hui : ${gluToday.toFixed(1)}g de glucides — ${sToday.l.replace(/[🎉👍⚠️❌]/g,"")}\nSuivi avec l'app gratuite Céto Club → https://app.cetoclub.com`;
                  navigator.clipboard?.writeText(txt).then(()=>alert("Score copié ! Colle-le où tu veux 🥑")).catch(()=>alert("Copie le lien : https://app.cetoclub.com"));
                }} style={{padding:"8px 14px",borderRadius:8,background:sToday.c,color:"#fff",border:"none",fontWeight:800,fontSize:11,cursor:"pointer",flexShrink:0}}>
                  📤 Partager mon score
                </button>
              </div>
            );
          })()}

          {/* ── SUGGESTIONS ── */}
          {journeeEntrees.length>0 && (
            <div style={{background:"#fff",borderRadius:12,border:"2px solid #F4A03530",padding:14,marginBottom:14}}>
              <div style={{fontSize:11,fontWeight:900,color:"#F4A035",marginBottom:8}}>💡 Suggestions</div>
              {(()=>{
                const resteLip = objectifs.lip - totalJ.lip;
                const restePro = objectifs.pro - totalJ.pro;
                const resteGlu = objectifs.glu - totalJ.glu;
                const suggestions = [];
                if (resteLip > 30) suggestions.push({e:"🧈",titre:"Manque de lipides",items:["Huile d'olive (+14g/c.à.s)","Avocat (+15g/100g)","Noix de macadamia (+76g/100g)","Beurre (+82g/100g)"],c:"#E65100",bg:"#FFF3E0"});
                if (resteLip > 0 && resteLip <= 30) suggestions.push({e:"🥑",titre:"Petit boost lipides",items:["Olives (quelques)","Crème fraîche (+30g/100g)","Fromage maturé (+27g/100g)"],c:"#E65100",bg:"#FFF3E0"});
                if (restePro > 20) suggestions.push({e:"💪",titre:"Manque de protéines",items:["Oeufs (+13g/100g)","Saumon (+20g/100g)","Poulet (+20g/100g)","Thon (+29g/100g)"],c:"#2A5298",bg:"#E3F2FD"});
                if (restePro > 0 && restePro <= 20) suggestions.push({e:"🥚",titre:"Petit boost protéines",items:["1 oeuf (+6g)","Yaourt grec (+9g/100g)","Fromage maturé (+22g/100g)"],c:"#2A5298",bg:"#E3F2FD"});
                if (resteGlu < 3 && resteGlu >= 0) suggestions.push({e:"⚠️",titre:"Glucides presque atteints",items:["Privilégie viandes & poissons","Évite fruits & légumes sucrés","Eau, café, thé sans sucre ✓"],c:"#C62828",bg:"#FFEBEE"});
                if (totalJ.glu > objectifs.glu) suggestions.push({e:"🚨",titre:"Glucides dépassés",items:["Stoppe les glucides pour aujourd'hui","Compense avec lipides & protéines","Hydrate-toi bien"],c:"#C62828",bg:"#FFEBEE"});
                if (suggestions.length === 0) return <div style={{textAlign:"center",padding:"8px 0",color:"#7CB342",fontSize:12,fontWeight:800}}>✅ Bilan bien équilibré !</div>;
                return suggestions.map((s,i)=>(
                  <div key={i} style={{background:s.bg,borderRadius:8,padding:"8px 10px",marginBottom:i<suggestions.length-1?6:0,border:`1px solid ${s.c}20`}}>
                    <div style={{fontSize:11,fontWeight:900,color:s.c,marginBottom:4}}>{s.e} {s.titre}</div>
                    {s.items.map((item,j)=>(
                      <div key={j} style={{display:"flex",gap:5,alignItems:"flex-start",marginBottom:2}}>
                        <div style={{width:4,height:4,borderRadius:"50%",background:s.c,marginTop:4,flexShrink:0}}/>
                        <span style={{fontSize:10,color:"#1a2a1a",lineHeight:1.4}}>{item}</span>
                      </div>
                    ))}
                  </div>
                ));
              })()}
            </div>
          )}

          {/* ── LIGNE DE LA SEMAINE ── */}
          {(()=>{
            const joursOkSemaine = [0,1,2,3,4,5,6].filter(d=>{
              const dt = new Date(); dt.setDate(dt.getDate()-d);
              const k = dt.toISOString().split("T")[0];
              const entries = journal[k]||[];
              return entries.length>0 && entries.reduce((s,e)=>s+e.glu,0)<=20;
            }).length;
            const joursConsecutifs = (()=>{
              let n=0, dt=new Date();
              while(true){
                const k=dt.toISOString().split("T")[0];
                const entries=journal[k]||[];
                if(entries.length>0 && entries.reduce((s,e)=>s+e.glu,0)<=20){n++;dt.setDate(dt.getDate()-1);}
                else break;
              }
              return n;
            })();
            return (
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:16}}>
                {[
                  {l:"Jours ≤20g cette semaine",v:`${joursOkSemaine}/7`,c:"#7CB342",bg:"#F1F8E9"},
                  {l:"Jours consécutifs en céto",v:`${joursConsecutifs} 🔥`,c:"#F4A035",bg:"#FFF8F0"},
                  {l:"Recette du jour",v:recetteJour.emoji,c:"#1B3A6B",bg:"#F0F4FF",link:true},
                ].map((s,i)=>(
                  <div key={i} onClick={s.link?()=>setPage("recettes"):undefined}
                    style={{background:s.bg,border:`1.5px solid ${s.c}25`,borderRadius:10,padding:"10px 8px",textAlign:"center",cursor:s.link?"pointer":"default"}}>
                    <div style={{fontSize:s.link?24:18,fontWeight:900,color:s.c}}>{s.v}</div>
                    <div style={{fontSize:9,color:"#6B7280",lineHeight:1.3,marginTop:2}}>{s.l}</div>
                  </div>
                ))}
              </div>
            );
          })()}

            </div>}
          </div>

          {/* ══════════════════════════════════════════════════════ */}
          {/* ── BANDEAU PREMIUM : ENREGISTRER MES FUTURS REPAS ── */}
          {/* ══════════════════════════════════════════════════════ */}
          {(()=>{
            if (!PREMIUM_ACTIF) {
              return (
                <BandeauPremium
                  titre="📅 Anticiper ses repas"
                  description="Anticipe tes repas sur le mois à venir. Planifie chaque journée à l'avance — les repas du jour se transfèrent automatiquement dans ton journal."
                  onClick={()=>setPage("premium")}
                />
              );
            }
            // Version premium : bandeau dépliable
            const today = todayStr();
            const demain = (() => { const d=new Date(); d.setDate(d.getDate()+1); return d.toISOString().split("T")[0]; })();
            const dans30j = (() => { const d=new Date(); d.setDate(d.getDate()+30); return d.toISOString().split("T")[0]; })();
            const MOIS_FR = ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];
            const JOURS_FR = ["L","M","M","J","V","S","D"];

            // Si on est en mode saisie pour une date
            if (futurDate) {
              const entreesDate = journalFutur[futurDate] || [];
              const dateAffichee = (() => {
                const d = new Date(futurDate+"T12:00:00");
                return d.toLocaleDateString("fr-FR",{weekday:"long",day:"numeric",month:"long"});
              })();
              return (
                <div style={{borderRadius:14,marginBottom:14,boxShadow:"0 2px 12px rgba(27,58,107,0.10)"}}>
                  {/* Header */}
                  <div style={{background:"linear-gradient(90deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:"14px 14px 0 0"}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <button onClick={()=>{ setFuturDate(null); setFuturRepasOuvert(null); setFuturJSel(null); setFuturJSearch(""); setFuturJSearchRes([]); }} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:8,color:"#fff",fontSize:16,fontWeight:900,cursor:"pointer",padding:"4px 10px"}}>‹</button>
                      <div>
                        <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>📅 {dateAffichee}</div>
                        <div style={{fontSize:10,color:"rgba(255,255,255,0.7)"}}>Repas planifiés</div>
                      </div>
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",flexShrink:0}}>
                      <span style={{fontSize:13}}>💎</span>
                      <span style={{fontSize:11,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
                    </div>
                  </div>
                  <div style={{background:"#fff",border:"2px solid #1B3A6B20",borderTop:"none",borderRadius:"0 0 14px 14px",padding:14}}>
                    {/* 3 cases repas futur */}
                    <div style={{display:"grid",gridTemplateColumns:"1fr",gap:10,marginBottom:14}}>
                      {[1,2,3].map(num => {
                        const repasEntrees = entreesDate.filter(e=>(e.repas||1)===num);
                        const totaux = repasEntrees.reduce((acc,e)=>({lip:acc.lip+e.lip,glu:acc.glu+e.glu,pro:acc.pro+e.pro}),{lip:0,glu:0,pro:0});
                        const ouvert = futurRepasOuvert===num;
                        return (
                          <div key={num} style={{background:"#fff",borderRadius:12,border:`2px solid ${ouvert?"#1B3A6B":"#1B3A6B15"}`,transition:"border .2s"}}>
                            <div onClick={()=>setFuturRepasOuvert(ouvert?null:num)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 16px",cursor:"pointer",background:ouvert?"#F0F4FF":"#fff"}}>
                              <div style={{display:"flex",alignItems:"center",gap:10}}>
                                <div style={{width:32,height:32,borderRadius:8,background:ouvert?"#1B3A6B":"#F3F4F6",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>
                                  {num===1?"🌅":num===2?"☀️":"🌙"}
                                </div>
                                <div>
                                  <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B"}}>Repas {num}</div>
                                  {repasEntrees.length>0
                                    ? <div style={{fontSize:10,color:"#6B7280"}}>{repasEntrees.length} aliment{repasEntrees.length>1?"s":""} · <span style={{color:"#C62828",fontWeight:800}}>{totaux.glu.toFixed(1)}g glu</span></div>
                                    : <div style={{fontSize:10,color:"#9CA3AF",fontStyle:"italic"}}>Aucun aliment planifié</div>
                                  }
                                </div>
                              </div>
                              <div style={{display:"flex",alignItems:"center",gap:8}}>
                                {repasEntrees.length>0 && (
                                  <div style={{display:"flex",gap:8,fontSize:10,color:"#6B7280"}}>
                                    <span style={{color:"#E65100",fontWeight:700}}>{totaux.lip.toFixed(1)}g lip</span>
                                    <span style={{color:"#2A5298",fontWeight:700}}>{totaux.pro.toFixed(1)}g pro</span>
                                  </div>
                                )}
                                <div style={{fontSize:18,color:"#1B3A6B",transition:"transform .2s",transform:ouvert?"rotate(180deg)":"rotate(0deg)"}}>⌄</div>
                              </div>
                            </div>
                            {ouvert && (
                              <div style={{padding:"0 16px 16px",borderTop:"1px solid #F3F4F6"}}>
                                {repasEntrees.length>0 && (
                                  <div style={{marginTop:10,marginBottom:10,border:"1px solid #F3F4F6",borderRadius:8,overflow:"hidden"}}>
                                    {repasEntrees.map((e,i)=>(
                                      <div key={e.id} style={{borderBottom:"1px solid #F3F4F6",background:i%2===0?"#fff":"#FAFAF7"}}>
                                        <div style={{display:"grid",gridTemplateColumns:"1fr 38px 34px 34px 34px 24px 24px",gap:2,alignItems:"center",padding:"6px 6px",minWidth:0}}>
                                          <div style={{minWidth:0,overflow:"hidden"}}>
                                            <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{e.nom}</div>
                                            {e.marque&&<div style={{fontSize:9,color:"#7CB342",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{e.marque}</div>}
                                          </div>
                                          <div style={{textAlign:"center",fontSize:11,fontWeight:700,color:"#6B7280"}}>{e.source==="recette"?`${e.gram} part${e.gram>1?"s":""}`:e.unite?`x${e.gram}`:`${e.gram}g`}</div>
                                          <div style={{textAlign:"center",fontSize:11,fontWeight:800,color:"#E65100"}}>{e.lip.toFixed(1)}</div>
                                          <div style={{textAlign:"center",fontSize:11,fontWeight:800,color:"#C62828"}}>{e.glu.toFixed(1)}</div>
                                          <div style={{textAlign:"center",fontSize:11,fontWeight:800,color:"#2A5298"}}>{e.pro.toFixed(1)}</div>
                                          <button onClick={()=>{setFuturEditEntreeId(e.id===futurEditEntreeId?null:e.id);setFuturEditEntreeGram(String(e.gram));}} style={{background:"none",border:"none",cursor:"pointer",fontSize:13,padding:0}}>✏️</button>
                                          <button onClick={()=>removeFuturEntree(e.id)} style={{background:"none",border:"none",cursor:"pointer",color:"#C62828",fontSize:13,padding:0}}>🗑️</button>
                                        </div>
                                        {futurEditEntreeId===e.id && (
                                          <div style={{display:"flex",gap:8,alignItems:"center",padding:"6px 10px 10px",background:"#F1F8E9"}}>
                                            <span style={{fontSize:11,color:"#6B7280",flex:1}}>Modifier la quantité :</span>
                                            <input type="number" min="1" max="2000" value={futurEditEntreeGram} onChange={ev=>setFuturEditEntreeGram(ev.target.value)} style={{width:70,padding:"6px 8px",border:"2px solid #7CB34250",borderRadius:6,fontSize:14,fontWeight:900,textAlign:"center",outline:"none"}}/>
                                            <span style={{fontSize:11,color:"#6B7280"}}>g</span>
                                            <button onClick={()=>saveFuturEditEntree(e.id)} style={{padding:"6px 14px",borderRadius:6,background:"#1B3A6B",color:"#fff",border:"none",fontWeight:800,fontSize:12,cursor:"pointer"}}>✓</button>
                                            <button onClick={()=>setFuturEditEntreeId(null)} style={{padding:"6px 10px",borderRadius:6,background:"none",border:"1px solid #ccc",color:"#6B7280",fontWeight:700,fontSize:11,cursor:"pointer"}}>✕</button>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                )}
                                <div style={{marginTop:10}}>
                                  {!futurJSel ? (
                                    <>
                                      <input
                                        value={futurJSearch}
                                        onChange={e=>doFuturJSearch(e.target.value)}
                                        placeholder="🔍 Tape un aliment (ex: poulet, oeuf…)"
                                        autoComplete="off"
                                        style={{width:"100%",padding:"11px 12px",border:"2px solid #1B3A6B40",borderRadius:8,fontSize:14,outline:"none",boxSizing:"border-box",background:"#fff"}}
                                      />
                                      {futurJSearchRes.length>0 && (
                                        <div style={{marginTop:4,border:"2px solid #1B3A6B20",borderRadius:8,background:"#fff",maxHeight:220,overflowY:"scroll",scrollbarWidth:"auto",paddingRight:4}}>
                                          {futurJSearchRes.map(a=>(
                                            <div key={a.id+a.source}
                                              onClick={()=>{
                                                if(a.source==="recette"){
                                                  const recObj = recettes.find(r=>r.id===a.id);
                                                  if(recObj){ addFuturRecetteAuJournal(recObj); setFuturJSearchRes([]); setFuturJSearch(""); }
                                                } else {
                                                  setFuturJSel(a); setFuturJGram(a.unite?1:100); setFuturJSearchRes([]); setFuturJSearch("");
                                                }
                                              }}
                                              style={{padding:"11px 14px",cursor:"pointer",borderBottom:"1px solid #F3F4F6",display:"flex",justifyContent:"space-between",alignItems:"center",background:"#fff"}}
                                              onMouseEnter={e=>e.currentTarget.style.background="#F1F8E9"}
                                              onMouseLeave={e=>e.currentTarget.style.background="#fff"}
                                            >
                                              <div style={{display:"flex",alignItems:"center",gap:8}}>
                                                <span style={{fontSize:14,fontWeight:700,color:"#1B3A6B"}}>{a.nom}</span>
                                                {a.source==="recette"&&<span style={{fontSize:9,background:"#F0F4FF",color:"#2A5298",padding:"2px 6px",borderRadius:4,fontWeight:800}}>Ma recette</span>}
                                                {a.source==="perso"&&<span style={{fontSize:9,background:"#FFF8F0",color:"#F4A035",padding:"2px 6px",borderRadius:4,fontWeight:800}}>Perso</span>}
                                              </div>
                                              {a.source==="recette"
                                                ?<span style={{fontSize:12,color:"#2A5298",fontWeight:800}}>{a.glu}g glu/part</span>
                                                :<span style={{fontSize:12,color:"#C62828",fontWeight:800}}>{a.glu}g glu/100g</span>
                                              }
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                      {futurJSearch.length>1 && futurJSearchRes.length===0 && (
                                        <div style={{marginTop:4,padding:"10px 14px",background:"#F3F4F6",borderRadius:8,fontSize:12,color:"#6B7280"}}>
                                          Aucun résultat pour «&nbsp;{futurJSearch}&nbsp;» — essaie un autre mot
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <div style={{background:"#F1F8E9",border:"2px solid #7CB34250",borderRadius:10,padding:14}}>
                                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                                        <div style={{fontSize:14,fontWeight:900,color:"#1B3A6B"}}>{futurJSel.nom}</div>
                                        <button onClick={()=>{setFuturJSel(null);setFuturJSearch("");setFuturJSearchRes([]);}} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:"#9CA3AF",padding:0}}>✕</button>
                                      </div>
                                      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                                        <input
                                          type="number" min="1" max="2000"
                                          value={futurJGram}
                                          onChange={e=>setFuturJGram(e.target.value===""?"":Math.max(1,+e.target.value))}
                                          style={{width:80,padding:"10px",border:"2px solid #1B3A6B40",borderRadius:8,fontSize:16,fontWeight:900,textAlign:"center",outline:"none"}}
                                        />
                                        <span style={{fontSize:13,color:"#6B7280"}}>{futurJSel.unite?"unité(s)":"g"}</span>
                                        <div style={{fontSize:12,color:"#6B7280"}}>
                                          🧈 {(futurJSel.unite?futurJSel.lip*(+futurJGram||1):(futurJSel.lip*(+futurJGram||100))/100).toFixed(1)}g &nbsp;🌾 {(futurJSel.unite?futurJSel.glu*(+futurJGram||1):(futurJSel.glu*(+futurJGram||100))/100).toFixed(1)}g &nbsp;💪 {(futurJSel.unite?futurJSel.pro*(+futurJGram||1):(futurJSel.pro*(+futurJGram||100))/100).toFixed(1)}g
                                        </div>
                                      </div>
                                      <button onClick={addFuturEntree} style={{width:"100%",padding:"12px",borderRadius:8,background:"#1B3A6B",color:"#fff",border:"none",fontWeight:900,fontSize:14,cursor:"pointer"}}>
                                        ✓ Ajouter au repas {num}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                    {/* Bilan du jour planifié */}
                    {entreesDate.length>0 && (()=>{
                      const tot = entreesDate.reduce((acc,e)=>({lip:acc.lip+e.lip,glu:acc.glu+e.glu,pro:acc.pro+e.pro}),{lip:0,glu:0,pro:0});
                      return (
                        <div style={{background:"#F0F4FF",borderRadius:10,padding:"12px 14px",marginTop:8,fontSize:12}}>
                          <div style={{fontWeight:900,color:"#1B3A6B",marginBottom:6}}>Bilan planifié</div>
                          <div style={{display:"flex",gap:16}}>
                            <span style={{color:"#E65100",fontWeight:800}}>🧈 {tot.lip.toFixed(1)}g lip</span>
                            <span style={{color:"#C62828",fontWeight:800}}>🌾 {tot.glu.toFixed(1)}g glu</span>
                            <span style={{color:"#2A5298",fontWeight:800}}>💪 {tot.pro.toFixed(1)}g pro</span>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              );
            }

            // Mode calendrier
            const calMois = (() => {
              const d = new Date(demain);
              return { annee: d.getFullYear(), mois: d.getMonth() };
            })();

            return (
              <div style={{borderRadius:14,marginBottom:14,boxShadow:"0 2px 12px rgba(27,58,107,0.10)"}}>
                {/* Header dépliable */}
                <button onClick={()=>setOpenFutursRepas(!openFutursRepas)} style={{width:"100%",padding:"14px 16px",borderRadius:openFutursRepas?"14px 14px 0 0":14,background:"linear-gradient(90deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <span>📅 Anticiper ses repas</span>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",flexShrink:0}}>
                      <span style={{fontSize:13}}>💎</span>
                      <span style={{fontSize:11,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
                    </div>
                    <span style={{fontSize:12,opacity:0.8}}>{openFutursRepas?"▲":"▼"}</span>
                  </div>
                </button>
                {openFutursRepas && (()=>{
                  // Construire le calendrier dynamiquement sur 30j à partir de demain
                  const days = [];
                  for (let i=0; i<30; i++) {
                    const d = new Date(); d.setDate(d.getDate()+1+i);
                    days.push(d.toISOString().split("T")[0]);
                  }
                  // Grouper par mois
                  const moisGroups = {};
                  days.forEach(dateStr => {
                    const d = new Date(dateStr+"T12:00:00");
                    const key = `${d.getFullYear()}-${d.getMonth()}`;
                    if (!moisGroups[key]) moisGroups[key] = {annee:d.getFullYear(),mois:d.getMonth(),jours:[]};
                    moisGroups[key].jours.push(dateStr);
                  });

                  return (
                    <div style={{background:"#fff",border:"2px solid #1B3A6B20",borderTop:"none",borderRadius:"0 0 14px 14px",padding:14}}>
                      <div style={{fontSize:12,color:"#6B7280",marginBottom:14,lineHeight:1.5}}>
                        Sélectionne un jour pour planifier tes repas à l'avance. Ils s'ajouteront automatiquement à ton journal le jour J.
                      </div>
                      {Object.values(moisGroups).map(({annee,mois,jours}) => {
                        // Construire la grille du mois
                        const premierJourDuMois = new Date(annee,mois,1);
                        const decalage = (premierJourDuMois.getDay()+6)%7;
                        const nbJoursDuMois = new Date(annee,mois+1,0).getDate();
                        // Tous les jours du mois (pas que ceux dans les 30j)
                        const joursSet = new Set(jours);
                        const cases = [];
                        for(let i=0;i<decalage;i++) cases.push(null);
                        for(let j=1;j<=nbJoursDuMois;j++) {
                          const dateStr = `${annee}-${String(mois+1).padStart(2,"0")}-${String(j).padStart(2,"0")}`;
                          cases.push({j, dateStr, actif: joursSet.has(dateStr)});
                        }
                        return (
                          <div key={`${annee}-${mois}`} style={{marginBottom:18}}>
                            <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:8,textAlign:"center"}}>{MOIS_FR[mois]} {annee}</div>
                            {/* En-tête jours */}
                            <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3,marginBottom:3}}>
                              {JOURS_FR.map((j,i)=>(
                                <div key={i} style={{textAlign:"center",fontSize:11,fontWeight:800,color:"#6B7280",padding:"2px 0"}}>{j}</div>
                              ))}
                            </div>
                            {/* Grille */}
                            <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:3}}>
                              {cases.map((c,i) => {
                                if (!c) return <div key={i} style={{aspectRatio:"1",minHeight:38}}/>;
                                const nbRepas = (journalFutur[c.dateStr]||[]).length;
                                const hasData = nbRepas > 0;
                                return (
                                  <button
                                    key={i}
                                    onClick={()=>{ if(c.actif){ setFuturDate(c.dateStr); setFuturRepasOuvert(null); setFuturJSel(null); setFuturJSearch(""); setFuturJSearchRes([]); }}}
                                    disabled={!c.actif}
                                    style={{
                                      aspectRatio:"1",minHeight:38,padding:"3px 2px",
                                      background: hasData?"#F1F8E9":c.actif?"#F0F4FF":"#F9FAFB",
                                      color: !c.actif?"#D1D5DB":"#1B3A6B",
                                      border:`1.5px solid ${hasData?"#7CB342":c.actif?"#2A529840":"#E5E7EB"}`,
                                      borderRadius:8,fontSize:12,fontWeight:c.actif?800:400,
                                      cursor:c.actif?"pointer":"default",
                                      display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:1,
                                      fontFamily:"inherit",opacity:c.actif?1:0.4
                                    }}>
                                    <div>{c.j}</div>
                                    {hasData && <div style={{fontSize:7}}>🍽️</div>}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                      <div style={{marginTop:4,padding:"8px 10px",background:"#F9FAFB",borderRadius:8,fontSize:10,color:"#6B7280",lineHeight:1.6}}>
                        🍽️ Repas planifié · Les jours grisés sont hors de la fenêtre de 30 jours
                      </div>
                    </div>
                  );
                })()}
              </div>
            );
          })()}

          {/* ── Courbes macros 7 jours (premium) ── */}
          {PREMIUM_ACTIF ? (()=>{
            const objMacros = getObjectifsEffectifs();
            const jours7 = Array.from({length:7},(_,i)=>{
              const d = new Date(); d.setDate(d.getDate()-6+i);
              const dateKey = d.toISOString().split("T")[0];
              try {
                // Le journal est stocké dans un seul objet { "YYYY-MM-DD": [...entrées] }
                const journalAll = JSON.parse(localStorage.getItem("cetoclub_journal")||"{}");
                const entries = journalAll[dateKey] || [];
                return {
                  label: d.toLocaleDateString("fr-FR",{weekday:"short"}).slice(0,3),
                  glu: parseFloat(entries.reduce((s,e)=>s+(e.glu||0),0).toFixed(1)),
                  lip: parseFloat(entries.reduce((s,e)=>s+(e.lip||0),0).toFixed(1)),
                  pro: parseFloat(entries.reduce((s,e)=>s+(e.pro||0),0).toFixed(1)),
                };
              } catch { return {label:d.toLocaleDateString("fr-FR",{weekday:"short"}).slice(0,3),glu:0,lip:0,pro:0}; }
            });

            const series = [
              {k:"lip", l:"Lipides",   couleur:"#7CB342", obj:objMacros.lip},
              {k:"pro", l:"Protéines", couleur:"#2A5298", obj:objMacros.pro},
              {k:"glu", l:"Glucides",  couleur:"#C62828", obj:objMacros.glu},
            ];

            // Calcul de l'échelle commune
            const allVals = jours7.flatMap(j=>[j.glu,j.lip,j.pro]);
            const allObj = series.map(s=>s.obj);
            const maxVal = Math.max(...allVals,...allObj,1);

            const W=300, H=140, PL=32, PR=10, PT=12, PB=22;
            const pw = W-PL-PR, ph = H-PT-PB;
            const px = (i) => PL + (i/(jours7.length-1))*pw;
            const py = (v) => PT + (1 - Math.min(v/maxVal,1))*ph;

            return (
              <div style={{borderRadius:14,marginTop:14,boxShadow:"0 2px 12px rgba(27,58,107,0.10)"}}>
                <div onClick={()=>setOpenMacros(!openMacros)} style={{background:"linear-gradient(90deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:openMacros?"14px 14px 0 0":14,cursor:"pointer"}}>
                  <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>📊 Mes macros sur 7 jours</div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px"}}>
                      <span style={{fontSize:13}}>💎</span>
                      <span style={{fontSize:11,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
                    </div>
                    <span style={{fontSize:12,color:"rgba(255,255,255,0.7)"}}>{openMacros?"▲":"▼"}</span>
                  </div>
                </div>
                {openMacros && <div style={{background:"#fff",padding:16,borderRadius:"0 0 14px 14px"}}>
                <div style={{fontSize:10,color:"#9CA3AF",marginBottom:12}}>Lignes pointillées = tes objectifs personnels</div>

                {/* Légende */}
                <div style={{display:"flex",gap:12,marginBottom:10,flexWrap:"wrap"}}>
                  {series.map(s=>(
                    <div key={s.k} style={{display:"flex",alignItems:"center",gap:5}}>
                      <div style={{width:20,height:3,background:s.couleur,borderRadius:2}}/>
                      <span style={{fontSize:10,fontWeight:800,color:s.couleur}}>{s.l}</span>
                      <span style={{fontSize:9,color:"#9CA3AF"}}>obj. {s.obj}g</span>
                    </div>
                  ))}
                </div>

                {/* Graphique SVG */}
                <div style={{overflowX:"auto"}}>
                  <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{overflow:"visible",display:"block"}}>
                    {/* Grille horizontale */}
                    {[0,0.25,0.5,0.75,1].map((t,i)=>(
                      <g key={i}>
                        <line x1={PL} y1={PT+ph*t} x2={W-PR} y2={PT+ph*t} stroke="#F3F4F6" strokeWidth="1"/>
                        <text x={PL-4} y={PT+ph*t+3} textAnchor="end" fontSize="8" fill="#9CA3AF">{Math.round(maxVal*(1-t))}</text>
                      </g>
                    ))}
                    {/* Lignes objectifs (pointillées) */}
                    {series.map(s=>(
                      <line key={s.k+"-obj"}
                        x1={PL} y1={py(s.obj)} x2={W-PR} y2={py(s.obj)}
                        stroke={s.couleur} strokeWidth="1" strokeDasharray="4,3" opacity="0.5"/>
                    ))}
                    {/* Courbes — uniquement si au moins un jour a des données */}
                    {series.map(s=>{
                      const vals = jours7.map(j=>j[s.k]);
                      if (vals.every(v=>v===0)) return null;
                      const pts = jours7.map((j,i)=>`${px(i)},${py(j[s.k])}`).join(" ");
                      const aire = `${px(0)},${PT+ph} ${jours7.map((j,i)=>`${px(i)},${py(j[s.k])}`).join(" ")} ${px(6)},${PT+ph}`;
                      return (
                        <g key={s.k}>
                          <polygon points={aire} fill={s.couleur} fillOpacity="0.05"/>
                          <polyline points={pts} fill="none" stroke={s.couleur} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round"/>
                          {jours7.map((j,i)=>j[s.k]>0?(
                            <circle key={i} cx={px(i)} cy={py(j[s.k])} r="3" fill="#fff" stroke={s.couleur} strokeWidth="2"/>
                          ):null)}
                        </g>
                      );
                    })}
                    {/* Labels X */}
                    {jours7.map((j,i)=>(
                      <text key={i} x={px(i)} y={H-4} textAnchor="middle" fontSize="9" fill="#9CA3AF">{j.label}</text>
                    ))}
                  </svg>
                </div>

                {/* Moyenne du jour */}
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginTop:12}}>
                  {series.map(s=>{
                    const moy = (jours7.reduce((a,j)=>a+j[s.k],0)/7).toFixed(1);
                    const pct = Math.round((parseFloat(moy)/s.obj)*100);
                    return (
                      <div key={s.k} style={{background:"#F8FAFF",borderRadius:8,padding:"8px 6px",textAlign:"center",borderTop:`3px solid ${s.couleur}`}}>
                        <div style={{fontSize:9,color:"#9CA3AF",marginBottom:2}}>{s.l} moy/j</div>
                        <div style={{fontSize:15,fontWeight:900,color:s.couleur}}>{moy}g</div>
                        <div style={{fontSize:9,color:pct>100?"#C62828":pct>80?"#F4A035":"#7CB342",fontWeight:700}}>{pct}% obj.</div>
                      </div>
                    );
                  })}
                </div>
                </div>}
              </div>
            );
          })() : (
            <BandeauPremium
              titre="📊 Mes macros sur 7 jours"
              description="Courbes glucides, lipides et protéines superposées sur 7 jours avec tes objectifs personnels en pointillés. Vois en un coup d'œil si tu respectes tes macros céto."
              onClick={()=>setPage("premium")}
            />
          )}



          </div>)} {/* ── FIN ONGLET NUTRITION ── */}

          {/* ══════════════════════════════════════════════════════ */}
          {/* ── ONGLET CORPS ── (à venir) */}
          {/* ══════════════════════════════════════════════════════ */}
          {/* ══════════════════════════════════════════════════════ */}
          {/* ── ONGLET CORPS ── */}
          {/* ══════════════════════════════════════════════════════ */}
          {tabJournal==="corps" && (
            <div>

              {/* ── Conseils poids ── */}
              <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
                <button onClick={()=>setOpenConseilsPoids(!openConseilsPoids)} style={{width:"100%",padding:"14px 16px",borderRadius:openConseilsPoids?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>💡 Le poids en céto</span>
                  <span style={{fontSize:12,opacity:0.8}}>{openConseilsPoids?"▲":"▼"}</span>
                </button>
                {openConseilsPoids && (
                  <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                    <div style={{display:"grid",gap:6}}>
                      {[
                        {e:"🌅", t:"Pesée une fois par semaine, le matin", c:"Toujours dans les mêmes conditions, à jeun. Se peser tous les jours crée du stress, des blocages, des obsessions et le cortisol qui les accompagne — et le cortisol fait stocker."},
                        {e:"💧", t:"La fonte au début c'est de l'eau", c:"Pour chaque molécule de sucre perdue, ton corps libère 4 molécules d'eau. La perte rapide des premiers jours est réelle, mais c'est de l'eau. La graisse, elle, part ensuite, progressivement."},
                        {e:"💪", t:"Le muscle pèse plus que la graisse", c:"Si tu fais du sport, tu peux stagner en poids tout en affinant ta silhouette. Les mensurations sont souvent bien plus révélatrices que la balance."},
                        {e:"📏", t:"Les mesures ne mentent pas", c:"Tour de taille, hanches, cuisses — ces chiffres reflètent la perte de graisse réelle, indépendamment de l'eau, du muscle ou des hormones. En céto, le corps se recompose souvent avant de maigrir au sens strict : les cm partent avant les kg, avant de mincir."},
                        {e:"⏸️", t:"Un plateau ? Ton corps guérit", c:"Un plateau en céto c'est le corps qui travaille sur les inflammations, qui soigne des problèmes dont tu n'as même pas conscience. Ce n'est pas du temps perdu — jamais. Tu guéris."},
                        {e:"😄", t:"Joie obligatoire !", c:"Un bon moral aide à la perte de poids. Si tu stresses, ton corps se croit en guerre et stocke pour survivre. En céto, la joie n'est pas un luxe — c'est une stratégie."},
                      ].map((c,i)=>(
                        <div key={i} style={{background:"#F1F8E9",border:"1.5px solid #7CB342",borderRadius:8,padding:"8px 10px",display:"flex",gap:8,alignItems:"flex-start"}}>
                          <span style={{fontSize:16,flexShrink:0,marginTop:1}}>{c.e}</span>
                          <div>
                            <div style={{fontSize:11,fontWeight:800,color:"#2E7D32",marginBottom:2}}>{c.t}</div>
                            <div style={{fontSize:11,color:"#374151",lineHeight:1.5}}>{c.c}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* ── Poids ── */}
              <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
                <button onClick={()=>setOpenPoids(!openPoids)} style={{width:"100%",padding:"14px 16px",borderRadius:openPoids?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>⚖️ Enregistrer mon poids</span>
                  <span style={{fontSize:12,opacity:0.8}}>{openPoids?"▲":"▼"}</span>
                </button>
                {openPoids && <div style={{background:"#fff",border:"2px solid #1B3A6B15",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:12}}>⚖️ Mon poids</div>
                <div style={{display:"flex",gap:8,marginBottom:12}}>
                  <input type="number" step="0.1" min="30" max="300"
                    value={poidsSaisi} onChange={e=>setPoidsSaisi(e.target.value)}
                    placeholder="Ex: 72.5"
                    style={{flex:1,padding:"10px 12px",border:"2px solid #7CB342",borderRadius:8,fontSize:16,fontWeight:900,outline:"none"}}/>
                  <button onClick={()=>{
                    const p = parseFloat(poidsSaisi);
                    if(!p||p<30||p>300){alert("Poids invalide");return;}
                    const today = todayStr();
                    const updated = [...poidsHistorique.filter(e=>e.date!==today),{date:today,poids:p}].sort((a,b)=>a.date.localeCompare(b.date));
                    setPoidsHistorique(updated);
                    try{localStorage.setItem("cetoclub_poids",JSON.stringify(updated));}catch{}
                    const newProfil={...profil,poids:String(p)};
                    setProfil(newProfil);
                    setProfilForm(f=>({...f,poids:String(p)}));
                    try{localStorage.setItem("cetoclub_profil",JSON.stringify(newProfil));}catch{}
                    setPoidsSaisi("");
                  }} style={{padding:"10px 18px",borderRadius:8,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer"}}>
                    ✓ Enregistrer
                  </button>
                </div>
                {poidsHistorique.length>0 && (()=>{
                  const derniere = poidsHistorique[poidsHistorique.length-1];
                  const premiere = poidsHistorique[0];
                  const delta = (derniere.poids - premiere.poids).toFixed(1);
                  return (
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:12}}>
                      {[
                        {l:"Poids actuel",v:derniere.poids+"kg",c:"#1B3A6B"},
                        {l:"Poids de départ",v:premiere.poids+"kg",c:"#6B7280"},
                        {l:"Évolution",v:(parseFloat(delta)>0?"+":"")+delta+"kg",c:parseFloat(delta)<0?"#7CB342":"#C62828"},
                      ].map(m=>(
                        <div key={m.l} style={{background:"#F8FAFF",borderRadius:10,padding:"10px 8px",textAlign:"center"}}>
                          <div style={{fontSize:16,fontWeight:900,color:m.c}}>{m.v}</div>
                          <div style={{fontSize:9,color:"#9ca3af",marginTop:2}}>{m.l}</div>
                        </div>
                      ))}
                    </div>
                  );
                })()}
                {(()=>{
                  const derniere = poidsHistorique.length>0 ? poidsHistorique[poidsHistorique.length-1] : null;
                  const premiere = poidsHistorique.length>0 ? poidsHistorique[0] : null;
                  return (
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",border:"2px solid #7CB342",borderRadius:12,marginBottom:12,background:"#fff",overflow:"hidden"}}>
                      {[
                        {l:"Départ",v:premiere?premiere.poids+"kg":profil&&profil.poids?profil.poids+"kg":"—"},
                        {l:"Actuel",v:derniere?derniere.poids+"kg":profil&&profil.poids?profil.poids+"kg":"—"},
                        {l:"Objectif",v:profil&&profil.poidsObjectif?profil.poidsObjectif+"kg":"—"},
                      ].map((m,i)=>(
                        <div key={m.l} style={{padding:"12px 8px",textAlign:"center",borderRight:i<2?"1px solid #7CB34230":"none"}}>
                          <div style={{fontSize:17,fontWeight:900,color:"#1B3A6B"}}>{m.v}</div>
                          <div style={{fontSize:10,color:"#9ca3af",marginTop:3}}>{m.l}</div>
                        </div>
                      ))}
                    </div>
                  );
                })()}
                </div>}
              </div>

              {/* ── Mensurations ── */}
              {mensHistorique !== undefined && (
                <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
                  <button onClick={()=>setOpenMensurations(!openMensurations)} style={{width:"100%",padding:"14px 16px",borderRadius:openMensurations?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span>📏 Enregistrer mes mensurations</span>
                    <span style={{fontSize:12,opacity:0.8}}>{openMensurations?"▲":"▼"}</span>
                  </button>
                  {openMensurations && <div style={{background:"#fff",border:"2px solid #1B3A6B15",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                  <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:12}}>📏 Mes mensurations</div>

                  {(()=>{
                    const peutMesurer = mensJoursDepuis() >= 7;
                    const joursRestants = 7 - mensJoursDepuis();
                    return peutMesurer ? (
                      <div style={{marginBottom:16}}>
                        <div style={{fontSize:10,fontWeight:800,color:"#F4A035",marginBottom:10}}>📏 C'est l'heure de tes mensurations !</div>
                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
                          {[{k:"taille",l:"Tour de taille",emoji:"👗"},{k:"hanches",l:"Hanches",emoji:"🍑"},{k:"cuisseD",l:"Cuisse droite",emoji:"🦵"},{k:"cuisseG",l:"Cuisse gauche",emoji:"🦵"}].map(f=>(
                            <div key={f.k}>
                              <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:4}}>{f.emoji} {f.l} (cm)</div>
                              <input type="number" min="20" max="200" step="0.1" value={mensForm[f.k]} onChange={e=>setMensForm(ff=>({...ff,[f.k]:e.target.value}))} placeholder="ex: 85"
                                style={{width:"100%",padding:"9px 12px",border:"2px solid #7CB34250",borderRadius:8,fontSize:14,fontWeight:800,outline:"none",textAlign:"center",boxSizing:"border-box"}}/>
                            </div>
                          ))}
                        </div>
                        <button onClick={ajouterMensurations} style={{width:"100%",padding:"11px",borderRadius:8,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer"}}>
                          ✓ Enregistrer mes mensurations
                        </button>
                      </div>
                    ) : (
                      <div style={{background:"#FFF8F0",border:"2px solid #F4A03530",borderRadius:10,padding:14,marginBottom:16,display:"flex",alignItems:"center",gap:14}}>
                        <div style={{fontSize:32}}>📏</div>
                        <div>
                          <div style={{fontSize:12,fontWeight:900,color:"#E65100",marginBottom:3}}>Mensurations — patience !</div>
                          <div style={{fontSize:11,color:"#F4A035",lineHeight:1.6}}>
                            Une fois par semaine suffit pour suivre ta progression.<br/>
                            <strong>Prochaines mensurations : dans {joursRestants} jour{joursRestants>1?"s":""}</strong>
                          </div>
                        </div>
                      </div>
                    );
                  })()}

                  {(()=>{
                        const first = mensHistorique.length>0 ? mensHistorique[0] : null;
                        const last = mensHistorique.length>0 ? mensHistorique[mensHistorique.length-1] : null;
                        return (
                          <div style={{border:"2px solid #7CB342",borderRadius:12,marginBottom:12,background:"#fff",overflow:"hidden"}}>
                            {[
                              [{l:"👗 Départ",v:first&&first.taille?first.taille+"cm":"—"},{l:"👗 Actuel",v:last&&last.taille?last.taille+"cm":"—"},{l:"🍑 Départ",v:first&&first.hanches?first.hanches+"cm":"—"},{l:"🍑 Actuel",v:last&&last.hanches?last.hanches+"cm":"—"}],
                              [{l:"🦵D Départ",v:first&&first.cuisseD?first.cuisseD+"cm":"—"},{l:"🦵D Actuel",v:last&&last.cuisseD?last.cuisseD+"cm":"—"},{l:"🦵G Départ",v:first&&first.cuisseG?first.cuisseG+"cm":"—"},{l:"🦵G Actuel",v:last&&last.cuisseG?last.cuisseG+"cm":"—"}],
                            ].map((row,ri)=>(
                              <div key={ri} style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",borderBottom:ri===0?"1px solid #7CB34220":"none"}}>
                                {row.map((m,i)=>(
                                  <div key={m.l} style={{padding:"9px 4px",textAlign:"center",borderRight:i<3?"1px solid #7CB34220":"none"}}>
                                    <div style={{fontSize:12,fontWeight:900,color:"#1B3A6B"}}>{m.v}</div>
                                    <div style={{fontSize:8,color:"#9ca3af",marginTop:2}}>{m.l}</div>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        );
                      })()}
                  {false && (
                    <div>
                      {(()=>{
                        const last = mensHistorique[mensHistorique.length-1];
                        const prev = mensHistorique.length>1 ? mensHistorique[mensHistorique.length-2] : null;
                        return (
                          <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8,marginBottom:14}}>
                            {[{k:"taille",l:"👗 Taille"},{k:"hanches",l:"🍑 Hanches"},{k:"cuisseD",l:"🦵 Cuisse D"},{k:"cuisseG",l:"🦵 Cuisse G"}].map(f=>{
                              const val=last[f.k]; const prevVal=prev?prev[f.k]:null;
                              const delta=(val&&prevVal)?(parseFloat(val)-parseFloat(prevVal)).toFixed(1):null;
                              if (!val) return null;
                              return (
                                <div key={f.k} style={{background:"#F3F4F6",borderRadius:8,padding:"8px 10px",textAlign:"center"}}>
                                  <div style={{fontSize:9,color:"#6B7280",fontWeight:700,marginBottom:2}}>{f.l}</div>
                                  <div style={{fontSize:16,fontWeight:900,color:"#1B3A6B"}}>{val} cm</div>
                                  {delta!==null&&<div style={{fontSize:10,fontWeight:800,color:parseFloat(delta)<0?"#7CB342":parseFloat(delta)>0?"#C62828":"#F4A035"}}>{parseFloat(delta)>0?"+":""}{delta} cm</div>}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })()}
                      <div style={{maxHeight:200,overflowY:"auto",marginTop:8}}>
                        <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
                          <thead>
                            <tr style={{background:"#F3F4F6"}}>
                              <th style={{padding:"6px 8px",textAlign:"left",fontWeight:800,color:"#1B3A6B",fontSize:10}}>Date</th>
                              <th style={{padding:"6px 4px",textAlign:"center",fontWeight:800,color:"#1B3A6B",fontSize:10}}>👗</th>
                              <th style={{padding:"6px 4px",textAlign:"center",fontWeight:800,color:"#1B3A6B",fontSize:10}}>🍑</th>
                              <th style={{padding:"6px 4px",textAlign:"center",fontWeight:800,color:"#1B3A6B",fontSize:10}}>🦵D</th>
                              <th style={{padding:"6px 4px",textAlign:"center",fontWeight:800,color:"#1B3A6B",fontSize:10}}>🦵G</th>
                              <th style={{padding:"6px 4px",width:26}}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {[...mensHistorique].reverse().map((d,i)=>{
                              const dd=new Date(d.date+"T12:00:00");
                              return (
                                <React.Fragment key={d.date}>
                                  <tr style={{borderBottom:"1px solid #F3F4F6"}}>
                                    <td style={{padding:"6px 8px",color:"#6B7280",fontSize:10}}>{dd.toLocaleDateString("fr-FR",{day:"numeric",month:"short"})}</td>
                                    <td style={{padding:"6px 4px",textAlign:"center",fontWeight:800,color:"#1B3A6B"}}>{d.taille||"—"}</td>
                                    <td style={{padding:"6px 4px",textAlign:"center",fontWeight:800,color:"#1B3A6B"}}>{d.hanches||"—"}</td>
                                    <td style={{padding:"6px 4px",textAlign:"center",fontWeight:800,color:"#1B3A6B"}}>{d.cuisseD||"—"}</td>
                                    <td style={{padding:"6px 4px",textAlign:"center",fontWeight:800,color:"#1B3A6B"}}>{d.cuisseG||"—"}</td>
                                    <td style={{padding:"6px 4px",textAlign:"center"}}>
                                      <div style={{display:"flex",gap:3,justifyContent:"center"}}>
                                        <button onClick={()=>{setEditMensDate(d.date===editMensDate?null:d.date);setEditMensForm({taille:d.taille||"",hanches:d.hanches||"",cuisseD:d.cuisseD||"",cuisseG:d.cuisseG||""});}} style={{background:"none",border:"none",cursor:"pointer",fontSize:12,padding:0}}>✏️</button>
                                        <button onClick={()=>saveMensHistorique(mensHistorique.filter(e=>e.date!==d.date))} style={{background:"none",border:"none",cursor:"pointer",color:"#C62828",fontSize:12,padding:0}}>🗑️</button>
                                      </div>
                                    </td>
                                  </tr>
                                  {editMensDate===d.date&&(
                                    <tr style={{background:"#FFF8F0"}}>
                                      <td colSpan={6} style={{padding:"10px 8px"}}>
                                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr auto",gap:6,alignItems:"center"}}>
                                          {[{k:"taille",l:"Taille"},{k:"hanches",l:"Hanches"},{k:"cuisseD",l:"C.Droite"},{k:"cuisseG",l:"C.Gauche"}].map(f=>(
                                            <div key={f.k}>
                                              <div style={{fontSize:9,color:"#6B7280",marginBottom:2}}>{f.l} cm</div>
                                              <input type="number" min="20" max="200" step="0.1" value={editMensForm[f.k]} onChange={ev=>setEditMensForm(ff=>({...ff,[f.k]:ev.target.value}))} style={{width:"100%",padding:"5px 6px",border:"2px solid #7CB34250",borderRadius:6,fontSize:13,fontWeight:800,textAlign:"center",outline:"none",boxSizing:"border-box"}}/>
                                            </div>
                                          ))}
                                          <div style={{display:"flex",gap:4,alignSelf:"flex-end"}}>
                                            <button onClick={()=>{saveMensHistorique(mensHistorique.map(e=>e.date===d.date?{...e,...editMensForm}:e));setEditMensDate(null);}} style={{padding:"6px 10px",borderRadius:6,background:"#F4A035",color:"#fff",border:"none",fontWeight:800,fontSize:12,cursor:"pointer"}}>✓</button>
                                            <button onClick={()=>setEditMensDate(null)} style={{padding:"6px 8px",borderRadius:6,background:"none",border:"1px solid #ccc",color:"#6B7280",fontWeight:700,fontSize:11,cursor:"pointer"}}>✕</button>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  </div>}
                </div>
              )}

              {/* ── Cétonémie & Glycémie ── */}
              {PREMIUM_ACTIF
                ? <ModuleBiologie />
                : <div onClick={()=>setPage("premium")} style={{borderRadius:14,marginBottom:12,background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:900,color:"#fff"}}>🔬 Cétonémie & Glycémie</div>
                      <div style={{fontSize:10,color:"rgba(255,255,255,0.7)",marginTop:2}}>Suivez vos mesures biologiques et partagez-les avec votre médecin</div>
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",flexShrink:0}}>
                      <span style={{fontSize:11}}>💎</span>
                      <span style={{fontSize:10,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
                    </div>
                  </div>
              }

              {/* ── Module Évolution (premium) ── */}
              {PREMIUM_ACTIF
                ? <ModuleEvolution todayStr={todayStr} poidsHistorique={poidsHistorique} mensHistorique={mensHistorique} />
                : <BandeauPremium titre="📊 Mon évolution" description="Courbes de poids, mensurations et photos mois après mois. Vois ta progression en un coup d'œil." onClick={()=>setPage("premium")}/>
              }
            </div>
          )}

          {/* ══════════════════════════════════════════════════════ */}
          {/* ── ONGLET ACTIVITÉ ── */}
          {/* ══════════════════════════════════════════════════════ */}
          {tabJournal==="activite" && (
            <div>

              {/* Recommandation selon poids */}
              {(()=>{
                const reco = recoActivite();
                return (
                  <div style={{background:"#F1F8E9",border:"2px solid #7CB342",borderRadius:14,padding:16,color:"#1a1a1a",marginBottom:14}}>
                    <div style={{fontSize:14,fontWeight:900,marginBottom:8,color:"#1a1a1a"}}>🎯 {reco.titre}</div>
                    <div style={{fontSize:11,lineHeight:1.7,marginBottom:10,color:"#374151"}}>{reco.message}</div>
                    <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                      {reco.activites.map((a,i)=>(
                        <span key={i} style={{background:"#E8F5E9",border:"1.5px solid #7CB342",borderRadius:6,padding:"3px 8px",fontSize:10,fontWeight:700,color:"#1a1a1a"}}>{a}</span>
                      ))}
                    </div>
                  </div>
                );
              })()}

              <BandeauPremium
                titre="🚶‍♀️ Activité Douce — Coaching guidé"
                description="Le mouvement doux, c'est le premier pas vers un corps qu'on réhabite. 30 exercices inspirés des recommandations kinésithérapeutiques, adaptés à tous les niveaux."
                onClick={()=>setPage(PREMIUM_ACTIF?"activite":"premium")}
              />

              {["marche","course","natation","velo","muscu"].map(sport=>(
                <BandeauSport key={sport} sport={sport} PREMIUM_ACTIF={PREMIUM_ACTIF} setPage={setPage}/>
              ))}

              {PREMIUM_ACTIF && <CourbesSport/>}

            </div>
          )}

          {/* ══════════════════════════════════════════════════════ */}
          {/* ── ONGLET JEÛNE ── */}
          {/* ══════════════════════════════════════════════════════ */}
          {tabJournal==="jeune" && (
            <div>

              {/* Écoute du corps */}
              <div style={{background:"#F1F8E9",border:"2px solid #7CB34230",borderRadius:14,padding:14,marginBottom:14,display:"flex",gap:12,alignItems:"flex-start"}}>
                <div style={{fontSize:28,flexShrink:0}}>🥑</div>
                <div>
                  <div style={{fontSize:12,fontWeight:900,color:"#2E7D32",marginBottom:3}}>Pas faim ? Écoute ton corps !</div>
                  <div style={{fontSize:11,color:"#558B2F",lineHeight:1.6}}>
                    Si tu n'as pas faim, saute simplement ce repas. C'est de l'écoute du corps — pas du jeûne structuré, et c'est déjà excellent.
                  </div>
                </div>
              </div>

              {/* Conseils jeûne */}
              <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
                <button onClick={()=>setOpenConseilsJeune(!openConseilsJeune)} style={{width:"100%",padding:"14px 16px",borderRadius:openConseilsJeune?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>💡 Conseils pour bien jeûner</span>
                  <span style={{fontSize:12,opacity:0.8}}>{openConseilsJeune?"▲":"▼"}</span>
                </button>
                {openConseilsJeune && (
                  <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                    <div style={{display:"grid",gap:6}}>
                      {conseilsJeune.map((c,i)=>(
                        <div key={i} style={{background:"#F1F8E9",border:"1.5px solid #7CB342",borderRadius:8,padding:"8px 10px",display:"flex",gap:8,alignItems:"flex-start"}}>
                          <span style={{fontSize:16,flexShrink:0,marginTop:1}}>{c.e}</span>
                          <div>
                            <div style={{fontSize:11,fontWeight:800,color:"#2E7D32",marginBottom:2}}>{c.t}</div>
                            <div style={{fontSize:11,color:"#374151",lineHeight:1.5}}>{c.c}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Chronomètre jeûne */}
              <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.08)"}}>
                <button onClick={()=>setOpenJeune(!openJeune)} style={{width:"100%",padding:"14px 18px",borderRadius:openJeune?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:14,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <span>⏱️ {jeuneActif?"Jeûne en cours":"Commencer un jeûne"}</span>
                    {(()=>{
                      const maintenant = new Date();
                      const debutSemaine = new Date(maintenant);
                      debutSemaine.setDate(maintenant.getDate() - maintenant.getDay());
                      debutSemaine.setHours(0,0,0,0);
                      const totalH = jeuneHistorique
                        .filter(j => j.fin && new Date(j.fin) >= debutSemaine)
                        .reduce((sum, j) => sum + (parseFloat(j.dureeH)||0), 0);
                      return <div style={{fontSize:10,color:"rgba(255,255,255,0.8)",marginTop:2}}>⏱️ Cette semaine : {totalH.toFixed(1)}h</div>;
                    })()}
                  </div>
                  <span style={{fontSize:12,opacity:0.8}}>{openJeune?"▲":"▼"}</span>
                </button>
                {openJeune && <div style={{background:"#fff",border:`2px solid ${jeuneActif?"#7CB342":"#1B3A6B20"}`,borderTop:"none",borderRadius:"0 0 14px 14px",padding:18}}>
                <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:14}}>⏱️ Mon jeûne</div>

                {/* Choix protocole — visible seulement si pas de jeûne actif */}
                {!jeuneActif && (
                  <div style={{marginBottom:14}}>
                    <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:8,textTransform:"uppercase",letterSpacing:1}}>Choisis ton protocole</div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                      {protocoles.map(p=>(
                        <button key={p.id} onClick={()=>setJeuneProtocole(p.id)}
                          style={{padding:"12px",borderRadius:10,border:`2px solid ${jeuneProtocole===p.id?"#7CB342":"#E5E7EB"}`,
                            background:jeuneProtocole===p.id?"#F1F8E9":"#fff",color:"#1a1a1a",cursor:"pointer",textAlign:"left"}}>
                          <div style={{fontWeight:900,fontSize:13,marginBottom:2,color:"#1a1a1a"}}>{p.l}</div>
                          <div style={{fontSize:9,opacity:.75,marginBottom:4,color:"#374151"}}>{p.d}</div>
                          <div style={{fontSize:9,color:jeuneProtocole===p.id?"#E65100":"#7CB342",fontStyle:"italic"}}>{p.bienfait}</div>
                        </button>
                      ))}
                    </div>

                    {/* Heure de début personnalisable */}
                    <div style={{marginTop:12,background:"#F8FAFF",borderRadius:10,padding:"10px 14px"}}>
                      <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:6}}>🕐 Heure de début du jeûne</div>
                      <div style={{display:"flex",gap:8,alignItems:"center"}}>
                        <input type="time" value={jeuneHeureDebut||new Date().toTimeString().slice(0,5)}
                          onChange={e=>setJeuneHeureDebut(e.target.value)}
                          style={{flex:1,padding:"8px 12px",border:"2px solid #7CB342",borderRadius:8,fontSize:14,fontWeight:800,outline:"none"}}/>
                        <div style={{fontSize:10,color:"#9CA3AF"}}>
                          → fin prévue {(()=>{
                            const h = jeuneHeureDebut||new Date().toTimeString().slice(0,5);
                            const [hh,mm] = h.split(":").map(Number);
                            const duree = protocoles.find(p=>p.id===jeuneProtocole)?.duree||16;
                            const fin = new Date(); fin.setHours(hh+duree,mm,0,0);
                            return fin.toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"});
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Minuteur actif */}
                {jeuneActif && (()=>{
                  const proto = protocoles.find(p=>p.id===jeuneActif.protocole)||{duree:16};
                  const msEcoule = jeuneNow - new Date(jeuneActif.debut);
                  const msCible = proto.duree*3600000;
                  const pct = Math.min(100,(msEcoule/msCible)*100);
                  const msRestant = Math.max(0, msCible-msEcoule);
                  const hR = Math.floor(msRestant/3600000);
                  const mR = Math.floor((msRestant%3600000)/60000);
                  const sR = Math.floor((msRestant%60000)/1000);
                  const termine = msRestant===0;
                  const hFin = new Date(new Date(jeuneActif.debut).getTime()+msCible);
                  return (
                    <div style={{textAlign:"center",marginBottom:14}}>
                      <div style={{fontSize:11,color:termine?"#7CB342":"#1B3A6B",fontWeight:800,marginBottom:8}}>
                        {termine ? "🎉 Jeûne terminé !" : `⏱️ ${protocoles.find(p=>p.id===jeuneActif.protocole)?.l||""} en cours`}
                      </div>
                      <div style={{fontSize:48,fontWeight:900,color:termine?"#7CB342":"#1B3A6B",marginBottom:8,fontVariantNumeric:"tabular-nums",lineHeight:1}}>
                        {String(hR).padStart(2,"0")}:{String(mR).padStart(2,"0")}:{String(sR).padStart(2,"0")}
                      </div>
                      <div style={{background:"#F3F4F6",borderRadius:8,height:10,marginBottom:10,overflow:"hidden"}}>
                        <div style={{width:`${pct}%`,height:"100%",background:termine?"#7CB342":"linear-gradient(90deg,#1B3A6B,#2A5298)",borderRadius:8,transition:"width .5s"}}/>
                      </div>
                      <div style={{display:"flex",justifyContent:"center",gap:16,fontSize:10,color:"#6B7280"}}>
                        <span>Démarré à {new Date(jeuneActif.debut).toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})}</span>
                        {!termine && <span>Fin prévue à {hFin.toLocaleTimeString("fr-FR",{hour:"2-digit",minute:"2-digit"})}</span>}
                      </div>
                    </div>
                  );
                })()}

                {/* Boutons action */}
                {!jeuneActif ? (
                  <button onClick={demarrerJeune}
                    style={{width:"100%",padding:"13px",borderRadius:10,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:15,cursor:"pointer"}}>
                    ▶ Démarrer le jeûne {jeuneProtocole}
                  </button>
                ) : (
                  <div>
                    {jeuneCorrection && (
                      <div style={{background:"#FFF8F0",border:"2px solid #F4A03540",borderRadius:12,padding:14,marginBottom:10}}>
                        <div style={{fontSize:12,fontWeight:900,color:"#E65100",marginBottom:10}}>✏️ Corriger l'heure de début</div>
                        <input type="time" id="correction-heure"
                          defaultValue={new Date(jeuneActif.debut).toTimeString().slice(0,5)}
                          style={{width:"100%",padding:"8px 12px",border:"2px solid #F4A035",borderRadius:8,fontSize:14,fontWeight:800,outline:"none",boxSizing:"border-box",marginBottom:10}}/>
                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                          <button onClick={()=>{
                            const val = document.getElementById("correction-heure").value;
                            if (!val) return;
                            const [hh,mm] = val.split(":").map(Number);
                            const newDebut = new Date(); newDebut.setHours(hh,mm,0,0);
                            const updated = {...jeuneActif, debut: newDebut.toISOString()};
                            saveJeuneActif(updated); setJeuneCorrection(false);
                          }} style={{padding:"10px",borderRadius:8,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:12,cursor:"pointer"}}>
                            ✓ Valider
                          </button>
                          <button onClick={()=>setJeuneCorrection(false)}
                            style={{padding:"10px",borderRadius:8,background:"#fff",color:"#6B7280",border:"1px solid #ccc",fontWeight:800,fontSize:12,cursor:"pointer"}}>
                            Annuler
                          </button>
                        </div>
                      </div>
                    )}
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
                      <button onClick={terminerJeune}
                        style={{padding:"12px",borderRadius:10,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:12,cursor:"pointer"}}>
                        ✅ Terminer
                      </button>
                      <button onClick={()=>setJeuneCorrection(!jeuneCorrection)}
                        style={{padding:"12px",borderRadius:10,background:"#FFF8F0",color:"#E65100",border:"2px solid #F4A035",fontWeight:900,fontSize:12,cursor:"pointer"}}>
                        ✏️ Corriger
                      </button>
                      <button onClick={()=>{ if(window.confirm("Annuler ce jeûne sans l'enregistrer ?")){ setJeuneActif(null); setJeuneCorrection(false); try{localStorage.removeItem("cetoclub_jeune_actif");}catch{} } }}
                        style={{padding:"12px",borderRadius:10,background:"#fff",color:"#C62828",border:"2px solid #C62828",fontWeight:900,fontSize:12,cursor:"pointer"}}>
                        ✕ Annuler
                      </button>
                    </div>
                  </div>
                )}
                </div>}
              </div>




              {/* Planning jeûne hebdomadaire */}
              {PREMIUM_ACTIF ? (
                  <div>
                    <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.08)"}}>
                      <div onClick={()=>setOpenPlanning(!openPlanning)} style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",borderRadius:openPlanning?"14px 14px 0 0":14}}>
                        <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>📅 Mon planning de jeûne</div>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <div style={{background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",display:"flex",alignItems:"center",gap:5}}>
                            <span style={{fontSize:11}}>💎</span><span style={{fontSize:10,fontWeight:900,color:"#fff"}}>PREMIUM</span>
                          </div>
                          <span style={{fontSize:12,color:"rgba(255,255,255,0.7)"}}>{openPlanning?"▲":"▼"}</span>
                        </div>
                      </div>
                      {openPlanning && <div style={{background:"#fff",borderRadius:"0 0 14px 14px",padding:14}}><PlanningJeune protocoles={protocoles}/></div>}
                    </div>
                    <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.08)"}}>
                      <div onClick={()=>setOpenFemme(!openFemme)} style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",borderRadius:openFemme?"14px 14px 0 0":14}}>
                        <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>🌸 Spécial Femme</div>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <div style={{background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",display:"flex",alignItems:"center",gap:5}}>
                            <span style={{fontSize:11}}>💎</span><span style={{fontSize:10,fontWeight:900,color:"#fff"}}>PREMIUM</span>
                          </div>
                          <span style={{fontSize:12,color:"rgba(255,255,255,0.7)"}}>{openFemme?"▲":"▼"}</span>
                        </div>
                      </div>
                      {openFemme && <div style={{background:"#fff",borderRadius:"0 0 14px 14px",padding:14}}><SpecialFemme/></div>}
                    </div>
                    <div style={{borderRadius:14,marginBottom:10,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.08)"}}>
                      <div onClick={()=>setOpenCourbes(!openCourbes)} style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",borderRadius:openCourbes?"14px 14px 0 0":14}}>
                        <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>📈 Courbes de mes jeûnes</div>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <div style={{background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",display:"flex",alignItems:"center",gap:5}}>
                            <span style={{fontSize:11}}>💎</span><span style={{fontSize:10,fontWeight:900,color:"#fff"}}>PREMIUM</span>
                          </div>
                          <span style={{fontSize:12,color:"rgba(255,255,255,0.7)"}}>{openCourbes?"▲":"▼"}</span>
                        </div>
                      </div>
                      {openCourbes && <div style={{background:"#fff",borderRadius:"0 0 14px 14px",padding:14,fontSize:11,color:"#6B7280"}}>Courbes à venir 📊</div>}
                    </div>
                  </div>
              ) : (
                <div>
                  <BandeauPremium titre="📅 Mon planning de jeûne" description="Programme tes jours de jeûne ON/OFF, ton heure de début et ton protocole pour chaque jour de la semaine." onClick={()=>setPage("premium")}/>
                  <BandeauPremium titre="🌸 Spécial Femme" description="Adapte ton jeûne à ton cycle hormonal ou à la ménopause. Recommandations personnalisées pour chaque phase." onClick={()=>setPage("premium")}/>
                  <BandeauPremium titre="📈 Courbes de mes jeûnes" description="Visualise tes heures de jeûne semaine après semaine. Suis ta progression et tes habitudes dans le temps." onClick={()=>setPage("premium")}/>
                </div>
              )}

            </div>
          )}

          {/* ══════════════════════════════════════════════════════ */}
          {/* ── ONGLET BIEN-ÊTRE ── */}
          {/* ══════════════════════════════════════════════════════ */}
          {tabJournal==="bienetre" && (
            <div>

              {/* Sommeil */}
              <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
                {/* Conseils pour bien dormir — bandeau vert dépliable */}
                <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
                  <button onClick={()=>setOpenConseils(!openConseils)} style={{width:"100%",padding:"14px 16px",borderRadius:openConseils?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span>💡 Conseils pour bien dormir</span>
                    <span style={{fontSize:12,opacity:0.8}}>{openConseils?"▲":"▼"}</span>
                  </button>
                  {openConseils && (
                    <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                      <div style={{display:"grid",gap:6}}>
                        {[
                          {e:"🌡️", t:"Température fraîche", c:"La chambre idéale est entre 16 et 18°C. Le céto peut augmenter la température corporelle la nuit."},
                          {e:"🍽️", t:"Dîner léger et tôt", c:"Terminer de manger 3h avant de dormir aide l'endormissement et prolonge naturellement le jeûne."},
                          {e:"☀️", t:"Lumière le matin", c:"10 min de lumière naturelle au réveil recale ton horloge biologique et améliore le sommeil de la nuit suivante."},
                          {e:"🧂", t:"Magnésium et hydratation", c:"Une carence en magnésium, fréquente en céto, peut causer crampes et réveils nocturnes. Privilégie les eaux riches en magnésium (plus de 50mg/L, indiqué sur l'étiquette) ou un complément le soir. Des urines trop foncées sont un signe de déshydratation : bois légèrement salé ou ajoute une pincée de bicarbonate de sodium à ton eau."},
                          {e:"📵", t:"Écrans -1h", c:"La lumière bleue des écrans fait croire à ton cerveau qu'il fait encore jour, empêchant la mélatonine de s'activer. Le soir, préfère un livre ou de la musique."},
                          {e:"🔄", t:"Régularité avant tout", c:"Se coucher et se lever à la même heure est le levier le plus puissant pour la qualité du sommeil, céto ou pas."},
                        ].map((c,i)=>(
                          <div key={i} style={{background:"#F1F8E9",border:"1.5px solid #7CB342",borderRadius:8,padding:"8px 10px",display:"flex",gap:8,alignItems:"flex-start"}}>
                            <span style={{fontSize:16,flexShrink:0,marginTop:1}}>{c.e}</span>
                            <div>
                              <div style={{fontSize:11,fontWeight:800,color:"#2E7D32",marginBottom:2}}>{c.t}</div>
                              <div style={{fontSize:11,color:"#374151",lineHeight:1.5}}>{c.c}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <button onClick={()=>setOpenSommeil(!openSommeil)} style={{width:"100%",padding:"14px 16px",borderRadius:openSommeil?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>🌙 Enregistrer mon sommeil{sommeilAujourdhui?` · ✓ ${sommeilAujourdhui.dureeH}h`:""}</span>
                  <span style={{fontSize:12,opacity:0.8}}>{openSommeil?"▲":"▼"}</span>
                </button>
                {openSommeil && <div style={{background:"#fff",border:"2px solid #1B3A6B15",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:12}}>
                  🌙 Mon sommeil
                  {sommeilAujourdhui && <span style={{fontSize:10,color:"#7CB342",fontWeight:700,marginLeft:8}}>✓ {sommeilAujourdhui.dureeH}h enregistrées</span>}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
                  <div>
                    <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:4}}>🌙 Coucher</div>
                    <input type="time" value={sommeilForm.heureCoucher}
                      onChange={e=>setSommeilForm(f=>({...f,heureCoucher:e.target.value}))}
                      style={{width:"100%",padding:"8px 10px",border:"2px solid #1B3A6B30",borderRadius:8,fontSize:14,fontWeight:800,outline:"none",boxSizing:"border-box"}}/>
                  </div>
                  <div>
                    <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:4}}>☀️ Lever</div>
                    <input type="time" value={sommeilForm.heureReveil}
                      onChange={e=>setSommeilForm(f=>({...f,heureReveil:e.target.value}))}
                      style={{width:"100%",padding:"8px 10px",border:"2px solid #1B3A6B30",borderRadius:8,fontSize:14,fontWeight:800,outline:"none",boxSizing:"border-box"}}/>
                  </div>
                </div>
                {(()=>{
                  const [hC,mC]=sommeilForm.heureCoucher.split(":").map(Number);
                  const [hR,mR]=sommeilForm.heureReveil.split(":").map(Number);
                  let d=(hR*60+mR)-(hC*60+mC); if(d<0) d+=1440;
                  return <div style={{background:"#F0F4FF",borderRadius:8,padding:"8px 12px",marginBottom:10,fontSize:12,fontWeight:900,color:"#1B3A6B",textAlign:"center"}}>⏱️ Durée estimée : {(d/60).toFixed(1)}h</div>;
                })()}
                <div style={{marginBottom:10}}>
                  <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:6}}>Qualité</div>
                  <div style={{display:"flex",gap:6}}>
                    {[{v:"1",l:"😩 Mauvaise"},{v:"2",l:"😐 Moyenne"},{v:"3",l:"😌 Bonne"},{v:"4",l:"🌟 Excellente"}].map(opt=>(
                      <button key={opt.v} onClick={()=>setSommeilForm(f=>({...f,qualite:opt.v}))}
                        style={{flex:1,padding:"6px 4px",borderRadius:7,border:`1.5px solid ${sommeilForm.qualite===opt.v?"#7CB342":"#D1D5DB"}`,
                          background:sommeilForm.qualite===opt.v?"#F1F8E9":"#fff",fontSize:10,cursor:"pointer",fontWeight:sommeilForm.qualite===opt.v?900:400}}>
                        {opt.l}
                      </button>
                    ))}
                  </div>
                </div>
                <button onClick={saveSommeilJour} style={{width:"100%",padding:"10px",borderRadius:8,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:12,cursor:"pointer"}}>
                  ✓ Enregistrer mon sommeil
                </button>
                </div>}
              </div>

              {/* Humeur du jour */}
              <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
                <button onClick={()=>setOpenRessenti(!openRessenti)} style={{width:"100%",padding:"14px 16px",borderRadius:openRessenti?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>🌅 Comment tu te sens ?{suiviAujourdhui?" · ✓ Enregistré":""}</span>
                  <span style={{fontSize:12,opacity:0.8}}>{openRessenti?"▲":"▼"}</span>
                </button>
                {openRessenti && <div style={{background:"#fff",border:"2px solid #1B3A6B15",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                <div style={{marginBottom:14}}>
                  <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:6}}>
                    🌅 Comment tu te sens aujourd'hui ?
                    {suiviAujourdhui && <span style={{fontSize:10,color:"#7CB342",fontWeight:700,marginLeft:8}}>✓ Enregistré</span>}
                  </div>
                  <div style={{background:"#FFF8F0",border:"1.5px solid #F4A03540",borderRadius:10,padding:"9px 12px",fontSize:11,color:"#E65100",lineHeight:1.6,fontStyle:"italic"}}>
                    💡 Il est prouvé qu'on peut tromper son cerveau — tu es triste ? Souris. Ton cerveau pense que tu es heureux et t'envoie des hormones de joie.
                  </div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8,marginBottom:12}}>
                  {[
                    {k:"energie", l:"⚡ Énergie",  opts:[{v:"1",l:"😴",d:"Épuisé"},{v:"2",l:"😑",d:"Fatigué"},{v:"3",l:"😐",d:"Normal"},{v:"4",l:"😊",d:"En forme"},{v:"5",l:"🚀",d:"Au top"}], border:"#2A529855", bg:"#F0F4FF"},
                    {k:"humeur",  l:"😊 Humeur",   opts:[{v:"1",l:"😢",d:"Déprimé"},{v:"2",l:"😕",d:"Morose"},{v:"3",l:"😐",d:"Neutre"},{v:"4",l:"🙂",d:"Bien"},{v:"5",l:"😄",d:"Super"}], border:"#F4A03555", bg:"#FFF8F0"},
                    {k:"sommeil", l:"🌙 Sommeil",  opts:[{v:"1",l:"😩",d:"Très mal"},{v:"2",l:"😐",d:"Moyen"},{v:"3",l:"😌",d:"Bien dormi"}], border:"#7CB34255", bg:"#F1F8E9"},
                    {k:"faim",    l:"🍽️ Faim du jour", opts:[{v:"1",l:"😌",d:"Pas faim"},{v:"2",l:"🙂",d:"Un peu"},{v:"3",l:"😐",d:"Modérée"},{v:"4",l:"😋",d:"Bien faim"},{v:"5",l:"🤤",d:"Très faim"}], border:"#C6282855", bg:"#FFF5F5"},
                  ].map(f=>(
                    <div key={f.k} style={{border:`1.5px solid ${f.border}`,borderRadius:10,padding:"8px 6px",background:f.bg}}>
                      <div style={{fontSize:10,fontWeight:800,color:"#6B7280",marginBottom:6,textAlign:"center"}}>{f.l}</div>
                      <div style={{display:"flex",gap:3,flexWrap:"wrap",justifyContent:"center"}}>
                        {f.opts.map(opt=>(
                          <button key={opt.v} onClick={()=>setSuiviForm(ff=>({...ff,[f.k]:opt.v}))}
                            style={{flex:1,padding:"4px 2px",borderRadius:7,
                              border:`1.5px solid ${suiviForm[f.k]===opt.v?"#7CB342":"transparent"}`,
                              background:suiviForm[f.k]===opt.v?"#F1F8E9":"transparent",fontSize:14,cursor:"pointer",textAlign:"center"}}>
                            <div>{opt.l}</div>
                            <div style={{fontSize:8,color:suiviForm[f.k]===opt.v?"#558B2F":"#9CA3AF",fontWeight:600,marginTop:1,lineHeight:1.2}}>{opt.d}</div>
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                <button onClick={saveSuiviJour} style={{width:"100%",padding:"10px",borderRadius:8,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:12,cursor:"pointer"}}>
                  ✓ Enregistrer mon ressenti
                </button>
                </div>}
              </div>

              <div style={{borderRadius:14,marginBottom:14,overflow:"hidden",boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
                <button onClick={()=>setOpenRespiration(!openRespiration)} style={{width:"100%",padding:"14px 16px",borderRadius:openRespiration?"14px 14px 0 0":14,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>🫁 Les 5 types de respiration</span>
                  <span style={{fontSize:12,opacity:0.8}}>{openRespiration?"▲":"▼"}</span>
                </button>
                {openRespiration && <div style={{background:"#fff",border:"2px solid #7CB34230",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                  <div style={{fontSize:11,color:"#6B7280",marginBottom:14,lineHeight:1.5}}>5 techniques scientifiquement validées pour réduire le cortisol, améliorer le sommeil et soutenir ta perte de poids en céto.</div>
                  {TECHS_RESP.map((t) => (
                    <div key={t.id} style={{borderRadius:10,border:"1.5px solid #E5E7EB",padding:"10px 12px",marginBottom:8,background:"#F9FAFB"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3}}>
                        <div style={{fontWeight:900,fontSize:12,color:"#1B3A6B"}}>{t.nom}</div>
                        <span style={{fontSize:10,padding:"2px 8px",borderRadius:20,fontWeight:700,background:"#FFF3E0",color:"#F4A035",border:"1px solid #F4A03555"}}>{t.rythme}</span>
                      </div>
                      <div style={{fontSize:10,color:"#7CB342",fontWeight:700,marginBottom:3}}>{t.quand}</div>
                      <div style={{fontSize:11,color:"#6B7280",lineHeight:1.5}}>{t.desc}</div>
                    </div>
                  ))}
                </div>}
              </div>

              <BandeauPremium
                titre="🫁 Respiration guidée — Coaching animé"
                description="5 techniques scientifiques (Cohérence cardiaque, 4-7-8, Box Breathing...) avec animation canvas, sons, minuteur et journal de tes séances."
                onClick={()=>setPage(PREMIUM_ACTIF?"respiration":"premium")}
              />

              {/* ── BANDEAU PREMIUM : MES NOTES PERSO ── */}
              {(()=>{
                if (!PREMIUM_ACTIF) {
                  return (
                    <BandeauPremium
                      titre="📓 Mes notes perso"
                      description="Ton journal privé : écris tes ressentis, victoires et difficultés. Chaque note est datée automatiquement et conservée dans l'app."
                      onClick={()=>setPage("premium")}
                    />
                  );
                }
                const formatDateNote = (dateStr) => {
                  const d = new Date(dateStr+"T12:00:00");
                  return d.toLocaleDateString("fr-FR",{weekday:"long",day:"numeric",month:"long",year:"numeric"});
                };
                return (
                  <div style={{borderRadius:14,marginBottom:14,boxShadow:"0 2px 8px rgba(27,58,107,0.06)"}}>
                    <button onClick={()=>setOpenNotesPerso(!openNotesPerso)} style={{width:"100%",padding:"14px 16px",borderRadius:openNotesPerso?"14px 14px 0 0":14,background:"linear-gradient(90deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",fontWeight:900,fontSize:13,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span>📓 Mes notes perso</span>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px",flexShrink:0}}>
                          <span style={{fontSize:13}}>💎</span>
                          <span style={{fontSize:11,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
                        </div>
                        <span style={{fontSize:12,opacity:0.8}}>{openNotesPerso?"▲":"▼"}</span>
                      </div>
                    </button>
                    {openNotesPerso && (
                      <div style={{background:"#fff",border:"2px solid #1B3A6B15",borderTop:"none",borderRadius:"0 0 14px 14px",padding:16}}>
                        <div style={{background:"#F0F4FF",borderRadius:10,padding:12,marginBottom:14}}>
                          <div style={{fontSize:11,fontWeight:800,color:"#1B3A6B",marginBottom:8}}>
                            📅 {formatDateNote(todayStr())}
                          </div>
                          <textarea
                            value={notePersoTexte}
                            onChange={e=>setNotePersoTexte(e.target.value)}
                            placeholder="Comment s'est passée ta journée ? Tes ressentis, tes victoires, tes difficultés..."
                            rows={4}
                            style={{width:"100%",padding:"10px 12px",border:"2px solid #1B3A6B30",borderRadius:10,fontSize:12,outline:"none",resize:"none",fontFamily:"inherit",boxSizing:"border-box",lineHeight:1.6,background:"#fff"}}
                            onFocus={e=>e.target.style.borderColor="#1B3A6B"}
                            onBlur={e=>e.target.style.borderColor="#1B3A6B30"}
                          />
                          <button onClick={ajouterNotePerso} style={{width:"100%",marginTop:8,padding:"10px",borderRadius:8,background:"linear-gradient(135deg,#1B3A6B,#2A5298)",color:"#fff",border:"none",fontWeight:900,fontSize:12,cursor:"pointer"}}>
                            ✓ Ajouter cette note
                          </button>
                        </div>
                        {notesPerso.length === 0 ? (
                          <div style={{textAlign:"center",padding:"16px 0",fontSize:12,color:"#9CA3AF",fontStyle:"italic"}}>
                            Aucune note pour l'instant. Écris ta première note ci-dessus !
                          </div>
                        ) : (
                          <div style={{display:"flex",flexDirection:"column",gap:8}}>
                            {notesPerso.map(note=>(
                              <div key={note.id} style={{border:"1.5px solid #E5E7EB",borderRadius:10,padding:"10px 12px",background:"#FAFAF7"}}>
                                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}}>
                                  <div style={{fontSize:10,fontWeight:800,color:"#1B3A6B"}}>{formatDateNote(note.date)}</div>
                                  <button onClick={()=>supprimerNotePerso(note.id)} style={{background:"none",border:"none",cursor:"pointer",color:"#C62828",fontSize:14,padding:"0 2px",flexShrink:0}}>🗑️</button>
                                </div>
                                <div style={{fontSize:12,color:"#374151",lineHeight:1.6,whiteSpace:"pre-wrap"}}>{note.texte}</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })()}


              {PREMIUM_ACTIF ? (()=>{
                // Données 7 jours
                const jours7 = Array.from({length:7},(_,i)=>{
                  const d = new Date(); d.setDate(d.getDate()-6+i);
                  const dateKey = d.toISOString().split("T")[0];
                  const label = d.toLocaleDateString("fr-FR",{weekday:"short"}).slice(0,3);
                  try {
                    const suivi = JSON.parse(localStorage.getItem("cetoclub_suivi")||"{}")[dateKey];
                    const som = JSON.parse(localStorage.getItem("cetoclub_sommeil")||"{}")[dateKey];
                    return {
                      label,
                      energie: suivi ? parseFloat(suivi.energie||0) : 0,
                      humeur:  suivi ? parseFloat(suivi.humeur||0)  : 0,
                      faim:    suivi ? parseFloat(suivi.faim||0)    : 0,
                      somDuree: som  ? parseFloat(som.dureeH||0)    : 0,
                      somQual:  som  ? parseFloat(som.qualite||0)   : 0,
                    };
                  } catch { return {label,energie:0,humeur:0,faim:0,somDuree:0,somQual:0}; }
                });

                const W=300, H=120, PL=28, PR=8, PT=10, PB=20;
                const pw=W-PL-PR, ph=H-PT-PB;
                const px = i => PL+(i/(jours7.length-1))*pw;
                const pyScale = (v,max) => PT+(1-Math.min(v/max,1))*ph;

                // Graphe 1 : Énergie, Humeur, Faim (échelle 0-5)
                const series1 = [
                  {k:"energie", l:"Énergie",  c:"#F4A035", ideal:4},
                  {k:"humeur",  l:"Humeur",   c:"#9C27B0", ideal:4},
                  {k:"faim",    l:"Faim",     c:"#C62828", ideal:2},
                ];
                // Graphe 2 : Sommeil durée (0-10h) et qualité (0-4)
                const series2 = [
                  {k:"somDuree", l:"Durée (h)", c:"#7CB342", ideal:8, max:10},
                  {k:"somQual",  l:"Qualité",   c:"#2A5298", ideal:3, max:4},
                ];

                const renderGraph = (series, max, title) => (
                  <div style={{background:"#fff",borderRadius:12,padding:"12px 14px",marginBottom:12,border:"1px solid #F3F4F6"}}>
                    <div style={{fontSize:12,fontWeight:900,color:"#1B3A6B",marginBottom:8}}>{title}</div>
                    <div style={{display:"flex",gap:10,marginBottom:8,flexWrap:"wrap"}}>
                      {series.map(s=>(
                        <div key={s.k} style={{display:"flex",alignItems:"center",gap:4}}>
                          <div style={{width:16,height:3,background:s.c,borderRadius:2}}/>
                          <span style={{fontSize:9,fontWeight:800,color:s.c}}>{s.l}</span>
                        </div>
                      ))}
                    </div>
                    <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{overflow:"visible",display:"block"}}>
                      {[0,0.25,0.5,0.75,1].map((t,i)=>(
                        <g key={i}>
                          <line x1={PL} y1={PT+ph*t} x2={W-PR} y2={PT+ph*t} stroke="#F3F4F6" strokeWidth="1"/>
                          <text x={PL-4} y={PT+ph*t+3} textAnchor="end" fontSize="7" fill="#9CA3AF">{Math.round((max||5)*(1-t))}</text>
                        </g>
                      ))}
                      {series.map(s=>(
                        <line key={s.k+"-ideal"}
                          x1={PL} y1={pyScale(s.ideal, s.max||max||5)} x2={W-PR} y2={pyScale(s.ideal, s.max||max||5)}
                          stroke={s.c} strokeWidth="1.5" strokeDasharray="4,3" opacity="0.5"/>
                      ))}
                      {series.map(s=>{
                        const vals = jours7.map(j=>j[s.k]);
                        if (vals.every(v=>v===0)) return null;
                        const pts = jours7.map((j,i)=>`${px(i)},${pyScale(j[s.k],s.max||max||5)}`).join(" ");
                        return (
                          <g key={s.k}>
                            <polyline points={pts} fill="none" stroke={s.c} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round"/>
                            {jours7.map((j,i)=>j[s.k]>0?(
                              <circle key={i} cx={px(i)} cy={pyScale(j[s.k],s.max||max||5)} r="3" fill="#fff" stroke={s.c} strokeWidth="2"/>
                            ):null)}
                          </g>
                        );
                      })}
                      {jours7.map((j,i)=>(
                        <text key={i} x={px(i)} y={H-4} textAnchor="middle" fontSize="8" fill="#9CA3AF">{j.label}</text>
                      ))}
                    </svg>
                  </div>
                );

                return (
                  <div style={{borderRadius:14,overflow:"hidden",boxShadow:"0 2px 12px rgba(27,58,107,0.10)"}}>
                    <div onClick={()=>setOpenBienetre(!openBienetre)} style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"14px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderRadius:openBienetre?"14px 14px 0 0":14,cursor:"pointer"}}>
                      <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>📈 Courbes de mon bien-être</div>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px"}}>
                          <span style={{fontSize:11}}>💎</span>
                          <span style={{fontSize:10,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
                        </div>
                        <span style={{fontSize:12,color:"rgba(255,255,255,0.7)"}}>{openBienetre?"▲":"▼"}</span>
                      </div>
                    </div>
                    {openBienetre && (
                      <div style={{background:"#F8FAFF",padding:"12px"}}>
                        <div style={{fontSize:9,color:"#9CA3AF",marginBottom:10}}>— — — idéal · —— enregistré</div>
                        {renderGraph(series1, 5, "😊 Énergie · Humeur · Faim")}
                        {renderGraph(series2, 10, "🌙 Sommeil")}
                      </div>
                    )}
                  </div>
                );
              })() : (
                <BandeauPremium
                  titre="📈 Courbes de mon bien-être"
                  description="Énergie, humeur, sommeil, faim — visualise tes courbes sur 7 jours avec les niveaux idéaux en pointillés."
                  onClick={()=>setPage("premium")}
                />
              )}

            </div>
          )}

        </main>
      )}

      
      {/* ── PAGE MERCI — après paiement Stripe ── */}
      {MERCI_URL && <PageMerci />}

      {/* ── PAGE PREMIUM — visible uniquement via ?sophie=true pendant les tests ── */}
      {page==="premium" && <PagePremium setPage={setPage} codeInput={codeInput} setCodeInput={setCodeInput} codeError={codeError} codeSuccess={codeSuccess} activerCodePremium={activerCodePremium} />}

      {page==="scanner" && PREMIUM_ACTIF && <ModuleScanner setPage={setPage} produits={produits} />}

      {page==="respiration" && PREMIUM_ACTIF && (
        <div style={{maxWidth:600,margin:"0 auto"}}>
          <ModuleRespiration onRetour={() => setPage("journal")} />
        </div>
      )}

      {page==="activite" && PREMIUM_ACTIF && (
        <div style={{maxWidth:600,margin:"0 auto"}}>
          <ModuleActivite onRetour={() => setPage("journal")} />
        </div>
      )}

      {page==="podometre" && PREMIUM_ACTIF && (
        <div style={{maxWidth:600,margin:"0 auto",fontFamily:"Georgia,serif",background:"#FAFAF7",minHeight:"100vh"}}>
          <div style={{background:"linear-gradient(135deg,#1B3A6B 0%,#2A5298 100%)",padding:"24px 20px 20px",position:"relative",overflow:"hidden"}}>
            <div style={{position:"absolute",top:0,right:0,width:100,height:100,background:"rgba(255,255,255,0.05)",borderRadius:"0 0 0 100%"}}/>
            <button onClick={()=>setPage("journal")} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:8,color:"rgba(255,255,255,0.7)",padding:"4px 10px",fontSize:12,cursor:"pointer",marginBottom:10,fontFamily:"Georgia,serif"}}>← Retour</button>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <h1 style={{margin:"0 0 4px",color:"#fff",fontSize:24,fontWeight:"normal"}}>👟 Coaching Marche</h1>
                <div style={{color:"rgba(255,255,255,0.7)",fontSize:12}}>Objectif personnalisé · mis à jour à chaque pesée</div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:6,background:"linear-gradient(135deg,#F4A035,#E65100)",borderRadius:20,padding:"4px 12px"}}>
                <span style={{fontSize:11}}>💎</span>
                <span style={{fontSize:10,fontWeight:900,color:"#fff",letterSpacing:0.5}}>PREMIUM</span>
              </div>
            </div>
          </div>
          <div style={{padding:16}}>
            <PodometrePremium/>
          </div>
        </div>
      )}

      {page==="mentions" && (
        <main style={{maxWidth:700,margin:"0 auto",padding:"16px 12px",overflowX:"hidden",boxSizing:"border-box",width:"100%"}}>
          <div style={{textAlign:"center",marginBottom:24}}>
            <h1 style={{fontSize:22,fontWeight:900,color:"#1B3A6B",margin:"0 0 4px"}}>📋 Mentions Légales</h1>
            <button onClick={()=>history.back?history.back():setPage("profil")} style={{fontSize:11,color:"#7CB342",background:"none",border:"none",cursor:"pointer",fontWeight:700}}>← Retour</button>
          </div>
          {[
            {t:"1. Éditeur de l'application",c:"Dénomination sociale : Association Cuisiner pour la Paix — Céto Club\nForme juridique : Association à but non lucratif régie par la loi du 1er juillet 1901\nNuméro de déclaration en préfecture : W751230210\nSiège social : 13 rue de l'Yvette, 75016 Paris, France\nAdresse e-mail : contact@cetoclub.com\nSite web : cetoclub.com\nCommunauté : facebook.com/groups/cetoclub\n\nLe directeur de la publication est le représentant légal de l'association en exercice."},
            {t:"2. Hébergement",c:"L'application web Céto Club est hébergée par :\nVercel Inc. — 440 N Barranca Ave #4133, Covina, CA 91723, USA\nSite web : vercel.com\n\nLes données saisies dans l'application (profil, journal, objectifs, bien-être) sont stockées exclusivement en local sur l'appareil de l'utilisateur via le mécanisme localStorage du navigateur. Aucune donnée personnelle n'est transmise à des serveurs tiers."},
            {t:"3. Sources des données",c:"Données nutritionnelles : Base de données Ciqual 2020 de l'ANSES (Agence nationale de sécurité sanitaire de l'alimentation, de l'environnement et du travail) — données publiques librement réutilisables.\n\nDonnées produits alimentaires : © Open Food Facts — openfoodfacts.org — Licence Open Database License (ODbL). Attribution obligatoire conformément aux termes de la licence."},
            {t:"4. Propriété intellectuelle",c:"Le contenu éditorial, les textes, les conseils, l'interface graphique, le logo et la charte graphique de l'application Céto Club sont la propriété exclusive de l'Association Cuisiner pour la Paix — Céto Club.\n\n© 2026 Céto Club — Association loi 1901 — Tous droits réservés.\n\nToute reproduction, représentation, modification, publication ou transmission, totale ou partielle, est interdite sans autorisation écrite préalable de l'association."},
            {t:"5. Avertissement médical ⚕️",c:"Les informations fournies par cette application ont un caractère général et informatif uniquement. Elles ne constituent en aucun cas un conseil médical, un diagnostic ou une prescription thérapeutique.\n\nIl est impératif de consulter un professionnel de santé avant de débuter un régime cétogène, particulièrement en cas de diabète, d'insuffisance rénale ou hépatique, de grossesse, d'allaitement ou de prise de médicaments.\n\nL'association Céto Club décline toute responsabilité quant aux conséquences d'une utilisation des informations fournies sans avis médical préalable."},
            {t:"6. Limitation de responsabilité",c:"L'application est fournie en l'état, sans garantie d'aucune sorte quant à son exactitude, son exhaustivité ou son adéquation à un usage particulier.\n\nL'association Céto Club ne peut être tenue responsable de tout dommage direct ou indirect résultant de l'utilisation ou de l'impossibilité d'utilisation de l'application.\n\nL'utilisateur est seul responsable de ses choix alimentaires et de santé."},
            {t:"7. Données personnelles & RGPD",c:"L'application Céto Club ne collecte aucune donnée personnelle identifiable. Toutes les données saisies restent exclusivement stockées sur l'appareil de l'utilisateur.\n\nL'application ne dépose aucun cookie de tracking, n'intègre aucun outil d'analytics et ne contient aucune publicité.\n\nConformément au Règlement (UE) 2016/679 (RGPD) et à la loi Informatique et Libertés, l'utilisateur peut supprimer l'intégralité de ses données à tout moment en effaçant les données de navigation de son navigateur.\n\nPour toute question relative à vos données : contact@cetoclub.com"},
            {t:"8. Droit applicable & médiation",c:"Les présentes mentions légales sont régies par le droit français.\n\nEn cas de litige, une tentative de résolution amiable sera préalablement recherchée. À défaut, les tribunaux français seront seuls compétents.\n\nConformément aux articles L.616-1 et R.616-1 du Code de la consommation, l'association propose un dispositif de médiation de la consommation. Le médiateur compétent peut être contacté via : contact@cetoclub.com"},
          ].map((s,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:12,border:"2px solid #1B3A6B10",padding:16,marginBottom:12}}>
              <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:8}}>{s.t}</div>
              <div style={{fontSize:11,color:"#6B7280",lineHeight:1.7,whiteSpace:"pre-line"}}>{s.c}</div>
            </div>
          ))}
          <div style={{textAlign:"center",fontSize:10,color:"#9ca3af",marginTop:16,lineHeight:1.8}}>
            © 2026 Association Cuisiner pour la Paix — Céto Club · Association loi 1901<br/>
            13 rue de l'Yvette, 75016 Paris · contact@cetoclub.com<br/>
            Dernière mise à jour : mars 2026
          </div>
        </main>
      )}

      {page==="cgu" && (
        <main style={{maxWidth:700,margin:"0 auto",padding:"16px 12px",overflowX:"hidden",boxSizing:"border-box",width:"100%"}}>
          <div style={{textAlign:"center",marginBottom:24}}>
            <h1 style={{fontSize:22,fontWeight:900,color:"#1B3A6B",margin:"0 0 4px"}}>📄 CGU & CGV</h1>
            <div style={{fontSize:11,color:"#6B7280",marginBottom:8}}>Conditions Générales d'Utilisation et de Vente</div>
            <button onClick={()=>history.back?history.back():setPage("profil")} style={{fontSize:11,color:"#7CB342",background:"none",border:"none",cursor:"pointer",fontWeight:700}}>← Retour</button>
          </div>

          {/* PARTIE I — CGU */}
          <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",borderRadius:12,padding:"12px 16px",marginBottom:12}}>
            <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>PARTIE I — Conditions Générales d'Utilisation (CGU)</div>
          </div>
          {[
            {t:"Article 1 — Présentation",c:"L'application Céto Club est éditée par l'Association Cuisiner pour la Paix — Céto Club, association à but non lucratif déclarée selon la loi du 1er juillet 1901.\n\nSiège social : 13 rue de l'Yvette, 75016 Paris\nContact : contact@cetoclub.com\n\nL'application a pour objet d'accompagner les utilisateurs dans la pratique de l'alimentation cétogène à travers des outils de suivi nutritionnel, de bien-être et d'accompagnement.\n\n© 2026 Céto Club — Tous droits réservés."},
            {t:"Article 2 — Acceptation et modification des CGU",c:"L'utilisation de l'application vaut acceptation pleine et entière des présentes Conditions Générales d'Utilisation.\n\nL'association se réserve le droit de modifier les présentes CGU à tout moment. Les modifications prennent effet dès leur mise en ligne. L'utilisateur est invité à les consulter régulièrement. En cas de modification substantielle, une information sera affichée dans l'application."},
            {t:"Article 3 — Accès et utilisation",c:"L'application est accessible gratuitement, sans inscription et sans création de compte obligatoire. Les fonctionnalités gratuites ne nécessitent aucune donnée personnelle.\n\nL'utilisateur s'engage à utiliser l'application de façon loyale, conformément à sa destination et aux présentes CGU. Sont notamment interdits :\n• Toute utilisation à des fins commerciales, de scraping ou de reproduction\n• Toute tentative de contournement des mécanismes de sécurité\n• Toute utilisation contraire à l'ordre public ou aux bonnes mœurs"},
            {t:"Article 4 — Données personnelles & RGPD",c:"L'application Céto Club ne collecte aucune donnée personnelle identifiable pour les fonctionnalités gratuites. Toutes les données saisies (profil, journal, objectifs) sont stockées exclusivement en local sur l'appareil de l'utilisateur.\n\nL'application ne dépose aucun cookie de tracking et ne contient aucune publicité.\n\nConformément au RGPD, l'utilisateur dispose des droits suivants : accès, rectification, suppression et portabilité de ses données. Ces droits peuvent être exercés directement depuis l'application (suppression des données de navigation) ou par courrier électronique à : contact@cetoclub.com\n\nResponsable de traitement : Association Cuisiner pour la Paix — Céto Club, 13 rue de l'Yvette, 75016 Paris."},
            {t:"Article 5 — Propriété intellectuelle",c:"L'ensemble du contenu de l'application — code source, textes, conseils, interface, logo, charte graphique — est la propriété exclusive de l'association Céto Club, protégé par le droit d'auteur.\n\nToute reproduction, totale ou partielle, sans autorisation écrite préalable est strictement interdite.\n\nSources tierces utilisées :\n• Base Ciqual 2020 de l'ANSES (données publiques)\n• Open Food Facts (Licence ODbL — openfoodfacts.org)"},
            {t:"Article 6 — Avertissement médical ⚕️",c:"Les informations fournies ont un caractère général et informatif uniquement. Elles ne constituent en aucun cas un conseil médical, un diagnostic ou une prescription.\n\nIl est impératif de consulter un professionnel de santé avant de débuter ou modifier un régime cétogène, particulièrement en cas de : diabète (type 1 ou 2), insuffisance rénale ou hépatique, grossesse, allaitement, prise de médicaments, troubles du comportement alimentaire.\n\nL'association décline toute responsabilité quant aux conséquences d'une utilisation des informations sans avis médical préalable."},
            {t:"Article 7 — Limitation de responsabilité",c:"L'application est fournie en l'état, sans garantie d'exactitude, d'exhaustivité ou d'adéquation à un usage particulier.\n\nL'association ne peut être tenue responsable de tout dommage direct ou indirect résultant de l'utilisation de l'application, ni de toute décision prise sur la base des informations fournies.\n\nL'association ne garantit pas la disponibilité continue du service et se réserve le droit d'interrompre, modifier ou supprimer tout ou partie de l'application sans préavis."},
            {t:"Article 8 — Droit applicable",c:"Les présentes CGU sont régies par le droit français. Tout litige sera soumis, après tentative de résolution amiable, à la compétence exclusive des tribunaux français.\n\nContact : contact@cetoclub.com"},
          ].map((s,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:12,border:"2px solid #1B3A6B10",padding:16,marginBottom:12}}>
              <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:8}}>{s.t}</div>
              <div style={{fontSize:11,color:"#6B7280",lineHeight:1.7,whiteSpace:"pre-line"}}>{s.c}</div>
            </div>
          ))}

          {/* PARTIE II — CGV */}
          <div style={{background:"linear-gradient(135deg,#7CB342,#558B2F)",borderRadius:12,padding:"12px 16px",marginBottom:12,marginTop:20}}>
            <div style={{fontSize:14,fontWeight:900,color:"#fff"}}>PARTIE II — Conditions Générales de Vente (CGV)</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,.8)",marginTop:4}}>Applicable aux abonnements et dons avec contrepartie</div>
          </div>
          {[
            {t:"Article 9 — Objet et champ d'application",c:"Les présentes CGV régissent les relations contractuelles entre l'Association Cuisiner pour la Paix — Céto Club (ci-après « l'Association ») et toute personne physique (ci-après « le Membre ») souscrivant à un accès premium ou effectuant un don avec contrepartie numérique via l'application.\n\nLe Membre reconnaît avoir la capacité juridique de conclure un contrat conformément au droit français."},
            {t:"Article 10 — Description des offres",c:"L'Association propose les offres suivantes, donnant accès aux fonctionnalités premium de l'application :\n\n🔷 Abonnement Soutien — 3,99 €/mois TTC\nAccès à toutes les fonctionnalités premium. Renouvellement automatique mensuel. Résiliable à tout moment.\n\n🔷 Abonnement Bienfaiteur — 7,99 €/mois TTC\nAccès à toutes les fonctionnalités premium. Contribution renforcée au développement. Renouvellement automatique mensuel. Résiliable à tout moment.\n\n🔷 Abonnement Annuel — 35,00 €/an TTC\nAccès à toutes les fonctionnalités premium pendant 12 mois. Renouvellement automatique annuel. Résiliable à tout moment.\n\n🔷 Don libre ≥ 35 €\nDon ponctuel d'un montant libre égal ou supérieur à 35 €. Donne accès aux fonctionnalités premium pour une durée de 12 mois.\n\nTous les prix sont indiqués en euros TTC. En tant qu'association à but non lucratif, les offres constituent des contributions à l'objet associatif."},
            {t:"Article 11 — Processus de commande et paiement",c:"Le paiement est traité par Stripe. En cliquant sur le bouton de paiement correspondant à l'offre choisie, le Membre est redirigé vers la plateforme sécurisée de Stripe.\n\nLe Membre accepte les CGU de Stripe lors du règlement. L'Association ne conserve aucune donnée bancaire.\n\nAprès validation du paiement par Stripe, le Membre reçoit par email un code d'activation unique à saisir dans l'application pour activer l'accès premium. Ce code est valable sur tous les appareils du Membre.\n\nL'accès premium est activé sur présentation du code d'activation. Chaque code est strictement personnel et utilisable sur 2 appareils maximum : une activation sur smartphone et une activation sur ordinateur ou tablette."},
            {t:"Article 12 — Droit de rétractation",c:"Conformément aux articles L.221-18 et suivants du Code de la consommation, le Membre dispose d'un délai de 14 jours calendaires à compter de la souscription pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.\n\nEXCEPTION : Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation ne peut être exercé pour les contenus numériques dont l'exécution a commencé avec l'accord du Membre avant l'expiration du délai de rétractation. En activant son code d'accès premium avant l'expiration du délai de 14 jours, le Membre reconnaît expressément renoncer à son droit de rétractation.\n\nPour exercer le droit de rétractation dans les délais, contacter : contact@cetoclub.com"},
            {t:"Article 13 — Remboursement",c:"Toute demande de remboursement doit être adressée par email à contact@cetoclub.com dans un délai de 14 jours suivant la date de paiement, sous réserve de l'exception relative au contenu numérique visée à l'article 12.\n\nEn cas de remboursement accordé, celui-ci sera effectué par le même moyen de paiement que celui utilisé lors de l'achat, dans un délai de 14 jours ouvrés à compter de la décision.\n\nL'activation du code premium vaut renonciation expresse au droit de rétractation pour les contenus numériques."},
            {t:"Article 14 — Résiliation et renouvellement",c:"Les abonnements mensuels et annuels sont reconduits automatiquement à leur échéance via Stripe, sauf résiliation préalable.\n\nLe Membre peut résilier son abonnement à tout moment directement depuis son espace client Stripe, en accédant à la gestion des abonnements. La résiliation prend effet à la fin de la période en cours, sans remboursement au prorata.\n\nEn cas de résiliation, l'accès premium reste actif jusqu'à la fin de la période payée."},
            {t:"Article 15 — Garantie légale de conformité",c:"Conformément aux articles L.224-25-12 à L.224-25-26 du Code de la consommation (applicables aux services numériques depuis le 1er janvier 2022), l'Association garantit que les fonctionnalités premium sont conformes à leur description au moment de la souscription.\n\nEn cas de défaut de conformité, le Membre peut contacter l'Association à : contact@cetoclub.com\n\nGarant : Association Cuisiner pour la Paix — Céto Club\n13 rue de l'Yvette, 75016 Paris\ncontact@cetoclub.com"},
            {t:"Article 16 — Droit de rétractation en ligne (à compter du 19 juin 2026)",c:"Conformément à l'ordonnance n°2026-2 du 5 janvier 2026 (applicable au 19 juin 2026), le Membre disposera d'une fonctionnalité de rétractation directement accessible en ligne, lui permettant d'exercer son droit de rétractation en un clic depuis l'application.\n\nCette fonctionnalité sera intégrée avant la date d'entrée en vigueur."},
            {t:"Article 17 — Médiation de la consommation",c:"Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, en cas de litige non résolu à l'amiable, le Membre peut recourir gratuitement à un médiateur de la consommation.\n\nContact préalable obligatoire : contact@cetoclub.com\n\nLa Commission européenne met également à disposition une plateforme de résolution des litiges en ligne : https://ec.europa.eu/consumers/odr"},
            {t:"Article 18 — Droit applicable",c:"Les présentes CGV sont soumises au droit français, notamment au Code de la consommation et au Code civil.\n\nTout litige relatif à leur interprétation ou exécution sera de la compétence exclusive des tribunaux français compétents, après tentative obligatoire de résolution amiable.\n\nPour toute réclamation : contact@cetoclub.com"},
          ].map((s,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:12,border:"2px solid #7CB34215",padding:16,marginBottom:12}}>
              <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:8}}>{s.t}</div>
              <div style={{fontSize:11,color:"#6B7280",lineHeight:1.7,whiteSpace:"pre-line"}}>{s.c}</div>
            </div>
          ))}

          <div style={{background:"#F1F8E9",borderRadius:12,border:"2px solid #7CB34230",padding:16,marginTop:8,marginBottom:16}}>
            <div style={{fontSize:11,color:"#2E7D32",fontWeight:800,marginBottom:6}}>⚖️ Récapitulatif des droits du consommateur</div>
            <div style={{fontSize:10,color:"#558B2F",lineHeight:1.8}}>
              • Droit de rétractation : 14 jours (sauf contenu numérique activé avec accord préalable)

              • Garantie légale de conformité : service conforme à sa description

              • Médiation gratuite disponible en cas de litige

              • Résiliation abonnement : à tout moment depuis votre espace Stripe

              • Contact : contact@cetoclub.com
            </div>
          </div>

          <div style={{textAlign:"center",fontSize:10,color:"#9ca3af",marginTop:16,lineHeight:1.8}}>
            © 2026 Association Cuisiner pour la Paix — Céto Club · Association loi 1901<br/>
            13 rue de l'Yvette, 75016 Paris · contact@cetoclub.com<br/>
            Dernière mise à jour : mars 2026
          </div>
        </main>
      )}

            {page==="cgu" && (
        <main style={{maxWidth:700,margin:"0 auto",padding:"16px 12px",overflowX:"hidden",boxSizing:"border-box",width:"100%"}}>
          <div style={{textAlign:"center",marginBottom:24}}>
            <h1 style={{fontSize:22,fontWeight:900,color:"#1B3A6B",margin:"0 0 4px"}}>📄 Conditions Générales d'Utilisation</h1>
            <button onClick={()=>setPage("pratiques")} style={{fontSize:11,color:"#7CB342",background:"none",border:"none",cursor:"pointer",fontWeight:700}}>← Retour</button>
          </div>
          {[
            {t:"1. Présentation de l'application",c:"L'application Céto Club est éditée par l'association Céto Club, association à but non lucratif déclarée selon la loi du 1er juillet 1901.\n\nL'application est accessible gratuitement à l'adresse cetoclub.vercel.app et installable sur tout appareil compatible. Elle a pour objet d'accompagner les utilisateurs dans la pratique de l'alimentation cétogène.\n\n© 2026 Céto Club — Association loi 1901 — Tous droits réservés."},
            {t:"2. Acceptation des CGU",c:"L'utilisation de l'application implique l'acceptation pleine et entière des présentes Conditions Générales d'Utilisation. Si tu n'acceptes pas ces conditions, tu es invité(e) à ne pas utiliser l'application.\n\nCéto Club se réserve le droit de modifier les présentes CGU à tout moment. Les modifications prennent effet dès leur mise en ligne."},
            {t:"3. Accès et utilisation",c:"L'application est accessible gratuitement, sans inscription, sans création de compte. Aucune donnée personnelle n'est requise pour utiliser l'application.\n\nL'utilisateur s'engage à utiliser l'application de façon loyale, conformément à sa destination et aux présentes CGU. Toute utilisation à des fins commerciales, de scraping, de reproduction ou de revente est strictement interdite."},
            {t:"4. Données personnelles & RGPD",c:"L'application Céto Club ne collecte aucune donnée personnelle.\n\nToutes les informations saisies (profil, journal, objectifs, bien-être) sont stockées exclusivement en local sur l'appareil de l'utilisateur via le mécanisme localStorage du navigateur. Ces données ne transitent sur aucun serveur, ne sont partagées avec aucun tiers, et ne font l'objet d'aucun traitement automatisé.\n\nL'application ne dépose aucun cookie de tracking, n'intègre aucun outil d'analytics et ne contient aucune publicité.\n\nConformément au Règlement Général sur la Protection des Données (RGPD), l'utilisateur peut supprimer l'intégralité de ses données à tout moment en effaçant les données de navigation de son navigateur ou en désinstallant l'application."},
            {t:"5. Propriété intellectuelle",c:"L'ensemble du contenu de l'application — code source, textes, conseils nutritionnels, interface graphique, logo, charte graphique — est la propriété exclusive de l'association Céto Club.\n\nToute reproduction, représentation, modification, publication, transmission ou dénaturation, totale ou partielle, de l'application ou de son contenu, par quelque procédé que ce soit et sur quelque support que ce soit, est interdite sans l'autorisation écrite préalable de l'association Céto Club.\n\nLes données nutritionnelles utilisées proviennent de la base Ciqual 2020 de l'ANSES, données publiques librement réutilisables."},
            {t:"6. Avertissement médical ⚕️",c:"Les informations fournies par l'application Céto Club ont un caractère général et informatif uniquement. Elles ne constituent en aucun cas un conseil médical, un diagnostic ou une prescription thérapeutique.\n\nL'utilisation de l'application ne remplace pas l'avis d'un professionnel de santé. Il est impératif de consulter un médecin avant de débuter ou modifier un régime cétogène, particulièrement en cas de diabète, d'insuffisance rénale ou hépatique, de grossesse, d'allaitement ou de traitement médicamenteux.\n\nCéto Club ne saurait être tenu responsable des conséquences d'une utilisation des informations fournies sans avis médical préalable."},
            {t:"7. Limitation de responsabilité",c:"L'application est fournie 'en l'état', sans garantie d'aucune sorte. Céto Club ne garantit pas l'exactitude, l'exhaustivité ou l'actualité des informations fournies.\n\nCéto Club ne peut être tenu responsable de tout dommage direct ou indirect résultant de l'utilisation ou de l'impossibilité d'utilisation de l'application, ni de toute décision prise sur la base des informations fournies.\n\nL'utilisateur est seul responsable de ses choix alimentaires et de santé."},
            {t:"8. Disponibilité de l'application",c:"Céto Club s'efforce d'assurer la disponibilité de l'application 24h/24, 7j/7. Toutefois, des interruptions pour maintenance, mise à jour ou raisons techniques peuvent survenir sans préavis.\n\nCéto Club ne saurait être tenu responsable des interruptions de service et de leurs conséquences."},
            {t:"9. Droit applicable",c:"Les présentes CGU sont régies par le droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux français seront seuls compétents.\n\nPour toute question relative aux présentes CGU, tu peux contacter l'association via la page Facebook : facebook.com/groups/cetoclub"},
          ].map((s,i)=>(
            <div key={i} style={{background:"#fff",borderRadius:12,border:"2px solid #1B3A6B10",padding:16,marginBottom:12}}>
              <div style={{fontSize:13,fontWeight:900,color:"#1B3A6B",marginBottom:8}}>{s.t}</div>
              <div style={{fontSize:11,color:"#6B7280",lineHeight:1.7,whiteSpace:"pre-line"}}>{s.c}</div>
            </div>
          ))}
          <div style={{textAlign:"center",fontSize:10,color:"#9ca3af",marginTop:16,lineHeight:1.8}}>
            © 2026 Céto Club · Association loi 1901 · Tous droits réservés<br/>
            Dernière mise à jour : {new Date().toLocaleDateString("fr-FR",{month:"long",year:"numeric"})}
          </div>
        </main>
      )}

      {page==="pratiques" && (
        <main style={{maxWidth:900,margin:"0 auto",padding:"16px 12px",overflowX:"hidden",boxSizing:"border-box",width:"100%"}}>
          <div style={{textAlign:"center",marginBottom:16}}>
            <h1 style={{fontSize:28,fontWeight:900,color:"#1B3A6B",margin:"0 0 4px"}}>🥑 Le Guide Céto</h1>
          </div>
          {/* Onglets */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:16}}>
            <button onClick={()=>setOngletGuide("generalites")}
              style={{padding:"10px 8px",borderRadius:10,fontWeight:800,fontSize:13,
                border:`2px solid ${ongletGuide==="generalites"?"#1B3A6B":"#E5E7EB"}`,
                background:ongletGuide==="generalites"?"#1B3A6B":"#fff",
                color:ongletGuide==="generalites"?"#fff":"#6B7280",
                cursor:"pointer",fontFamily:"inherit"}}>
              📖 Généralités
            </button>
            <button onClick={()=>setOngletGuide("grippe")}
              style={{padding:"10px 8px",borderRadius:10,fontWeight:800,fontSize:13,
                border:`2px solid ${ongletGuide==="grippe"?"#1B3A6B":"#E5E7EB"}`,
                background:ongletGuide==="grippe"?"#1B3A6B":"#fff",
                color:ongletGuide==="grippe"?"#fff":"#6B7280",
                cursor:"pointer",fontFamily:"inherit"}}>
              🤒 Grippe céto (Keto Flu)
            </button>
          </div>

          {ongletGuide==="generalites" && (<>
            <div style={{background:"#fff",border:"2px solid #1B3A6B",borderRadius:12,padding:"14px 20px",marginBottom:16,display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
              <AvocatLogo size={54}/>
              <div style={{color:"#1B3A6B"}}>
                <div style={{fontSize:15,fontWeight:900,color:"#1B3A6B",marginBottom:2}}>Le principe fondamental</div>
                <div style={{fontSize:12,color:"#6B7280",lineHeight:1.6}}>Glucides &lt;20g/j + lipides élevés = corps cétoniques = <strong>cétose</strong>.</div>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(250px,100%),1fr))",gap:10}}>
              {BP.map((bp,i)=>(
                <div key={i} style={{background:"#fff",borderRadius:10,border:`2px solid ${bp.c}15`,padding:16}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                    <div style={{width:36,height:36,borderRadius:8,background:`${bp.c}12`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>{bp.e}</div>
                    <div style={{fontSize:13,fontWeight:900,color:bp.c}}>{bp.t}</div>
                  </div>
                  {bp.i.map((item,j)=>(
                    <div key={j} style={{display:"flex",gap:6,alignItems:"flex-start",marginBottom:5}}>
                      <div style={{width:5,height:5,borderRadius:"50%",background:bp.c,marginTop:5,flexShrink:0}}/>
                      <span style={{fontSize:11,lineHeight:1.5}}>{item}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </>)}

          {ongletGuide==="grippe" && (<>
            <div style={{background:"#FFF8F0",border:"2px solid #F4A035",borderRadius:12,padding:"14px 20px",marginBottom:16,display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
              <div style={{fontSize:40}}>🤒</div>
              <div>
                <div style={{fontSize:15,fontWeight:900,color:"#E65100",marginBottom:2}}>La grippe céto — Keto Flu</div>
                <div style={{fontSize:12,color:"#6B7280",lineHeight:1.6}}>Une phase d'adaptation normale et temporaire. Elle passe. Tiens bon.</div>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(250px,100%),1fr))",gap:10}}>
              {BP_GRIPPE.map((bp,i)=>(
                <div key={i} style={{background:"#fff",borderRadius:10,border:`2px solid ${bp.c}15`,padding:16}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                    <div style={{width:36,height:36,borderRadius:8,background:`${bp.c}12`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>{bp.e}</div>
                    <div style={{fontSize:13,fontWeight:900,color:bp.c}}>{bp.t}</div>
                  </div>
                  {bp.i.map((item,j)=>(
                    <div key={j} style={{display:"flex",gap:6,alignItems:"flex-start",marginBottom:5}}>
                      <div style={{width:5,height:5,borderRadius:"50%",background:bp.c,marginTop:5,flexShrink:0}}/>
                      <span style={{fontSize:11,lineHeight:1.5}}>{item}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </>)}
        </main>
      )}

      {page==="plan7j" && PREMIUM_ACTIF && <ModulePlan7Jours />}



      <footer style={{borderTop:"1px solid #1B3A6B10",padding:"12px 12px",background:"#fff",marginTop:28,overflowX:"hidden"}}>
        <div style={{display:"flex",flexWrap:"wrap",justifyContent:"space-between",alignItems:"center",color:"#9ca3af",fontSize:10,marginBottom:4,gap:4}}>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <AvocatLogo size={18}/>
            <span style={{fontWeight:800,color:"#1B3A6B"}}>Céto Club</span>
            <span>· Association à but non lucratif · ANSES Ciqual 2020 · Données produits : © <a href="https://openfoodfacts.org" target="_blank" rel="noopener noreferrer" style={{color:"#9ca3af",textDecoration:"underline"}}>Open Food Facts</a> (ODbL) · © 2026 Céto Club — Tous droits réservés</span>
          </div>
          <span>⚕️ Informations générales — pas de conseil médical</span>
        </div>
        <div style={{display:"flex",justifyContent:"center",marginBottom:8}}>
          <button onClick={()=>{
            const txt = "🥑 Je te recommande l'app Céto Club — gratuite, sans pub, sans tracking !\nParfaite pour suivre ses glucides et réussir le céto.\n👉 https://app.cetoclub.com";
            navigator.clipboard?.writeText(txt).then(()=>alert("Lien copié ! Colle-le où tu veux 🥑")).catch(()=>alert("Copie le lien : https://app.cetoclub.com"));
          }} style={{padding:"8px 18px",borderRadius:20,background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",fontWeight:800,fontSize:11,cursor:"pointer",boxShadow:"0 2px 8px rgba(124,179,66,.3)"}}>
            💚 Je recommande l'app Céto Club
          </button>
        </div>
        <div style={{fontSize:9,color:"#9ca3af",textAlign:"center",lineHeight:1.6}}>
          Consulte ton médecin avant de démarrer le céto · Données locales uniquement · Aucune collecte · Conforme RGPD ·
          ℹ️ Nous comptons anonymement les ouvertures de l'app — aucune donnée personnelle collectée ·
          <button onClick={()=>setPage("mentions")} style={{background:"none",border:"none",color:"#1B3A6B",cursor:"pointer",fontSize:9,fontWeight:700,textDecoration:"underline",padding:"0 4px"}}>Mentions légales</button>
          · <button onClick={()=>setPage("cgu")} style={{background:"none",border:"none",color:"#1B3A6B",cursor:"pointer",fontSize:9,fontWeight:700,textDecoration:"underline",padding:"0 4px"}}>CGU</button>
        </div>
      </footer>

      {/* ─── MODAL D'INSTRUCTIONS INSTALLATION ─────────────────── */}
      {modalInstall && (() => {
        const nav = detecterNavigateur();
        const instructions = {
          "ios": {
            titre: "📱 Installer sur iPhone / iPad",
            etapes: [
              "En bas de Safari, appuie sur le bouton Partager",
              "(le carré avec la flèche vers le haut ⬆️)",
              "",
              "Dans la liste qui s'ouvre, fais défiler vers le bas",
              "et appuie sur « Sur l'écran d'accueil »",
              "",
              "Confirme en appuyant sur « Ajouter » en haut à droite",
              "",
              "✅ L'icône Céto Club apparaît sur ton écran d'accueil !"
            ],
            note: "ℹ️ Si tu es dans Chrome ou Firefox sur iPhone, l'installation ne fonctionne que depuis Safari (limitation Apple). Ouvre d'abord app.cetoclub.com dans Safari."
          },
          "android-chrome": {
            titre: "📱 Installer sur Android",
            etapes: [
              "Appuie sur le menu ⋮ (trois points en haut à droite)",
              "",
              "Choisis « Installer l'application »",
              "ou « Ajouter à l'écran d'accueil »",
              "",
              "Confirme en appuyant sur « Installer »",
              "",
              "✅ L'icône Céto Club apparaît sur ton écran d'accueil !"
            ],
            note: "💡 Sur Samsung Internet ou Brave, la manipulation est identique."
          },
          "firefox-android": {
            titre: "🦊 Installer sur Firefox Android",
            etapes: [
              "Appuie sur le menu ⋮ en bas à droite",
              "",
              "Choisis « Installer »",
              "ou « Ajouter à l'écran d'accueil »",
              "",
              "Confirme l'ajout",
              "",
              "✅ L'icône Céto Club apparaît sur ton écran d'accueil !"
            ],
            note: "💡 Pour une meilleure expérience d'installation, tu peux aussi utiliser Chrome ou Samsung Internet."
          },
          "desktop-chrome": {
            titre: "💻 Installer sur ordinateur",
            etapes: [
              "Regarde dans la barre d'adresse en haut",
              "",
              "À droite de l'URL, tu verras une petite icône",
              "en forme d'écran avec une flèche vers le bas 📥",
              "",
              "Clique dessus puis sur « Installer »",
              "",
              "✅ Céto Club devient une appli à part entière sur ton bureau !"
            ],
            note: "💡 Tu peux aussi passer par le menu ⋮ → « Installer Céto Club » ou « Apps » → « Installer ce site comme application »."
          },
          "firefox-desktop": {
            titre: "🦊 Firefox sur ordinateur",
            etapes: [
              "Firefox desktop ne permet pas encore d'installer",
              "les applications web (PWA) nativement.",
              "",
              "Deux solutions :",
              "",
              "1️⃣ Utilise Chrome, Edge ou Brave pour installer l'app",
              "",
              "2️⃣ Ou ajoute simplement app.cetoclub.com",
              "à tes favoris (Ctrl+D) pour un accès rapide"
            ],
            note: "ℹ️ L'app fonctionne parfaitement dans Firefox, mais sans icône dédiée sur le bureau."
          },
          "safari-desktop": {
            titre: "🍎 Installer sur Mac (Safari)",
            etapes: [
              "Dans la barre de menu en haut, clique sur « Fichier »",
              "",
              "Choisis « Ajouter au Dock »",
              "(disponible sur macOS Sonoma et versions plus récentes)",
              "",
              "Confirme l'ajout",
              "",
              "✅ Céto Club devient une appli sur ton Dock !"
            ],
            note: "ℹ️ Sur macOS plus ancien, ajoute simplement le site aux favoris (Cmd+D)."
          },
          "autre": {
            titre: "📲 Installer Céto Club",
            etapes: [
              "Ton navigateur n'est pas reconnu, mais voici les étapes générales :",
              "",
              "Cherche dans le menu de ton navigateur",
              "une option « Installer l'application »",
              "ou « Ajouter à l'écran d'accueil »",
              "",
              "Si tu ne trouves pas, ajoute simplement",
              "app.cetoclub.com à tes favoris"
            ],
            note: "💡 Chrome, Edge, Samsung Internet et Brave offrent la meilleure expérience d'installation."
          }
        };
        const inst = instructions[nav];

        return (
          <div
            onClick={()=>setModalInstall(false)}
            style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(27,58,107,0.75)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:16,backdropFilter:"blur(4px)"}}
          >
            <div
              onClick={(e)=>e.stopPropagation()}
              style={{background:"#fff",borderRadius:20,maxWidth:420,width:"100%",maxHeight:"85vh",overflowY:"auto",boxShadow:"0 20px 50px rgba(0,0,0,0.3)",fontFamily:"'Nunito',sans-serif"}}
            >
              <div style={{background:"linear-gradient(135deg,#1B3A6B,#2A5298)",padding:"20px 24px",borderRadius:"20px 20px 0 0",color:"#fff",position:"relative"}}>
                <button
                  onClick={()=>setModalInstall(false)}
                  style={{position:"absolute",top:12,right:12,background:"rgba(255,255,255,0.2)",border:"none",borderRadius:"50%",width:28,height:28,color:"#fff",fontSize:16,cursor:"pointer",fontWeight:700}}
                >×</button>
                <div style={{fontSize:22,fontWeight:900,marginBottom:4}}>{inst.titre}</div>
                <div style={{fontSize:12,opacity:0.85}}>Céto Club sur ton écran d'accueil</div>
              </div>
              <div style={{padding:"20px 24px"}}>
                {inst.etapes.map((etape,i)=>{
                  if (etape === "") return <div key={i} style={{height:8}}/>;
                  const estEmoji = /^[✅💡ℹ️🌟]/.test(etape) || etape.startsWith("1️⃣") || etape.startsWith("2️⃣");
                  return (
                    <div key={i} style={{fontSize:14,color:estEmoji?"#2E7D32":"#374151",fontWeight:estEmoji?800:600,lineHeight:1.7,marginBottom:4,paddingLeft:estEmoji?0:8}}>
                      {etape}
                    </div>
                  );
                })}
                <div style={{background:"#F1F8E9",borderLeft:"3px solid #7CB342",borderRadius:8,padding:"12px 14px",marginTop:16,fontSize:12,color:"#374151",lineHeight:1.6}}>
                  {inst.note}
                </div>
                <div style={{marginTop:16,padding:"14px 16px",background:"#F0F4FF",borderRadius:12,fontSize:12,color:"#1B3A6B",lineHeight:1.7}}>
                  <div style={{fontWeight:900,marginBottom:6}}>🚀 Pourquoi installer ?</div>
                  <div>✓ Accès direct depuis ton écran d'accueil</div>
                  <div>✓ Fonctionne même sans connexion Internet</div>
                  <div>✓ Plein écran, comme une vraie app</div>
                  <div>✓ Aucun espace de stockage utilisé (moins de 1 Mo)</div>
                </div>
                <button
                  onClick={()=>setModalInstall(false)}
                  style={{width:"100%",marginTop:18,padding:"12px",background:"linear-gradient(135deg,#7CB342,#558B2F)",color:"#fff",border:"none",borderRadius:10,fontWeight:900,fontSize:14,cursor:"pointer"}}
                >
                  Compris, je vais essayer !
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}
